
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire35c3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire35c3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aBhlC", function(module, exports) {

$parcel$export(module.exports, "ExtensionType", () => $f709b01588a671e1$export$4f037c6ec2da4eeb);
$parcel$export(module.exports, "extensions", () => $f709b01588a671e1$export$cc3e2d3244e01b7f);
"use strict";
var $f709b01588a671e1$export$4f037c6ec2da4eeb = /* @__PURE__ */ ((ExtensionType2)=>{
    ExtensionType2["Application"] = "application";
    ExtensionType2["WebGLPipes"] = "webgl-pipes";
    ExtensionType2["WebGLPipesAdaptor"] = "webgl-pipes-adaptor";
    ExtensionType2["WebGLSystem"] = "webgl-system";
    ExtensionType2["WebGPUPipes"] = "webgpu-pipes";
    ExtensionType2["WebGPUPipesAdaptor"] = "webgpu-pipes-adaptor";
    ExtensionType2["WebGPUSystem"] = "webgpu-system";
    ExtensionType2["CanvasSystem"] = "canvas-system";
    ExtensionType2["CanvasPipesAdaptor"] = "canvas-pipes-adaptor";
    ExtensionType2["CanvasPipes"] = "canvas-pipes";
    ExtensionType2["Asset"] = "asset";
    ExtensionType2["LoadParser"] = "load-parser";
    ExtensionType2["ResolveParser"] = "resolve-parser";
    ExtensionType2["CacheParser"] = "cache-parser";
    ExtensionType2["DetectionParser"] = "detection-parser";
    ExtensionType2["MaskEffect"] = "mask-effect";
    ExtensionType2["BlendMode"] = "blend-mode";
    ExtensionType2["TextureSource"] = "texture-source";
    ExtensionType2["Environment"] = "environment";
    ExtensionType2["ShapeBuilder"] = "shape-builder";
    ExtensionType2["Batcher"] = "batcher";
    return ExtensionType2;
})($f709b01588a671e1$export$4f037c6ec2da4eeb || {});
const $f709b01588a671e1$var$normalizeExtension = (ext)=>{
    if (typeof ext === "function" || typeof ext === "object" && ext.extension) {
        if (!ext.extension) throw new Error("Extension class must have an extension object");
        const metadata = typeof ext.extension !== "object" ? {
            type: ext.extension
        } : ext.extension;
        ext = {
            ...metadata,
            ref: ext
        };
    }
    if (typeof ext === "object") ext = {
        ...ext
    };
    else throw new Error("Invalid extension type");
    if (typeof ext.type === "string") ext.type = [
        ext.type
    ];
    return ext;
};
const $f709b01588a671e1$export$ba4241979983e013 = (ext, defaultPriority)=>$f709b01588a671e1$var$normalizeExtension(ext).priority ?? defaultPriority;
const $f709b01588a671e1$export$cc3e2d3244e01b7f = {
    /** @ignore */ _addHandlers: {},
    /** @ignore */ _removeHandlers: {},
    /** @ignore */ _queue: {},
    /**
   * Remove extensions from PixiJS.
   * @param extensions - Extensions to be removed. Can be:
   * - Extension class with static `extension` property
   * - Extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns {extensions} this for chaining
   * @example
   * ```ts
   * // Remove a single extension
   * extensions.remove(MyRendererPlugin);
   *
   * // Remove multiple extensions
   * extensions.remove(
   *     MyRendererPlugin,
   *     MySystemPlugin
   * );
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   */ remove (...extensions2) {
        extensions2.map($f709b01588a671e1$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>this._removeHandlers[type]?.(ext));
        });
        return this;
    },
    /**
   * Register new extensions with PixiJS. Extensions can be registered in multiple formats:
   * - As a class with a static `extension` property
   * - As an extension format object
   * - As multiple extensions passed as separate arguments
   * @param extensions - Extensions to add to PixiJS. Each can be:
   * - A class with static `extension` property
   * - An extension format object with `type` and `ref`
   * - Multiple extensions as separate arguments
   * @returns This extensions instance for chaining
   * @example
   * ```ts
   * // Register a simple extension
   * extensions.add(MyRendererPlugin);
   *
   * // Register multiple extensions
   * extensions.add(
   *     MyRendererPlugin,
   *     MySystemPlugin,
   * });
   * ```
   * @see {@link ExtensionType} For available extension types
   * @see {@link ExtensionFormat} For extension format details
   * @see {@link extensions.remove} For removing registered extensions
   */ add (...extensions2) {
        extensions2.map($f709b01588a671e1$var$normalizeExtension).forEach((ext)=>{
            ext.type.forEach((type)=>{
                const handlers = this._addHandlers;
                const queue = this._queue;
                if (!handlers[type]) {
                    queue[type] = queue[type] || [];
                    queue[type]?.push(ext);
                } else handlers[type]?.(ext);
            });
        });
        return this;
    },
    /**
   * Internal method to handle extensions by name.
   * @param type - The extension type.
   * @param onAdd  - Function handler when extensions are added/registered {@link StrictExtensionFormat}.
   * @param onRemove  - Function handler when extensions are removed/unregistered {@link StrictExtensionFormat}.
   * @returns this for chaining.
   * @internal
   * @ignore
   */ handle (type, onAdd, onRemove) {
        const addHandlers = this._addHandlers;
        const removeHandlers = this._removeHandlers;
        if (addHandlers[type] || removeHandlers[type]) throw new Error(`Extension type ${type} already has a handler`);
        addHandlers[type] = onAdd;
        removeHandlers[type] = onRemove;
        const queue = this._queue;
        if (queue[type]) {
            queue[type]?.forEach((ext)=>onAdd(ext));
            delete queue[type];
        }
        return this;
    },
    /**
   * Handle a type, but using a map by `name` property.
   * @param type - Type of extension to handle.
   * @param map - The object map of named extensions.
   * @returns this for chaining.
   * @ignore
   */ handleByMap (type, map) {
        return this.handle(type, (extension)=>{
            if (extension.name) map[extension.name] = extension.ref;
        }, (extension)=>{
            if (extension.name) delete map[extension.name];
        });
    },
    /**
   * Handle a type, but using a list of extensions with a `name` property.
   * @param type - Type of extension to handle.
   * @param map - The array of named extensions.
   * @param defaultPriority - Fallback priority if none is defined.
   * @returns this for chaining.
   * @ignore
   */ handleByNamedList (type, map, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            const index = map.findIndex((item)=>item.name === extension.name);
            if (index >= 0) return;
            map.push({
                name: extension.name,
                value: extension.ref
            });
            map.sort((a, b)=>$f709b01588a671e1$export$ba4241979983e013(b.value, defaultPriority) - $f709b01588a671e1$export$ba4241979983e013(a.value, defaultPriority));
        }, (extension)=>{
            const index = map.findIndex((item)=>item.name === extension.name);
            if (index !== -1) map.splice(index, 1);
        });
    },
    /**
   * Handle a type, but using a list of extensions.
   * @param type - Type of extension to handle.
   * @param list - The list of extensions.
   * @param defaultPriority - The default priority to use if none is specified.
   * @returns this for chaining.
   * @ignore
   */ handleByList (type, list, defaultPriority = -1) {
        return this.handle(type, (extension)=>{
            if (list.includes(extension.ref)) return;
            list.push(extension.ref);
            list.sort((a, b)=>$f709b01588a671e1$export$ba4241979983e013(b, defaultPriority) - $f709b01588a671e1$export$ba4241979983e013(a, defaultPriority));
        }, (extension)=>{
            const index = list.indexOf(extension.ref);
            if (index !== -1) list.splice(index, 1);
        });
    },
    /**
   * Mixin the source object(s) properties into the target class's prototype.
   * Copies all property descriptors from source objects to the target's prototype.
   * @param Target - The target class to mix properties into
   * @param sources - One or more source objects containing properties to mix in
   * @example
   * ```ts
   * // Create a mixin with shared properties
   * const moveable = {
   *     x: 0,
   *     y: 0,
   *     move(x: number, y: number) {
   *         this.x += x;
   *         this.y += y;
   *     }
   * };
   *
   * // Create a mixin with computed properties
   * const scalable = {
   *     scale: 1,
   *     get scaled() {
   *         return this.scale > 1;
   *     }
   * };
   *
   * // Apply mixins to a class
   * extensions.mixin(Sprite, moveable, scalable);
   *
   * // Use mixed-in properties
   * const sprite = new Sprite();
   * sprite.move(10, 20);
   * console.log(sprite.x, sprite.y); // 10, 20
   * ```
   * @remarks
   * - Copies all properties including getters/setters
   * - Does not modify source objects
   * - Preserves property descriptors
   * @see {@link Object.defineProperties} For details on property descriptors
   * @see {@link Object.getOwnPropertyDescriptors} For details on property copying
   */ mixin (Target, ...sources) {
        for (const source of sources)Object.defineProperties(Target.prototype, Object.getOwnPropertyDescriptors(source));
    }
};

});

parcelRegister("7D6Dk", function(module, exports) {
module.exports = Promise.all([
    import("kMEgw"),
    import("5wxiL")
]).then(()=>parcelRequire('ll1pg'));

});

parcelRegister("2xXnk", function(module, exports) {
module.exports = Promise.all([
    import("kMEgw"),
    import("ieN1S")
]).then(()=>parcelRequire('12dkY'));

});

parcelRegister("1VA6u", function(module, exports) {

var $aBhlC = parcelRequire("aBhlC");

var $3sgKi = parcelRequire("3sgKi");

var $acmb2 = parcelRequire("acmb2");

var $g1oOp = parcelRequire("g1oOp");

var $fquaa = parcelRequire("fquaa");

var $2lEA3 = parcelRequire("2lEA3");

var $7xwxM = parcelRequire("7xwxM");

var $jmijm = parcelRequire("jmijm");
parcelRequire("ejgnR");

"use strict";
(0, $aBhlC.extensions).add((0, $3sgKi.AlphaMask), (0, $acmb2.ColorMask), (0, $g1oOp.StencilMask), (0, $jmijm.VideoSource), (0, $7xwxM.ImageSource), (0, $2lEA3.CanvasSource), (0, $fquaa.BufferImageSource));

});
parcelRegister("3sgKi", function(module, exports) {

$parcel$export(module.exports, "AlphaMask", () => $3501da7f944da933$export$3c32667be409917c);

var $aBhlC = parcelRequire("aBhlC");

var $ellmw = parcelRequire("ellmw");

var $64Mji = parcelRequire("64Mji");

var $dV5cI = parcelRequire("dV5cI");
"use strict";
class $3501da7f944da933$export$3c32667be409917c {
    constructor(options){
        this.priority = 0;
        this.inverse = false;
        this.channel = "red";
        this.pipe = "alphaMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
        this.renderMaskToTexture = !(mask instanceof (0, $ellmw.Sprite));
        this.mask.renderable = this.renderMaskToTexture;
        this.mask.includeInBuild = !this.renderMaskToTexture;
        this.mask.measurable = false;
    }
    reset() {
        if (this.mask === null) return;
        this.mask.measurable = true;
        this.mask = null;
    }
    addBounds(bounds, skipUpdateTransform) {
        if (!this.inverse) (0, $64Mji.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $dV5cI.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    destroy() {
        this.reset();
    }
    static test(mask) {
        return mask instanceof (0, $ellmw.Sprite);
    }
}
$3501da7f944da933$export$3c32667be409917c.extension = (0, $aBhlC.ExtensionType).MaskEffect;

});
parcelRegister("ellmw", function(module, exports) {

$parcel$export(module.exports, "Sprite", () => $4d3e30cf7ba6f3f5$export$3075603db8e6204c);

var $2sdBn = parcelRequire("2sdBn");

var $cmH9g = parcelRequire("cmH9g");

var $cfUjt = parcelRequire("cfUjt");

var $dXBy0 = parcelRequire("dXBy0");

var $aHyJR = parcelRequire("aHyJR");
"use strict";
class $4d3e30cf7ba6f3f5$export$3075603db8e6204c extends (0, $aHyJR.ViewContainer) {
    /**
   * @param options - The options for creating the sprite.
   */ constructor(options = (0, $cmH9g.Texture).EMPTY){
        if (options instanceof (0, $cmH9g.Texture)) options = {
            texture: options
        };
        const { texture: texture = (0, $cmH9g.Texture).EMPTY, anchor: anchor, roundPixels: roundPixels, width: width, height: height, ...rest } = options;
        super({
            label: "Sprite",
            ...rest
        });
        /** @internal */ this.renderPipeId = "sprite";
        /** @internal */ this.batched = true;
        this._visualBounds = {
            minX: 0,
            maxX: 1,
            minY: 0,
            maxY: 0
        };
        this._anchor = new (0, $2sdBn.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        else if (texture.defaultAnchor) this.anchor = texture.defaultAnchor;
        this.texture = texture;
        this.allowChildren = false;
        this.roundPixels = roundPixels ?? false;
        if (width !== void 0) this.width = width;
        if (height !== void 0) this.height = height;
    }
    /**
   * Creates a new sprite based on a source texture, image, video, or canvas element.
   * This is a convenience method that automatically creates and manages textures.
   * @example
   * ```ts
   * // Create from path or URL
   * const sprite = Sprite.from('assets/image.png');
   *
   * // Create from existing texture
   * const sprite = Sprite.from(texture);
   *
   * // Create from canvas
   * const canvas = document.createElement('canvas');
   * const sprite = Sprite.from(canvas, true); // Skip caching new texture
   * ```
   * @param source - The source to create the sprite from. Can be a path to an image, a texture,
   * or any valid texture source (canvas, video, etc.)
   * @param skipCache - Whether to skip adding to the texture cache when creating a new texture
   * @returns A new sprite based on the source
   * @see {@link Texture.from} For texture creation details
   * @see {@link Assets} For asset loading and management
   */ static from(source, skipCache = false) {
        if (source instanceof (0, $cmH9g.Texture)) return new $4d3e30cf7ba6f3f5$export$3075603db8e6204c(source);
        return new $4d3e30cf7ba6f3f5$export$3075603db8e6204c((0, $cmH9g.Texture).from(source, skipCache));
    }
    set texture(value) {
        value || (value = (0, $cmH9g.Texture).EMPTY);
        const currentTexture = this._texture;
        if (currentTexture === value) return;
        if (currentTexture && currentTexture.dynamic) currentTexture.off("update", this.onViewUpdate, this);
        if (value.dynamic) value.on("update", this.onViewUpdate, this);
        this._texture = value;
        if (this._width) this._setWidth(this._width, this._texture.orig.width);
        if (this._height) this._setHeight(this._height, this._texture.orig.height);
        this.onViewUpdate();
    }
    /**
   * The texture that is displayed by the sprite. When changed, automatically updates
   * the sprite dimensions and manages texture event listeners.
   * @example
   * ```ts
   * // Create sprite with texture
   * const sprite = new Sprite({
   *     texture: Texture.from('sprite.png')
   * });
   *
   * // Update texture
   * sprite.texture = Texture.from('newSprite.png');
   *
   * // Use texture from spritesheet
   * const sheet = await Assets.load('spritesheet.json');
   * sprite.texture = sheet.textures['frame1.png'];
   *
   * // Reset to empty texture
   * sprite.texture = Texture.EMPTY;
   * ```
   * @see {@link Texture} For texture creation and management
   * @see {@link Assets} For asset loading
   */ get texture() {
        return this._texture;
    }
    /**
   * The bounds of the sprite, taking into account the texture's trim area.
   * @example
   * ```ts
   * const texture = new Texture({
   *     source: new TextureSource({ width: 300, height: 300 }),
   *     frame: new Rectangle(196, 66, 58, 56),
   *     trim: new Rectangle(4, 4, 58, 56),
   *     orig: new Rectangle(0, 0, 64, 64),
   *     rotate: 2,
   * });
   * const sprite = new Sprite(texture);
   * const visualBounds = sprite.visualBounds;
   * // console.log(visualBounds); // { minX: -4, maxX: 62, minY: -4, maxY: 60 }
   */ get visualBounds() {
        (0, $cfUjt.updateQuadBounds)(this._visualBounds, this._anchor, this._texture);
        return this._visualBounds;
    }
    /**
   * @deprecated
   * @ignore
   */ get sourceBounds() {
        (0, $dXBy0.deprecation)("8.6.1", "Sprite.sourceBounds is deprecated, use visualBounds instead.");
        return this.visualBounds;
    }
    /** @private */ updateBounds() {
        const anchor = this._anchor;
        const texture = this._texture;
        const bounds = this._bounds;
        const { width: width, height: height } = texture.orig;
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
    /**
   * Destroys this sprite renderable and optionally its texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * sprite.destroy();
   * sprite.destroy(true);
   * sprite.destroy({ texture: true, textureSource: true });
   */ destroy(options = false) {
        super.destroy(options);
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            this._texture.destroy(destroyTextureSource);
        }
        this._texture = null;
        this._visualBounds = null;
        this._bounds = null;
        this._anchor = null;
    }
    /**
   * The anchor sets the origin point of the sprite. The default value is taken from the {@link Texture}
   * and passed to the constructor.
   *
   * - The default is `(0,0)`, this means the sprite's origin is the top left.
   * - Setting the anchor to `(0.5,0.5)` means the sprite's origin is centered.
   * - Setting the anchor to `(1,1)` would mean the sprite's origin point will be the bottom right corner.
   *
   * If you pass only single parameter, it will set both x and y to the same value as shown in the example below.
   * @example
   * ```ts
   * // Center the anchor point
   * sprite.anchor = 0.5; // Sets both x and y to 0.5
   * sprite.position.set(400, 300); // Sprite will be centered at this position
   *
   * // Set specific x/y anchor points
   * sprite.anchor = {
   *     x: 1, // Right edge
   *     y: 0  // Top edge
   * };
   *
   * // Using individual coordinates
   * sprite.anchor.set(0.5, 1); // Center-bottom
   *
   * // For rotation around center
   * sprite.anchor.set(0.5);
   * sprite.rotation = Math.PI / 4; // 45 degrees around center
   *
   * // For scaling from center
   * sprite.anchor.set(0.5);
   * sprite.scale.set(2); // Scales from center point
   * ```
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * The width of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set width directly
   * sprite.width = 200;
   * console.log(sprite.scale.x); // Scale adjusted to match width
   *
   * // Set width while preserving aspect ratio
   * const ratio = sprite.height / sprite.width;
   * sprite.width = 300;
   * sprite.height = 300 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.width = sprite.texture.orig.width;
   * ```
   */ get width() {
        return Math.abs(this.scale.x) * this._texture.orig.width;
    }
    set width(value) {
        this._setWidth(value, this._texture.orig.width);
        this._width = value;
    }
    /**
   * The height of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set height directly
   * sprite.height = 150;
   * console.log(sprite.scale.y); // Scale adjusted to match height
   *
   * // Set height while preserving aspect ratio
   * const ratio = sprite.width / sprite.height;
   * sprite.height = 200;
   * sprite.width = 200 * ratio;
   *
   * // For better performance when setting both width and height
   * sprite.setSize(300, 400); // Avoids recalculating bounds twice
   *
   * // Reset to original texture size
   * sprite.height = sprite.texture.orig.height;
   * ```
   */ get height() {
        return Math.abs(this.scale.y) * this._texture.orig.height;
    }
    set height(value) {
        this._setHeight(value, this._texture.orig.height);
        this._height = value;
    }
    /**
   * Retrieves the size of the Sprite as a [Size]{@link Size} object based on the texture dimensions and scale.
   * This is faster than getting width and height separately as it only calculates the bounds once.
   * @example
   * ```ts
   * // Basic size retrieval
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * const size = sprite.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * sprite.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the Sprite
   * @see {@link Sprite#width} For getting just the width
   * @see {@link Sprite#height} For getting just the height
   * @see {@link Sprite#setSize} For setting both width and height
   */ getSize(out) {
        out || (out = {});
        out.width = Math.abs(this.scale.x) * this._texture.orig.width;
        out.height = Math.abs(this.scale.y) * this._texture.orig.height;
        return out;
    }
    /**
   * Sets the size of the Sprite to the specified width and height.
   * This is faster than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * const sprite = new Sprite(Texture.from('sprite.png'));
   * sprite.setSize(100, 200); // Width: 100, Height: 200
   *
   * // Set uniform size
   * sprite.setSize(100); // Sets both width and height to 100
   *
   * // Set size with object
   * sprite.setSize({
   *     width: 200,
   *     height: 300
   * });
   *
   * // Reset to texture size
   * sprite.setSize(
   *     sprite.texture.orig.width,
   *     sprite.texture.orig.height
   * );
   * ```
   * @param value - This can be either a number or a {@link Size} object
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link Sprite#width} For setting width only
   * @see {@link Sprite#height} For setting height only
   * @see {@link Sprite#texture} For the source dimensions
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, this._texture.orig.width);
        height !== void 0 && this._setHeight(height, this._texture.orig.height);
    }
}

});
parcelRegister("2sdBn", function(module, exports) {

$parcel$export(module.exports, "ObservablePoint", () => $a03bc8ed5c9e927f$export$3755aaad3fd42e52);
"use strict";
class $a03bc8ed5c9e927f$export$3755aaad3fd42e52 {
    /**
   * Creates a new `ObservablePoint`
   * @param observer - Observer to pass to listen for change events.
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(observer, x, y){
        this._x = x || 0;
        this._y = y || 0;
        this._observer = observer;
    }
    /**
   * Creates a clone of this point.
   * @example
   * ```ts
   * // Basic cloning
   * const point = new ObservablePoint(observer, 100, 200);
   * const copy = point.clone();
   *
   * // Clone with new observer
   * const newObserver = {
   *     _onUpdate: (p) => console.log(`Clone updated: (${p.x}, ${p.y})`)
   * };
   * const watched = point.clone(newObserver);
   *
   * // Verify independence
   * watched.set(300, 400); // Only triggers new observer
   * ```
   * @param observer - Optional observer to pass to the new observable point
   * @returns A copy of this observable point
   * @see {@link ObservablePoint.copyFrom} For copying into existing point
   * @see {@link Observer} For observer interface details
   */ clone(observer) {
        return new $a03bc8ed5c9e927f$export$3755aaad3fd42e52(observer ?? this._observer, this._x, this._y);
    }
    /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new ObservablePoint(observer);
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.equals} For comparing positions
   */ set(x = 0, y = x) {
        if (this._x !== x || this._y !== y) {
            this._x = x;
            this._y = y;
            this._observer._onUpdate(this);
        }
        return this;
    }
    /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(observer, 100, 200);
   * const target = new ObservablePoint();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new ObservablePoint()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link ObservablePoint.copyTo} For copying to another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */ copyFrom(p) {
        if (this._x !== p.x || this._y !== p.y) {
            this._x = p.x;
            this._y = p.y;
            this._observer._onUpdate(this);
        }
        return this;
    }
    /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new ObservablePoint(100, 200);
   * const target = new ObservablePoint();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link ObservablePoint.copyFrom} For copying from another point
   * @see {@link ObservablePoint.clone} For creating new point copy
   */ copyTo(p) {
        p.set(this._x, this._y);
        return p;
    }
    /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new ObservablePoint(100, 200);
   * const p2 = new ObservablePoint(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new ObservablePoint(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link ObservablePoint.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */ equals(p) {
        return p.x === this._x && p.y === this._y;
    }
    toString() {
        return `[pixi.js/math:ObservablePoint x=${this._x} y=${this._y} scope=${this._observer}]`;
    }
    /**
   * Position of the observable point on the x axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic x position
   * const point = new ObservablePoint(observer);
   * point.x = 100; // Triggers observer
   *
   * // Use in calculations
   * const width = rightPoint.x - leftPoint.x;
   * ```
   * @default 0
   */ get x() {
        return this._x;
    }
    set x(value) {
        if (this._x !== value) {
            this._x = value;
            this._observer._onUpdate(this);
        }
    }
    /**
   * Position of the observable point on the y axis.
   * Triggers observer callback when value changes.
   * @example
   * ```ts
   * // Basic y position
   * const point = new ObservablePoint(observer);
   * point.y = 200; // Triggers observer
   *
   * // Use in calculations
   * const height = bottomPoint.y - topPoint.y;
   * ```
   * @default 0
   */ get y() {
        return this._y;
    }
    set y(value) {
        if (this._y !== value) {
            this._y = value;
            this._observer._onUpdate(this);
        }
    }
}

});

parcelRegister("cmH9g", function(module, exports) {

$parcel$export(module.exports, "Texture", () => $7bbdc65ac265cc3c$export$5431306cf43de24a);

var $6AQ4q = parcelRequire("6AQ4q");

var $bLbU4 = parcelRequire("bLbU4");

var $kNl9L = parcelRequire("kNl9L");

var $kfwXR = parcelRequire("kfwXR");

var $dXBy0 = parcelRequire("dXBy0");

var $lRaOh = parcelRequire("lRaOh");

var $fquaa = parcelRequire("fquaa");

var $gl1XZ = parcelRequire("gl1XZ");

var $67pbJ = parcelRequire("67pbJ");
"use strict";
class $7bbdc65ac265cc3c$export$5431306cf43de24a extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    /**
   * @param {TextureOptions} options - Options for the texture
   */ constructor({ source: source, label: label, frame: frame, orig: orig, trim: trim, defaultAnchor: defaultAnchor, defaultBorders: defaultBorders, rotate: rotate, dynamic: dynamic } = {}){
        super();
        /** unique id for this texture */ this.uid = (0, $kfwXR.uid)("texture");
        /** A uvs object based on the given frame and the texture source */ this.uvs = {
            x0: 0,
            y0: 0,
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 0,
            x3: 0,
            y3: 0
        };
        /**
     * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
     * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
     */ this.frame = new (0, $kNl9L.Rectangle)();
        /**
     * Does this Texture have any frame data assigned to it?
     *
     * This mode is enabled automatically if no frame was passed inside constructor.
     *
     * In this mode texture is subscribed to baseTexture events, and fires `update` on any change.
     *
     * Beware, after loading or resize of baseTexture event can fired two times!
     * If you want more control, subscribe on baseTexture itself.
     * @example
     * texture.on('update', () => {});
     */ this.noFrame = false;
        /**
     * Set to true if you plan on modifying the uvs of this texture.
     * When this is the case, sprites and other objects using the texture will
     * make sure to listen for changes to the uvs and update their vertices accordingly.
     */ this.dynamic = false;
        /** is it a texture? yes! used for type checking */ this.isTexture = true;
        this.label = label;
        this.source = source?.source ?? new (0, $gl1XZ.TextureSource)();
        this.noFrame = !frame;
        if (frame) this.frame.copyFrom(frame);
        else {
            const { width: width, height: height } = this._source;
            this.frame.width = width;
            this.frame.height = height;
        }
        this.orig = orig || this.frame;
        this.trim = trim;
        this.rotate = rotate ?? 0;
        this.defaultAnchor = defaultAnchor;
        this.defaultBorders = defaultBorders;
        this.destroyed = false;
        this.dynamic = dynamic || false;
        this.updateUvs();
    }
    set source(value) {
        if (this._source) this._source.off("resize", this.update, this);
        this._source = value;
        value.on("resize", this.update, this);
        this.emit("update", this);
    }
    /** the underlying source of the texture (equivalent of baseTexture in v7) */ get source() {
        return this._source;
    }
    /** returns a TextureMatrix instance for this texture. By default, that object is not created because its heavy. */ get textureMatrix() {
        if (!this._textureMatrix) this._textureMatrix = new (0, $67pbJ.TextureMatrix)(this);
        return this._textureMatrix;
    }
    /** The width of the Texture in pixels. */ get width() {
        return this.orig.width;
    }
    /** The height of the Texture in pixels. */ get height() {
        return this.orig.height;
    }
    /** Call this function when you have modified the frame of this texture. */ updateUvs() {
        const { uvs: uvs, frame: frame } = this;
        const { width: width, height: height } = this._source;
        const nX = frame.x / width;
        const nY = frame.y / height;
        const nW = frame.width / width;
        const nH = frame.height / height;
        let rotate = this.rotate;
        if (rotate) {
            const w2 = nW / 2;
            const h2 = nH / 2;
            const cX = nX + w2;
            const cY = nY + h2;
            rotate = (0, $bLbU4.groupD8).add(rotate, (0, $bLbU4.groupD8).NW);
            uvs.x0 = cX + w2 * (0, $bLbU4.groupD8).uX(rotate);
            uvs.y0 = cY + h2 * (0, $bLbU4.groupD8).uY(rotate);
            rotate = (0, $bLbU4.groupD8).add(rotate, 2);
            uvs.x1 = cX + w2 * (0, $bLbU4.groupD8).uX(rotate);
            uvs.y1 = cY + h2 * (0, $bLbU4.groupD8).uY(rotate);
            rotate = (0, $bLbU4.groupD8).add(rotate, 2);
            uvs.x2 = cX + w2 * (0, $bLbU4.groupD8).uX(rotate);
            uvs.y2 = cY + h2 * (0, $bLbU4.groupD8).uY(rotate);
            rotate = (0, $bLbU4.groupD8).add(rotate, 2);
            uvs.x3 = cX + w2 * (0, $bLbU4.groupD8).uX(rotate);
            uvs.y3 = cY + h2 * (0, $bLbU4.groupD8).uY(rotate);
        } else {
            uvs.x0 = nX;
            uvs.y0 = nY;
            uvs.x1 = nX + nW;
            uvs.y1 = nY;
            uvs.x2 = nX + nW;
            uvs.y2 = nY + nH;
            uvs.x3 = nX;
            uvs.y3 = nY + nH;
        }
    }
    /**
   * Destroys this texture
   * @param destroySource - Destroy the source when the texture is destroyed.
   */ destroy(destroySource = false) {
        if (this._source) {
            this._source.off("resize", this.update, this);
            if (destroySource) {
                this._source.destroy();
                this._source = null;
            }
        }
        this._textureMatrix = null;
        this.destroyed = true;
        this.emit("destroy", this);
        this.removeAllListeners();
    }
    /**
   * Call this if you have modified the `texture outside` of the constructor.
   *
   * If you have modified this texture's source, you must separately call `texture.source.update()` to see those changes.
   */ update() {
        if (this.noFrame) {
            this.frame.width = this._source.width;
            this.frame.height = this._source.height;
        }
        this.updateUvs();
        this.emit("update", this);
    }
    /** @deprecated since 8.0.0 */ get baseTexture() {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "Texture.baseTexture is now Texture.source");
        return this._source;
    }
}
$7bbdc65ac265cc3c$export$5431306cf43de24a.EMPTY = new $7bbdc65ac265cc3c$export$5431306cf43de24a({
    label: "EMPTY",
    source: new (0, $gl1XZ.TextureSource)({
        label: "EMPTY"
    })
});
$7bbdc65ac265cc3c$export$5431306cf43de24a.EMPTY.destroy = (0, $lRaOh.NOOP);
$7bbdc65ac265cc3c$export$5431306cf43de24a.WHITE = new $7bbdc65ac265cc3c$export$5431306cf43de24a({
    source: new (0, $fquaa.BufferImageSource)({
        resource: new Uint8Array([
            255,
            255,
            255,
            255
        ]),
        width: 1,
        height: 1,
        alphaMode: "premultiply-alpha-on-upload",
        label: "WHITE"
    }),
    label: "WHITE"
});
$7bbdc65ac265cc3c$export$5431306cf43de24a.WHITE.destroy = (0, $lRaOh.NOOP);

});
parcelRegister("6AQ4q", function(module, exports) {
'use strict';
var $4cce7efc07365608$var$has = Object.prototype.hasOwnProperty, $4cce7efc07365608$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $4cce7efc07365608$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $4cce7efc07365608$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $4cce7efc07365608$var$Events().__proto__) $4cce7efc07365608$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $4cce7efc07365608$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $4cce7efc07365608$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $4cce7efc07365608$var$EE(fn, context || emitter, once), evt = $4cce7efc07365608$var$prefix ? $4cce7efc07365608$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $4cce7efc07365608$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $4cce7efc07365608$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $4cce7efc07365608$var$EventEmitter() {
    this._events = new $4cce7efc07365608$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $4cce7efc07365608$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($4cce7efc07365608$var$has.call(events, name)) names.push($4cce7efc07365608$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $4cce7efc07365608$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $4cce7efc07365608$var$prefix ? $4cce7efc07365608$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $4cce7efc07365608$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $4cce7efc07365608$var$prefix ? $4cce7efc07365608$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $4cce7efc07365608$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $4cce7efc07365608$var$prefix ? $4cce7efc07365608$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4cce7efc07365608$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $4cce7efc07365608$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4cce7efc07365608$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $4cce7efc07365608$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4cce7efc07365608$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $4cce7efc07365608$var$prefix ? $4cce7efc07365608$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $4cce7efc07365608$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $4cce7efc07365608$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $4cce7efc07365608$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4cce7efc07365608$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $4cce7efc07365608$var$prefix ? $4cce7efc07365608$var$prefix + event : event;
        if (this._events[evt]) $4cce7efc07365608$var$clearEvent(this, evt);
    } else {
        this._events = new $4cce7efc07365608$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$4cce7efc07365608$var$EventEmitter.prototype.off = $4cce7efc07365608$var$EventEmitter.prototype.removeListener;
$4cce7efc07365608$var$EventEmitter.prototype.addListener = $4cce7efc07365608$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$4cce7efc07365608$var$EventEmitter.prefixed = $4cce7efc07365608$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$4cce7efc07365608$var$EventEmitter.EventEmitter = $4cce7efc07365608$var$EventEmitter;
module.exports = $4cce7efc07365608$var$EventEmitter;

});

parcelRegister("bLbU4", function(module, exports) {

$parcel$export(module.exports, "groupD8", () => $38ae5498cf79a20a$export$b7bb6a2a8d203102);

var $deLbn = parcelRequire("deLbn");
"use strict";
const $38ae5498cf79a20a$var$ux = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1
];
const $38ae5498cf79a20a$var$uy = [
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $38ae5498cf79a20a$var$vx = [
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1
];
const $38ae5498cf79a20a$var$vy = [
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    1,
    1,
    1,
    0,
    -1
];
const $38ae5498cf79a20a$var$rotationCayley = [];
const $38ae5498cf79a20a$var$rotationMatrices = [];
const $38ae5498cf79a20a$var$signum = Math.sign;
function $38ae5498cf79a20a$var$init() {
    for(let i = 0; i < 16; i++){
        const row = [];
        $38ae5498cf79a20a$var$rotationCayley.push(row);
        for(let j = 0; j < 16; j++){
            const _ux = $38ae5498cf79a20a$var$signum($38ae5498cf79a20a$var$ux[i] * $38ae5498cf79a20a$var$ux[j] + $38ae5498cf79a20a$var$vx[i] * $38ae5498cf79a20a$var$uy[j]);
            const _uy = $38ae5498cf79a20a$var$signum($38ae5498cf79a20a$var$uy[i] * $38ae5498cf79a20a$var$ux[j] + $38ae5498cf79a20a$var$vy[i] * $38ae5498cf79a20a$var$uy[j]);
            const _vx = $38ae5498cf79a20a$var$signum($38ae5498cf79a20a$var$ux[i] * $38ae5498cf79a20a$var$vx[j] + $38ae5498cf79a20a$var$vx[i] * $38ae5498cf79a20a$var$vy[j]);
            const _vy = $38ae5498cf79a20a$var$signum($38ae5498cf79a20a$var$uy[i] * $38ae5498cf79a20a$var$vx[j] + $38ae5498cf79a20a$var$vy[i] * $38ae5498cf79a20a$var$vy[j]);
            for(let k = 0; k < 16; k++)if ($38ae5498cf79a20a$var$ux[k] === _ux && $38ae5498cf79a20a$var$uy[k] === _uy && $38ae5498cf79a20a$var$vx[k] === _vx && $38ae5498cf79a20a$var$vy[k] === _vy) {
                row.push(k);
                break;
            }
        }
    }
    for(let i = 0; i < 16; i++){
        const mat = new (0, $deLbn.Matrix)();
        mat.set($38ae5498cf79a20a$var$ux[i], $38ae5498cf79a20a$var$uy[i], $38ae5498cf79a20a$var$vx[i], $38ae5498cf79a20a$var$vy[i], 0, 0);
        $38ae5498cf79a20a$var$rotationMatrices.push(mat);
    }
}
$38ae5498cf79a20a$var$init();
const $38ae5498cf79a20a$export$b7bb6a2a8d203102 = {
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 0°       | East      |
   * @group groupD8
   * @type {GD8Symmetry}
   */ E: 0,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 45°↻     | Southeast |
   * @group groupD8
   * @type {GD8Symmetry}
   */ SE: 1,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 90°↻     | South     |
   * @group groupD8
   * @type {GD8Symmetry}
   */ S: 2,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 135°↻    | Southwest |
   * @group groupD8
   * @type {GD8Symmetry}
   */ SW: 3,
    /**
   * | Rotation | Direction |
   * |----------|-----------|
   * | 180°     | West      |
   * @group groupD8
   * @type {GD8Symmetry}
   */ W: 4,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -135°/225°↻ | Northwest    |
   * @group groupD8
   * @type {GD8Symmetry}
   */ NW: 5,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -90°/270°↻  | North        |
   * @group groupD8
   * @type {GD8Symmetry}
   */ N: 6,
    /**
   * | Rotation    | Direction    |
   * |-------------|--------------|
   * | -45°/315°↻  | Northeast    |
   * @group groupD8
   * @type {GD8Symmetry}
   */ NE: 7,
    /**
   * Reflection about Y-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */ MIRROR_VERTICAL: 8,
    /**
   * Reflection about the main diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */ MAIN_DIAGONAL: 10,
    /**
   * Reflection about X-axis.
   * @group groupD8
   * @type {GD8Symmetry}
   */ MIRROR_HORIZONTAL: 12,
    /**
   * Reflection about reverse diagonal.
   * @group groupD8
   * @type {GD8Symmetry}
   */ REVERSE_DIAGONAL: 14,
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the U-axis
   *    after rotating the axes.
   */ uX: (ind)=>$38ae5498cf79a20a$var$ux[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the U-axis
   *    after rotating the axes.
   */ uY: (ind)=>$38ae5498cf79a20a$var$uy[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The X-component of the V-axis
   *    after rotating the axes.
   */ vX: (ind)=>$38ae5498cf79a20a$var$vx[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} ind - sprite rotation angle.
   * @returns {GD8Symmetry} The Y-component of the V-axis
   *    after rotating the axes.
   */ vY: (ind)=>$38ae5498cf79a20a$var$vy[ind],
    /**
   * @group groupD8
   * @param {GD8Symmetry} rotation - symmetry whose opposite
   *   is needed. Only rotations have opposite symmetries while
   *   reflections don't.
   * @returns {GD8Symmetry} The opposite symmetry of `rotation`
   */ inv: (rotation)=>{
        if (rotation & 8) return rotation & 15;
        return -rotation & 7;
    },
    /**
   * Composes the two D8 operations.
   *
   * Taking `^` as reflection:
   *
   * |       | E=0 | S=2 | W=4 | N=6 | E^=8 | S^=10 | W^=12 | N^=14 |
   * |-------|-----|-----|-----|-----|------|-------|-------|-------|
   * | E=0   | E   | S   | W   | N   | E^   | S^    | W^    | N^    |
   * | S=2   | S   | W   | N   | E   | S^   | W^    | N^    | E^    |
   * | W=4   | W   | N   | E   | S   | W^   | N^    | E^    | S^    |
   * | N=6   | N   | E   | S   | W   | N^   | E^    | S^    | W^    |
   * | E^=8  | E^  | N^  | W^  | S^  | E    | N     | W     | S     |
   * | S^=10 | S^  | E^  | N^  | W^  | S    | E     | N     | W     |
   * | W^=12 | W^  | S^  | E^  | N^  | W    | S     | E     | N     |
   * | N^=14 | N^  | W^  | S^  | E^  | N    | W     | S     | E     |
   *
   * [This is a Cayley table]{@link https://en.wikipedia.org/wiki/Cayley_table}
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation, which
   *   is the row in the above cayley table.
   * @param {GD8Symmetry} rotationFirst - First operation, which
   *   is the column in the above cayley table.
   * @returns {GD8Symmetry} Composed operation
   */ add: (rotationSecond, rotationFirst)=>$38ae5498cf79a20a$var$rotationCayley[rotationSecond][rotationFirst],
    /**
   * Reverse of `add`.
   * @group groupD8
   * @param {GD8Symmetry} rotationSecond - Second operation
   * @param {GD8Symmetry} rotationFirst - First operation
   * @returns {GD8Symmetry} Result
   */ sub: (rotationSecond, rotationFirst)=>$38ae5498cf79a20a$var$rotationCayley[rotationSecond][$38ae5498cf79a20a$export$b7bb6a2a8d203102.inv(rotationFirst)],
    /**
   * Adds 180 degrees to rotation, which is a commutative
   * operation.
   * @group groupD8
   * @param {number} rotation - The number to rotate.
   * @returns {number} Rotated number
   */ rotate180: (rotation)=>rotation ^ 4,
    /**
   * Checks if the rotation angle is vertical, i.e. south
   * or north. It doesn't work for reflections.
   * @group groupD8
   * @param {GD8Symmetry} rotation - The number to check.
   * @returns {boolean} Whether or not the direction is vertical
   */ isVertical: (rotation)=>(rotation & 3) === 2,
    // rotation % 4 === 2
    /**
   * Approximates the vector `V(dx,dy)` into one of the
   * eight directions provided by `groupD8`.
   * @group groupD8
   * @param {number} dx - X-component of the vector
   * @param {number} dy - Y-component of the vector
   * @returns {GD8Symmetry} Approximation of the vector into
   *  one of the eight symmetries.
   */ byDirection: (dx, dy)=>{
        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
            if (dy >= 0) return $38ae5498cf79a20a$export$b7bb6a2a8d203102.S;
            return $38ae5498cf79a20a$export$b7bb6a2a8d203102.N;
        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
            if (dx > 0) return $38ae5498cf79a20a$export$b7bb6a2a8d203102.E;
            return $38ae5498cf79a20a$export$b7bb6a2a8d203102.W;
        } else if (dy > 0) {
            if (dx > 0) return $38ae5498cf79a20a$export$b7bb6a2a8d203102.SE;
            return $38ae5498cf79a20a$export$b7bb6a2a8d203102.SW;
        } else if (dx > 0) return $38ae5498cf79a20a$export$b7bb6a2a8d203102.NE;
        return $38ae5498cf79a20a$export$b7bb6a2a8d203102.NW;
    },
    /**
   * Helps sprite to compensate texture packer rotation.
   * @group groupD8
   * @param {Matrix} matrix - sprite world matrix
   * @param {GD8Symmetry} rotation - The rotation factor to use.
   * @param {number} tx - sprite anchoring
   * @param {number} ty - sprite anchoring
   * @param {number} dw - sprite width
   * @param {number} dh - sprite height
   */ matrixAppendRotationInv: (matrix, rotation, tx = 0, ty = 0, dw = 0, dh = 0)=>{
        const mat = $38ae5498cf79a20a$var$rotationMatrices[$38ae5498cf79a20a$export$b7bb6a2a8d203102.inv(rotation)];
        const a = mat.a;
        const b = mat.b;
        const c = mat.c;
        const d = mat.d;
        const finalTx = tx - Math.min(0, a * dw, c * dh, a * dw + c * dh);
        const finalTy = ty - Math.min(0, b * dw, d * dh, b * dw + d * dh);
        const a1 = matrix.a;
        const b1 = matrix.b;
        const c1 = matrix.c;
        const d1 = matrix.d;
        matrix.a = a * a1 + b * c1;
        matrix.b = a * b1 + b * d1;
        matrix.c = c * a1 + d * c1;
        matrix.d = c * b1 + d * d1;
        matrix.tx = finalTx * a1 + finalTy * c1 + matrix.tx;
        matrix.ty = finalTx * b1 + finalTy * d1 + matrix.ty;
    },
    /**
   * Transforms rectangle coordinates based on texture packer rotation.
   * Used when texture atlas pages are rotated and coordinates need to be adjusted.
   * @group groupD8
   * @param {RectangleLike} rect - Rectangle with original coordinates to transform
   * @param {RectangleLike} sourceFrame - Source texture frame (includes offset and dimensions)
   * @param {GD8Symmetry} rotation - The groupD8 rotation value
   * @param {Rectangle} out - Rectangle to store the result
   * @returns {Rectangle} Transformed coordinates (includes source frame offset)
   */ transformRectCoords: (rect, sourceFrame, rotation, out)=>{
        const { x: x, y: y, width: width, height: height } = rect;
        const { x: frameX, y: frameY, width: frameWidth, height: frameHeight } = sourceFrame;
        if (rotation === $38ae5498cf79a20a$export$b7bb6a2a8d203102.E) {
            out.set(x + frameX, y + frameY, width, height);
            return out;
        } else if (rotation === $38ae5498cf79a20a$export$b7bb6a2a8d203102.S) return out.set(frameWidth - y - height + frameX, x + frameY, height, width);
        else if (rotation === $38ae5498cf79a20a$export$b7bb6a2a8d203102.W) return out.set(frameWidth - x - width + frameX, frameHeight - y - height + frameY, width, height);
        else if (rotation === $38ae5498cf79a20a$export$b7bb6a2a8d203102.N) return out.set(y + frameX, frameHeight - x - width + frameY, height, width);
        return out.set(x + frameX, y + frameY, width, height);
    }
};

});
parcelRegister("deLbn", function(module, exports) {

$parcel$export(module.exports, "Matrix", () => $693946078f5e856a$export$5b12bf1653c0dd85);

var $ll3gZ = parcelRequire("ll3gZ");

var $lwGvb = parcelRequire("lwGvb");
"use strict";
class $693946078f5e856a$export$5b12bf1653c0dd85 {
    /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */ constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0){
        /**
     * Array representation of the matrix.
     * Only populated when `toArray()` is called.
     * @default null
     * @see {@link Matrix.toArray} For filling this array
     */ this.array = null;
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
    }
    /**
   * Creates a Matrix object based on the given array.
   * Populates matrix components from a flat array in column-major order.
   *
   * > [!NOTE] Array mapping order:
   * > ```
   * > array[0] = a  (x scale)
   * > array[1] = b  (y skew)
   * > array[2] = tx (x translation)
   * > array[3] = c  (x skew)
   * > array[4] = d  (y scale)
   * > array[5] = ty (y translation)
   * > ```
   * @example
   * ```ts
   * // Create matrix from array
   * const matrix = new Matrix();
   * matrix.fromArray([
   *     2, 0,  100,  // a, b, tx
   *     0, 2,  100   // c, d, ty
   * ]);
   *
   * // Create matrix from typed array
   * const float32Array = new Float32Array([
   *     1, 0, 0,     // Scale x1, no skew
   *     0, 1, 0      // No skew, scale x1
   * ]);
   * matrix.fromArray(float32Array);
   * ```
   * @param array - The array to populate the matrix from
   * @see {@link Matrix.toArray} For converting matrix to array
   * @see {@link Matrix.set} For setting values directly
   */ fromArray(array) {
        this.a = array[0];
        this.b = array[1];
        this.c = array[3];
        this.d = array[4];
        this.tx = array[2];
        this.ty = array[5];
    }
    /**
   * Sets the matrix properties directly.
   * All matrix components can be set in one call.
   * @example
   * ```ts
   * // Set to identity matrix
   * matrix.set(1, 0, 0, 1, 0, 0);
   *
   * // Set to scale matrix
   * matrix.set(2, 0, 0, 2, 0, 0); // Scale 2x
   *
   * // Set to translation matrix
   * matrix.set(1, 0, 0, 1, 100, 50); // Move 100,50
   * ```
   * @param a - Scale on x axis
   * @param b - Shear on y axis
   * @param c - Shear on x axis
   * @param d - Scale on y axis
   * @param tx - Translation on x axis
   * @param ty - Translation on y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.fromArray} For setting from array
   */ set(a, b, c, d, tx, ty) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
        return this;
    }
    /**
   * Creates an array from the current Matrix object.
   *
   * > [!NOTE] The array format is:
   * > ```
   * > Non-transposed:
   * > [a, c, tx,
   * > b, d, ty,
   * > 0, 0, 1]
   * >
   * > Transposed:
   * > [a, b, 0,
   * > c, d, 0,
   * > tx,ty,1]
   * > ```
   * @example
   * ```ts
   * // Basic array conversion
   * const matrix = new Matrix(2, 0, 0, 2, 100, 100);
   * const array = matrix.toArray();
   *
   * // Using existing array
   * const float32Array = new Float32Array(9);
   * matrix.toArray(false, float32Array);
   *
   * // Get transposed array
   * const transposed = matrix.toArray(true);
   * ```
   * @param transpose - Whether to transpose the matrix
   * @param out - Optional Float32Array to store the result
   * @returns The array containing the matrix values
   * @see {@link Matrix.fromArray} For creating matrix from array
   * @see {@link Matrix.array} For cached array storage
   */ toArray(transpose, out) {
        if (!this.array) this.array = new Float32Array(9);
        const array = out || this.array;
        if (transpose) {
            array[0] = this.a;
            array[1] = this.b;
            array[2] = 0;
            array[3] = this.c;
            array[4] = this.d;
            array[5] = 0;
            array[6] = this.tx;
            array[7] = this.ty;
            array[8] = 1;
        } else {
            array[0] = this.a;
            array[1] = this.c;
            array[2] = this.tx;
            array[3] = this.b;
            array[4] = this.d;
            array[5] = this.ty;
            array[6] = 0;
            array[7] = 0;
            array[8] = 1;
        }
        return array;
    }
    /**
   * Get a new position with the current transformation applied.
   *
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   * @example
   * ```ts
   * // Basic point transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const point = new Point(10, 20);
   * const transformed = matrix.apply(point);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.apply(point, output);
   * ```
   * @param pos - The origin point to transform
   * @param newPos - Optional point to store the result
   * @returns The transformed point
   * @see {@link Matrix.applyInverse} For inverse transformation
   * @see {@link Point} For point operations
   */ apply(pos, newPos) {
        newPos = newPos || new (0, $lwGvb.Point)();
        const x = pos.x;
        const y = pos.y;
        newPos.x = this.a * x + this.c * y + this.tx;
        newPos.y = this.b * x + this.d * y + this.ty;
        return newPos;
    }
    /**
   * Get a new position with the inverse of the current transformation applied.
   *
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   * @example
   * ```ts
   * // Basic inverse transformation
   * const matrix = new Matrix().translate(100, 50).rotate(Math.PI / 4);
   * const worldPoint = new Point(150, 100);
   * const localPoint = matrix.applyInverse(worldPoint);
   *
   * // Reuse existing point
   * const output = new Point();
   * matrix.applyInverse(worldPoint, output);
   *
   * // Convert mouse position to local space
   * const mousePoint = new Point(mouseX, mouseY);
   * const localMouse = matrix.applyInverse(mousePoint);
   * ```
   * @param pos - The origin point to inverse-transform
   * @param newPos - Optional point to store the result
   * @returns The inverse-transformed point
   * @see {@link Matrix.apply} For forward transformation
   * @see {@link Matrix.invert} For getting inverse matrix
   */ applyInverse(pos, newPos) {
        newPos = newPos || new (0, $lwGvb.Point)();
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const tx = this.tx;
        const ty = this.ty;
        const id = 1 / (a * d + c * -b);
        const x = pos.x;
        const y = pos.y;
        newPos.x = d * id * x + -c * id * y + (ty * c - tx * d) * id;
        newPos.y = a * id * y + -b * id * x + (-ty * a + tx * b) * id;
        return newPos;
    }
    /**
   * Translates the matrix on the x and y axes.
   * Adds to the position values while preserving scale, rotation and skew.
   * @example
   * ```ts
   * // Basic translation
   * const matrix = new Matrix();
   * matrix.translate(100, 50); // Move right 100, down 50
   *
   * // Chain with other transformations
   * matrix
   *     .scale(2, 2)
   *     .translate(100, 0)
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - How much to translate on the x axis
   * @param y - How much to translate on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.set} For setting position directly
   * @see {@link Matrix.setTransform} For complete transform setup
   */ translate(x, y) {
        this.tx += x;
        this.ty += y;
        return this;
    }
    /**
   * Applies a scale transformation to the matrix.
   * Multiplies the scale values with existing matrix components.
   * @example
   * ```ts
   * // Basic scaling
   * const matrix = new Matrix();
   * matrix.scale(2, 3); // Scale 2x horizontally, 3x vertically
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100)
   *     .scale(2, 2)     // Scales after translation
   *     .rotate(Math.PI / 4);
   * ```
   * @param x - The amount to scale horizontally
   * @param y - The amount to scale vertically
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting scale directly
   * @see {@link Matrix.append} For combining transformations
   */ scale(x, y) {
        this.a *= x;
        this.d *= y;
        this.c *= x;
        this.b *= y;
        this.tx *= x;
        this.ty *= y;
        return this;
    }
    /**
   * Applies a rotation transformation to the matrix.
   *
   * Rotates around the origin (0,0) by the given angle in radians.
   * @example
   * ```ts
   * // Basic rotation
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // Rotate 45 degrees
   *
   * // Chain with other transformations
   * matrix
   *     .translate(100, 100) // Move to rotation center
   *     .rotate(Math.PI)     // Rotate 180 degrees
   *     .scale(2, 2);        // Scale after rotation
   *
   * // Common angles
   * matrix.rotate(Math.PI / 2);  // 90 degrees
   * matrix.rotate(Math.PI);      // 180 degrees
   * matrix.rotate(Math.PI * 2);  // 360 degrees
   * ```
   * @remarks
   * - Rotates around origin point (0,0)
   * - Affects position if translation was set
   * - Uses counter-clockwise rotation
   * - Order of operations matters when chaining
   * @param angle - The angle in radians
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.setTransform} For setting rotation directly
   * @see {@link Matrix.append} For combining transformations
   */ rotate(angle) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const a1 = this.a;
        const c1 = this.c;
        const tx1 = this.tx;
        this.a = a1 * cos - this.b * sin;
        this.b = a1 * sin + this.b * cos;
        this.c = c1 * cos - this.d * sin;
        this.d = c1 * sin + this.d * cos;
        this.tx = tx1 * cos - this.ty * sin;
        this.ty = tx1 * sin + this.ty * cos;
        return this;
    }
    /**
   * Appends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = this * matrix
   * @example
   * ```ts
   * // Basic matrix combination
   * const matrix = new Matrix();
   * const other = new Matrix().translate(100, 0).rotate(Math.PI / 4);
   * matrix.append(other);
   * ```
   * @remarks
   * - Order matters: A.append(B) !== B.append(A)
   * - Modifies current matrix
   * - Preserves transformation order
   * - Commonly used for combining transforms
   * @param matrix - The matrix to append
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.prepend} For prepending transformations
   * @see {@link Matrix.appendFrom} For appending two external matrices
   */ append(matrix) {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        this.a = matrix.a * a1 + matrix.b * c1;
        this.b = matrix.a * b1 + matrix.b * d1;
        this.c = matrix.c * a1 + matrix.d * c1;
        this.d = matrix.c * b1 + matrix.d * d1;
        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
        return this;
    }
    /**
   * Appends two matrices and sets the result to this matrix.
   * Performs matrix multiplication: this = A * B
   * @example
   * ```ts
   * // Basic matrix multiplication
   * const result = new Matrix();
   * const matrixA = new Matrix().scale(2, 2);
   * const matrixB = new Matrix().rotate(Math.PI / 4);
   * result.appendFrom(matrixA, matrixB);
   * ```
   * @remarks
   * - Order matters: A * B !== B * A
   * - Creates a new transformation from two others
   * - More efficient than append() for multiple operations
   * - Does not modify input matrices
   * @param a - The first matrix to multiply
   * @param b - The second matrix to multiply
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For single matrix combination
   * @see {@link Matrix.prepend} For reverse order multiplication
   */ appendFrom(a, b) {
        const a1 = a.a;
        const b1 = a.b;
        const c1 = a.c;
        const d1 = a.d;
        const tx = a.tx;
        const ty = a.ty;
        const a2 = b.a;
        const b2 = b.b;
        const c2 = b.c;
        const d2 = b.d;
        this.a = a1 * a2 + b1 * c2;
        this.b = a1 * b2 + b1 * d2;
        this.c = c1 * a2 + d1 * c2;
        this.d = c1 * b2 + d1 * d2;
        this.tx = tx * a2 + ty * c2 + b.tx;
        this.ty = tx * b2 + ty * d2 + b.ty;
        return this;
    }
    /**
   * Sets the matrix based on all the available properties.
   * Combines position, scale, rotation, skew and pivot in a single operation.
   * @example
   * ```ts
   * // Basic transform setup
   * const matrix = new Matrix();
   * matrix.setTransform(
   *     100, 100,    // position
   *     0, 0,        // pivot
   *     2, 2,        // scale
   *     Math.PI / 4, // rotation (45 degrees)
   *     0, 0         // skew
   * );
   * ```
   * @remarks
   * - Updates all matrix components at once
   * - More efficient than separate transform calls
   * - Uses radians for rotation and skew
   * - Pivot affects rotation center
   * @param x - Position on the x axis
   * @param y - Position on the y axis
   * @param pivotX - Pivot on the x axis
   * @param pivotY - Pivot on the y axis
   * @param scaleX - Scale on the x axis
   * @param scaleY - Scale on the y axis
   * @param rotation - Rotation in radians
   * @param skewX - Skew on the x axis
   * @param skewY - Skew on the y axis
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.decompose} For extracting transform properties
   * @see {@link TransformableObject} For transform data structure
   */ setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
        this.a = Math.cos(rotation + skewY) * scaleX;
        this.b = Math.sin(rotation + skewY) * scaleX;
        this.c = -Math.sin(rotation - skewX) * scaleY;
        this.d = Math.cos(rotation - skewX) * scaleY;
        this.tx = x - (pivotX * this.a + pivotY * this.c);
        this.ty = y - (pivotX * this.b + pivotY * this.d);
        return this;
    }
    /**
   * Prepends the given Matrix to this Matrix.
   * Combines two matrices by multiplying them together: this = matrix * this
   * @example
   * ```ts
   * // Basic matrix prepend
   * const matrix = new Matrix().scale(2, 2);
   * const other = new Matrix().translate(100, 0);
   * matrix.prepend(other); // Translation happens before scaling
   * ```
   * @remarks
   * - Order matters: A.prepend(B) !== B.prepend(A)
   * - Modifies current matrix
   * - Reverses transformation order compared to append()
   * @param matrix - The matrix to prepend
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.append} For appending transformations
   * @see {@link Matrix.appendFrom} For combining external matrices
   */ prepend(matrix) {
        const tx1 = this.tx;
        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            const a1 = this.a;
            const c1 = this.c;
            this.a = a1 * matrix.a + this.b * matrix.c;
            this.b = a1 * matrix.b + this.b * matrix.d;
            this.c = c1 * matrix.a + this.d * matrix.c;
            this.d = c1 * matrix.b + this.d * matrix.d;
        }
        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
        return this;
    }
    /**
   * Decomposes the matrix into its individual transform components.
   * Extracts position, scale, rotation and skew values from the matrix.
   * @example
   * ```ts
   * // Basic decomposition
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * const transform = {
   *     position: new Point(),
   *     scale: new Point(),
   *     pivot: new Point(),
   *     skew: new Point(),
   *     rotation: 0
   * };
   *
   * matrix.decompose(transform);
   * console.log(transform.position); // Point(100, 100)
   * console.log(transform.rotation); // ~0.785 (PI/4)
   * console.log(transform.scale); // Point(2, 2)
   * ```
   * @remarks
   * - Handles combined transformations
   * - Accounts for pivot points
   * - Chooses between rotation/skew based on transform type
   * - Uses radians for rotation and skew
   * @param transform - The transform object to store the decomposed values
   * @returns The transform with the newly applied properties
   * @see {@link Matrix.setTransform} For composing from components
   * @see {@link TransformableObject} For transform structure
   */ decompose(transform) {
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const pivot = transform.pivot;
        const skewX = -Math.atan2(-c, d);
        const skewY = Math.atan2(b, a);
        const delta = Math.abs(skewX + skewY);
        if (delta < 1e-5 || Math.abs((0, $ll3gZ.PI_2) - delta) < 1e-5) {
            transform.rotation = skewY;
            transform.skew.x = transform.skew.y = 0;
        } else {
            transform.rotation = 0;
            transform.skew.x = skewX;
            transform.skew.y = skewY;
        }
        transform.scale.x = Math.sqrt(a * a + b * b);
        transform.scale.y = Math.sqrt(c * c + d * d);
        transform.position.x = this.tx + (pivot.x * a + pivot.y * c);
        transform.position.y = this.ty + (pivot.x * b + pivot.y * d);
        return transform;
    }
    /**
   * Inverts this matrix.
   * Creates the matrix that when multiplied with this matrix results in an identity matrix.
   * @example
   * ```ts
   * // Basic matrix inversion
   * const matrix = new Matrix()
   *     .translate(100, 50)
   *     .scale(2, 2);
   *
   * matrix.invert(); // Now transforms in opposite direction
   *
   * // Verify inversion
   * const point = new Point(50, 50);
   * const transformed = matrix.apply(point);
   * const original = matrix.invert().apply(transformed);
   * // original ≈ point
   * ```
   * @remarks
   * - Modifies the current matrix
   * - Useful for reversing transformations
   * - Cannot invert matrices with zero determinant
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.applyInverse} For inverse transformations
   */ invert() {
        const a1 = this.a;
        const b1 = this.b;
        const c1 = this.c;
        const d1 = this.d;
        const tx1 = this.tx;
        const n = a1 * d1 - b1 * c1;
        this.a = d1 / n;
        this.b = -b1 / n;
        this.c = -c1 / n;
        this.d = a1 / n;
        this.tx = (c1 * this.ty - d1 * tx1) / n;
        this.ty = -(a1 * this.ty - b1 * tx1) / n;
        return this;
    }
    /**
   * Checks if this matrix is an identity matrix.
   *
   * An identity matrix has no transformations applied (default state).
   * @example
   * ```ts
   * // Check if matrix is identity
   * const matrix = new Matrix();
   * console.log(matrix.isIdentity()); // true
   *
   * // Check after transformations
   * matrix.translate(100, 0);
   * console.log(matrix.isIdentity()); // false
   *
   * // Reset and verify
   * matrix.identity();
   * console.log(matrix.isIdentity()); // true
   * ```
   * @remarks
   * - Verifies a = 1, d = 1 (no scale)
   * - Verifies b = 0, c = 0 (no skew)
   * - Verifies tx = 0, ty = 0 (no translation)
   * @returns True if matrix has no transformations
   * @see {@link Matrix.identity} For resetting to identity
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   */ isIdentity() {
        return this.a === 1 && this.b === 0 && this.c === 0 && this.d === 1 && this.tx === 0 && this.ty === 0;
    }
    /**
   * Resets this Matrix to an identity (default) matrix.
   * Sets all components to their default values: scale=1, no skew, no translation.
   * @example
   * ```ts
   * // Reset transformed matrix
   * const matrix = new Matrix()
   *     .scale(2, 2)
   *     .rotate(Math.PI / 4);
   * matrix.identity(); // Back to default state
   *
   * // Chain after reset
   * matrix
   *     .identity()
   *     .translate(100, 100)
   *     .scale(2, 2);
   *
   * // Compare with identity constant
   * const isDefault = matrix.equals(Matrix.IDENTITY);
   * ```
   * @remarks
   * - Sets a=1, d=1 (default scale)
   * - Sets b=0, c=0 (no skew)
   * - Sets tx=0, ty=0 (no translation)
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.IDENTITY} For constant identity matrix
   * @see {@link Matrix.isIdentity} For checking identity state
   */ identity() {
        this.a = 1;
        this.b = 0;
        this.c = 0;
        this.d = 1;
        this.tx = 0;
        this.ty = 0;
        return this;
    }
    /**
   * Creates a new Matrix object with the same values as this one.
   * @returns A copy of this matrix. Good for chaining method calls.
   */ clone() {
        const matrix = new $693946078f5e856a$export$5b12bf1653c0dd85();
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    /**
   * Creates a new Matrix object with the same values as this one.
   * @param matrix
   * @example
   * ```ts
   * // Basic matrix cloning
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const copy = matrix.clone();
   *
   * // Clone and modify
   * const modified = matrix.clone()
   *     .scale(2, 2);
   *
   * // Compare matrices
   * console.log(matrix.equals(copy));     // true
   * console.log(matrix.equals(modified)); // false
   * ```
   * @returns A copy of this matrix. Good for chaining method calls.
   * @see {@link Matrix.copyTo} For copying to existing matrix
   * @see {@link Matrix.copyFrom} For copying from another matrix
   */ copyTo(matrix) {
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;
        return matrix;
    }
    /**
   * Changes the values of the matrix to be the same as the ones in given matrix.
   * @example
   * ```ts
   * // Basic matrix copying
   * const source = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4);
   * const target = new Matrix();
   * target.copyFrom(source);
   * ```
   * @param matrix - The matrix to copy from
   * @returns This matrix. Good for chaining method calls.
   * @see {@link Matrix.clone} For creating new matrix copy
   * @see {@link Matrix.copyTo} For copying to another matrix
   */ copyFrom(matrix) {
        this.a = matrix.a;
        this.b = matrix.b;
        this.c = matrix.c;
        this.d = matrix.d;
        this.tx = matrix.tx;
        this.ty = matrix.ty;
        return this;
    }
    /**
   * Checks if this matrix equals another matrix.
   * Compares all components for exact equality.
   * @example
   * ```ts
   * // Basic equality check
   * const m1 = new Matrix();
   * const m2 = new Matrix();
   * console.log(m1.equals(m2)); // true
   *
   * // Compare transformed matrices
   * const transform = new Matrix()
   *     .translate(100, 100)
   * const clone = new Matrix()
   *     .scale(2, 2);
   * console.log(transform.equals(clone)); // false
   * ```
   * @param matrix - The matrix to compare to
   * @returns True if matrices are identical
   * @see {@link Matrix.copyFrom} For copying matrix values
   * @see {@link Matrix.isIdentity} For identity comparison
   */ equals(matrix) {
        return matrix.a === this.a && matrix.b === this.b && matrix.c === this.c && matrix.d === this.d && matrix.tx === this.tx && matrix.ty === this.ty;
    }
    toString() {
        return `[pixi.js:Matrix a=${this.a} b=${this.b} c=${this.c} d=${this.d} tx=${this.tx} ty=${this.ty}]`;
    }
    /**
   * A default (identity) matrix with no transformations applied.
   *
   * > [!IMPORTANT] This is a shared read-only object. Create a new Matrix if you need to modify it.
   * @example
   * ```ts
   * // Get identity matrix reference
   * const identity = Matrix.IDENTITY;
   * console.log(identity.isIdentity()); // true
   *
   * // Compare with identity
   * const matrix = new Matrix();
   * console.log(matrix.equals(Matrix.IDENTITY)); // true
   *
   * // Create new matrix instead of modifying IDENTITY
   * const transform = new Matrix()
   *     .copyFrom(Matrix.IDENTITY)
   *     .translate(100, 100);
   * ```
   * @readonly
   * @returns A read-only identity matrix
   * @see {@link Matrix.shared} For temporary calculations
   * @see {@link Matrix.identity} For resetting matrices
   */ static get IDENTITY() {
        return $693946078f5e856a$var$identityMatrix.identity();
    }
    /**
   * A static Matrix that can be used to avoid creating new objects.
   * Will always ensure the matrix is reset to identity when requested.
   *
   * > [!IMPORTANT] This matrix is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempMatrix = Matrix.shared;
   * tempMatrix.translate(100, 100).rotate(Math.PI / 4);
   * const point = tempMatrix.apply({ x: 10, y: 20 });
   *
   * // Will be reset to identity on next access
   * const fresh = Matrix.shared; // Back to identity
   * ```
   * @remarks
   * - Always returns identity matrix
   * - Safe to modify temporarily
   * - Not safe to store references
   * - Useful for one-off calculations
   * @readonly
   * @returns A fresh identity matrix for temporary use
   * @see {@link Matrix.IDENTITY} For immutable identity matrix
   * @see {@link Matrix.identity} For resetting matrices
   */ static get shared() {
        return $693946078f5e856a$var$tempMatrix.identity();
    }
}
const $693946078f5e856a$var$tempMatrix = new $693946078f5e856a$export$5b12bf1653c0dd85();
const $693946078f5e856a$var$identityMatrix = new $693946078f5e856a$export$5b12bf1653c0dd85();

});
parcelRegister("ll3gZ", function(module, exports) {

$parcel$export(module.exports, "PI_2", () => $43b7c84dea92c0cd$export$59ed0a0a5de1084b);
$parcel$export(module.exports, "RAD_TO_DEG", () => $43b7c84dea92c0cd$export$3f91627dc85c5d57);
$parcel$export(module.exports, "DEG_TO_RAD", () => $43b7c84dea92c0cd$export$870617f62e3187f1);
"use strict";
const $43b7c84dea92c0cd$export$59ed0a0a5de1084b = Math.PI * 2;
const $43b7c84dea92c0cd$export$3f91627dc85c5d57 = 180 / Math.PI;
const $43b7c84dea92c0cd$export$870617f62e3187f1 = Math.PI / 180;

});

parcelRegister("lwGvb", function(module, exports) {

$parcel$export(module.exports, "Point", () => $d835165070fa52ef$export$baf26146a414f24a);
"use strict";
class $d835165070fa52ef$export$baf26146a414f24a {
    /**
   * Creates a new `Point`
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */ constructor(x = 0, y = 0){
        /**
     * Position of the point on the x axis
     * @example
     * ```ts
     * // Set x position
     * const point = new Point();
     * point.x = 100;
     *
     * // Use in calculations
     * const width = rightPoint.x - leftPoint.x;
     * ```
     */ this.x = 0;
        /**
     * Position of the point on the y axis
     * @example
     * ```ts
     * // Set y position
     * const point = new Point();
     * point.y = 200;
     *
     * // Use in calculations
     * const height = bottomPoint.y - topPoint.y;
     * ```
     */ this.y = 0;
        this.x = x;
        this.y = y;
    }
    /**
   * Creates a clone of this point, which is a new instance with the same `x` and `y` values.
   * @example
   * ```ts
   * // Basic point cloning
   * const original = new Point(100, 200);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.set(300, 400);
   *
   * // Verify independence
   * console.log(original); // Point(100, 200)
   * console.log(modified); // Point(300, 400)
   * ```
   * @remarks
   * - Creates new Point instance
   * - Deep copies x and y values
   * - Independent from original
   * - Useful for preserving values
   * @returns A clone of this point
   * @see {@link Point.copyFrom} For copying into existing point
   * @see {@link Point.copyTo} For copying to existing point
   */ clone() {
        return new $d835165070fa52ef$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * Copies x and y from the given point into this point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * target.copyFrom(source);
   *
   * // Copy and chain operations
   * const point = new Point()
   *     .copyFrom(source)
   *     .set(x + 50, y + 50);
   *
   * // Copy from any PointData
   * const data = { x: 10, y: 20 };
   * point.copyFrom(data);
   * ```
   * @param p - The point to copy from
   * @returns The point instance itself
   * @see {@link Point.copyTo} For copying to another point
   * @see {@link Point.clone} For creating new point copy
   */ copyFrom(p) {
        this.set(p.x, p.y);
        return this;
    }
    /**
   * Copies this point's x and y into the given point.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Point(100, 200);
   * const target = new Point();
   * source.copyTo(target);
   * ```
   * @param p - The point to copy to. Can be any type that is or extends `PointLike`
   * @returns The point (`p`) with values updated
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.clone} For creating new point copy
   */ copyTo(p) {
        p.set(this.x, this.y);
        return p;
    }
    /**
   * Checks if another point is equal to this point.
   *
   * Compares x and y values using strict equality.
   * @example
   * ```ts
   * // Basic equality check
   * const p1 = new Point(100, 200);
   * const p2 = new Point(100, 200);
   * console.log(p1.equals(p2)); // true
   *
   * // Compare with PointData
   * const data = { x: 100, y: 200 };
   * console.log(p1.equals(data)); // true
   *
   * // Check different points
   * const p3 = new Point(200, 300);
   * console.log(p1.equals(p3)); // false
   * ```
   * @param p - The point to check
   * @returns `true` if both `x` and `y` are equal
   * @see {@link Point.copyFrom} For making points equal
   * @see {@link PointData} For point data interface
   */ equals(p) {
        return p.x === this.x && p.y === this.y;
    }
    /**
   * Sets the point to a new x and y position.
   *
   * If y is omitted, both x and y will be set to x.
   * @example
   * ```ts
   * // Basic position setting
   * const point = new Point();
   * point.set(100, 200);
   *
   * // Set both x and y to same value
   * point.set(50); // x=50, y=50
   *
   * // Chain with other operations
   * point
   *     .set(10, 20)
   *     .copyTo(otherPoint);
   * ```
   * @param x - Position on the x axis
   * @param y - Position on the y axis, defaults to x
   * @returns The point instance itself
   * @see {@link Point.copyFrom} For copying from another point
   * @see {@link Point.equals} For comparing positions
   */ set(x = 0, y = x) {
        this.x = x;
        this.y = y;
        return this;
    }
    toString() {
        return `[pixi.js/math:Point x=${this.x} y=${this.y}]`;
    }
    /**
   * A static Point object with `x` and `y` values of `0`.
   *
   * This shared instance is reset to zero values when accessed.
   *
   * > [!IMPORTANT] This point is shared and temporary. Do not store references to it.
   * @example
   * ```ts
   * // Use for temporary calculations
   * const tempPoint = Point.shared;
   * tempPoint.set(100, 200);
   * matrix.apply(tempPoint);
   *
   * // Will be reset to (0,0) on next access
   * const fresh = Point.shared; // x=0, y=0
   * ```
   * @readonly
   * @returns A fresh zeroed point for temporary use
   * @see {@link Point.constructor} For creating new points
   * @see {@link PointData} For basic point interface
   */ static get shared() {
        $d835165070fa52ef$var$tempPoint.x = 0;
        $d835165070fa52ef$var$tempPoint.y = 0;
        return $d835165070fa52ef$var$tempPoint;
    }
}
const $d835165070fa52ef$var$tempPoint = new $d835165070fa52ef$export$baf26146a414f24a();

});



parcelRegister("kNl9L", function(module, exports) {

$parcel$export(module.exports, "Rectangle", () => $f41957fced550189$export$4617fb02663045ef);

var $lwGvb = parcelRequire("lwGvb");
"use strict";
const $f41957fced550189$var$tempPoints = [
    new (0, $lwGvb.Point)(),
    new (0, $lwGvb.Point)(),
    new (0, $lwGvb.Point)(),
    new (0, $lwGvb.Point)()
];
class $f41957fced550189$export$4617fb02663045ef {
    /**
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   */ constructor(x = 0, y = 0, width = 0, height = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Rectangle(0, 0, 100, 100);
     * console.log(shape.type); // 'rectangle'
     *
     * // Use in type guards
     * if (shape.type === 'rectangle') {
     *     console.log(shape.width, shape.height);
     * }
     * ```
     * @readonly
     * @default 'rectangle'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "rectangle";
        this.x = Number(x);
        this.y = Number(y);
        this.width = Number(width);
        this.height = Number(height);
    }
    /**
   * Returns the left edge (x-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get left edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.left); // 100
   *
   * // Use in alignment calculations
   * sprite.x = rect.left + padding;
   *
   * // Compare positions
   * if (point.x > rect.left) {
   *     console.log('Point is right of rectangle');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the left edge
   * @see {@link Rectangle.right} For right edge position
   * @see {@link Rectangle.x} For direct x-coordinate access
   */ get left() {
        return this.x;
    }
    /**
   * Returns the right edge (x + width) of the rectangle.
   * @example
   * ```ts
   * // Get right edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.right); // 300
   *
   * // Align to right edge
   * sprite.x = rect.right - sprite.width;
   *
   * // Check boundaries
   * if (point.x < rect.right) {
   *     console.log('Point is inside right bound');
   * }
   * ```
   * @readonly
   * @returns The x-coordinate of the right edge
   * @see {@link Rectangle.left} For left edge position
   * @see {@link Rectangle.width} For width value
   */ get right() {
        return this.x + this.width;
    }
    /**
   * Returns the top edge (y-coordinate) of the rectangle.
   * @example
   * ```ts
   * // Get top edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.top); // 100
   *
   * // Position above rectangle
   * sprite.y = rect.top - sprite.height;
   *
   * // Check vertical position
   * if (point.y > rect.top) {
   *     console.log('Point is below top edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the top edge
   * @see {@link Rectangle.bottom} For bottom edge position
   * @see {@link Rectangle.y} For direct y-coordinate access
   */ get top() {
        return this.y;
    }
    /**
   * Returns the bottom edge (y + height) of the rectangle.
   * @example
   * ```ts
   * // Get bottom edge position
   * const rect = new Rectangle(100, 100, 200, 150);
   * console.log(rect.bottom); // 250
   *
   * // Stack below rectangle
   * sprite.y = rect.bottom + margin;
   *
   * // Check vertical bounds
   * if (point.y < rect.bottom) {
   *     console.log('Point is above bottom edge');
   * }
   * ```
   * @readonly
   * @returns The y-coordinate of the bottom edge
   * @see {@link Rectangle.top} For top edge position
   * @see {@link Rectangle.height} For height value
   */ get bottom() {
        return this.y + this.height;
    }
    /**
   * Determines whether the Rectangle is empty (has no area).
   * @example
   * ```ts
   * // Check zero dimensions
   * const rect = new Rectangle(100, 100, 0, 50);
   * console.log(rect.isEmpty()); // true
   * ```
   * @returns True if the rectangle has no area
   * @see {@link Rectangle.width} For width value
   * @see {@link Rectangle.height} For height value
   */ isEmpty() {
        return this.left === this.right || this.top === this.bottom;
    }
    /**
   * A constant empty rectangle. This is a new object every time the property is accessed.
   * @example
   * ```ts
   * // Get fresh empty rectangle
   * const empty = Rectangle.EMPTY;
   * console.log(empty.isEmpty()); // true
   * ```
   * @returns A new empty rectangle instance
   * @see {@link Rectangle.isEmpty} For empty state testing
   */ static get EMPTY() {
        return new $f41957fced550189$export$4617fb02663045ef(0, 0, 0, 0);
    }
    /**
   * Creates a clone of this Rectangle
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Rectangle(100, 100, 200, 150);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.width *= 2;
   * modified.height += 50;
   *
   * // Verify independence
   * console.log(original.width);  // 200
   * console.log(modified.width);  // 400
   * ```
   * @returns A copy of the rectangle
   * @see {@link Rectangle.copyFrom} For copying into existing rectangle
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   */ clone() {
        return new $f41957fced550189$export$4617fb02663045ef(this.x, this.y, this.width, this.height);
    }
    /**
   * Converts a Bounds object to a Rectangle object.
   * @example
   * ```ts
   * // Convert bounds to rectangle
   * const bounds = container.getBounds();
   * const rect = new Rectangle().copyFromBounds(bounds);
   * ```
   * @param bounds - The bounds to copy and convert to a rectangle
   * @returns Returns itself
   * @see {@link Bounds} For bounds object structure
   * @see {@link Rectangle.getBounds} For getting rectangle bounds
   */ copyFromBounds(bounds) {
        this.x = bounds.minX;
        this.y = bounds.minY;
        this.width = bounds.maxX - bounds.minX;
        this.height = bounds.maxY - bounds.minY;
        return this;
    }
    /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new Rectangle()
   *     .copyFrom(source)
   *     .pad(10);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link Rectangle.copyTo} For copying to another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */ copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Rectangle(100, 100, 200, 150);
   * const target = new Rectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new Rectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating new rectangle copy
   */ copyTo(rectangle) {
        rectangle.copyFrom(this);
        return rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isInside = rect.contains(150, 125); // true
   * // Check edge cases
   * console.log(rect.contains(100, 100)); // true (on edge)
   * console.log(rect.contains(300, 250)); // false (outside)
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rectangle
   * @see {@link Rectangle.containsRect} For rectangle containment
   * @see {@link Rectangle.strokeContains} For checking stroke intersection
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x < this.x + this.width) {
            if (y >= this.y && y < this.y + this.height) return true;
        }
        return false;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new Rectangle(100, 100, 200, 150);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link Rectangle.contains} For checking fill containment
   * @see {@link Rectangle.getBounds} For getting stroke bounds
   */ strokeContains(x, y, strokeWidth, alignment = 0.5) {
        const { width: width, height: height } = this;
        if (width <= 0 || height <= 0) return false;
        const _x = this.x;
        const _y = this.y;
        const strokeWidthOuter = strokeWidth * (1 - alignment);
        const strokeWidthInner = strokeWidth - strokeWidthOuter;
        const outerLeft = _x - strokeWidthOuter;
        const outerRight = _x + width + strokeWidthOuter;
        const outerTop = _y - strokeWidthOuter;
        const outerBottom = _y + height + strokeWidthOuter;
        const innerLeft = _x + strokeWidthInner;
        const innerRight = _x + width - strokeWidthInner;
        const innerTop = _y + strokeWidthInner;
        const innerBottom = _y + height - strokeWidthInner;
        return x >= outerLeft && x <= outerRight && y >= outerTop && y <= outerBottom && !(x > innerLeft && x < innerRight && y > innerTop && y < innerBottom);
    }
    /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   * Returns true only if the area of the intersection is >0, this means that Rectangles
   * sharing a side are not overlapping. Another side effect is that an arealess rectangle
   * (width or height equal to zero) can't intersect any other rectangle.
   * @param {Rectangle} other - The Rectangle to intersect with `this`.
   * @param {Matrix} transform - The transformation matrix of `other`.
   * @returns {boolean} A value of `true` if the transformed `other` Rectangle intersects with `this`; otherwise `false`.
   */ /**
   * Determines whether the `other` Rectangle transformed by `transform` intersects with `this` Rectangle object.
   *
   * Returns true only if the area of the intersection is greater than 0.
   * This means that rectangles sharing only a side are not considered intersecting.
   * @example
   * ```ts
   * // Basic intersection check
   * const rect1 = new Rectangle(0, 0, 100, 100);
   * const rect2 = new Rectangle(50, 50, 100, 100);
   * console.log(rect1.intersects(rect2)); // true
   *
   * // With transformation matrix
   * const matrix = new Matrix();
   * matrix.rotate(Math.PI / 4); // 45 degrees
   * console.log(rect1.intersects(rect2, matrix)); // Checks with rotation
   *
   * // Edge cases
   * const zeroWidth = new Rectangle(0, 0, 0, 100);
   * console.log(rect1.intersects(zeroWidth)); // false (no area)
   * ```
   * @remarks
   * - Returns true only if intersection area is > 0
   * - Rectangles sharing only a side are not intersecting
   * - Zero-area rectangles cannot intersect anything
   * - Supports optional transformation matrix
   * @param other - The Rectangle to intersect with `this`
   * @param transform - Optional transformation matrix of `other`
   * @returns True if the transformed `other` Rectangle intersects with `this`
   * @see {@link Rectangle.containsRect} For containment testing
   * @see {@link Rectangle.contains} For point testing
   */ intersects(other, transform) {
        if (!transform) {
            const x02 = this.x < other.x ? other.x : this.x;
            const x12 = this.right > other.right ? other.right : this.right;
            if (x12 <= x02) return false;
            const y02 = this.y < other.y ? other.y : this.y;
            const y12 = this.bottom > other.bottom ? other.bottom : this.bottom;
            return y12 > y02;
        }
        const x0 = this.left;
        const x1 = this.right;
        const y0 = this.top;
        const y1 = this.bottom;
        if (x1 <= x0 || y1 <= y0) return false;
        const lt = $f41957fced550189$var$tempPoints[0].set(other.left, other.top);
        const lb = $f41957fced550189$var$tempPoints[1].set(other.left, other.bottom);
        const rt = $f41957fced550189$var$tempPoints[2].set(other.right, other.top);
        const rb = $f41957fced550189$var$tempPoints[3].set(other.right, other.bottom);
        if (rt.x <= lt.x || lb.y <= lt.y) return false;
        const s = Math.sign(transform.a * transform.d - transform.b * transform.c);
        if (s === 0) return false;
        transform.apply(lt, lt);
        transform.apply(lb, lb);
        transform.apply(rt, rt);
        transform.apply(rb, rb);
        if (Math.max(lt.x, lb.x, rt.x, rb.x) <= x0 || Math.min(lt.x, lb.x, rt.x, rb.x) >= x1 || Math.max(lt.y, lb.y, rt.y, rb.y) <= y0 || Math.min(lt.y, lb.y, rt.y, rb.y) >= y1) return false;
        const nx = s * (lb.y - lt.y);
        const ny = s * (lt.x - lb.x);
        const n00 = nx * x0 + ny * y0;
        const n10 = nx * x1 + ny * y0;
        const n01 = nx * x0 + ny * y1;
        const n11 = nx * x1 + ny * y1;
        if (Math.max(n00, n10, n01, n11) <= nx * lt.x + ny * lt.y || Math.min(n00, n10, n01, n11) >= nx * rb.x + ny * rb.y) return false;
        const mx = s * (lt.y - rt.y);
        const my = s * (rt.x - lt.x);
        const m00 = mx * x0 + my * y0;
        const m10 = mx * x1 + my * y0;
        const m01 = mx * x0 + my * y1;
        const m11 = mx * x1 + my * y1;
        if (Math.max(m00, m10, m01, m11) <= mx * lt.x + my * lt.y || Math.min(m00, m10, m01, m11) >= mx * rb.x + my * rb.y) return false;
        return true;
    }
    /**
   * Pads the rectangle making it grow in all directions.
   *
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * // Basic padding
   * const rect = new Rectangle(100, 100, 200, 150);
   * rect.pad(10); // Adds 10px padding on all sides
   *
   * // Different horizontal and vertical padding
   * const uiRect = new Rectangle(0, 0, 100, 50);
   * uiRect.pad(20, 10); // 20px horizontal, 10px vertical
   * ```
   * @remarks
   * - Adjusts x/y by subtracting padding
   * - Increases width/height by padding * 2
   * - Common in UI layout calculations
   * - Chainable with other methods
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   */ pad(paddingX = 0, paddingY = paddingX) {
        this.x -= paddingX;
        this.y -= paddingY;
        this.width += paddingX * 2;
        this.height += paddingY * 2;
        return this;
    }
    /**
   * Fits this rectangle around the passed one.
   * @example
   * ```ts
   * // Basic fitting
   * const container = new Rectangle(0, 0, 100, 100);
   * const content = new Rectangle(25, 25, 200, 200);
   * content.fit(container); // Clips to container bounds
   * ```
   * @param rectangle - The rectangle to fit around
   * @returns Returns itself
   * @see {@link Rectangle.enlarge} For growing to include another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */ fit(rectangle) {
        const x1 = Math.max(this.x, rectangle.x);
        const x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.max(this.y, rectangle.y);
        const y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = Math.max(x2 - x1, 0);
        this.y = y1;
        this.height = Math.max(y2 - y1, 0);
        return this;
    }
    /**
   * Enlarges rectangle so that its corners lie on a grid defined by resolution.
   * @example
   * ```ts
   * // Basic grid alignment
   * const rect = new Rectangle(10.2, 10.6, 100.8, 100.4);
   * rect.ceil(); // Aligns to whole pixels
   *
   * // Custom resolution grid
   * const uiRect = new Rectangle(5.3, 5.7, 50.2, 50.8);
   * uiRect.ceil(0.5); // Aligns to half pixels
   *
   * // Use with precision value
   * const preciseRect = new Rectangle(20.001, 20.999, 100.001, 100.999);
   * preciseRect.ceil(1, 0.01); // Handles small decimal variations
   * ```
   * @param resolution - The grid size to align to (1 = whole pixels)
   * @param eps - Small number to prevent floating point errors
   * @returns Returns itself
   * @see {@link Rectangle.fit} For constraining to bounds
   * @see {@link Rectangle.enlarge} For growing dimensions
   */ ceil(resolution = 1, eps = 1e-3) {
        const x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution;
        const y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;
        this.x = Math.floor((this.x + eps) * resolution) / resolution;
        this.y = Math.floor((this.y + eps) * resolution) / resolution;
        this.width = x2 - this.x;
        this.height = y2 - this.y;
        return this;
    }
    /**
   * Scales the rectangle's dimensions and position by the specified factors.
   * @example
   * ```ts
   * const rect = new Rectangle(50, 50, 100, 100);
   *
   * // Scale uniformly
   * rect.scale(0.5, 0.5);
   * // rect is now: x=25, y=25, width=50, height=50
   *
   * // non-uniformly
   * rect.scale(0.5, 1);
   * // rect is now: x=25, y=50, width=50, height=100
   * ```
   * @param x - The factor by which to scale the horizontal properties (x, width).
   * @param y - The factor by which to scale the vertical properties (y, height).
   * @returns Returns itself
   */ scale(x, y = x) {
        this.x *= x;
        this.y *= y;
        this.width *= x;
        this.height *= y;
        return this;
    }
    /**
   * Enlarges this rectangle to include the passed rectangle.
   * @example
   * ```ts
   * // Basic enlargement
   * const rect = new Rectangle(50, 50, 100, 100);
   * const other = new Rectangle(0, 0, 200, 75);
   * rect.enlarge(other);
   * // rect is now: x=0, y=0, width=200, height=150
   *
   * // Use for bounding box calculation
   * const bounds = new Rectangle();
   * objects.forEach((obj) => {
   *     bounds.enlarge(obj.getBounds());
   * });
   * ```
   * @param rectangle - The rectangle to include
   * @returns Returns itself
   * @see {@link Rectangle.fit} For shrinking to fit within another rectangle
   * @see {@link Rectangle.pad} For adding padding around the rectangle
   */ enlarge(rectangle) {
        const x1 = Math.min(this.x, rectangle.x);
        const x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
        const y1 = Math.min(this.y, rectangle.y);
        const y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
        this.x = x1;
        this.width = x2 - x1;
        this.y = y1;
        this.height = y2 - y1;
        return this;
    }
    /**
   * Returns the framing rectangle of the rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds retrieval
   * const rect = new Rectangle(100, 100, 200, 150);
   * const bounds = rect.getBounds();
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle.copyFrom} For direct copying
   * @see {@link Rectangle.clone} For creating new copy
   */ getBounds(out) {
        out || (out = new $f41957fced550189$export$4617fb02663045ef());
        out.copyFrom(this);
        return out;
    }
    /**
   * Determines whether another Rectangle is fully contained within this Rectangle.
   *
   * Rectangles that occupy the same space are considered to be containing each other.
   *
   * Rectangles without area (width or height equal to zero) can't contain anything,
   * not even other arealess rectangles.
   * @example
   * ```ts
   * // Check if one rectangle contains another
   * const container = new Rectangle(0, 0, 100, 100);
   * const inner = new Rectangle(25, 25, 50, 50);
   *
   * console.log(container.containsRect(inner)); // true
   *
   * // Check overlapping rectangles
   * const partial = new Rectangle(75, 75, 50, 50);
   * console.log(container.containsRect(partial)); // false
   *
   * // Zero-area rectangles
   * const empty = new Rectangle(0, 0, 0, 100);
   * console.log(container.containsRect(empty)); // false
   * ```
   * @param other - The Rectangle to check for containment
   * @returns True if other is fully contained within this Rectangle
   * @see {@link Rectangle.contains} For point containment
   * @see {@link Rectangle.intersects} For overlap testing
   */ containsRect(other) {
        if (this.width <= 0 || this.height <= 0) return false;
        const x1 = other.x;
        const y1 = other.y;
        const x2 = other.x + other.width;
        const y2 = other.y + other.height;
        return x1 >= this.x && x1 < this.x + this.width && y1 >= this.y && y1 < this.y + this.height && x2 >= this.x && x2 < this.x + this.width && y2 >= this.y && y2 < this.y + this.height;
    }
    /**
   * Sets the position and dimensions of the rectangle.
   * @example
   * ```ts
   * // Basic usage
   * const rect = new Rectangle();
   * rect.set(100, 100, 200, 150);
   *
   * // Chain with other operations
   * const bounds = new Rectangle()
   *     .set(0, 0, 100, 100)
   *     .pad(10);
   * ```
   * @param x - The X coordinate of the upper-left corner of the rectangle
   * @param y - The Y coordinate of the upper-left corner of the rectangle
   * @param width - The overall width of the rectangle
   * @param height - The overall height of the rectangle
   * @returns Returns itself for method chaining
   * @see {@link Rectangle.copyFrom} For copying from another rectangle
   * @see {@link Rectangle.clone} For creating a new copy
   */ set(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        return this;
    }
    toString() {
        return `[pixi.js/math:Rectangle x=${this.x} y=${this.y} width=${this.width} height=${this.height}]`;
    }
}

});

parcelRegister("kfwXR", function(module, exports) {

$parcel$export(module.exports, "uid", () => $6349ffae7e122b11$export$e2a22331486dcca0);
"use strict";
const $6349ffae7e122b11$var$uidCache = {
    default: -1
};
function $6349ffae7e122b11$export$e2a22331486dcca0(name = "default") {
    if ($6349ffae7e122b11$var$uidCache[name] === void 0) $6349ffae7e122b11$var$uidCache[name] = -1;
    return ++$6349ffae7e122b11$var$uidCache[name];
}
function $6349ffae7e122b11$export$220409b686c277d0() {
    for(const key in $6349ffae7e122b11$var$uidCache)delete $6349ffae7e122b11$var$uidCache[key];
}

});

parcelRegister("dXBy0", function(module, exports) {

$parcel$export(module.exports, "v8_0_0", () => $b38be7c1dac7792f$export$dc79da96439604f0);
$parcel$export(module.exports, "v8_3_4", () => $b38be7c1dac7792f$export$e88af00f5d3e8bcc);
$parcel$export(module.exports, "deprecation", () => $b38be7c1dac7792f$export$afd31d834b512e89);
"use strict";
const $b38be7c1dac7792f$var$warnings = /* @__PURE__ */ new Set();
const $b38be7c1dac7792f$export$dc79da96439604f0 = "8.0.0";
const $b38be7c1dac7792f$export$e88af00f5d3e8bcc = "8.3.4";
const $b38be7c1dac7792f$var$deprecationState = {
    quiet: false,
    noColor: false
};
const $b38be7c1dac7792f$export$afd31d834b512e89 = (version, message, ignoreDepth = 3)=>{
    if ($b38be7c1dac7792f$var$deprecationState.quiet || $b38be7c1dac7792f$var$warnings.has(message)) return;
    let stack = new Error().stack;
    const deprecationMessage = `${message}
Deprecated since v${version}`;
    const useGroup = typeof console.groupCollapsed === "function" && !$b38be7c1dac7792f$var$deprecationState.noColor;
    if (typeof stack === "undefined") console.warn("PixiJS Deprecation Warning: ", deprecationMessage);
    else {
        stack = stack.split("\n").splice(ignoreDepth).join("\n");
        if (useGroup) {
            console.groupCollapsed("%cPixiJS Deprecation Warning: %c%s", "color:#614108;background:#fffbe6", "font-weight:normal;color:#614108;background:#fffbe6", deprecationMessage);
            console.warn(stack);
            console.groupEnd();
        } else {
            console.warn("PixiJS Deprecation Warning: ", deprecationMessage);
            console.warn(stack);
        }
    }
    $b38be7c1dac7792f$var$warnings.add(message);
};
Object.defineProperties($b38be7c1dac7792f$export$afd31d834b512e89, {
    quiet: {
        get: ()=>$b38be7c1dac7792f$var$deprecationState.quiet,
        set: (value)=>{
            $b38be7c1dac7792f$var$deprecationState.quiet = value;
        },
        enumerable: true,
        configurable: false
    },
    noColor: {
        get: ()=>$b38be7c1dac7792f$var$deprecationState.noColor,
        set: (value)=>{
            $b38be7c1dac7792f$var$deprecationState.noColor = value;
        },
        enumerable: true,
        configurable: false
    }
});

});

parcelRegister("lRaOh", function(module, exports) {

$parcel$export(module.exports, "NOOP", () => $c3c6c1911f502120$export$5702a91a6f42969f);
"use strict";
const $c3c6c1911f502120$export$5702a91a6f42969f = ()=>{};

});

parcelRegister("fquaa", function(module, exports) {

$parcel$export(module.exports, "BufferImageSource", () => $06adbe44dcd0b297$export$1872462350fcb7cd);

var $aBhlC = parcelRequire("aBhlC");

var $gl1XZ = parcelRequire("gl1XZ");
"use strict";
class $06adbe44dcd0b297$export$1872462350fcb7cd extends (0, $gl1XZ.TextureSource) {
    constructor(options){
        const buffer = options.resource || new Float32Array(options.width * options.height * 4);
        let format = options.format;
        if (!format) {
            if (buffer instanceof Float32Array) format = "rgba32float";
            else if (buffer instanceof Int32Array) format = "rgba32uint";
            else if (buffer instanceof Uint32Array) format = "rgba32uint";
            else if (buffer instanceof Int16Array) format = "rgba16uint";
            else if (buffer instanceof Uint16Array) format = "rgba16uint";
            else if (buffer instanceof Int8Array) format = "bgra8unorm";
            else format = "bgra8unorm";
        }
        super({
            ...options,
            resource: buffer,
            format: format
        });
        this.uploadMethodId = "buffer";
    }
    static test(resource) {
        return resource instanceof Int8Array || resource instanceof Uint8Array || resource instanceof Uint8ClampedArray || resource instanceof Int16Array || resource instanceof Uint16Array || resource instanceof Int32Array || resource instanceof Uint32Array || resource instanceof Float32Array;
    }
}
$06adbe44dcd0b297$export$1872462350fcb7cd.extension = (0, $aBhlC.ExtensionType).TextureSource;

});
parcelRegister("gl1XZ", function(module, exports) {

$parcel$export(module.exports, "TextureSource", () => $0e9ba54f63ff83d5$export$8498e6a2e655d3d8);

var $6AQ4q = parcelRequire("6AQ4q");

var $2CXjJ = parcelRequire("2CXjJ");

var $bjnCb = parcelRequire("bjnCb");

var $kfwXR = parcelRequire("kfwXR");

var $ju4z4 = parcelRequire("ju4z4");
"use strict";
const $0e9ba54f63ff83d5$var$_TextureSource = class _TextureSource extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    /**
   * @param options - options for creating a new TextureSource
   */ constructor(options = {}){
        super();
        this.options = options;
        /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        /** @internal */ this._gcLastUsed = -1;
        /** unique id for this Texture source */ this.uid = (0, $kfwXR.uid)("textureSource");
        /**
     * The resource type used by this TextureSource. This is used by the bind groups to determine
     * how to handle this resource.
     * @internal
     */ this._resourceType = "textureSource";
        /**
     * i unique resource id, used by the bind group systems.
     * This can change if the texture is resized or its resource changes
     * @internal
     */ this._resourceId = (0, $kfwXR.uid)("resource");
        /**
     * this is how the backends know how to upload this texture to the GPU
     * It changes depending on the resource type. Classes that extend TextureSource
     * should override this property.
     * @internal
     */ this.uploadMethodId = "unknown";
        /** @internal */ this._resolution = 1;
        /** the pixel width of this texture source. This is the REAL pure number, not accounting resolution */ this.pixelWidth = 1;
        /** the pixel height of this texture source. This is the REAL pure number, not accounting resolution */ this.pixelHeight = 1;
        /**
     * the width of this texture source, accounting for resolution
     * eg pixelWidth 200, resolution 2, then width will be 100
     */ this.width = 1;
        /**
     * the height of this texture source, accounting for resolution
     * eg pixelHeight 200, resolution 2, then height will be 100
     */ this.height = 1;
        /**
     * The number of samples of a multisample texture. This is always 1 for non-multisample textures.
     * To enable multisample for a texture, set antialias to true
     * @internal
     */ this.sampleCount = 1;
        /**
     * The number of mip levels to generate for this texture.
     * this is overridden if autoGenerateMipmaps is true. it is read only!
     */ this.mipLevelCount = 1;
        /**
     * Should we auto generate mipmaps for this texture? This will automatically generate mipmaps
     * for this texture when uploading to the GPU. Mipmapped textures take up more memory, but
     * can look better when scaled down.
     *
     * For performance reasons, it is recommended to NOT use this with RenderTextures, as they are often updated every frame.
     * If you do, make sure to call `updateMipmaps` after you update the texture.
     */ this.autoGenerateMipmaps = false;
        /** the format that the texture data has */ this.format = "rgba8unorm";
        /** how many dimensions does this texture have? currently v8 only supports 2d */ this.dimension = "2d";
        /** how this texture is viewed/sampled by shaders (WebGPU view dimension) */ this.viewDimension = "2d";
        /** how many array layers this texture has (WebGPU depthOrArrayLayers) */ this.arrayLayerCount = 1;
        /**
     * Only really affects RenderTextures.
     * Should we use antialiasing for this texture. It will look better, but may impact performance as a
     * Blit operation will be required to resolve the texture.
     */ this.antialias = false;
        /**
     * Used by automatic texture Garbage Collection, stores last GC tick when it was bound
     * @protected
     */ this._touched = 0;
        /**
     * Used by the batcher to build texture batches. faster to have the variable here!
     * @protected
     */ this._batchTick = -1;
        /**
     * A temporary batch location for the texture batching. Here for performance reasons only!
     * @protected
     */ this._textureBindLocation = -1;
        options = {
            ..._TextureSource.defaultOptions,
            ...options
        };
        this.label = options.label ?? "";
        this.resource = options.resource;
        this.autoGarbageCollect = options.autoGarbageCollect;
        this._resolution = options.resolution;
        if (options.width) this.pixelWidth = options.width * this._resolution;
        else this.pixelWidth = this.resource ? this.resourceWidth ?? 1 : 1;
        if (options.height) this.pixelHeight = options.height * this._resolution;
        else this.pixelHeight = this.resource ? this.resourceHeight ?? 1 : 1;
        this.width = this.pixelWidth / this._resolution;
        this.height = this.pixelHeight / this._resolution;
        this.format = options.format;
        this.dimension = options.dimensions;
        this.viewDimension = options.viewDimension ?? options.dimensions;
        this.arrayLayerCount = options.arrayLayerCount;
        this.mipLevelCount = options.mipLevelCount;
        this.autoGenerateMipmaps = options.autoGenerateMipmaps;
        this.sampleCount = options.sampleCount;
        this.antialias = options.antialias;
        this.alphaMode = options.alphaMode;
        this.style = new (0, $ju4z4.TextureStyle)((0, $bjnCb.definedProps)(options));
        this.destroyed = false;
        this._refreshPOT();
    }
    /** returns itself */ get source() {
        return this;
    }
    /** the style of the texture */ get style() {
        return this._style;
    }
    set style(value) {
        if (this.style === value) return;
        this._style?.off("change", this._onStyleChange, this);
        this._style = value;
        this._style?.on("change", this._onStyleChange, this);
        this._onStyleChange();
    }
    /** Specifies the maximum anisotropy value clamp used by the sampler. */ set maxAnisotropy(value) {
        this._style.maxAnisotropy = value;
    }
    get maxAnisotropy() {
        return this._style.maxAnisotropy;
    }
    /** setting this will set wrapModeU, wrapModeV and wrapModeW all at once! */ get addressMode() {
        return this._style.addressMode;
    }
    set addressMode(value) {
        this._style.addressMode = value;
    }
    /** setting this will set wrapModeU, wrapModeV and wrapModeW all at once! */ get repeatMode() {
        return this._style.addressMode;
    }
    set repeatMode(value) {
        this._style.addressMode = value;
    }
    /** Specifies the sampling behavior when the sample footprint is smaller than or equal to one texel. */ get magFilter() {
        return this._style.magFilter;
    }
    set magFilter(value) {
        this._style.magFilter = value;
    }
    /** Specifies the sampling behavior when the sample footprint is larger than one texel. */ get minFilter() {
        return this._style.minFilter;
    }
    set minFilter(value) {
        this._style.minFilter = value;
    }
    /** Specifies behavior for sampling between mipmap levels. */ get mipmapFilter() {
        return this._style.mipmapFilter;
    }
    set mipmapFilter(value) {
        this._style.mipmapFilter = value;
    }
    /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */ get lodMinClamp() {
        return this._style.lodMinClamp;
    }
    set lodMinClamp(value) {
        this._style.lodMinClamp = value;
    }
    /** Specifies the minimum and maximum levels of detail, respectively, used internally when sampling a texture. */ get lodMaxClamp() {
        return this._style.lodMaxClamp;
    }
    set lodMaxClamp(value) {
        this._style.lodMaxClamp = value;
    }
    _onStyleChange() {
        this.emit("styleChange", this);
    }
    /** call this if you have modified the texture outside of the constructor */ update() {
        if (this.resource) {
            const resolution = this._resolution;
            const didResize = this.resize(this.resourceWidth / resolution, this.resourceHeight / resolution);
            if (didResize) return;
        }
        this.emit("update", this);
    }
    /** Destroys this texture source */ destroy() {
        this.destroyed = true;
        this.unload();
        this.emit("destroy", this);
        if (this._style) {
            this._style.destroy();
            this._style = null;
        }
        this.uploadMethodId = null;
        this.resource = null;
        this.removeAllListeners();
    }
    /**
   * This will unload the Texture source from the GPU. This will free up the GPU memory
   * As soon as it is required fore rendering, it will be re-uploaded.
   */ unload() {
        this._resourceId = (0, $kfwXR.uid)("resource");
        this.emit("change", this);
        this.emit("unload", this);
        for(const key in this._gpuData)this._gpuData[key]?.destroy?.();
        this._gpuData = /* @__PURE__ */ Object.create(null);
    }
    /** the width of the resource. This is the REAL pure number, not accounting resolution   */ get resourceWidth() {
        const { resource: resource } = this;
        return resource.naturalWidth || resource.videoWidth || resource.displayWidth || resource.width;
    }
    /** the height of the resource. This is the REAL pure number, not accounting resolution */ get resourceHeight() {
        const { resource: resource } = this;
        return resource.naturalHeight || resource.videoHeight || resource.displayHeight || resource.height;
    }
    /**
   * the resolution of the texture. Changing this number, will not change the number of pixels in the actual texture
   * but will the size of the texture when rendered.
   *
   * changing the resolution of this texture to 2 for example will make it appear twice as small when rendered (as pixel
   * density will have increased)
   */ get resolution() {
        return this._resolution;
    }
    set resolution(resolution) {
        if (this._resolution === resolution) return;
        this._resolution = resolution;
        this.width = this.pixelWidth / resolution;
        this.height = this.pixelHeight / resolution;
    }
    /**
   * Resize the texture, this is handy if you want to use the texture as a render texture
   * @param width - the new width of the texture
   * @param height - the new height of the texture
   * @param resolution - the new resolution of the texture
   * @returns - if the texture was resized
   */ resize(width, height, resolution) {
        resolution || (resolution = this._resolution);
        width || (width = this.width);
        height || (height = this.height);
        const newPixelWidth = Math.round(width * resolution);
        const newPixelHeight = Math.round(height * resolution);
        this.width = newPixelWidth / resolution;
        this.height = newPixelHeight / resolution;
        this._resolution = resolution;
        if (this.pixelWidth === newPixelWidth && this.pixelHeight === newPixelHeight) return false;
        this._refreshPOT();
        this.pixelWidth = newPixelWidth;
        this.pixelHeight = newPixelHeight;
        this.emit("resize", this);
        this._resourceId = (0, $kfwXR.uid)("resource");
        this.emit("change", this);
        return true;
    }
    /**
   * Lets the renderer know that this texture has been updated and its mipmaps should be re-generated.
   * This is only important for RenderTexture instances, as standard Texture instances will have their
   * mipmaps generated on upload. You should call this method after you make any change to the texture
   *
   * The reason for this is is can be quite expensive to update mipmaps for a texture. So by default,
   * We want you, the developer to specify when this action should happen.
   *
   * Generally you don't want to have mipmaps generated on Render targets that are changed every frame,
   */ updateMipmaps() {
        if (this.autoGenerateMipmaps && this.mipLevelCount > 1) this.emit("updateMipmaps", this);
    }
    set wrapMode(value) {
        this._style.wrapMode = value;
    }
    get wrapMode() {
        return this._style.wrapMode;
    }
    set scaleMode(value) {
        this._style.scaleMode = value;
    }
    /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */ get scaleMode() {
        return this._style.scaleMode;
    }
    /**
   * Refresh check for isPowerOfTwo texture based on size
   * @private
   */ _refreshPOT() {
        this.isPowerOfTwo = (0, $2CXjJ.isPow2)(this.pixelWidth) && (0, $2CXjJ.isPow2)(this.pixelHeight);
    }
    static test(_resource) {
        throw new Error("Unimplemented");
    }
};
/** The default options used when creating a new TextureSource. override these to add your own defaults */ $0e9ba54f63ff83d5$var$_TextureSource.defaultOptions = {
    resolution: 1,
    format: "bgra8unorm",
    alphaMode: "premultiply-alpha-on-upload",
    dimensions: "2d",
    viewDimension: "2d",
    arrayLayerCount: 1,
    mipLevelCount: 1,
    autoGenerateMipmaps: false,
    sampleCount: 1,
    antialias: false,
    autoGarbageCollect: false
};
let $0e9ba54f63ff83d5$export$8498e6a2e655d3d8 = $0e9ba54f63ff83d5$var$_TextureSource;

});
parcelRegister("2CXjJ", function(module, exports) {

$parcel$export(module.exports, "nextPow2", () => $d08271704c2ab9db$export$f0d90cf68bd426eb);
$parcel$export(module.exports, "isPow2", () => $d08271704c2ab9db$export$eb50b9c078eb6ae7);
"use strict";
function $d08271704c2ab9db$export$f0d90cf68bd426eb(v) {
    v += v === 0 ? 1 : 0;
    --v;
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v + 1;
}
function $d08271704c2ab9db$export$eb50b9c078eb6ae7(v) {
    return !(v & v - 1) && !!v;
}
function $d08271704c2ab9db$export$b9fae0bba9d9094d(v) {
    let r = (v > 65535 ? 1 : 0) << 4;
    v >>>= r;
    let shift = (v > 255 ? 1 : 0) << 3;
    v >>>= shift;
    r |= shift;
    shift = (v > 15 ? 1 : 0) << 2;
    v >>>= shift;
    r |= shift;
    shift = (v > 3 ? 1 : 0) << 1;
    v >>>= shift;
    r |= shift;
    return r | v >> 1;
}

});

parcelRegister("bjnCb", function(module, exports) {

$parcel$export(module.exports, "definedProps", () => $1908d924b5db9ee3$export$801feaffb936a09d);
"use strict";
function $1908d924b5db9ee3$export$801feaffb936a09d(obj) {
    const result = {};
    for(const key in obj)if (obj[key] !== void 0) result[key] = obj[key];
    return result;
}

});

parcelRegister("ju4z4", function(module, exports) {

$parcel$export(module.exports, "TextureStyle", () => $98268aea3d7abe37$export$1ce1d0c10d3de5d5);

var $6AQ4q = parcelRequire("6AQ4q");

var $kfwXR = parcelRequire("kfwXR");

var $dXBy0 = parcelRequire("dXBy0");
"use strict";
const $98268aea3d7abe37$var$idHash = /* @__PURE__ */ Object.create(null);
function $98268aea3d7abe37$var$createResourceIdFromString(value) {
    const id = $98268aea3d7abe37$var$idHash[value];
    if (id === void 0) $98268aea3d7abe37$var$idHash[value] = (0, $kfwXR.uid)("resource");
    return id;
}
const $98268aea3d7abe37$var$_TextureStyle = class _TextureStyle extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    /**
   * @param options - options for the style
   */ constructor(options = {}){
        super();
        /** @internal */ this._resourceType = "textureSampler";
        /** @internal */ this._touched = 0;
        /**
     * Specifies the maximum anisotropy value clamp used by the sampler.
     * Note: Most implementations support {@link TextureStyle#maxAnisotropy} values in range
     * between 1 and 16, inclusive. The used value of {@link TextureStyle#maxAnisotropy} will
     * be clamped to the maximum value that the platform supports.
     * @internal
     */ this._maxAnisotropy = 1;
        /**
     * Has the style been destroyed?
     * @readonly
     */ this.destroyed = false;
        options = {
            ..._TextureStyle.defaultOptions,
            ...options
        };
        this.addressMode = options.addressMode;
        this.addressModeU = options.addressModeU ?? this.addressModeU;
        this.addressModeV = options.addressModeV ?? this.addressModeV;
        this.addressModeW = options.addressModeW ?? this.addressModeW;
        this.scaleMode = options.scaleMode;
        this.magFilter = options.magFilter ?? this.magFilter;
        this.minFilter = options.minFilter ?? this.minFilter;
        this.mipmapFilter = options.mipmapFilter ?? this.mipmapFilter;
        this.lodMinClamp = options.lodMinClamp;
        this.lodMaxClamp = options.lodMaxClamp;
        this.compare = options.compare;
        this.maxAnisotropy = options.maxAnisotropy ?? 1;
    }
    set addressMode(value) {
        this.addressModeU = value;
        this.addressModeV = value;
        this.addressModeW = value;
    }
    /** setting this will set wrapModeU,wrapModeV and wrapModeW all at once! */ get addressMode() {
        return this.addressModeU;
    }
    set wrapMode(value) {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "TextureStyle.wrapMode is now TextureStyle.addressMode");
        this.addressMode = value;
    }
    get wrapMode() {
        return this.addressMode;
    }
    set scaleMode(value) {
        this.magFilter = value;
        this.minFilter = value;
        this.mipmapFilter = value;
    }
    /** setting this will set magFilter,minFilter and mipmapFilter all at once!  */ get scaleMode() {
        return this.magFilter;
    }
    /** Specifies the maximum anisotropy value clamp used by the sampler. */ set maxAnisotropy(value) {
        this._maxAnisotropy = Math.min(value, 16);
        if (this._maxAnisotropy > 1) this.scaleMode = "linear";
    }
    get maxAnisotropy() {
        return this._maxAnisotropy;
    }
    // TODO - move this to WebGL?
    get _resourceId() {
        return this._sharedResourceId || this._generateResourceId();
    }
    update() {
        this._sharedResourceId = null;
        this.emit("change", this);
    }
    _generateResourceId() {
        const bigKey = `${this.addressModeU}-${this.addressModeV}-${this.addressModeW}-${this.magFilter}-${this.minFilter}-${this.mipmapFilter}-${this.lodMinClamp}-${this.lodMaxClamp}-${this.compare}-${this._maxAnisotropy}`;
        this._sharedResourceId = $98268aea3d7abe37$var$createResourceIdFromString(bigKey);
        return this._resourceId;
    }
    /** Destroys the style */ destroy() {
        this.destroyed = true;
        this.emit("destroy", this);
        this.emit("change", this);
        this.removeAllListeners();
    }
};
/** default options for the style */ $98268aea3d7abe37$var$_TextureStyle.defaultOptions = {
    addressMode: "clamp-to-edge",
    scaleMode: "linear"
};
let $98268aea3d7abe37$export$1ce1d0c10d3de5d5 = $98268aea3d7abe37$var$_TextureStyle;

});



parcelRegister("67pbJ", function(module, exports) {

$parcel$export(module.exports, "TextureMatrix", () => $fe1bed56ea50f71f$export$dbea3135e9da48cb);

var $deLbn = parcelRequire("deLbn");
"use strict";
const $fe1bed56ea50f71f$var$tempMat = new (0, $deLbn.Matrix)();
class $fe1bed56ea50f71f$export$dbea3135e9da48cb {
    /**
   * @param texture - observed texture
   * @param clampMargin - Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
   */ constructor(texture, clampMargin){
        this.mapCoord = new (0, $deLbn.Matrix)();
        this.uClampFrame = new Float32Array(4);
        this.uClampOffset = new Float32Array(2);
        this._updateID = 0;
        this.clampOffset = 0;
        if (typeof clampMargin === "undefined") this.clampMargin = texture.width < 10 ? 0 : 0.5;
        else this.clampMargin = clampMargin;
        this.isSimple = false;
        this.texture = texture;
    }
    /** Texture property. */ get texture() {
        return this._texture;
    }
    set texture(value) {
        if (this._texture !== value) {
            this._texture?.removeListener("update", this.update, this);
            this._texture = value;
            this._texture.addListener("update", this.update, this);
        }
        this.update();
    }
    /**
   * Multiplies uvs array to transform
   * @param uvs - mesh uvs
   * @param [out=uvs] - output
   * @returns - output
   */ multiplyUvs(uvs, out) {
        if (out === void 0) out = uvs;
        const mat = this.mapCoord;
        for(let i = 0; i < uvs.length; i += 2){
            const x = uvs[i];
            const y = uvs[i + 1];
            out[i] = x * mat.a + y * mat.c + mat.tx;
            out[i + 1] = x * mat.b + y * mat.d + mat.ty;
        }
        return out;
    }
    /**
   * Updates matrices if texture was changed
   * @returns - whether or not it was updated
   */ update() {
        const tex = this._texture;
        this._updateID++;
        const uvs = tex.uvs;
        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
        const orig = tex.orig;
        const trim = tex.trim;
        if (trim) {
            $fe1bed56ea50f71f$var$tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
            this.mapCoord.append($fe1bed56ea50f71f$var$tempMat);
        }
        const texBase = tex.source;
        const frame = this.uClampFrame;
        const margin = this.clampMargin / texBase._resolution;
        const offset = this.clampOffset / texBase._resolution;
        frame[0] = (tex.frame.x + margin + offset) / texBase.width;
        frame[1] = (tex.frame.y + margin + offset) / texBase.height;
        frame[2] = (tex.frame.x + tex.frame.width - margin + offset) / texBase.width;
        frame[3] = (tex.frame.y + tex.frame.height - margin + offset) / texBase.height;
        this.uClampOffset[0] = this.clampOffset / texBase.pixelWidth;
        this.uClampOffset[1] = this.clampOffset / texBase.pixelHeight;
        this.isSimple = tex.frame.width === texBase.width && tex.frame.height === texBase.height && tex.rotate === 0;
        return true;
    }
}

});


parcelRegister("cfUjt", function(module, exports) {

$parcel$export(module.exports, "updateQuadBounds", () => $55acef76f4a9df7d$export$558ce66aa5723f1d);
"use strict";
function $55acef76f4a9df7d$export$558ce66aa5723f1d(bounds, anchor, texture) {
    const { width: width, height: height } = texture.orig;
    const trim = texture.trim;
    if (trim) {
        const sourceWidth = trim.width;
        const sourceHeight = trim.height;
        bounds.minX = trim.x - anchor._x * width;
        bounds.maxX = bounds.minX + sourceWidth;
        bounds.minY = trim.y - anchor._y * height;
        bounds.maxY = bounds.minY + sourceHeight;
    } else {
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
}

});

parcelRegister("aHyJR", function(module, exports) {

$parcel$export(module.exports, "ViewContainer", () => $a20e82eeb9884b2e$export$19fb617b96998849);

var $eWGg9 = parcelRequire("eWGg9");

var $5Wp7K = parcelRequire("5Wp7K");
"use strict";
class $a20e82eeb9884b2e$export$19fb617b96998849 extends (0, $5Wp7K.Container) {
    constructor(options){
        super(options);
        /** @internal */ this.canBundle = true;
        /** @internal */ this.allowChildren = false;
        /** @internal */ this._roundPixels = 0;
        /** @internal */ this._lastUsed = -1;
        /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        /** If set to true, the resource will be garbage collected automatically when it is not used. */ this.autoGarbageCollect = true;
        /** @internal */ this._gcLastUsed = -1;
        this._bounds = new (0, $eWGg9.Bounds)(0, 1, 0, 0);
        this._boundsDirty = true;
        this.autoGarbageCollect = options.autoGarbageCollect ?? true;
    }
    /**
   * The local bounds of the view in its own coordinate space.
   * Bounds are automatically updated when the view's content changes.
   * @example
   * ```ts
   * // Get bounds dimensions
   * const bounds = view.bounds;
   * console.log(`Width: ${bounds.maxX - bounds.minX}`);
   * console.log(`Height: ${bounds.maxY - bounds.minY}`);
   * ```
   * @returns The rectangular bounds of the view
   * @see {@link Bounds} For bounds operations
   */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        this.updateBounds();
        this._boundsDirty = false;
        return this._bounds;
    }
    /**
   * Whether or not to round the x/y position of the sprite.
   * @example
   * ```ts
   * // Enable pixel rounding for crisp rendering
   * view.roundPixels = true;
   * ```
   * @default false
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    set roundPixels(value) {
        this._roundPixels = value ? 1 : 0;
    }
    /**
   * Checks if the object contains the given point in local coordinates.
   * Uses the view's bounds for hit testing.
   * @example
   * ```ts
   * // Basic point check
   * const localPoint = { x: 50, y: 25 };
   * const contains = view.containsPoint(localPoint);
   * console.log('Point is inside:', contains);
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the view's bounds
   * @see {@link ViewContainer#bounds} For the bounds used in hit testing
   * @see {@link Container#toLocal} For converting global coordinates to local
   */ containsPoint(point) {
        const bounds = this.bounds;
        const { x: x, y: y } = point;
        return x >= bounds.minX && x <= bounds.maxX && y >= bounds.minY && y <= bounds.maxY;
    }
    /** @private */ onViewUpdate() {
        this._didViewChangeTick++;
        this._boundsDirty = true;
        if (this.didViewUpdate) return;
        this.didViewUpdate = true;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.onChildViewUpdate(this);
    }
    /** Unloads the GPU data from the view. */ unload() {
        this.emit("unload", this);
        for(const key in this._gpuData)this._gpuData[key]?.destroy();
        this._gpuData = /* @__PURE__ */ Object.create(null);
        this.onViewUpdate();
    }
    destroy(options) {
        this.unload();
        super.destroy(options);
        this._bounds = null;
    }
    /**
   * Collects renderables for the view container.
   * @param instructionSet - The instruction set to collect renderables for.
   * @param renderer - The renderer to collect renderables for.
   * @param currentLayer - The current render layer.
   * @internal
   */ collectRenderablesSimple(instructionSet, renderer, currentLayer) {
        const { renderPipes: renderPipes } = renderer;
        renderPipes.blendMode.pushBlendMode(this, this.groupBlendMode, instructionSet);
        const rp = renderPipes;
        const pipe = rp[this.renderPipeId];
        if (pipe?.addRenderable) pipe.addRenderable(this, instructionSet);
        this.didViewUpdate = false;
        const children = this.children;
        const length = children.length;
        for(let i = 0; i < length; i++)children[i].collectRenderables(instructionSet, renderer, currentLayer);
        renderPipes.blendMode.popBlendMode(instructionSet);
    }
}

});
parcelRegister("eWGg9", function(module, exports) {

$parcel$export(module.exports, "Bounds", () => $9e4672727a6a5b0b$export$c4e9d269599ab4b4);

var $deLbn = parcelRequire("deLbn");

var $kNl9L = parcelRequire("kNl9L");
"use strict";
const $9e4672727a6a5b0b$var$defaultMatrix = new (0, $deLbn.Matrix)();
class $9e4672727a6a5b0b$export$c4e9d269599ab4b4 {
    /**
   * Creates a new Bounds object.
   * @param minX - The minimum X coordinate of the bounds.
   * @param minY - The minimum Y coordinate of the bounds.
   * @param maxX - The maximum X coordinate of the bounds.
   * @param maxY - The maximum Y coordinate of the bounds.
   */ constructor(minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity){
        /**
     * The minimum X coordinate of the bounds.
     * Represents the leftmost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set left edge
     * bounds.minX = 100;
     * ```
     * @default Infinity
     */ this.minX = Infinity;
        /**
     * The minimum Y coordinate of the bounds.
     * Represents the topmost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set top edge
     * bounds.minY = 100;
     * ```
     * @default Infinity
     */ this.minY = Infinity;
        /**
     * The maximum X coordinate of the bounds.
     * Represents the rightmost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set right edge
     * bounds.maxX = 200;
     * // Get width
     * const width = bounds.maxX - bounds.minX;
     * ```
     * @default -Infinity
     */ this.maxX = -Infinity;
        /**
     * The maximum Y coordinate of the bounds.
     * Represents the bottommost edge of the bounding box.
     * @example
     * ```ts
     * const bounds = new Bounds();
     * // Set bottom edge
     * bounds.maxY = 200;
     * // Get height
     * const height = bounds.maxY - bounds.minY;
     * ```
     * @default -Infinity
     */ this.maxY = -Infinity;
        /**
     * The transformation matrix applied to this bounds object.
     * Used when calculating bounds with transforms.
     * @example
     * ```ts
     * const bounds = new Bounds();
     *
     * // Apply translation matrix
     * bounds.matrix = new Matrix()
     *     .translate(100, 100);
     *
     * // Combine transformations
     * bounds.matrix = new Matrix()
     *     .translate(50, 50)
     *     .rotate(Math.PI / 4)
     *     .scale(2, 2);
     *
     * // Use in bounds calculations
     * bounds.addFrame(0, 0, 100, 100); // Uses current matrix
     * bounds.addFrame(0, 0, 100, 100, customMatrix); // Override matrix
     * ```
     * @advanced
     */ this.matrix = $9e4672727a6a5b0b$var$defaultMatrix;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Checks if bounds are empty, meaning either width or height is zero or negative.
   * Empty bounds occur when min values exceed max values on either axis.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Check if newly created bounds are empty
   * console.log(bounds.isEmpty()); // true, default bounds are empty
   *
   * // Add frame and check again
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false, bounds now have area
   *
   * // Clear bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true, bounds are empty again
   * ```
   * @returns True if bounds are empty (have no area)
   * @see {@link Bounds#clear} For resetting bounds
   * @see {@link Bounds#isValid} For checking validity
   */ isEmpty() {
        return this.minX > this.maxX || this.minY > this.maxY;
    }
    /**
   * The bounding rectangle representation of these bounds.
   * Lazily creates and updates a Rectangle instance based on the current bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Get rectangle representation
   * const rect = bounds.rectangle;
   * console.log(rect.x, rect.y, rect.width, rect.height);
   *
   * // Use for hit testing
   * if (bounds.rectangle.contains(mouseX, mouseY)) {
   *     console.log('Mouse is inside bounds!');
   * }
   * ```
   * @see {@link Rectangle} For rectangle methods
   * @see {@link Bounds.isEmpty} For bounds validation
   */ get rectangle() {
        if (!this._rectangle) this._rectangle = new (0, $kNl9L.Rectangle)();
        const rectangle = this._rectangle;
        if (this.minX > this.maxX || this.minY > this.maxY) {
            rectangle.x = 0;
            rectangle.y = 0;
            rectangle.width = 0;
            rectangle.height = 0;
        } else rectangle.copyFromBounds(this);
        return rectangle;
    }
    /**
   * Clears the bounds and resets all coordinates to their default values.
   * Resets the transformation matrix back to identity.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.isEmpty()); // false
   * // Clear the bounds
   * bounds.clear();
   * console.log(bounds.isEmpty()); // true
   * ```
   * @returns This bounds object for chaining
   */ clear() {
        this.minX = Infinity;
        this.minY = Infinity;
        this.maxX = -Infinity;
        this.maxY = -Infinity;
        this.matrix = $9e4672727a6a5b0b$var$defaultMatrix;
        return this;
    }
    /**
   * Sets the bounds directly using coordinate values.
   * Provides a way to set all bounds values at once.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(0, 0, 100, 100);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @see {@link Bounds#addFrame} For matrix-aware bounds setting
   * @see {@link Bounds#clear} For resetting bounds
   */ set(x0, y0, x1, y1) {
        this.minX = x0;
        this.minY = y0;
        this.maxX = x1;
        this.maxY = y1;
    }
    /**
   * Adds a rectangular frame to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the new frame coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.addFrame(0, 0, 100, 100);
   *
   * // Add transformed frame
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addFrame(0, 0, 100, 100, matrix);
   * ```
   * @param x0 - Left X coordinate of frame
   * @param y0 - Top Y coordinate of frame
   * @param x1 - Right X coordinate of frame
   * @param y1 - Bottom Y coordinate of frame
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addRect} For adding Rectangle objects
   * @see {@link Bounds#addBounds} For adding other Bounds
   */ addFrame(x0, y0, x1, y1, matrix) {
        matrix || (matrix = this.matrix);
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        let x = a * x0 + c * y0 + tx;
        let y = b * x0 + d * y0 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x1 + c * y0 + tx;
        y = b * x1 + d * y0 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x0 + c * y1 + tx;
        y = b * x0 + d * y1 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        x = a * x1 + c * y1 + tx;
        y = b * x1 + d * y1 + ty;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Adds a rectangle to the bounds, optionally transformed by a matrix.
   * Updates the bounds to encompass the given rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * // Add simple rectangle
   * const rect = new Rectangle(0, 0, 100, 100);
   * bounds.addRect(rect);
   *
   * // Add transformed rectangle
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addRect(rect, matrix);
   * ```
   * @param rect - The rectangle to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addBounds} For adding other bounds
   */ addRect(rect, matrix) {
        this.addFrame(rect.x, rect.y, rect.x + rect.width, rect.y + rect.height, matrix);
    }
    /**
   * Adds another bounds object to this one, optionally transformed by a matrix.
   * Expands the bounds to include the given bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add child bounds
   * const childBounds = sprite.getBounds();
   * bounds.addBounds(childBounds);
   *
   * // Add transformed bounds
   * const matrix = new Matrix()
   *     .scale(2, 2);
   * bounds.addBounds(childBounds, matrix);
   * ```
   * @param bounds - The bounds to be added
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding raw coordinates
   * @see {@link Bounds#addRect} For adding rectangles
   */ addBounds(bounds, matrix) {
        this.addFrame(bounds.minX, bounds.minY, bounds.maxX, bounds.maxY, matrix);
    }
    /**
   * Adds other Bounds as a mask, creating an intersection of the two bounds.
   * Only keeps the overlapping region between current bounds and mask bounds.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Create mask bounds
   * const mask = new Bounds();
   * mask.addFrame(50, 50, 150, 150);
   * // Apply mask - results in bounds of (50,50,100,100)
   * bounds.addBoundsMask(mask);
   * ```
   * @param mask - The Bounds to use as a mask
   * @see {@link Bounds#addBounds} For union operation
   * @see {@link Bounds#fit} For fitting to rectangle
   */ addBoundsMask(mask) {
        this.minX = this.minX > mask.minX ? this.minX : mask.minX;
        this.minY = this.minY > mask.minY ? this.minY : mask.minY;
        this.maxX = this.maxX < mask.maxX ? this.maxX : mask.maxX;
        this.maxY = this.maxY < mask.maxY ? this.maxY : mask.maxY;
    }
    /**
   * Applies a transformation matrix to the bounds, updating its coordinates.
   * Transforms all corners of the bounds using the given matrix.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Apply translation
   * const translateMatrix = new Matrix()
   *     .translate(50, 50);
   * bounds.applyMatrix(translateMatrix);
   * ```
   * @param matrix - The matrix to apply to the bounds
   * @see {@link Matrix} For matrix operations
   * @see {@link Bounds#addFrame} For adding transformed frames
   */ applyMatrix(matrix) {
        const minX = this.minX;
        const minY = this.minY;
        const maxX = this.maxX;
        const maxY = this.maxY;
        const { a: a, b: b, c: c, d: d, tx: tx, ty: ty } = matrix;
        let x = a * minX + c * minY + tx;
        let y = b * minX + d * minY + ty;
        this.minX = x;
        this.minY = y;
        this.maxX = x;
        this.maxY = y;
        x = a * maxX + c * minY + tx;
        y = b * maxX + d * minY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
        x = a * minX + c * maxY + tx;
        y = b * minX + d * maxY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
        x = a * maxX + c * maxY + tx;
        y = b * maxX + d * maxY + ty;
        this.minX = x < this.minX ? x : this.minX;
        this.minY = y < this.minY ? y : this.minY;
        this.maxX = x > this.maxX ? x : this.maxX;
        this.maxY = y > this.maxY ? y : this.maxY;
    }
    /**
   * Resizes the bounds object to fit within the given rectangle.
   * Clips the bounds if they extend beyond the rectangle's edges.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit within viewport
   * const viewport = new Rectangle(50, 50, 100, 100);
   * bounds.fit(viewport);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param rect - The rectangle to fit within
   * @returns This bounds object for chaining
   * @see {@link Bounds#addBoundsMask} For intersection
   * @see {@link Bounds#pad} For expanding bounds
   */ fit(rect) {
        if (this.minX < rect.left) this.minX = rect.left;
        if (this.maxX > rect.right) this.maxX = rect.right;
        if (this.minY < rect.top) this.minY = rect.top;
        if (this.maxY > rect.bottom) this.maxY = rect.bottom;
        return this;
    }
    /**
   * Resizes the bounds object to include the given bounds.
   * Similar to fit() but works with raw coordinate values instead of a Rectangle.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 200, 200);
   * // Fit to specific coordinates
   * bounds.fitBounds(50, 150, 50, 150);
   * // bounds are now (50, 50, 150, 150)
   * ```
   * @param left - The left value of the bounds
   * @param right - The right value of the bounds
   * @param top - The top value of the bounds
   * @param bottom - The bottom value of the bounds
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For fitting to Rectangle
   * @see {@link Bounds#addBoundsMask} For intersection
   */ fitBounds(left, right, top, bottom) {
        if (this.minX < left) this.minX = left;
        if (this.maxX > right) this.maxX = right;
        if (this.minY < top) this.minY = top;
        if (this.maxY > bottom) this.maxY = bottom;
        return this;
    }
    /**
   * Pads bounds object, making it grow in all directions.
   * If paddingY is omitted, both paddingX and paddingY will be set to paddingX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Add equal padding
   * bounds.pad(10);
   * // bounds are now (-10, -10, 110, 110)
   *
   * // Add different padding for x and y
   * bounds.pad(20, 10);
   * // bounds are now (-30, -20, 130, 120)
   * ```
   * @param paddingX - The horizontal padding amount
   * @param paddingY - The vertical padding amount
   * @returns This bounds object for chaining
   * @see {@link Bounds#fit} For constraining bounds
   * @see {@link Bounds#scale} For uniform scaling
   */ pad(paddingX, paddingY = paddingX) {
        this.minX -= paddingX;
        this.maxX += paddingX;
        this.minY -= paddingY;
        this.maxY += paddingY;
        return this;
    }
    /**
   * Ceils the bounds by rounding up max values and rounding down min values.
   * Useful for pixel-perfect calculations and avoiding fractional pixels.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * bounds.set(10.2, 10.9, 50.1, 50.8);
   *
   * // Round to whole pixels
   * bounds.ceil();
   * // bounds are now (10, 10, 51, 51)
   * ```
   * @returns This bounds object for chaining
   * @see {@link Bounds#scale} For size adjustments
   * @see {@link Bounds#fit} For constraining bounds
   */ ceil() {
        this.minX = Math.floor(this.minX);
        this.minY = Math.floor(this.minY);
        this.maxX = Math.ceil(this.maxX);
        this.maxY = Math.ceil(this.maxY);
        return this;
    }
    /**
   * Creates a new Bounds instance with the same values.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Create a copy
   * const copy = bounds.clone();
   *
   * // Original and copy are independent
   * bounds.pad(10);
   * console.log(copy.width === bounds.width); // false
   * ```
   * @returns A new Bounds instance with the same values
   * @see {@link Bounds#copyFrom} For reusing existing bounds
   */ clone() {
        return new $9e4672727a6a5b0b$export$c4e9d269599ab4b4(this.minX, this.minY, this.maxX, this.maxY);
    }
    /**
   * Scales the bounds by the given values, adjusting all edges proportionally.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   *
   * // Scale uniformly
   * bounds.scale(2);
   * // bounds are now (0, 0, 200, 200)
   *
   * // Scale non-uniformly
   * bounds.scale(0.5, 2);
   * // bounds are now (0, 0, 100, 400)
   * ```
   * @param x - The X value to scale by
   * @param y - The Y value to scale by (defaults to x)
   * @returns This bounds object for chaining
   * @see {@link Bounds#pad} For adding padding
   * @see {@link Bounds#fit} For constraining size
   */ scale(x, y = x) {
        this.minX *= x;
        this.minY *= y;
        this.maxX *= x;
        this.maxY *= y;
        return this;
    }
    /**
   * The x position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its width.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get x position
   * console.log(bounds.x); // 0
   *
   * // Move bounds horizontally
   * bounds.x = 50;
   * console.log(bounds.minX, bounds.maxX); // 50, 150
   *
   * // Width stays the same
   * console.log(bounds.width); // Still 100
   * ```
   */ get x() {
        return this.minX;
    }
    set x(value) {
        const width = this.maxX - this.minX;
        this.minX = value;
        this.maxX = value + width;
    }
    /**
   * The y position of the bounds in local space.
   * Setting this value will move the bounds while maintaining its height.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get y position
   * console.log(bounds.y); // 0
   *
   * // Move bounds vertically
   * bounds.y = 50;
   * console.log(bounds.minY, bounds.maxY); // 50, 150
   *
   * // Height stays the same
   * console.log(bounds.height); // Still 100
   * ```
   */ get y() {
        return this.minY;
    }
    set y(value) {
        const height = this.maxY - this.minY;
        this.minY = value;
        this.maxY = value + height;
    }
    /**
   * The width value of the bounds.
   * Represents the distance between minX and maxX coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get width
   * console.log(bounds.width); // 100
   * // Resize width
   * bounds.width = 200;
   * console.log(bounds.maxX - bounds.minX); // 200
   * ```
   */ get width() {
        return this.maxX - this.minX;
    }
    set width(value) {
        this.maxX = this.minX + value;
    }
    /**
   * The height value of the bounds.
   * Represents the distance between minY and maxY coordinates.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Get height
   * console.log(bounds.height); // 100
   * // Resize height
   * bounds.height = 150;
   * console.log(bounds.maxY - bounds.minY); // 150
   * ```
   */ get height() {
        return this.maxY - this.minY;
    }
    set height(value) {
        this.maxY = this.minY + value;
    }
    /**
   * The left edge coordinate of the bounds.
   * Alias for minX.
   * @example
   * ```ts
   * const bounds = new Bounds(50, 0, 150, 100);
   * console.log(bounds.left); // 50
   * console.log(bounds.left === bounds.minX); // true
   * ```
   * @readonly
   */ get left() {
        return this.minX;
    }
    /**
   * The right edge coordinate of the bounds.
   * Alias for maxX.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.right); // 100
   * console.log(bounds.right === bounds.maxX); // true
   * ```
   * @readonly
   */ get right() {
        return this.maxX;
    }
    /**
   * The top edge coordinate of the bounds.
   * Alias for minY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 25, 100, 125);
   * console.log(bounds.top); // 25
   * console.log(bounds.top === bounds.minY); // true
   * ```
   * @readonly
   */ get top() {
        return this.minY;
    }
    /**
   * The bottom edge coordinate of the bounds.
   * Alias for maxY.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 200);
   * console.log(bounds.bottom); // 200
   * console.log(bounds.bottom === bounds.maxY); // true
   * ```
   * @readonly
   */ get bottom() {
        return this.maxY;
    }
    /**
   * Whether the bounds has positive width and height.
   * Checks if both dimensions are greater than zero.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Check if bounds are positive
   * console.log(bounds.isPositive); // true
   *
   * // Negative bounds
   * bounds.maxX = bounds.minX;
   * console.log(bounds.isPositive); // false, width is 0
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isValid} For checking validity
   */ get isPositive() {
        return this.maxX - this.minX > 0 && this.maxY - this.minY > 0;
    }
    /**
   * Whether the bounds has valid coordinates.
   * Checks if the bounds has been initialized with real values.
   * @example
   * ```ts
   * const bounds = new Bounds();
   * console.log(bounds.isValid); // false, default state
   *
   * // Set valid bounds
   * bounds.addFrame(0, 0, 100, 100);
   * console.log(bounds.isValid); // true
   * ```
   * @readonly
   * @see {@link Bounds#isEmpty} For checking empty state
   * @see {@link Bounds#isPositive} For checking dimensions
   */ get isValid() {
        return this.minX + this.minY !== Infinity;
    }
    /**
   * Adds vertices from a Float32Array to the bounds, optionally transformed by a matrix.
   * Used for efficiently updating bounds from raw vertex data.
   * @example
   * ```ts
   * const bounds = new Bounds();
   *
   * // Add vertices from geometry
   * const vertices = new Float32Array([
   *     0, 0,    // Vertex 1
   *     100, 0,  // Vertex 2
   *     100, 100 // Vertex 3
   * ]);
   * bounds.addVertexData(vertices, 0, 6);
   *
   * // Add transformed vertices
   * const matrix = new Matrix()
   *     .translate(50, 50)
   *     .rotate(Math.PI / 4);
   * bounds.addVertexData(vertices, 0, 6, matrix);
   *
   * // Add subset of vertices
   * bounds.addVertexData(vertices, 2, 4); // Only second vertex
   * ```
   * @param vertexData - The array of vertices to add
   * @param beginOffset - Starting index in the vertex array
   * @param endOffset - Ending index in the vertex array (excluded)
   * @param matrix - Optional transformation matrix
   * @see {@link Bounds#addFrame} For adding rectangular frames
   * @see {@link Matrix} For transformation details
   */ addVertexData(vertexData, beginOffset, endOffset, matrix) {
        let minX = this.minX;
        let minY = this.minY;
        let maxX = this.maxX;
        let maxY = this.maxY;
        matrix || (matrix = this.matrix);
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        for(let i = beginOffset; i < endOffset; i += 2){
            const localX = vertexData[i];
            const localY = vertexData[i + 1];
            const x = a * localX + c * localY + tx;
            const y = b * localX + d * localY + ty;
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
        }
        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    }
    /**
   * Checks if a point is contained within the bounds.
   * Returns true if the point's coordinates fall within the bounds' area.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * // Basic point check
   * console.log(bounds.containsPoint(50, 50)); // true
   * console.log(bounds.containsPoint(150, 150)); // false
   *
   * // Check edges
   * console.log(bounds.containsPoint(0, 0));   // true, includes edges
   * console.log(bounds.containsPoint(100, 100)); // true, includes edges
   * ```
   * @param x - x coordinate to check
   * @param y - y coordinate to check
   * @returns True if the point is inside the bounds
   * @see {@link Bounds#isPositive} For valid bounds check
   * @see {@link Bounds#rectangle} For Rectangle representation
   */ containsPoint(x, y) {
        if (this.minX <= x && this.minY <= y && this.maxX >= x && this.maxY >= y) return true;
        return false;
    }
    /**
   * Returns a string representation of the bounds.
   * Useful for debugging and logging bounds information.
   * @example
   * ```ts
   * const bounds = new Bounds(0, 0, 100, 100);
   * console.log(bounds.toString()); // "[pixi.js:Bounds minX=0 minY=0 maxX=100 maxY=100 width=100 height=100]"
   * ```
   * @returns A string describing the bounds
   * @see {@link Bounds#copyFrom} For copying bounds
   * @see {@link Bounds#clone} For creating a new instance
   */ toString() {
        return `[pixi.js:Bounds minX=${this.minX} minY=${this.minY} maxX=${this.maxX} maxY=${this.maxY} width=${this.width} height=${this.height}]`;
    }
    /**
   * Copies the bounds from another bounds object.
   * Useful for reusing bounds objects and avoiding allocations.
   * @example
   * ```ts
   * const sourceBounds = new Bounds(0, 0, 100, 100);
   * // Copy bounds
   * const targetBounds = new Bounds();
   * targetBounds.copyFrom(sourceBounds);
   * ```
   * @param bounds - The bounds to copy from
   * @returns This bounds object for chaining
   * @see {@link Bounds#clone} For creating new instances
   */ copyFrom(bounds) {
        this.minX = bounds.minX;
        this.minY = bounds.minY;
        this.maxX = bounds.maxX;
        this.maxY = bounds.maxY;
        return this;
    }
}

});

parcelRegister("5Wp7K", function(module, exports) {

$parcel$export(module.exports, "UPDATE_COLOR", () => $11bdb5024bc26ff4$export$f8ede8d8bf091ab5);
$parcel$export(module.exports, "UPDATE_BLEND", () => $11bdb5024bc26ff4$export$e4801e7edc7582f);
$parcel$export(module.exports, "UPDATE_VISIBLE", () => $11bdb5024bc26ff4$export$83db162b74637ea);
$parcel$export(module.exports, "Container", () => $11bdb5024bc26ff4$export$42a852a2b6b56249);

var $6AQ4q = parcelRequire("6AQ4q");

var $jr7Dg = parcelRequire("jr7Dg");

var $4N8dQ = parcelRequire("4N8dQ");

var $aBhlC = parcelRequire("aBhlC");

var $deLbn = parcelRequire("deLbn");

var $ll3gZ = parcelRequire("ll3gZ");

var $2sdBn = parcelRequire("2sdBn");

var $kfwXR = parcelRequire("kfwXR");

var $dXBy0 = parcelRequire("dXBy0");

var $fGITk = parcelRequire("fGITk");

var $2xwDK = parcelRequire("2xwDK");

var $92Flf = parcelRequire("92Flf");

var $bCFwy = parcelRequire("bCFwy");

var $bFfCu = parcelRequire("bFfCu");

var $9VS0a = parcelRequire("9VS0a");

var $jDZzv = parcelRequire("jDZzv");

var $kP4Pt = parcelRequire("kP4Pt");

var $dMm4C = parcelRequire("dMm4C");

var $dDLWo = parcelRequire("dDLWo");

var $hYre8 = parcelRequire("hYre8");

var $lswM9 = parcelRequire("lswM9");

var $gIDcH = parcelRequire("gIDcH");

var $3b4bt = parcelRequire("3b4bt");

var $c6uH2 = parcelRequire("c6uH2");
"use strict";
const $11bdb5024bc26ff4$var$defaultSkew = new (0, $2sdBn.ObservablePoint)(null);
const $11bdb5024bc26ff4$var$defaultPivot = new (0, $2sdBn.ObservablePoint)(null);
const $11bdb5024bc26ff4$var$defaultScale = new (0, $2sdBn.ObservablePoint)(null, 1, 1);
const $11bdb5024bc26ff4$var$defaultOrigin = new (0, $2sdBn.ObservablePoint)(null);
const $11bdb5024bc26ff4$export$f8ede8d8bf091ab5 = 1;
const $11bdb5024bc26ff4$export$e4801e7edc7582f = 2;
const $11bdb5024bc26ff4$export$83db162b74637ea = 4;
const $11bdb5024bc26ff4$export$8363b5079568fbee = 8;
class $11bdb5024bc26ff4$export$42a852a2b6b56249 extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    constructor(options = {}){
        super();
        /**
     * unique id for this container
     * @internal
     */ this.uid = (0, $kfwXR.uid)("renderable");
        /** @private */ this._updateFlags = 15;
        // the render group this container owns
        /** @private */ this.renderGroup = null;
        // the render group this container belongs to
        /** @private */ this.parentRenderGroup = null;
        // the index of the container in the render group
        /** @private */ this.parentRenderGroupIndex = 0;
        // set to true if the container has changed. It is reset once the changes have been applied
        // by the transform system
        // its here to stop ensure that when things change, only one update gets registers with the transform system
        /** @private */ this.didChange = false;
        // same as above, but for the renderable
        /** @private */ this.didViewUpdate = false;
        // how deep is the container relative to its render group..
        // unless the element is the root render group - it will be relative to its parent
        /** @private */ this.relativeRenderGroupDepth = 0;
        /**
     * The array of children of this container. Each child must be a Container or extend from it.
     *
     * The array is read-only, but its contents can be modified using Container methods.
     * @example
     * ```ts
     * // Access children
     * const firstChild = container.children[0];
     * const lastChild = container.children[container.children.length - 1];
     * ```
     * @readonly
     * @see {@link Container#addChild} For adding children
     * @see {@link Container#removeChild} For removing children
     */ this.children = [];
        /**
     * The display object container that contains this display object.
     * This represents the parent-child relationship in the display tree.
     * @example
     * ```ts
     * // Basic parent access
     * const parent = sprite.parent;
     *
     * // Walk up the tree
     * let current = sprite;
     * while (current.parent) {
     *     console.log('Level up:', current.parent.constructor.name);
     *     current = current.parent;
     * }
     * ```
     * @readonly
     * @see {@link Container#addChild} For adding to a parent
     * @see {@link Container#removeChild} For removing from parent
     */ this.parent = null;
        // used internally for changing up the render order.. mainly for masks and filters
        // TODO setting this should cause a rebuild??
        /** @private */ this.includeInBuild = true;
        /** @private */ this.measurable = true;
        /** @private */ this.isSimple = true;
        /**
     * The RenderLayer this container belongs to, if any.
     * If it belongs to a RenderLayer, it will be rendered from the RenderLayer's position in the scene.
     * @readonly
     * @advanced
     */ this.parentRenderLayer = null;
        // / /////////////Transform related props//////////////
        // used by the transform system to check if a container needs to be updated that frame
        // if the tick matches the current transform system tick, it is not updated again
        /** @internal */ this.updateTick = -1;
        /**
     * Current transform of the object based on local factors: position, scale, other stuff.
     * This matrix represents the local transformation without any parent influence.
     * @example
     * ```ts
     * // Basic transform access
     * const localMatrix = sprite.localTransform;
     * console.log(localMatrix.toString());
     * ```
     * @readonly
     * @see {@link Container#worldTransform} For global transform
     * @see {@link Container#groupTransform} For render group transform
     */ this.localTransform = new (0, $deLbn.Matrix)();
        /**
     * The relative group transform is a transform relative to the render group it belongs too. It will include all parent
     * transforms and up to the render group (think of it as kind of like a stage - but the stage can be nested).
     * If this container is is self a render group matrix will be relative to its parent render group
     * @readonly
     * @advanced
     */ this.relativeGroupTransform = new (0, $deLbn.Matrix)();
        /**
     * The group transform is a transform relative to the render group it belongs too.
     * If this container is render group then this will be an identity matrix. other wise it
     * will be the same as the relativeGroupTransform.
     * Use this value when actually rendering things to the screen
     * @readonly
     * @advanced
     */ this.groupTransform = this.relativeGroupTransform;
        /**
     * Whether this object has been destroyed. If true, the object should no longer be used.
     * After an object is destroyed, all of its functionality is disabled and references are removed.
     * @example
     * ```ts
     * // Cleanup with destroy
     * sprite.destroy();
     * console.log(sprite.destroyed); // true
     * ```
     * @default false
     * @see {@link Container#destroy} For destroying objects
     */ this.destroyed = false;
        // transform data..
        /**
     * The coordinate of the object relative to the local coordinates of the parent.
     * @internal
     */ this._position = new (0, $2sdBn.ObservablePoint)(this, 0, 0);
        /**
     * The scale factor of the object.
     * @internal
     */ this._scale = $11bdb5024bc26ff4$var$defaultScale;
        /**
     * The pivot point of the container that it rotates around.
     * @internal
     */ this._pivot = $11bdb5024bc26ff4$var$defaultPivot;
        /**
     * The origin point around which the container rotates and scales.
     * Unlike pivot, changing origin will not move the container's position.
     * @private
     */ this._origin = $11bdb5024bc26ff4$var$defaultOrigin;
        /**
     * The skew amount, on the x and y axis.
     * @internal
     */ this._skew = $11bdb5024bc26ff4$var$defaultSkew;
        /**
     * The X-coordinate value of the normalized local X axis,
     * the first column of the local transformation matrix without a scale.
     * @internal
     */ this._cx = 1;
        /**
     * The Y-coordinate value of the normalized local X axis,
     * the first column of the local transformation matrix without a scale.
     * @internal
     */ this._sx = 0;
        /**
     * The X-coordinate value of the normalized local Y axis,
     * the second column of the local transformation matrix without a scale.
     * @internal
     */ this._cy = 0;
        /**
     * The Y-coordinate value of the normalized local Y axis,
     * the second column of the local transformation matrix without a scale.
     * @internal
     */ this._sy = 1;
        /**
     * The rotation amount.
     * @internal
     */ this._rotation = 0;
        // / COLOR related props //////////////
        // color stored as ABGR
        /** @internal */ this.localColor = 16777215;
        /** @internal */ this.localAlpha = 1;
        /** @internal */ this.groupAlpha = 1;
        // A
        /** @internal */ this.groupColor = 16777215;
        // BGR
        /** @internal */ this.groupColorAlpha = 4294967295;
        // ABGR
        // / BLEND related props //////////////
        /** @internal */ this.localBlendMode = "inherit";
        /** @internal */ this.groupBlendMode = "normal";
        // / VISIBILITY related props //////////////
        // visibility
        // 0b11
        // first bit is visible, second bit is renderable
        /**
     * This property holds three bits: culled, visible, renderable
     * the third bit represents culling (0 = culled, 1 = not culled) 0b100
     * the second bit represents visibility (0 = not visible, 1 = visible) 0b010
     * the first bit represents renderable (0 = not renderable, 1 = renderable) 0b001
     * @internal
     */ this.localDisplayStatus = 7;
        // 0b11 | 0b10 | 0b01 | 0b00
        /** @internal */ this.globalDisplayStatus = 7;
        /**
     * A value that increments each time the containe is modified
     * eg children added, removed etc
     * @ignore
     */ this._didContainerChangeTick = 0;
        /**
     * A value that increments each time the container view is modified
     * eg texture swap, geometry change etc
     * @ignore
     */ this._didViewChangeTick = 0;
        /**
     * property that tracks if the container transform has changed
     * @ignore
     */ this._didLocalTransformChangeId = -1;
        this.effects = [];
        (0, $c6uH2.assignWithIgnore)(this, options, {
            children: true,
            parent: true,
            effects: true
        });
        options.children?.forEach((child)=>this.addChild(child));
        options.parent?.addChild(this);
    }
    /**
   * Mixes all enumerable properties and methods from a source object to Container.
   * @param source - The source of properties and methods to mix in.
   * @deprecated since 8.8.0
   */ static mixin(source) {
        (0, $dXBy0.deprecation)("8.8.0", "Container.mixin is deprecated, please use extensions.mixin instead.");
        (0, $aBhlC.extensions).mixin($11bdb5024bc26ff4$export$42a852a2b6b56249, source);
    }
    // = 'default';
    /**
   * We now use the _didContainerChangeTick and _didViewChangeTick to track changes
   * @deprecated since 8.2.6
   * @ignore
   */ set _didChangeId(value) {
        this._didViewChangeTick = value >> 12 & 4095;
        this._didContainerChangeTick = value & 4095;
    }
    /** @ignore */ get _didChangeId() {
        return this._didContainerChangeTick & 4095 | (this._didViewChangeTick & 4095) << 12;
    }
    /**
   * Adds one or more children to the container.
   * The children will be rendered as part of this container's display list.
   * @example
   * ```ts
   * // Add a single child
   * container.addChild(sprite);
   *
   * // Add multiple children
   * container.addChild(background, player, foreground);
   *
   * // Add with type checking
   * const sprite = container.addChild<Sprite>(new Sprite(texture));
   * sprite.tint = 'red';
   * ```
   * @param children - The Container(s) to add to the container
   * @returns The first child that was added
   * @see {@link Container#removeChild} For removing children
   * @see {@link Container#addChildAt} For adding at specific index
   */ addChild(...children) {
        if (!this.allowChildren) (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "addChild: Only Containers will be allowed to add children in v8.0.0");
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.addChild(children[i]);
            return children[0];
        }
        const child = children[0];
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (child.parent === this) {
            this.children.splice(this.children.indexOf(child), 1);
            this.children.push(child);
            if (renderGroup) renderGroup.structureDidChange = true;
            return child;
        }
        if (child.parent) child.parent.removeChild(child);
        this.children.push(child);
        if (this.sortableChildren) this.sortDirty = true;
        child.parent = this;
        child.didChange = true;
        child._updateFlags = 15;
        if (renderGroup) renderGroup.addChild(child);
        this.emit("childAdded", child, this, this.children.length - 1);
        child.emit("added", this);
        this._didViewChangeTick++;
        if (child._zIndex !== 0) child.depthOfChildModified();
        return child;
    }
    /**
   * Removes one or more children from the container.
   * When removing multiple children, events will be triggered for each child in sequence.
   * @example
   * ```ts
   * // Remove a single child
   * const removed = container.removeChild(sprite);
   *
   * // Remove multiple children
   * const bg = container.removeChild(background, player, userInterface);
   *
   * // Remove with type checking
   * const sprite = container.removeChild<Sprite>(childSprite);
   * sprite.texture = newTexture;
   * ```
   * @param children - The Container(s) to remove
   * @returns The first child that was removed
   * @see {@link Container#addChild} For adding children
   * @see {@link Container#removeChildren} For removing multiple children
   */ removeChild(...children) {
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
            return children[0];
        }
        const child = children[0];
        const index = this.children.indexOf(child);
        if (index > -1) {
            this._didViewChangeTick++;
            this.children.splice(index, 1);
            if (this.renderGroup) this.renderGroup.removeChild(child);
            else if (this.parentRenderGroup) this.parentRenderGroup.removeChild(child);
            if (child.parentRenderLayer) child.parentRenderLayer.detach(child);
            child.parent = null;
            this.emit("childRemoved", child, this, index);
            child.emit("removed", this);
        }
        return child;
    }
    /** @ignore */ _onUpdate(point) {
        if (point) {
            if (point === this._skew) this._updateSkew();
        }
        this._didContainerChangeTick++;
        if (this.didChange) return;
        this.didChange = true;
        if (this.parentRenderGroup) this.parentRenderGroup.onChildUpdate(this);
    }
    set isRenderGroup(value) {
        if (!!this.renderGroup === value) return;
        if (value) this.enableRenderGroup();
        else this.disableRenderGroup();
    }
    /**
   * Returns true if this container is a render group.
   * This means that it will be rendered as a separate pass, with its own set of instructions
   * @advanced
   */ get isRenderGroup() {
        return !!this.renderGroup;
    }
    /**
   * Calling this enables a render group for this container.
   * This means it will be rendered as a separate set of instructions.
   * The transform of the container will also be handled on the GPU rather than the CPU.
   * @advanced
   */ enableRenderGroup() {
        if (this.renderGroup) return;
        const parentRenderGroup = this.parentRenderGroup;
        parentRenderGroup?.removeChild(this);
        this.renderGroup = (0, $2xwDK.BigPool).get((0, $3b4bt.RenderGroup), this);
        this.groupTransform = (0, $deLbn.Matrix).IDENTITY;
        parentRenderGroup?.addChild(this);
        this._updateIsSimple();
    }
    /**
   * This will disable the render group for this container.
   * @advanced
   */ disableRenderGroup() {
        if (!this.renderGroup) return;
        const parentRenderGroup = this.parentRenderGroup;
        parentRenderGroup?.removeChild(this);
        (0, $2xwDK.BigPool).return(this.renderGroup);
        this.renderGroup = null;
        this.groupTransform = this.relativeGroupTransform;
        parentRenderGroup?.addChild(this);
        this._updateIsSimple();
    }
    /** @ignore */ _updateIsSimple() {
        this.isSimple = !this.renderGroup && this.effects.length === 0;
    }
    /**
   * Current transform of the object based on world (parent) factors.
   *
   * This matrix represents the absolute transformation in the scene graph.
   * @example
   * ```ts
   * // Get world position
   * const worldPos = container.worldTransform;
   * console.log(`World position: (${worldPos.tx}, ${worldPos.ty})`);
   * ```
   * @readonly
   * @see {@link Container#localTransform} For local space transform
   */ get worldTransform() {
        this._worldTransform || (this._worldTransform = new (0, $deLbn.Matrix)());
        if (this.renderGroup) this._worldTransform.copyFrom(this.renderGroup.worldTransform);
        else if (this.parentRenderGroup) this._worldTransform.appendFrom(this.relativeGroupTransform, this.parentRenderGroup.worldTransform);
        return this._worldTransform;
    }
    /**
   * The position of the container on the x axis relative to the local coordinates of the parent.
   *
   * An alias to position.x
   * @example
   * ```ts
   * // Basic position
   * container.x = 100;
   * ```
   */ get x() {
        return this._position.x;
    }
    set x(value) {
        this._position.x = value;
    }
    /**
   * The position of the container on the y axis relative to the local coordinates of the parent.
   *
   * An alias to position.y
   * @example
   * ```ts
   * // Basic position
   * container.y = 200;
   * ```
   */ get y() {
        return this._position.y;
    }
    set y(value) {
        this._position.y = value;
    }
    /**
   * The coordinate of the object relative to the local coordinates of the parent.
   * @example
   * ```ts
   * // Basic position setting
   * container.position.set(100, 200);
   * container.position.set(100); // Sets both x and y to 100
   * // Using point data
   * container.position = { x: 50, y: 75 };
   * ```
   * @since 4.0.0
   */ get position() {
        return this._position;
    }
    set position(value) {
        this._position.copyFrom(value);
    }
    /**
   * The rotation of the object in radians.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   * @example
   * ```ts
   * // Basic rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   *
   * // Convert from degrees
   * const degrees = 45;
   * container.rotation = degrees * Math.PI / 180;
   *
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // 180 degrees
   *
   * // Rotate around center with origin
   * container.origin.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // 180 degrees
   * ```
   */ get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        if (this._rotation !== value) {
            this._rotation = value;
            this._onUpdate(this._skew);
        }
    }
    /**
   * The angle of the object in degrees.
   *
   * > [!NOTE] 'rotation' and 'angle' have the same effect on a display object;
   * > rotation is in radians, angle is in degrees.
   * @example
   * ```ts
   * // Basic angle rotation
   * sprite.angle = 45; // 45 degrees
   *
   * // Rotate around center
   * sprite.pivot.set(sprite.width / 2, sprite.height / 2);
   * sprite.angle = 180; // Half rotation
   *
   * // Rotate around center with origin
   * sprite.origin.set(sprite.width / 2, sprite.height / 2);
   * sprite.angle = 180; // Half rotation
   *
   * // Reset rotation
   * sprite.angle = 0;
   * ```
   */ get angle() {
        return this.rotation * (0, $ll3gZ.RAD_TO_DEG);
    }
    set angle(value) {
        this.rotation = value * (0, $ll3gZ.DEG_TO_RAD);
    }
    /**
   * The center of rotation, scaling, and skewing for this display object in its local space.
   * The `position` is the projection of `pivot` in the parent's local space.
   *
   * By default, the pivot is the origin (0, 0).
   * @example
   * ```ts
   * // Rotate around center
   * container.pivot.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // Rotates around center
   * ```
   * @since 4.0.0
   */ get pivot() {
        if (this._pivot === $11bdb5024bc26ff4$var$defaultPivot) this._pivot = new (0, $2sdBn.ObservablePoint)(this, 0, 0);
        return this._pivot;
    }
    set pivot(value) {
        if (this._pivot === $11bdb5024bc26ff4$var$defaultPivot) {
            this._pivot = new (0, $2sdBn.ObservablePoint)(this, 0, 0);
            if (this._origin !== $11bdb5024bc26ff4$var$defaultOrigin) (0, $fGITk.warn)(`Setting both a pivot and origin on a Container is not recommended. This can lead to unexpected behavior if not handled carefully.`);
        }
        typeof value === "number" ? this._pivot.set(value) : this._pivot.copyFrom(value);
    }
    /**
   * The skew factor for the object in radians. Skewing is a transformation that distorts
   * the object by rotating it differently at each point, creating a non-uniform shape.
   * @example
   * ```ts
   * // Basic skewing
   * container.skew.set(0.5, 0); // Skew horizontally
   * container.skew.set(0, 0.5); // Skew vertically
   *
   * // Skew with point data
   * container.skew = { x: 0.3, y: 0.3 }; // Diagonal skew
   *
   * // Reset skew
   * container.skew.set(0, 0);
   *
   * // Animate skew
   * app.ticker.add(() => {
   *     // Create wave effect
   *     container.skew.x = Math.sin(Date.now() / 1000) * 0.3;
   * });
   *
   * // Combine with rotation
   * container.rotation = Math.PI / 4; // 45 degrees
   * container.skew.set(0.2, 0.2); // Skew the rotated object
   * ```
   * @since 4.0.0
   * @type {ObservablePoint} Point-like object with x/y properties in radians
   * @default {x: 0, y: 0}
   */ get skew() {
        if (this._skew === $11bdb5024bc26ff4$var$defaultSkew) this._skew = new (0, $2sdBn.ObservablePoint)(this, 0, 0);
        return this._skew;
    }
    set skew(value) {
        if (this._skew === $11bdb5024bc26ff4$var$defaultSkew) this._skew = new (0, $2sdBn.ObservablePoint)(this, 0, 0);
        this._skew.copyFrom(value);
    }
    /**
   * The scale factors of this object along the local coordinate axes.
   *
   * The default scale is (1, 1).
   * @example
   * ```ts
   * // Basic scaling
   * container.scale.set(2, 2); // Scales to double size
   * container.scale.set(2); // Scales uniformly to double size
   * container.scale = 2; // Scales uniformly to double size
   * // Scale to a specific width and height
   * container.setSize(200, 100); // Sets width to 200 and height to 100
   * ```
   * @since 4.0.0
   */ get scale() {
        if (this._scale === $11bdb5024bc26ff4$var$defaultScale) this._scale = new (0, $2sdBn.ObservablePoint)(this, 1, 1);
        return this._scale;
    }
    set scale(value) {
        if (this._scale === $11bdb5024bc26ff4$var$defaultScale) this._scale = new (0, $2sdBn.ObservablePoint)(this, 0, 0);
        if (typeof value === "string") value = parseFloat(value);
        typeof value === "number" ? this._scale.set(value) : this._scale.copyFrom(value);
    }
    /**
   * @experimental
   * The origin point around which the container rotates and scales without affecting its position.
   * Unlike pivot, changing the origin will not move the container's position.
   * @example
   * ```ts
   * // Rotate around center point
   * container.origin.set(container.width / 2, container.height / 2);
   * container.rotation = Math.PI; // Rotates around center
   *
   * // Reset origin
   * container.origin.set(0, 0);
   * ```
   */ get origin() {
        if (this._origin === $11bdb5024bc26ff4$var$defaultOrigin) this._origin = new (0, $2sdBn.ObservablePoint)(this, 0, 0);
        return this._origin;
    }
    set origin(value) {
        if (this._origin === $11bdb5024bc26ff4$var$defaultOrigin) {
            this._origin = new (0, $2sdBn.ObservablePoint)(this, 0, 0);
            if (this._pivot !== $11bdb5024bc26ff4$var$defaultPivot) (0, $fGITk.warn)(`Setting both a pivot and origin on a Container is not recommended. This can lead to unexpected behavior if not handled carefully.`);
        }
        typeof value === "number" ? this._origin.set(value) : this._origin.copyFrom(value);
    }
    /**
   * The width of the Container, setting this will actually modify the scale to achieve the value set.
   * > [!NOTE] Changing the width will adjust the scale.x property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   * @example
   * ```ts
   * // Basic width setting
   * container.width = 100;
   * // Optimized width setting
   * container.setSize(100, 100);
   * ```
   */ get width() {
        return Math.abs(this.scale.x * this.getLocalBounds().width);
    }
    set width(value) {
        const localWidth = this.getLocalBounds().width;
        this._setWidth(value, localWidth);
    }
    /**
   * The height of the Container,
   * > [!NOTE] Changing the height will adjust the scale.y property of the container while maintaining its aspect ratio.
   * > [!NOTE] If you want to set both width and height at the same time, use {@link Container#setSize}
   * as it is more optimized by not recalculating the local bounds twice.
   * @example
   * ```ts
   * // Basic height setting
   * container.height = 200;
   * // Optimized height setting
   * container.setSize(100, 200);
   * ```
   */ get height() {
        return Math.abs(this.scale.y * this.getLocalBounds().height);
    }
    set height(value) {
        const localHeight = this.getLocalBounds().height;
        this._setHeight(value, localHeight);
    }
    /**
   * Retrieves the size of the container as a [Size]{@link Size} object.
   *
   * This is faster than get the width and height separately.
   * @example
   * ```ts
   * // Basic size retrieval
   * const size = container.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * container.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in.
   * @returns The size of the container.
   */ getSize(out) {
        if (!out) out = {};
        const bounds = this.getLocalBounds();
        out.width = Math.abs(this.scale.x * bounds.width);
        out.height = Math.abs(this.scale.y * bounds.height);
        return out;
    }
    /**
   * Sets the size of the container to the specified width and height.
   * This is more efficient than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * container.setSize(100, 200);
   *
   * // Set uniform size
   * container.setSize(100); // Sets both width and height to 100
   * ```
   * @param value - This can be either a number or a [Size]{@link Size} object.
   * @param height - The height to set. Defaults to the value of `width` if not provided.
   */ setSize(value, height) {
        const size = this.getLocalBounds();
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, size.width);
        height !== void 0 && this._setHeight(height, size.height);
    }
    /** Called when the skew or the rotation changes. */ _updateSkew() {
        const rotation = this._rotation;
        const skew = this._skew;
        this._cx = Math.cos(rotation + skew._y);
        this._sx = Math.sin(rotation + skew._y);
        this._cy = -Math.sin(rotation - skew._x);
        this._sy = Math.cos(rotation - skew._x);
    }
    /**
   * Updates the transform properties of the container.
   * Allows partial updates of transform properties for optimized manipulation.
   * @example
   * ```ts
   * // Basic transform update
   * container.updateTransform({
   *     x: 100,
   *     y: 200,
   *     rotation: Math.PI / 4
   * });
   *
   * // Scale and rotate around center
   * sprite.updateTransform({
   *     pivotX: sprite.width / 2,
   *     pivotY: sprite.height / 2,
   *     scaleX: 2,
   *     scaleY: 2,
   *     rotation: Math.PI
   * });
   *
   * // Update position only
   * button.updateTransform({
   *     x: button.x + 10, // Move right
   *     y: button.y      // Keep same y
   * });
   * ```
   * @param opts - Transform options to update
   * @param opts.x - The x position
   * @param opts.y - The y position
   * @param opts.scaleX - The x-axis scale factor
   * @param opts.scaleY - The y-axis scale factor
   * @param opts.rotation - The rotation in radians
   * @param opts.skewX - The x-axis skew factor
   * @param opts.skewY - The y-axis skew factor
   * @param opts.pivotX - The x-axis pivot point
   * @param opts.pivotY - The y-axis pivot point
   * @returns This container, for chaining
   * @see {@link Container#setFromMatrix} For matrix-based transforms
   * @see {@link Container#position} For direct position access
   */ updateTransform(opts) {
        this.position.set(typeof opts.x === "number" ? opts.x : this.position.x, typeof opts.y === "number" ? opts.y : this.position.y);
        this.scale.set(typeof opts.scaleX === "number" ? opts.scaleX || 1 : this.scale.x, typeof opts.scaleY === "number" ? opts.scaleY || 1 : this.scale.y);
        this.rotation = typeof opts.rotation === "number" ? opts.rotation : this.rotation;
        this.skew.set(typeof opts.skewX === "number" ? opts.skewX : this.skew.x, typeof opts.skewY === "number" ? opts.skewY : this.skew.y);
        this.pivot.set(typeof opts.pivotX === "number" ? opts.pivotX : this.pivot.x, typeof opts.pivotY === "number" ? opts.pivotY : this.pivot.y);
        this.origin.set(typeof opts.originX === "number" ? opts.originX : this.origin.x, typeof opts.originY === "number" ? opts.originY : this.origin.y);
        return this;
    }
    /**
   * Updates the local transform properties by decomposing the given matrix.
   * Extracts position, scale, rotation, and skew from a transformation matrix.
   * @example
   * ```ts
   * // Basic matrix transform
   * const matrix = new Matrix()
   *     .translate(100, 100)
   *     .rotate(Math.PI / 4)
   *     .scale(2, 2);
   *
   * container.setFromMatrix(matrix);
   *
   * // Copy transform from another container
   * const source = new Container();
   * source.position.set(100, 100);
   * source.rotation = Math.PI / 2;
   *
   * target.setFromMatrix(source.localTransform);
   *
   * // Reset transform
   * container.setFromMatrix(Matrix.IDENTITY);
   * ```
   * @param matrix - The matrix to use for updating the transform
   * @see {@link Container#updateTransform} For property-based updates
   * @see {@link Matrix#decompose} For matrix decomposition details
   */ setFromMatrix(matrix) {
        matrix.decompose(this);
    }
    /** Updates the local transform. */ updateLocalTransform() {
        const localTransformChangeId = this._didContainerChangeTick;
        if (this._didLocalTransformChangeId === localTransformChangeId) return;
        this._didLocalTransformChangeId = localTransformChangeId;
        const lt = this.localTransform;
        const scale = this._scale;
        const pivot = this._pivot;
        const origin = this._origin;
        const position = this._position;
        const sx = scale._x;
        const sy = scale._y;
        const px = pivot._x;
        const py = pivot._y;
        const ox = -origin._x;
        const oy = -origin._y;
        lt.a = this._cx * sx;
        lt.b = this._sx * sx;
        lt.c = this._cy * sy;
        lt.d = this._sy * sy;
        lt.tx = position._x - (px * lt.a + py * lt.c) + (ox * lt.a + oy * lt.c) - ox;
        lt.ty = position._y - (px * lt.b + py * lt.d) + (ox * lt.b + oy * lt.d) - oy;
    }
    // / ///// color related stuff
    set alpha(value) {
        if (value === this.localAlpha) return;
        this.localAlpha = value;
        this._updateFlags |= $11bdb5024bc26ff4$export$f8ede8d8bf091ab5;
        this._onUpdate();
    }
    /**
   * The opacity of the object relative to its parent's opacity.
   * Value ranges from 0 (fully transparent) to 1 (fully opaque).
   * @example
   * ```ts
   * // Basic transparency
   * sprite.alpha = 0.5; // 50% opacity
   *
   * // Inherited opacity
   * container.alpha = 0.5;
   * const child = new Sprite(texture);
   * child.alpha = 0.5;
   * container.addChild(child);
   * // child's effective opacity is 0.25 (0.5 * 0.5)
   * ```
   * @default 1
   * @see {@link Container#visible} For toggling visibility
   * @see {@link Container#renderable} For render control
   */ get alpha() {
        return this.localAlpha;
    }
    set tint(value) {
        const tempColor = (0, $jr7Dg.Color).shared.setValue(value ?? 16777215);
        const bgr = tempColor.toBgrNumber();
        if (bgr === this.localColor) return;
        this.localColor = bgr;
        this._updateFlags |= $11bdb5024bc26ff4$export$f8ede8d8bf091ab5;
        this._onUpdate();
    }
    /**
   * The tint applied to the sprite.
   *
   * This can be any valid {@link ColorSource}.
   * @example
   * ```ts
   * // Basic color tinting
   * container.tint = 0xff0000; // Red tint
   * container.tint = 'red';    // Same as above
   * container.tint = '#00ff00'; // Green
   * container.tint = 'rgb(0,0,255)'; // Blue
   *
   * // Remove tint
   * container.tint = 0xffffff; // White = no tint
   * container.tint = null;     // Also removes tint
   * ```
   * @default 0xFFFFFF
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#visible} For visibility control
   */ get tint() {
        return (0, $dMm4C.bgr2rgb)(this.localColor);
    }
    // / //////////////// blend related stuff
    set blendMode(value) {
        if (this.localBlendMode === value) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $11bdb5024bc26ff4$export$e4801e7edc7582f;
        this.localBlendMode = value;
        this._onUpdate();
    }
    /**
   * The blend mode to be applied to the sprite. Controls how pixels are blended when rendering.
   *
   * Setting to 'normal' will reset to default blending.
   * > [!NOTE] More blend modes are available after importing the `pixi.js/advanced-blend-modes` sub-export.
   * @example
   * ```ts
   * // Basic blend modes
   * sprite.blendMode = 'add';        // Additive blending
   * sprite.blendMode = 'multiply';   // Multiply colors
   * sprite.blendMode = 'screen';     // Screen blend
   *
   * // Reset blend mode
   * sprite.blendMode = 'normal';     // Normal blending
   * ```
   * @default 'normal'
   * @see {@link Container#alpha} For transparency
   * @see {@link Container#tint} For color adjustments
   */ get blendMode() {
        return this.localBlendMode;
    }
    // / ///////// VISIBILITY / RENDERABLE /////////////////
    /**
   * The visibility of the object. If false the object will not be drawn,
   * and the transform will not be updated.
   * @example
   * ```ts
   * // Basic visibility toggle
   * sprite.visible = false; // Hide sprite
   * sprite.visible = true;  // Show sprite
   * ```
   * @default true
   * @see {@link Container#renderable} For render-only control
   * @see {@link Container#alpha} For transparency
   */ get visible() {
        return !!(this.localDisplayStatus & 2);
    }
    set visible(value) {
        const valueNumber = value ? 2 : 0;
        if ((this.localDisplayStatus & 2) === valueNumber) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $11bdb5024bc26ff4$export$83db162b74637ea;
        this.localDisplayStatus ^= 2;
        this._onUpdate();
        this.emit("visibleChanged", value);
    }
    /** @ignore */ get culled() {
        return !(this.localDisplayStatus & 4);
    }
    /** @ignore */ set culled(value) {
        const valueNumber = value ? 0 : 4;
        if ((this.localDisplayStatus & 4) === valueNumber) return;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._updateFlags |= $11bdb5024bc26ff4$export$83db162b74637ea;
        this.localDisplayStatus ^= 4;
        this._onUpdate();
    }
    /**
   * Controls whether this object can be rendered. If false the object will not be drawn,
   * but the transform will still be updated. This is different from visible, which skips
   * transform updates.
   * @example
   * ```ts
   * // Basic render control
   * sprite.renderable = false; // Skip rendering
   * sprite.renderable = true;  // Enable rendering
   * ```
   * @default true
   * @see {@link Container#visible} For skipping transform updates
   * @see {@link Container#alpha} For transparency
   */ get renderable() {
        return !!(this.localDisplayStatus & 1);
    }
    set renderable(value) {
        const valueNumber = value ? 1 : 0;
        if ((this.localDisplayStatus & 1) === valueNumber) return;
        this._updateFlags |= $11bdb5024bc26ff4$export$83db162b74637ea;
        this.localDisplayStatus ^= 1;
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
        this._onUpdate();
    }
    /**
   * Whether or not the object should be rendered.
   * @advanced
   */ get isRenderable() {
        return this.localDisplayStatus === 7 && this.groupAlpha > 0;
    }
    /**
   * Removes all internal references and listeners as well as removes children from the display list.
   * Do not use a Container after calling `destroy`.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * ```ts
   * container.destroy();
   * container.destroy(true);
   * container.destroy({ children: true });
   * container.destroy({ children: true, texture: true, textureSource: true });
   * ```
   */ destroy(options = false) {
        if (this.destroyed) return;
        this.destroyed = true;
        let oldChildren;
        if (this.children.length) oldChildren = this.removeChildren(0, this.children.length);
        this.removeFromParent();
        this.parent = null;
        this._maskEffect = null;
        this._filterEffect = null;
        this.effects = null;
        this._position = null;
        this._scale = null;
        this._pivot = null;
        this._origin = null;
        this._skew = null;
        this.emit("destroyed", this);
        this.removeAllListeners();
        const destroyChildren = typeof options === "boolean" ? options : options?.children;
        if (destroyChildren && oldChildren) for(let i = 0; i < oldChildren.length; ++i)oldChildren[i].destroy(options);
        this.renderGroup?.destroy();
        this.renderGroup = null;
    }
}
(0, $aBhlC.extensions).mixin($11bdb5024bc26ff4$export$42a852a2b6b56249, (0, $bCFwy.childrenHelperMixin), (0, $kP4Pt.getFastGlobalBoundsMixin), (0, $gIDcH.toLocalGlobalMixin), (0, $hYre8.onRenderMixin), (0, $dDLWo.measureMixin), (0, $9VS0a.effectsMixin), (0, $jDZzv.findMixin), (0, $lswM9.sortMixin), (0, $4N8dQ.cullingMixin), (0, $92Flf.cacheAsTextureMixin), (0, $dMm4C.getGlobalMixin), (0, $bFfCu.collectRenderablesMixin));

});
parcelRegister("jr7Dg", function(module, exports) {

$parcel$export(module.exports, "Color", () => $5cb115d260f4b119$export$892596cec99bc70e);

var $jyvmC = parcelRequire("jyvmC");

var $flk9m = parcelRequire("flk9m");
"use strict";
(0, $jyvmC.extend)([
    (0, $flk9m.default)
]);
const $5cb115d260f4b119$var$_Color = class _Color {
    /**
   * @param {ColorSource} value - Optional value to use, if not provided, white is used.
   */ constructor(value = 16777215){
        this._value = null;
        this._components = new Float32Array(4);
        this._components.fill(1);
        this._int = 16777215;
        this.value = value;
    }
    /**
   * Get the red component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.red); // 1
   *
   * const green = new Color('#00ff00');
   * console.log(green.red); // 0
   * ```
   */ get red() {
        return this._components[0];
    }
    /**
   * Get the green component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('lime');
   * console.log(color.green); // 1
   *
   * const red = new Color('#ff0000');
   * console.log(red.green); // 0
   * ```
   */ get green() {
        return this._components[1];
    }
    /**
   * Get the blue component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('blue');
   * console.log(color.blue); // 1
   *
   * const yellow = new Color('#ffff00');
   * console.log(yellow.blue); // 0
   * ```
   */ get blue() {
        return this._components[2];
    }
    /**
   * Get the alpha component of the color, normalized between 0 and 1.
   * @example
   * ```ts
   * const color = new Color('red');
   * console.log(color.alpha); // 1 (fully opaque)
   *
   * const transparent = new Color('rgba(255, 0, 0, 0.5)');
   * console.log(transparent.alpha); // 0.5 (semi-transparent)
   * ```
   */ get alpha() {
        return this._components[3];
    }
    /**
   * Sets the color value and returns the instance for chaining.
   *
   * This is a chainable version of setting the `value` property.
   * @param value - The color to set. Accepts various formats:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA values (arrays, objects)
   * - CSS color names
   * - HSL/HSLA values
   * - HSV/HSVA values
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic usage
   * const color = new Color();
   * color.setValue('#ff0000')
   *     .setAlpha(0.5)
   *     .premultiply(0.8);
   *
   * // Different formats
   * color.setValue(0xff0000);          // Hex number
   * color.setValue('#ff0000');         // Hex string
   * color.setValue([1, 0, 0]);         // RGB array
   * color.setValue([1, 0, 0, 0.5]);    // RGBA array
   * color.setValue({ r: 1, g: 0, b: 0 }); // RGB object
   *
   * // Copy from another color
   * const red = new Color('red');
   * color.setValue(red);
   * ```
   * @throws {Error} If the color value is invalid or null
   * @see {@link Color.value} For the underlying value property
   */ setValue(value) {
        this.value = value;
        return this;
    }
    /**
   * The current color source. This property allows getting and setting the color value
   * while preserving the original format where possible.
   * @remarks
   * When setting:
   * - Setting to a `Color` instance copies its source and components
   * - Setting to other valid sources normalizes and stores the value
   * - Setting to `null` throws an Error
   * - The color remains unchanged if normalization fails
   *
   * When getting:
   * - Returns `null` if color was modified by {@link Color.multiply} or {@link Color.premultiply}
   * - Otherwise returns the original color source
   * @example
   * ```ts
   * // Setting different color formats
   * const color = new Color();
   *
   * color.value = 0xff0000;         // Hex number
   * color.value = '#ff0000';        // Hex string
   * color.value = [1, 0, 0];        // RGB array
   * color.value = [1, 0, 0, 0.5];   // RGBA array
   * color.value = { r: 1, g: 0, b: 0 }; // RGB object
   *
   * // Copying from another color
   * const red = new Color('red');
   * color.value = red;  // Copies red's components
   *
   * // Getting the value
   * console.log(color.value);  // Returns original format
   *
   * // After modifications
   * color.multiply([0.5, 0.5, 0.5]);
   * console.log(color.value);  // Returns null
   * ```
   * @throws {Error} When attempting to set `null`
   */ set value(value) {
        if (value instanceof _Color) {
            this._value = this._cloneSource(value._value);
            this._int = value._int;
            this._components.set(value._components);
        } else if (value === null) throw new Error("Cannot set Color#value to null");
        else if (this._value === null || !this._isSourceEqual(this._value, value)) {
            this._value = this._cloneSource(value);
            this._normalize(this._value);
        }
    }
    get value() {
        return this._value;
    }
    /**
   * Copy a color source internally.
   * @param value - Color source
   */ _cloneSource(value) {
        if (typeof value === "string" || typeof value === "number" || value instanceof Number || value === null) return value;
        else if (Array.isArray(value) || ArrayBuffer.isView(value)) return value.slice(0);
        else if (typeof value === "object" && value !== null) return {
            ...value
        };
        return value;
    }
    /**
   * Equality check for color sources.
   * @param value1 - First color source
   * @param value2 - Second color source
   * @returns `true` if the color sources are equal, `false` otherwise.
   */ _isSourceEqual(value1, value2) {
        const type1 = typeof value1;
        const type2 = typeof value2;
        if (type1 !== type2) return false;
        else if (type1 === "number" || type1 === "string" || value1 instanceof Number) return value1 === value2;
        else if (Array.isArray(value1) && Array.isArray(value2) || ArrayBuffer.isView(value1) && ArrayBuffer.isView(value2)) {
            if (value1.length !== value2.length) return false;
            return value1.every((v, i)=>v === value2[i]);
        } else if (value1 !== null && value2 !== null) {
            const keys1 = Object.keys(value1);
            const keys2 = Object.keys(value2);
            if (keys1.length !== keys2.length) return false;
            return keys1.every((key)=>value1[key] === value2[key]);
        }
        return value1 === value2;
    }
    /**
   * Convert to a RGBA color object with normalized components (0-1).
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA objects
   * new Color('white').toRgba();     // returns { r: 1, g: 1, b: 1, a: 1 }
   * new Color('#ff0000').toRgba();   // returns { r: 1, g: 0, b: 0, a: 1 }
   *
   * // With transparency
   * new Color('rgba(255,0,0,0.5)').toRgba(); // returns { r: 1, g: 0, b: 0, a: 0.5 }
   * ```
   * @returns An RGBA object with normalized components
   */ toRgba() {
        const [r, g, b, a] = this._components;
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    }
    /**
   * Convert to a RGB color object with normalized components (0-1).
   *
   * Alpha component is omitted in the output.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGB objects
   * new Color('white').toRgb();     // returns { r: 1, g: 1, b: 1 }
   * new Color('#ff0000').toRgb();   // returns { r: 1, g: 0, b: 0 }
   *
   * // Alpha is ignored
   * new Color('rgba(255,0,0,0.5)').toRgb(); // returns { r: 1, g: 0, b: 0 }
   * ```
   * @returns An RGB object with normalized components
   */ toRgb() {
        const [r, g, b] = this._components;
        return {
            r: r,
            g: g,
            b: b
        };
    }
    /**
   * Convert to a CSS-style rgba string representation.
   *
   * RGB components are scaled to 0-255 range, alpha remains 0-1.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert colors to RGBA strings
   * new Color('white').toRgbaString();     // returns "rgba(255,255,255,1)"
   * new Color('#ff0000').toRgbaString();   // returns "rgba(255,0,0,1)"
   *
   * // With transparency
   * new Color([1, 0, 0, 0.5]).toRgbaString(); // returns "rgba(255,0,0,0.5)"
   * ```
   * @returns A CSS-compatible rgba string
   */ toRgbaString() {
        const [r, g, b] = this.toUint8RgbArray();
        return `rgba(${r},${g},${b},${this.alpha})`;
    }
    /**
   * Convert to an [R, G, B] array of clamped uint8 values (0 to 255).
   * @param {number[]|Uint8Array|Uint8ClampedArray} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as integers between 0-255
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toUint8RgbArray(); // returns [255, 255, 255]
   * new Color('#ff0000').toUint8RgbArray(); // returns [255, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Uint8Array(3);
   * new Color('blue').toUint8RgbArray(rgb); // rgb is now [0, 0, 255]
   *
   * // Using different array types
   * new Color('red').toUint8RgbArray(new Uint8ClampedArray(3)); // [255, 0, 0]
   * new Color('red').toUint8RgbArray([]); // [255, 0, 0]
   * ```
   * @remarks
   * - Output values are always clamped between 0-255
   * - Alpha component is not included in output
   * - Reuses internal cache array if no output array provided
   */ toUint8RgbArray(out) {
        const [r, g, b] = this._components;
        if (!this._arrayRgb) this._arrayRgb = [];
        out || (out = this._arrayRgb);
        out[0] = Math.round(r * 255);
        out[1] = Math.round(g * 255);
        out[2] = Math.round(b * 255);
        return out;
    }
    /**
   * Convert to an [R, G, B, A] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGBA components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toArray();  // returns [1, 1, 1, 1]
   * new Color('red').toArray();    // returns [1, 0, 0, 1]
   *
   * // With alpha
   * new Color('rgba(255,0,0,0.5)').toArray(); // returns [1, 0, 0, 0.5]
   *
   * // Using custom output array
   * const rgba = new Float32Array(4);
   * new Color('blue').toArray(rgba); // rgba is now [0, 0, 1, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Includes alpha component as the fourth value
   * - Reuses internal cache array if no output array provided
   */ toArray(out) {
        if (!this._arrayRgba) this._arrayRgba = [];
        out || (out = this._arrayRgba);
        const [r, g, b, a] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        out[3] = a;
        return out;
    }
    /**
   * Convert to an [R, G, B] array of normalized floats (numbers from 0.0 to 1.0).
   * @param {number[]|Float32Array} [out] - Optional output array. If not provided,
   * a cached array will be used and returned.
   * @returns Array containing RGB components as floats between 0-1
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toRgbArray(); // returns [1, 1, 1]
   * new Color('red').toRgbArray();   // returns [1, 0, 0]
   *
   * // Using custom output array
   * const rgb = new Float32Array(3);
   * new Color('blue').toRgbArray(rgb); // rgb is now [0, 0, 1]
   * ```
   * @remarks
   * - Output values are normalized between 0-1
   * - Alpha component is omitted from output
   * - Reuses internal cache array if no output array provided
   */ toRgbArray(out) {
        if (!this._arrayRgb) this._arrayRgb = [];
        out || (out = this._arrayRgb);
        const [r, g, b] = this._components;
        out[0] = r;
        out[1] = g;
        out[2] = b;
        return out;
    }
    /**
   * Convert to a hexadecimal number.
   * @returns The color as a 24-bit RGB integer
   * @example
   * ```ts
   * // Basic usage
   * new Color('white').toNumber(); // returns 0xffffff
   * new Color('red').toNumber();   // returns 0xff0000
   *
   * // Store as hex
   * const color = new Color('blue');
   * const hex = color.toNumber(); // 0x0000ff
   * ```
   */ toNumber() {
        return this._int;
    }
    /**
   * Convert to a BGR number.
   *
   * Useful for platforms that expect colors in BGR format.
   * @returns The color as a 24-bit BGR integer
   * @example
   * ```ts
   * // Convert RGB to BGR
   * new Color(0xffcc99).toBgrNumber(); // returns 0x99ccff
   *
   * // Common use case: platform-specific color format
   * const color = new Color('orange');
   * const bgrColor = color.toBgrNumber(); // Color with swapped R/B channels
   * ```
   * @remarks
   * This swaps the red and blue channels compared to the normal RGB format:
   * - RGB 0xRRGGBB becomes BGR 0xBBGGRR
   */ toBgrNumber() {
        const [r, g, b] = this.toUint8RgbArray();
        return (b << 16) + (g << 8) + r;
    }
    /**
   * Convert to a hexadecimal number in little endian format (e.g., BBGGRR).
   *
   * Useful for platforms that expect colors in little endian byte order.
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Convert RGB color to little endian format
   * new Color(0xffcc99).toLittleEndianNumber(); // returns 0x99ccff
   *
   * // Common use cases:
   * const color = new Color('orange');
   * const leColor = color.toLittleEndianNumber(); // Swaps byte order for LE systems
   *
   * // Multiple conversions
   * const colors = {
   *     normal: 0xffcc99,
   *     littleEndian: new Color(0xffcc99).toLittleEndianNumber(), // 0x99ccff
   *     backToNormal: new Color(0x99ccff).toLittleEndianNumber()  // 0xffcc99
   * };
   * ```
   * @remarks
   * - Swaps R and B channels in the color value
   * - RGB 0xRRGGBB becomes 0xBBGGRR
   * - Useful for systems that use little endian byte order
   * - Can be used to convert back and forth between formats
   * @returns The color as a number in little endian format (BBGGRR)
   * @see {@link Color.toBgrNumber} For BGR format without byte swapping
   */ toLittleEndianNumber() {
        const value = this._int;
        return (value >> 16) + (value & 65280) + ((value & 255) << 16);
    }
    /**
   * Multiply with another color.
   *
   * This action is destructive and modifies the original color.
   * @param {ColorSource} value - The color to multiply by. Accepts any valid color format:
   * - Hex strings/numbers (e.g., '#ff0000', 0xff0000)
   * - RGB/RGBA arrays ([1, 0, 0], [1, 0, 0, 1])
   * - Color objects ({ r: 1, g: 0, b: 0 })
   * - CSS color names ('red', 'blue')
   * @returns this - The Color instance for chaining
   * @example
   * ```ts
   * // Basic multiplication
   * const color = new Color('#ff0000');
   * color.multiply(0x808080); // 50% darker red
   *
   * // With transparency
   * color.multiply([1, 1, 1, 0.5]); // 50% transparent
   *
   * // Chain operations
   * color
   *     .multiply('#808080')
   *     .multiply({ r: 1, g: 1, b: 1, a: 0.5 });
   * ```
   * @remarks
   * - Multiplies each RGB component and alpha separately
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */ multiply(value) {
        const [r, g, b, a] = _Color._temp.setValue(value)._components;
        this._components[0] *= r;
        this._components[1] *= g;
        this._components[2] *= b;
        this._components[3] *= a;
        this._refreshInt();
        this._value = null;
        return this;
    }
    /**
   * Converts color to a premultiplied alpha format.
   *
   * This action is destructive and modifies the original color.
   * @param alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {Color} The Color instance for chaining
   * @example
   * ```ts
   * // Basic premultiplication
   * const color = new Color('red');
   * color.premultiply(0.5); // 50% transparent red with premultiplied RGB
   *
   * // Alpha only (RGB unchanged)
   * color.premultiply(0.5, false); // 50% transparent, original RGB
   *
   * // Chain with other operations
   * color
   *     .multiply(0x808080)
   *     .premultiply(0.5)
   *     .toNumber();
   * ```
   * @remarks
   * - RGB channels are multiplied by alpha when applyToRGB is true
   * - Alpha is always set to the provided value
   * - Values are clamped between 0-1
   * - Original color format is lost (value becomes null)
   * - Operation cannot be undone
   */ premultiply(alpha, applyToRGB = true) {
        if (applyToRGB) {
            this._components[0] *= alpha;
            this._components[1] *= alpha;
            this._components[2] *= alpha;
        }
        this._components[3] = alpha;
        this._refreshInt();
        this._value = null;
        return this;
    }
    /**
   * Returns the color as a 32-bit premultiplied alpha integer.
   *
   * Format: 0xAARRGGBB
   * @param {number} alpha - The alpha value to multiply by (0-1)
   * @param {boolean} [applyToRGB=true] - Whether to premultiply RGB channels
   * @returns {number} The premultiplied color as a 32-bit integer
   * @example
   * ```ts
   * // Convert to premultiplied format
   * const color = new Color('red');
   *
   * // Full opacity (0xFFRRGGBB)
   * color.toPremultiplied(1.0); // 0xFFFF0000
   *
   * // 50% transparency with premultiplied RGB
   * color.toPremultiplied(0.5); // 0x7F7F0000
   *
   * // 50% transparency without RGB premultiplication
   * color.toPremultiplied(0.5, false); // 0x7FFF0000
   * ```
   * @remarks
   * - Returns full opacity (0xFF000000) when alpha is 1.0
   * - Returns 0 when alpha is 0.0 and applyToRGB is true
   * - RGB values are rounded during premultiplication
   */ toPremultiplied(alpha, applyToRGB = true) {
        if (alpha === 1) return -16777216 + this._int;
        if (alpha === 0) return applyToRGB ? 0 : this._int;
        let r = this._int >> 16 & 255;
        let g = this._int >> 8 & 255;
        let b = this._int & 255;
        if (applyToRGB) {
            r = r * alpha + 0.5 | 0;
            g = g * alpha + 0.5 | 0;
            b = b * alpha + 0.5 | 0;
        }
        return (alpha * 255 << 24) + (r << 16) + (g << 8) + b;
    }
    /**
   * Convert to a hexadecimal string (6 characters).
   * @returns A CSS-compatible hex color string (e.g., "#ff0000")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Basic colors
   * new Color('red').toHex();    // returns "#ff0000"
   * new Color('white').toHex();  // returns "#ffffff"
   * new Color('black').toHex();  // returns "#000000"
   *
   * // From different formats
   * new Color(0xff0000).toHex(); // returns "#ff0000"
   * new Color([1, 0, 0]).toHex(); // returns "#ff0000"
   * new Color({ r: 1, g: 0, b: 0 }).toHex(); // returns "#ff0000"
   * ```
   * @remarks
   * - Always returns a 6-character hex string
   * - Includes leading "#" character
   * - Alpha channel is ignored
   * - Values are rounded to nearest hex value
   */ toHex() {
        const hexString = this._int.toString(16);
        return `#${"000000".substring(0, 6 - hexString.length) + hexString}`;
    }
    /**
   * Convert to a hexadecimal string with alpha (8 characters).
   * @returns A CSS-compatible hex color string with alpha (e.g., "#ff0000ff")
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // Fully opaque colors
   * new Color('red').toHexa();   // returns "#ff0000ff"
   * new Color('white').toHexa(); // returns "#ffffffff"
   *
   * // With transparency
   * new Color('rgba(255, 0, 0, 0.5)').toHexa(); // returns "#ff00007f"
   * new Color([1, 0, 0, 0]).toHexa(); // returns "#ff000000"
   * ```
   * @remarks
   * - Returns an 8-character hex string
   * - Includes leading "#" character
   * - Alpha is encoded in last two characters
   * - Values are rounded to nearest hex value
   */ toHexa() {
        const alphaValue = Math.round(this._components[3] * 255);
        const alphaString = alphaValue.toString(16);
        return this.toHex() + "00".substring(0, 2 - alphaString.length) + alphaString;
    }
    /**
   * Set alpha (transparency) value while preserving color components.
   *
   * Provides a chainable interface for setting alpha.
   * @param alpha - Alpha value between 0 (fully transparent) and 1 (fully opaque)
   * @returns The Color instance for chaining
   * @example
   * ```ts
   * // Basic alpha setting
   * const color = new Color('red');
   * color.setAlpha(0.5);  // 50% transparent red
   *
   * // Chain with other operations
   * color
   *     .setValue('#ff0000')
   *     .setAlpha(0.8)    // 80% opaque
   *     .premultiply(0.5); // Further modify alpha
   *
   * // Reset to fully opaque
   * color.setAlpha(1);
   * ```
   * @remarks
   * - Alpha value is clamped between 0-1
   * - Can be chained with other color operations
   */ setAlpha(alpha) {
        this._components[3] = this._clamp(alpha);
        this._value = null;
        return this;
    }
    /**
   * Normalize the input value into rgba
   * @param value - Input value
   */ _normalize(value) {
        let r;
        let g;
        let b;
        let a;
        if ((typeof value === "number" || value instanceof Number) && value >= 0 && value <= 16777215) {
            const int = value;
            r = (int >> 16 & 255) / 255;
            g = (int >> 8 & 255) / 255;
            b = (int & 255) / 255;
            a = 1;
        } else if ((Array.isArray(value) || value instanceof Float32Array) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value);
            [r, g, b, a = 1] = value;
        } else if ((value instanceof Uint8Array || value instanceof Uint8ClampedArray) && value.length >= 3 && value.length <= 4) {
            value = this._clamp(value, 0, 255);
            [r, g, b, a = 255] = value;
            r /= 255;
            g /= 255;
            b /= 255;
            a /= 255;
        } else if (typeof value === "string" || typeof value === "object") {
            if (typeof value === "string") {
                const match = _Color.HEX_PATTERN.exec(value);
                if (match) value = `#${match[2]}`;
            }
            const color = (0, $jyvmC.colord)(value);
            if (color.isValid()) {
                ({ r: r, g: g, b: b, a: a } = color.rgba);
                r /= 255;
                g /= 255;
                b /= 255;
            }
        }
        if (r !== void 0) {
            this._components[0] = r;
            this._components[1] = g;
            this._components[2] = b;
            this._components[3] = a;
            this._refreshInt();
        } else throw new Error(`Unable to convert color ${value}`);
    }
    /** Refresh the internal color rgb number */ _refreshInt() {
        this._clamp(this._components);
        const [r, g, b] = this._components;
        this._int = (r * 255 << 16) + (g * 255 << 8) + (b * 255 | 0);
    }
    /**
   * Clamps values to a range. Will override original values
   * @param value - Value(s) to clamp
   * @param min - Minimum value
   * @param max - Maximum value
   */ _clamp(value, min = 0, max = 1) {
        if (typeof value === "number") return Math.min(Math.max(value, min), max);
        value.forEach((v, i)=>{
            value[i] = Math.min(Math.max(v, min), max);
        });
        return value;
    }
    /**
   * Check if a value can be interpreted as a valid color format.
   * Supports all color formats that can be used with the Color class.
   * @param value - Value to check
   * @returns True if the value can be used as a color
   * @example
   * ```ts
   * import { Color } from 'pixi.js';
   *
   * // CSS colors and hex values
   * Color.isColorLike('red');          // true
   * Color.isColorLike('#ff0000');      // true
   * Color.isColorLike(0xff0000);       // true
   *
   * // Arrays (RGB/RGBA)
   * Color.isColorLike([1, 0, 0]);      // true
   * Color.isColorLike([1, 0, 0, 0.5]); // true
   *
   * // TypedArrays
   * Color.isColorLike(new Float32Array([1, 0, 0]));          // true
   * Color.isColorLike(new Uint8Array([255, 0, 0]));          // true
   * Color.isColorLike(new Uint8ClampedArray([255, 0, 0]));   // true
   *
   * // Object formats
   * Color.isColorLike({ r: 1, g: 0, b: 0 });            // true (RGB)
   * Color.isColorLike({ r: 1, g: 0, b: 0, a: 0.5 });    // true (RGBA)
   * Color.isColorLike({ h: 0, s: 100, l: 50 });         // true (HSL)
   * Color.isColorLike({ h: 0, s: 100, l: 50, a: 0.5 }); // true (HSLA)
   * Color.isColorLike({ h: 0, s: 100, v: 100 });        // true (HSV)
   * Color.isColorLike({ h: 0, s: 100, v: 100, a: 0.5 });// true (HSVA)
   *
   * // Color instances
   * Color.isColorLike(new Color('red')); // true
   *
   * // Invalid values
   * Color.isColorLike(null);           // false
   * Color.isColorLike(undefined);      // false
   * Color.isColorLike({});             // false
   * Color.isColorLike([]);             // false
   * Color.isColorLike('not-a-color');  // false
   * ```
   * @remarks
   * Checks for the following formats:
   * - Numbers (0x000000 to 0xffffff)
   * - CSS color strings
   * - RGB/RGBA arrays and objects
   * - HSL/HSLA objects
   * - HSV/HSVA objects
   * - TypedArrays (Float32Array, Uint8Array, Uint8ClampedArray)
   * - Color instances
   * @see {@link ColorSource} For supported color format types
   * @see {@link Color.setValue} For setting color values
   * @category utility
   */ static isColorLike(value) {
        return typeof value === "number" || typeof value === "string" || value instanceof Number || value instanceof _Color || Array.isArray(value) || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Float32Array || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 || value.r !== void 0 && value.g !== void 0 && value.b !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 || value.h !== void 0 && value.s !== void 0 && value.l !== void 0 && value.a !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 || value.h !== void 0 && value.s !== void 0 && value.v !== void 0 && value.a !== void 0;
    }
};
/**
 * Static shared Color instance used for utility operations. This is a singleton color object
 * that can be reused to avoid creating unnecessary Color instances.
 * > [!IMPORTANT] You should be careful when using this shared instance, as it is mutable and can be
 * > changed by any code that uses it.
 * >
 * > It is best used for one-off color operations or temporary transformations.
 * > For persistent colors, create your own Color instance instead.
 * @example
 * ```ts
 * import { Color } from 'pixi.js';
 *
 * // Use shared instance for one-off color operations
 * Color.shared.setValue(0xff0000);
 * const redHex = Color.shared.toHex();     // "#ff0000"
 * const redRgb = Color.shared.toRgbArray(); // [1, 0, 0]
 *
 * // Temporary color transformations
 * const colorNumber = Color.shared
 *     .setValue('#ff0000')     // Set to red
 *     .setAlpha(0.5)          // Make semi-transparent
 *     .premultiply(0.8)       // Apply premultiplication
 *     .toNumber();            // Convert to number
 *
 * // Chain multiple operations
 * const result = Color.shared
 *     .setValue(someColor)
 *     .multiply(tintColor)
 *     .toPremultiplied(alpha);
 * ```
 * @remarks
 * - This is a shared instance - be careful about multiple code paths using it simultaneously
 * - Use for temporary color operations to avoid allocating new Color instances
 * - The value is preserved between operations, so reset if needed
 * - For persistent colors, create your own Color instance instead
 */ $5cb115d260f4b119$var$_Color.shared = new $5cb115d260f4b119$var$_Color();
/**
 * Temporary Color object for static uses internally.
 * As to not conflict with Color.shared.
 * @ignore
 */ $5cb115d260f4b119$var$_Color._temp = new $5cb115d260f4b119$var$_Color();
/** Pattern for hex strings */ // eslint-disable-next-line @typescript-eslint/naming-convention
$5cb115d260f4b119$var$_Color.HEX_PATTERN = /^(#|0x)?(([a-f0-9]{3}){1,2}([a-f0-9]{2})?)$/i;
let $5cb115d260f4b119$export$892596cec99bc70e = $5cb115d260f4b119$var$_Color;

});
parcelRegister("jyvmC", function(module, exports) {

$parcel$export(module.exports, "colord", () => $34b99b961acc9a90$export$c8efe09109f9cb9e);
$parcel$export(module.exports, "extend", () => $34b99b961acc9a90$export$8b58be045bf06082);
var $34b99b961acc9a90$var$r = {
    grad: .9,
    turn: 360,
    rad: 360 / (2 * Math.PI)
}, $34b99b961acc9a90$var$t = function(r) {
    return "string" == typeof r ? r.length > 0 : "number" == typeof r;
}, $34b99b961acc9a90$var$n = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = Math.pow(10, t)), Math.round(n * r) / n + 0;
}, $34b99b961acc9a90$var$e = function(r, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = 1), r > n ? n : r > t ? r : t;
}, $34b99b961acc9a90$var$u = function(r) {
    return (r = isFinite(r) ? r % 360 : 0) > 0 ? r : r + 360;
}, $34b99b961acc9a90$var$a = function(r) {
    return {
        r: $34b99b961acc9a90$var$e(r.r, 0, 255),
        g: $34b99b961acc9a90$var$e(r.g, 0, 255),
        b: $34b99b961acc9a90$var$e(r.b, 0, 255),
        a: $34b99b961acc9a90$var$e(r.a)
    };
}, $34b99b961acc9a90$var$o = function(r) {
    return {
        r: $34b99b961acc9a90$var$n(r.r),
        g: $34b99b961acc9a90$var$n(r.g),
        b: $34b99b961acc9a90$var$n(r.b),
        a: $34b99b961acc9a90$var$n(r.a, 3)
    };
}, $34b99b961acc9a90$var$i = /^#([0-9a-f]{3,8})$/i, $34b99b961acc9a90$var$s = function(r) {
    var t = r.toString(16);
    return t.length < 2 ? "0" + t : t;
}, $34b99b961acc9a90$var$h = function(r) {
    var t = r.r, n = r.g, e = r.b, u = r.a, a = Math.max(t, n, e), o = a - Math.min(t, n, e), i = o ? a === t ? (n - e) / o : a === n ? 2 + (e - t) / o : 4 + (t - n) / o : 0;
    return {
        h: 60 * (i < 0 ? i + 6 : i),
        s: a ? o / a * 100 : 0,
        v: a / 255 * 100,
        a: u
    };
}, $34b99b961acc9a90$var$b = function(r) {
    var t = r.h, n = r.s, e = r.v, u = r.a;
    t = t / 360 * 6, n /= 100, e /= 100;
    var a = Math.floor(t), o = e * (1 - n), i = e * (1 - (t - a) * n), s = e * (1 - (1 - t + a) * n), h = a % 6;
    return {
        r: 255 * [
            e,
            i,
            o,
            o,
            s,
            e
        ][h],
        g: 255 * [
            s,
            e,
            e,
            i,
            o,
            o
        ][h],
        b: 255 * [
            o,
            o,
            s,
            e,
            e,
            i
        ][h],
        a: u
    };
}, $34b99b961acc9a90$var$g = function(r) {
    return {
        h: $34b99b961acc9a90$var$u(r.h),
        s: $34b99b961acc9a90$var$e(r.s, 0, 100),
        l: $34b99b961acc9a90$var$e(r.l, 0, 100),
        a: $34b99b961acc9a90$var$e(r.a)
    };
}, $34b99b961acc9a90$var$d = function(r) {
    return {
        h: $34b99b961acc9a90$var$n(r.h),
        s: $34b99b961acc9a90$var$n(r.s),
        l: $34b99b961acc9a90$var$n(r.l),
        a: $34b99b961acc9a90$var$n(r.a, 3)
    };
}, $34b99b961acc9a90$var$f = function(r) {
    var t, n, e;
    return $34b99b961acc9a90$var$b((n = (t = r).s, {
        h: t.h,
        s: (n *= ((e = t.l) < 50 ? e : 100 - e) / 100) > 0 ? 2 * n / (e + n) * 100 : 0,
        v: e + n,
        a: t.a
    }));
}, $34b99b961acc9a90$var$c = function(r) {
    var t, n, e, u;
    return {
        h: (t = $34b99b961acc9a90$var$h(r)).h,
        s: (u = (200 - (n = t.s)) * (e = t.v) / 100) > 0 && u < 200 ? n * e / 100 / (u <= 100 ? u : 200 - u) * 100 : 0,
        l: u / 2,
        a: t.a
    };
}, $34b99b961acc9a90$var$l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $34b99b961acc9a90$var$p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $34b99b961acc9a90$var$v = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $34b99b961acc9a90$var$m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, $34b99b961acc9a90$var$y = {
    string: [
        [
            function(r) {
                var t = $34b99b961acc9a90$var$i.exec(r);
                return t ? (r = t[1]).length <= 4 ? {
                    r: parseInt(r[0] + r[0], 16),
                    g: parseInt(r[1] + r[1], 16),
                    b: parseInt(r[2] + r[2], 16),
                    a: 4 === r.length ? $34b99b961acc9a90$var$n(parseInt(r[3] + r[3], 16) / 255, 2) : 1
                } : 6 === r.length || 8 === r.length ? {
                    r: parseInt(r.substr(0, 2), 16),
                    g: parseInt(r.substr(2, 2), 16),
                    b: parseInt(r.substr(4, 2), 16),
                    a: 8 === r.length ? $34b99b961acc9a90$var$n(parseInt(r.substr(6, 2), 16) / 255, 2) : 1
                } : null : null;
            },
            "hex"
        ],
        [
            function(r) {
                var t = $34b99b961acc9a90$var$v.exec(r) || $34b99b961acc9a90$var$m.exec(r);
                return t ? t[2] !== t[4] || t[4] !== t[6] ? null : $34b99b961acc9a90$var$a({
                    r: Number(t[1]) / (t[2] ? 100 / 255 : 1),
                    g: Number(t[3]) / (t[4] ? 100 / 255 : 1),
                    b: Number(t[5]) / (t[6] ? 100 / 255 : 1),
                    a: void 0 === t[7] ? 1 : Number(t[7]) / (t[8] ? 100 : 1)
                }) : null;
            },
            "rgb"
        ],
        [
            function(t) {
                var n = $34b99b961acc9a90$var$l.exec(t) || $34b99b961acc9a90$var$p.exec(t);
                if (!n) return null;
                var e, u, a = $34b99b961acc9a90$var$g({
                    h: (e = n[1], u = n[2], void 0 === u && (u = "deg"), Number(e) * ($34b99b961acc9a90$var$r[u] || 1)),
                    s: Number(n[3]),
                    l: Number(n[4]),
                    a: void 0 === n[5] ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
                return $34b99b961acc9a90$var$f(a);
            },
            "hsl"
        ]
    ],
    object: [
        [
            function(r) {
                var n = r.r, e = r.g, u = r.b, o = r.a, i = void 0 === o ? 1 : o;
                return $34b99b961acc9a90$var$t(n) && $34b99b961acc9a90$var$t(e) && $34b99b961acc9a90$var$t(u) ? $34b99b961acc9a90$var$a({
                    r: Number(n),
                    g: Number(e),
                    b: Number(u),
                    a: Number(i)
                }) : null;
            },
            "rgb"
        ],
        [
            function(r) {
                var n = r.h, e = r.s, u = r.l, a = r.a, o = void 0 === a ? 1 : a;
                if (!$34b99b961acc9a90$var$t(n) || !$34b99b961acc9a90$var$t(e) || !$34b99b961acc9a90$var$t(u)) return null;
                var i = $34b99b961acc9a90$var$g({
                    h: Number(n),
                    s: Number(e),
                    l: Number(u),
                    a: Number(o)
                });
                return $34b99b961acc9a90$var$f(i);
            },
            "hsl"
        ],
        [
            function(r) {
                var n = r.h, a = r.s, o = r.v, i = r.a, s = void 0 === i ? 1 : i;
                if (!$34b99b961acc9a90$var$t(n) || !$34b99b961acc9a90$var$t(a) || !$34b99b961acc9a90$var$t(o)) return null;
                var h = function(r) {
                    return {
                        h: $34b99b961acc9a90$var$u(r.h),
                        s: $34b99b961acc9a90$var$e(r.s, 0, 100),
                        v: $34b99b961acc9a90$var$e(r.v, 0, 100),
                        a: $34b99b961acc9a90$var$e(r.a)
                    };
                }({
                    h: Number(n),
                    s: Number(a),
                    v: Number(o),
                    a: Number(s)
                });
                return $34b99b961acc9a90$var$b(h);
            },
            "hsv"
        ]
    ]
}, $34b99b961acc9a90$var$N = function(r, t) {
    for(var n = 0; n < t.length; n++){
        var e = t[n][0](r);
        if (e) return [
            e,
            t[n][1]
        ];
    }
    return [
        null,
        void 0
    ];
}, $34b99b961acc9a90$var$x = function(r) {
    return "string" == typeof r ? $34b99b961acc9a90$var$N(r.trim(), $34b99b961acc9a90$var$y.string) : "object" == typeof r && null !== r ? $34b99b961acc9a90$var$N(r, $34b99b961acc9a90$var$y.object) : [
        null,
        void 0
    ];
}, $34b99b961acc9a90$export$f61ac8b6f1f46202 = function(r) {
    return $34b99b961acc9a90$var$x(r)[1];
}, $34b99b961acc9a90$var$M = function(r, t) {
    var n = $34b99b961acc9a90$var$c(r);
    return {
        h: n.h,
        s: $34b99b961acc9a90$var$e(n.s + 100 * t, 0, 100),
        l: n.l,
        a: n.a
    };
}, $34b99b961acc9a90$var$H = function(r) {
    return (299 * r.r + 587 * r.g + 114 * r.b) / 1e3 / 255;
}, $34b99b961acc9a90$var$$ = function(r, t) {
    var n = $34b99b961acc9a90$var$c(r);
    return {
        h: n.h,
        s: n.s,
        l: $34b99b961acc9a90$var$e(n.l + 100 * t, 0, 100),
        a: n.a
    };
}, $34b99b961acc9a90$export$4d30ed660ff08d0 = function() {
    function r(r) {
        this.parsed = $34b99b961acc9a90$var$x(r)[0], this.rgba = this.parsed || {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    return r.prototype.isValid = function() {
        return null !== this.parsed;
    }, r.prototype.brightness = function() {
        return $34b99b961acc9a90$var$n($34b99b961acc9a90$var$H(this.rgba), 2);
    }, r.prototype.isDark = function() {
        return $34b99b961acc9a90$var$H(this.rgba) < .5;
    }, r.prototype.isLight = function() {
        return $34b99b961acc9a90$var$H(this.rgba) >= .5;
    }, r.prototype.toHex = function() {
        var r, t, e, u, a, i;
        return r = $34b99b961acc9a90$var$o(this.rgba), t = r.r, e = r.g, u = r.b, i = (a = r.a) < 1 ? $34b99b961acc9a90$var$s($34b99b961acc9a90$var$n(255 * a)) : "", "#" + $34b99b961acc9a90$var$s(t) + $34b99b961acc9a90$var$s(e) + $34b99b961acc9a90$var$s(u) + i;
    }, r.prototype.toRgb = function() {
        return $34b99b961acc9a90$var$o(this.rgba);
    }, r.prototype.toRgbString = function() {
        var r, t, n, e, u;
        return r = $34b99b961acc9a90$var$o(this.rgba), t = r.r, n = r.g, e = r.b, (u = r.a) < 1 ? "rgba(" + t + ", " + n + ", " + e + ", " + u + ")" : "rgb(" + t + ", " + n + ", " + e + ")";
    }, r.prototype.toHsl = function() {
        return $34b99b961acc9a90$var$d($34b99b961acc9a90$var$c(this.rgba));
    }, r.prototype.toHslString = function() {
        var r, t, n, e, u;
        return r = $34b99b961acc9a90$var$d($34b99b961acc9a90$var$c(this.rgba)), t = r.h, n = r.s, e = r.l, (u = r.a) < 1 ? "hsla(" + t + ", " + n + "%, " + e + "%, " + u + ")" : "hsl(" + t + ", " + n + "%, " + e + "%)";
    }, r.prototype.toHsv = function() {
        var r;
        return r = $34b99b961acc9a90$var$h(this.rgba), {
            h: $34b99b961acc9a90$var$n(r.h),
            s: $34b99b961acc9a90$var$n(r.s),
            v: $34b99b961acc9a90$var$n(r.v),
            a: $34b99b961acc9a90$var$n(r.a, 3)
        };
    }, r.prototype.invert = function() {
        var r;
        return $34b99b961acc9a90$export$c8efe09109f9cb9e({
            r: 255 - (r = this.rgba).r,
            g: 255 - r.g,
            b: 255 - r.b,
            a: r.a
        });
    }, r.prototype.saturate = function(r) {
        return void 0 === r && (r = .1), $34b99b961acc9a90$export$c8efe09109f9cb9e($34b99b961acc9a90$var$M(this.rgba, r));
    }, r.prototype.desaturate = function(r) {
        return void 0 === r && (r = .1), $34b99b961acc9a90$export$c8efe09109f9cb9e($34b99b961acc9a90$var$M(this.rgba, -r));
    }, r.prototype.grayscale = function() {
        return $34b99b961acc9a90$export$c8efe09109f9cb9e($34b99b961acc9a90$var$M(this.rgba, -1));
    }, r.prototype.lighten = function(r) {
        return void 0 === r && (r = .1), $34b99b961acc9a90$export$c8efe09109f9cb9e($34b99b961acc9a90$var$$(this.rgba, r));
    }, r.prototype.darken = function(r) {
        return void 0 === r && (r = .1), $34b99b961acc9a90$export$c8efe09109f9cb9e($34b99b961acc9a90$var$$(this.rgba, -r));
    }, r.prototype.rotate = function(r) {
        return void 0 === r && (r = 15), this.hue(this.hue() + r);
    }, r.prototype.alpha = function(r) {
        var t;
        return "number" == typeof r ? $34b99b961acc9a90$export$c8efe09109f9cb9e({
            r: (t = this.rgba).r,
            g: t.g,
            b: t.b,
            a: r
        }) : $34b99b961acc9a90$var$n(this.rgba.a, 3);
    }, r.prototype.hue = function(r) {
        var t = $34b99b961acc9a90$var$c(this.rgba);
        return "number" == typeof r ? $34b99b961acc9a90$export$c8efe09109f9cb9e({
            h: r,
            s: t.s,
            l: t.l,
            a: t.a
        }) : $34b99b961acc9a90$var$n(t.h);
    }, r.prototype.isEqual = function(r) {
        return this.toHex() === $34b99b961acc9a90$export$c8efe09109f9cb9e(r).toHex();
    }, r;
}(), $34b99b961acc9a90$export$c8efe09109f9cb9e = function(r) {
    return r instanceof $34b99b961acc9a90$export$4d30ed660ff08d0 ? r : new $34b99b961acc9a90$export$4d30ed660ff08d0(r);
}, $34b99b961acc9a90$var$S = [], $34b99b961acc9a90$export$8b58be045bf06082 = function(r) {
    r.forEach(function(r) {
        $34b99b961acc9a90$var$S.indexOf(r) < 0 && (r($34b99b961acc9a90$export$4d30ed660ff08d0, $34b99b961acc9a90$var$y), $34b99b961acc9a90$var$S.push(r));
    });
}, $34b99b961acc9a90$export$4385e60b38654f68 = function() {
    return new $34b99b961acc9a90$export$4d30ed660ff08d0({
        r: 255 * Math.random(),
        g: 255 * Math.random(),
        b: 255 * Math.random()
    });
};

});

parcelRegister("flk9m", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d738a730be80407$export$2e2bcd8739ae039);
function $6d738a730be80407$export$2e2bcd8739ae039(e, f) {
    var a = {
        white: "#ffffff",
        bisque: "#ffe4c4",
        blue: "#0000ff",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        azure: "#f0ffff",
        whitesmoke: "#f5f5f5",
        papayawhip: "#ffefd5",
        plum: "#dda0dd",
        blanchedalmond: "#ffebcd",
        black: "#000000",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gainsboro: "#dcdcdc",
        cornsilk: "#fff8dc",
        cornflowerblue: "#6495ed",
        burlywood: "#deb887",
        aquamarine: "#7fffd4",
        beige: "#f5f5dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkkhaki: "#bdb76b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        peachpuff: "#ffdab9",
        darkmagenta: "#8b008b",
        darkred: "#8b0000",
        darkorchid: "#9932cc",
        darkorange: "#ff8c00",
        darkslateblue: "#483d8b",
        gray: "#808080",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        wheat: "#f5deb3",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        ghostwhite: "#f8f8ff",
        darkviolet: "#9400d3",
        magenta: "#ff00ff",
        green: "#008000",
        dodgerblue: "#1e90ff",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        blueviolet: "#8a2be2",
        forestgreen: "#228b22",
        lawngreen: "#7cfc00",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        fuchsia: "#ff00ff",
        brown: "#a52a2a",
        maroon: "#800000",
        mediumblue: "#0000cd",
        lightcoral: "#f08080",
        darkturquoise: "#00ced1",
        lightcyan: "#e0ffff",
        ivory: "#fffff0",
        lightyellow: "#ffffe0",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        linen: "#faf0e6",
        mediumaquamarine: "#66cdaa",
        lemonchiffon: "#fffacd",
        lime: "#00ff00",
        khaki: "#f0e68c",
        mediumseagreen: "#3cb371",
        limegreen: "#32cd32",
        mediumspringgreen: "#00fa9a",
        lightskyblue: "#87cefa",
        lightblue: "#add8e6",
        midnightblue: "#191970",
        lightpink: "#ffb6c1",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        mintcream: "#f5fffa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        navajowhite: "#ffdead",
        navy: "#000080",
        mediumvioletred: "#c71585",
        powderblue: "#b0e0e6",
        palegoldenrod: "#eee8aa",
        oldlace: "#fdf5e6",
        paleturquoise: "#afeeee",
        mediumturquoise: "#48d1cc",
        mediumorchid: "#ba55d3",
        rebeccapurple: "#663399",
        lightsteelblue: "#b0c4de",
        mediumslateblue: "#7b68ee",
        thistle: "#d8bfd8",
        tan: "#d2b48c",
        orchid: "#da70d6",
        mediumpurple: "#9370db",
        purple: "#800080",
        pink: "#ffc0cb",
        skyblue: "#87ceeb",
        springgreen: "#00ff7f",
        palegreen: "#98fb98",
        red: "#ff0000",
        yellow: "#ffff00",
        slateblue: "#6a5acd",
        lavenderblush: "#fff0f5",
        peru: "#cd853f",
        palevioletred: "#db7093",
        violet: "#ee82ee",
        teal: "#008080",
        slategray: "#708090",
        slategrey: "#708090",
        aliceblue: "#f0f8ff",
        darkseagreen: "#8fbc8f",
        darkolivegreen: "#556b2f",
        greenyellow: "#adff2f",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        tomato: "#ff6347",
        silver: "#c0c0c0",
        sienna: "#a0522d",
        lavender: "#e6e6fa",
        lightgreen: "#90ee90",
        orange: "#ffa500",
        orangered: "#ff4500",
        steelblue: "#4682b4",
        royalblue: "#4169e1",
        turquoise: "#40e0d0",
        yellowgreen: "#9acd32",
        salmon: "#fa8072",
        saddlebrown: "#8b4513",
        sandybrown: "#f4a460",
        rosybrown: "#bc8f8f",
        darksalmon: "#e9967a",
        lightgoldenrodyellow: "#fafad2",
        snow: "#fffafa",
        lightgrey: "#d3d3d3",
        lightgray: "#d3d3d3",
        dimgray: "#696969",
        dimgrey: "#696969",
        olivedrab: "#6b8e23",
        olive: "#808000"
    }, r = {};
    for(var d in a)r[a[d]] = d;
    var l = {};
    e.prototype.toName = function(f) {
        if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
        var d, i, n = r[this.toHex()];
        if (n) return n;
        if (null == f ? void 0 : f.closest) {
            var o = this.toRgb(), t = 1 / 0, b = "black";
            if (!l.length) for(var c in a)l[c] = new e(a[c]).toRgb();
            for(var g in a){
                var u = (d = o, i = l[g], Math.pow(d.r - i.r, 2) + Math.pow(d.g - i.g, 2) + Math.pow(d.b - i.b, 2));
                u < t && (t = u, b = g);
            }
            return b;
        }
    };
    f.string.push([
        function(f) {
            var r = f.toLowerCase(), d = "transparent" === r ? "#0000" : a[r];
            return d ? new e(d).toRgb() : null;
        },
        "name"
    ]);
}

});


parcelRegister("4N8dQ", function(module, exports) {

$parcel$export(module.exports, "cullingMixin", () => $d18339d2de19382b$export$dce76d4f0fd249ed);
"use strict";
const $d18339d2de19382b$export$dce76d4f0fd249ed = {
    cullArea: null,
    cullable: false,
    cullableChildren: true
};

});

parcelRegister("fGITk", function(module, exports) {

$parcel$export(module.exports, "warn", () => $11c1f7229a6a6a73$export$c106dd0671a0fc2d);
"use strict";
let $11c1f7229a6a6a73$var$warnCount = 0;
const $11c1f7229a6a6a73$var$maxWarnings = 500;
function $11c1f7229a6a6a73$export$c106dd0671a0fc2d(...args) {
    if ($11c1f7229a6a6a73$var$warnCount === $11c1f7229a6a6a73$var$maxWarnings) return;
    $11c1f7229a6a6a73$var$warnCount++;
    if ($11c1f7229a6a6a73$var$warnCount === $11c1f7229a6a6a73$var$maxWarnings) console.warn("PixiJS Warning: too many warnings, no more warnings will be reported to the console by PixiJS.");
    else console.warn("PixiJS Warning: ", ...args);
}

});

parcelRegister("2xwDK", function(module, exports) {

$parcel$export(module.exports, "BigPool", () => $2b32afb6cfc5d181$export$8249372279066210);

var $9VJ7s = parcelRequire("9VJ7s");

var $dinEV = parcelRequire("dinEV");
"use strict";
class $2b32afb6cfc5d181$export$866836a21808b71c {
    constructor(){
        /**
     * A map to store the pools by their class type.
     * @private
     */ this._poolsByClass = /* @__PURE__ */ new Map();
    }
    /**
   * Prepopulates a specific pool with a given number of items.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {number} total - The number of items to add to the pool.
   */ prepopulate(Class, total) {
        const classPool = this.getPool(Class);
        classPool.prepopulate(total);
    }
    /**
   * Gets an item from a specific pool.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} Class - The constructor of the items in the pool.
   * @param {unknown} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */ get(Class, data) {
        const pool = this.getPool(Class);
        return pool.get(data);
    }
    /**
   * Returns an item to its respective pool.
   * @param {PoolItem} item - The item to return to the pool.
   */ return(item) {
        const pool = this.getPool(item.constructor);
        pool.return(item);
    }
    /**
   * Gets a specific pool based on the class type.
   * @template T The type of items in the pool. Must extend PoolItem.
   * @param {PoolItemConstructor<T>} ClassType - The constructor of the items in the pool.
   * @returns {Pool<T>} The pool of the given class type.
   */ getPool(ClassType) {
        if (!this._poolsByClass.has(ClassType)) this._poolsByClass.set(ClassType, new (0, $dinEV.Pool)(ClassType));
        return this._poolsByClass.get(ClassType);
    }
    /** gets the usage stats of each pool in the system */ stats() {
        const stats = {};
        this._poolsByClass.forEach((pool)=>{
            const name = stats[pool._classType.name] ? pool._classType.name + pool._classType.ID : pool._classType.name;
            stats[name] = {
                free: pool.totalFree,
                used: pool.totalUsed,
                size: pool.totalSize
            };
        });
        return stats;
    }
    /** Clears all pools in the group. This will reset all pools and free their resources. */ clear() {
        this._poolsByClass.forEach((pool)=>pool.clear());
        this._poolsByClass.clear();
    }
}
const $2b32afb6cfc5d181$export$8249372279066210 = new $2b32afb6cfc5d181$export$866836a21808b71c();
(0, $9VJ7s.GlobalResourceRegistry).register($2b32afb6cfc5d181$export$8249372279066210);

});
parcelRegister("9VJ7s", function(module, exports) {

$parcel$export(module.exports, "GlobalResourceRegistry", () => $30eb1a69dce8590c$export$b2525f5e8e38902b);
"use strict";
const $30eb1a69dce8590c$export$b2525f5e8e38902b = {
    /**
   * Set of registered pools and cleanable objects.
   * @private
   */ _registeredResources: /* @__PURE__ */ new Set(),
    /**
   * Registers a pool or cleanable object for cleanup.
   * @param {Cleanable} pool - The pool or object to register.
   */ register (pool) {
        this._registeredResources.add(pool);
    },
    /**
   * Unregisters a pool or cleanable object from cleanup.
   * @param {Cleanable} pool - The pool or object to unregister.
   */ unregister (pool) {
        this._registeredResources.delete(pool);
    },
    /** Clears all registered pools and cleanable objects. This will call clear() on each registered item. */ release () {
        this._registeredResources.forEach((pool)=>pool.clear());
    },
    /**
   * Gets the number of registered pools and cleanable objects.
   * @returns {number} The count of registered items.
   */ get registeredCount () {
        return this._registeredResources.size;
    },
    /**
   * Checks if a specific pool or cleanable object is registered.
   * @param {Cleanable} pool - The pool or object to check.
   * @returns {boolean} True if the item is registered, false otherwise.
   */ isRegistered (pool) {
        return this._registeredResources.has(pool);
    },
    /**
   * Removes all registrations without clearing the pools.
   * Useful if you want to reset the collector without affecting the pools.
   */ reset () {
        this._registeredResources.clear();
    }
};

});

parcelRegister("dinEV", function(module, exports) {

$parcel$export(module.exports, "Pool", () => $b134521b4a02e790$export$14963ee5c8637e11);
"use strict";
class $b134521b4a02e790$export$14963ee5c8637e11 {
    /**
   * Constructs a new Pool.
   * @param ClassType - The constructor of the items in the pool.
   * @param {number} [initialSize] - The initial size of the pool.
   */ constructor(ClassType, initialSize){
        this._pool = [];
        this._count = 0;
        this._index = 0;
        this._classType = ClassType;
        if (initialSize) this.prepopulate(initialSize);
    }
    /**
   * Prepopulates the pool with a given number of items.
   * @param total - The number of items to add to the pool.
   */ prepopulate(total) {
        for(let i = 0; i < total; i++)this._pool[this._index++] = new this._classType();
        this._count += total;
    }
    /**
   * Gets an item from the pool. Calls the item's `init` method if it exists.
   * If there are no items left in the pool, a new one will be created.
   * @param {I} [data] - Optional data to pass to the item's constructor.
   * @returns {T} The item from the pool.
   */ get(data) {
        let item;
        if (this._index > 0) item = this._pool[--this._index];
        else {
            item = new this._classType();
            this._count++;
        }
        item.init?.(data);
        return item;
    }
    /**
   * Returns an item to the pool. Calls the item's `reset` method if it exists.
   * @param {T} item - The item to return to the pool.
   */ return(item) {
        item.reset?.();
        this._pool[this._index++] = item;
    }
    /**
   * Gets the number of items in the pool.
   * @readonly
   */ get totalSize() {
        return this._count;
    }
    /**
   * Gets the number of items in the pool that are free to use without needing to create more.
   * @readonly
   */ get totalFree() {
        return this._index;
    }
    /**
   * Gets the number of items in the pool that are currently in use.
   * @readonly
   */ get totalUsed() {
        return this._count - this._index;
    }
    /** clears the pool */ clear() {
        if (this._pool.length > 0 && this._pool[0].destroy) for(let i = 0; i < this._index; i++)this._pool[i].destroy();
        this._pool.length = 0;
        this._count = 0;
        this._index = 0;
    }
}

});


parcelRegister("92Flf", function(module, exports) {

$parcel$export(module.exports, "cacheAsTextureMixin", () => $0a27b83528915c63$export$9660f593b1298e75);

var $dXBy0 = parcelRequire("dXBy0");
"use strict";
const $0a27b83528915c63$export$9660f593b1298e75 = {
    get isCachedAsTexture () {
        return !!this.renderGroup?.isCachedAsTexture;
    },
    cacheAsTexture (val1) {
        if (typeof val1 === "boolean" && val1 === false) this.disableRenderGroup();
        else {
            this.enableRenderGroup();
            this.renderGroup.enableCacheAsTexture(val1 === true ? {} : val1);
        }
    },
    updateCacheTexture () {
        this.renderGroup?.updateCacheTexture();
    },
    get cacheAsBitmap () {
        return this.isCachedAsTexture;
    },
    set cacheAsBitmap (val){
        (0, $dXBy0.deprecation)("v8.6.0", "cacheAsBitmap is deprecated, use cacheAsTexture instead.");
        this.cacheAsTexture(val);
    }
};

});

parcelRegister("bCFwy", function(module, exports) {

$parcel$export(module.exports, "childrenHelperMixin", () => $6338b5efc9c23554$export$64cca9f0c2df174a);

var $AOO6Q = parcelRequire("AOO6Q");

var $dXBy0 = parcelRequire("dXBy0");
"use strict";
const $6338b5efc9c23554$export$64cca9f0c2df174a = {
    allowChildren: true,
    removeChildren (beginIndex = 0, endIndex) {
        const end = endIndex ?? this.children.length;
        const range = end - beginIndex;
        const removed = [];
        if (range > 0 && range <= end) {
            for(let i = end - 1; i >= beginIndex; i--){
                const child = this.children[i];
                if (!child) continue;
                removed.push(child);
                child.parent = null;
            }
            (0, $AOO6Q.removeItems)(this.children, beginIndex, end);
            const renderGroup = this.renderGroup || this.parentRenderGroup;
            if (renderGroup) renderGroup.removeChildren(removed);
            for(let i = 0; i < removed.length; ++i){
                const child = removed[i];
                child.parentRenderLayer?.detach(child);
                this.emit("childRemoved", child, this, i);
                removed[i].emit("removed", this);
            }
            if (removed.length > 0) this._didViewChangeTick++;
            return removed;
        } else if (range === 0 && this.children.length === 0) return removed;
        throw new RangeError("removeChildren: numeric values are outside the acceptable range.");
    },
    removeChildAt (index) {
        const child = this.getChildAt(index);
        return this.removeChild(child);
    },
    getChildAt (index) {
        if (index < 0 || index >= this.children.length) throw new Error(`getChildAt: Index (${index}) does not exist.`);
        return this.children[index];
    },
    setChildIndex (child, index) {
        if (index < 0 || index >= this.children.length) throw new Error(`The index ${index} supplied is out of bounds ${this.children.length}`);
        this.getChildIndex(child);
        this.addChildAt(child, index);
    },
    getChildIndex (child) {
        const index = this.children.indexOf(child);
        if (index === -1) throw new Error("The supplied Container must be a child of the caller");
        return index;
    },
    addChildAt (child, index) {
        if (!this.allowChildren) (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "addChildAt: Only Containers will be allowed to add children in v8.0.0");
        const { children: children } = this;
        if (index < 0 || index > children.length) throw new Error(`${child}addChildAt: The index ${index} supplied is out of bounds ${children.length}`);
        const sameParent = child.parent === this;
        if (child.parent) {
            const currentIndex = child.parent.children.indexOf(child);
            if (sameParent) {
                if (currentIndex === index) return child;
                child.parent.children.splice(currentIndex, 1);
            } else child.removeFromParent();
        }
        if (index === children.length) children.push(child);
        else children.splice(index, 0, child);
        child.parent = this;
        child.didChange = true;
        child._updateFlags = 15;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.addChild(child);
        if (this.sortableChildren) this.sortDirty = true;
        if (sameParent) return child;
        this.emit("childAdded", child, this, index);
        child.emit("added", this);
        return child;
    },
    swapChildren (child, child2) {
        if (child === child2) return;
        const index1 = this.getChildIndex(child);
        const index2 = this.getChildIndex(child2);
        this.children[index1] = child2;
        this.children[index2] = child;
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.structureDidChange = true;
        this._didContainerChangeTick++;
    },
    removeFromParent () {
        this.parent?.removeChild(this);
    },
    reparentChild (...child) {
        if (child.length === 1) return this.reparentChildAt(child[0], this.children.length);
        child.forEach((c)=>this.reparentChildAt(c, this.children.length));
        return child[0];
    },
    reparentChildAt (child, index) {
        if (child.parent === this) {
            this.setChildIndex(child, index);
            return child;
        }
        const childMat = child.worldTransform.clone();
        child.removeFromParent();
        this.addChildAt(child, index);
        const newMatrix = this.worldTransform.clone();
        newMatrix.invert();
        childMat.prepend(newMatrix);
        child.setFromMatrix(childMat);
        return child;
    },
    replaceChild (oldChild, newChild) {
        oldChild.updateLocalTransform();
        this.addChildAt(newChild, this.getChildIndex(oldChild));
        newChild.setFromMatrix(oldChild.localTransform);
        newChild.updateLocalTransform();
        this.removeChild(oldChild);
    }
};

});
parcelRegister("AOO6Q", function(module, exports) {

$parcel$export(module.exports, "removeItems", () => $07a6dd78ff5a9d5b$export$8d47c0e1ce445404);
"use strict";
function $07a6dd78ff5a9d5b$export$8d47c0e1ce445404(arr, startIdx, removeCount) {
    const length = arr.length;
    let i;
    if (startIdx >= length || removeCount === 0) return;
    removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    const len = length - removeCount;
    for(i = startIdx; i < len; ++i)arr[i] = arr[i + removeCount];
    arr.length = len;
}

});


parcelRegister("bFfCu", function(module, exports) {

$parcel$export(module.exports, "collectRenderablesMixin", () => $67d687706298d99e$export$e50be97f8cd670d0);
"use strict";
const $67d687706298d99e$export$e50be97f8cd670d0 = {
    collectRenderables (instructionSet, renderer, currentLayer) {
        if (this.parentRenderLayer && this.parentRenderLayer !== currentLayer || this.globalDisplayStatus < 7 || !this.includeInBuild) return;
        if (this.sortableChildren) this.sortChildren();
        if (this.isSimple) this.collectRenderablesSimple(instructionSet, renderer, currentLayer);
        else if (this.renderGroup) renderer.renderPipes.renderGroup.addRenderGroup(this.renderGroup, instructionSet);
        else this.collectRenderablesWithEffects(instructionSet, renderer, currentLayer);
    },
    collectRenderablesSimple (instructionSet, renderer, currentLayer) {
        const children = this.children;
        const length = children.length;
        for(let i = 0; i < length; i++)children[i].collectRenderables(instructionSet, renderer, currentLayer);
    },
    collectRenderablesWithEffects (instructionSet, renderer, currentLayer) {
        const { renderPipes: renderPipes } = renderer;
        for(let i = 0; i < this.effects.length; i++){
            const effect = this.effects[i];
            const pipe = renderPipes[effect.pipe];
            pipe.push(effect, this, instructionSet);
        }
        this.collectRenderablesSimple(instructionSet, renderer, currentLayer);
        for(let i = this.effects.length - 1; i >= 0; i--){
            const effect = this.effects[i];
            const pipe = renderPipes[effect.pipe];
            pipe.pop(effect, this, instructionSet);
        }
    }
};

});

parcelRegister("9VS0a", function(module, exports) {

$parcel$export(module.exports, "effectsMixin", () => $abf073b77d3f5b94$export$eec5e288a9d02a7c);

var $5iRTg = parcelRequire("5iRTg");

var $8PRDF = parcelRequire("8PRDF");
"use strict";
const $abf073b77d3f5b94$export$eec5e288a9d02a7c = {
    _maskEffect: null,
    _maskOptions: {
        inverse: false,
        channel: "red"
    },
    _filterEffect: null,
    effects: [],
    _markStructureAsChanged () {
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (renderGroup) renderGroup.structureDidChange = true;
    },
    addEffect (effect) {
        const index = this.effects.indexOf(effect);
        if (index !== -1) return;
        this.effects.push(effect);
        this.effects.sort((a, b)=>a.priority - b.priority);
        this._markStructureAsChanged();
        this._updateIsSimple();
    },
    removeEffect (effect) {
        const index = this.effects.indexOf(effect);
        if (index === -1) return;
        this.effects.splice(index, 1);
        this._markStructureAsChanged();
        this._updateIsSimple();
    },
    set mask (value){
        const effect = this._maskEffect;
        if (effect?.mask === value) return;
        if (effect) {
            this.removeEffect(effect);
            (0, $8PRDF.MaskEffectManager).returnMaskEffect(effect);
            this._maskEffect = null;
        }
        if (value === null || value === void 0) return;
        this._maskEffect = (0, $8PRDF.MaskEffectManager).getMaskEffect(value);
        this.addEffect(this._maskEffect);
    },
    get mask () {
        return this._maskEffect?.mask;
    },
    setMask (options) {
        this._maskOptions = {
            ...this._maskOptions,
            ...options
        };
        if (options.mask) this.mask = options.mask;
        this._markStructureAsChanged();
    },
    set filters (value){
        if (!Array.isArray(value) && value) value = [
            value
        ];
        const effect = this._filterEffect || (this._filterEffect = new (0, $5iRTg.FilterEffect)());
        value;
        const hasFilters = value?.length > 0;
        const hadFilters = effect.filters?.length > 0;
        const didChange = hasFilters !== hadFilters;
        value = Array.isArray(value) ? value.slice(0) : value;
        effect.filters = Object.freeze(value);
        if (didChange) {
            if (hasFilters) this.addEffect(effect);
            else {
                this.removeEffect(effect);
                effect.filters = value ?? null;
            }
        }
    },
    get filters () {
        return this._filterEffect?.filters;
    },
    set filterArea (value){
        this._filterEffect || (this._filterEffect = new (0, $5iRTg.FilterEffect)());
        this._filterEffect.filterArea = value;
    },
    get filterArea () {
        return this._filterEffect?.filterArea;
    }
};

});
parcelRegister("5iRTg", function(module, exports) {

$parcel$export(module.exports, "FilterEffect", () => $0d74af352cc615af$export$d66c06ffe23037ab);
"use strict";
class $0d74af352cc615af$export$d66c06ffe23037ab {
    constructor(){
        /** the pipe that knows how to handle this effect */ this.pipe = "filter";
        /** the priority of this effect */ this.priority = 1;
    }
    destroy() {
        for(let i = 0; i < this.filters.length; i++)this.filters[i].destroy();
        this.filters = null;
        this.filterArea = null;
    }
}

});

parcelRegister("8PRDF", function(module, exports) {

$parcel$export(module.exports, "MaskEffectManager", () => $63b36473a280ee49$export$1eb319167fe02d04);

var $aBhlC = parcelRequire("aBhlC");

var $2xwDK = parcelRequire("2xwDK");
"use strict";
class $63b36473a280ee49$export$3b0749bf144d4b29 {
    constructor(){
        /** @private */ this._effectClasses = [];
        this._tests = [];
        this._initialized = false;
    }
    init() {
        if (this._initialized) return;
        this._initialized = true;
        this._effectClasses.forEach((test)=>{
            this.add({
                test: test.test,
                maskClass: test
            });
        });
    }
    add(test) {
        this._tests.push(test);
    }
    getMaskEffect(item) {
        if (!this._initialized) this.init();
        for(let i = 0; i < this._tests.length; i++){
            const test = this._tests[i];
            if (test.test(item)) return (0, $2xwDK.BigPool).get(test.maskClass, item);
        }
        return item;
    }
    returnMaskEffect(effect) {
        (0, $2xwDK.BigPool).return(effect);
    }
}
const $63b36473a280ee49$export$1eb319167fe02d04 = new $63b36473a280ee49$export$3b0749bf144d4b29();
(0, $aBhlC.extensions).handleByList((0, $aBhlC.ExtensionType).MaskEffect, $63b36473a280ee49$export$1eb319167fe02d04._effectClasses);

});


parcelRegister("jDZzv", function(module, exports) {

$parcel$export(module.exports, "findMixin", () => $3caf9e9d191d88d9$export$468b0762e1bfbd64);

var $dXBy0 = parcelRequire("dXBy0");
"use strict";
const $3caf9e9d191d88d9$export$468b0762e1bfbd64 = {
    label: null,
    get name () {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "Container.name property has been removed, use Container.label instead");
        return this.label;
    },
    set name (value){
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "Container.name property has been removed, use Container.label instead");
        this.label = value;
    },
    getChildByName (name, deep = false) {
        return this.getChildByLabel(name, deep);
    },
    getChildByLabel (label, deep = false) {
        const children = this.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.label === label || label instanceof RegExp && label.test(child.label)) return child;
        }
        if (deep) for(let i = 0; i < children.length; i++){
            const child = children[i];
            const found = child.getChildByLabel(label, true);
            if (found) return found;
        }
        return null;
    },
    getChildrenByLabel (label, deep = false, out = []) {
        const children = this.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child.label === label || label instanceof RegExp && label.test(child.label)) out.push(child);
        }
        if (deep) for(let i = 0; i < children.length; i++)children[i].getChildrenByLabel(label, true, out);
        return out;
    }
};

});

parcelRegister("kP4Pt", function(module, exports) {

$parcel$export(module.exports, "getFastGlobalBoundsMixin", () => $a677e9ffd330068e$export$993f17c9646405e3);

var $deLbn = parcelRequire("deLbn");

var $eWGg9 = parcelRequire("eWGg9");

var $6heIF = parcelRequire("6heIF");
"use strict";
const $a677e9ffd330068e$var$tempMatrix = new (0, $deLbn.Matrix)();
const $a677e9ffd330068e$export$993f17c9646405e3 = {
    getFastGlobalBounds (factorRenderLayers, bounds) {
        bounds || (bounds = new (0, $eWGg9.Bounds)());
        bounds.clear();
        this._getGlobalBoundsRecursive(!!factorRenderLayers, bounds, this.parentRenderLayer);
        if (!bounds.isValid) bounds.set(0, 0, 0, 0);
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        bounds.applyMatrix(renderGroup.worldTransform);
        return bounds;
    },
    _getGlobalBoundsRecursive (factorRenderLayers, bounds, currentLayer) {
        let localBounds = bounds;
        if (factorRenderLayers && this.parentRenderLayer && this.parentRenderLayer !== currentLayer) return;
        if (this.localDisplayStatus !== 7 || !this.measurable) return;
        const manageEffects = !!this.effects.length;
        if (this.renderGroup || manageEffects) localBounds = (0, $6heIF.boundsPool).get().clear();
        if (this.boundsArea) bounds.addRect(this.boundsArea, this.worldTransform);
        else {
            if (this.renderPipeId) {
                const viewBounds = this.bounds;
                localBounds.addFrame(viewBounds.minX, viewBounds.minY, viewBounds.maxX, viewBounds.maxY, this.groupTransform);
            }
            const children = this.children;
            for(let i = 0; i < children.length; i++)children[i]._getGlobalBoundsRecursive(factorRenderLayers, localBounds, currentLayer);
        }
        if (manageEffects) {
            let advanced = false;
            const renderGroup = this.renderGroup || this.parentRenderGroup;
            for(let i = 0; i < this.effects.length; i++)if (this.effects[i].addBounds) {
                if (!advanced) {
                    advanced = true;
                    localBounds.applyMatrix(renderGroup.worldTransform);
                }
                this.effects[i].addBounds(localBounds, true);
            }
            if (advanced) localBounds.applyMatrix(renderGroup.worldTransform.copyTo($a677e9ffd330068e$var$tempMatrix).invert());
            bounds.addBounds(localBounds);
            (0, $6heIF.boundsPool).return(localBounds);
        } else if (this.renderGroup) {
            bounds.addBounds(localBounds, this.relativeGroupTransform);
            (0, $6heIF.boundsPool).return(localBounds);
        }
    }
};

});
parcelRegister("6heIF", function(module, exports) {

$parcel$export(module.exports, "matrixPool", () => $52dc74666e3176e8$export$3849005ba4dacf72);
$parcel$export(module.exports, "boundsPool", () => $52dc74666e3176e8$export$9194656040c1dc42);

var $deLbn = parcelRequire("deLbn");

var $2xwDK = parcelRequire("2xwDK");

var $eWGg9 = parcelRequire("eWGg9");
"use strict";
const $52dc74666e3176e8$export$3849005ba4dacf72 = (0, $2xwDK.BigPool).getPool((0, $deLbn.Matrix));
const $52dc74666e3176e8$export$9194656040c1dc42 = (0, $2xwDK.BigPool).getPool((0, $eWGg9.Bounds));

});


parcelRegister("dMm4C", function(module, exports) {

$parcel$export(module.exports, "bgr2rgb", () => $730cc7e0820dc9cb$export$110f9f26b10ddb4a);
$parcel$export(module.exports, "getGlobalMixin", () => $730cc7e0820dc9cb$export$c7c22dc0c465d95a);

var $deLbn = parcelRequire("deLbn");

var $kanJL = parcelRequire("kanJL");

var $6heIF = parcelRequire("6heIF");

var $lBE2C = parcelRequire("lBE2C");
"use strict";
function $730cc7e0820dc9cb$export$110f9f26b10ddb4a(color) {
    return ((color & 255) << 16) + (color & 65280) + (color >> 16 & 255);
}
const $730cc7e0820dc9cb$export$c7c22dc0c465d95a = {
    getGlobalAlpha (skipUpdate) {
        if (skipUpdate) {
            if (this.renderGroup) return this.renderGroup.worldAlpha;
            if (this.parentRenderGroup) return this.parentRenderGroup.worldAlpha * this.alpha;
            return this.alpha;
        }
        let alpha = this.alpha;
        let current = this.parent;
        while(current){
            alpha *= current.alpha;
            current = current.parent;
        }
        return alpha;
    },
    getGlobalTransform (matrix = new (0, $deLbn.Matrix)(), skipUpdate) {
        if (skipUpdate) return matrix.copyFrom(this.worldTransform);
        this.updateLocalTransform();
        const parentTransform = (0, $kanJL.updateTransformBackwards)(this, (0, $6heIF.matrixPool).get().identity());
        matrix.appendFrom(this.localTransform, parentTransform);
        (0, $6heIF.matrixPool).return(parentTransform);
        return matrix;
    },
    getGlobalTint (skipUpdate) {
        if (skipUpdate) {
            if (this.renderGroup) return $730cc7e0820dc9cb$export$110f9f26b10ddb4a(this.renderGroup.worldColor);
            if (this.parentRenderGroup) return $730cc7e0820dc9cb$export$110f9f26b10ddb4a((0, $lBE2C.multiplyColors)(this.localColor, this.parentRenderGroup.worldColor));
            return this.tint;
        }
        let color = this.localColor;
        let parent = this.parent;
        while(parent){
            color = (0, $lBE2C.multiplyColors)(color, parent.localColor);
            parent = parent.parent;
        }
        return $730cc7e0820dc9cb$export$110f9f26b10ddb4a(color);
    }
};

});
parcelRegister("kanJL", function(module, exports) {

$parcel$export(module.exports, "getGlobalBounds", () => $348b842d6a8461b4$export$f4412a6981d97baa);
$parcel$export(module.exports, "updateTransformBackwards", () => $348b842d6a8461b4$export$2022bc48a49dd6d2);

var $deLbn = parcelRequire("deLbn");

var $6heIF = parcelRequire("6heIF");
"use strict";
function $348b842d6a8461b4$export$f4412a6981d97baa(target, skipUpdateTransform, bounds) {
    bounds.clear();
    let parentTransform;
    let pooledMatrix;
    if (target.parent) {
        if (!skipUpdateTransform) {
            pooledMatrix = (0, $6heIF.matrixPool).get().identity();
            parentTransform = $348b842d6a8461b4$export$2022bc48a49dd6d2(target, pooledMatrix);
        } else parentTransform = target.parent.worldTransform;
    } else parentTransform = (0, $deLbn.Matrix).IDENTITY;
    $348b842d6a8461b4$var$_getGlobalBounds(target, bounds, parentTransform, skipUpdateTransform);
    if (pooledMatrix) (0, $6heIF.matrixPool).return(pooledMatrix);
    if (!bounds.isValid) bounds.set(0, 0, 0, 0);
    return bounds;
}
function $348b842d6a8461b4$var$_getGlobalBounds(target, bounds, parentTransform, skipUpdateTransform) {
    if (!target.visible || !target.measurable) return;
    let worldTransform;
    if (!skipUpdateTransform) {
        target.updateLocalTransform();
        worldTransform = (0, $6heIF.matrixPool).get();
        worldTransform.appendFrom(target.localTransform, parentTransform);
    } else worldTransform = target.worldTransform;
    const parentBounds = bounds;
    const preserveBounds = !!target.effects.length;
    if (preserveBounds) bounds = (0, $6heIF.boundsPool).get().clear();
    if (target.boundsArea) bounds.addRect(target.boundsArea, worldTransform);
    else {
        const renderableBounds = target.bounds;
        if (renderableBounds && !renderableBounds.isEmpty()) {
            bounds.matrix = worldTransform;
            bounds.addBounds(renderableBounds);
        }
        for(let i = 0; i < target.children.length; i++)$348b842d6a8461b4$var$_getGlobalBounds(target.children[i], bounds, worldTransform, skipUpdateTransform);
    }
    if (preserveBounds) {
        for(let i = 0; i < target.effects.length; i++)target.effects[i].addBounds?.(bounds);
        parentBounds.addBounds(bounds, (0, $deLbn.Matrix).IDENTITY);
        (0, $6heIF.boundsPool).return(bounds);
    }
    if (!skipUpdateTransform) (0, $6heIF.matrixPool).return(worldTransform);
}
function $348b842d6a8461b4$export$2022bc48a49dd6d2(target, parentTransform) {
    const parent = target.parent;
    if (parent) {
        $348b842d6a8461b4$export$2022bc48a49dd6d2(parent, parentTransform);
        parent.updateLocalTransform();
        parentTransform.append(parent.localTransform);
    }
    return parentTransform;
}

});

parcelRegister("lBE2C", function(module, exports) {

$parcel$export(module.exports, "multiplyColors", () => $85e379eb60b9de6d$export$a82a3ae2e3118160);

var $hV5oi = parcelRequire("hV5oi");
"use strict";
const $85e379eb60b9de6d$var$WHITE_BGR = 16777215;
function $85e379eb60b9de6d$export$a82a3ae2e3118160(localBGRColor, parentBGRColor) {
    if (localBGRColor === $85e379eb60b9de6d$var$WHITE_BGR) return parentBGRColor;
    if (parentBGRColor === $85e379eb60b9de6d$var$WHITE_BGR) return localBGRColor;
    return (0, $hV5oi.multiplyHexColors)(localBGRColor, parentBGRColor);
}

});
parcelRegister("hV5oi", function(module, exports) {

$parcel$export(module.exports, "multiplyHexColors", () => $81642e0258cadd83$export$815d7ea0395de72c);
"use strict";
function $81642e0258cadd83$export$815d7ea0395de72c(color1, color2) {
    if (color1 === 16777215 || !color2) return color2;
    if (color2 === 16777215 || !color1) return color1;
    const r1 = color1 >> 16 & 255;
    const g1 = color1 >> 8 & 255;
    const b1 = color1 & 255;
    const r2 = color2 >> 16 & 255;
    const g2 = color2 >> 8 & 255;
    const b2 = color2 & 255;
    const r = r1 * r2 / 255 | 0;
    const g = g1 * g2 / 255 | 0;
    const b = b1 * b2 / 255 | 0;
    return (r << 16) + (g << 8) + b;
}

});



parcelRegister("dDLWo", function(module, exports) {

$parcel$export(module.exports, "measureMixin", () => $c050d4df3cca6b8c$export$285e6e72e8e62f0);

var $deLbn = parcelRequire("deLbn");

var $eWGg9 = parcelRequire("eWGg9");

var $kanJL = parcelRequire("kanJL");

var $lrLlc = parcelRequire("lrLlc");

var $gQQWG = parcelRequire("gQQWG");
"use strict";
const $c050d4df3cca6b8c$var$tempMatrix = new (0, $deLbn.Matrix)();
const $c050d4df3cca6b8c$export$285e6e72e8e62f0 = {
    _localBoundsCacheId: -1,
    _localBoundsCacheData: null,
    _setWidth (value, localWidth) {
        const sign = Math.sign(this.scale.x) || 1;
        if (localWidth !== 0) this.scale.x = value / localWidth * sign;
        else this.scale.x = sign;
    },
    _setHeight (value, localHeight) {
        const sign = Math.sign(this.scale.y) || 1;
        if (localHeight !== 0) this.scale.y = value / localHeight * sign;
        else this.scale.y = sign;
    },
    getLocalBounds () {
        if (!this._localBoundsCacheData) this._localBoundsCacheData = {
            data: [],
            index: 1,
            didChange: false,
            localBounds: new (0, $eWGg9.Bounds)()
        };
        const localBoundsCacheData = this._localBoundsCacheData;
        localBoundsCacheData.index = 1;
        localBoundsCacheData.didChange = false;
        if (localBoundsCacheData.data[0] !== this._didViewChangeTick) {
            localBoundsCacheData.didChange = true;
            localBoundsCacheData.data[0] = this._didViewChangeTick;
        }
        (0, $gQQWG.checkChildrenDidChange)(this, localBoundsCacheData);
        if (localBoundsCacheData.didChange) (0, $lrLlc.getLocalBounds)(this, localBoundsCacheData.localBounds, $c050d4df3cca6b8c$var$tempMatrix);
        return localBoundsCacheData.localBounds;
    },
    getBounds (skipUpdate, bounds) {
        return (0, $kanJL.getGlobalBounds)(this, skipUpdate, bounds || new (0, $eWGg9.Bounds)());
    }
};

});
parcelRegister("lrLlc", function(module, exports) {

$parcel$export(module.exports, "getLocalBounds", () => $84967fbd674c0ae2$export$ffaf4f504c4c5c9c);

var $deLbn = parcelRequire("deLbn");

var $6heIF = parcelRequire("6heIF");
"use strict";
function $84967fbd674c0ae2$export$ffaf4f504c4c5c9c(target, bounds, relativeMatrix) {
    bounds.clear();
    relativeMatrix || (relativeMatrix = (0, $deLbn.Matrix).IDENTITY);
    $84967fbd674c0ae2$var$_getLocalBounds(target, bounds, relativeMatrix, target, true);
    if (!bounds.isValid) bounds.set(0, 0, 0, 0);
    return bounds;
}
function $84967fbd674c0ae2$var$_getLocalBounds(target, bounds, parentTransform, rootContainer, isRoot) {
    let relativeTransform;
    if (!isRoot) {
        if (!target.visible || !target.measurable) return;
        target.updateLocalTransform();
        const localTransform = target.localTransform;
        relativeTransform = (0, $6heIF.matrixPool).get();
        relativeTransform.appendFrom(localTransform, parentTransform);
    } else {
        relativeTransform = (0, $6heIF.matrixPool).get();
        relativeTransform = parentTransform.copyTo(relativeTransform);
    }
    const parentBounds = bounds;
    const preserveBounds = !!target.effects.length;
    if (preserveBounds) bounds = (0, $6heIF.boundsPool).get().clear();
    if (target.boundsArea) bounds.addRect(target.boundsArea, relativeTransform);
    else {
        if (target.renderPipeId) {
            bounds.matrix = relativeTransform;
            bounds.addBounds(target.bounds);
        }
        const children = target.children;
        for(let i = 0; i < children.length; i++)$84967fbd674c0ae2$var$_getLocalBounds(children[i], bounds, relativeTransform, rootContainer, false);
    }
    if (preserveBounds) {
        for(let i = 0; i < target.effects.length; i++)target.effects[i].addLocalBounds?.(bounds, rootContainer);
        parentBounds.addBounds(bounds, (0, $deLbn.Matrix).IDENTITY);
        (0, $6heIF.boundsPool).return(bounds);
    }
    (0, $6heIF.matrixPool).return(relativeTransform);
}

});

parcelRegister("gQQWG", function(module, exports) {

$parcel$export(module.exports, "checkChildrenDidChange", () => $3ae00ed69804834e$export$fd5aadbd3827bcf1);
"use strict";
function $3ae00ed69804834e$export$fd5aadbd3827bcf1(container, previousData) {
    const children = container.children;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        const uid = child.uid;
        const didChange = (child._didViewChangeTick & 65535) << 16 | child._didContainerChangeTick & 65535;
        const index = previousData.index;
        if (previousData.data[index] !== uid || previousData.data[index + 1] !== didChange) {
            previousData.data[previousData.index] = uid;
            previousData.data[previousData.index + 1] = didChange;
            previousData.didChange = true;
        }
        previousData.index = index + 2;
        if (child.children.length) $3ae00ed69804834e$export$fd5aadbd3827bcf1(child, previousData);
    }
    return previousData.didChange;
}

});


parcelRegister("hYre8", function(module, exports) {

$parcel$export(module.exports, "onRenderMixin", () => $8536301568dad1cc$export$2a5246d1114cb81d);
"use strict";
const $8536301568dad1cc$export$2a5246d1114cb81d = {
    _onRender: null,
    set onRender (func){
        const renderGroup = this.renderGroup || this.parentRenderGroup;
        if (!func) {
            if (this._onRender) renderGroup?.removeOnRender(this);
            this._onRender = null;
            return;
        }
        if (!this._onRender) renderGroup?.addOnRender(this);
        this._onRender = func;
    },
    get onRender () {
        return this._onRender;
    }
};

});

parcelRegister("lswM9", function(module, exports) {

$parcel$export(module.exports, "sortMixin", () => $eef2e99d3f61d887$export$eb4acdd9f4781aed);
"use strict";
const $eef2e99d3f61d887$export$eb4acdd9f4781aed = {
    _zIndex: 0,
    sortDirty: false,
    sortableChildren: false,
    get zIndex () {
        return this._zIndex;
    },
    set zIndex (value){
        if (this._zIndex === value) return;
        this._zIndex = value;
        this.depthOfChildModified();
    },
    depthOfChildModified () {
        if (this.parent) {
            this.parent.sortableChildren = true;
            this.parent.sortDirty = true;
        }
        if (this.parentRenderGroup) this.parentRenderGroup.structureDidChange = true;
    },
    sortChildren () {
        if (!this.sortDirty) return;
        this.sortDirty = false;
        this.children.sort($eef2e99d3f61d887$var$sortChildren);
    }
};
function $eef2e99d3f61d887$var$sortChildren(a, b) {
    return a._zIndex - b._zIndex;
}

});

parcelRegister("gIDcH", function(module, exports) {

$parcel$export(module.exports, "toLocalGlobalMixin", () => $0bef78977d6c0796$export$38fa7a987602e8dd);

var $lwGvb = parcelRequire("lwGvb");

var $6heIF = parcelRequire("6heIF");
"use strict";
const $0bef78977d6c0796$export$38fa7a987602e8dd = {
    getGlobalPosition (point = new (0, $lwGvb.Point)(), skipUpdate = false) {
        if (this.parent) this.parent.toGlobal(this._position, point, skipUpdate);
        else {
            point.x = this._position.x;
            point.y = this._position.y;
        }
        return point;
    },
    toGlobal (position, point, skipUpdate = false) {
        const globalMatrix = this.getGlobalTransform((0, $6heIF.matrixPool).get(), skipUpdate);
        point = globalMatrix.apply(position, point);
        (0, $6heIF.matrixPool).return(globalMatrix);
        return point;
    },
    toLocal (position, from, point, skipUpdate) {
        if (from) position = from.toGlobal(position, point, skipUpdate);
        const globalMatrix = this.getGlobalTransform((0, $6heIF.matrixPool).get(), skipUpdate);
        point = globalMatrix.applyInverse(position, point);
        (0, $6heIF.matrixPool).return(globalMatrix);
        return point;
    }
};

});

parcelRegister("3b4bt", function(module, exports) {

$parcel$export(module.exports, "RenderGroup", () => $e089367b78e418c4$export$94d273f8d74f2a5);

var $deLbn = parcelRequire("deLbn");

var $eGbEm = parcelRequire("eGbEm");

var $cOfCf = parcelRequire("cOfCf");
"use strict";
class $e089367b78e418c4$export$94d273f8d74f2a5 {
    constructor(){
        this.renderPipeId = "renderGroup";
        this.root = null;
        this.canBundle = false;
        this.renderGroupParent = null;
        this.renderGroupChildren = [];
        this.worldTransform = new (0, $deLbn.Matrix)();
        this.worldColorAlpha = 4294967295;
        this.worldColor = 16777215;
        this.worldAlpha = 1;
        // these updates are transform changes..
        this.childrenToUpdate = /* @__PURE__ */ Object.create(null);
        this.updateTick = 0;
        this.gcTick = 0;
        // these update are renderable changes..
        this.childrenRenderablesToUpdate = {
            list: [],
            index: 0
        };
        // other
        this.structureDidChange = true;
        this.instructionSet = new (0, $eGbEm.InstructionSet)();
        this._onRenderContainers = [];
        /**
     * Indicates if the cached texture needs to be updated.
     * @default true
     */ this.textureNeedsUpdate = true;
        /**
     * Indicates if the container should be cached as a texture.
     * @default false
     */ this.isCachedAsTexture = false;
        this._matrixDirty = 7;
    }
    init(root) {
        this.root = root;
        if (root._onRender) this.addOnRender(root);
        root.didChange = true;
        const children = root.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            child._updateFlags = 15;
            this.addChild(child);
        }
    }
    enableCacheAsTexture(options = {}) {
        this.textureOptions = options;
        this.isCachedAsTexture = true;
        this.textureNeedsUpdate = true;
    }
    disableCacheAsTexture() {
        this.isCachedAsTexture = false;
        if (this.texture) {
            (0, $cOfCf.TexturePool).returnTexture(this.texture, true);
            this.texture = null;
        }
    }
    updateCacheTexture() {
        this.textureNeedsUpdate = true;
        const cachedParent = this._parentCacheAsTextureRenderGroup;
        if (cachedParent && !cachedParent.textureNeedsUpdate) cachedParent.updateCacheTexture();
    }
    reset() {
        this.renderGroupChildren.length = 0;
        for(const i in this.childrenToUpdate){
            const childrenAtDepth = this.childrenToUpdate[i];
            childrenAtDepth.list.fill(null);
            childrenAtDepth.index = 0;
        }
        this.childrenRenderablesToUpdate.index = 0;
        this.childrenRenderablesToUpdate.list.fill(null);
        this.root = null;
        this.updateTick = 0;
        this.structureDidChange = true;
        this._onRenderContainers.length = 0;
        this.renderGroupParent = null;
        this.disableCacheAsTexture();
    }
    get localTransform() {
        return this.root.localTransform;
    }
    addRenderGroupChild(renderGroupChild) {
        if (renderGroupChild.renderGroupParent) renderGroupChild.renderGroupParent._removeRenderGroupChild(renderGroupChild);
        renderGroupChild.renderGroupParent = this;
        this.renderGroupChildren.push(renderGroupChild);
    }
    _removeRenderGroupChild(renderGroupChild) {
        const index = this.renderGroupChildren.indexOf(renderGroupChild);
        if (index > -1) this.renderGroupChildren.splice(index, 1);
        renderGroupChild.renderGroupParent = null;
    }
    addChild(child) {
        this.structureDidChange = true;
        child.parentRenderGroup = this;
        child.updateTick = -1;
        if (child.parent === this.root) child.relativeRenderGroupDepth = 1;
        else child.relativeRenderGroupDepth = child.parent.relativeRenderGroupDepth + 1;
        child.didChange = true;
        this.onChildUpdate(child);
        if (child.renderGroup) {
            this.addRenderGroupChild(child.renderGroup);
            return;
        }
        if (child._onRender) this.addOnRender(child);
        const children = child.children;
        for(let i = 0; i < children.length; i++)this.addChild(children[i]);
    }
    removeChild(child) {
        this.structureDidChange = true;
        if (child._onRender) {
            if (!child.renderGroup) this.removeOnRender(child);
        }
        child.parentRenderGroup = null;
        if (child.renderGroup) {
            this._removeRenderGroupChild(child.renderGroup);
            return;
        }
        const children = child.children;
        for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
    }
    removeChildren(children) {
        for(let i = 0; i < children.length; i++)this.removeChild(children[i]);
    }
    onChildUpdate(child) {
        let childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth];
        if (!childrenToUpdate) childrenToUpdate = this.childrenToUpdate[child.relativeRenderGroupDepth] = {
            index: 0,
            list: []
        };
        childrenToUpdate.list[childrenToUpdate.index++] = child;
    }
    updateRenderable(renderable) {
        if (renderable.globalDisplayStatus < 7) return;
        this.instructionSet.renderPipes[renderable.renderPipeId].updateRenderable(renderable);
        renderable.didViewUpdate = false;
    }
    onChildViewUpdate(child) {
        this.childrenRenderablesToUpdate.list[this.childrenRenderablesToUpdate.index++] = child;
    }
    get isRenderable() {
        return this.root.localDisplayStatus === 7 && this.worldAlpha > 0;
    }
    /**
   * adding a container to the onRender list will make sure the user function
   * passed in to the user defined 'onRender` callBack
   * @param container - the container to add to the onRender list
   */ addOnRender(container) {
        this._onRenderContainers.push(container);
    }
    removeOnRender(container) {
        this._onRenderContainers.splice(this._onRenderContainers.indexOf(container), 1);
    }
    runOnRender(renderer) {
        for(let i = 0; i < this._onRenderContainers.length; i++)this._onRenderContainers[i]._onRender(renderer);
    }
    destroy() {
        this.disableCacheAsTexture();
        this.renderGroupParent = null;
        this.root = null;
        this.childrenRenderablesToUpdate = null;
        this.childrenToUpdate = null;
        this.renderGroupChildren = null;
        this._onRenderContainers = null;
        this.instructionSet = null;
    }
    getChildren(out = []) {
        const children = this.root.children;
        for(let i = 0; i < children.length; i++)this._getChildren(children[i], out);
        return out;
    }
    _getChildren(container, out = []) {
        out.push(container);
        if (container.renderGroup) return out;
        const children = container.children;
        for(let i = 0; i < children.length; i++)this._getChildren(children[i], out);
        return out;
    }
    invalidateMatrices() {
        this._matrixDirty = 7;
    }
    /**
   * Returns the inverse of the world transform matrix.
   * @returns {Matrix} The inverse of the world transform matrix.
   */ get inverseWorldTransform() {
        if ((this._matrixDirty & 1) === 0) return this._inverseWorldTransform;
        this._matrixDirty &= -2;
        this._inverseWorldTransform || (this._inverseWorldTransform = new (0, $deLbn.Matrix)());
        return this._inverseWorldTransform.copyFrom(this.worldTransform).invert();
    }
    /**
   * Returns the inverse of the texture offset transform matrix.
   * @returns {Matrix} The inverse of the texture offset transform matrix.
   */ get textureOffsetInverseTransform() {
        if ((this._matrixDirty & 2) === 0) return this._textureOffsetInverseTransform;
        this._matrixDirty &= -3;
        this._textureOffsetInverseTransform || (this._textureOffsetInverseTransform = new (0, $deLbn.Matrix)());
        return this._textureOffsetInverseTransform.copyFrom(this.inverseWorldTransform).translate(-this._textureBounds.x, -this._textureBounds.y);
    }
    /**
   * Returns the inverse of the parent texture transform matrix.
   * This is used to properly transform coordinates when rendering into cached textures.
   * @returns {Matrix} The inverse of the parent texture transform matrix.
   */ get inverseParentTextureTransform() {
        if ((this._matrixDirty & 4) === 0) return this._inverseParentTextureTransform;
        this._matrixDirty &= -5;
        const parentCacheAsTexture = this._parentCacheAsTextureRenderGroup;
        if (parentCacheAsTexture) {
            this._inverseParentTextureTransform || (this._inverseParentTextureTransform = new (0, $deLbn.Matrix)());
            return this._inverseParentTextureTransform.copyFrom(this.worldTransform).prepend(parentCacheAsTexture.inverseWorldTransform).translate(-parentCacheAsTexture._textureBounds.x, -parentCacheAsTexture._textureBounds.y);
        }
        return this.worldTransform;
    }
    /**
   * Returns a matrix that transforms coordinates to the correct coordinate space of the texture being rendered to.
   * This is the texture offset inverse transform of the closest parent RenderGroup that is cached as a texture.
   * @returns {Matrix | null} The transform matrix for the cached texture coordinate space,
   * or null if no parent is cached as texture.
   */ get cacheToLocalTransform() {
        if (this.isCachedAsTexture) return this.textureOffsetInverseTransform;
        if (!this._parentCacheAsTextureRenderGroup) return null;
        return this._parentCacheAsTextureRenderGroup.textureOffsetInverseTransform;
    }
}

});
parcelRegister("eGbEm", function(module, exports) {

$parcel$export(module.exports, "InstructionSet", () => $2e589e783dc03a4b$export$2946bd01f10dd922);

var $kfwXR = parcelRequire("kfwXR");
"use strict";
class $2e589e783dc03a4b$export$2946bd01f10dd922 {
    constructor(){
        /** a unique id for this instruction set used through the renderer */ this.uid = (0, $kfwXR.uid)("instructionSet");
        /** the array of instructions */ this.instructions = [];
        /** the actual size of the array (any instructions passed this should be ignored) */ this.instructionSize = 0;
        this.renderables = [];
        /** used by the garbage collector to track when the instruction set was last used */ this.gcTick = 0;
    }
    /** reset the instruction set so it can be reused set size back to 0 */ reset() {
        this.instructionSize = 0;
    }
    /**
   * Destroy the instruction set, clearing the instructions and renderables.
   * @internal
   */ destroy() {
        this.instructions.length = 0;
        this.renderables.length = 0;
        this.renderPipes = null;
        this.gcTick = 0;
    }
    /**
   * Add an instruction to the set
   * @param instruction - add an instruction to the set
   */ add(instruction) {
        this.instructions[this.instructionSize++] = instruction;
    }
    /**
   * Log the instructions to the console (for debugging)
   * @internal
   */ log() {
        this.instructions.length = this.instructionSize;
        console.table(this.instructions, [
            "type",
            "action"
        ]);
    }
}

});

parcelRegister("cOfCf", function(module, exports) {

$parcel$export(module.exports, "TexturePool", () => $b4879ec9c2dfe69b$export$686d8ddcd5ee6cd2);

var $2CXjJ = parcelRequire("2CXjJ");

var $9VJ7s = parcelRequire("9VJ7s");

var $gl1XZ = parcelRequire("gl1XZ");

var $cmH9g = parcelRequire("cmH9g");

var $ju4z4 = parcelRequire("ju4z4");
"use strict";
let $b4879ec9c2dfe69b$var$count = 0;
class $b4879ec9c2dfe69b$export$f5c6a2d8ed21d1d {
    /**
   * @param textureOptions - options that will be passed to BaseRenderTexture constructor
   * @param {SCALE_MODE} [textureOptions.scaleMode] - See {@link SCALE_MODE} for possible values.
   */ constructor(textureOptions){
        this._poolKeyHash = /* @__PURE__ */ Object.create(null);
        this._texturePool = {};
        this.textureOptions = textureOptions || {};
        this.enableFullScreen = false;
        this.textureStyle = new (0, $ju4z4.TextureStyle)(this.textureOptions);
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   * @param antialias
   * @param autoGenerateMipmaps - Whether to automatically generate mipmaps for this texture
   */ createTexture(pixelWidth, pixelHeight, antialias, autoGenerateMipmaps) {
        const textureSource = new (0, $gl1XZ.TextureSource)({
            ...this.textureOptions,
            width: pixelWidth,
            height: pixelHeight,
            resolution: 1,
            antialias: antialias,
            autoGarbageCollect: false,
            autoGenerateMipmaps: autoGenerateMipmaps
        });
        return new (0, $cmH9g.Texture)({
            source: textureSource,
            label: `texturePool_${$b4879ec9c2dfe69b$var$count++}`
        });
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param frameWidth - The minimum width of the render texture.
   * @param frameHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @param antialias
   * @param autoGenerateMipmaps - Whether to automatically generate mipmaps. Defaults to false.
   * @returns The new render texture.
   */ getOptimalTexture(frameWidth, frameHeight, resolution = 1, antialias, autoGenerateMipmaps = false) {
        let po2Width = Math.ceil(frameWidth * resolution - 1e-6);
        let po2Height = Math.ceil(frameHeight * resolution - 1e-6);
        po2Width = (0, $2CXjJ.nextPow2)(po2Width);
        po2Height = (0, $2CXjJ.nextPow2)(po2Height);
        const antialiasFlag = antialias ? 1 : 0;
        const mipmapFlag = autoGenerateMipmaps ? 1 : 0;
        const key = (po2Width << 17) + (po2Height << 2) + (mipmapFlag << 1) + antialiasFlag;
        if (!this._texturePool[key]) this._texturePool[key] = [];
        let texture = this._texturePool[key].pop();
        if (!texture) texture = this.createTexture(po2Width, po2Height, antialias, autoGenerateMipmaps);
        texture.source._resolution = resolution;
        texture.source.width = po2Width / resolution;
        texture.source.height = po2Height / resolution;
        texture.source.pixelWidth = po2Width;
        texture.source.pixelHeight = po2Height;
        texture.frame.x = 0;
        texture.frame.y = 0;
        texture.frame.width = frameWidth;
        texture.frame.height = frameHeight;
        texture.updateUvs();
        this._poolKeyHash[texture.uid] = key;
        return texture;
    }
    /**
   * Gets a pooled texture matching the dimensions and resolution of the given texture.
   *
   * This is a convenience wrapper around {@link TexturePoolClass#getOptimalTexture|getOptimalTexture}
   * that copies width, height, and resolution from an existing texture. Useful when a filter needs
   * a temporary texture the same size as its input (e.g., for multi-pass blur).
   * @param texture - The texture whose dimensions to match.
   * @param antialias - Whether to use antialias on the pooled texture. Defaults to `false`.
   * @returns A pooled texture with power-of-two backing dimensions at the source resolution.
   */ getSameSizeTexture(texture, antialias = false) {
        const source = texture.source;
        return this.getOptimalTexture(texture.width, texture.height, source._resolution, antialias);
    }
    /**
   * Returns a texture to the pool so it can be reused by future
   * {@link TexturePoolClass#getOptimalTexture|getOptimalTexture}
   * or {@link TexturePoolClass#getSameSizeTexture|getSameSizeTexture} calls.
   *
   * If you modified the texture's style after obtaining it (e.g., changed filtering or wrapping),
   * pass `resetStyle = true` to restore the pool's default {@link TexturePoolClass#textureStyle|textureStyle}.
   * This prevents style changes from leaking into subsequent consumers of the same pooled texture.
   * @param renderTexture - The texture to return to the pool.
   * @param resetStyle - When `true`, replaces the texture source's style with the pool default. Defaults to `false`.
   */ returnTexture(renderTexture, resetStyle = false) {
        const key = this._poolKeyHash[renderTexture.uid];
        if (resetStyle) renderTexture.source.style = this.textureStyle;
        this._texturePool[key].push(renderTexture);
    }
    /**
   * Clears the pool.
   * @param destroyTextures - Destroy all stored textures.
   */ clear(destroyTextures) {
        destroyTextures = destroyTextures !== false;
        if (destroyTextures) for(const i in this._texturePool){
            const textures = this._texturePool[i];
            if (textures) for(let j = 0; j < textures.length; j++)textures[j].destroy(true);
        }
        this._texturePool = {};
    }
}
const $b4879ec9c2dfe69b$export$686d8ddcd5ee6cd2 = new $b4879ec9c2dfe69b$export$f5c6a2d8ed21d1d();
(0, $9VJ7s.GlobalResourceRegistry).register($b4879ec9c2dfe69b$export$686d8ddcd5ee6cd2);

});


parcelRegister("c6uH2", function(module, exports) {

$parcel$export(module.exports, "assignWithIgnore", () => $c5c9d82fb4c50726$export$59d0441a278e5935);
"use strict";
function $c5c9d82fb4c50726$export$59d0441a278e5935(target, options, ignore = {}) {
    for(const key in options)if (!ignore[key] && options[key] !== void 0) target[key] = options[key];
}

});




parcelRegister("64Mji", function(module, exports) {

$parcel$export(module.exports, "addMaskBounds", () => $7d599a109fa60b23$export$12af48852c6ac574);

var $eWGg9 = parcelRequire("eWGg9");

var $kanJL = parcelRequire("kanJL");
"use strict";
const $7d599a109fa60b23$var$tempBounds = new (0, $eWGg9.Bounds)();
function $7d599a109fa60b23$export$12af48852c6ac574(mask, bounds, skipUpdateTransform) {
    const boundsToMask = $7d599a109fa60b23$var$tempBounds;
    mask.measurable = true;
    (0, $kanJL.getGlobalBounds)(mask, skipUpdateTransform, boundsToMask);
    bounds.addBoundsMask(boundsToMask);
    mask.measurable = false;
}

});

parcelRegister("dV5cI", function(module, exports) {

$parcel$export(module.exports, "addMaskLocalBounds", () => $feee7cf0a116aaef$export$7416ac774b1f1a33);

var $lrLlc = parcelRequire("lrLlc");

var $6heIF = parcelRequire("6heIF");

var $fGITk = parcelRequire("fGITk");
"use strict";
function $feee7cf0a116aaef$export$7416ac774b1f1a33(mask, bounds, localRoot) {
    const boundsToMask = (0, $6heIF.boundsPool).get();
    mask.measurable = true;
    const tempMatrix = (0, $6heIF.matrixPool).get().identity();
    const relativeMask = $feee7cf0a116aaef$var$getMatrixRelativeToParent(mask, localRoot, tempMatrix);
    (0, $lrLlc.getLocalBounds)(mask, boundsToMask, relativeMask);
    mask.measurable = false;
    bounds.addBoundsMask(boundsToMask);
    (0, $6heIF.matrixPool).return(tempMatrix);
    (0, $6heIF.boundsPool).return(boundsToMask);
}
function $feee7cf0a116aaef$var$getMatrixRelativeToParent(target, root, matrix) {
    if (!target) {
        (0, $fGITk.warn)("Mask bounds, renderable is not inside the root container");
        return matrix;
    }
    if (target !== root) {
        $feee7cf0a116aaef$var$getMatrixRelativeToParent(target.parent, root, matrix);
        target.updateLocalTransform();
        matrix.append(target.localTransform);
    }
    return matrix;
}

});


parcelRegister("acmb2", function(module, exports) {

$parcel$export(module.exports, "ColorMask", () => $560f974c6f160c2e$export$1e2a2c76374c2542);

var $aBhlC = parcelRequire("aBhlC");
"use strict";
class $560f974c6f160c2e$export$1e2a2c76374c2542 {
    constructor(options){
        this.priority = 0;
        this.pipe = "colorMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
    }
    destroy() {}
    static test(mask) {
        return typeof mask === "number";
    }
}
$560f974c6f160c2e$export$1e2a2c76374c2542.extension = (0, $aBhlC.ExtensionType).MaskEffect;

});

parcelRegister("g1oOp", function(module, exports) {

$parcel$export(module.exports, "StencilMask", () => $bcb35750d0659ca0$export$abd85894695764cb);

var $aBhlC = parcelRequire("aBhlC");

var $5Wp7K = parcelRequire("5Wp7K");

var $64Mji = parcelRequire("64Mji");

var $dV5cI = parcelRequire("dV5cI");
"use strict";
class $bcb35750d0659ca0$export$abd85894695764cb {
    constructor(options){
        this.priority = 0;
        this.pipe = "stencilMask";
        if (options?.mask) this.init(options.mask);
    }
    init(mask) {
        this.mask = mask;
        this.mask.includeInBuild = false;
        this.mask.measurable = false;
    }
    reset() {
        if (this.mask === null) return;
        this.mask.measurable = true;
        this.mask.includeInBuild = true;
        this.mask = null;
    }
    addBounds(bounds, skipUpdateTransform) {
        (0, $64Mji.addMaskBounds)(this.mask, bounds, skipUpdateTransform);
    }
    addLocalBounds(bounds, localRoot) {
        (0, $dV5cI.addMaskLocalBounds)(this.mask, bounds, localRoot);
    }
    containsPoint(point, hitTestFn) {
        const mask = this.mask;
        return hitTestFn(mask, point);
    }
    destroy() {
        this.reset();
    }
    static test(mask) {
        return mask instanceof (0, $5Wp7K.Container);
    }
}
$bcb35750d0659ca0$export$abd85894695764cb.extension = (0, $aBhlC.ExtensionType).MaskEffect;

});

parcelRegister("2lEA3", function(module, exports) {

$parcel$export(module.exports, "CanvasSource", () => $73bd720c9e777cdd$export$ca65ccf5708c6a0c);

var $dHliN = parcelRequire("dHliN");

var $aBhlC = parcelRequire("aBhlC");

var $gl1XZ = parcelRequire("gl1XZ");
"use strict";
class $73bd720c9e777cdd$export$ca65ccf5708c6a0c extends (0, $gl1XZ.TextureSource) {
    constructor(options){
        if (!options.resource) options.resource = (0, $dHliN.DOMAdapter).get().createCanvas();
        if (!options.width) {
            options.width = options.resource.width;
            if (!options.autoDensity) options.width /= options.resolution;
        }
        if (!options.height) {
            options.height = options.resource.height;
            if (!options.autoDensity) options.height /= options.resolution;
        }
        super(options);
        this.uploadMethodId = "image";
        this.autoDensity = options.autoDensity;
        this.resizeCanvas();
        this.transparent = !!options.transparent;
    }
    resizeCanvas() {
        if (this.autoDensity && "style" in this.resource) {
            this.resource.style.width = `${this.width}px`;
            this.resource.style.height = `${this.height}px`;
        }
        if (this.resource.width !== this.pixelWidth || this.resource.height !== this.pixelHeight) {
            this.resource.width = this.pixelWidth;
            this.resource.height = this.pixelHeight;
        }
    }
    resize(width = this.width, height = this.height, resolution = this._resolution) {
        const didResize = super.resize(width, height, resolution);
        if (didResize) this.resizeCanvas();
        return didResize;
    }
    static test(resource) {
        return globalThis.HTMLCanvasElement && resource instanceof HTMLCanvasElement || globalThis.OffscreenCanvas && resource instanceof OffscreenCanvas;
    }
    /**
   * Returns the 2D rendering context for the canvas.
   * Caches the context after creating it.
   * @returns The 2D rendering context of the canvas.
   */ get context2D() {
        return this._context2D || (this._context2D = this.resource.getContext("2d"));
    }
}
$73bd720c9e777cdd$export$ca65ccf5708c6a0c.extension = (0, $aBhlC.ExtensionType).TextureSource;

});
parcelRegister("dHliN", function(module, exports) {

$parcel$export(module.exports, "DOMAdapter", () => $a149647124e18cbf$export$d988306fa84f7b44);

var $fVmBW = parcelRequire("fVmBW");
"use strict";
let $a149647124e18cbf$var$currentAdapter = (0, $fVmBW.BrowserAdapter);
const $a149647124e18cbf$export$d988306fa84f7b44 = {
    /**
   * Returns the current adapter.
   * @returns {environment.Adapter} The current adapter.
   */ get () {
        return $a149647124e18cbf$var$currentAdapter;
    },
    /**
   * Sets the current adapter.
   * @param adapter - The new adapter.
   */ set (adapter) {
        $a149647124e18cbf$var$currentAdapter = adapter;
    }
};

});
parcelRegister("fVmBW", function(module, exports) {

$parcel$export(module.exports, "BrowserAdapter", () => $a7da63aaf5c9d7a4$export$e467cc3399500025);
"use strict";
const $a7da63aaf5c9d7a4$export$e467cc3399500025 = {
    createCanvas: (width, height)=>{
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    },
    createImage: ()=>new Image(),
    getCanvasRenderingContext2D: ()=>CanvasRenderingContext2D,
    getWebGLRenderingContext: ()=>WebGLRenderingContext,
    getNavigator: ()=>navigator,
    getBaseUrl: ()=>document.baseURI ?? window.location.href,
    getFontFaceSet: ()=>document.fonts,
    fetch: (url, options)=>fetch(url, options),
    parseXML: (xml)=>{
        const parser = new DOMParser();
        return parser.parseFromString(xml, "text/xml");
    }
};

});



parcelRegister("7xwxM", function(module, exports) {

$parcel$export(module.exports, "ImageSource", () => $e38e2716858a3c7f$export$280e9a68c3ffd919);

var $aBhlC = parcelRequire("aBhlC");

var $gl1XZ = parcelRequire("gl1XZ");
"use strict";
class $e38e2716858a3c7f$export$280e9a68c3ffd919 extends (0, $gl1XZ.TextureSource) {
    constructor(options){
        super(options);
        this.uploadMethodId = "image";
        this.autoGarbageCollect = true;
    }
    static test(resource) {
        return globalThis.HTMLImageElement && resource instanceof HTMLImageElement || typeof ImageBitmap !== "undefined" && resource instanceof ImageBitmap || globalThis.VideoFrame && resource instanceof VideoFrame;
    }
}
$e38e2716858a3c7f$export$280e9a68c3ffd919.extension = (0, $aBhlC.ExtensionType).TextureSource;

});

parcelRegister("jmijm", function(module, exports) {

$parcel$export(module.exports, "VideoSource", () => $a2e0fefdda2c16e1$export$f3a17123d80000c5);

var $aBhlC = parcelRequire("aBhlC");

var $lcv0T = parcelRequire("lcv0T");

var $bcJb6 = parcelRequire("bcJb6");

var $gl1XZ = parcelRequire("gl1XZ");
"use strict";
const $a2e0fefdda2c16e1$var$_VideoSource = class _VideoSource extends (0, $gl1XZ.TextureSource) {
    constructor(options){
        super(options);
        // Public
        /** Whether or not the video is ready to play. */ this.isReady = false;
        /** The upload method for this texture. */ this.uploadMethodId = "video";
        options = {
            ..._VideoSource.defaultOptions,
            ...options
        };
        this._autoUpdate = true;
        this._isConnectedToTicker = false;
        this._updateFPS = options.updateFPS || 0;
        this._msToNextUpdate = 0;
        this.autoPlay = options.autoPlay !== false;
        this.alphaMode = options.alphaMode ?? "premultiply-alpha-on-upload";
        this._videoFrameRequestCallback = this._videoFrameRequestCallback.bind(this);
        this._videoFrameRequestCallbackHandle = null;
        this._load = null;
        this._resolve = null;
        this._reject = null;
        this._onCanPlay = this._onCanPlay.bind(this);
        this._onCanPlayThrough = this._onCanPlayThrough.bind(this);
        this._onError = this._onError.bind(this);
        this._onPlayStart = this._onPlayStart.bind(this);
        this._onPlayStop = this._onPlayStop.bind(this);
        this._onSeeked = this._onSeeked.bind(this);
        this._onLoadedMetadata = this._onLoadedMetadata.bind(this);
        if (options.autoLoad !== false) this.load();
    }
    /** Update the video frame if the source is not destroyed and meets certain conditions. */ updateFrame() {
        if (this.destroyed) return;
        if (this._updateFPS) {
            const elapsedMS = (0, $lcv0T.Ticker).shared.elapsedMS * this.resource.playbackRate;
            this._msToNextUpdate = Math.floor(this._msToNextUpdate - elapsedMS);
        }
        if (!this._updateFPS || this._msToNextUpdate <= 0) this._msToNextUpdate = this._updateFPS ? Math.floor(1e3 / this._updateFPS) : 0;
        if (this.isValid) this.update();
    }
    /** Callback to update the video frame and potentially request the next frame update. */ _videoFrameRequestCallback() {
        this.updateFrame();
        if (this.destroyed) this._videoFrameRequestCallbackHandle = null;
        else this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(this._videoFrameRequestCallback);
    }
    /**
   * Checks if the resource has valid dimensions.
   * @returns {boolean} True if width and height are set, otherwise false.
   */ get isValid() {
        return !!this.resource.videoWidth && !!this.resource.videoHeight;
    }
    /**
   * Start preloading the video resource.
   * @returns {Promise<this>} Handle the validate event
   */ async load() {
        if (this._load) return this._load;
        const source = this.resource;
        const options = this.options;
        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) source.complete = true;
        source.addEventListener("play", this._onPlayStart);
        source.addEventListener("pause", this._onPlayStop);
        source.addEventListener("seeked", this._onSeeked);
        if (!this._isSourceReady()) {
            if (!options.preload) source.addEventListener("canplay", this._onCanPlay);
            source.addEventListener("canplaythrough", this._onCanPlayThrough);
            source.addEventListener("error", this._onError, true);
        } else this._mediaReady();
        if (!this.isValid) source.addEventListener("loadedmetadata", this._onLoadedMetadata);
        this.alphaMode = await (0, $bcJb6.detectVideoAlphaMode)();
        this._load = new Promise((resolve, reject)=>{
            if (this.isValid) resolve(this);
            else {
                this._resolve = resolve;
                this._reject = reject;
                if (options.preloadTimeoutMs !== void 0) this._preloadTimeout = setTimeout(()=>{
                    this._onError(new ErrorEvent(`Preload exceeded timeout of ${options.preloadTimeoutMs}ms`));
                });
                source.load();
            }
        });
        return this._load;
    }
    /**
   * Handle video error events.
   * @param event - The error event
   */ _onError(event) {
        this.resource.removeEventListener("error", this._onError, true);
        this.emit("error", event);
        if (this._reject) {
            this._reject(event);
            this._reject = null;
            this._resolve = null;
        }
    }
    /**
   * Checks if the underlying source is playing.
   * @returns True if playing.
   */ _isSourcePlaying() {
        const source = this.resource;
        return !source.paused && !source.ended;
    }
    /**
   * Checks if the underlying source is ready for playing.
   * @returns True if ready.
   */ _isSourceReady() {
        const source = this.resource;
        return source.readyState > 2;
    }
    /** Runs the update loop when the video is ready to play. */ _onPlayStart() {
        this._configureAutoUpdate();
    }
    /** Stops the update loop when a pause event is triggered. */ _onPlayStop() {
        this._configureAutoUpdate();
    }
    /** Handles behavior when the video completes seeking to the current playback position. */ _onSeeked() {
        if (this._autoUpdate && !this._isSourcePlaying()) {
            this._msToNextUpdate = 0;
            this.updateFrame();
            this._msToNextUpdate = 0;
        }
    }
    /** When intrinsic size becomes known after play / canplay (common with MediaStream). */ _onLoadedMetadata() {
        if (!this.isValid) return;
        this._mediaReady();
    }
    _onCanPlay() {
        const source = this.resource;
        source.removeEventListener("canplay", this._onCanPlay);
        this._mediaReady();
    }
    _onCanPlayThrough() {
        const source = this.resource;
        source.removeEventListener("canplaythrough", this._onCanPlayThrough);
        if (this._preloadTimeout) {
            clearTimeout(this._preloadTimeout);
            this._preloadTimeout = void 0;
        }
        this._mediaReady();
    }
    /** Fired when the video is loaded and ready to play. */ _mediaReady() {
        const source = this.resource;
        if (this.isValid) {
            this.isReady = true;
            this.resize(source.videoWidth, source.videoHeight);
        }
        this._msToNextUpdate = 0;
        this.updateFrame();
        this._msToNextUpdate = 0;
        if (this._resolve && this.isValid) {
            this._resolve(this);
            this._resolve = null;
            this._reject = null;
        }
        if (this._isSourcePlaying()) this._onPlayStart();
        else if (this.autoPlay) this.resource.play();
    }
    /** Cleans up resources and event listeners associated with this texture. */ destroy() {
        this._configureAutoUpdate();
        const source = this.resource;
        if (source) {
            source.removeEventListener("play", this._onPlayStart);
            source.removeEventListener("pause", this._onPlayStop);
            source.removeEventListener("seeked", this._onSeeked);
            source.removeEventListener("canplay", this._onCanPlay);
            source.removeEventListener("canplaythrough", this._onCanPlayThrough);
            source.removeEventListener("loadedmetadata", this._onLoadedMetadata);
            source.removeEventListener("error", this._onError, true);
            source.pause();
            source.src = "";
            source.load();
        }
        super.destroy();
    }
    /** Should the base texture automatically update itself, set to true by default. */ get autoUpdate() {
        return this._autoUpdate;
    }
    set autoUpdate(value) {
        if (value !== this._autoUpdate) {
            this._autoUpdate = value;
            this._configureAutoUpdate();
        }
    }
    /**
   * How many times a second to update the texture from the video.
   * Leave at 0 to update at every render.
   * A lower fps can help performance, as updating the texture at 60fps on a 30ps video may not be efficient.
   */ get updateFPS() {
        return this._updateFPS;
    }
    set updateFPS(value) {
        if (value !== this._updateFPS) {
            this._updateFPS = value;
            this._configureAutoUpdate();
        }
    }
    /**
   * Configures the updating mechanism based on the current state and settings.
   *
   * This method decides between using the browser's native video frame callback or a custom ticker
   * for updating the video frame. It ensures optimal performance and responsiveness
   * based on the video's state, playback status, and the desired frames-per-second setting.
   *
   * - If `_autoUpdate` is enabled and the video source is playing:
   *   - It will prefer the native video frame callback if available and no specific FPS is set.
   *   - Otherwise, it will use a custom ticker for manual updates.
   * - If `_autoUpdate` is disabled or the video isn't playing, any active update mechanisms are halted.
   */ _configureAutoUpdate() {
        if (this._autoUpdate && this._isSourcePlaying()) {
            if (!this._updateFPS && this.resource.requestVideoFrameCallback) {
                if (this._isConnectedToTicker) {
                    (0, $lcv0T.Ticker).shared.remove(this.updateFrame, this);
                    this._isConnectedToTicker = false;
                    this._msToNextUpdate = 0;
                }
                if (this._videoFrameRequestCallbackHandle === null) this._videoFrameRequestCallbackHandle = this.resource.requestVideoFrameCallback(this._videoFrameRequestCallback);
            } else {
                if (this._videoFrameRequestCallbackHandle !== null) {
                    this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
                    this._videoFrameRequestCallbackHandle = null;
                }
                if (!this._isConnectedToTicker) {
                    (0, $lcv0T.Ticker).shared.add(this.updateFrame, this);
                    this._isConnectedToTicker = true;
                    this._msToNextUpdate = 0;
                }
            }
        } else {
            if (this._videoFrameRequestCallbackHandle !== null) {
                this.resource.cancelVideoFrameCallback(this._videoFrameRequestCallbackHandle);
                this._videoFrameRequestCallbackHandle = null;
            }
            if (this._isConnectedToTicker) {
                (0, $lcv0T.Ticker).shared.remove(this.updateFrame, this);
                this._isConnectedToTicker = false;
                this._msToNextUpdate = 0;
            }
        }
    }
    static test(resource) {
        return globalThis.HTMLVideoElement && resource instanceof HTMLVideoElement;
    }
};
$a2e0fefdda2c16e1$var$_VideoSource.extension = (0, $aBhlC.ExtensionType).TextureSource;
/** The default options for video sources. */ $a2e0fefdda2c16e1$var$_VideoSource.defaultOptions = {
    ...(0, $gl1XZ.TextureSource).defaultOptions,
    /** If true, the video will start loading immediately. */ autoLoad: true,
    /** If true, the video will start playing as soon as it is loaded. */ autoPlay: true,
    /** The number of times a second to update the texture from the video. Leave at 0 to update at every render. */ updateFPS: 0,
    /** If true, the video will be loaded with the `crossorigin` attribute. */ crossorigin: true,
    /** If true, the video will loop when it ends. */ loop: false,
    /** If true, the video will be muted. */ muted: true,
    /** If true, the video will play inline. */ playsinline: true,
    /** If true, the video will be preloaded. */ preload: false
};
/**
 * Map of video MIME types that can't be directly derived from file extensions.
 * @readonly
 */ $a2e0fefdda2c16e1$var$_VideoSource.MIME_TYPES = {
    ogv: "video/ogg",
    mov: "video/quicktime",
    m4v: "video/mp4"
};
let $a2e0fefdda2c16e1$export$f3a17123d80000c5 = $a2e0fefdda2c16e1$var$_VideoSource;

});
parcelRegister("lcv0T", function(module, exports) {

$parcel$export(module.exports, "Ticker", () => $646368822c00f70c$export$39c54bcc89dcee11);

var $7iB5e = parcelRequire("7iB5e");

var $3l1i2 = parcelRequire("3l1i2");
"use strict";
const $646368822c00f70c$var$_Ticker = class _Ticker {
    constructor(){
        /**
     * Whether or not this ticker should invoke the method {@link Ticker#start|start}
     * automatically when a listener is added.
     * @example
     * ```ts
     * // Default behavior (manual start)
     * const ticker = new Ticker();
     * ticker.autoStart = false;
     * ticker.add(() => {
     *     // Won't run until ticker.start() is called
     * });
     *
     * // Auto-start behavior
     * const autoTicker = new Ticker();
     * autoTicker.autoStart = true;
     * autoTicker.add(() => {
     *     // Runs immediately when added
     * });
     * ```
     * @default false
     * @see {@link Ticker#start} For manually starting the ticker
     * @see {@link Ticker#stop} For manually stopping the ticker
     */ this.autoStart = false;
        /**
     * Scalar representing the delta time factor.
     * This is a dimensionless value representing the fraction of a frame at the target framerate.
     * At 60 FPS, this value is typically around 1.0.
     *
     * This is NOT in milliseconds - it's a scalar multiplier for frame-independent animations.
     * For actual milliseconds, use {@link Ticker#deltaMS}.
     * @example
     * ```ts
     * // Frame-independent animation using deltaTime scalar
     * ticker.add((ticker) => {
     *     // Rotate sprite by 0.1 radians per frame, scaled by deltaTime
     *     sprite.rotation += 0.1 * ticker.deltaTime;
     * });
     * ```
     */ this.deltaTime = 1;
        /**
     * The last time update was invoked, in milliseconds since epoch.
     * Similar to performance.now() timestamp format.
     *
     * Used internally for calculating time deltas between frames.
     * @example
     * ```ts
     * ticker.add((ticker) => {
     *     const currentTime = performance.now();
     *     const timeSinceLastFrame = currentTime - ticker.lastTime;
     *     console.log(`Time since last frame: ${timeSinceLastFrame}ms`);
     * });
     * ```
     */ this.lastTime = -1;
        /**
     * Factor of current {@link Ticker#deltaTime|deltaTime}.
     * Used to scale time for slow motion or fast-forward effects.
     * @example
     * ```ts
     * // Basic speed adjustment
     * ticker.speed = 0.5; // Half speed (slow motion)
     * ticker.speed = 2.0; // Double speed (fast forward)
     *
     * // Temporary speed changes
     * function slowMotion() {
     *     const normalSpeed = ticker.speed;
     *     ticker.speed = 0.2;
     *     setTimeout(() => {
     *         ticker.speed = normalSpeed;
     *     }, 1000);
     * }
     * ```
     */ this.speed = 1;
        /**
     * Whether or not this ticker has been started.
     *
     * `true` if {@link Ticker#start|start} has been called.
     * `false` if {@link Ticker#stop|Stop} has been called.
     *
     * While `false`, this value may change to `true` in the
     * event of {@link Ticker#autoStart|autoStart} being `true`
     * and a listener is added.
     * @example
     * ```ts
     * // Check ticker state
     * const ticker = new Ticker();
     * console.log(ticker.started); // false
     *
     * // Start and verify
     * ticker.start();
     * console.log(ticker.started); // true
     * ```
     */ this.started = false;
        /** Internal current frame request ID */ this._requestId = null;
        /**
     * Internal value managed by minFPS property setter and getter.
     * This is the maximum allowed milliseconds between updates.
     */ this._maxElapsedMS = 100;
        /**
     * Internal value managed by maxFPS property setter and getter.
     * This is the minimum allowed milliseconds between updates.
     */ this._minElapsedMS = 0;
        /** If enabled, deleting is disabled.*/ this._protected = false;
        /** The last time keyframe was executed. Maintains a relatively fixed interval with the previous value. */ this._lastFrame = -1;
        this._head = new (0, $3l1i2.TickerListener)(null, null, Infinity);
        this.deltaMS = 1 / _Ticker.targetFPMS;
        this.elapsedMS = 1 / _Ticker.targetFPMS;
        this._tick = (time)=>{
            this._requestId = null;
            if (this.started) {
                this.update(time);
                if (this.started && this._requestId === null && this._head.next) this._requestId = requestAnimationFrame(this._tick);
            }
        };
    }
    /**
   * Conditionally requests a new animation frame.
   * If a frame has not already been requested, and if the internal
   * emitter has listeners, a new frame is requested.
   */ _requestIfNeeded() {
        if (this._requestId === null && this._head.next) {
            this.lastTime = performance.now();
            this._lastFrame = this.lastTime;
            this._requestId = requestAnimationFrame(this._tick);
        }
    }
    /** Conditionally cancels a pending animation frame. */ _cancelIfNeeded() {
        if (this._requestId !== null) {
            cancelAnimationFrame(this._requestId);
            this._requestId = null;
        }
    }
    /**
   * Conditionally requests a new animation frame.
   * If the ticker has been started it checks if a frame has not already
   * been requested, and if the internal emitter has listeners. If these
   * conditions are met, a new frame is requested. If the ticker has not
   * been started, but autoStart is `true`, then the ticker starts now,
   * and continues with the previous conditions to request a new frame.
   */ _startIfPossible() {
        if (this.started) this._requestIfNeeded();
        else if (this.autoStart) this.start();
    }
    /**
   * Register a handler for tick events.
   * @param fn - The listener function to add. Receives the Ticker instance as parameter
   * @param context - The context for the listener
   * @param priority - The priority of the listener
   * @example
   * ```ts
   * // Access time properties through the ticker parameter
   * ticker.add((ticker) => {
   *     // Use deltaTime (dimensionless scalar) for frame-independent animations
   *     sprite.rotation += 0.1 * ticker.deltaTime;
   *
   *     // Use deltaMS (milliseconds) for time-based calculations
   *     const progress = ticker.deltaMS / animationDuration;
   *
   *     // Use elapsedMS for raw timing measurements
   *     console.log(`Raw frame time: ${ticker.elapsedMS}ms`);
   * });
   * ```
   */ add(fn, context, priority = (0, $7iB5e.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $3l1i2.TickerListener)(fn, context, priority));
    }
    /**
   * Add a handler for the tick event which is only executed once on the next frame.
   * @example
   * ```ts
   * // Basic one-time update
   * ticker.addOnce(() => {
   *     console.log('Runs next frame only');
   * });
   *
   * // With specific context
   * const game = {
   *     init(ticker) {
   *         this.loadResources();
   *         console.log('Game initialized');
   *     }
   * };
   * ticker.addOnce(game.init, game);
   *
   * // With priority
   * ticker.addOnce(
   *     () => {
   *         // High priority one-time setup
   *         physics.init();
   *     },
   *     undefined,
   *     UPDATE_PRIORITY.HIGH
   * );
   * ```
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting (default: UPDATE_PRIORITY.NORMAL)
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For continuous updates
   * @see {@link Ticker#remove} For removing handlers
   */ addOnce(fn, context, priority = (0, $7iB5e.UPDATE_PRIORITY).NORMAL) {
        return this._addListener(new (0, $3l1i2.TickerListener)(fn, context, priority, true));
    }
    /**
   * Internally adds the event handler so that it can be sorted by priority.
   * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
   * before the rendering.
   * @private
   * @param listener - Current listener being added.
   * @returns This instance of a ticker
   */ _addListener(listener) {
        let current = this._head.next;
        let previous = this._head;
        if (!current) listener.connect(previous);
        else {
            while(current){
                if (listener.priority > current.priority) {
                    listener.connect(previous);
                    break;
                }
                previous = current;
                current = current.next;
            }
            if (!listener.previous) listener.connect(previous);
        }
        this._startIfPossible();
        return this;
    }
    /**
   * Removes any handlers matching the function and context parameters.
   * If no handlers are left after removing, then it cancels the animation frame.
   * @example
   * ```ts
   * // Basic removal
   * const onTick = () => {
   *     sprite.rotation += 0.1;
   * };
   * ticker.add(onTick);
   * ticker.remove(onTick);
   *
   * // Remove with context
   * const game = {
   *     update(ticker) {
   *         this.physics.update(ticker.deltaTime);
   *     }
   * };
   * ticker.add(game.update, game);
   * ticker.remove(game.update, game);
   *
   * // Remove all matching handlers
   * // (if same function was added multiple times)
   * ticker.add(onTick);
   * ticker.add(onTick);
   * ticker.remove(onTick); // Removes all instances
   * ```
   * @param fn - The listener function to be removed
   * @param context - The listener context to be removed
   * @returns This instance of a ticker
   * @see {@link Ticker#add} For adding handlers
   * @see {@link Ticker#addOnce} For one-time handlers
   */ remove(fn, context) {
        let listener = this._head.next;
        while(listener)if (listener.match(fn, context)) listener = listener.destroy();
        else listener = listener.next;
        if (!this._head.next) this._cancelIfNeeded();
        return this;
    }
    /**
   * The number of listeners on this ticker, calculated by walking through linked list.
   * @example
   * ```ts
   * // Check number of active listeners
   * const ticker = new Ticker();
   * console.log(ticker.count); // 0
   *
   * // Add some listeners
   * ticker.add(() => {});
   * ticker.add(() => {});
   * console.log(ticker.count); // 2
   *
   * // Check after cleanup
   * ticker.destroy();
   * console.log(ticker.count); // 0
   * ```
   * @readonly
   * @see {@link Ticker#add} For adding listeners
   * @see {@link Ticker#remove} For removing listeners
   */ get count() {
        if (!this._head) return 0;
        let count = 0;
        let current = this._head;
        while(current = current.next)count++;
        return count;
    }
    /**
   * Starts the ticker. If the ticker has listeners a new animation frame is requested at this point.
   * @example
   * ```ts
   * // Basic manual start
   * const ticker = new Ticker();
   * ticker.add(() => {
   *     // Animation code here
   * });
   * ticker.start();
   * ```
   * @see {@link Ticker#stop} For stopping the ticker
   * @see {@link Ticker#autoStart} For automatic starting
   * @see {@link Ticker#started} For checking ticker state
   */ start() {
        if (!this.started) {
            this.started = true;
            this._requestIfNeeded();
        }
    }
    /**
   * Stops the ticker. If the ticker has requested an animation frame it is canceled at this point.
   * @example
   * ```ts
   * // Basic stop
   * const ticker = new Ticker();
   * ticker.stop();
   * ```
   * @see {@link Ticker#start} For starting the ticker
   * @see {@link Ticker#started} For checking ticker state
   * @see {@link Ticker#destroy} For cleaning up the ticker
   */ stop() {
        if (this.started) {
            this.started = false;
            this._cancelIfNeeded();
        }
    }
    /**
   * Destroy the ticker and don't use after this. Calling this method removes all references to internal events.
   * @example
   * ```ts
   * // Clean up with active listeners
   * const ticker = new Ticker();
   * ticker.add(() => {});
   * ticker.destroy(); // Removes all listeners
   * ```
   * @see {@link Ticker#stop} For stopping without destroying
   * @see {@link Ticker#remove} For removing specific listeners
   */ destroy() {
        if (!this._protected) {
            this.stop();
            let listener = this._head.next;
            while(listener)listener = listener.destroy(true);
            this._head.destroy();
            this._head = null;
        }
    }
    /**
   * Triggers an update.
   *
   * An update entails setting the
   * current {@link Ticker#elapsedMS|elapsedMS},
   * the current {@link Ticker#deltaTime|deltaTime},
   * invoking all listeners with current deltaTime,
   * and then finally setting {@link Ticker#lastTime|lastTime}
   * with the value of currentTime that was provided.
   *
   * This method will be called automatically by animation
   * frame callbacks if the ticker instance has been started
   * and listeners are added.
   * @example
   * ```ts
   * // Basic manual update
   * const ticker = new Ticker();
   * ticker.update(performance.now());
   * ```
   * @param currentTime - The current time of execution (defaults to performance.now())
   * @see {@link Ticker#deltaTime} For frame delta value
   * @see {@link Ticker#elapsedMS} For raw elapsed time
   */ update(currentTime = performance.now()) {
        let elapsedMS;
        if (currentTime > this.lastTime) {
            elapsedMS = this.elapsedMS = currentTime - this.lastTime;
            if (elapsedMS > this._maxElapsedMS) elapsedMS = this._maxElapsedMS;
            elapsedMS *= this.speed;
            if (this._minElapsedMS) {
                const delta = currentTime - this._lastFrame | 0;
                if (delta < this._minElapsedMS) return;
                this._lastFrame = currentTime - delta % this._minElapsedMS;
            }
            this.deltaMS = elapsedMS;
            this.deltaTime = this.deltaMS * _Ticker.targetFPMS;
            const head = this._head;
            let listener = head.next;
            while(listener)listener = listener.emit(this);
            if (!head.next) this._cancelIfNeeded();
        } else this.deltaTime = this.deltaMS = this.elapsedMS = 0;
        this.lastTime = currentTime;
    }
    /**
   * The frames per second at which this ticker is running.
   * The default is approximately 60 in most modern browsers.
   * > [!NOTE] This does not factor in the value of
   * > {@link Ticker#speed|speed}, which is specific
   * > to scaling {@link Ticker#deltaTime|deltaTime}.
   * @example
   * ```ts
   * // Basic FPS monitoring
   * ticker.add(() => {
   *     console.log(`Current FPS: ${Math.round(ticker.FPS)}`);
   * });
   * ```
   * @readonly
   */ get FPS() {
        return 1e3 / this.elapsedMS;
    }
    /**
   * Manages the maximum amount of milliseconds allowed to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This value is used to cap {@link Ticker#deltaTime|deltaTime},
   * but does not effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * When setting this property it is clamped to a value between
   * `0` and `Ticker.targetFPMS * 1000` (typically 60).
   *
   * If `maxFPS` is currently set (non-zero) and `minFPS` is set above it,
   * `maxFPS` is automatically raised to match. This keeps the two limits consistent.
   * @example
   * ```ts
   * // Set minimum acceptable frame rate
   * const ticker = new Ticker();
   * ticker.minFPS = 30; // Never go below 30 FPS
   *
   * // Use with maxFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // minFPS above maxFPS pushes maxFPS up
   * ticker.minFPS = 50; // maxFPS is raised to 50
   * ```
   * @default 10
   */ get minFPS() {
        return 1e3 / this._maxElapsedMS;
    }
    set minFPS(fps) {
        const minFPMS = Math.min(Math.max(0, fps) / 1e3, _Ticker.targetFPMS);
        this._maxElapsedMS = 1 / minFPMS;
        if (this._minElapsedMS && fps > this.maxFPS) this.maxFPS = fps;
    }
    /**
   * Manages the minimum amount of milliseconds required to
   * elapse between invoking {@link Ticker#update|update}.
   *
   * This will effect the measured value of {@link Ticker#FPS|FPS}.
   *
   * If it is set to `0`, then there is no limit; PixiJS will render as many frames as it can.
   * Otherwise it will be at least `minFPS`.
   *
   * If `maxFPS` is set below the current `minFPS`, `minFPS` is automatically lowered to match.
   * This keeps the two limits consistent.
   * @example
   * ```ts
   * // Cap the frame rate
   * const ticker = new Ticker();
   * ticker.maxFPS = 60; // Never go above 60 FPS
   *
   * // Use with minFPS for frame rate clamping
   * ticker.minFPS = 30;
   * ticker.maxFPS = 60;
   *
   * // maxFPS below minFPS pushes minFPS down
   * ticker.maxFPS = 20; // minFPS is now also 20
   * ```
   * @default 0
   */ get maxFPS() {
        if (this._minElapsedMS) return Math.round(1e3 / this._minElapsedMS);
        return 0;
    }
    set maxFPS(fps) {
        if (fps === 0) this._minElapsedMS = 0;
        else {
            if (fps < this.minFPS) this.minFPS = fps;
            this._minElapsedMS = 1 / (fps / 1e3);
        }
    }
    /**
   * The shared ticker instance used by {@link AnimatedSprite} and by
   * {@link VideoSource} to update animation frames / video textures.
   *
   * It may also be used by {@link Application} if created with the `sharedTicker` option property set to true.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * Please follow the examples for usage, including how to opt-out of auto-starting the shared ticker.
   * @example
   * import { Ticker } from 'pixi.js';
   *
   * const ticker = Ticker.shared;
   * // Set this to prevent starting this ticker when listeners are added.
   * // By default this is true only for the Ticker.shared instance.
   * ticker.autoStart = false;
   *
   * // FYI, call this to ensure the ticker is stopped. It should be stopped
   * // if you have not attempted to render anything yet.
   * ticker.stop();
   *
   * // Call this when you are ready for a running shared ticker.
   * ticker.start();
   * @example
   * import { autoDetectRenderer, Container } from 'pixi.js';
   *
   * // You may use the shared ticker to render...
   * const renderer = autoDetectRenderer();
   * const stage = new Container();
   * document.body.appendChild(renderer.view);
   * ticker.add((time) => renderer.render(stage));
   *
   * // Or you can just update it manually.
   * ticker.autoStart = false;
   * ticker.stop();
   * const animate = (time) => {
   *     ticker.update(time);
   *     renderer.render(stage);
   *     requestAnimationFrame(animate);
   * };
   * animate(performance.now());
   * @type {Ticker}
   * @readonly
   */ static get shared() {
        if (!_Ticker._shared) {
            const shared = _Ticker._shared = new _Ticker();
            shared.autoStart = true;
            shared._protected = true;
        }
        return _Ticker._shared;
    }
    /**
   * The system ticker instance used by {@link PrepareBase} for core timing
   * functionality that shouldn't usually need to be paused, unlike the `shared`
   * ticker which drives visual animations and rendering which may want to be paused.
   *
   * The property {@link Ticker#autoStart|autoStart} is set to `true` for this instance.
   * @type {Ticker}
   * @readonly
   * @advanced
   */ static get system() {
        if (!_Ticker._system) {
            const system = _Ticker._system = new _Ticker();
            system.autoStart = true;
            system._protected = true;
        }
        return _Ticker._system;
    }
};
/**
 * Target frame rate in frames per millisecond.
 * Used for converting deltaTime to a scalar time delta.
 * @example
 * ```ts
 * // Default is 0.06 (60 FPS)
 * console.log(Ticker.targetFPMS); // 0.06
 *
 * // Calculate target frame duration
 * const frameDuration = 1 / Ticker.targetFPMS; // ≈ 16.67ms
 *
 * // Use in custom timing calculations
 * const deltaTime = elapsedMS * Ticker.targetFPMS;
 * ```
 * @remarks
 * - Default is 0.06 (equivalent to 60 FPS)
 * - Used in deltaTime calculations
 * - Affects all ticker instances
 * @default 0.06
 * @see {@link Ticker#deltaTime} For time scaling
 * @see {@link Ticker#FPS} For actual frame rate
 */ $646368822c00f70c$var$_Ticker.targetFPMS = 0.06;
let $646368822c00f70c$export$39c54bcc89dcee11 = $646368822c00f70c$var$_Ticker;

});
parcelRegister("7iB5e", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PRIORITY", () => $269b41e614f73fed$export$688aaf132ba9b379);
"use strict";
var $269b41e614f73fed$export$688aaf132ba9b379 = /* @__PURE__ */ ((UPDATE_PRIORITY2)=>{
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["INTERACTION"] = 50] = "INTERACTION";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["HIGH"] = 25] = "HIGH";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["NORMAL"] = 0] = "NORMAL";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["LOW"] = -25] = "LOW";
    UPDATE_PRIORITY2[UPDATE_PRIORITY2["UTILITY"] = -50] = "UTILITY";
    return UPDATE_PRIORITY2;
})($269b41e614f73fed$export$688aaf132ba9b379 || {});

});

parcelRegister("3l1i2", function(module, exports) {

$parcel$export(module.exports, "TickerListener", () => $ef5fc6763620627e$export$579021a5759a260f);
"use strict";
class $ef5fc6763620627e$export$579021a5759a260f {
    /**
   * Constructor
   * @private
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @param priority - The priority for emitting
   * @param once - If the handler should fire once
   */ constructor(fn, context = null, priority = 0, once = false){
        /** The next item in chain. */ this.next = null;
        /** The previous item in chain. */ this.previous = null;
        /** `true` if this listener has been destroyed already. */ this._destroyed = false;
        this._fn = fn;
        this._context = context;
        this.priority = priority;
        this._once = once;
    }
    /**
   * Simple compare function to figure out if a function and context match.
   * @param fn - The listener function to be added for one update
   * @param context - The listener context
   * @returns `true` if the listener match the arguments
   */ match(fn, context = null) {
        return this._fn === fn && this._context === context;
    }
    /**
   * Emit by calling the current function.
   * @param ticker - The ticker emitting.
   * @returns Next ticker
   */ emit(ticker) {
        if (this._fn) {
            if (this._context) this._fn.call(this._context, ticker);
            else this._fn(ticker);
        }
        const redirect = this.next;
        if (this._once) this.destroy(true);
        if (this._destroyed) this.next = null;
        return redirect;
    }
    /**
   * Connect to the list.
   * @param previous - Input node, previous listener
   */ connect(previous) {
        this.previous = previous;
        if (previous.next) previous.next.previous = this;
        this.next = previous.next;
        previous.next = this;
    }
    /**
   * Destroy and don't use after this.
   * @param hard - `true` to remove the `next` reference, this
   *        is considered a hard destroy. Soft destroy maintains the next reference.
   * @returns The listener to redirect while emitting or removing.
   */ destroy(hard = false) {
        this._destroyed = true;
        this._fn = null;
        this._context = null;
        if (this.previous) this.previous.next = this.next;
        if (this.next) this.next.previous = this.previous;
        const redirect = this.next;
        this.next = hard ? null : redirect;
        this.previous = null;
        return redirect;
    }
}

});


parcelRegister("bcJb6", function(module, exports) {

$parcel$export(module.exports, "detectVideoAlphaMode", () => $412fb14ff3278298$export$8df68d58aae31877);

var $dHliN = parcelRequire("dHliN");
"use strict";
let $412fb14ff3278298$var$promise;
async function $412fb14ff3278298$export$8df68d58aae31877() {
    $412fb14ff3278298$var$promise ?? ($412fb14ff3278298$var$promise = (async ()=>{
        const canvas = (0, $dHliN.DOMAdapter).get().createCanvas(1, 1);
        const gl = canvas.getContext("webgl");
        if (!gl) return "premultiply-alpha-on-upload";
        const video = await new Promise((resolve)=>{
            const video2 = document.createElement("video");
            video2.onloadeddata = ()=>resolve(video2);
            video2.onerror = ()=>resolve(null);
            video2.autoplay = false;
            video2.crossOrigin = "anonymous";
            video2.preload = "auto";
            video2.src = "data:video/webm;base64,GkXfo59ChoEBQveBAULygQRC84EIQoKEd2VibUKHgQJChYECGFOAZwEAAAAAAAHTEU2bdLpNu4tTq4QVSalmU6yBoU27i1OrhBZUrmtTrIHGTbuMU6uEElTDZ1OsggEXTbuMU6uEHFO7a1OsggG97AEAAAAAAABZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmoCrXsYMPQkBNgIRMYXZmV0GETGF2ZkSJiEBEAAAAAAAAFlSua8yuAQAAAAAAAEPXgQFzxYgAAAAAAAAAAZyBACK1nIN1bmSIgQCGhVZfVlA5g4EBI+ODhAJiWgDglLCBArqBApqBAlPAgQFVsIRVuYEBElTDZ9Vzc9JjwItjxYgAAAAAAAAAAWfInEWjh0VOQ09ERVJEh49MYXZjIGxpYnZweC12cDlnyKJFo4hEVVJBVElPTkSHlDAwOjAwOjAwLjA0MDAwMDAwMAAAH0O2dcfngQCgwqGggQAAAIJJg0IAABAAFgA4JBwYSgAAICAAEb///4r+AAB1oZ2mm+6BAaWWgkmDQgAAEAAWADgkHBhKAAAgIABIQBxTu2uRu4+zgQC3iveBAfGCAXHwgQM=";
            video2.load();
        });
        if (!video) return "premultiply-alpha-on-upload";
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        const framebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, gl.NONE);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, video);
        const pixel = new Uint8Array(4);
        gl.readPixels(0, 0, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, pixel);
        gl.deleteFramebuffer(framebuffer);
        gl.deleteTexture(texture);
        gl.getExtension("WEBGL_lose_context")?.loseContext();
        return pixel[0] <= pixel[3] ? "premultiplied-alpha" : "premultiply-alpha-on-upload";
    })());
    return $412fb14ff3278298$var$promise;
}

});


parcelRegister("ejgnR", function(module, exports) {

var $gW2Te = parcelRequire("gW2Te");

var $aBhlC = parcelRequire("aBhlC");

var $gl1XZ = parcelRequire("gl1XZ");

var $cmH9g = parcelRequire("cmH9g");
"use strict";
const $d1e8fad913e4eaf1$var$sources = [];
(0, $aBhlC.extensions).handleByList((0, $aBhlC.ExtensionType).TextureSource, $d1e8fad913e4eaf1$var$sources);
function $d1e8fad913e4eaf1$export$688bcf31fbf7eb15(options = {}) {
    return $d1e8fad913e4eaf1$var$textureSourceFrom(options);
}
function $d1e8fad913e4eaf1$var$textureSourceFrom(options = {}) {
    const hasResource = options && options.resource;
    const res = hasResource ? options.resource : options;
    const opts = hasResource ? options : {
        resource: options
    };
    for(let i = 0; i < $d1e8fad913e4eaf1$var$sources.length; i++){
        const Source = $d1e8fad913e4eaf1$var$sources[i];
        if (Source.test(res)) return new Source(opts);
    }
    throw new Error(`Could not find a source type for resource: ${opts.resource}`);
}
function $d1e8fad913e4eaf1$export$3b748ed6327ec85b(options = {}, skipCache = false) {
    const hasResource = options && options.resource;
    const resource = hasResource ? options.resource : options;
    const opts = hasResource ? options : {
        resource: options
    };
    if (!skipCache && (0, $gW2Te.Cache).has(resource)) return (0, $gW2Te.Cache).get(resource);
    const texture = new (0, $cmH9g.Texture)({
        source: $d1e8fad913e4eaf1$var$textureSourceFrom(opts)
    });
    texture.on("destroy", ()=>{
        if ((0, $gW2Te.Cache).has(resource)) (0, $gW2Te.Cache).remove(resource);
    });
    if (!skipCache) (0, $gW2Te.Cache).set(resource, texture);
    return texture;
}
function $d1e8fad913e4eaf1$export$4266177d9730bb1(id, skipCache = false) {
    if (typeof id === "string") return (0, $gW2Te.Cache).get(id);
    else if (id instanceof (0, $gl1XZ.TextureSource)) return new (0, $cmH9g.Texture)({
        source: id
    });
    return $d1e8fad913e4eaf1$export$3b748ed6327ec85b(id, skipCache);
}
(0, $cmH9g.Texture).from = $d1e8fad913e4eaf1$export$4266177d9730bb1;
(0, $gl1XZ.TextureSource).from = $d1e8fad913e4eaf1$var$textureSourceFrom;

});
parcelRegister("gW2Te", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $63d1495415cec30e$export$94affb487e701bf2);

var $fGITk = parcelRequire("fGITk");

var $kzjqQ = parcelRequire("kzjqQ");
"use strict";
class $63d1495415cec30e$var$CacheClass {
    constructor(){
        this._parsers = [];
        this._cache = /* @__PURE__ */ new Map();
        this._cacheMap = /* @__PURE__ */ new Map();
    }
    /** Clear all entries. */ reset() {
        this._cacheMap.clear();
        this._cache.clear();
    }
    /**
   * Check if the key exists
   * @param key - The key to check
   */ has(key) {
        return this._cache.has(key);
    }
    /**
   * Fetch entry by key
   * @param key - The key of the entry to get
   */ get(key) {
        const result = this._cache.get(key);
        if (!result) (0, $fGITk.warn)(`[Assets] Asset id ${key} was not found in the Cache`);
        return result;
    }
    /**
   * Set a value by key or keys name
   * @param key - The key or keys to set
   * @param value - The value to store in the cache or from which cacheable assets will be derived.
   */ set(key, value) {
        const keys = (0, $kzjqQ.convertToList)(key);
        let cacheableAssets;
        for(let i = 0; i < this.parsers.length; i++){
            const parser = this.parsers[i];
            if (parser.test(value)) {
                cacheableAssets = parser.getCacheableAssets(keys, value);
                break;
            }
        }
        const cacheableMap = new Map(Object.entries(cacheableAssets || {}));
        if (!cacheableAssets) keys.forEach((key2)=>{
            cacheableMap.set(key2, value);
        });
        const cacheKeys = [
            ...cacheableMap.keys()
        ];
        const cachedAssets = {
            cacheKeys: cacheKeys,
            keys: keys
        };
        keys.forEach((key2)=>{
            this._cacheMap.set(key2, cachedAssets);
        });
        cacheKeys.forEach((key2)=>{
            const val = cacheableAssets ? cacheableAssets[key2] : value;
            if (this._cache.has(key2) && this._cache.get(key2) !== val) (0, $fGITk.warn)("[Cache] already has key:", key2);
            this._cache.set(key2, cacheableMap.get(key2));
        });
    }
    /**
   * Remove entry by key
   *
   * This function will also remove any associated alias from the cache also.
   * @param key - The key of the entry to remove
   */ remove(key) {
        if (!this._cacheMap.has(key)) {
            (0, $fGITk.warn)(`[Assets] Asset id ${key} was not found in the Cache`);
            return;
        }
        const cacheMap = this._cacheMap.get(key);
        const cacheKeys = cacheMap.cacheKeys;
        cacheKeys.forEach((key2)=>{
            this._cache.delete(key2);
        });
        cacheMap.keys.forEach((key2)=>{
            this._cacheMap.delete(key2);
        });
    }
    /**
   * All loader parsers registered
   * @advanced
   */ get parsers() {
        return this._parsers;
    }
}
const $63d1495415cec30e$export$94affb487e701bf2 = new $63d1495415cec30e$var$CacheClass();

});
parcelRegister("kzjqQ", function(module, exports) {

$parcel$export(module.exports, "convertToList", () => $f4406bd5f2af486a$export$b01be8e180bf3d9b);
"use strict";
const $f4406bd5f2af486a$export$b01be8e180bf3d9b = (input, transform, forceTransform = false)=>{
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!transform) return input;
    return input.map((item)=>{
        if (typeof item === "string" || forceTransform) return transform(item);
        return item;
    });
};

});




parcelRegister("lVjv8", function(module, exports) {

var $aBhlC = parcelRequire("aBhlC");

var $iDzxe = parcelRequire("iDzxe");
"use strict";
(0, $aBhlC.extensions).add((0, $iDzxe.spritesheetAsset));

});
parcelRegister("iDzxe", function(module, exports) {

$parcel$export(module.exports, "spritesheetAsset", () => $a26abe3df362cc12$export$46dcda4f1cdd80fe);

var $c3G86 = parcelRequire("c3G86");

var $jTQFU = parcelRequire("jTQFU");

var $cDUPZ = parcelRequire("cDUPZ");

var $aBhlC = parcelRequire("aBhlC");

var $cmH9g = parcelRequire("cmH9g");

var $iWj4P = parcelRequire("iWj4P");

var $fDJrK = parcelRequire("fDJrK");
"use strict";
const $a26abe3df362cc12$var$validImages = [
    "jpg",
    "png",
    "jpeg",
    "avif",
    "webp",
    "basis",
    "etc2",
    "bc7",
    "bc6h",
    "bc5",
    "bc4",
    "bc3",
    "bc2",
    "bc1",
    "eac",
    "astc"
];
function $a26abe3df362cc12$var$getCacheableAssets(keys, asset, ignoreMultiPack) {
    const out = {};
    keys.forEach((key)=>{
        out[key] = asset;
    });
    Object.keys(asset.textures).forEach((key)=>{
        out[`${asset.cachePrefix}${key}`] = asset.textures[key];
    });
    if (!ignoreMultiPack) {
        const basePath = (0, $iWj4P.path).dirname(keys[0]);
        asset.linkedSheets.forEach((item, i)=>{
            const out2 = $a26abe3df362cc12$var$getCacheableAssets([
                `${basePath}/${asset.data.meta.related_multi_packs[i]}`
            ], item, true);
            Object.assign(out, out2);
        });
    }
    return out;
}
const $a26abe3df362cc12$export$46dcda4f1cdd80fe = {
    extension: (0, $aBhlC.ExtensionType).Asset,
    /** Handle the caching of the related Spritesheet Textures */ cache: {
        test: (asset)=>asset instanceof (0, $fDJrK.Spritesheet),
        getCacheableAssets: (keys, asset)=>$a26abe3df362cc12$var$getCacheableAssets(keys, asset, false)
    },
    /** Resolve the resolution of the asset. */ resolver: {
        extension: {
            type: (0, $aBhlC.ExtensionType).ResolveParser,
            name: "resolveSpritesheet"
        },
        test: (value)=>{
            const tempURL = value.split("?")[0];
            const split = tempURL.split(".");
            const extension = split.pop();
            const format = split.pop();
            return extension === "json" && $a26abe3df362cc12$var$validImages.includes(format);
        },
        parse: (value)=>{
            const split = value.split(".");
            return {
                resolution: parseFloat((0, $jTQFU.Resolver).RETINA_PREFIX.exec(value)?.[1] ?? "1"),
                format: split[split.length - 2],
                src: value
            };
        }
    },
    /**
   * Loader plugin that parses sprite sheets!
   * once the JSON has been loaded this checks to see if the JSON is spritesheet data.
   * If it is, we load the spritesheets image and parse the data into Spritesheet
   * All textures in the sprite sheet are then added to the cache
   */ loader: {
        /** used for deprecation purposes */ name: "spritesheetLoader",
        id: "spritesheet",
        extension: {
            type: (0, $aBhlC.ExtensionType).LoadParser,
            priority: (0, $c3G86.LoaderParserPriority).Normal,
            name: "spritesheetLoader"
        },
        async testParse (asset, options) {
            return (0, $iWj4P.path).extname(options.src).toLowerCase() === ".json" && !!asset.frames;
        },
        async parse (asset, options, loader) {
            const { texture: imageTexture, imageFilename: // if user need to use preloaded texture
            imageFilename, textureOptions: // if user need to use custom filename (not from jsonFile.meta.image)
            textureOptions, cachePrefix: // if user need to set texture options on texture
            cachePrefix } = options?.data ?? {};
            let basePath = (0, $iWj4P.path).dirname(options.src);
            if (basePath && basePath.lastIndexOf("/") !== basePath.length - 1) basePath += "/";
            let texture;
            if (imageTexture instanceof (0, $cmH9g.Texture)) texture = imageTexture;
            else {
                const imagePath = (0, $cDUPZ.copySearchParams)(basePath + (imageFilename ?? asset.meta.image), options.src);
                const assets = await loader.load([
                    {
                        src: imagePath,
                        data: textureOptions
                    }
                ]);
                texture = assets[imagePath];
            }
            const spritesheet = new (0, $fDJrK.Spritesheet)({
                texture: texture.source,
                data: asset,
                cachePrefix: cachePrefix
            });
            await spritesheet.parse();
            const multiPacks = asset?.meta?.related_multi_packs;
            if (Array.isArray(multiPacks)) {
                const promises = [];
                for (const item of multiPacks){
                    if (typeof item !== "string") continue;
                    let itemUrl = basePath + item;
                    if (options.data?.ignoreMultiPack) continue;
                    itemUrl = (0, $cDUPZ.copySearchParams)(itemUrl, options.src);
                    promises.push(loader.load({
                        src: itemUrl,
                        data: {
                            textureOptions: textureOptions,
                            ignoreMultiPack: true
                        }
                    }));
                }
                const res = await Promise.all(promises);
                spritesheet.linkedSheets = res;
                res.forEach((item)=>{
                    item.linkedSheets = [
                        spritesheet
                    ].concat(spritesheet.linkedSheets.filter((sp)=>sp !== item));
                });
            }
            return spritesheet;
        },
        async unload (spritesheet, _resolvedAsset, loader) {
            await loader.unload(spritesheet.textureSource._sourceOrigin);
            spritesheet.destroy(false);
        }
    }
};

});
parcelRegister("c3G86", function(module, exports) {

$parcel$export(module.exports, "LoaderParserPriority", () => $5f64903c66e71fcd$export$820ed6348c4f2750);
"use strict";
var $5f64903c66e71fcd$export$820ed6348c4f2750 = /* @__PURE__ */ ((LoaderParserPriority2)=>{
    LoaderParserPriority2[LoaderParserPriority2["Low"] = 0] = "Low";
    LoaderParserPriority2[LoaderParserPriority2["Normal"] = 1] = "Normal";
    LoaderParserPriority2[LoaderParserPriority2["High"] = 2] = "High";
    return LoaderParserPriority2;
})($5f64903c66e71fcd$export$820ed6348c4f2750 || {});

});

parcelRegister("jTQFU", function(module, exports) {

$parcel$export(module.exports, "Resolver", () => $fe1c3a9fd933cd1b$export$8b4c839865b08288);

var $fGITk = parcelRequire("fGITk");

var $iWj4P = parcelRequire("iWj4P");

var $kzjqQ = parcelRequire("kzjqQ");

var $ePlVq = parcelRequire("ePlVq");

var $7AAK1 = parcelRequire("7AAK1");
"use strict";
class $fe1c3a9fd933cd1b$export$8b4c839865b08288 {
    constructor(){
        this._defaultBundleIdentifierOptions = {
            connector: "-",
            createBundleAssetId: (bundleId, assetId)=>`${bundleId}${this._bundleIdConnector}${assetId}`,
            extractAssetIdFromBundle: (bundleId, assetBundleId)=>assetBundleId.replace(`${bundleId}${this._bundleIdConnector}`, "")
        };
        /** The character that is used to connect the bundleId and the assetId when generating a bundle asset id key */ this._bundleIdConnector = this._defaultBundleIdentifierOptions.connector;
        /**
     * A function that generates a bundle asset id key from a bundleId and an assetId
     * @param bundleId - the bundleId
     * @param assetId  - the assetId
     * @returns the bundle asset id key
     */ this._createBundleAssetId = this._defaultBundleIdentifierOptions.createBundleAssetId;
        /**
     * A function that generates an assetId from a bundle asset id key. This is the reverse of generateBundleAssetId
     * @param bundleId - the bundleId
     * @param assetBundleId - the bundle asset id key
     * @returns the assetId
     */ this._extractAssetIdFromBundle = this._defaultBundleIdentifierOptions.extractAssetIdFromBundle;
        this._assetMap = {};
        this._preferredOrder = [];
        this._parsers = [];
        this._resolverHash = {};
        this._bundles = {};
    }
    /**
   * Override how the resolver deals with generating bundle ids.
   * must be called before any bundles are added
   * @param bundleIdentifier - the bundle identifier options
   */ setBundleIdentifier(bundleIdentifier) {
        this._bundleIdConnector = bundleIdentifier.connector ?? this._bundleIdConnector;
        this._createBundleAssetId = bundleIdentifier.createBundleAssetId ?? this._createBundleAssetId;
        this._extractAssetIdFromBundle = bundleIdentifier.extractAssetIdFromBundle ?? this._extractAssetIdFromBundle;
        if (this._extractAssetIdFromBundle("foo", this._createBundleAssetId("foo", "bar")) !== "bar") throw new Error("[Resolver] GenerateBundleAssetId are not working correctly");
    }
    /**
   * Let the resolver know which assets you prefer to use when resolving assets.
   * Multiple prefer user defined rules can be added.
   * @example
   * resolver.prefer({
   *     // first look for something with the correct format, and then then correct resolution
   *     priority: ['format', 'resolution'],
   *     params:{
   *         format:'webp', // prefer webp images
   *         resolution: 2, // prefer a resolution of 2
   *     }
   * })
   * resolver.add('foo', ['bar@2x.webp', 'bar@2x.png', 'bar.webp', 'bar.png']);
   * resolver.resolveUrl('foo') // => 'bar@2x.webp'
   * @param preferOrders - the prefer options
   */ prefer(...preferOrders) {
        preferOrders.forEach((prefer)=>{
            this._preferredOrder.push(prefer);
            if (!prefer.priority) prefer.priority = Object.keys(prefer.params);
        });
        this._resolverHash = {};
    }
    /**
   * Set the base path to prepend to all urls when resolving
   * @example
   * resolver.basePath = 'https://home.com/';
   * resolver.add('foo', 'bar.ong');
   * resolver.resolveUrl('foo', 'bar.png'); // => 'https://home.com/bar.png'
   * @param basePath - the base path to use
   */ set basePath(basePath) {
        this._basePath = basePath;
    }
    get basePath() {
        return this._basePath;
    }
    /**
   * Set the root path for root-relative URLs. By default the `basePath`'s root is used. If no `basePath` is set, then the
   * default value for browsers is `window.location.origin`
   * @example
   * // Application hosted on https://home.com/some-path/index.html
   * resolver.basePath = 'https://home.com/some-path/';
   * resolver.rootPath = 'https://home.com/';
   * resolver.add('foo', '/bar.png');
   * resolver.resolveUrl('foo', '/bar.png'); // => 'https://home.com/bar.png'
   * @param rootPath - the root path to use
   */ set rootPath(rootPath) {
        this._rootPath = rootPath;
    }
    get rootPath() {
        return this._rootPath;
    }
    /**
   * All the active URL parsers that help the parser to extract information and create
   * an asset object-based on parsing the URL itself.
   *
   * Can be added using the extensions API
   * @example
   * resolver.add('foo', [
   *     {
   *         resolution: 2,
   *         format: 'png',
   *         src: 'image@2x.png',
   *     },
   *     {
   *         resolution:1,
   *         format:'png',
   *         src: 'image.png',
   *     },
   * ]);
   *
   * // With a url parser the information such as resolution and file format could extracted from the url itself:
   * extensions.add({
   *     extension: ExtensionType.ResolveParser,
   *     test: loadTextures.test, // test if url ends in an image
   *     parse: (value: string) =>
   *     ({
   *         resolution: parseFloat(Resolver.RETINA_PREFIX.exec(value)?.[1] ?? '1'),
   *         format: value.split('.').pop(),
   *         src: value,
   *     }),
   * });
   *
   * // Now resolution and format can be extracted from the url
   * resolver.add('foo', [
   *     'image@2x.png',
   *     'image.png',
   * ]);
   */ get parsers() {
        return this._parsers;
    }
    /** Used for testing, this resets the resolver to its initial state */ reset() {
        this.setBundleIdentifier(this._defaultBundleIdentifierOptions);
        this._assetMap = {};
        this._preferredOrder = [];
        this._resolverHash = {};
        this._rootPath = null;
        this._basePath = null;
        this._manifest = null;
        this._bundles = {};
        this._defaultSearchParams = null;
    }
    /**
   * Sets the default URL search parameters for the URL resolver. The urls can be specified as a string or an object.
   * @param searchParams - the default url parameters to append when resolving urls
   */ setDefaultSearchParams(searchParams) {
        if (typeof searchParams === "string") this._defaultSearchParams = searchParams;
        else {
            const queryValues = searchParams;
            this._defaultSearchParams = Object.keys(queryValues).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(queryValues[key])}`).join("&");
        }
    }
    /**
   * Returns the aliases for a given asset
   * @param asset - the asset to get the aliases for
   */ getAlias(asset) {
        const { alias: alias, src: src } = asset;
        const aliasesToUse = (0, $kzjqQ.convertToList)(alias || src, (value)=>{
            if (typeof value === "string") return value;
            if (Array.isArray(value)) return value.map((v)=>v?.src ?? v);
            if (value?.src) return value.src;
            return value;
        }, true);
        return aliasesToUse;
    }
    /**
   * Removes the specified alias for an asset.
   *
   * This only removes the alias mapping. It does **not** remove, unload, or destroy the
   * underlying asset. If the asset is already cached, it stays in memory until you call
   * `Assets.unload`.
   *
   * If `asset` is provided, the alias is only removed when the resolver's current mapping for
   * that alias matches the given `ResolvedAsset`. This lets you avoid accidentally removing an
   * alias that has been reassigned.
   *
   * Silently returns if the alias does not exist or the asset does not match.
   * @param alias - the alias to remove
   * @param asset - only remove the alias if it is currently assigned to this asset
   * @example
   * ```ts
   * resolver.add({ alias: 'hero', src: 'hero.png' });
   *
   * // Simple removal
   * resolver.removeAlias('hero');
   *
   * // Conditional removal — only if alias currently maps to a specific asset
   * const resolved = resolver.resolve('hero');
   * resolver.removeAlias('hero', resolved);
   * ```
   */ removeAlias(alias, asset) {
        if (!this._assetMap[alias]) return;
        if (asset && asset !== this._resolverHash[alias]) return;
        delete this._resolverHash[alias];
        delete this._assetMap[alias];
    }
    /**
   * Add a manifest to the asset resolver. This is a nice way to add all the asset information in one go.
   * generally a manifest would be built using a tool.
   * @param manifest - the manifest to add to the resolver
   */ addManifest(manifest) {
        if (this._manifest) (0, $fGITk.warn)("[Resolver] Manifest already exists, this will be overwritten");
        this._manifest = manifest;
        manifest.bundles.forEach((bundle)=>{
            this.addBundle(bundle.name, bundle.assets);
        });
    }
    /**
   * This adds a bundle of assets in one go so that you can resolve them as a group.
   * For example you could add a bundle for each screen in you pixi app
   * @example
   * resolver.addBundle('animals', [
   *  { alias: 'bunny', src: 'bunny.png' },
   *  { alias: 'chicken', src: 'chicken.png' },
   *  { alias: 'thumper', src: 'thumper.png' },
   * ]);
   * // or
   * resolver.addBundle('animals', {
   *     bunny: 'bunny.png',
   *     chicken: 'chicken.png',
   *     thumper: 'thumper.png',
   * });
   *
   * const resolvedAssets = await resolver.resolveBundle('animals');
   * @param bundleId - The id of the bundle to add
   * @param assets - A record of the asset or assets that will be chosen from when loading via the specified key
   */ addBundle(bundleId, assets) {
        const assetNames = [];
        let convertedAssets = assets;
        if (!Array.isArray(assets)) convertedAssets = Object.entries(assets).map(([alias, src])=>{
            if (typeof src === "string" || Array.isArray(src)) return {
                alias: alias,
                src: src
            };
            return {
                alias: alias,
                ...src
            };
        });
        convertedAssets.forEach((asset)=>{
            const srcs = asset.src;
            const aliases = asset.alias;
            let ids;
            if (typeof aliases === "string") {
                const bundleAssetId = this._createBundleAssetId(bundleId, aliases);
                assetNames.push(bundleAssetId);
                ids = [
                    aliases,
                    bundleAssetId
                ];
            } else {
                const bundleIds = aliases.map((name)=>this._createBundleAssetId(bundleId, name));
                assetNames.push(...bundleIds);
                ids = [
                    ...aliases,
                    ...bundleIds
                ];
            }
            this.add({
                ...asset,
                alias: ids,
                src: srcs
            });
        });
        this._bundles[bundleId] = assetNames;
    }
    /**
   * Tells the resolver what keys are associated with witch asset.
   * The most important thing the resolver does
   * @example
   * // Single key, single asset:
   * resolver.add({alias: 'foo', src: 'bar.png');
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Multiple keys, single asset:
   * resolver.add({alias: ['foo', 'boo'], src: 'bar.png'});
   * resolver.resolveUrl('foo') // => 'bar.png'
   * resolver.resolveUrl('boo') // => 'bar.png'
   *
   * // Multiple keys, multiple assets:
   * resolver.add({alias: ['foo', 'boo'], src: ['bar.png', 'bar.webp']});
   * resolver.resolveUrl('foo') // => 'bar.png'
   *
   * // Add custom data attached to the resolver
   * Resolver.add({
   *     alias: 'bunnyBooBooSmooth',
   *     src: 'bunny{png,webp}',
   *     data: { scaleMode:SCALE_MODES.NEAREST }, // Base texture options
   * });
   *
   * resolver.resolve('bunnyBooBooSmooth') // => { src: 'bunny.png', data: { scaleMode: SCALE_MODES.NEAREST } }
   * @param aliases - the UnresolvedAsset or array of UnresolvedAssets to add to the resolver
   */ add(aliases) {
        const assets = [];
        if (Array.isArray(aliases)) assets.push(...aliases);
        else assets.push(aliases);
        let keyCheck;
        keyCheck = (key)=>{
            if (this.hasKey(key)) (0, $fGITk.warn)(`[Resolver] already has key: ${key} overwriting`);
        };
        const assetArray = (0, $kzjqQ.convertToList)(assets);
        assetArray.forEach((asset)=>{
            const { src: src } = asset;
            let { data: data, format: format, loadParser: userDefinedLoadParser, parser: userDefinedParser } = asset;
            const srcsToUse = (0, $kzjqQ.convertToList)(src).map((src2)=>{
                if (typeof src2 === "string") return (0, $ePlVq.createStringVariations)(src2);
                return Array.isArray(src2) ? src2 : [
                    src2
                ];
            });
            const aliasesToUse = this.getAlias(asset);
            Array.isArray(aliasesToUse) ? aliasesToUse.forEach(keyCheck) : keyCheck(aliasesToUse);
            const resolvedAssets = [];
            const parseUrl = (url)=>{
                const parser = this._parsers.find((p)=>p.test(url));
                return {
                    src: url,
                    ...parser?.parse(url)
                };
            };
            srcsToUse.forEach((srcs)=>{
                srcs.forEach((src2)=>{
                    let formattedAsset = {};
                    if (typeof src2 !== "object") formattedAsset = parseUrl(src2);
                    else {
                        data = src2.data ?? data;
                        format = src2.format ?? format;
                        if (src2.loadParser || src2.parser) {
                            userDefinedLoadParser = src2.loadParser ?? userDefinedLoadParser;
                            userDefinedParser = src2.parser ?? userDefinedParser;
                        }
                        formattedAsset = {
                            ...parseUrl(src2.src),
                            ...src2
                        };
                    }
                    if (!aliasesToUse) throw new Error(`[Resolver] alias is undefined for this asset: ${formattedAsset.src}`);
                    formattedAsset = this._buildResolvedAsset(formattedAsset, {
                        aliases: aliasesToUse,
                        data: data,
                        format: format,
                        loadParser: userDefinedLoadParser,
                        parser: userDefinedParser,
                        progressSize: asset.progressSize
                    });
                    resolvedAssets.push(formattedAsset);
                });
            });
            aliasesToUse.forEach((alias)=>{
                this._assetMap[alias] = resolvedAssets;
            });
        });
    }
    // TODO: this needs an overload like load did in Assets
    /**
   * If the resolver has had a manifest set via setManifest, this will return the assets urls for
   * a given bundleId or bundleIds.
   * @example
   * // Manifest Example
   * const manifest = {
   *     bundles: [
   *         {
   *             name: 'load-screen',
   *             assets: [
   *                 {
   *                     alias: 'background',
   *                     src: 'sunset.png',
   *                 },
   *                 {
   *                     alias: 'bar',
   *                     src: 'load-bar.{png,webp}',
   *                 },
   *             ],
   *         },
   *         {
   *             name: 'game-screen',
   *             assets: [
   *                 {
   *                     alias: 'character',
   *                     src: 'robot.png',
   *                 },
   *                 {
   *                     alias: 'enemy',
   *                     src: 'bad-guy.png',
   *                 },
   *             ],
   *         },
   *     ]
   * };
   *
   * resolver.setManifest(manifest);
   * const resolved = resolver.resolveBundle('load-screen');
   * @param bundleIds - The bundle ids to resolve
   * @returns All the bundles assets or a hash of assets for each bundle specified
   */ resolveBundle(bundleIds) {
        const singleAsset = (0, $7AAK1.isSingleItem)(bundleIds);
        bundleIds = (0, $kzjqQ.convertToList)(bundleIds);
        const out = {};
        bundleIds.forEach((bundleId)=>{
            const assetNames = this._bundles[bundleId];
            if (assetNames) {
                const results = this.resolve(assetNames);
                const assets = {};
                for(const key in results){
                    const asset = results[key];
                    assets[this._extractAssetIdFromBundle(bundleId, key)] = asset;
                }
                out[bundleId] = assets;
            }
        });
        return singleAsset ? out[bundleIds[0]] : out;
    }
    /**
   * Does exactly what resolve does, but returns just the URL rather than the whole asset object
   * @param key - The key or keys to resolve
   * @returns - The URLs associated with the key(s)
   */ resolveUrl(key) {
        const result = this.resolve(key);
        if (typeof key !== "string") {
            const out = {};
            for(const i in result)out[i] = result[i].src;
            return out;
        }
        return result.src;
    }
    resolve(keys) {
        const singleAsset = (0, $7AAK1.isSingleItem)(keys);
        keys = (0, $kzjqQ.convertToList)(keys);
        const result = {};
        keys.forEach((key)=>{
            if (!this._resolverHash[key]) {
                if (this._assetMap[key]) {
                    let assets = this._assetMap[key];
                    const preferredOrder = this._getPreferredOrder(assets);
                    preferredOrder?.priority.forEach((priorityKey)=>{
                        preferredOrder.params[priorityKey].forEach((value)=>{
                            const filteredAssets = assets.filter((asset)=>{
                                if (asset[priorityKey]) return asset[priorityKey] === value;
                                return false;
                            });
                            if (filteredAssets.length) assets = filteredAssets;
                        });
                    });
                    this._resolverHash[key] = assets[0];
                } else this._resolverHash[key] = this._buildResolvedAsset({
                    alias: [
                        key
                    ],
                    src: key
                }, {});
            }
            result[key] = this._resolverHash[key];
        });
        return singleAsset ? result[keys[0]] : result;
    }
    /**
   * Checks if an asset with a given key exists in the resolver
   * @param key - The key of the asset
   */ hasKey(key) {
        return !!this._assetMap[key];
    }
    /**
   * Checks if a bundle with the given key exists in the resolver
   * @param key - The key of the bundle
   */ hasBundle(key) {
        return !!this._bundles[key];
    }
    /**
   * Internal function for figuring out what prefer criteria an asset should use.
   * @param assets
   */ _getPreferredOrder(assets) {
        for(let i = 0; i < assets.length; i++){
            const asset = assets[i];
            const preferred = this._preferredOrder.find((preference)=>preference.params.format.includes(asset.format));
            if (preferred) return preferred;
        }
        return this._preferredOrder[0];
    }
    /**
   * Appends the default url parameters to the url
   * @param url - The url to append the default parameters to
   * @returns - The url with the default parameters appended
   */ _appendDefaultSearchParams(url) {
        if (!this._defaultSearchParams) return url;
        const paramConnector = /\?/.test(url) ? "&" : "?";
        return `${url}${paramConnector}${this._defaultSearchParams}`;
    }
    _buildResolvedAsset(formattedAsset, data) {
        const { aliases: aliases, data: assetData, loadParser: loadParser, parser: parser, format: format, progressSize: progressSize } = data;
        if (this._basePath || this._rootPath) formattedAsset.src = (0, $iWj4P.path).toAbsolute(formattedAsset.src, this._basePath, this._rootPath);
        formattedAsset.alias = aliases ?? formattedAsset.alias ?? [
            formattedAsset.src
        ];
        formattedAsset.src = this._appendDefaultSearchParams(formattedAsset.src);
        formattedAsset.data = {
            ...assetData || {},
            ...formattedAsset.data
        };
        formattedAsset.loadParser = loadParser ?? formattedAsset.loadParser;
        formattedAsset.parser = parser ?? formattedAsset.parser;
        formattedAsset.format = format ?? formattedAsset.format ?? $fe1c3a9fd933cd1b$export$4bb0ea38086a2ed5(formattedAsset.src);
        if (progressSize !== void 0) formattedAsset.progressSize = progressSize;
        return formattedAsset;
    }
}
/**
 * The prefix that denotes a URL is for a retina asset.
 * @default /@([0-9\.]+)x/
 * @example `@2x`
 */ $fe1c3a9fd933cd1b$export$8b4c839865b08288.RETINA_PREFIX = /@([0-9\.]+)x/;
function $fe1c3a9fd933cd1b$export$4bb0ea38086a2ed5(url) {
    return url.split(".").pop().split("?").shift().split("#").shift();
}

});
parcelRegister("iWj4P", function(module, exports) {

$parcel$export(module.exports, "path", () => $1e2b009dc6c83348$export$bb654e07daaf8c3a);

var $dHliN = parcelRequire("dHliN");
"use strict";
function $1e2b009dc6c83348$var$assertPath(path2) {
    if (typeof path2 !== "string") throw new TypeError(`Path must be a string. Received ${JSON.stringify(path2)}`);
}
function $1e2b009dc6c83348$var$removeUrlParams(url) {
    const re = url.split("?")[0];
    return re.split("#")[0];
}
function $1e2b009dc6c83348$var$escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $1e2b009dc6c83348$var$replaceAll(str, find, replace) {
    return str.replace(new RegExp($1e2b009dc6c83348$var$escapeRegExp(find), "g"), replace);
}
function $1e2b009dc6c83348$var$normalizeStringPosix(path2, allowAboveRoot) {
    let res = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let code = -1;
    for(let i = 0; i <= path2.length; ++i){
        if (i < path2.length) code = path2.charCodeAt(i);
        else if (code === 47) break;
        else code = 47;
        if (code === 47) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 || res.charCodeAt(res.length - 2) !== 46) {
                    if (res.length > 2) {
                        const lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += `/${path2.slice(lastSlash + 1, i)}`;
                else res = path2.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
const $1e2b009dc6c83348$export$bb654e07daaf8c3a = {
    /**
   * Converts a path to posix format.
   * @param path - The path to convert to posix
   * @example
   * ```ts
   * // Convert a Windows path to POSIX format
   * path.toPosix('C:\\Users\\User\\Documents\\file.txt');
   * // -> 'C:/Users/User/Documents/file.txt'
   * ```
   */ toPosix (path2) {
        return $1e2b009dc6c83348$var$replaceAll(path2, "\\", "/");
    },
    /**
   * Checks if the path is a URL e.g. http://, https://
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a URL
   * path.isUrl('http://www.example.com');
   * // -> true
   * path.isUrl('C:/Users/User/Documents/file.txt');
   * // -> false
   * ```
   */ isUrl (path2) {
        return /^https?:/.test(this.toPosix(path2));
    },
    /**
   * Checks if the path is a data URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a data URL
   * path.isDataUrl('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA...');
   * // -> true
   * ```
   */ isDataUrl (path2) {
        return /^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()_|~`]+)*)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s<>]*?)$/i.test(path2);
    },
    /**
   * Checks if the path is a blob URL
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path is a blob URL
   * path.isBlobUrl('blob:http://www.example.com/12345678-1234-1234-1234-123456789012');
   * // -> true
   * ```
   */ isBlobUrl (path2) {
        return path2.startsWith("blob:");
    },
    /**
   * Checks if the path has a protocol e.g. http://, https://, file:///, data:, blob:, C:/
   * This will return true for windows file paths
   * @param path - The path to check
   * @example
   * ```ts
   * // Check if a path has a protocol
   * path.hasProtocol('http://www.example.com');
   * // -> true
   * path.hasProtocol('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */ hasProtocol (path2) {
        return /^[^/:]+:/.test(this.toPosix(path2));
    },
    /**
   * Returns the protocol of the path e.g. http://, https://, file:///, data:, blob:, C:/
   * @param path - The path to get the protocol from
   * @example
   * ```ts
   * // Get the protocol from a URL
   * path.getProtocol('http://www.example.com/path/to/resource');
   * // -> 'http://'
   * // Get the protocol from a file path
   * path.getProtocol('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */ getProtocol (path2) {
        $1e2b009dc6c83348$var$assertPath(path2);
        path2 = this.toPosix(path2);
        const matchFile = /^file:\/\/\//.exec(path2);
        if (matchFile) return matchFile[0];
        const matchProtocol = /^[^/:]+:\/{0,2}/.exec(path2);
        if (matchProtocol) return matchProtocol[0];
        return "";
    },
    /**
   * Converts URL to an absolute path.
   * When loading from a Web Worker, we must use absolute paths.
   * If the URL is already absolute we return it as is
   * If it's not, we convert it
   * @param url - The URL to test
   * @param customBaseUrl - The base URL to use
   * @param customRootUrl - The root URL to use
   * @example
   * ```ts
   * // Convert a relative URL to an absolute path
   * path.toAbsolute('images/texture.png', 'http://example.com/assets/');
   * // -> 'http://example.com/assets/images/texture.png'
   * ```
   */ toAbsolute (url, customBaseUrl, customRootUrl) {
        $1e2b009dc6c83348$var$assertPath(url);
        if (this.isDataUrl(url) || this.isBlobUrl(url)) return url;
        const baseUrl = $1e2b009dc6c83348$var$removeUrlParams(this.toPosix(customBaseUrl ?? (0, $dHliN.DOMAdapter).get().getBaseUrl()));
        const rootUrl = $1e2b009dc6c83348$var$removeUrlParams(this.toPosix(customRootUrl ?? this.rootname(baseUrl)));
        url = this.toPosix(url);
        if (url.startsWith("/")) return $1e2b009dc6c83348$export$bb654e07daaf8c3a.join(rootUrl, url.slice(1));
        const absolutePath = this.isAbsolute(url) ? url : this.join(baseUrl, url);
        return absolutePath;
    },
    /**
   * Normalizes the given path, resolving '..' and '.' segments
   * @param path - The path to normalize
   * @example
   * ```ts
   * // Normalize a path with relative segments
   * path.normalize('http://www.example.com/foo/bar/../baz');
   * // -> 'http://www.example.com/foo/baz'
   * // Normalize a file path with relative segments
   * path.normalize('C:\\Users\\User\\Documents\\..\\file.txt');
   * // -> 'C:/Users/User/file.txt'
   * ```
   */ normalize (path2) {
        $1e2b009dc6c83348$var$assertPath(path2);
        if (path2.length === 0) return ".";
        if (this.isDataUrl(path2) || this.isBlobUrl(path2)) return path2;
        path2 = this.toPosix(path2);
        let protocol = "";
        const isAbsolute = path2.startsWith("/");
        if (this.hasProtocol(path2)) {
            protocol = this.rootname(path2);
            path2 = path2.slice(protocol.length);
        }
        const trailingSeparator = path2.endsWith("/");
        path2 = $1e2b009dc6c83348$var$normalizeStringPosix(path2, false);
        if (path2.length > 0 && trailingSeparator) path2 += "/";
        if (isAbsolute) return `/${path2}`;
        return protocol + path2;
    },
    /**
   * Determines if path is an absolute path.
   * Absolute paths can be urls, data urls, or paths on disk
   * @param path - The path to test
   * @example
   * ```ts
   * // Check if a path is absolute
   * path.isAbsolute('http://www.example.com/foo/bar');
   * // -> true
   * path.isAbsolute('C:/Users/User/Documents/file.txt');
   * // -> true
   * ```
   */ isAbsolute (path2) {
        $1e2b009dc6c83348$var$assertPath(path2);
        path2 = this.toPosix(path2);
        if (this.hasProtocol(path2)) return true;
        return path2.startsWith("/");
    },
    /**
   * Joins all given path segments together using the platform-specific separator as a delimiter,
   * then normalizes the resulting path
   * @param segments - The segments of the path to join
   * @example
   * ```ts
   * // Join multiple path segments
   * path.join('assets', 'images', 'sprite.png');
   * // -> 'assets/images/sprite.png'
   * // Join with relative segments
   * path.join('assets', 'images', '../textures', 'sprite.png');
   * // -> 'assets/textures/sprite.png'
   * ```
   */ join (...segments) {
        if (segments.length === 0) return ".";
        let joined;
        for(let i = 0; i < segments.length; ++i){
            const arg = segments[i];
            $1e2b009dc6c83348$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === void 0) joined = arg;
                else {
                    const prevArg = segments[i - 1] ?? "";
                    if (this.joinExtensions.includes(this.extname(prevArg).toLowerCase())) joined += `/../${arg}`;
                    else joined += `/${arg}`;
                }
            }
        }
        if (joined === void 0) return ".";
        return this.normalize(joined);
    },
    /**
   * Returns the directory name of a path
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the directory name of a path
   * path.dirname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/foo/bar'
   * // Get the directory name of a file path
   * path.dirname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/Users/User/Documents'
   * ```
   */ dirname (path2) {
        $1e2b009dc6c83348$var$assertPath(path2);
        if (path2.length === 0) return ".";
        path2 = this.toPosix(path2);
        let code = path2.charCodeAt(0);
        const hasRoot = code === 47;
        let end = -1;
        let matchedSlash = true;
        const proto = this.getProtocol(path2);
        const origpath = path2;
        path2 = path2.slice(proto.length);
        for(let i = path2.length - 1; i >= 1; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : this.isUrl(origpath) ? proto + path2 : proto;
        if (hasRoot && end === 1) return "//";
        return proto + path2.slice(0, end);
    },
    /**
   * Returns the root of the path e.g. /, C:/, file:///, http://domain.com/
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the root of a URL
   * path.rootname('http://www.example.com/foo/bar/baz.png');
   * // -> 'http://www.example.com/'
   * // Get the root of a file path
   * path.rootname('C:/Users/User/Documents/file.txt');
   * // -> 'C:/'
   * ```
   */ rootname (path2) {
        $1e2b009dc6c83348$var$assertPath(path2);
        path2 = this.toPosix(path2);
        let root = "";
        if (path2.startsWith("/")) root = "/";
        else root = this.getProtocol(path2);
        if (this.isUrl(path2)) {
            const index = path2.indexOf("/", root.length);
            if (index !== -1) root = path2.slice(0, index);
            else root = path2;
            if (!root.endsWith("/")) root += "/";
        }
        return root;
    },
    /**
   * Returns the last portion of a path
   * @param path - The path to test
   * @param ext - Optional extension to remove
   * @example
   * ```ts
   * // Get the basename of a URL
   * path.basename('http://www.example.com/foo/bar/baz.png');
   * // -> 'baz.png'
   * // Get the basename of a file path
   * path.basename('C:/Users/User/Documents/file.txt');
   * // -> 'file.txt'
   * ```
   */ basename (path2, ext) {
        $1e2b009dc6c83348$var$assertPath(path2);
        if (ext) $1e2b009dc6c83348$var$assertPath(ext);
        path2 = $1e2b009dc6c83348$var$removeUrlParams(this.toPosix(path2));
        let start = 0;
        let end = -1;
        let matchedSlash = true;
        let i;
        if (ext !== void 0 && ext.length > 0 && ext.length <= path2.length) {
            if (ext.length === path2.length && ext === path2) return "";
            let extIdx = ext.length - 1;
            let firstNonSlashEnd = -1;
            for(i = path2.length - 1; i >= 0; --i){
                const code = path2.charCodeAt(i);
                if (code === 47) {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) end = i;
                        } else {
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path2.length;
            return path2.slice(start, end);
        }
        for(i = path2.length - 1; i >= 0; --i){
            if (path2.charCodeAt(i) === 47) {
                if (!matchedSlash) {
                    start = i + 1;
                    break;
                }
            } else if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
        }
        if (end === -1) return "";
        return path2.slice(start, end);
    },
    /**
   * Returns the extension of the path, from the last occurrence of the . (period) character to end of string in the last
   * portion of the path. If there is no . in the last portion of the path, or if there are no . characters other than
   * the first character of the basename of path, an empty string is returned.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Get the extension of a URL
   * path.extname('http://www.example.com/foo/bar/baz.png');
   * // -> '.png'
   * // Get the extension of a file path
   * path.extname('C:/Users/User/Documents/file.txt');
   * // -> '.txt'
   * ```
   */ extname (path2) {
        $1e2b009dc6c83348$var$assertPath(path2);
        path2 = $1e2b009dc6c83348$var$removeUrlParams(this.toPosix(path2));
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let preDotState = 0;
        for(let i = path2.length - 1; i >= 0; --i){
            const code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path2.slice(startDot, end);
    },
    /**
   * Parses a path into an object containing the 'root', `dir`, `base`, `ext`, and `name` properties.
   * @param path - The path to parse
   * @example
   * ```ts
   * // Parse a URL
   * const parsed = path.parse('http://www.example.com/foo/bar/baz.png');
   * // -> {
   * //   root: 'http://www.example.com/',
   * //   dir: 'http://www.example.com/foo/bar',
   * //   base: 'baz.png',
   * //   ext: '.png',
   * //   name: 'baz'
   * // }
   * // Parse a file path
   * const parsedFile = path.parse('C:/Users/User/Documents/file.txt');
   * // -> {
   * //   root: 'C:/',
   * //   dir: 'C:/Users/User/Documents',
   * //   base: 'file.txt',
   * //   ext: '.txt',
   * //   name: 'file'
   * // }
   * ```
   */ parse (path2) {
        $1e2b009dc6c83348$var$assertPath(path2);
        const ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path2.length === 0) return ret;
        path2 = $1e2b009dc6c83348$var$removeUrlParams(this.toPosix(path2));
        let code = path2.charCodeAt(0);
        const isAbsolute = this.isAbsolute(path2);
        let start;
        const protocol = "";
        ret.root = this.rootname(path2);
        if (isAbsolute || this.hasProtocol(path2)) start = 1;
        else start = 0;
        let startDot = -1;
        let startPart = 0;
        let end = -1;
        let matchedSlash = true;
        let i = path2.length - 1;
        let preDotState = 0;
        for(; i >= start; --i){
            code = path2.charCodeAt(i);
            if (code === 47) {
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46) {
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) preDotState = -1;
        }
        if (startDot === -1 || end === -1 || preDotState === 0 || preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path2.slice(1, end);
                else ret.base = ret.name = path2.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path2.slice(1, startDot);
                ret.base = path2.slice(1, end);
            } else {
                ret.name = path2.slice(startPart, startDot);
                ret.base = path2.slice(startPart, end);
            }
            ret.ext = path2.slice(startDot, end);
        }
        ret.dir = this.dirname(path2);
        if (protocol) ret.dir = protocol + ret.dir;
        return ret;
    },
    sep: "/",
    delimiter: ":",
    joinExtensions: [
        ".html"
    ]
};

});

parcelRegister("ePlVq", function(module, exports) {

$parcel$export(module.exports, "createStringVariations", () => $45656caeca6f4b5f$export$738117acc6638004);
"use strict";
function $45656caeca6f4b5f$var$processX(base, ids, depth, result, tags) {
    const id = ids[depth];
    for(let i = 0; i < id.length; i++){
        const value = id[i];
        if (depth < ids.length - 1) $45656caeca6f4b5f$var$processX(base.replace(result[depth], value), ids, depth + 1, result, tags);
        else tags.push(base.replace(result[depth], value));
    }
}
function $45656caeca6f4b5f$export$738117acc6638004(string) {
    const regex = /\{(.*?)\}/g;
    const result = string.match(regex);
    const tags = [];
    if (result) {
        const ids = [];
        result.forEach((vars)=>{
            const split = vars.substring(1, vars.length - 1).split(",");
            ids.push(split);
        });
        $45656caeca6f4b5f$var$processX(string, ids, 0, result, tags);
    } else tags.push(string);
    return tags;
}

});

parcelRegister("7AAK1", function(module, exports) {

$parcel$export(module.exports, "isSingleItem", () => $88fc2c961510d31c$export$16a80d27953452d4);
"use strict";
const $88fc2c961510d31c$export$16a80d27953452d4 = (item)=>!Array.isArray(item);

});


parcelRegister("cDUPZ", function(module, exports) {

$parcel$export(module.exports, "copySearchParams", () => $fabfa845f1871d9d$export$f57b97ef8be10dda);
"use strict";
const $fabfa845f1871d9d$export$f57b97ef8be10dda = (targetUrl, sourceUrl)=>{
    const searchParams = sourceUrl.split("?")[1];
    if (searchParams) targetUrl += `?${searchParams}`;
    return targetUrl;
};

});

parcelRegister("fDJrK", function(module, exports) {

$parcel$export(module.exports, "Spritesheet", () => $c04401f8735caebe$export$674d2eb4debbef0c);

var $kNl9L = parcelRequire("kNl9L");

var $gl1XZ = parcelRequire("gl1XZ");

var $cmH9g = parcelRequire("cmH9g");
"use strict";
const $c04401f8735caebe$var$_Spritesheet = class _Spritesheet {
    constructor(optionsOrTexture, arg1){
        /** For multi-packed spritesheets, this contains a reference to all the other spritesheets it depends on. */ this.linkedSheets = [];
        let options = optionsOrTexture;
        if (optionsOrTexture?.source instanceof (0, $gl1XZ.TextureSource)) options = {
            texture: optionsOrTexture,
            data: arg1
        };
        const { texture: texture, data: data, cachePrefix: cachePrefix = "" } = options;
        this.cachePrefix = cachePrefix;
        this._texture = texture instanceof (0, $cmH9g.Texture) ? texture : null;
        this.textureSource = texture.source;
        this.textures = {};
        this.animations = {};
        this.data = data;
        const metaResolution = parseFloat(data.meta.scale);
        if (metaResolution) {
            this.resolution = metaResolution;
            texture.source.resolution = this.resolution;
        } else this.resolution = texture.source._resolution;
        this._frames = this.data.frames;
        this._frameKeys = Object.keys(this._frames);
        this._batchIndex = 0;
        this._callback = null;
    }
    /**
   * Parse spritesheet from loaded data. This is done asynchronously
   * to prevent creating too many Texture within a single process.
   */ parse() {
        return new Promise((resolve)=>{
            this._callback = resolve;
            this._batchIndex = 0;
            if (this._frameKeys.length <= _Spritesheet.BATCH_SIZE) {
                this._processFrames(0);
                this._processAnimations();
                this._parseComplete();
            } else this._nextBatch();
        });
    }
    /**
   * Parse spritesheet from loaded data. This is done synchronously
   * and is only suitable for smaller spritesheets (less than ~1000 frames)
   * or may cause too many Texture within a single process. However, synchronous parsing may be
   * more convenient since the called does not need to be asynchronous and is safe for
   * small-to-medium sized spritesheets.
   *
   * Other than being synchronous, `parseSync` is otherwise identical to `.parse()`.
   */ parseSync() {
        this._processFrames(0, true);
        this._processAnimations();
        return this.textures;
    }
    /**
   * Process a batch of frames
   * @param initialFrameIndex - The index of frame to start.
   * @param processAll - if true will process all frames in a single batch, ignoring BATCH_SIZE - this
   * is used for synchronous parsing.
   */ _processFrames(initialFrameIndex, processAll = false) {
        let frameIndex = initialFrameIndex;
        const maxFrames = processAll ? Infinity : _Spritesheet.BATCH_SIZE;
        while(frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length){
            const i = this._frameKeys[frameIndex];
            const data = this._frames[i];
            const rect = data.frame;
            if (rect) {
                let frame = null;
                let trim = null;
                const sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;
                const orig = new (0, $kNl9L.Rectangle)(0, 0, Math.floor(sourceSize.w) / this.resolution, Math.floor(sourceSize.h) / this.resolution);
                if (data.rotated) frame = new (0, $kNl9L.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.h) / this.resolution, Math.floor(rect.w) / this.resolution);
                else frame = new (0, $kNl9L.Rectangle)(Math.floor(rect.x) / this.resolution, Math.floor(rect.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                if (data.trimmed !== false && data.spriteSourceSize) trim = new (0, $kNl9L.Rectangle)(Math.floor(data.spriteSourceSize.x) / this.resolution, Math.floor(data.spriteSourceSize.y) / this.resolution, Math.floor(rect.w) / this.resolution, Math.floor(rect.h) / this.resolution);
                this.textures[i] = new (0, $cmH9g.Texture)({
                    source: this.textureSource,
                    frame: frame,
                    orig: orig,
                    trim: trim,
                    rotate: data.rotated ? 2 : 0,
                    defaultAnchor: data.anchor,
                    defaultBorders: data.borders,
                    label: i.toString()
                });
            }
            frameIndex++;
        }
    }
    /** Parse animations config. */ _processAnimations() {
        const animations = this.data.animations || {};
        for(const animName in animations){
            this.animations[animName] = [];
            for(let i = 0; i < animations[animName].length; i++){
                const frameName = animations[animName][i];
                this.animations[animName].push(this.textures[frameName]);
            }
        }
    }
    /** The parse has completed. */ _parseComplete() {
        const callback = this._callback;
        this._callback = null;
        this._batchIndex = 0;
        callback.call(this, this.textures);
    }
    /** Begin the next batch of textures. */ _nextBatch() {
        this._processFrames(this._batchIndex * _Spritesheet.BATCH_SIZE);
        this._batchIndex++;
        setTimeout(()=>{
            if (this._batchIndex * _Spritesheet.BATCH_SIZE < this._frameKeys.length) this._nextBatch();
            else {
                this._processAnimations();
                this._parseComplete();
            }
        }, 0);
    }
    /**
   * Destroy Spritesheet and don't use after this.
   * @param {boolean} [destroyBase=false] - Whether to destroy the base texture as well
   */ destroy(destroyBase = false) {
        for(const i in this.textures)this.textures[i].destroy();
        this._frames = null;
        this._frameKeys = null;
        this.data = null;
        this.textures = null;
        if (destroyBase) {
            this._texture?.destroy();
            this.textureSource.destroy();
        }
        this._texture = null;
        this.textureSource = null;
        this.linkedSheets = [];
    }
};
/**
 * The maximum number of Textures to build per process.
 * @advanced
 */ $c04401f8735caebe$var$_Spritesheet.BATCH_SIZE = 1e3;
let $c04401f8735caebe$export$674d2eb4debbef0c = $c04401f8735caebe$var$_Spritesheet;

});



parcelRegister("2C2CU", function(module, exports) {

$parcel$export(module.exports, "AbstractRenderer", () => $1ea0261838d287a1$export$58ab3ed211eed562);

var $jr7Dg = parcelRequire("jr7Dg");

var $2lbS1 = parcelRequire("2lbS1");

var $5Wp7K = parcelRequire("5Wp7K");

var $6KJtb = parcelRequire("6KJtb");

var $kfwXR = parcelRequire("kfwXR");

var $dXBy0 = parcelRequire("dXBy0");

var $9VJ7s = parcelRequire("9VJ7s");


var $54PKF = parcelRequire("54PKF");

var $9QckP = parcelRequire("9QckP");

var $6AQ4q = parcelRequire("6AQ4q");
"use strict";
const $1ea0261838d287a1$var$defaultRunners = [
    "init",
    "destroy",
    "contextChange",
    "resolutionChange",
    "resetState",
    "renderEnd",
    "renderStart",
    "render",
    "update",
    "postrender",
    "prerender"
];
const $1ea0261838d287a1$var$_AbstractRenderer = class _AbstractRenderer extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    /**
   * Set up a system with a collection of SystemClasses and runners.
   * Systems are attached dynamically to this class when added.
   * @param config - the config for the system manager
   */ constructor(config){
        super();
        /** The current tick of the renderer. */ this.tick = 0;
        /** @internal */ this.uid = (0, $kfwXR.uid)("renderer");
        /** @internal */ this.runners = /* @__PURE__ */ Object.create(null);
        /** @internal */ this.renderPipes = /* @__PURE__ */ Object.create(null);
        this._initOptions = {};
        this._systemsHash = /* @__PURE__ */ Object.create(null);
        this.type = config.type;
        this.name = config.name;
        this.config = config;
        const combinedRunners = [
            ...$1ea0261838d287a1$var$defaultRunners,
            ...this.config.runners ?? []
        ];
        this._addRunners(...combinedRunners);
        this._unsafeEvalCheck();
    }
    /**
   * Initialize the renderer.
   * @param options - The options to use to create the renderer.
   */ async init(options = {}) {
        const skip = options.skipExtensionImports === true ? true : options.manageImports === false;
        await (0, $2lbS1.loadEnvironmentExtensions)(skip);
        this._addSystems(this.config.systems);
        this._addPipes(this.config.renderPipes, this.config.renderPipeAdaptors);
        for(const systemName in this._systemsHash){
            const system = this._systemsHash[systemName];
            const defaultSystemOptions = system.constructor.defaultOptions;
            options = {
                ...defaultSystemOptions,
                ...options
            };
        }
        options = {
            ..._AbstractRenderer.defaultOptions,
            ...options
        };
        this._roundPixels = options.roundPixels ? 1 : 0;
        for(let i = 0; i < this.runners.init.items.length; i++)await this.runners.init.items[i].init(options);
        this._initOptions = options;
    }
    render(args, deprecated) {
        this.tick++;
        let options = args;
        if (options instanceof (0, $5Wp7K.Container)) {
            options = {
                container: options
            };
            if (deprecated) {
                (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "passing a second argument is deprecated, please use render options instead");
                options.target = deprecated.renderTexture;
            }
        }
        options.target || (options.target = this.view.renderTarget);
        if (options.target === this.view.renderTarget) {
            this._lastObjectRendered = options.container;
            options.clearColor ?? (options.clearColor = this.background.colorRgba);
            options.clear ?? (options.clear = this.background.clearBeforeRender);
        }
        if (options.clearColor) {
            const isRGBAArray = Array.isArray(options.clearColor) && options.clearColor.length === 4;
            options.clearColor = isRGBAArray ? options.clearColor : (0, $jr7Dg.Color).shared.setValue(options.clearColor).toArray();
        }
        if (!options.transform) {
            options.container.updateLocalTransform();
            options.transform = options.container.localTransform;
        }
        if (!options.container.visible) return;
        options.container.enableRenderGroup();
        this.runners.prerender.emit(options);
        this.runners.renderStart.emit(options);
        this.runners.render.emit(options);
        this.runners.renderEnd.emit(options);
        this.runners.postrender.emit(options);
    }
    /**
   * Resizes the WebGL view to the specified width and height.
   * @param desiredScreenWidth - The desired width of the screen.
   * @param desiredScreenHeight - The desired height of the screen.
   * @param resolution - The resolution / device pixel ratio of the renderer.
   */ resize(desiredScreenWidth, desiredScreenHeight, resolution) {
        const previousResolution = this.view.resolution;
        this.view.resize(desiredScreenWidth, desiredScreenHeight, resolution);
        this.emit("resize", this.view.screen.width, this.view.screen.height, this.view.resolution);
        if (resolution !== void 0 && resolution !== previousResolution) this.runners.resolutionChange.emit(resolution);
    }
    /**
   * Clears the render target.
   * @param options - The options to use when clearing the render target.
   * @param options.target - The render target to clear.
   * @param options.clearColor - The color to clear with.
   * @param options.clear - The clear mode to use.
   * @advanced
   */ clear(options = {}) {
        const renderer = this;
        options.target || (options.target = renderer.renderTarget.renderTarget);
        options.clearColor || (options.clearColor = this.background.colorRgba);
        options.clear ?? (options.clear = (0, $54PKF.CLEAR).ALL);
        const { clear: clear, clearColor: clearColor, target: target, mipLevel: mipLevel, layer: layer } = options;
        (0, $jr7Dg.Color).shared.setValue(clearColor ?? this.background.colorRgba);
        renderer.renderTarget.clear(target, clear, (0, $jr7Dg.Color).shared.toArray(), mipLevel ?? 0, layer ?? 0);
    }
    /** The resolution / device pixel ratio of the renderer. */ get resolution() {
        return this.view.resolution;
    }
    set resolution(value) {
        this.view.resolution = value;
        this.runners.resolutionChange.emit(value);
    }
    /**
   * Same as view.width, actual number of pixels in the canvas by horizontal.
   * @type {number}
   * @readonly
   * @default 800
   */ get width() {
        return this.view.texture.frame.width;
    }
    /**
   * Same as view.height, actual number of pixels in the canvas by vertical.
   * @default 600
   */ get height() {
        return this.view.texture.frame.height;
    }
    // NOTE: this was `view` in v7
    /**
   * The canvas element that everything is drawn to.
   * @type {environment.ICanvas}
   */ get canvas() {
        return this.view.canvas;
    }
    /**
   * the last object rendered by the renderer. Useful for other plugins like interaction managers
   * @readonly
   */ get lastObjectRendered() {
        return this._lastObjectRendered;
    }
    /**
   * Flag if we are rendering to the screen vs renderTexture
   * @readonly
   * @default true
   */ get renderingToScreen() {
        const renderer = this;
        return renderer.renderTarget.renderingToScreen;
    }
    /**
   * Measurements of the screen. (0, 0, screenWidth, screenHeight).
   *
   * Its safe to use as filterArea or hitArea for the whole stage.
   */ get screen() {
        return this.view.screen;
    }
    /**
   * Create a bunch of runners based of a collection of ids
   * @param runnerIds - the runner ids to add
   */ _addRunners(...runnerIds) {
        runnerIds.forEach((runnerId)=>{
            this.runners[runnerId] = new (0, $9QckP.SystemRunner)(runnerId);
        });
    }
    _addSystems(systems) {
        let i;
        for(i in systems){
            const val = systems[i];
            this._addSystem(val.value, val.name);
        }
    }
    /**
   * Add a new system to the renderer.
   * @param ClassRef - Class reference
   * @param name - Property name for system, if not specified
   *        will use a static `name` property on the class itself. This
   *        name will be assigned as s property on the Renderer so make
   *        sure it doesn't collide with properties on Renderer.
   * @returns Return instance of renderer
   */ _addSystem(ClassRef, name) {
        const system = new ClassRef(this);
        if (this[name]) throw new Error(`Whoops! The name "${name}" is already in use`);
        this[name] = system;
        this._systemsHash[name] = system;
        for(const i in this.runners)this.runners[i].add(system);
        return this;
    }
    _addPipes(pipes, pipeAdaptors) {
        const adaptors = pipeAdaptors.reduce((acc, adaptor)=>{
            acc[adaptor.name] = adaptor.value;
            return acc;
        }, {});
        pipes.forEach((pipe)=>{
            const PipeClass = pipe.value;
            const name = pipe.name;
            const Adaptor = adaptors[name];
            this.renderPipes[name] = new PipeClass(this, Adaptor ? new Adaptor() : null);
            this.runners.destroy.add(this.renderPipes[name]);
        });
    }
    destroy(options = false) {
        this.runners.destroy.items.reverse();
        this.runners.destroy.emit(options);
        if (options === true || typeof options === "object" && options.releaseGlobalResources) (0, $9VJ7s.GlobalResourceRegistry).release();
        Object.values(this.runners).forEach((runner)=>{
            runner.destroy();
        });
        this._systemsHash = null;
        this.renderPipes = null;
        this.removeAllListeners();
    }
    /**
   * Generate a texture from a container.
   * @param options - options or container target to use when generating the texture
   * @returns a texture
   */ generateTexture(options) {
        return this.textureGenerator.generateTexture(options);
    }
    /**
   * Whether the renderer will round coordinates to whole pixels when rendering.
   * Can be overridden on a per scene item basis.
   */ get roundPixels() {
        return !!this._roundPixels;
    }
    /**
   * Overridable function by `pixi.js/unsafe-eval` to silence
   * throwing an error if platform doesn't support unsafe-evals.
   * @private
   * @ignore
   */ _unsafeEvalCheck() {
        if (!(0, $6KJtb.unsafeEvalSupported)()) throw new Error("Current environment does not allow unsafe-eval, please use pixi.js/unsafe-eval module to enable support.");
    }
    /**
   * Resets the rendering state of the renderer.
   * This is useful when you want to use the WebGL context directly and need to ensure PixiJS's internal state
   * stays synchronized. When modifying the WebGL context state externally, calling this method before the next Pixi
   * render will reset all internal caches and ensure it executes correctly.
   *
   * This is particularly useful when combining PixiJS with other rendering engines like Three.js:
   * ```js
   * // Reset Three.js state
   * threeRenderer.resetState();
   *
   * // Render a Three.js scene
   * threeRenderer.render(threeScene, threeCamera);
   *
   * // Reset PixiJS state since Three.js modified the WebGL context
   * pixiRenderer.resetState();
   *
   * // Now render Pixi content
   * pixiRenderer.render(pixiScene);
   * ```
   * @advanced
   */ resetState() {
        this.runners.resetState.emit();
    }
};
/** The default options for the renderer. */ $1ea0261838d287a1$var$_AbstractRenderer.defaultOptions = {
    /**
   * Default resolution / device pixel ratio of the renderer.
   * @default 1
   */ resolution: 1,
    /**
   * Should the `failIfMajorPerformanceCaveat` flag be enabled as a context option used in the `isWebGLSupported`
   * function. If set to true, a WebGL renderer can fail to be created if the browser thinks there could be
   * performance issues when using WebGL.
   *
   * In PixiJS v6 this has changed from true to false by default, to allow WebGL to work in as many
   * scenarios as possible. However, some users may have a poor experience, for example, if a user has a gpu or
   * driver version blacklisted by the
   * browser.
   *
   * If your application requires high performance rendering, you may wish to set this to false.
   * We recommend one of two options if you decide to set this flag to false:
   *
   * 1: Use the Canvas renderer as a fallback in case high performance WebGL is
   *    not supported.
   *
   * 2: Call `isWebGLSupported` (which if found in the utils package) in your code before attempting to create a
   *    PixiJS renderer, and show an error message to the user if the function returns false, explaining that their
   *    device & browser combination does not support high performance WebGL.
   *    This is a much better strategy than trying to create a PixiJS renderer and finding it then fails.
   * @default false
   */ failIfMajorPerformanceCaveat: false,
    /**
   * Should round pixels be forced when rendering?
   * @default false
   */ roundPixels: false
};
let $1ea0261838d287a1$export$58ab3ed211eed562 = $1ea0261838d287a1$var$_AbstractRenderer;

});
parcelRegister("2lbS1", function(module, exports) {

$parcel$export(module.exports, "loadEnvironmentExtensions", () => $937c2080bcec83bf$export$3b30260a318c769f);

var $aBhlC = parcelRequire("aBhlC");
"use strict";
const $937c2080bcec83bf$var$environments = [];
(0, $aBhlC.extensions).handleByNamedList((0, $aBhlC.ExtensionType).Environment, $937c2080bcec83bf$var$environments);
async function $937c2080bcec83bf$export$3b30260a318c769f(skip) {
    if (skip) return;
    for(let i = 0; i < $937c2080bcec83bf$var$environments.length; i++){
        const env = $937c2080bcec83bf$var$environments[i];
        if (env.value.test()) {
            await env.value.load();
            return;
        }
    }
}
async function $937c2080bcec83bf$export$72225172dd907279(add) {
    return $937c2080bcec83bf$export$3b30260a318c769f(!add);
}

});

parcelRegister("6KJtb", function(module, exports) {

$parcel$export(module.exports, "unsafeEvalSupported", () => $1312041f4dc3e6df$export$70c0711f29adc5cf);
"use strict";
let $1312041f4dc3e6df$var$unsafeEval;
function $1312041f4dc3e6df$export$70c0711f29adc5cf() {
    if (typeof $1312041f4dc3e6df$var$unsafeEval === "boolean") return $1312041f4dc3e6df$var$unsafeEval;
    try {
        const func = new Function("param1", "param2", "param3", "return param1[param2] === param3;");
        $1312041f4dc3e6df$var$unsafeEval = func({
            a: "b"
        }, "a", "b") === true;
    } catch (_e) {
        $1312041f4dc3e6df$var$unsafeEval = false;
    }
    return $1312041f4dc3e6df$var$unsafeEval;
}

});

parcelRegister("54PKF", function(module, exports) {

$parcel$export(module.exports, "CLEAR", () => $de642acf6d254642$export$6c4d37c7f376a1de);
"use strict";
var $de642acf6d254642$export$6c4d37c7f376a1de = /* @__PURE__ */ ((CLEAR2)=>{
    CLEAR2[CLEAR2["NONE"] = 0] = "NONE";
    CLEAR2[CLEAR2["COLOR"] = 16384] = "COLOR";
    CLEAR2[CLEAR2["STENCIL"] = 1024] = "STENCIL";
    CLEAR2[CLEAR2["DEPTH"] = 256] = "DEPTH";
    CLEAR2[CLEAR2["COLOR_DEPTH"] = 16640] = "COLOR_DEPTH";
    CLEAR2[CLEAR2["COLOR_STENCIL"] = 17408] = "COLOR_STENCIL";
    CLEAR2[CLEAR2["DEPTH_STENCIL"] = 1280] = "DEPTH_STENCIL";
    CLEAR2[CLEAR2["ALL"] = 17664] = "ALL";
    return CLEAR2;
})($de642acf6d254642$export$6c4d37c7f376a1de || {});

});

parcelRegister("9QckP", function(module, exports) {

$parcel$export(module.exports, "SystemRunner", () => $4bc98b362556c2ce$export$ff5f2fe687fe3979);
"use strict";
class $4bc98b362556c2ce$export$ff5f2fe687fe3979 {
    /**
   * @param name - The function name that will be executed on the listeners added to this Runner.
   */ constructor(name){
        this.items = [];
        this._name = name;
    }
    /* jsdoc/check-param-names */ /**
   * Dispatch/Broadcast Runner to all listeners added to the queue.
   * @param {...any} params - (optional) parameters to pass to each listener
   */ /* jsdoc/check-param-names */ emit(a0, a1, a2, a3, a4, a5, a6, a7) {
        const { name: name, items: items } = this;
        for(let i = 0, len = items.length; i < len; i++)items[i][name](a0, a1, a2, a3, a4, a5, a6, a7);
        return this;
    }
    /**
   * Add a listener to the Runner
   *
   * Runners do not need to have scope or functions passed to them.
   * All that is required is to pass the listening object and ensure that it has contains a function that has the same name
   * as the name provided to the Runner when it was created.
   *
   * Eg A listener passed to this Runner will require a 'complete' function.
   *
   * ```ts
   * import { Runner } from 'pixi.js';
   *
   * const complete = new Runner('complete');
   * ```
   *
   * The scope used will be the object itself.
   * @param {any} item - The object that will be listening.
   */ add(item) {
        if (item[this._name]) {
            this.remove(item);
            this.items.push(item);
        }
        return this;
    }
    /**
   * Remove a single listener from the dispatch queue.
   * @param {any} item - The listener that you would like to remove.
   */ remove(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) this.items.splice(index, 1);
        return this;
    }
    /**
   * Check to see if the listener is already in the Runner
   * @param {any} item - The listener that you would like to check.
   */ contains(item) {
        return this.items.indexOf(item) !== -1;
    }
    /** Remove all listeners from the Runner */ removeAll() {
        this.items.length = 0;
        return this;
    }
    /** Remove all references, don't use after this. */ destroy() {
        this.removeAll();
        this.items = null;
        this._name = null;
    }
    /**
   * `true` if there are no this Runner contains no listeners
   * @readonly
   */ get empty() {
        return this.items.length === 0;
    }
    /**
   * The name of the runner.
   * @readonly
   */ get name() {
        return this._name;
    }
}

});


parcelRegister("la4xz", function(module, exports) {
module.exports = Promise.all([
    import("jhrX0"),
    import("3vQD1"),
    import("802bK")
]).then(()=>parcelRequire('aSHtL'));

});

parcelRegister("f8sY4", function(module, exports) {
module.exports = Promise.all([
    import("jhrX0"),
    import("3vQD1"),
    import("a4qJ5")
]).then(()=>parcelRequire('9h6F7'));

});

parcelRegister("hxI5C", function(module, exports) {
module.exports = Promise.all([
    import("jhrX0"),
    import("juGeF")
]).then(()=>parcelRequire('aG5x5'));

});

parcelRegister("k73MA", function(module, exports) {

$parcel$export(module.exports, "ApplicationInitHook", () => $95c18006131b9cb9$export$918f3e4d2b801859);
$parcel$export(module.exports, "RendererInitHook", () => $95c18006131b9cb9$export$5fba6e443d2fb64);

var $aBhlC = parcelRequire("aBhlC");

var $83LVW = parcelRequire("83LVW");
"use strict";
class $95c18006131b9cb9$export$918f3e4d2b801859 {
    static init() {
        globalThis.__PIXI_APP_INIT__?.(this, (0, $83LVW.VERSION));
    }
    static destroy() {}
}
/** @ignore */ $95c18006131b9cb9$export$918f3e4d2b801859.extension = (0, $aBhlC.ExtensionType).Application;
class $95c18006131b9cb9$export$5fba6e443d2fb64 {
    constructor(renderer){
        this._renderer = renderer;
    }
    init() {
        globalThis.__PIXI_RENDERER_INIT__?.(this._renderer, (0, $83LVW.VERSION));
    }
    destroy() {
        this._renderer = null;
    }
}
/** @ignore */ $95c18006131b9cb9$export$5fba6e443d2fb64.extension = {
    type: [
        (0, $aBhlC.ExtensionType).WebGLSystem,
        (0, $aBhlC.ExtensionType).WebGPUSystem
    ],
    name: "initHook",
    priority: -10
};

});
parcelRegister("83LVW", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $96e434b54789929e$export$a4ad2735b021c132);

var $6AQ4q = parcelRequire("6AQ4q");
"use strict";
const $96e434b54789929e$export$dbafa72958753fce = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;
const $96e434b54789929e$export$a4ad2735b021c132 = "8.18.1";

});


parcelRegister("4xevz", function(module, exports) {

$parcel$export(module.exports, "checkMaxIfStatementsInShader", () => $1386fcf297c03d3b$export$fb6ad4e758d74cc0);
"use strict";
const $1386fcf297c03d3b$var$fragTemplate = [
    "precision mediump float;",
    "void main(void){",
    "float test = 0.1;",
    "%forloop%",
    "gl_FragColor = vec4(0.0);",
    "}"
].join("\n");
function $1386fcf297c03d3b$var$generateIfTestSrc(maxIfs) {
    let src = "";
    for(let i = 0; i < maxIfs; ++i){
        if (i > 0) src += "\nelse ";
        if (i < maxIfs - 1) src += `if(test == ${i}.0){}`;
    }
    return src;
}
function $1386fcf297c03d3b$export$fb6ad4e758d74cc0(maxIfs, gl) {
    if (maxIfs === 0) throw new Error("Invalid value of `0` passed to `checkMaxIfStatementsInShader`");
    const shader = gl.createShader(gl.FRAGMENT_SHADER);
    try {
        while(true){
            const fragmentSrc = $1386fcf297c03d3b$var$fragTemplate.replace(/%forloop%/gi, $1386fcf297c03d3b$var$generateIfTestSrc(maxIfs));
            gl.shaderSource(shader, fragmentSrc);
            gl.compileShader(shader);
            if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) maxIfs = maxIfs / 2 | 0;
            else break;
        }
    } finally{
        gl.deleteShader(shader);
    }
    return maxIfs;
}

});

parcelRegister("fDVAe", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $de589d8cdf6f144d$export$84c26df82650dc9b);

var $cntNn = parcelRequire("cntNn");

var $cmH9g = parcelRequire("cmH9g");
"use strict";
const $de589d8cdf6f144d$var$cachedGroups = {};
function $de589d8cdf6f144d$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $de589d8cdf6f144d$var$cachedGroups[uid] || $de589d8cdf6f144d$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $de589d8cdf6f144d$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $cmH9g.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $cntNn.BindGroup)(bindGroupResources);
    $de589d8cdf6f144d$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});
parcelRegister("cntNn", function(module, exports) {

$parcel$export(module.exports, "BindGroup", () => $0651ea007e8f42d0$export$6f452ee382def63c);
"use strict";
class $0651ea007e8f42d0$export$6f452ee382def63c {
    /**
   * Create a new instance eof the Bind Group.
   * @param resources - The resources that are bound together for use by a shader.
   */ constructor(resources){
        /** The resources that are bound together for use by a shader. */ this.resources = /* @__PURE__ */ Object.create(null);
        this._dirty = true;
        let index = 0;
        for(const i in resources){
            const resource = resources[i];
            this.setResource(resource, index++);
        }
        this._updateKey();
    }
    /**
   * Updates the key if its flagged as dirty. This is used internally to
   * match this bind group to a WebGPU BindGroup.
   * @internal
   */ _updateKey() {
        if (!this._dirty) return;
        this._dirty = false;
        const keyParts = [];
        let index = 0;
        for(const i in this.resources)keyParts[index++] = this.resources[i]._resourceId;
        this._key = keyParts.join("|");
    }
    /**
   * Set a resource at a given index. this function will
   * ensure that listeners will be removed from the current resource
   * and added to the new resource.
   * @param resource - The resource to set.
   * @param index - The index to set the resource at.
   */ setResource(resource, index) {
        const currentResource = this.resources[index];
        if (resource === currentResource) return;
        currentResource?.off?.("change", this.onResourceChange, this);
        resource.on?.("change", this.onResourceChange, this);
        this.resources[index] = resource;
        this._dirty = true;
    }
    /**
   * Returns the resource at the current specified index.
   * @param index - The index of the resource to get.
   * @returns - The resource at the specified index.
   */ getResource(index) {
        return this.resources[index];
    }
    /**
   * Used internally to 'touch' each resource, to ensure that the GC
   * knows that all resources in this bind group are still being used.
   * @param now - The current time in milliseconds.
   * @param tick - The current tick.
   * @internal
   */ _touch(now, tick) {
        const resources = this.resources;
        for(const i in resources){
            resources[i]._gcLastUsed = now;
            resources[i]._touched = tick;
        }
    }
    /** Destroys this bind group and removes all listeners. */ destroy() {
        const resources = this.resources;
        for(const i in resources){
            const resource = resources[i];
            resource?.off?.("change", this.onResourceChange, this);
        }
        this.resources = null;
    }
    onResourceChange(resource) {
        this._dirty = true;
        if (resource.destroyed) this.destroy();
        else this._updateKey();
    }
}

});


parcelRegister("6uids", function(module, exports) {

$parcel$export(module.exports, "fastCopy", () => $52d88c07adceb80f$export$c691b0c42debe682);
"use strict";
function $52d88c07adceb80f$export$c691b0c42debe682(sourceBuffer, destinationBuffer, sourceOffset, byteLength) {
    sourceOffset ?? (sourceOffset = 0);
    byteLength ?? (byteLength = Math.min(sourceBuffer.byteLength - sourceOffset, destinationBuffer.byteLength));
    if (!(sourceOffset & 7) && !(byteLength & 7)) {
        const len = byteLength / 8;
        new Float64Array(destinationBuffer, 0, len).set(new Float64Array(sourceBuffer, sourceOffset, len));
    } else if (!(sourceOffset & 3) && !(byteLength & 3)) {
        const len = byteLength / 4;
        new Float32Array(destinationBuffer, 0, len).set(new Float32Array(sourceBuffer, sourceOffset, len));
    } else new Uint8Array(destinationBuffer).set(new Uint8Array(sourceBuffer, sourceOffset, byteLength));
}

});

parcelRegister("1SIha", function(module, exports) {

$parcel$export(module.exports, "BLEND_TO_NPM", () => $ee5a746c48fb464f$export$8c0bd2ccaa4a8d5e);
$parcel$export(module.exports, "STENCIL_MODES", () => $ee5a746c48fb464f$export$c250b85d73a91bdf);
"use strict";
const $ee5a746c48fb464f$export$8c0bd2ccaa4a8d5e = {
    normal: "normal-npm",
    add: "add-npm",
    screen: "screen-npm"
};
var $ee5a746c48fb464f$export$c250b85d73a91bdf = /* @__PURE__ */ ((STENCIL_MODES2)=>{
    STENCIL_MODES2[STENCIL_MODES2["DISABLED"] = 0] = "DISABLED";
    STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_ADD"] = 1] = "RENDERING_MASK_ADD";
    STENCIL_MODES2[STENCIL_MODES2["MASK_ACTIVE"] = 2] = "MASK_ACTIVE";
    STENCIL_MODES2[STENCIL_MODES2["INVERSE_MASK_ACTIVE"] = 3] = "INVERSE_MASK_ACTIVE";
    STENCIL_MODES2[STENCIL_MODES2["RENDERING_MASK_REMOVE"] = 4] = "RENDERING_MASK_REMOVE";
    STENCIL_MODES2[STENCIL_MODES2["NONE"] = 5] = "NONE";
    return STENCIL_MODES2;
})($ee5a746c48fb464f$export$c250b85d73a91bdf || {});

});

parcelRegister("jbDgC", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $9499d0e6ed848696$export$a143d493d941bafc);

var $6AQ4q = parcelRequire("6AQ4q");

var $kfwXR = parcelRequire("kfwXR");

var $kQVSf = parcelRequire("kQVSf");
"use strict";
class $9499d0e6ed848696$export$a143d493d941bafc extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    /**
   * Creates a new Buffer with the given options
   * @param options - the options for the buffer
   */ constructor(options){
        let { data: data, size: size } = options;
        const { usage: usage, label: label, shrinkToFit: shrinkToFit } = options;
        super();
        /**
     * emits when the underlying buffer has changed shape (i.e. resized)
     * letting the renderer know that it needs to discard the old buffer on the GPU and create a new one
     * @event change
     */ /**
     * emits when the underlying buffer data has been updated. letting the renderer know
     * that it needs to update the buffer on the GPU
     * @event update
     */ /**
     * emits when the buffer is destroyed. letting the renderer know that it needs to destroy the buffer on the GPU
     * @event destroy
     */ /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        /** @internal */ this._gcLastUsed = -1;
        /** If set to true, the buffer will be garbage collected automatically when it is not used. */ this.autoGarbageCollect = true;
        /** a unique id for this uniform group used through the renderer */ this.uid = (0, $kfwXR.uid)("buffer");
        /**
     * a resource type, used to identify how to handle it when its in a bind group / shader resource
     * @internal
     */ this._resourceType = "buffer";
        /**
     * the resource id used internally by the renderer to build bind group keys
     * @internal
     */ this._resourceId = (0, $kfwXR.uid)("resource");
        /**
     * used internally to know if a uniform group was used in the last render pass
     * @internal
     */ this._touched = 0;
        /** @internal */ this._updateID = 1;
        this._dataInt32 = null;
        /**
     * should the GPU buffer be shrunk when the data becomes smaller?
     * changing this will cause the buffer to be destroyed and a new one created on the GPU
     * this can be expensive, especially if the buffer is already big enough!
     * setting this to false will prevent the buffer from being shrunk. This will yield better performance
     * if you are constantly setting data that is changing size often.
     * @default true
     */ this.shrinkToFit = true;
        /**
     * Has the buffer been destroyed?
     * @readonly
     */ this.destroyed = false;
        if (data instanceof Array) data = new Float32Array(data);
        this._data = data;
        size ?? (size = data?.byteLength);
        const mappedAtCreation = !!data;
        this.descriptor = {
            size: size,
            usage: usage,
            mappedAtCreation: mappedAtCreation,
            label: label
        };
        this.shrinkToFit = shrinkToFit ?? true;
    }
    /** the data in the buffer */ get data() {
        return this._data;
    }
    set data(value) {
        this.setDataWithSize(value, value.length, true);
    }
    get dataInt32() {
        if (!this._dataInt32) this._dataInt32 = new Int32Array(this.data.buffer);
        return this._dataInt32;
    }
    /** whether the buffer is static or not */ get static() {
        return !!(this.descriptor.usage & (0, $kQVSf.BufferUsage).STATIC);
    }
    set static(value) {
        if (value) this.descriptor.usage |= (0, $kQVSf.BufferUsage).STATIC;
        else this.descriptor.usage &= ~(0, $kQVSf.BufferUsage).STATIC;
    }
    /**
   * Sets the data in the buffer to the given value. This will immediately update the buffer on the GPU.
   * If you only want to update a subset of the buffer, you can pass in the size of the data.
   * @param value - the data to set
   * @param size - the size of the data in bytes
   * @param syncGPU - should the buffer be updated on the GPU immediately?
   */ setDataWithSize(value, size, syncGPU) {
        this._updateID++;
        this._updateSize = size * value.BYTES_PER_ELEMENT;
        if (this._data === value) {
            if (syncGPU) this.emit("update", this);
            return;
        }
        const oldData = this._data;
        this._data = value;
        this._dataInt32 = null;
        if (!oldData || oldData.length !== value.length) {
            if (!this.shrinkToFit && oldData && value.byteLength < oldData.byteLength) {
                if (syncGPU) this.emit("update", this);
            } else {
                this.descriptor.size = value.byteLength;
                this._resourceId = (0, $kfwXR.uid)("resource");
                this.emit("change", this);
            }
            return;
        }
        if (syncGPU) this.emit("update", this);
    }
    /**
   * updates the buffer on the GPU to reflect the data in the buffer.
   * By default it will update the entire buffer. If you only want to update a subset of the buffer,
   * you can pass in the size of the buffer to update.
   * @param sizeInBytes - the new size of the buffer in bytes
   */ update(sizeInBytes) {
        this._updateSize = sizeInBytes ?? this._updateSize;
        this._updateID++;
        this.emit("update", this);
    }
    /** Unloads the buffer from the GPU */ unload() {
        this.emit("unload", this);
        for(const key in this._gpuData)this._gpuData[key]?.destroy();
        this._gpuData = /* @__PURE__ */ Object.create(null);
    }
    /** Destroys the buffer */ destroy() {
        this.destroyed = true;
        this.unload();
        this.emit("destroy", this);
        this.emit("change", this);
        this._data = null;
        this.descriptor = null;
        this.removeAllListeners();
    }
}

});
parcelRegister("kQVSf", function(module, exports) {

$parcel$export(module.exports, "BufferUsage", () => $8bb83b6fa86ccf65$export$f8deb2be8632fd10);
"use strict";
var $8bb83b6fa86ccf65$export$f8deb2be8632fd10 = /* @__PURE__ */ ((BufferUsage2)=>{
    BufferUsage2[BufferUsage2["MAP_READ"] = 1] = "MAP_READ";
    BufferUsage2[BufferUsage2["MAP_WRITE"] = 2] = "MAP_WRITE";
    BufferUsage2[BufferUsage2["COPY_SRC"] = 4] = "COPY_SRC";
    BufferUsage2[BufferUsage2["COPY_DST"] = 8] = "COPY_DST";
    BufferUsage2[BufferUsage2["INDEX"] = 16] = "INDEX";
    BufferUsage2[BufferUsage2["VERTEX"] = 32] = "VERTEX";
    BufferUsage2[BufferUsage2["UNIFORM"] = 64] = "UNIFORM";
    BufferUsage2[BufferUsage2["STORAGE"] = 128] = "STORAGE";
    BufferUsage2[BufferUsage2["INDIRECT"] = 256] = "INDIRECT";
    BufferUsage2[BufferUsage2["QUERY_RESOLVE"] = 512] = "QUERY_RESOLVE";
    BufferUsage2[BufferUsage2["STATIC"] = 1024] = "STATIC";
    return BufferUsage2;
})($8bb83b6fa86ccf65$export$f8deb2be8632fd10 || {});

});


parcelRegister("h4C0S", function(module, exports) {

$parcel$export(module.exports, "Geometry", () => $fb52273e121d2c7c$export$2db6c17465f94a2);

var $6AQ4q = parcelRequire("6AQ4q");

var $eWGg9 = parcelRequire("eWGg9");

var $kfwXR = parcelRequire("kfwXR");

var $jbDgC = parcelRequire("jbDgC");

var $6qxH4 = parcelRequire("6qxH4");

var $28Jrb = parcelRequire("28Jrb");
"use strict";
function $fb52273e121d2c7c$var$ensureIsAttribute(attribute) {
    if (attribute instanceof (0, $jbDgC.Buffer) || Array.isArray(attribute) || attribute.BYTES_PER_ELEMENT) attribute = {
        buffer: attribute
    };
    attribute.buffer = (0, $6qxH4.ensureIsBuffer)(attribute.buffer, false);
    return attribute;
}
class $fb52273e121d2c7c$export$2db6c17465f94a2 extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    /**
   * Create a new instance of a geometry
   * @param options - The options for the geometry.
   */ constructor(options = {}){
        super();
        /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        /** If set to true, the resource will be garbage collected automatically when it is not used. */ this.autoGarbageCollect = true;
        /** @internal */ this._gcLastUsed = -1;
        /** The unique id of the geometry. */ this.uid = (0, $kfwXR.uid)("geometry");
        /**
     * the layout key will be generated by WebGPU all geometries that have the same structure
     * will have the same layout key. This is used to cache the pipeline layout
     * @internal
     */ this._layoutKey = 0;
        /** the instance count of the geometry to draw */ this.instanceCount = 1;
        this._bounds = new (0, $eWGg9.Bounds)();
        this._boundsDirty = true;
        const { attributes: attributes, indexBuffer: indexBuffer, topology: topology } = options;
        this.buffers = [];
        this.attributes = {};
        if (attributes) for(const i in attributes)this.addAttribute(i, attributes[i]);
        this.instanceCount = options.instanceCount ?? 1;
        if (indexBuffer) this.addIndex(indexBuffer);
        this.topology = topology || "triangle-list";
    }
    onBufferUpdate() {
        this._boundsDirty = true;
        this.emit("update", this);
    }
    /**
   * Returns the requested attribute.
   * @param id - The name of the attribute required
   * @returns - The attribute requested.
   */ getAttribute(id) {
        return this.attributes[id];
    }
    /**
   * Returns the index buffer
   * @returns - The index buffer.
   */ getIndex() {
        return this.indexBuffer;
    }
    /**
   * Returns the requested buffer.
   * @param id - The name of the buffer required.
   * @returns - The buffer requested.
   */ getBuffer(id) {
        return this.getAttribute(id).buffer;
    }
    /**
   * Used to figure out how many vertices there are in this geometry
   * @returns the number of vertices in the geometry
   */ getSize() {
        for(const i in this.attributes){
            const attribute = this.attributes[i];
            const buffer = attribute.buffer;
            return buffer.data.length / (attribute.stride / 4 || attribute.size);
        }
        return 0;
    }
    /**
   * Adds an attribute to the geometry.
   * @param name - The name of the attribute to add.
   * @param attributeOption - The attribute option to add.
   */ addAttribute(name, attributeOption) {
        const attribute = $fb52273e121d2c7c$var$ensureIsAttribute(attributeOption);
        const bufferIndex = this.buffers.indexOf(attribute.buffer);
        if (bufferIndex === -1) {
            this.buffers.push(attribute.buffer);
            attribute.buffer.on("update", this.onBufferUpdate, this);
            attribute.buffer.on("change", this.onBufferUpdate, this);
        }
        this.attributes[name] = attribute;
    }
    /**
   * Adds an index buffer to the geometry.
   * @param indexBuffer - The index buffer to add. Can be a Buffer, TypedArray, or an array of numbers.
   */ addIndex(indexBuffer) {
        this.indexBuffer = (0, $6qxH4.ensureIsBuffer)(indexBuffer, true);
        this.buffers.push(this.indexBuffer);
    }
    /** Returns the bounds of the geometry. */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        this._boundsDirty = false;
        return (0, $28Jrb.getGeometryBounds)(this, "aPosition", this._bounds);
    }
    /** Unloads the geometry from the GPU. */ unload() {
        this.emit("unload", this);
        for(const key in this._gpuData)this._gpuData[key]?.destroy();
        this._gpuData = /* @__PURE__ */ Object.create(null);
    }
    /**
   * destroys the geometry.
   * @param destroyBuffers - destroy the buffers associated with this geometry
   */ destroy(destroyBuffers = false) {
        this.emit("destroy", this);
        this.removeAllListeners();
        if (destroyBuffers) this.buffers.forEach((buffer)=>buffer.destroy());
        this.unload();
        this.indexBuffer?.destroy();
        this.attributes = null;
        this.buffers = null;
        this.indexBuffer = null;
        this._bounds = null;
    }
}

});
parcelRegister("6qxH4", function(module, exports) {

$parcel$export(module.exports, "ensureIsBuffer", () => $7499666e0ac6f1e4$export$e02adcb3cf335e03);

var $jbDgC = parcelRequire("jbDgC");

var $kQVSf = parcelRequire("kQVSf");
"use strict";
function $7499666e0ac6f1e4$export$e02adcb3cf335e03(buffer, index) {
    if (!(buffer instanceof (0, $jbDgC.Buffer))) {
        let usage = index ? (0, $kQVSf.BufferUsage).INDEX : (0, $kQVSf.BufferUsage).VERTEX;
        if (buffer instanceof Array) {
            if (index) {
                buffer = new Uint32Array(buffer);
                usage = (0, $kQVSf.BufferUsage).INDEX | (0, $kQVSf.BufferUsage).COPY_DST;
            } else {
                buffer = new Float32Array(buffer);
                usage = (0, $kQVSf.BufferUsage).VERTEX | (0, $kQVSf.BufferUsage).COPY_DST;
            }
        }
        buffer = new (0, $jbDgC.Buffer)({
            data: buffer,
            label: index ? "index-mesh-buffer" : "vertex-mesh-buffer",
            usage: usage
        });
    }
    return buffer;
}

});

parcelRegister("28Jrb", function(module, exports) {

$parcel$export(module.exports, "getGeometryBounds", () => $38a93533286e5785$export$ca8be28ec6402f29);
"use strict";
function $38a93533286e5785$export$ca8be28ec6402f29(geometry, attributeId, bounds) {
    const attribute = geometry.getAttribute(attributeId);
    if (!attribute) {
        bounds.minX = 0;
        bounds.minY = 0;
        bounds.maxX = 0;
        bounds.maxY = 0;
        return bounds;
    }
    const data = attribute.buffer.data;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    const byteSize = data.BYTES_PER_ELEMENT;
    const offset = (attribute.offset || 0) / byteSize;
    const stride = (attribute.stride || 8) / byteSize;
    for(let i = offset; i < data.length; i += stride){
        const x = data[i];
        const y = data[i + 1];
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
    }
    bounds.minX = minX;
    bounds.minY = minY;
    bounds.maxX = maxX;
    bounds.maxY = maxY;
    return bounds;
}

});


parcelRegister("7JTYx", function(module, exports) {

$parcel$export(module.exports, "DefaultBatcher", () => $732a3dffbb47576e$export$34bf80542893bcb);

var $aBhlC = parcelRequire("aBhlC");

var $537EL = parcelRequire("537EL");

var $fJLMg = parcelRequire("fJLMg");

var $ayZpW = parcelRequire("ayZpW");
"use strict";
let $732a3dffbb47576e$var$defaultShader = null;
const $732a3dffbb47576e$var$_DefaultBatcher = class _DefaultBatcher extends (0, $537EL.Batcher) {
    constructor(options){
        super(options);
        this.geometry = new (0, $fJLMg.BatchGeometry)();
        this.name = _DefaultBatcher.extension.name;
        /** The size of one attribute. 1 = 32 bit. x, y, u, v, color, textureIdAndRound -> total = 6 */ this.vertexSize = 6;
        $732a3dffbb47576e$var$defaultShader ?? ($732a3dffbb47576e$var$defaultShader = new (0, $ayZpW.DefaultShader)(options.maxTextures));
        this.shader = $732a3dffbb47576e$var$defaultShader;
    }
    /**
   * Packs the attributes of a DefaultBatchableMeshElement into the provided views.
   * @param element - The DefaultBatchableMeshElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */ packAttributes(element, float32View, uint32View, index, textureId) {
        const textureIdAndRound = textureId << 16 | element.roundPixels & 65535;
        const wt = element.transform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const { positions: positions, uvs: uvs } = element;
        const argb = element.color;
        const offset = element.attributeOffset;
        const end = offset + element.attributeSize;
        for(let i = offset; i < end; i++){
            const i2 = i * 2;
            const x = positions[i2];
            const y = positions[i2 + 1];
            float32View[index++] = a * x + c * y + tx;
            float32View[index++] = d * y + b * x + ty;
            float32View[index++] = uvs[i2];
            float32View[index++] = uvs[i2 + 1];
            uint32View[index++] = argb;
            uint32View[index++] = textureIdAndRound;
        }
    }
    /**
   * Packs the attributes of a DefaultBatchableQuadElement into the provided views.
   * @param element - The DefaultBatchableQuadElement to pack.
   * @param float32View - The Float32Array view to pack into.
   * @param uint32View - The Uint32Array view to pack into.
   * @param index - The starting index in the views.
   * @param textureId - The texture ID to use.
   */ packQuadAttributes(element, float32View, uint32View, index, textureId) {
        const texture = element.texture;
        const wt = element.transform;
        const a = wt.a;
        const b = wt.b;
        const c = wt.c;
        const d = wt.d;
        const tx = wt.tx;
        const ty = wt.ty;
        const bounds = element.bounds;
        const w0 = bounds.maxX;
        const w1 = bounds.minX;
        const h0 = bounds.maxY;
        const h1 = bounds.minY;
        const uvs = texture.uvs;
        const argb = element.color;
        const textureIdAndRound = textureId << 16 | element.roundPixels & 65535;
        float32View[index + 0] = a * w1 + c * h1 + tx;
        float32View[index + 1] = d * h1 + b * w1 + ty;
        float32View[index + 2] = uvs.x0;
        float32View[index + 3] = uvs.y0;
        uint32View[index + 4] = argb;
        uint32View[index + 5] = textureIdAndRound;
        float32View[index + 6] = a * w0 + c * h1 + tx;
        float32View[index + 7] = d * h1 + b * w0 + ty;
        float32View[index + 8] = uvs.x1;
        float32View[index + 9] = uvs.y1;
        uint32View[index + 10] = argb;
        uint32View[index + 11] = textureIdAndRound;
        float32View[index + 12] = a * w0 + c * h0 + tx;
        float32View[index + 13] = d * h0 + b * w0 + ty;
        float32View[index + 14] = uvs.x2;
        float32View[index + 15] = uvs.y2;
        uint32View[index + 16] = argb;
        uint32View[index + 17] = textureIdAndRound;
        float32View[index + 18] = a * w1 + c * h0 + tx;
        float32View[index + 19] = d * h0 + b * w1 + ty;
        float32View[index + 20] = uvs.x3;
        float32View[index + 21] = uvs.y3;
        uint32View[index + 22] = argb;
        uint32View[index + 23] = textureIdAndRound;
    }
    /**
   * Updates the maximum number of textures that can be used in the shader.
   * @param maxTextures - The maximum number of textures that can be used in the shader.
   * @internal
   */ _updateMaxTextures(maxTextures) {
        if (this.shader.maxTextures === maxTextures) return;
        $732a3dffbb47576e$var$defaultShader = new (0, $ayZpW.DefaultShader)(maxTextures);
        this.shader = $732a3dffbb47576e$var$defaultShader;
    }
    destroy() {
        this.shader = null;
        super.destroy();
    }
};
/** @ignore */ $732a3dffbb47576e$var$_DefaultBatcher.extension = {
    type: [
        (0, $aBhlC.ExtensionType).Batcher
    ],
    name: "default"
};
let $732a3dffbb47576e$export$34bf80542893bcb = $732a3dffbb47576e$var$_DefaultBatcher;

});
parcelRegister("537EL", function(module, exports) {

$parcel$export(module.exports, "Batcher", () => $a5af825357f2c2e2$export$704b12ddc1dacdd2);

var $kfwXR = parcelRequire("kfwXR");

var $1PcKb = parcelRequire("1PcKb");

var $dXBy0 = parcelRequire("dXBy0");

var $9VJ7s = parcelRequire("9VJ7s");

var $6uids = parcelRequire("6uids");

var $lEmAA = parcelRequire("lEmAA");

var $bqYXY = parcelRequire("bqYXY");

var $ixGJr = parcelRequire("ixGJr");
"use strict";
class $a5af825357f2c2e2$export$33b107562567fc47 {
    constructor(){
        this.renderPipeId = "batch";
        this.action = "startBatch";
        // TODO - eventually this could be useful for flagging batches as dirty and then only rebuilding those ones
        // public elementStart = 0;
        // public elementSize = 0;
        // for drawing..
        this.start = 0;
        this.size = 0;
        this.textures = new (0, $ixGJr.BatchTextureArray)();
        this.blendMode = "normal";
        this.topology = "triangle-strip";
        this.canBundle = true;
    }
    destroy() {
        this.textures = null;
        this.gpuBindGroup = null;
        this.bindGroup = null;
        this.batcher = null;
        this.elements = null;
    }
}
const $a5af825357f2c2e2$var$batchPool = [];
let $a5af825357f2c2e2$var$batchPoolIndex = 0;
(0, $9VJ7s.GlobalResourceRegistry).register({
    clear: ()=>{
        if ($a5af825357f2c2e2$var$batchPool.length > 0) {
            for (const item of $a5af825357f2c2e2$var$batchPool)if (item) item.destroy();
        }
        $a5af825357f2c2e2$var$batchPool.length = 0;
        $a5af825357f2c2e2$var$batchPoolIndex = 0;
    }
});
function $a5af825357f2c2e2$var$getBatchFromPool() {
    return $a5af825357f2c2e2$var$batchPoolIndex > 0 ? $a5af825357f2c2e2$var$batchPool[--$a5af825357f2c2e2$var$batchPoolIndex] : new $a5af825357f2c2e2$export$33b107562567fc47();
}
function $a5af825357f2c2e2$var$returnBatchToPool(batch) {
    batch.elements = null;
    $a5af825357f2c2e2$var$batchPool[$a5af825357f2c2e2$var$batchPoolIndex++] = batch;
}
let $a5af825357f2c2e2$var$BATCH_TICK = 0;
const $a5af825357f2c2e2$var$_Batcher = class _Batcher {
    constructor(options){
        /** unique id for this batcher */ this.uid = (0, $kfwXR.uid)("batcher");
        /** Indicates whether the batch data has been modified and needs updating. */ this.dirty = true;
        /** The current index of the batch being processed. */ this.batchIndex = 0;
        /** An array of all batches created during the current rendering process. */ this.batches = [];
        this._elements = [];
        options = {
            ..._Batcher.defaultOptions,
            ...options
        };
        if (!options.maxTextures) {
            (0, $dXBy0.deprecation)("v8.8.0", "maxTextures is a required option for Batcher now, please pass it in the options");
            options.maxTextures = (0, $bqYXY.getMaxTexturesPerBatch)();
        }
        const { maxTextures: maxTextures, attributesInitialSize: attributesInitialSize, indicesInitialSize: indicesInitialSize } = options;
        this.attributeBuffer = new (0, $1PcKb.ViewableBuffer)(attributesInitialSize * 4);
        this.indexBuffer = new Uint16Array(indicesInitialSize);
        this.maxTextures = maxTextures;
    }
    begin() {
        this.elementSize = 0;
        this.elementStart = 0;
        this.indexSize = 0;
        this.attributeSize = 0;
        for(let i = 0; i < this.batchIndex; i++)$a5af825357f2c2e2$var$returnBatchToPool(this.batches[i]);
        this.batchIndex = 0;
        this._batchIndexStart = 0;
        this._batchIndexSize = 0;
        this.dirty = true;
    }
    add(batchableObject) {
        this._elements[this.elementSize++] = batchableObject;
        batchableObject._indexStart = this.indexSize;
        batchableObject._attributeStart = this.attributeSize;
        batchableObject._batcher = this;
        this.indexSize += batchableObject.indexSize;
        this.attributeSize += batchableObject.attributeSize * this.vertexSize;
    }
    checkAndUpdateTexture(batchableObject, texture) {
        const textureId = batchableObject._batch.textures.ids[texture._source.uid];
        if (!textureId && textureId !== 0) return false;
        batchableObject._textureId = textureId;
        batchableObject.texture = texture;
        return true;
    }
    updateElement(batchableObject) {
        this.dirty = true;
        const attributeBuffer = this.attributeBuffer;
        if (batchableObject.packAsQuad) this.packQuadAttributes(batchableObject, attributeBuffer.float32View, attributeBuffer.uint32View, batchableObject._attributeStart, batchableObject._textureId);
        else this.packAttributes(batchableObject, attributeBuffer.float32View, attributeBuffer.uint32View, batchableObject._attributeStart, batchableObject._textureId);
    }
    /**
   * breaks the batcher. This happens when a batch gets too big,
   * or we need to switch to a different type of rendering (a filter for example)
   * @param instructionSet
   */ break(instructionSet) {
        const elements = this._elements;
        if (!elements[this.elementStart]) return;
        let batch = $a5af825357f2c2e2$var$getBatchFromPool();
        let textureBatch = batch.textures;
        textureBatch.clear();
        const firstElement = elements[this.elementStart];
        let blendMode = (0, $lEmAA.getAdjustedBlendModeBlend)(firstElement.blendMode, firstElement.texture._source);
        let topology = firstElement.topology;
        if (this.attributeSize * 4 > this.attributeBuffer.size) this._resizeAttributeBuffer(this.attributeSize * 4);
        if (this.indexSize > this.indexBuffer.length) this._resizeIndexBuffer(this.indexSize);
        const f32 = this.attributeBuffer.float32View;
        const u32 = this.attributeBuffer.uint32View;
        const indexBuffer = this.indexBuffer;
        let size = this._batchIndexSize;
        let start = this._batchIndexStart;
        let action = "startBatch";
        let batchElements = [];
        const maxTextures = this.maxTextures;
        for(let i = this.elementStart; i < this.elementSize; ++i){
            const element = elements[i];
            elements[i] = null;
            const texture = element.texture;
            const source = texture._source;
            const adjustedBlendMode = (0, $lEmAA.getAdjustedBlendModeBlend)(element.blendMode, source);
            const breakRequired = blendMode !== adjustedBlendMode || topology !== element.topology;
            if (source._batchTick === $a5af825357f2c2e2$var$BATCH_TICK && !breakRequired) {
                element._textureId = source._textureBindLocation;
                size += element.indexSize;
                if (element.packAsQuad) {
                    this.packQuadAttributes(element, f32, u32, element._attributeStart, element._textureId);
                    this.packQuadIndex(indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
                } else {
                    this.packAttributes(element, f32, u32, element._attributeStart, element._textureId);
                    this.packIndex(element, indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
                }
                element._batch = batch;
                batchElements.push(element);
                continue;
            }
            source._batchTick = $a5af825357f2c2e2$var$BATCH_TICK;
            if (textureBatch.count >= maxTextures || breakRequired) {
                this._finishBatch(batch, start, size - start, textureBatch, blendMode, topology, instructionSet, action, batchElements);
                action = "renderBatch";
                start = size;
                blendMode = adjustedBlendMode;
                topology = element.topology;
                batch = $a5af825357f2c2e2$var$getBatchFromPool();
                textureBatch = batch.textures;
                textureBatch.clear();
                batchElements = [];
                ++$a5af825357f2c2e2$var$BATCH_TICK;
            }
            element._textureId = source._textureBindLocation = textureBatch.count;
            textureBatch.ids[source.uid] = textureBatch.count;
            textureBatch.textures[textureBatch.count++] = source;
            element._batch = batch;
            batchElements.push(element);
            size += element.indexSize;
            if (element.packAsQuad) {
                this.packQuadAttributes(element, f32, u32, element._attributeStart, element._textureId);
                this.packQuadIndex(indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
            } else {
                this.packAttributes(element, f32, u32, element._attributeStart, element._textureId);
                this.packIndex(element, indexBuffer, element._indexStart, element._attributeStart / this.vertexSize);
            }
        }
        if (textureBatch.count > 0) {
            this._finishBatch(batch, start, size - start, textureBatch, blendMode, topology, instructionSet, action, batchElements);
            start = size;
            ++$a5af825357f2c2e2$var$BATCH_TICK;
        }
        this.elementStart = this.elementSize;
        this._batchIndexStart = start;
        this._batchIndexSize = size;
    }
    _finishBatch(batch, indexStart, indexSize, textureBatch, blendMode, topology, instructionSet, action, elements) {
        batch.gpuBindGroup = null;
        batch.bindGroup = null;
        batch.action = action;
        batch.batcher = this;
        batch.textures = textureBatch;
        batch.blendMode = blendMode;
        batch.topology = topology;
        batch.start = indexStart;
        batch.size = indexSize;
        batch.elements = elements;
        ++$a5af825357f2c2e2$var$BATCH_TICK;
        this.batches[this.batchIndex++] = batch;
        instructionSet.add(batch);
    }
    finish(instructionSet) {
        this.break(instructionSet);
    }
    /**
   * Resizes the attribute buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */ ensureAttributeBuffer(size) {
        if (size * 4 <= this.attributeBuffer.size) return;
        this._resizeAttributeBuffer(size * 4);
    }
    /**
   * Resizes the index buffer to the given size (1 = 1 float32)
   * @param size - the size in vertices to ensure (not bytes!)
   */ ensureIndexBuffer(size) {
        if (size <= this.indexBuffer.length) return;
        this._resizeIndexBuffer(size);
    }
    _resizeAttributeBuffer(size) {
        const newSize = Math.max(size, this.attributeBuffer.size * 2);
        const newArrayBuffer = new (0, $1PcKb.ViewableBuffer)(newSize);
        (0, $6uids.fastCopy)(this.attributeBuffer.rawBinaryData, newArrayBuffer.rawBinaryData);
        this.attributeBuffer = newArrayBuffer;
    }
    _resizeIndexBuffer(size) {
        const indexBuffer = this.indexBuffer;
        let newSize = Math.max(size, indexBuffer.length * 1.5);
        newSize += newSize % 2;
        const newIndexBuffer = newSize > 65535 ? new Uint32Array(newSize) : new Uint16Array(newSize);
        if (newIndexBuffer.BYTES_PER_ELEMENT !== indexBuffer.BYTES_PER_ELEMENT) for(let i = 0; i < indexBuffer.length; i++)newIndexBuffer[i] = indexBuffer[i];
        else (0, $6uids.fastCopy)(indexBuffer.buffer, newIndexBuffer.buffer);
        this.indexBuffer = newIndexBuffer;
    }
    packQuadIndex(indexBuffer, index, indicesOffset) {
        indexBuffer[index] = indicesOffset + 0;
        indexBuffer[index + 1] = indicesOffset + 1;
        indexBuffer[index + 2] = indicesOffset + 2;
        indexBuffer[index + 3] = indicesOffset + 0;
        indexBuffer[index + 4] = indicesOffset + 2;
        indexBuffer[index + 5] = indicesOffset + 3;
    }
    packIndex(element, indexBuffer, index, indicesOffset) {
        const indices = element.indices;
        const size = element.indexSize;
        const indexOffset = element.indexOffset;
        const attributeOffset = element.attributeOffset;
        for(let i = 0; i < size; i++)indexBuffer[index++] = indicesOffset + indices[i + indexOffset] - attributeOffset;
    }
    /**
   * Destroys the batch and its resources.
   * @param options - destruction options
   * @param options.shader - whether to destroy the associated shader
   */ destroy(options = {}) {
        if (this.batches === null) return;
        for(let i = 0; i < this.batchIndex; i++)$a5af825357f2c2e2$var$returnBatchToPool(this.batches[i]);
        this.batches = null;
        this.geometry.destroy(true);
        this.geometry = null;
        if (options.shader) {
            this.shader?.destroy();
            this.shader = null;
        }
        for(let i = 0; i < this._elements.length; i++)if (this._elements[i]) this._elements[i]._batch = null;
        this._elements = null;
        this.indexBuffer = null;
        this.attributeBuffer.destroy();
        this.attributeBuffer = null;
    }
};
$a5af825357f2c2e2$var$_Batcher.defaultOptions = {
    maxTextures: null,
    attributesInitialSize: 4,
    indicesInitialSize: 6
};
let $a5af825357f2c2e2$export$704b12ddc1dacdd2 = $a5af825357f2c2e2$var$_Batcher;

});
parcelRegister("1PcKb", function(module, exports) {

$parcel$export(module.exports, "ViewableBuffer", () => $6340eddd1da51cf8$export$4fdbf0662aa3047a);
"use strict";
class $6340eddd1da51cf8$export$4fdbf0662aa3047a {
    constructor(sizeOrBuffer){
        if (typeof sizeOrBuffer === "number") this.rawBinaryData = new ArrayBuffer(sizeOrBuffer);
        else if (sizeOrBuffer instanceof Uint8Array) this.rawBinaryData = sizeOrBuffer.buffer;
        else this.rawBinaryData = sizeOrBuffer;
        this.uint32View = new Uint32Array(this.rawBinaryData);
        this.float32View = new Float32Array(this.rawBinaryData);
        this.size = this.rawBinaryData.byteLength;
    }
    /** View on the raw binary data as a `Int8Array`. */ get int8View() {
        if (!this._int8View) this._int8View = new Int8Array(this.rawBinaryData);
        return this._int8View;
    }
    /** View on the raw binary data as a `Uint8Array`. */ get uint8View() {
        if (!this._uint8View) this._uint8View = new Uint8Array(this.rawBinaryData);
        return this._uint8View;
    }
    /**  View on the raw binary data as a `Int16Array`. */ get int16View() {
        if (!this._int16View) this._int16View = new Int16Array(this.rawBinaryData);
        return this._int16View;
    }
    /** View on the raw binary data as a `Int32Array`. */ get int32View() {
        if (!this._int32View) this._int32View = new Int32Array(this.rawBinaryData);
        return this._int32View;
    }
    /** View on the raw binary data as a `Float64Array`. */ get float64View() {
        if (!this._float64Array) this._float64Array = new Float64Array(this.rawBinaryData);
        return this._float64Array;
    }
    /** View on the raw binary data as a `BigUint64Array`. */ get bigUint64View() {
        if (!this._bigUint64Array) this._bigUint64Array = new BigUint64Array(this.rawBinaryData);
        return this._bigUint64Array;
    }
    /**
   * Returns the view of the given type.
   * @param type - One of `int8`, `uint8`, `int16`,
   *    `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - typed array of given type
   */ view(type) {
        return this[`${type}View`];
    }
    /** Destroys all buffer references. Do not use after calling this. */ destroy() {
        this.rawBinaryData = null;
        this.uint32View = null;
        this.float32View = null;
        this.uint16View = null;
        this._int8View = null;
        this._uint8View = null;
        this._int16View = null;
        this._int32View = null;
        this._float64Array = null;
        this._bigUint64Array = null;
    }
    /**
   * Returns the size of the given type in bytes.
   * @param type - One of `int8`, `uint8`, `int16`,
   *   `uint16`, `int32`, `uint32`, and `float32`.
   * @returns - size of the type in bytes
   */ static sizeOf(type) {
        switch(type){
            case "int8":
            case "uint8":
                return 1;
            case "int16":
            case "uint16":
                return 2;
            case "int32":
            case "uint32":
            case "float32":
                return 4;
            default:
                throw new Error(`${type} isn't a valid view type`);
        }
    }
}

});

parcelRegister("lEmAA", function(module, exports) {

$parcel$export(module.exports, "getAdjustedBlendModeBlend", () => $c8eb7d32f5b5e068$export$ab2fc5cf3fe899fe);

var $1SIha = parcelRequire("1SIha");
"use strict";
function $c8eb7d32f5b5e068$export$ab2fc5cf3fe899fe(blendMode, textureSource) {
    if (textureSource.alphaMode === "no-premultiply-alpha") return (0, $1SIha.BLEND_TO_NPM)[blendMode] || blendMode;
    return blendMode;
}

});

parcelRegister("bqYXY", function(module, exports) {

$parcel$export(module.exports, "getMaxTexturesPerBatch", () => $10f5f864b020fa50$export$313b92466c30ee73);

var $9yv3u = parcelRequire("9yv3u");

var $4xevz = parcelRequire("4xevz");
"use strict";
let $10f5f864b020fa50$var$maxTexturesPerBatchCache = null;
function $10f5f864b020fa50$export$313b92466c30ee73() {
    if ($10f5f864b020fa50$var$maxTexturesPerBatchCache) return $10f5f864b020fa50$var$maxTexturesPerBatchCache;
    const gl = (0, $9yv3u.getTestContext)();
    $10f5f864b020fa50$var$maxTexturesPerBatchCache = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    $10f5f864b020fa50$var$maxTexturesPerBatchCache = (0, $4xevz.checkMaxIfStatementsInShader)($10f5f864b020fa50$var$maxTexturesPerBatchCache, gl);
    gl.getExtension("WEBGL_lose_context")?.loseContext();
    return $10f5f864b020fa50$var$maxTexturesPerBatchCache;
}

});
parcelRegister("9yv3u", function(module, exports) {

$parcel$export(module.exports, "getTestContext", () => $3d22dd1de44e0327$export$f034b2d55f8df08b);

var $dHliN = parcelRequire("dHliN");
"use strict";
let $3d22dd1de44e0327$var$context;
function $3d22dd1de44e0327$export$f034b2d55f8df08b() {
    if (!$3d22dd1de44e0327$var$context || $3d22dd1de44e0327$var$context?.isContextLost()) {
        const canvas = (0, $dHliN.DOMAdapter).get().createCanvas();
        $3d22dd1de44e0327$var$context = canvas.getContext("webgl", {});
    }
    return $3d22dd1de44e0327$var$context;
}

});


parcelRegister("ixGJr", function(module, exports) {

$parcel$export(module.exports, "BatchTextureArray", () => $fac8796b18eb0c99$export$aa760e0febf1a758);
"use strict";
class $fac8796b18eb0c99$export$aa760e0febf1a758 {
    constructor(){
        /** Respective locations for textures. */ this.ids = /* @__PURE__ */ Object.create(null);
        this.textures = [];
        this.count = 0;
    }
    /** Clear the textures and their locations. */ clear() {
        for(let i = 0; i < this.count; i++){
            const t = this.textures[i];
            this.textures[i] = null;
            this.ids[t.uid] = null;
        }
        this.count = 0;
    }
}

});


parcelRegister("fJLMg", function(module, exports) {

$parcel$export(module.exports, "BatchGeometry", () => $eece6a9b7767fe9f$export$449e8d355fd68e43);

var $jbDgC = parcelRequire("jbDgC");

var $kQVSf = parcelRequire("kQVSf");

var $h4C0S = parcelRequire("h4C0S");
"use strict";
const $eece6a9b7767fe9f$var$placeHolderBufferData = new Float32Array(1);
const $eece6a9b7767fe9f$var$placeHolderIndexData = new Uint32Array(1);
class $eece6a9b7767fe9f$export$449e8d355fd68e43 extends (0, $h4C0S.Geometry) {
    constructor(){
        const vertexSize = 6;
        const attributeBuffer = new (0, $jbDgC.Buffer)({
            data: $eece6a9b7767fe9f$var$placeHolderBufferData,
            label: "attribute-batch-buffer",
            usage: (0, $kQVSf.BufferUsage).VERTEX | (0, $kQVSf.BufferUsage).COPY_DST,
            shrinkToFit: false
        });
        const indexBuffer = new (0, $jbDgC.Buffer)({
            data: $eece6a9b7767fe9f$var$placeHolderIndexData,
            label: "index-batch-buffer",
            usage: (0, $kQVSf.BufferUsage).INDEX | (0, $kQVSf.BufferUsage).COPY_DST,
            // | BufferUsage.STATIC,
            shrinkToFit: false
        });
        const stride = vertexSize * 4;
        super({
            attributes: {
                aPosition: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 0
                },
                aUV: {
                    buffer: attributeBuffer,
                    format: "float32x2",
                    stride: stride,
                    offset: 8
                },
                aColor: {
                    buffer: attributeBuffer,
                    format: "unorm8x4",
                    stride: stride,
                    offset: 16
                },
                aTextureIdAndRound: {
                    buffer: attributeBuffer,
                    format: "uint16x2",
                    stride: stride,
                    offset: 20
                }
            },
            indexBuffer: indexBuffer
        });
    }
}

});

parcelRegister("ayZpW", function(module, exports) {

$parcel$export(module.exports, "DefaultShader", () => $7e25781e97212d80$export$5ee16216350ebcbc);

var $bKNF0 = parcelRequire("bKNF0");

var $i3anu = parcelRequire("i3anu");

var $dDksv = parcelRequire("dDksv");

var $gKQTw = parcelRequire("gKQTw");

var $4eEfd = parcelRequire("4eEfd");

var $bO5A1 = parcelRequire("bO5A1");
"use strict";
class $7e25781e97212d80$export$5ee16216350ebcbc extends (0, $bO5A1.Shader) {
    constructor(maxTextures){
        const glProgram = (0, $bKNF0.compileHighShaderGlProgram)({
            name: "batch",
            bits: [
                (0, $i3anu.colorBitGl),
                (0, $dDksv.generateTextureBatchBitGl)(maxTextures),
                (0, $gKQTw.roundPixelsBitGl)
            ]
        });
        const gpuProgram = (0, $bKNF0.compileHighShaderGpuProgram)({
            name: "batch",
            bits: [
                (0, $i3anu.colorBit),
                (0, $dDksv.generateTextureBatchBit)(maxTextures),
                (0, $gKQTw.roundPixelsBit)
            ]
        });
        super({
            glProgram: glProgram,
            gpuProgram: gpuProgram,
            resources: {
                batchSamplers: (0, $4eEfd.getBatchSamplersUniformGroup)(maxTextures)
            }
        });
        this.maxTextures = maxTextures;
    }
}

});
parcelRegister("bKNF0", function(module, exports) {

$parcel$export(module.exports, "compileHighShaderGpuProgram", () => $00cff27275ed3ff5$export$af9d352c01aa9018);
$parcel$export(module.exports, "compileHighShaderGlProgram", () => $00cff27275ed3ff5$export$477b8252c7ecdf2);

var $500zs = parcelRequire("500zs");

var $1dFA8 = parcelRequire("1dFA8");

var $tFVp7 = parcelRequire("tFVp7");

var $eTrtM = parcelRequire("eTrtM");

var $gieLR = parcelRequire("gieLR");
"use strict";
function $00cff27275ed3ff5$export$af9d352c01aa9018({ bits: bits, name: name }) {
    const source = (0, $tFVp7.compileHighShader)({
        template: {
            fragment: (0, $eTrtM.fragmentGPUTemplate),
            vertex: (0, $eTrtM.vertexGPUTemplate)
        },
        bits: [
            (0, $gieLR.globalUniformsBit),
            ...bits
        ]
    });
    return (0, $1dFA8.GpuProgram).from({
        name: name,
        vertex: {
            source: source.vertex,
            entryPoint: "main"
        },
        fragment: {
            source: source.fragment,
            entryPoint: "main"
        }
    });
}
function $00cff27275ed3ff5$export$477b8252c7ecdf2({ bits: bits, name: name }) {
    return new (0, $500zs.GlProgram)({
        name: name,
        ...(0, $tFVp7.compileHighShaderGl)({
            template: {
                vertex: (0, $eTrtM.vertexGlTemplate),
                fragment: (0, $eTrtM.fragmentGlTemplate)
            },
            bits: [
                (0, $gieLR.globalUniformsBitGl),
                ...bits
            ]
        })
    });
}

});
parcelRegister("500zs", function(module, exports) {

$parcel$export(module.exports, "GlProgram", () => $1cc574488e791fe4$export$64881d9ea0a969d7);

var $4zaxb = parcelRequire("4zaxb");

var $aYbkD = parcelRequire("aYbkD");

var $bmCbj = parcelRequire("bmCbj");

var $7R0fU = parcelRequire("7R0fU");

var $c8o3G = parcelRequire("c8o3G");

var $ilJl9 = parcelRequire("ilJl9");

var $PWFzQ = parcelRequire("PWFzQ");
"use strict";
const $1cc574488e791fe4$var$processes = {
    stripVersion: // strips any version headers..
    $PWFzQ.stripVersion,
    ensurePrecision: // adds precision string if not already present
    $7R0fU.ensurePrecision,
    addProgramDefines: // add some defines if WebGL1 to make it more compatible with WebGL2 shaders
    $bmCbj.addProgramDefines,
    setProgramName: // add the program name to the shader
    $ilJl9.setProgramName,
    insertVersion: // add the version string to the shader header
    $c8o3G.insertVersion
};
const $1cc574488e791fe4$var$programCache = /* @__PURE__ */ Object.create(null);
const $1cc574488e791fe4$var$_GlProgram = class _GlProgram {
    /**
   * Creates a shiny new GlProgram. Used by WebGL renderer.
   * @param options - The options for the program.
   */ constructor(options){
        options = {
            ..._GlProgram.defaultOptions,
            ...options
        };
        const isES300 = options.fragment.indexOf("#version 300 es") !== -1;
        const preprocessorOptions = {
            stripVersion: isES300,
            ensurePrecision: {
                requestedFragmentPrecision: options.preferredFragmentPrecision,
                requestedVertexPrecision: options.preferredVertexPrecision,
                maxSupportedVertexPrecision: "highp",
                maxSupportedFragmentPrecision: (0, $aYbkD.getMaxFragmentPrecision)()
            },
            setProgramName: {
                name: options.name
            },
            addProgramDefines: isES300,
            insertVersion: isES300
        };
        let fragment = options.fragment;
        let vertex = options.vertex;
        Object.keys($1cc574488e791fe4$var$processes).forEach((processKey)=>{
            const processOptions = preprocessorOptions[processKey];
            fragment = $1cc574488e791fe4$var$processes[processKey](fragment, processOptions, true);
            vertex = $1cc574488e791fe4$var$processes[processKey](vertex, processOptions, false);
        });
        this.fragment = fragment;
        this.vertex = vertex;
        this.transformFeedbackVaryings = options.transformFeedbackVaryings;
        this._key = (0, $4zaxb.createIdFromString)(`${this.vertex}:${this.fragment}`, "gl-program");
    }
    /** destroys the program */ destroy() {
        this.fragment = null;
        this.vertex = null;
        this._attributeData = null;
        this._uniformData = null;
        this._uniformBlockData = null;
        this.transformFeedbackVaryings = null;
        $1cc574488e791fe4$var$programCache[this._cacheKey] = null;
    }
    /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */ static from(options) {
        const key = `${options.vertex}:${options.fragment}`;
        if (!$1cc574488e791fe4$var$programCache[key]) {
            $1cc574488e791fe4$var$programCache[key] = new _GlProgram(options);
            $1cc574488e791fe4$var$programCache[key]._cacheKey = key;
        }
        return $1cc574488e791fe4$var$programCache[key];
    }
};
/** The default options used by the program. */ $1cc574488e791fe4$var$_GlProgram.defaultOptions = {
    preferredVertexPrecision: "highp",
    preferredFragmentPrecision: "mediump"
};
let $1cc574488e791fe4$export$64881d9ea0a969d7 = $1cc574488e791fe4$var$_GlProgram;

});
parcelRegister("4zaxb", function(module, exports) {

$parcel$export(module.exports, "createIdFromString", () => $85965fa645eb365d$export$1e452c36dfe36a93);
"use strict";
const $85965fa645eb365d$var$idCounts = /* @__PURE__ */ Object.create(null);
const $85965fa645eb365d$var$idHash = /* @__PURE__ */ Object.create(null);
function $85965fa645eb365d$export$1e452c36dfe36a93(value, groupId) {
    let id = $85965fa645eb365d$var$idHash[value];
    if (id === void 0) {
        if ($85965fa645eb365d$var$idCounts[groupId] === void 0) $85965fa645eb365d$var$idCounts[groupId] = 1;
        $85965fa645eb365d$var$idHash[value] = id = $85965fa645eb365d$var$idCounts[groupId]++;
    }
    return id;
}

});

parcelRegister("aYbkD", function(module, exports) {

$parcel$export(module.exports, "getMaxFragmentPrecision", () => $d14fd234fd0aa11e$export$428c38e64838140);

var $9yv3u = parcelRequire("9yv3u");
"use strict";
let $d14fd234fd0aa11e$var$maxFragmentPrecision;
function $d14fd234fd0aa11e$export$428c38e64838140() {
    if (!$d14fd234fd0aa11e$var$maxFragmentPrecision) {
        $d14fd234fd0aa11e$var$maxFragmentPrecision = "mediump";
        const gl = (0, $9yv3u.getTestContext)();
        if (gl) {
            if (gl.getShaderPrecisionFormat) {
                const shaderFragment = gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT);
                $d14fd234fd0aa11e$var$maxFragmentPrecision = shaderFragment.precision ? "highp" : "mediump";
            }
        }
    }
    return $d14fd234fd0aa11e$var$maxFragmentPrecision;
}

});

parcelRegister("bmCbj", function(module, exports) {

$parcel$export(module.exports, "addProgramDefines", () => $aa02e34597ce0bab$export$fba00ea8bc676dd1);
"use strict";
function $aa02e34597ce0bab$export$fba00ea8bc676dd1(src, isES300, isFragment) {
    if (isES300) return src;
    if (isFragment) {
        src = src.replace("out vec4 finalColor;", "");
        return `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in varying
        #define finalColor gl_FragColor
        #define texture texture2D
        #endif
        ${src}
        `;
    }
    return `

        #ifdef GL_ES // This checks if it is WebGL1
        #define in attribute
        #define out varying
        #endif
        ${src}
        `;
}

});

parcelRegister("7R0fU", function(module, exports) {

$parcel$export(module.exports, "ensurePrecision", () => $21be9f121d6f85e8$export$899bdffb1b617f8b);
"use strict";
function $21be9f121d6f85e8$export$899bdffb1b617f8b(src, options, isFragment) {
    const maxSupportedPrecision = isFragment ? options.maxSupportedFragmentPrecision : options.maxSupportedVertexPrecision;
    if (src.substring(0, 9) !== "precision") {
        let precision = isFragment ? options.requestedFragmentPrecision : options.requestedVertexPrecision;
        if (precision === "highp" && maxSupportedPrecision !== "highp") precision = "mediump";
        return `precision ${precision} float;
${src}`;
    } else if (maxSupportedPrecision !== "highp" && src.substring(0, 15) === "precision highp") return src.replace("precision highp", "precision mediump");
    return src;
}

});

parcelRegister("c8o3G", function(module, exports) {

$parcel$export(module.exports, "insertVersion", () => $fa7a4cbff0e245fb$export$df5409633d2e06a0);
"use strict";
function $fa7a4cbff0e245fb$export$df5409633d2e06a0(src, isES300) {
    if (!isES300) return src;
    return `#version 300 es
${src}`;
}

});

parcelRegister("ilJl9", function(module, exports) {

$parcel$export(module.exports, "setProgramName", () => $f409173ab294cbfc$export$fcd35f5a80d5e29b);
"use strict";
const $f409173ab294cbfc$var$fragmentNameCache = {};
const $f409173ab294cbfc$var$VertexNameCache = {};
function $f409173ab294cbfc$export$fcd35f5a80d5e29b(src, { name: name = `pixi-program` }, isFragment = true) {
    name = name.replace(/\s+/g, "-");
    name += isFragment ? "-fragment" : "-vertex";
    const nameCache = isFragment ? $f409173ab294cbfc$var$fragmentNameCache : $f409173ab294cbfc$var$VertexNameCache;
    if (nameCache[name]) {
        nameCache[name]++;
        name += `-${nameCache[name]}`;
    } else nameCache[name] = 1;
    if (src.indexOf("#define SHADER_NAME") !== -1) return src;
    const shaderName = `#define SHADER_NAME ${name}`;
    return `${shaderName}
${src}`;
}

});

parcelRegister("PWFzQ", function(module, exports) {

$parcel$export(module.exports, "stripVersion", () => $4c34f2607c3fbe8c$export$f71406e7a553e9e5);
"use strict";
function $4c34f2607c3fbe8c$export$f71406e7a553e9e5(src, isES300) {
    if (!isES300) return src;
    return src.replace("#version 300 es", "");
}

});


parcelRegister("1dFA8", function(module, exports) {

$parcel$export(module.exports, "GpuProgram", () => $6654914d538933ee$export$b7a31a3cdd61870);

var $4zaxb = parcelRequire("4zaxb");

var $2yFuA = parcelRequire("2yFuA");

var $7kprI = parcelRequire("7kprI");

var $3jlpD = parcelRequire("3jlpD");

var $59JUo = parcelRequire("59JUo");

var $bRixD = parcelRequire("bRixD");
"use strict";
const $6654914d538933ee$var$programCache = /* @__PURE__ */ Object.create(null);
class $6654914d538933ee$export$b7a31a3cdd61870 {
    /**
   * Create a new GpuProgram
   * @param options - The options for the gpu program
   */ constructor(options){
        /** @internal */ this._layoutKey = 0;
        /** @internal */ this._attributeLocationsKey = 0;
        const { fragment: fragment, vertex: vertex, layout: layout, gpuLayout: gpuLayout, name: name } = options;
        this.name = name;
        this.fragment = fragment;
        this.vertex = vertex;
        if (fragment.source === vertex.source) {
            const structsAndGroups = (0, $7kprI.extractStructAndGroups)(fragment.source);
            this.structsAndGroups = structsAndGroups;
        } else {
            const vertexStructsAndGroups = (0, $7kprI.extractStructAndGroups)(vertex.source);
            const fragmentStructsAndGroups = (0, $7kprI.extractStructAndGroups)(fragment.source);
            this.structsAndGroups = (0, $bRixD.removeStructAndGroupDuplicates)(vertexStructsAndGroups, fragmentStructsAndGroups);
        }
        this.layout = layout ?? (0, $59JUo.generateLayoutHash)(this.structsAndGroups);
        this.gpuLayout = gpuLayout ?? (0, $3jlpD.generateGpuLayoutGroups)(this.structsAndGroups);
        this.autoAssignGlobalUniforms = !!(this.layout[0]?.globalUniforms !== void 0);
        this.autoAssignLocalUniforms = !!(this.layout[1]?.localUniforms !== void 0);
        this._generateProgramKey();
    }
    // TODO maker this pure
    _generateProgramKey() {
        const { vertex: vertex, fragment: fragment } = this;
        const bigKey = vertex.source + fragment.source + vertex.entryPoint + fragment.entryPoint;
        this._layoutKey = (0, $4zaxb.createIdFromString)(bigKey, "program");
    }
    get attributeData() {
        this._attributeData ?? (this._attributeData = (0, $2yFuA.extractAttributesFromGpuProgram)(this.vertex));
        return this._attributeData;
    }
    /** destroys the program */ destroy() {
        this.gpuLayout = null;
        this.layout = null;
        this.structsAndGroups = null;
        this.fragment = null;
        this.vertex = null;
        $6654914d538933ee$var$programCache[this._cacheKey] = null;
    }
    /**
   * Helper function that creates a program for a given source.
   * It will check the program cache if the program has already been created.
   * If it has that one will be returned, if not a new one will be created and cached.
   * @param options - The options for the program.
   * @returns A program using the same source
   */ static from(options) {
        const key = `${options.vertex.source}:${options.fragment.source}:${options.fragment.entryPoint}:${options.vertex.entryPoint}`;
        if (!$6654914d538933ee$var$programCache[key]) {
            $6654914d538933ee$var$programCache[key] = new $6654914d538933ee$export$b7a31a3cdd61870(options);
            $6654914d538933ee$var$programCache[key]._cacheKey = key;
        }
        return $6654914d538933ee$var$programCache[key];
    }
}

});
parcelRegister("2yFuA", function(module, exports) {

$parcel$export(module.exports, "extractAttributesFromGpuProgram", () => $8674f2f0c14432ee$export$b0efe5f01c53f69f);

var $jqFAF = parcelRequire("jqFAF");
"use strict";
const $8674f2f0c14432ee$var$WGSL_TO_VERTEX_TYPES = {
    f32: "float32",
    "vec2<f32>": "float32x2",
    "vec3<f32>": "float32x3",
    "vec4<f32>": "float32x4",
    vec2f: "float32x2",
    vec3f: "float32x3",
    vec4f: "float32x4",
    i32: "sint32",
    "vec2<i32>": "sint32x2",
    "vec3<i32>": "sint32x3",
    "vec4<i32>": "sint32x4",
    vec2i: "sint32x2",
    vec3i: "sint32x3",
    vec4i: "sint32x4",
    u32: "uint32",
    "vec2<u32>": "uint32x2",
    "vec3<u32>": "uint32x3",
    "vec4<u32>": "uint32x4",
    vec2u: "uint32x2",
    vec3u: "uint32x3",
    vec4u: "uint32x4",
    bool: "uint32",
    "vec2<bool>": "uint32x2",
    "vec3<bool>": "uint32x3",
    "vec4<bool>": "uint32x4"
};
const $8674f2f0c14432ee$var$LOCATION_REGEX = /@location\((\d+)\)\s+([a-zA-Z0-9_]+)\s*:\s*([a-zA-Z0-9_<>]+)(?:,|\s|\)|$)/g;
function $8674f2f0c14432ee$var$parseLocations(str, results) {
    let match;
    while((match = $8674f2f0c14432ee$var$LOCATION_REGEX.exec(str)) !== null){
        const format = $8674f2f0c14432ee$var$WGSL_TO_VERTEX_TYPES[match[3]] ?? "float32";
        results[match[2]] = {
            location: parseInt(match[1], 10),
            format: format,
            stride: (0, $jqFAF.getAttributeInfoFromFormat)(format).stride,
            offset: 0,
            instance: false,
            start: 0
        };
    }
    $8674f2f0c14432ee$var$LOCATION_REGEX.lastIndex = 0;
}
function $8674f2f0c14432ee$var$stripComments(source) {
    return source.replace(/\/\/.*$/gm, "").replace(/\/\*[\s\S]*?\*\//g, "");
}
function $8674f2f0c14432ee$export$b0efe5f01c53f69f({ source: source, entryPoint: entryPoint }) {
    const results = {};
    const cleanSource = $8674f2f0c14432ee$var$stripComments(source);
    const mainVertStart = cleanSource.indexOf(`fn ${entryPoint}(`);
    if (mainVertStart === -1) return results;
    const arrowFunctionStart = cleanSource.indexOf("->", mainVertStart);
    if (arrowFunctionStart === -1) return results;
    const functionArgsSubstring = cleanSource.substring(mainVertStart, arrowFunctionStart);
    $8674f2f0c14432ee$var$parseLocations(functionArgsSubstring, results);
    if (Object.keys(results).length === 0) {
        const structMatch = functionArgsSubstring.match(/\(\s*\w+\s*:\s*(\w+)/);
        if (structMatch) {
            const structName = structMatch[1];
            const structRegex = new RegExp(`struct\\s+${structName}\\s*\\{([^}]+)\\}`, "s");
            const structBody = cleanSource.match(structRegex);
            if (structBody) $8674f2f0c14432ee$var$parseLocations(structBody[1], results);
        }
    }
    return results;
}

});
parcelRegister("jqFAF", function(module, exports) {

$parcel$export(module.exports, "getAttributeInfoFromFormat", () => $dd22030803bd2e89$export$4da509c30cc6be33);
"use strict";
const $dd22030803bd2e89$var$attributeFormatData = {
    uint8x2: {
        size: 2,
        stride: 2,
        normalised: false
    },
    uint8x4: {
        size: 4,
        stride: 4,
        normalised: false
    },
    sint8x2: {
        size: 2,
        stride: 2,
        normalised: false
    },
    sint8x4: {
        size: 4,
        stride: 4,
        normalised: false
    },
    unorm8x2: {
        size: 2,
        stride: 2,
        normalised: true
    },
    unorm8x4: {
        size: 4,
        stride: 4,
        normalised: true
    },
    snorm8x2: {
        size: 2,
        stride: 2,
        normalised: true
    },
    snorm8x4: {
        size: 4,
        stride: 4,
        normalised: true
    },
    uint16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    uint16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    sint16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    sint16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    unorm16x2: {
        size: 2,
        stride: 4,
        normalised: true
    },
    unorm16x4: {
        size: 4,
        stride: 8,
        normalised: true
    },
    snorm16x2: {
        size: 2,
        stride: 4,
        normalised: true
    },
    snorm16x4: {
        size: 4,
        stride: 8,
        normalised: true
    },
    float16x2: {
        size: 2,
        stride: 4,
        normalised: false
    },
    float16x4: {
        size: 4,
        stride: 8,
        normalised: false
    },
    float32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    float32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    float32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    float32x4: {
        size: 4,
        stride: 16,
        normalised: false
    },
    uint32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    uint32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    uint32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    uint32x4: {
        size: 4,
        stride: 16,
        normalised: false
    },
    sint32: {
        size: 1,
        stride: 4,
        normalised: false
    },
    sint32x2: {
        size: 2,
        stride: 8,
        normalised: false
    },
    sint32x3: {
        size: 3,
        stride: 12,
        normalised: false
    },
    sint32x4: {
        size: 4,
        stride: 16,
        normalised: false
    }
};
function $dd22030803bd2e89$export$4da509c30cc6be33(format) {
    return $dd22030803bd2e89$var$attributeFormatData[format] ?? $dd22030803bd2e89$var$attributeFormatData.float32;
}

});


parcelRegister("7kprI", function(module, exports) {

$parcel$export(module.exports, "extractStructAndGroups", () => $027e2c763ecfa0ce$export$368e99a200562975);
"use strict";
function $027e2c763ecfa0ce$export$368e99a200562975(wgsl) {
    const linePattern = /(^|[^/])@(group|binding)\(\d+\)[^;]+;/g;
    const groupPattern = /@group\((\d+)\)/;
    const bindingPattern = /@binding\((\d+)\)/;
    const namePattern = /var(<[^>]+>)? (\w+)/;
    const typePattern = /:\s*([\w<>]+)/;
    const structPattern = /struct\s+(\w+)\s*{([^}]+)}/g;
    const structMemberPattern = /(\w+)\s*:\s*([\w\<\>]+)/g;
    const structName = /struct\s+(\w+)/;
    const groups = wgsl.match(linePattern)?.map((item)=>({
            group: parseInt(item.match(groupPattern)[1], 10),
            binding: parseInt(item.match(bindingPattern)[1], 10),
            name: item.match(namePattern)[2],
            isUniform: item.match(namePattern)[1] === "<uniform>",
            type: item.match(typePattern)[1]
        }));
    if (!groups) return {
        groups: [],
        structs: []
    };
    const structs = wgsl.match(structPattern)?.map((struct)=>{
        const name = struct.match(structName)[1];
        const members = struct.match(structMemberPattern).reduce((acc, member)=>{
            const [name2, type] = member.split(":");
            acc[name2.trim()] = type.trim();
            return acc;
        }, {});
        if (!members) return null;
        return {
            name: name,
            members: members
        };
    }).filter(({ name: name })=>groups.some((group)=>// Handle both direct type matches and generic types like array<StructName>
            group.type === name || group.type.includes(`<${name}>`))) ?? [];
    return {
        groups: groups,
        structs: structs
    };
}

});

parcelRegister("3jlpD", function(module, exports) {

$parcel$export(module.exports, "generateGpuLayoutGroups", () => $edb541484c7306bd$export$950011c0dc347495);

var $2N1MO = parcelRequire("2N1MO");
"use strict";
function $edb541484c7306bd$export$950011c0dc347495({ groups: groups }) {
    const layout = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        if (!layout[group.group]) layout[group.group] = [];
        if (group.isUniform) layout[group.group].push({
            binding: group.binding,
            visibility: (0, $2N1MO.ShaderStage).VERTEX | (0, $2N1MO.ShaderStage).FRAGMENT,
            buffer: {
                type: "uniform"
            }
        });
        else if (group.type === "sampler") layout[group.group].push({
            binding: group.binding,
            visibility: (0, $2N1MO.ShaderStage).FRAGMENT,
            sampler: {
                type: "filtering"
            }
        });
        else if (group.type === "texture_2d" || group.type.startsWith("texture_2d<")) layout[group.group].push({
            binding: group.binding,
            visibility: (0, $2N1MO.ShaderStage).FRAGMENT,
            texture: {
                sampleType: "float",
                viewDimension: "2d",
                multisampled: false
            }
        });
        else if (group.type === "texture_2d_array" || group.type.startsWith("texture_2d_array<")) layout[group.group].push({
            binding: group.binding,
            visibility: (0, $2N1MO.ShaderStage).FRAGMENT,
            texture: {
                sampleType: "float",
                viewDimension: "2d-array",
                multisampled: false
            }
        });
        else if (group.type === "texture_cube" || group.type.startsWith("texture_cube<")) layout[group.group].push({
            binding: group.binding,
            visibility: (0, $2N1MO.ShaderStage).FRAGMENT,
            texture: {
                sampleType: "float",
                viewDimension: "cube",
                multisampled: false
            }
        });
    }
    for(let i = 0; i < layout.length; i++)layout[i] || (layout[i] = []);
    return layout;
}

});
parcelRegister("2N1MO", function(module, exports) {

$parcel$export(module.exports, "ShaderStage", () => $8ce191b3670c97ed$export$34a0cafc5a97ef31);
"use strict";
var $8ce191b3670c97ed$export$34a0cafc5a97ef31 = /* @__PURE__ */ ((ShaderStage2)=>{
    ShaderStage2[ShaderStage2["VERTEX"] = 1] = "VERTEX";
    ShaderStage2[ShaderStage2["FRAGMENT"] = 2] = "FRAGMENT";
    ShaderStage2[ShaderStage2["COMPUTE"] = 4] = "COMPUTE";
    return ShaderStage2;
})($8ce191b3670c97ed$export$34a0cafc5a97ef31 || {});

});


parcelRegister("59JUo", function(module, exports) {

$parcel$export(module.exports, "generateLayoutHash", () => $3cf0c246f40a5ff5$export$6a0f9650f9d4f875);
"use strict";
function $3cf0c246f40a5ff5$export$6a0f9650f9d4f875({ groups: groups }) {
    const layout = [];
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        if (!layout[group.group]) layout[group.group] = {};
        layout[group.group][group.name] = group.binding;
    }
    return layout;
}

});

parcelRegister("bRixD", function(module, exports) {

$parcel$export(module.exports, "removeStructAndGroupDuplicates", () => $ee1b1b1eb6db2c01$export$5f344e20ddfaa2d6);
"use strict";
function $ee1b1b1eb6db2c01$export$5f344e20ddfaa2d6(vertexStructsAndGroups, fragmentStructsAndGroups) {
    const structNameSet = /* @__PURE__ */ new Set();
    const dupeGroupKeySet = /* @__PURE__ */ new Set();
    const structs = [
        ...vertexStructsAndGroups.structs,
        ...fragmentStructsAndGroups.structs
    ].filter((struct)=>{
        if (structNameSet.has(struct.name)) return false;
        structNameSet.add(struct.name);
        return true;
    });
    const groups = [
        ...vertexStructsAndGroups.groups,
        ...fragmentStructsAndGroups.groups
    ].filter((group)=>{
        const key = `${group.name}-${group.binding}`;
        if (dupeGroupKeySet.has(key)) return false;
        dupeGroupKeySet.add(key);
        return true;
    });
    return {
        structs: structs,
        groups: groups
    };
}

});


parcelRegister("tFVp7", function(module, exports) {

$parcel$export(module.exports, "compileHighShader", () => $e90d5e0e6831ff22$export$86219fd7a1c584d2);
$parcel$export(module.exports, "compileHighShaderGl", () => $e90d5e0e6831ff22$export$ff7039b165d48f97);

var $bZ4ob = parcelRequire("bZ4ob");

var $1B5lF = parcelRequire("1B5lF");

var $lk4sb = parcelRequire("lk4sb");

var $lnDTD = parcelRequire("lnDTD");

var $8iU5U = parcelRequire("8iU5U");
"use strict";
const $e90d5e0e6831ff22$var$cacheMap = /* @__PURE__ */ Object.create(null);
const $e90d5e0e6831ff22$var$bitCacheMap = /* @__PURE__ */ new Map();
let $e90d5e0e6831ff22$var$CACHE_UID = 0;
function $e90d5e0e6831ff22$export$86219fd7a1c584d2({ template: template, bits: bits }) {
    const cacheId = $e90d5e0e6831ff22$var$generateCacheId(template, bits);
    if ($e90d5e0e6831ff22$var$cacheMap[cacheId]) return $e90d5e0e6831ff22$var$cacheMap[cacheId];
    const { vertex: vertex, fragment: fragment } = $e90d5e0e6831ff22$var$compileInputsAndOutputs(template, bits);
    $e90d5e0e6831ff22$var$cacheMap[cacheId] = $e90d5e0e6831ff22$var$compileBits(vertex, fragment, bits);
    return $e90d5e0e6831ff22$var$cacheMap[cacheId];
}
function $e90d5e0e6831ff22$export$ff7039b165d48f97({ template: template, bits: bits }) {
    const cacheId = $e90d5e0e6831ff22$var$generateCacheId(template, bits);
    if ($e90d5e0e6831ff22$var$cacheMap[cacheId]) return $e90d5e0e6831ff22$var$cacheMap[cacheId];
    $e90d5e0e6831ff22$var$cacheMap[cacheId] = $e90d5e0e6831ff22$var$compileBits(template.vertex, template.fragment, bits);
    return $e90d5e0e6831ff22$var$cacheMap[cacheId];
}
function $e90d5e0e6831ff22$var$compileInputsAndOutputs(template, bits) {
    const vertexFragments = bits.map((shaderBit)=>shaderBit.vertex).filter((v)=>!!v);
    const fragmentFragments = bits.map((shaderBit)=>shaderBit.fragment).filter((v)=>!!v);
    let compiledVertex = (0, $lk4sb.compileInputs)(vertexFragments, template.vertex, true);
    compiledVertex = (0, $lnDTD.compileOutputs)(vertexFragments, compiledVertex);
    const compiledFragment = (0, $lk4sb.compileInputs)(fragmentFragments, template.fragment, true);
    return {
        vertex: compiledVertex,
        fragment: compiledFragment
    };
}
function $e90d5e0e6831ff22$var$generateCacheId(template, bits) {
    return bits.map((highFragment)=>{
        if (!$e90d5e0e6831ff22$var$bitCacheMap.has(highFragment)) $e90d5e0e6831ff22$var$bitCacheMap.set(highFragment, $e90d5e0e6831ff22$var$CACHE_UID++);
        return $e90d5e0e6831ff22$var$bitCacheMap.get(highFragment);
    }).sort((a, b)=>a - b).join("-") + template.vertex + template.fragment;
}
function $e90d5e0e6831ff22$var$compileBits(vertex, fragment, bits) {
    const vertexParts = (0, $1B5lF.compileHooks)(vertex);
    const fragmentParts = (0, $1B5lF.compileHooks)(fragment);
    bits.forEach((shaderBit)=>{
        (0, $bZ4ob.addBits)(shaderBit.vertex, vertexParts, shaderBit.name);
        (0, $bZ4ob.addBits)(shaderBit.fragment, fragmentParts, shaderBit.name);
    });
    return {
        vertex: (0, $8iU5U.injectBits)(vertex, vertexParts),
        fragment: (0, $8iU5U.injectBits)(fragment, fragmentParts)
    };
}

});
parcelRegister("bZ4ob", function(module, exports) {

$parcel$export(module.exports, "addBits", () => $1424ffed857d3a1d$export$38c21fb192fe3d9);

var $fGITk = parcelRequire("fGITk");
"use strict";
function $1424ffed857d3a1d$export$38c21fb192fe3d9(srcParts, parts, name) {
    if (srcParts) for(const i in srcParts){
        const id = i.toLocaleLowerCase();
        const part = parts[id];
        if (part) {
            let sanitisedPart = srcParts[i];
            if (i === "header") sanitisedPart = sanitisedPart.replace(/@in\s+[^;]+;\s*/g, "").replace(/@out\s+[^;]+;\s*/g, "");
            if (name) part.push(`//----${name}----//`);
            part.push(sanitisedPart);
        } else (0, $fGITk.warn)(`${i} placement hook does not exist in shader`);
    }
}

});

parcelRegister("1B5lF", function(module, exports) {

$parcel$export(module.exports, "compileHooks", () => $ca1c35c0d46965c1$export$17705ba43ca63936);
"use strict";
const $ca1c35c0d46965c1$var$findHooksRx = /\{\{(.*?)\}\}/g;
function $ca1c35c0d46965c1$export$17705ba43ca63936(programSrc) {
    const parts = {};
    const partMatches = programSrc.match($ca1c35c0d46965c1$var$findHooksRx)?.map((hook)=>hook.replace(/[{()}]/g, "")) ?? [];
    partMatches.forEach((hook)=>{
        parts[hook] = [];
    });
    return parts;
}

});

parcelRegister("lk4sb", function(module, exports) {

$parcel$export(module.exports, "compileInputs", () => $448d478ebe90b3ed$export$aa47df9391ef0455);
"use strict";
function $448d478ebe90b3ed$var$extractInputs(fragmentSource, out) {
    let match;
    const regex = /@in\s+([^;]+);/g;
    while((match = regex.exec(fragmentSource)) !== null)out.push(match[1]);
}
function $448d478ebe90b3ed$export$aa47df9391ef0455(fragments, template, sort = false) {
    const results = [];
    $448d478ebe90b3ed$var$extractInputs(template, results);
    fragments.forEach((fragment)=>{
        if (fragment.header) $448d478ebe90b3ed$var$extractInputs(fragment.header, results);
    });
    const mainInput = results;
    if (sort) mainInput.sort();
    const finalString = mainInput.map((inValue, i)=>`       @location(${i}) ${inValue},`).join("\n");
    let cleanedString = template.replace(/@in\s+[^;]+;\s*/g, "");
    cleanedString = cleanedString.replace("{{in}}", `
${finalString}
`);
    return cleanedString;
}

});

parcelRegister("lnDTD", function(module, exports) {

$parcel$export(module.exports, "compileOutputs", () => $c965eac670338d6c$export$ae19cc473c7ab18);
"use strict";
function $c965eac670338d6c$var$extractOutputs(fragmentSource, out) {
    let match;
    const regex = /@out\s+([^;]+);/g;
    while((match = regex.exec(fragmentSource)) !== null)out.push(match[1]);
}
function $c965eac670338d6c$var$extractVariableName(value) {
    const regex = /\b(\w+)\s*:/g;
    const match = regex.exec(value);
    return match ? match[1] : "";
}
function $c965eac670338d6c$var$stripVariable(value) {
    const regex = /@.*?\s+/g;
    return value.replace(regex, "");
}
function $c965eac670338d6c$export$ae19cc473c7ab18(fragments, template) {
    const results = [];
    $c965eac670338d6c$var$extractOutputs(template, results);
    fragments.forEach((fragment)=>{
        if (fragment.header) $c965eac670338d6c$var$extractOutputs(fragment.header, results);
    });
    let index = 0;
    const mainStruct = results.sort().map((inValue)=>{
        if (inValue.indexOf("builtin") > -1) return inValue;
        return `@location(${index++}) ${inValue}`;
    }).join(",\n");
    const mainStart = results.sort().map((inValue)=>`       var ${$c965eac670338d6c$var$stripVariable(inValue)};`).join("\n");
    const mainEnd = `return VSOutput(
            ${results.sort().map((inValue)=>` ${$c965eac670338d6c$var$extractVariableName(inValue)}`).join(",\n")});`;
    let compiledCode = template.replace(/@out\s+[^;]+;\s*/g, "");
    compiledCode = compiledCode.replace("{{struct}}", `
${mainStruct}
`);
    compiledCode = compiledCode.replace("{{start}}", `
${mainStart}
`);
    compiledCode = compiledCode.replace("{{return}}", `
${mainEnd}
`);
    return compiledCode;
}

});

parcelRegister("8iU5U", function(module, exports) {

$parcel$export(module.exports, "injectBits", () => $f782761a35ffc498$export$83c47c7340456c75);
"use strict";
function $f782761a35ffc498$export$83c47c7340456c75(templateSrc, fragmentParts) {
    let out = templateSrc;
    for(const i in fragmentParts){
        const parts = fragmentParts[i];
        const toInject = parts.join("\n");
        if (toInject.length) out = out.replace(`{{${i}}}`, `//-----${i} START-----//
${parts.join("\n")}
//----${i} FINISH----//`);
        else out = out.replace(`{{${i}}}`, "");
    }
    return out;
}

});


parcelRegister("eTrtM", function(module, exports) {

$parcel$export(module.exports, "vertexGPUTemplate", () => $e475f33d8e1040ef$export$61ecfa8d2718163a);
$parcel$export(module.exports, "fragmentGPUTemplate", () => $e475f33d8e1040ef$export$922d1073ee2ef930);
$parcel$export(module.exports, "vertexGlTemplate", () => $e475f33d8e1040ef$export$99b0f79e15be8ede);
$parcel$export(module.exports, "fragmentGlTemplate", () => $e475f33d8e1040ef$export$3f7784dd6a13ff5a);
"use strict";
const $e475f33d8e1040ef$export$61ecfa8d2718163a = /* wgsl */ `
    @in aPosition: vec2<f32>;
    @in aUV: vec2<f32>;

    @out @builtin(position) vPosition: vec4<f32>;
    @out vUV : vec2<f32>;
    @out vColor : vec4<f32>;

    {{header}}

    struct VSOutput {
        {{struct}}
    };

    @vertex
    fn main( {{in}} ) -> VSOutput {

        var worldTransformMatrix = globalUniforms.uWorldTransformMatrix;
        var modelMatrix = mat3x3<f32>(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        var position = aPosition;
        var uv = aUV;

        {{start}}

        vColor = vec4<f32>(1., 1., 1., 1.);

        {{main}}

        vUV = uv;

        var modelViewProjectionMatrix = globalUniforms.uProjectionMatrix * worldTransformMatrix * modelMatrix;

        vPosition =  vec4<f32>((modelViewProjectionMatrix *  vec3<f32>(position, 1.0)).xy, 0.0, 1.0);

        vColor *= globalUniforms.uWorldColorAlpha;

        {{end}}

        {{return}}
    };
`;
const $e475f33d8e1040ef$export$922d1073ee2ef930 = /* wgsl */ `
    @in vUV : vec2<f32>;
    @in vColor : vec4<f32>;

    {{header}}

    @fragment
    fn main(
        {{in}}
      ) -> @location(0) vec4<f32> {

        {{start}}

        var outColor:vec4<f32>;

        {{main}}

        var finalColor:vec4<f32> = outColor * vColor;

        {{end}}

        return finalColor;
      };
`;
const $e475f33d8e1040ef$export$99b0f79e15be8ede = /* glsl */ `
    in vec2 aPosition;
    in vec2 aUV;

    out vec4 vColor;
    out vec2 vUV;

    {{header}}

    void main(void){

        mat3 worldTransformMatrix = uWorldTransformMatrix;
        mat3 modelMatrix = mat3(
            1.0, 0.0, 0.0,
            0.0, 1.0, 0.0,
            0.0, 0.0, 1.0
          );
        vec2 position = aPosition;
        vec2 uv = aUV;

        {{start}}

        vColor = vec4(1.);

        {{main}}

        vUV = uv;

        mat3 modelViewProjectionMatrix = uProjectionMatrix * worldTransformMatrix * modelMatrix;

        gl_Position = vec4((modelViewProjectionMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);

        vColor *= uWorldColorAlpha;

        {{end}}
    }
`;
const $e475f33d8e1040ef$export$3f7784dd6a13ff5a = /* glsl */ `

    in vec4 vColor;
    in vec2 vUV;

    out vec4 finalColor;

    {{header}}

    void main(void) {

        {{start}}

        vec4 outColor;

        {{main}}

        finalColor = outColor * vColor;

        {{end}}
    }
`;

});

parcelRegister("gieLR", function(module, exports) {

$parcel$export(module.exports, "globalUniformsBit", () => $081ce3ac1776a1e6$export$435d64b3a14c5a51);
$parcel$export(module.exports, "globalUniformsBitGl", () => $081ce3ac1776a1e6$export$38608853d4735d51);
"use strict";
const $081ce3ac1776a1e6$export$435d64b3a14c5a51 = {
    name: "global-uniforms-bit",
    vertex: {
        header: /* wgsl */ `
        struct GlobalUniforms {
            uProjectionMatrix:mat3x3<f32>,
            uWorldTransformMatrix:mat3x3<f32>,
            uWorldColorAlpha: vec4<f32>,
            uResolution: vec2<f32>,
        }

        @group(0) @binding(0) var<uniform> globalUniforms : GlobalUniforms;
        `
    }
};
const $081ce3ac1776a1e6$export$320b7a2ae65b2f3a = {
    name: "global-uniforms-ubo-bit",
    vertex: {
        header: /* glsl */ `
          uniform globalUniforms {
            mat3 uProjectionMatrix;
            mat3 uWorldTransformMatrix;
            vec4 uWorldColorAlpha;
            vec2 uResolution;
          };
        `
    }
};
const $081ce3ac1776a1e6$export$38608853d4735d51 = {
    name: "global-uniforms-bit",
    vertex: {
        header: /* glsl */ `
          uniform mat3 uProjectionMatrix;
          uniform mat3 uWorldTransformMatrix;
          uniform vec4 uWorldColorAlpha;
          uniform vec2 uResolution;
        `
    }
};

});


parcelRegister("i3anu", function(module, exports) {

$parcel$export(module.exports, "colorBit", () => $5e8ba652308bd635$export$a62becfe5fe4ad2);
$parcel$export(module.exports, "colorBitGl", () => $5e8ba652308bd635$export$93189e9821cf4459);
"use strict";
const $5e8ba652308bd635$export$a62becfe5fe4ad2 = {
    name: "color-bit",
    vertex: {
        header: /* wgsl */ `
            @in aColor: vec4<f32>;
        `,
        main: /* wgsl */ `
            vColor *= vec4<f32>(aColor.rgb * aColor.a, aColor.a);
        `
    }
};
const $5e8ba652308bd635$export$93189e9821cf4459 = {
    name: "color-bit",
    vertex: {
        header: /* glsl */ `
            in vec4 aColor;
        `,
        main: /* glsl */ `
            vColor *= vec4(aColor.rgb * aColor.a, aColor.a);
        `
    }
};

});

parcelRegister("dDksv", function(module, exports) {

$parcel$export(module.exports, "generateTextureBatchBit", () => $a5c6532b64ef743c$export$aff2d36945cda647);
$parcel$export(module.exports, "generateTextureBatchBitGl", () => $a5c6532b64ef743c$export$204e46d9a7a4f835);
"use strict";
const $a5c6532b64ef743c$var$textureBatchBitGpuCache = {};
function $a5c6532b64ef743c$var$generateBindingSrc(maxTextures) {
    const src = [];
    if (maxTextures === 1) {
        src.push("@group(1) @binding(0) var textureSource1: texture_2d<f32>;");
        src.push("@group(1) @binding(1) var textureSampler1: sampler;");
    } else {
        let bindingIndex = 0;
        for(let i = 0; i < maxTextures; i++){
            src.push(`@group(1) @binding(${bindingIndex++}) var textureSource${i + 1}: texture_2d<f32>;`);
            src.push(`@group(1) @binding(${bindingIndex++}) var textureSampler${i + 1}: sampler;`);
        }
    }
    return src.join("\n");
}
function $a5c6532b64ef743c$var$generateSampleSrc(maxTextures) {
    const src = [];
    if (maxTextures === 1) src.push("outColor = textureSampleGrad(textureSource1, textureSampler1, vUV, uvDx, uvDy);");
    else {
        src.push("switch vTextureId {");
        for(let i = 0; i < maxTextures; i++){
            if (i === maxTextures - 1) src.push(`  default:{`);
            else src.push(`  case ${i}:{`);
            src.push(`      outColor = textureSampleGrad(textureSource${i + 1}, textureSampler${i + 1}, vUV, uvDx, uvDy);`);
            src.push(`      break;}`);
        }
        src.push(`}`);
    }
    return src.join("\n");
}
function $a5c6532b64ef743c$export$aff2d36945cda647(maxTextures) {
    if (!$a5c6532b64ef743c$var$textureBatchBitGpuCache[maxTextures]) $a5c6532b64ef743c$var$textureBatchBitGpuCache[maxTextures] = {
        name: "texture-batch-bit",
        vertex: {
            header: `
                @in aTextureIdAndRound: vec2<u32>;
                @out @interpolate(flat) vTextureId : u32;
            `,
            main: `
                vTextureId = aTextureIdAndRound.y;
            `,
            end: `
                if(aTextureIdAndRound.x == 1)
                {
                    vPosition = vec4<f32>(roundPixels(vPosition.xy, globalUniforms.uResolution), vPosition.zw);
                }
            `
        },
        fragment: {
            header: `
                @in @interpolate(flat) vTextureId: u32;

                ${$a5c6532b64ef743c$var$generateBindingSrc(maxTextures)}
            `,
            main: `
                var uvDx = dpdx(vUV);
                var uvDy = dpdy(vUV);

                ${$a5c6532b64ef743c$var$generateSampleSrc(maxTextures)}
            `
        }
    };
    return $a5c6532b64ef743c$var$textureBatchBitGpuCache[maxTextures];
}
const $a5c6532b64ef743c$var$textureBatchBitGlCache = {};
function $a5c6532b64ef743c$var$generateSampleGlSrc(maxTextures) {
    const src = [];
    for(let i = 0; i < maxTextures; i++){
        if (i > 0) src.push("else");
        if (i < maxTextures - 1) src.push(`if(vTextureId < ${i}.5)`);
        src.push("{");
        src.push(`	outColor = texture(uTextures[${i}], vUV);`);
        src.push("}");
    }
    return src.join("\n");
}
function $a5c6532b64ef743c$export$204e46d9a7a4f835(maxTextures) {
    if (!$a5c6532b64ef743c$var$textureBatchBitGlCache[maxTextures]) $a5c6532b64ef743c$var$textureBatchBitGlCache[maxTextures] = {
        name: "texture-batch-bit",
        vertex: {
            header: `
                in vec2 aTextureIdAndRound;
                out float vTextureId;

            `,
            main: `
                vTextureId = aTextureIdAndRound.y;
            `,
            end: `
                if(aTextureIdAndRound.x == 1.)
                {
                    gl_Position.xy = roundPixels(gl_Position.xy, uResolution);
                }
            `
        },
        fragment: {
            header: `
                in float vTextureId;

                uniform sampler2D uTextures[${maxTextures}];

            `,
            main: `

                ${$a5c6532b64ef743c$var$generateSampleGlSrc(maxTextures)}
            `
        }
    };
    return $a5c6532b64ef743c$var$textureBatchBitGlCache[maxTextures];
}

});

parcelRegister("gKQTw", function(module, exports) {

$parcel$export(module.exports, "roundPixelsBit", () => $757df967de9801f4$export$22150169726f7b1);
$parcel$export(module.exports, "roundPixelsBitGl", () => $757df967de9801f4$export$222909710f39cc5);
"use strict";
const $757df967de9801f4$export$22150169726f7b1 = {
    name: "round-pixels-bit",
    vertex: {
        header: /* wgsl */ `
            fn roundPixels(position: vec2<f32>, targetSize: vec2<f32>) -> vec2<f32>
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    }
};
const $757df967de9801f4$export$222909710f39cc5 = {
    name: "round-pixels-bit",
    vertex: {
        header: /* glsl */ `
            vec2 roundPixels(vec2 position, vec2 targetSize)
            {
                return (floor(((position * 0.5 + 0.5) * targetSize) + 0.5) / targetSize) * 2.0 - 1.0;
            }
        `
    }
};

});

parcelRegister("4eEfd", function(module, exports) {

$parcel$export(module.exports, "getBatchSamplersUniformGroup", () => $c95185d2b88130d0$export$5fc8295c6cba6ffe);

var $cUeqr = parcelRequire("cUeqr");
"use strict";
const $c95185d2b88130d0$var$batchSamplersUniformGroupHash = {};
function $c95185d2b88130d0$export$5fc8295c6cba6ffe(maxTextures) {
    let batchSamplersUniformGroup = $c95185d2b88130d0$var$batchSamplersUniformGroupHash[maxTextures];
    if (batchSamplersUniformGroup) return batchSamplersUniformGroup;
    const sampleValues = new Int32Array(maxTextures);
    for(let i = 0; i < maxTextures; i++)sampleValues[i] = i;
    batchSamplersUniformGroup = $c95185d2b88130d0$var$batchSamplersUniformGroupHash[maxTextures] = new (0, $cUeqr.UniformGroup)({
        uTextures: {
            value: sampleValues,
            type: `i32`,
            size: maxTextures
        }
    }, {
        isStatic: true
    });
    return batchSamplersUniformGroup;
}

});
parcelRegister("cUeqr", function(module, exports) {

$parcel$export(module.exports, "UniformGroup", () => $b868d6403b571dc9$export$6601a7a2dcf79bf5);

var $kfwXR = parcelRequire("kfwXR");

var $4zaxb = parcelRequire("4zaxb");

var $3EOR3 = parcelRequire("3EOR3");

var $a74GC = parcelRequire("a74GC");
"use strict";
const $b868d6403b571dc9$var$_UniformGroup = class _UniformGroup {
    /**
   * Create a new Uniform group
   * @param uniformStructures - The structures of the uniform group
   * @param options - The optional parameters of this uniform group
   */ constructor(uniformStructures, options){
        /**
     * used internally to know if a uniform group was used in the last render pass
     * @internal
     */ this._touched = 0;
        /** a unique id for this uniform group used through the renderer */ this.uid = (0, $kfwXR.uid)("uniform");
        /**
     * a resource type, used to identify how to handle it when its in a bind group / shader resource
     * @internal
     */ this._resourceType = "uniformGroup";
        /**
     * the resource id used internally by the renderer to build bind group keys
     * @internal
     */ this._resourceId = (0, $kfwXR.uid)("resource");
        /** used ito identify if this is a uniform group */ this.isUniformGroup = true;
        /**
     * used to flag if this Uniform groups data is different from what it has stored in its buffer / on the GPU
     * @internal
     */ this._dirtyId = 0;
        // implementing the interface - UniformGroup are not destroyed
        this.destroyed = false;
        options = {
            ..._UniformGroup.defaultOptions,
            ...options
        };
        this.uniformStructures = uniformStructures;
        const uniforms = {};
        for(const i in uniformStructures){
            const uniformData = uniformStructures[i];
            uniformData.name = i;
            uniformData.size = uniformData.size ?? 1;
            if (!(0, $3EOR3.UNIFORM_TYPES_MAP)[uniformData.type]) {
                const arrayMatch = uniformData.type.match(/^array<(\w+(?:<\w+>)?),\s*(\d+)>$/);
                if (arrayMatch) {
                    const [, innerType, size] = arrayMatch;
                    throw new Error(`Uniform type ${uniformData.type} is not supported. Use type: '${innerType}', size: ${size} instead.`);
                }
                throw new Error(`Uniform type ${uniformData.type} is not supported. Supported uniform types are: ${(0, $3EOR3.UNIFORM_TYPES_VALUES).join(", ")}`);
            }
            uniformData.value ?? (uniformData.value = (0, $a74GC.getDefaultUniformValue)(uniformData.type, uniformData.size));
            uniforms[i] = uniformData.value;
        }
        this.uniforms = uniforms;
        this._dirtyId = 1;
        this.ubo = options.ubo;
        this.isStatic = options.isStatic;
        this._signature = (0, $4zaxb.createIdFromString)(Object.keys(uniforms).map((i)=>`${i}-${uniformStructures[i].type}`).join("-"), "uniform-group");
    }
    /** Call this if you want the uniform groups data to be uploaded to the GPU only useful if `isStatic` is true. */ update() {
        this._dirtyId++;
    }
};
/** The default options used by the uniform group. */ $b868d6403b571dc9$var$_UniformGroup.defaultOptions = {
    /** if true the UniformGroup is handled as an Uniform buffer object. */ ubo: false,
    /** if true, then you are responsible for when the data is uploaded to the GPU by calling `update()` */ isStatic: false
};
let $b868d6403b571dc9$export$6601a7a2dcf79bf5 = $b868d6403b571dc9$var$_UniformGroup;

});
parcelRegister("3EOR3", function(module, exports) {

$parcel$export(module.exports, "UNIFORM_TYPES_VALUES", () => $3d74a3ae674644d7$export$94ae83f3c0da5990);
$parcel$export(module.exports, "UNIFORM_TYPES_MAP", () => $3d74a3ae674644d7$export$97ddd6675231876e);
"use strict";
const $3d74a3ae674644d7$export$94ae83f3c0da5990 = [
    "f32",
    "i32",
    "vec2<f32>",
    "vec3<f32>",
    "vec4<f32>",
    "mat2x2<f32>",
    "mat3x3<f32>",
    "mat4x4<f32>",
    "mat3x2<f32>",
    "mat4x2<f32>",
    "mat2x3<f32>",
    "mat4x3<f32>",
    "mat2x4<f32>",
    "mat3x4<f32>",
    "vec2<i32>",
    "vec3<i32>",
    "vec4<i32>"
];
const $3d74a3ae674644d7$export$97ddd6675231876e = $3d74a3ae674644d7$export$94ae83f3c0da5990.reduce((acc, type)=>{
    acc[type] = true;
    return acc;
}, {});

});

parcelRegister("a74GC", function(module, exports) {

$parcel$export(module.exports, "getDefaultUniformValue", () => $54c5f9d984a17d53$export$7febdb6905805c3d);
"use strict";
function $54c5f9d984a17d53$export$7febdb6905805c3d(type, size) {
    switch(type){
        case "f32":
            return 0;
        case "vec2<f32>":
            return new Float32Array(2 * size);
        case "vec3<f32>":
            return new Float32Array(3 * size);
        case "vec4<f32>":
            return new Float32Array(4 * size);
        case "mat2x2<f32>":
            return new Float32Array([
                1,
                0,
                0,
                1
            ]);
        case "mat3x3<f32>":
            return new Float32Array([
                1,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                1
            ]);
        case "mat4x4<f32>":
            return new Float32Array([
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ]);
    }
    return null;
}

});



parcelRegister("bO5A1", function(module, exports) {

$parcel$export(module.exports, "Shader", () => $6830a7dd0a1b58ca$export$462bb059fed9d9e5);

var $6AQ4q = parcelRequire("6AQ4q");

var $kfwXR = parcelRequire("kfwXR");

var $500zs = parcelRequire("500zs");

var $cntNn = parcelRequire("cntNn");

var $1dFA8 = parcelRequire("1dFA8");

var $15BVx = parcelRequire("15BVx");

var $cUeqr = parcelRequire("cUeqr");
"use strict";
class $6830a7dd0a1b58ca$export$462bb059fed9d9e5 extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    constructor(options){
        super();
        /** A unique identifier for the shader */ this.uid = (0, $kfwXR.uid)("shader");
        /**
     * A record of the uniform groups and resources used by the shader.
     * This is used by WebGL renderer to sync uniform data.
     * @internal
     */ this._uniformBindMap = /* @__PURE__ */ Object.create(null);
        this._ownedBindGroups = [];
        /** @internal */ this._destroyed = false;
        let { gpuProgram: gpuProgram, glProgram: glProgram, groups: groups, resources: resources, compatibleRenderers: compatibleRenderers, groupMap: groupMap } = options;
        this.gpuProgram = gpuProgram;
        this.glProgram = glProgram;
        if (compatibleRenderers === void 0) {
            compatibleRenderers = 0;
            if (gpuProgram) compatibleRenderers |= (0, $15BVx.RendererType).WEBGPU;
            if (glProgram) compatibleRenderers |= (0, $15BVx.RendererType).WEBGL;
        }
        this.compatibleRenderers = compatibleRenderers;
        const nameHash = {};
        if (!resources && !groups) resources = {};
        if (resources && groups) throw new Error("[Shader] Cannot have both resources and groups");
        else if (!gpuProgram && groups && !groupMap) throw new Error("[Shader] No group map or WebGPU shader provided - consider using resources instead.");
        else if (!gpuProgram && groups && groupMap) {
            for(const i in groupMap)for(const j in groupMap[i]){
                const uniformName = groupMap[i][j];
                nameHash[uniformName] = {
                    group: i,
                    binding: j,
                    name: uniformName
                };
            }
        } else if (gpuProgram && groups && !groupMap) {
            const groupData = gpuProgram.structsAndGroups.groups;
            groupMap = {};
            groupData.forEach((data)=>{
                groupMap[data.group] = groupMap[data.group] || {};
                groupMap[data.group][data.binding] = data.name;
                nameHash[data.name] = data;
            });
        } else if (resources) {
            groups = {};
            groupMap = {};
            if (gpuProgram) {
                const groupData = gpuProgram.structsAndGroups.groups;
                groupData.forEach((data)=>{
                    groupMap[data.group] = groupMap[data.group] || {};
                    groupMap[data.group][data.binding] = data.name;
                    nameHash[data.name] = data;
                });
            }
            let bindTick = 0;
            for(const i in resources){
                if (nameHash[i]) continue;
                if (!groups[99]) {
                    groups[99] = new (0, $cntNn.BindGroup)();
                    this._ownedBindGroups.push(groups[99]);
                }
                nameHash[i] = {
                    group: 99,
                    binding: bindTick,
                    name: i
                };
                groupMap[99] = groupMap[99] || {};
                groupMap[99][bindTick] = i;
                bindTick++;
            }
            for(const i in resources){
                const name = i;
                let value = resources[i];
                if (!value.source && !value._resourceType) value = new (0, $cUeqr.UniformGroup)(value);
                const data = nameHash[name];
                if (data) {
                    if (!groups[data.group]) {
                        groups[data.group] = new (0, $cntNn.BindGroup)();
                        this._ownedBindGroups.push(groups[data.group]);
                    }
                    groups[data.group].setResource(value, data.binding);
                }
            }
        }
        this.groups = groups;
        this._uniformBindMap = groupMap;
        this.resources = this._buildResourceAccessor(groups, nameHash);
    }
    /**
   * Sometimes a resource group will be provided later (for example global uniforms)
   * In such cases, this method can be used to let the shader know about the group.
   * @param name - the name of the resource group
   * @param groupIndex - the index of the group (should match the webGPU shader group location)
   * @param bindIndex - the index of the bind point (should match the webGPU shader bind point)
   */ addResource(name, groupIndex, bindIndex) {
        var _a, _b;
        (_a = this._uniformBindMap)[groupIndex] || (_a[groupIndex] = {});
        (_b = this._uniformBindMap[groupIndex])[bindIndex] || (_b[bindIndex] = name);
        if (!this.groups[groupIndex]) {
            this.groups[groupIndex] = new (0, $cntNn.BindGroup)();
            this._ownedBindGroups.push(this.groups[groupIndex]);
        }
    }
    _buildResourceAccessor(groups, nameHash) {
        const uniformsOut = {};
        for(const i in nameHash){
            const data = nameHash[i];
            Object.defineProperty(uniformsOut, data.name, {
                get () {
                    return groups[data.group].getResource(data.binding);
                },
                set (value) {
                    groups[data.group].setResource(value, data.binding);
                }
            });
        }
        return uniformsOut;
    }
    /**
   * Use to destroy the shader when its not longer needed.
   * It will destroy the resources and remove listeners.
   * @param destroyPrograms - if the programs should be destroyed as well.
   * Make sure its not being used by other shaders!
   */ destroy(destroyPrograms = false) {
        if (this._destroyed) return;
        this._destroyed = true;
        this.emit("destroy", this);
        if (destroyPrograms) {
            this.gpuProgram?.destroy();
            this.glProgram?.destroy();
        }
        this.gpuProgram = null;
        this.glProgram = null;
        this.removeAllListeners();
        this._uniformBindMap = null;
        this._ownedBindGroups.forEach((bindGroup)=>{
            bindGroup.destroy();
        });
        this._ownedBindGroups = null;
        this.resources = null;
        this.groups = null;
    }
    static from(options) {
        const { gpu: gpu, gl: gl, ...rest } = options;
        let gpuProgram;
        let glProgram;
        if (gpu) gpuProgram = (0, $1dFA8.GpuProgram).from(gpu);
        if (gl) glProgram = (0, $500zs.GlProgram).from(gl);
        return new $6830a7dd0a1b58ca$export$462bb059fed9d9e5({
            gpuProgram: gpuProgram,
            glProgram: glProgram,
            ...rest
        });
    }
}

});
parcelRegister("15BVx", function(module, exports) {

$parcel$export(module.exports, "RendererType", () => $b3f88a9109a56cbf$export$2ca8315eebe81c3d);
"use strict";
var $b3f88a9109a56cbf$export$2ca8315eebe81c3d = /* @__PURE__ */ ((RendererType2)=>{
    RendererType2[RendererType2["WEBGL"] = 1] = "WEBGL";
    RendererType2[RendererType2["WEBGPU"] = 2] = "WEBGPU";
    RendererType2[RendererType2["CANVAS"] = 4] = "CANVAS";
    RendererType2[RendererType2["BOTH"] = 3] = "BOTH";
    return RendererType2;
})($b3f88a9109a56cbf$export$2ca8315eebe81c3d || {});

});




parcelRegister("8xcvq", function(module, exports) {

$parcel$export(module.exports, "State", () => $057ce09b55579ee8$export$7254cc27399e90bd);
"use strict";
const $057ce09b55579ee8$var$blendModeIds = {
    normal: 0,
    add: 1,
    multiply: 2,
    screen: 3,
    overlay: 4,
    erase: 5,
    "normal-npm": 6,
    "add-npm": 7,
    "screen-npm": 8,
    min: 9,
    max: 10
};
const $057ce09b55579ee8$var$BLEND = 0;
const $057ce09b55579ee8$var$OFFSET = 1;
const $057ce09b55579ee8$var$CULLING = 2;
const $057ce09b55579ee8$var$DEPTH_TEST = 3;
const $057ce09b55579ee8$var$WINDING = 4;
const $057ce09b55579ee8$var$DEPTH_MASK = 5;
const $057ce09b55579ee8$var$_State = class _State {
    constructor(){
        this.data = 0;
        this.blendMode = "normal";
        this.polygonOffset = 0;
        this.blend = true;
        this.depthMask = true;
    }
    /**
   * Activates blending of the computed fragment color values.
   * @default true
   */ get blend() {
        return !!(this.data & 1 << $057ce09b55579ee8$var$BLEND);
    }
    set blend(value) {
        if (!!(this.data & 1 << $057ce09b55579ee8$var$BLEND) !== value) this.data ^= 1 << $057ce09b55579ee8$var$BLEND;
    }
    /**
   * Activates adding an offset to depth values of polygon's fragments
   * @default false
   */ get offsets() {
        return !!(this.data & 1 << $057ce09b55579ee8$var$OFFSET);
    }
    set offsets(value) {
        if (!!(this.data & 1 << $057ce09b55579ee8$var$OFFSET) !== value) this.data ^= 1 << $057ce09b55579ee8$var$OFFSET;
    }
    /** The culling settings for this state none - No culling back - Back face culling front - Front face culling */ set cullMode(value) {
        if (value === "none") {
            this.culling = false;
            return;
        }
        this.culling = true;
        this.clockwiseFrontFace = value === "front";
    }
    get cullMode() {
        if (!this.culling) return "none";
        return this.clockwiseFrontFace ? "front" : "back";
    }
    /**
   * Activates culling of polygons.
   * @default false
   */ get culling() {
        return !!(this.data & 1 << $057ce09b55579ee8$var$CULLING);
    }
    set culling(value) {
        if (!!(this.data & 1 << $057ce09b55579ee8$var$CULLING) !== value) this.data ^= 1 << $057ce09b55579ee8$var$CULLING;
    }
    /**
   * Activates depth comparisons and updates to the depth buffer.
   * @default false
   */ get depthTest() {
        return !!(this.data & 1 << $057ce09b55579ee8$var$DEPTH_TEST);
    }
    set depthTest(value) {
        if (!!(this.data & 1 << $057ce09b55579ee8$var$DEPTH_TEST) !== value) this.data ^= 1 << $057ce09b55579ee8$var$DEPTH_TEST;
    }
    /**
   * Enables or disables writing to the depth buffer.
   * @default true
   */ get depthMask() {
        return !!(this.data & 1 << $057ce09b55579ee8$var$DEPTH_MASK);
    }
    set depthMask(value) {
        if (!!(this.data & 1 << $057ce09b55579ee8$var$DEPTH_MASK) !== value) this.data ^= 1 << $057ce09b55579ee8$var$DEPTH_MASK;
    }
    /**
   * Specifies whether or not front or back-facing polygons can be culled.
   * @default false
   */ get clockwiseFrontFace() {
        return !!(this.data & 1 << $057ce09b55579ee8$var$WINDING);
    }
    set clockwiseFrontFace(value) {
        if (!!(this.data & 1 << $057ce09b55579ee8$var$WINDING) !== value) this.data ^= 1 << $057ce09b55579ee8$var$WINDING;
    }
    /**
   * The blend mode to be applied when this state is set. Apply a value of `normal` to reset the blend mode.
   * Setting this mode to anything other than NO_BLEND will automatically switch blending on.
   * @default 'normal'
   */ get blendMode() {
        return this._blendMode;
    }
    set blendMode(value) {
        this.blend = value !== "none";
        this._blendMode = value;
        this._blendModeId = $057ce09b55579ee8$var$blendModeIds[value] || 0;
    }
    /**
   * The polygon offset. Setting this property to anything other than 0 will automatically enable polygon offset fill.
   * @default 0
   */ get polygonOffset() {
        return this._polygonOffset;
    }
    set polygonOffset(value) {
        this.offsets = !!value;
        this._polygonOffset = value;
    }
    toString() {
        return `[pixi.js/core:State blendMode=${this.blendMode} clockwiseFrontFace=${this.clockwiseFrontFace} culling=${this.culling} depthMask=${this.depthMask} polygonOffset=${this.polygonOffset}]`;
    }
    /**
   * A quickly getting an instance of a State that is configured for 2d rendering.
   * @returns a new State with values set for 2d rendering
   */ static for2d() {
        const state = new _State();
        state.depthTest = false;
        state.blend = true;
        return state;
    }
};
$057ce09b55579ee8$var$_State.default2d = $057ce09b55579ee8$var$_State.for2d();
let $057ce09b55579ee8$export$7254cc27399e90bd = $057ce09b55579ee8$var$_State;

});

parcelRegister("jcSXK", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $bd0c15e85a3d71c8$export$e56d0a06781accc9);

var $dHliN = parcelRequire("dHliN");

var $2CXjJ = parcelRequire("2CXjJ");

var $9VJ7s = parcelRequire("9VJ7s");
"use strict";
class $bd0c15e85a3d71c8$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $dHliN.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $2CXjJ.nextPow2)(minWidth);
        minHeight = (0, $2CXjJ.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.resetTransform();
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $bd0c15e85a3d71c8$export$e56d0a06781accc9 = new $bd0c15e85a3d71c8$export$62d9f0b8aada09d7();
(0, $9VJ7s.GlobalResourceRegistry).register($bd0c15e85a3d71c8$export$e56d0a06781accc9);

});

parcelRegister("96EPk", function(module, exports) {

$parcel$export(module.exports, "GCManagedHash", () => $d43eea8f0de866ee$export$632d6e63cd4488df);
"use strict";
class $d43eea8f0de866ee$export$632d6e63cd4488df {
    constructor(options){
        // Exposed directly for GC system access
        this.items = /* @__PURE__ */ Object.create(null);
        const { renderer: renderer, type: type, onUnload: onUnload, priority: priority, name: name } = options;
        this._renderer = renderer;
        renderer.gc.addResourceHash(this, "items", type, priority ?? 0);
        this._onUnload = onUnload;
        this.name = name;
    }
    /**
   * Add an item to the hash. No-op if already added.
   * @param item
   * @returns true if the item was added, false if it was already in the hash
   */ add(item) {
        if (this.items[item.uid]) return false;
        this.items[item.uid] = item;
        item.once("unload", this.remove, this);
        item._gcLastUsed = this._renderer.gc.now;
        return true;
    }
    remove(item, ...args) {
        if (!this.items[item.uid]) return;
        const gpuData = item._gpuData[this._renderer.uid];
        if (!gpuData) return;
        this._onUnload?.(item, ...args);
        gpuData.destroy();
        item._gpuData[this._renderer.uid] = null;
        this.items[item.uid] = null;
    }
    removeAll(...args) {
        Object.values(this.items).forEach((item)=>item && this.remove(item, ...args));
    }
    destroy(...args) {
        this.removeAll(...args);
        this.items = /* @__PURE__ */ Object.create(null);
        this._renderer = null;
        this._onUnload = null;
    }
}

});

parcelRegister("8BD2x", function(module, exports) {

$parcel$export(module.exports, "color32BitToUniform", () => $784b2d7eaecd7bcc$export$2c68e848c5b81f5);
"use strict";
function $784b2d7eaecd7bcc$export$d13a52631f102a23(rgb, alpha, out, offset) {
    out[offset++] = (rgb >> 16 & 255) / 255;
    out[offset++] = (rgb >> 8 & 255) / 255;
    out[offset++] = (rgb & 255) / 255;
    out[offset++] = alpha;
}
function $784b2d7eaecd7bcc$export$2c68e848c5b81f5(abgr, out, offset) {
    const alpha = (abgr >> 24 & 255) / 255;
    out[offset++] = (abgr & 255) / 255 * alpha;
    out[offset++] = (abgr >> 8 & 255) / 255 * alpha;
    out[offset++] = (abgr >> 16 & 255) / 255 * alpha;
    out[offset++] = alpha;
}

});

parcelRegister("joLVF", function(module, exports) {

$parcel$export(module.exports, "shapeBuilders", () => $ec15faa722447c64$export$ab760b0d495e92a1);
$parcel$export(module.exports, "buildContextBatches", () => $ec15faa722447c64$export$e3c00f31a053d231);

var $aBhlC = parcelRequire("aBhlC");

var $deLbn = parcelRequire("deLbn");

var $kNl9L = parcelRequire("kNl9L");

var $lcjWv = parcelRequire("lcjWv");

var $9yA57 = parcelRequire("9yA57");

var $cmH9g = parcelRequire("cmH9g");

var $2xwDK = parcelRequire("2xwDK");

var $fTkea = parcelRequire("fTkea");

var $4a7Ki = parcelRequire("4a7Ki");

var $3h4MN = parcelRequire("3h4MN");

var $kn8XA = parcelRequire("kn8XA");

var $9gGCh = parcelRequire("9gGCh");

var $jkTZP = parcelRequire("jkTZP");

var $4fj3M = parcelRequire("4fj3M");

var $diq28 = parcelRequire("diq28");

var $9jupH = parcelRequire("9jupH");
"use strict";
const $ec15faa722447c64$export$ab760b0d495e92a1 = {};
(0, $aBhlC.extensions).handleByMap((0, $aBhlC.ExtensionType).ShapeBuilder, $ec15faa722447c64$export$ab760b0d495e92a1);
(0, $aBhlC.extensions).add((0, $jkTZP.buildRectangle), (0, $9gGCh.buildPolygon), (0, $4fj3M.buildTriangle), (0, $4a7Ki.buildCircle), (0, $4a7Ki.buildEllipse), (0, $4a7Ki.buildRoundedRectangle));
const $ec15faa722447c64$var$tempRect = new (0, $kNl9L.Rectangle)();
const $ec15faa722447c64$var$tempTextureMatrix = new (0, $deLbn.Matrix)();
function $ec15faa722447c64$export$e3c00f31a053d231(context, gpuContext) {
    const { geometryData: geometryData, batches: batches } = gpuContext;
    batches.length = 0;
    geometryData.indices.length = 0;
    geometryData.vertices.length = 0;
    geometryData.uvs.length = 0;
    for(let i = 0; i < context.instructions.length; i++){
        const instruction = context.instructions[i];
        if (instruction.action === "texture") $ec15faa722447c64$var$addTextureToGeometryData(instruction.data, batches, geometryData);
        else if (instruction.action === "fill" || instruction.action === "stroke") {
            const isStroke = instruction.action === "stroke";
            const shapePath = instruction.data.path.shapePath;
            const style = instruction.data.style;
            const hole = instruction.data.hole;
            if (isStroke && hole) $ec15faa722447c64$var$addShapePathToGeometryData(hole.shapePath, style, true, batches, geometryData);
            if (hole) shapePath.shapePrimitives[shapePath.shapePrimitives.length - 1].holes = hole.shapePath.shapePrimitives;
            $ec15faa722447c64$var$addShapePathToGeometryData(shapePath, style, isStroke, batches, geometryData);
        }
    }
}
function $ec15faa722447c64$var$addTextureToGeometryData(data, batches, geometryData) {
    const points = [];
    const build = $ec15faa722447c64$export$ab760b0d495e92a1.rectangle;
    const rect = $ec15faa722447c64$var$tempRect;
    rect.x = data.dx;
    rect.y = data.dy;
    rect.width = data.dw;
    rect.height = data.dh;
    const matrix = data.transform;
    if (!build.build(rect, points)) return;
    const { vertices: vertices, uvs: uvs, indices: indices } = geometryData;
    const indexOffset = indices.length;
    const vertOffset = vertices.length / 2;
    if (matrix) (0, $9yA57.transformVertices)(points, matrix);
    build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
    const texture = data.image;
    const textureUvs = texture.uvs;
    uvs.push(textureUvs.x0, textureUvs.y0, textureUvs.x1, textureUvs.y1, textureUvs.x3, textureUvs.y3, textureUvs.x2, textureUvs.y2);
    const graphicsBatch = (0, $2xwDK.BigPool).get((0, $fTkea.BatchableGraphics));
    graphicsBatch.indexOffset = indexOffset;
    graphicsBatch.indexSize = indices.length - indexOffset;
    graphicsBatch.attributeOffset = vertOffset;
    graphicsBatch.attributeSize = vertices.length / 2 - vertOffset;
    graphicsBatch.baseColor = data.style;
    graphicsBatch.alpha = data.alpha;
    graphicsBatch.texture = texture;
    graphicsBatch.geometryData = geometryData;
    batches.push(graphicsBatch);
}
function $ec15faa722447c64$var$addShapePathToGeometryData(shapePath, style, isStroke, batches, geometryData) {
    const { vertices: vertices, uvs: uvs, indices: indices } = geometryData;
    shapePath.shapePrimitives.forEach(({ shape: shape, transform: matrix, holes: holes })=>{
        const points = [];
        const build = $ec15faa722447c64$export$ab760b0d495e92a1[shape.type];
        if (!build.build(shape, points)) return;
        const indexOffset = indices.length;
        const vertOffset = vertices.length / 2;
        let topology = "triangle-list";
        if (matrix) (0, $9yA57.transformVertices)(points, matrix);
        if (!isStroke) {
            if (holes) {
                const holeIndices = [];
                const otherPoints = points.slice();
                const holeArrays = $ec15faa722447c64$var$getHoleArrays(holes);
                holeArrays.forEach((holePoints)=>{
                    holeIndices.push(otherPoints.length / 2);
                    otherPoints.push(...holePoints);
                });
                (0, $9jupH.triangulateWithHoles)(otherPoints, holeIndices, vertices, 2, vertOffset, indices, indexOffset);
            } else build.triangulate(points, vertices, 2, vertOffset, indices, indexOffset);
        } else {
            const close = shape.closePath ?? true;
            const lineStyle = style;
            if (!lineStyle.pixelLine) (0, $3h4MN.buildLine)(points, lineStyle, false, close, vertices, indices);
            else {
                (0, $kn8XA.buildPixelLine)(points, close, vertices, indices);
                topology = "line-list";
            }
        }
        const uvsOffset = uvs.length / 2;
        const texture = style.texture;
        if (texture !== (0, $cmH9g.Texture).WHITE) {
            const textureMatrix = (0, $diq28.generateTextureMatrix)($ec15faa722447c64$var$tempTextureMatrix, style, shape, matrix);
            (0, $lcjWv.buildUvs)(vertices, 2, vertOffset, uvs, uvsOffset, 2, vertices.length / 2 - vertOffset, textureMatrix);
        } else (0, $lcjWv.buildSimpleUvs)(uvs, uvsOffset, 2, vertices.length / 2 - vertOffset);
        const graphicsBatch = (0, $2xwDK.BigPool).get((0, $fTkea.BatchableGraphics));
        graphicsBatch.indexOffset = indexOffset;
        graphicsBatch.indexSize = indices.length - indexOffset;
        graphicsBatch.attributeOffset = vertOffset;
        graphicsBatch.attributeSize = vertices.length / 2 - vertOffset;
        graphicsBatch.baseColor = style.color;
        graphicsBatch.alpha = style.alpha;
        graphicsBatch.texture = texture;
        graphicsBatch.geometryData = geometryData;
        graphicsBatch.topology = topology;
        batches.push(graphicsBatch);
    });
}
function $ec15faa722447c64$var$getHoleArrays(holePrimitives) {
    const holeArrays = [];
    for(let k = 0; k < holePrimitives.length; k++){
        const holePrimitive = holePrimitives[k].shape;
        const holePoints = [];
        const holeBuilder = $ec15faa722447c64$export$ab760b0d495e92a1[holePrimitive.type];
        if (holeBuilder.build(holePrimitive, holePoints)) holeArrays.push(holePoints);
    }
    return holeArrays;
}

});
parcelRegister("lcjWv", function(module, exports) {

$parcel$export(module.exports, "buildUvs", () => $bbec6719d4e497f0$export$2027711a0ff70dc2);
$parcel$export(module.exports, "buildSimpleUvs", () => $bbec6719d4e497f0$export$580e3d8462b9fe52);
"use strict";
function $bbec6719d4e497f0$export$2027711a0ff70dc2(vertices, verticesStride, verticesOffset, uvs, uvsOffset, uvsStride, size, matrix = null) {
    let index = 0;
    verticesOffset *= verticesStride;
    uvsOffset *= uvsStride;
    const a = matrix.a;
    const b = matrix.b;
    const c = matrix.c;
    const d = matrix.d;
    const tx = matrix.tx;
    const ty = matrix.ty;
    while(index < size){
        const x = vertices[verticesOffset];
        const y = vertices[verticesOffset + 1];
        uvs[uvsOffset] = a * x + c * y + tx;
        uvs[uvsOffset + 1] = b * x + d * y + ty;
        uvsOffset += uvsStride;
        verticesOffset += verticesStride;
        index++;
    }
}
function $bbec6719d4e497f0$export$580e3d8462b9fe52(uvs, uvsOffset, uvsStride, size) {
    let index = 0;
    uvsOffset *= uvsStride;
    while(index < size){
        uvs[uvsOffset] = 0;
        uvs[uvsOffset + 1] = 0;
        uvsOffset += uvsStride;
        index++;
    }
}

});

parcelRegister("9yA57", function(module, exports) {

$parcel$export(module.exports, "transformVertices", () => $ffdc129b8dcd62ab$export$cbe36b8a8d6e3d3);
"use strict";
function $ffdc129b8dcd62ab$export$cbe36b8a8d6e3d3(vertices, m, offset, stride, size) {
    const a = m.a;
    const b = m.b;
    const c = m.c;
    const d = m.d;
    const tx = m.tx;
    const ty = m.ty;
    offset || (offset = 0);
    stride || (stride = 2);
    size || (size = vertices.length / stride - offset);
    let index = offset * stride;
    for(let i = 0; i < size; i++){
        const x = vertices[index];
        const y = vertices[index + 1];
        vertices[index] = a * x + c * y + tx;
        vertices[index + 1] = b * x + d * y + ty;
        index += stride;
    }
}

});

parcelRegister("fTkea", function(module, exports) {

$parcel$export(module.exports, "BatchableGraphics", () => $ffd707f9b427f75a$export$91d2a08bbf21546b);

var $deLbn = parcelRequire("deLbn");

var $hV5oi = parcelRequire("hV5oi");
"use strict";
const $ffd707f9b427f75a$var$identityMatrix = new (0, $deLbn.Matrix)();
class $ffd707f9b427f75a$export$91d2a08bbf21546b {
    constructor(){
        this.packAsQuad = false;
        this.batcherName = "default";
        this.topology = "triangle-list";
        this.applyTransform = true;
        this.roundPixels = 0;
        this._batcher = null;
        this._batch = null;
    }
    get uvs() {
        return this.geometryData.uvs;
    }
    get positions() {
        return this.geometryData.vertices;
    }
    get indices() {
        return this.geometryData.indices;
    }
    get blendMode() {
        if (this.renderable && this.applyTransform) return this.renderable.groupBlendMode;
        return "normal";
    }
    get color() {
        const rgb = this.baseColor;
        const bgr = rgb >> 16 | rgb & 65280 | (rgb & 255) << 16;
        const renderable = this.renderable;
        if (renderable) return (0, $hV5oi.multiplyHexColors)(bgr, renderable.groupColor) + (this.alpha * renderable.groupAlpha * 255 << 24);
        return bgr + (this.alpha * 255 << 24);
    }
    get transform() {
        return this.renderable?.groupTransform || $ffd707f9b427f75a$var$identityMatrix;
    }
    copyTo(gpuBuffer) {
        gpuBuffer.indexOffset = this.indexOffset;
        gpuBuffer.indexSize = this.indexSize;
        gpuBuffer.attributeOffset = this.attributeOffset;
        gpuBuffer.attributeSize = this.attributeSize;
        gpuBuffer.baseColor = this.baseColor;
        gpuBuffer.alpha = this.alpha;
        gpuBuffer.texture = this.texture;
        gpuBuffer.geometryData = this.geometryData;
        gpuBuffer.topology = this.topology;
    }
    reset() {
        this.applyTransform = true;
        this.renderable = null;
        this.topology = "triangle-list";
    }
    destroy() {
        this.renderable = null;
        this.texture = null;
        this.geometryData = null;
        this._batcher = null;
        this._batch = null;
    }
}

});

parcelRegister("4a7Ki", function(module, exports) {

$parcel$export(module.exports, "buildCircle", () => $9ce566c8716b7e8c$export$a3541b2d8ecbfcf2);
$parcel$export(module.exports, "buildEllipse", () => $9ce566c8716b7e8c$export$d35b00c6ec9534ca);
$parcel$export(module.exports, "buildRoundedRectangle", () => $9ce566c8716b7e8c$export$4b54fce47d2ae7f4);

var $aBhlC = parcelRequire("aBhlC");
"use strict";
const $9ce566c8716b7e8c$export$a3541b2d8ecbfcf2 = {
    extension: {
        type: (0, $aBhlC.ExtensionType).ShapeBuilder,
        name: "circle"
    },
    build (shape, points) {
        let x;
        let y;
        let dx;
        let dy;
        let rx;
        let ry;
        if (shape.type === "circle") {
            const circle = shape;
            rx = ry = circle.radius;
            if (rx <= 0) return false;
            x = circle.x;
            y = circle.y;
            dx = dy = 0;
        } else if (shape.type === "ellipse") {
            const ellipse = shape;
            rx = ellipse.halfWidth;
            ry = ellipse.halfHeight;
            if (rx <= 0 || ry <= 0) return false;
            x = ellipse.x;
            y = ellipse.y;
            dx = dy = 0;
        } else {
            const roundedRect = shape;
            const halfWidth = roundedRect.width / 2;
            const halfHeight = roundedRect.height / 2;
            x = roundedRect.x + halfWidth;
            y = roundedRect.y + halfHeight;
            rx = ry = Math.max(0, Math.min(roundedRect.radius, Math.min(halfWidth, halfHeight)));
            dx = halfWidth - rx;
            dy = halfHeight - ry;
        }
        if (dx < 0 || dy < 0) return false;
        const n = Math.ceil(2.3 * Math.sqrt(rx + ry));
        const m = n * 8 + (dx ? 4 : 0) + (dy ? 4 : 0);
        if (m === 0) return false;
        if (n === 0) {
            points[0] = points[6] = x + dx;
            points[1] = points[3] = y + dy;
            points[2] = points[4] = x - dx;
            points[5] = points[7] = y - dy;
            return true;
        }
        let j1 = 0;
        let j2 = n * 4 + (dx ? 2 : 0) + 2;
        let j3 = j2;
        let j4 = m;
        let x0 = dx + rx;
        let y0 = dy;
        let x1 = x + x0;
        let x2 = x - x0;
        let y1 = y + y0;
        points[j1++] = x1;
        points[j1++] = y1;
        points[--j2] = y1;
        points[--j2] = x2;
        if (dy) {
            const y22 = y - y0;
            points[j3++] = x2;
            points[j3++] = y22;
            points[--j4] = y22;
            points[--j4] = x1;
        }
        for(let i = 1; i < n; i++){
            const a = Math.PI / 2 * (i / n);
            const x02 = dx + Math.cos(a) * rx;
            const y02 = dy + Math.sin(a) * ry;
            const x12 = x + x02;
            const x22 = x - x02;
            const y12 = y + y02;
            const y22 = y - y02;
            points[j1++] = x12;
            points[j1++] = y12;
            points[--j2] = y12;
            points[--j2] = x22;
            points[j3++] = x22;
            points[j3++] = y22;
            points[--j4] = y22;
            points[--j4] = x12;
        }
        x0 = dx;
        y0 = dy + ry;
        x1 = x + x0;
        x2 = x - x0;
        y1 = y + y0;
        const y2 = y - y0;
        points[j1++] = x1;
        points[j1++] = y1;
        points[--j4] = y2;
        points[--j4] = x1;
        if (dx) {
            points[j1++] = x2;
            points[j1++] = y1;
            points[--j4] = y2;
            points[--j4] = x2;
        }
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        if (points.length === 0) return;
        let centerX = 0;
        let centerY = 0;
        for(let i = 0; i < points.length; i += 2){
            centerX += points[i];
            centerY += points[i + 1];
        }
        centerX /= points.length / 2;
        centerY /= points.length / 2;
        let count = verticesOffset;
        vertices[count * verticesStride] = centerX;
        vertices[count * verticesStride + 1] = centerY;
        const centerIndex = count++;
        for(let i = 0; i < points.length; i += 2){
            vertices[count * verticesStride] = points[i];
            vertices[count * verticesStride + 1] = points[i + 1];
            if (i > 0) {
                indices[indicesOffset++] = count;
                indices[indicesOffset++] = centerIndex;
                indices[indicesOffset++] = count - 1;
            }
            count++;
        }
        indices[indicesOffset++] = centerIndex + 1;
        indices[indicesOffset++] = centerIndex;
        indices[indicesOffset++] = count - 1;
    }
};
const $9ce566c8716b7e8c$export$d35b00c6ec9534ca = {
    ...$9ce566c8716b7e8c$export$a3541b2d8ecbfcf2,
    extension: {
        ...$9ce566c8716b7e8c$export$a3541b2d8ecbfcf2.extension,
        name: "ellipse"
    }
};
const $9ce566c8716b7e8c$export$4b54fce47d2ae7f4 = {
    ...$9ce566c8716b7e8c$export$a3541b2d8ecbfcf2,
    extension: {
        ...$9ce566c8716b7e8c$export$a3541b2d8ecbfcf2.extension,
        name: "roundedRectangle"
    }
};

});

parcelRegister("3h4MN", function(module, exports) {

$parcel$export(module.exports, "buildLine", () => $6d4c987cd270ff32$export$45986ccf08e93b0b);

var $lwGvb = parcelRequire("lwGvb");

var $kNsFb = parcelRequire("kNsFb");

var $9RwZf = parcelRequire("9RwZf");
"use strict";
function $6d4c987cd270ff32$var$square(x, y, nx, ny, innerWeight, outerWeight, clockwise, verts) {
    const ix = x - nx * innerWeight;
    const iy = y - ny * innerWeight;
    const ox = x + nx * outerWeight;
    const oy = y + ny * outerWeight;
    let exx;
    let eyy;
    if (clockwise) {
        exx = ny;
        eyy = -nx;
    } else {
        exx = -ny;
        eyy = nx;
    }
    const eix = ix + exx;
    const eiy = iy + eyy;
    const eox = ox + exx;
    const eoy = oy + eyy;
    verts.push(eix, eiy);
    verts.push(eox, eoy);
    return 2;
}
function $6d4c987cd270ff32$var$round(cx, cy, sx, sy, ex, ey, verts, clockwise) {
    const cx2p0x = sx - cx;
    const cy2p0y = sy - cy;
    let angle0 = Math.atan2(cx2p0x, cy2p0y);
    let angle1 = Math.atan2(ex - cx, ey - cy);
    if (clockwise && angle0 < angle1) angle0 += Math.PI * 2;
    else if (!clockwise && angle0 > angle1) angle1 += Math.PI * 2;
    let startAngle = angle0;
    const angleDiff = angle1 - angle0;
    const absAngleDiff = Math.abs(angleDiff);
    const radius = Math.sqrt(cx2p0x * cx2p0x + cy2p0y * cy2p0y);
    const segCount = (15 * absAngleDiff * Math.sqrt(radius) / Math.PI >> 0) + 1;
    const angleInc = angleDiff / segCount;
    startAngle += angleInc;
    if (clockwise) {
        verts.push(cx, cy);
        verts.push(sx, sy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx, cy);
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
        }
        verts.push(cx, cy);
        verts.push(ex, ey);
    } else {
        verts.push(sx, sy);
        verts.push(cx, cy);
        for(let i = 1, angle = startAngle; i < segCount; i++, angle += angleInc){
            verts.push(cx + Math.sin(angle) * radius, cy + Math.cos(angle) * radius);
            verts.push(cx, cy);
        }
        verts.push(ex, ey);
        verts.push(cx, cy);
    }
    return segCount * 2;
}
function $6d4c987cd270ff32$export$45986ccf08e93b0b(points, lineStyle, flipAlignment, closed, vertices, indices) {
    const eps = (0, $kNsFb.closePointEps);
    if (points.length === 0) return;
    const style = lineStyle;
    let alignment = style.alignment;
    if (lineStyle.alignment !== 0.5) {
        let orientation = (0, $9RwZf.getOrientationOfPoints)(points);
        if (flipAlignment) orientation *= -1;
        alignment = (alignment - 0.5) * orientation + 0.5;
    }
    const firstPoint = new (0, $lwGvb.Point)(points[0], points[1]);
    const lastPoint = new (0, $lwGvb.Point)(points[points.length - 2], points[points.length - 1]);
    const closedShape = closed;
    const closedPath = Math.abs(firstPoint.x - lastPoint.x) < eps && Math.abs(firstPoint.y - lastPoint.y) < eps;
    if (closedShape) {
        points = points.slice();
        if (closedPath) {
            points.pop();
            points.pop();
            lastPoint.set(points[points.length - 2], points[points.length - 1]);
        }
        const midPointX = (firstPoint.x + lastPoint.x) * 0.5;
        const midPointY = (lastPoint.y + firstPoint.y) * 0.5;
        points.unshift(midPointX, midPointY);
        points.push(midPointX, midPointY);
    }
    const verts = vertices;
    const length = points.length / 2;
    let indexCount = points.length;
    const indexStart = verts.length / 2;
    const width = style.width / 2;
    const widthSquared = width * width;
    const miterLimitSquared = style.miterLimit * style.miterLimit;
    let x0 = points[0];
    let y0 = points[1];
    let x1 = points[2];
    let y1 = points[3];
    let x2 = 0;
    let y2 = 0;
    let perpX = -(y0 - y1);
    let perpY = x0 - x1;
    let perp1x = 0;
    let perp1y = 0;
    let dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    const ratio = alignment;
    const innerWeight = (1 - ratio) * 2;
    const outerWeight = ratio * 2;
    if (!closedShape) {
        if (style.cap === "round") indexCount += $6d4c987cd270ff32$var$round(x0 - perpX * (innerWeight - outerWeight) * 0.5, y0 - perpY * (innerWeight - outerWeight) * 0.5, x0 - perpX * innerWeight, y0 - perpY * innerWeight, x0 + perpX * outerWeight, y0 + perpY * outerWeight, verts, true) + 2;
        else if (style.cap === "square") indexCount += $6d4c987cd270ff32$var$square(x0, y0, perpX, perpY, innerWeight, outerWeight, true, verts);
    }
    verts.push(x0 - perpX * innerWeight, y0 - perpY * innerWeight);
    verts.push(x0 + perpX * outerWeight, y0 + perpY * outerWeight);
    for(let i = 1; i < length - 1; ++i){
        x0 = points[(i - 1) * 2];
        y0 = points[(i - 1) * 2 + 1];
        x1 = points[i * 2];
        y1 = points[i * 2 + 1];
        x2 = points[(i + 1) * 2];
        y2 = points[(i + 1) * 2 + 1];
        perpX = -(y0 - y1);
        perpY = x0 - x1;
        dist = Math.sqrt(perpX * perpX + perpY * perpY);
        perpX /= dist;
        perpY /= dist;
        perpX *= width;
        perpY *= width;
        perp1x = -(y1 - y2);
        perp1y = x1 - x2;
        dist = Math.sqrt(perp1x * perp1x + perp1y * perp1y);
        perp1x /= dist;
        perp1y /= dist;
        perp1x *= width;
        perp1y *= width;
        const dx0 = x1 - x0;
        const dy0 = y0 - y1;
        const dx1 = x1 - x2;
        const dy1 = y2 - y1;
        const dot = dx0 * dx1 + dy0 * dy1;
        const cross = dy0 * dx1 - dy1 * dx0;
        const clockwise = cross < 0;
        if (Math.abs(cross) < 1e-3 * Math.abs(dot)) {
            verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
            verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
            if (dot >= 0) {
                if (style.join === "round") indexCount += $6d4c987cd270ff32$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                else indexCount += 2;
                verts.push(x1 - perp1x * outerWeight, y1 - perp1y * outerWeight);
                verts.push(x1 + perp1x * innerWeight, y1 + perp1y * innerWeight);
            }
            continue;
        }
        const c1 = (-perpX + x0) * (-perpY + y1) - (-perpX + x1) * (-perpY + y0);
        const c2 = (-perp1x + x2) * (-perp1y + y1) - (-perp1x + x1) * (-perp1y + y2);
        const px = (dx0 * c2 - dx1 * c1) / cross;
        const py = (dy1 * c1 - dy0 * c2) / cross;
        const pDist = (px - x1) * (px - x1) + (py - y1) * (py - y1);
        const imx = x1 + (px - x1) * innerWeight;
        const imy = y1 + (py - y1) * innerWeight;
        const omx = x1 - (px - x1) * outerWeight;
        const omy = y1 - (py - y1) * outerWeight;
        const smallerInsideSegmentSq = Math.min(dx0 * dx0 + dy0 * dy0, dx1 * dx1 + dy1 * dy1);
        const insideWeight = clockwise ? innerWeight : outerWeight;
        const smallerInsideDiagonalSq = smallerInsideSegmentSq + insideWeight * insideWeight * widthSquared;
        const insideMiterOk = pDist <= smallerInsideDiagonalSq;
        if (insideMiterOk) {
            if (style.join === "bevel" || pDist / widthSquared > miterLimitSquared) {
                if (clockwise) {
                    verts.push(imx, imy);
                    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
                    verts.push(omx, omy);
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
                indexCount += 2;
            } else if (style.join === "round") {
                if (clockwise) {
                    verts.push(imx, imy);
                    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
                    indexCount += $6d4c987cd270ff32$var$round(x1, y1, x1 + perpX * outerWeight, y1 + perpY * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 4;
                    verts.push(imx, imy);
                    verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
                } else {
                    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
                    verts.push(omx, omy);
                    indexCount += $6d4c987cd270ff32$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 4;
                    verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
                    verts.push(omx, omy);
                }
            } else {
                verts.push(imx, imy);
                verts.push(omx, omy);
            }
        } else {
            verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
            verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
            if (style.join === "round") {
                if (clockwise) indexCount += $6d4c987cd270ff32$var$round(x1, y1, x1 + perpX * outerWeight, y1 + perpY * outerWeight, x1 + perp1x * outerWeight, y1 + perp1y * outerWeight, verts, true) + 2;
                else indexCount += $6d4c987cd270ff32$var$round(x1, y1, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 - perp1x * innerWeight, y1 - perp1y * innerWeight, verts, false) + 2;
            } else if (style.join === "miter" && pDist / widthSquared <= miterLimitSquared) {
                if (clockwise) {
                    verts.push(omx, omy);
                    verts.push(omx, omy);
                } else {
                    verts.push(imx, imy);
                    verts.push(imx, imy);
                }
                indexCount += 2;
            }
            verts.push(x1 - perp1x * innerWeight, y1 - perp1y * innerWeight);
            verts.push(x1 + perp1x * outerWeight, y1 + perp1y * outerWeight);
            indexCount += 2;
        }
    }
    x0 = points[(length - 2) * 2];
    y0 = points[(length - 2) * 2 + 1];
    x1 = points[(length - 1) * 2];
    y1 = points[(length - 1) * 2 + 1];
    perpX = -(y0 - y1);
    perpY = x0 - x1;
    dist = Math.sqrt(perpX * perpX + perpY * perpY);
    perpX /= dist;
    perpY /= dist;
    perpX *= width;
    perpY *= width;
    verts.push(x1 - perpX * innerWeight, y1 - perpY * innerWeight);
    verts.push(x1 + perpX * outerWeight, y1 + perpY * outerWeight);
    if (!closedShape) {
        if (style.cap === "round") indexCount += $6d4c987cd270ff32$var$round(x1 - perpX * (innerWeight - outerWeight) * 0.5, y1 - perpY * (innerWeight - outerWeight) * 0.5, x1 - perpX * innerWeight, y1 - perpY * innerWeight, x1 + perpX * outerWeight, y1 + perpY * outerWeight, verts, false) + 2;
        else if (style.cap === "square") indexCount += $6d4c987cd270ff32$var$square(x1, y1, perpX, perpY, innerWeight, outerWeight, false, verts);
    }
    const eps2 = (0, $kNsFb.curveEps) * (0, $kNsFb.curveEps);
    for(let i = indexStart; i < indexCount + indexStart - 2; ++i){
        x0 = verts[i * 2];
        y0 = verts[i * 2 + 1];
        x1 = verts[(i + 1) * 2];
        y1 = verts[(i + 1) * 2 + 1];
        x2 = verts[(i + 2) * 2];
        y2 = verts[(i + 2) * 2 + 1];
        if (Math.abs(x0 * (y1 - y2) + x1 * (y2 - y0) + x2 * (y0 - y1)) < eps2) continue;
        indices.push(i, i + 1, i + 2);
    }
}

});
parcelRegister("kNsFb", function(module, exports) {

$parcel$export(module.exports, "closePointEps", () => $6c62c0559f4438e4$export$7159a7c43f12984);
$parcel$export(module.exports, "curveEps", () => $6c62c0559f4438e4$export$51a946149243709);
"use strict";
const $6c62c0559f4438e4$export$7159a7c43f12984 = 1e-4;
const $6c62c0559f4438e4$export$51a946149243709 = 1e-4;

});

parcelRegister("9RwZf", function(module, exports) {

$parcel$export(module.exports, "getOrientationOfPoints", () => $ff4da2168631b14a$export$38856eae80d480e1);
"use strict";
function $ff4da2168631b14a$export$38856eae80d480e1(points) {
    const m = points.length;
    if (m < 6) return 1;
    let area = 0;
    for(let i = 0, x1 = points[m - 2], y1 = points[m - 1]; i < m; i += 2){
        const x2 = points[i];
        const y2 = points[i + 1];
        area += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    if (area < 0) return -1;
    return 1;
}

});


parcelRegister("kn8XA", function(module, exports) {

$parcel$export(module.exports, "buildPixelLine", () => $b6e08fdd57609b2c$export$44c058937667e9f0);

var $kNsFb = parcelRequire("kNsFb");
"use strict";
function $b6e08fdd57609b2c$export$44c058937667e9f0(points, closed, vertices, indices) {
    const eps = (0, $kNsFb.closePointEps);
    if (points.length === 0) return;
    const fx = points[0];
    const fy = points[1];
    const lx = points[points.length - 2];
    const ly = points[points.length - 1];
    const closePath = closed || Math.abs(fx - lx) < eps && Math.abs(fy - ly) < eps;
    const verts = vertices;
    const length = points.length / 2;
    const indexStart = verts.length / 2;
    for(let i = 0; i < length; i++){
        verts.push(points[i * 2]);
        verts.push(points[i * 2 + 1]);
    }
    for(let i = 0; i < length - 1; i++)indices.push(indexStart + i, indexStart + i + 1);
    if (closePath) indices.push(indexStart + length - 1, indexStart);
}

});

parcelRegister("9gGCh", function(module, exports) {

$parcel$export(module.exports, "buildPolygon", () => $21e35d1971878b6c$export$4c2d12f7b210f357);

var $aBhlC = parcelRequire("aBhlC");

var $9jupH = parcelRequire("9jupH");
"use strict";
const $21e35d1971878b6c$var$emptyArray = [];
const $21e35d1971878b6c$export$4c2d12f7b210f357 = {
    extension: {
        type: (0, $aBhlC.ExtensionType).ShapeBuilder,
        name: "polygon"
    },
    build (shape, points) {
        for(let i = 0; i < shape.points.length; i++)points[i] = shape.points[i];
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        (0, $9jupH.triangulateWithHoles)(points, $21e35d1971878b6c$var$emptyArray, vertices, verticesStride, verticesOffset, indices, indicesOffset);
    }
};

});
parcelRegister("9jupH", function(module, exports) {

$parcel$export(module.exports, "triangulateWithHoles", () => $9167cbebdf7f1f05$export$5a241bf9c2c3d94b);

var $dueFk = parcelRequire("dueFk");
"use strict";
function $9167cbebdf7f1f05$export$5a241bf9c2c3d94b(points, holes, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
    const triangles = (0, $dueFk.earcut)(points, holes, 2);
    if (!triangles) return;
    for(let i = 0; i < triangles.length; i += 3){
        indices[indicesOffset++] = triangles[i] + verticesOffset;
        indices[indicesOffset++] = triangles[i + 1] + verticesOffset;
        indices[indicesOffset++] = triangles[i + 2] + verticesOffset;
    }
    let index = verticesOffset * verticesStride;
    for(let i = 0; i < points.length; i += 2){
        vertices[index] = points[i];
        vertices[index + 1] = points[i + 1];
        index += verticesStride;
    }
}

});
parcelRegister("dueFk", function(module, exports) {

$parcel$export(module.exports, "earcut", () => $466e334599832720$export$71a1409458eaaf0d);

var $49m7e = parcelRequire("49m7e");

var $6AQ4q = parcelRequire("6AQ4q");
"use strict";
const $466e334599832720$export$71a1409458eaaf0d = (0, $49m7e.default).default || (0, $49m7e.default);

});
parcelRegister("49m7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $30592864694c3355$export$2e2bcd8739ae039);
function $30592864694c3355$export$2e2bcd8739ae039(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = $30592864694c3355$var$linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, invSize;
    if (hasHoles) outerNode = $30592864694c3355$var$eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = data[0];
        minY = data[1];
        let maxX = minX;
        let maxY = minY;
        for(let i = dim; i < outerLen; i += dim){
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    $30592864694c3355$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function $30592864694c3355$var$linkedList(data, start, end, dim, clockwise) {
    let last;
    if (clockwise === $30592864694c3355$var$signedArea(data, start, end, dim) > 0) for(let i = start; i < end; i += dim)last = $30592864694c3355$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    else for(let i = end - dim; i >= start; i -= dim)last = $30592864694c3355$var$insertNode(i / dim | 0, data[i], data[i + 1], last);
    if (last && $30592864694c3355$var$equals(last, last.next)) {
        $30592864694c3355$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $30592864694c3355$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($30592864694c3355$var$equals(p, p.next) || $30592864694c3355$var$area(p.prev, p, p.next) === 0)) {
            $30592864694c3355$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $30592864694c3355$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $30592864694c3355$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        const prev = ear.prev;
        const next = ear.next;
        if (invSize ? $30592864694c3355$var$isEarHashed(ear, minX, minY, invSize) : $30592864694c3355$var$isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle
            $30592864694c3355$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $30592864694c3355$var$earcutLinked($30592864694c3355$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $30592864694c3355$var$cureLocalIntersections($30592864694c3355$var$filterPoints(ear), triangles);
                $30592864694c3355$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $30592864694c3355$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $30592864694c3355$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($30592864694c3355$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $30592864694c3355$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $30592864694c3355$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $30592864694c3355$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($30592864694c3355$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    // z-order range for the current triangle bbox;
    const minZ = $30592864694c3355$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $30592864694c3355$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $30592864694c3355$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $30592864694c3355$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $30592864694c3355$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $30592864694c3355$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $30592864694c3355$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && $30592864694c3355$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $30592864694c3355$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && $30592864694c3355$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $30592864694c3355$var$cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$30592864694c3355$var$equals(a, b) && $30592864694c3355$var$intersects(a, p, p.next, b) && $30592864694c3355$var$locallyInside(a, b) && $30592864694c3355$var$locallyInside(b, a)) {
            triangles.push(a.i, p.i, b.i);
            // remove two nodes involved
            $30592864694c3355$var$removeNode(p);
            $30592864694c3355$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $30592864694c3355$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $30592864694c3355$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $30592864694c3355$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $30592864694c3355$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $30592864694c3355$var$filterPoints(a, a.next);
                c = $30592864694c3355$var$filterPoints(c, c.next);
                // run earcut on each half
                $30592864694c3355$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $30592864694c3355$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $30592864694c3355$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = $30592864694c3355$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($30592864694c3355$var$getLeftmost(list));
    }
    queue.sort($30592864694c3355$var$compareXYSlope);
    // process holes from left to right
    for(let i = 0; i < queue.length; i++)outerNode = $30592864694c3355$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $30592864694c3355$var$compareXYSlope(a, b) {
    let result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            const aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            const bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $30592864694c3355$var$eliminateHole(hole, outerNode) {
    const bridge = $30592864694c3355$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $30592864694c3355$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $30592864694c3355$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $30592864694c3355$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $30592864694c3355$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if ($30592864694c3355$var$equals(hole, p)) return p;
    do {
        if ($30592864694c3355$var$equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $30592864694c3355$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($30592864694c3355$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $30592864694c3355$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $30592864694c3355$var$sectorContainsSector(m, p) {
    return $30592864694c3355$var$area(m.prev, m, p.prev) < 0 && $30592864694c3355$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $30592864694c3355$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $30592864694c3355$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $30592864694c3355$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $30592864694c3355$var$sortLinked(list) {
    let numMerges;
    let inSize = 1;
    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            let q = p;
            let pSize = 0;
            for(let i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $30592864694c3355$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $30592864694c3355$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $30592864694c3355$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function $30592864694c3355$var$pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && $30592864694c3355$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $30592864694c3355$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$30592864694c3355$var$intersectsPolygon(a, b) && // doesn't intersect other edges
    ($30592864694c3355$var$locallyInside(a, b) && $30592864694c3355$var$locallyInside(b, a) && $30592864694c3355$var$middleInside(a, b) && // locally visible
    ($30592864694c3355$var$area(a.prev, a, b.prev) || $30592864694c3355$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $30592864694c3355$var$equals(a, b) && $30592864694c3355$var$area(a.prev, a, a.next) > 0 && $30592864694c3355$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $30592864694c3355$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $30592864694c3355$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $30592864694c3355$var$intersects(p1, q1, p2, q2) {
    const o1 = $30592864694c3355$var$sign($30592864694c3355$var$area(p1, q1, p2));
    const o2 = $30592864694c3355$var$sign($30592864694c3355$var$area(p1, q1, q2));
    const o3 = $30592864694c3355$var$sign($30592864694c3355$var$area(p2, q2, p1));
    const o4 = $30592864694c3355$var$sign($30592864694c3355$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $30592864694c3355$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $30592864694c3355$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $30592864694c3355$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $30592864694c3355$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $30592864694c3355$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $30592864694c3355$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $30592864694c3355$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $30592864694c3355$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $30592864694c3355$var$locallyInside(a, b) {
    return $30592864694c3355$var$area(a.prev, a, a.next) < 0 ? $30592864694c3355$var$area(a, b, a.next) >= 0 && $30592864694c3355$var$area(a, a.prev, b) >= 0 : $30592864694c3355$var$area(a, b, a.prev) < 0 || $30592864694c3355$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $30592864694c3355$var$middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $30592864694c3355$var$splitPolygon(a, b) {
    const a2 = $30592864694c3355$var$createNode(a.i, a.x, a.y), b2 = $30592864694c3355$var$createNode(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $30592864694c3355$var$insertNode(i, x, y, last) {
    const p = $30592864694c3355$var$createNode(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $30592864694c3355$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $30592864694c3355$var$createNode(i, x, y) {
    return {
        i: i,
        x: x,
        y: y,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}
function $30592864694c3355$export$e8fd98ab2e1cd1ee(data, holeIndices, dim, triangles) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let polygonArea = Math.abs($30592864694c3355$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($30592864694c3355$var$signedArea(data, start, end, dim));
    }
    let trianglesArea = 0;
    for(let i = 0; i < triangles.length; i += 3){
        const a = triangles[i] * dim;
        const b = triangles[i + 1] * dim;
        const c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
}
function $30592864694c3355$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
function $30592864694c3355$export$bffa455ba8c619a6(data) {
    const vertices = [];
    const holes = [];
    const dimensions = data[0][0].length;
    let holeIndex = 0;
    let prevLen = 0;
    for (const ring of data){
        for (const p of ring)for(let d = 0; d < dimensions; d++)vertices.push(p[d]);
        if (prevLen) {
            holeIndex += prevLen;
            holes.push(holeIndex);
        }
        prevLen = ring.length;
    }
    return {
        vertices: vertices,
        holes: holes,
        dimensions: dimensions
    };
}

});




parcelRegister("jkTZP", function(module, exports) {

$parcel$export(module.exports, "buildRectangle", () => $adc2e7960eee03a5$export$cbe813d11f2192b2);

var $aBhlC = parcelRequire("aBhlC");
"use strict";
const $adc2e7960eee03a5$export$cbe813d11f2192b2 = {
    extension: {
        type: (0, $aBhlC.ExtensionType).ShapeBuilder,
        name: "rectangle"
    },
    build (shape, points) {
        const rectData = shape;
        const x = rectData.x;
        const y = rectData.y;
        const width = rectData.width;
        const height = rectData.height;
        if (!(width > 0 && height > 0)) return false;
        points[0] = x;
        points[1] = y;
        points[2] = x + width;
        points[3] = y;
        points[4] = x + width;
        points[5] = y + height;
        points[6] = x;
        points[7] = y + height;
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        let count = 0;
        verticesOffset *= verticesStride;
        vertices[verticesOffset + count] = points[0];
        vertices[verticesOffset + count + 1] = points[1];
        count += verticesStride;
        vertices[verticesOffset + count] = points[2];
        vertices[verticesOffset + count + 1] = points[3];
        count += verticesStride;
        vertices[verticesOffset + count] = points[6];
        vertices[verticesOffset + count + 1] = points[7];
        count += verticesStride;
        vertices[verticesOffset + count] = points[4];
        vertices[verticesOffset + count + 1] = points[5];
        count += verticesStride;
        const verticesIndex = verticesOffset / verticesStride;
        indices[indicesOffset++] = verticesIndex;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 2;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 3;
        indices[indicesOffset++] = verticesIndex + 2;
    }
};

});

parcelRegister("4fj3M", function(module, exports) {

$parcel$export(module.exports, "buildTriangle", () => $86e3afa6394a9ead$export$8eb75cb9f614d270);

var $aBhlC = parcelRequire("aBhlC");
"use strict";
const $86e3afa6394a9ead$export$8eb75cb9f614d270 = {
    extension: {
        type: (0, $aBhlC.ExtensionType).ShapeBuilder,
        name: "triangle"
    },
    build (shape, points) {
        points[0] = shape.x;
        points[1] = shape.y;
        points[2] = shape.x2;
        points[3] = shape.y2;
        points[4] = shape.x3;
        points[5] = shape.y3;
        return true;
    },
    triangulate (points, vertices, verticesStride, verticesOffset, indices, indicesOffset) {
        let count = 0;
        verticesOffset *= verticesStride;
        vertices[verticesOffset + count] = points[0];
        vertices[verticesOffset + count + 1] = points[1];
        count += verticesStride;
        vertices[verticesOffset + count] = points[2];
        vertices[verticesOffset + count + 1] = points[3];
        count += verticesStride;
        vertices[verticesOffset + count] = points[4];
        vertices[verticesOffset + count + 1] = points[5];
        const verticesIndex = verticesOffset / verticesStride;
        indices[indicesOffset++] = verticesIndex;
        indices[indicesOffset++] = verticesIndex + 1;
        indices[indicesOffset++] = verticesIndex + 2;
    }
};

});

parcelRegister("diq28", function(module, exports) {

$parcel$export(module.exports, "generateTextureMatrix", () => $70087a5d3aa93827$export$1e9b9e463121b388);

var $deLbn = parcelRequire("deLbn");

var $kNl9L = parcelRequire("kNl9L");

var $4dwOg = parcelRequire("4dwOg");
"use strict";
const $70087a5d3aa93827$var$tempTextureMatrix = new (0, $deLbn.Matrix)();
const $70087a5d3aa93827$var$tempRect = new (0, $kNl9L.Rectangle)();
function $70087a5d3aa93827$export$1e9b9e463121b388(out, style, shape, matrix) {
    const textureMatrix = style.matrix ? out.copyFrom(style.matrix).invert() : out.identity();
    if (style.textureSpace === "local") {
        const bounds = shape.getBounds($70087a5d3aa93827$var$tempRect);
        if (style.width) bounds.pad(style.width);
        const { x: tx, y: ty } = bounds;
        const sx = 1 / bounds.width;
        const sy = 1 / bounds.height;
        const mTx = -tx * sx;
        const mTy = -ty * sy;
        const a1 = textureMatrix.a;
        const b1 = textureMatrix.b;
        const c1 = textureMatrix.c;
        const d1 = textureMatrix.d;
        textureMatrix.a *= sx;
        textureMatrix.b *= sx;
        textureMatrix.c *= sy;
        textureMatrix.d *= sy;
        textureMatrix.tx = mTx * a1 + mTy * c1 + textureMatrix.tx;
        textureMatrix.ty = mTx * b1 + mTy * d1 + textureMatrix.ty;
    } else {
        textureMatrix.translate(style.texture.frame.x, style.texture.frame.y);
        textureMatrix.scale(1 / style.texture.source.width, 1 / style.texture.source.height);
    }
    const sourceStyle = style.texture.source.style;
    if (!(style.fill instanceof (0, $4dwOg.FillGradient)) && sourceStyle.addressMode === "clamp-to-edge") {
        sourceStyle.addressMode = "repeat";
        sourceStyle.update();
    }
    if (matrix) textureMatrix.append($70087a5d3aa93827$var$tempTextureMatrix.copyFrom(matrix).invert());
    return textureMatrix;
}

});
parcelRegister("4dwOg", function(module, exports) {

$parcel$export(module.exports, "FillGradient", () => $81d9f6150bfb4f00$export$722a6ea8c60ca86);

var $jr7Dg = parcelRequire("jr7Dg");

var $dHliN = parcelRequire("dHliN");

var $deLbn = parcelRequire("deLbn");

var $7xwxM = parcelRequire("7xwxM");

var $cmH9g = parcelRequire("cmH9g");

var $kfwXR = parcelRequire("kfwXR");

var $dXBy0 = parcelRequire("dXBy0");

var $bjnCb = parcelRequire("bjnCb");
"use strict";
const $81d9f6150bfb4f00$var$emptyColorStops = [
    {
        offset: 0,
        color: "white"
    },
    {
        offset: 1,
        color: "black"
    }
];
const $81d9f6150bfb4f00$var$_FillGradient = class _FillGradient {
    constructor(...args){
        /**
     * Unique identifier for this gradient instance
     * @internal
     */ this.uid = (0, $kfwXR.uid)("fillGradient");
        /**
     * Internal tick counter to track changes in the gradient.
     * This is used to invalidate the gradient when the texture changes.
     * @internal
     */ this._tick = 0;
        /** Type of gradient - currently only supports 'linear' */ this.type = "linear";
        /** Array of color stops defining the gradient */ this.colorStops = [];
        let options = $81d9f6150bfb4f00$var$ensureGradientOptions(args);
        const defaults = options.type === "radial" ? _FillGradient.defaultRadialOptions : _FillGradient.defaultLinearOptions;
        options = {
            ...defaults,
            ...(0, $bjnCb.definedProps)(options)
        };
        this._textureSize = options.textureSize;
        this._wrapMode = options.wrapMode;
        if (options.type === "radial") {
            this.center = options.center;
            this.outerCenter = options.outerCenter ?? this.center;
            this.innerRadius = options.innerRadius;
            this.outerRadius = options.outerRadius;
            this.scale = options.scale;
            this.rotation = options.rotation;
        } else {
            this.start = options.start;
            this.end = options.end;
        }
        this.textureSpace = options.textureSpace;
        this.type = options.type;
        options.colorStops.forEach((stop)=>{
            this.addColorStop(stop.offset, stop.color);
        });
    }
    /**
   * Adds a color stop to the gradient
   * @param offset - Position of the stop (0-1)
   * @param color - Color of the stop
   * @returns This gradient instance for chaining
   */ addColorStop(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: (0, $jr7Dg.Color).shared.setValue(color).toHexa()
        });
        return this;
    }
    /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */ buildLinearGradient() {
        if (this.texture) return;
        let { x: x0, y: y0 } = this.start;
        let { x: x1, y: y1 } = this.end;
        let dx = x1 - x0;
        let dy = y1 - y0;
        const flip = dx < 0 || dy < 0;
        if (this._wrapMode === "clamp-to-edge") {
            if (dx < 0) {
                const temp = x0;
                x0 = x1;
                x1 = temp;
                dx *= -1;
            }
            if (dy < 0) {
                const temp = y0;
                y0 = y1;
                y1 = temp;
                dy *= -1;
            }
        }
        const colorStops = this.colorStops.length ? this.colorStops : $81d9f6150bfb4f00$var$emptyColorStops;
        const defaultSize = this._textureSize;
        const { canvas: canvas, context: context } = $81d9f6150bfb4f00$var$getCanvas(defaultSize, 1);
        const gradient = !flip ? context.createLinearGradient(0, 0, this._textureSize, 0) : context.createLinearGradient(this._textureSize, 0, 0, 0);
        $81d9f6150bfb4f00$var$addColorStops(gradient, colorStops);
        context.fillStyle = gradient;
        context.fillRect(0, 0, defaultSize, 1);
        this.texture = new (0, $cmH9g.Texture)({
            source: new (0, $7xwxM.ImageSource)({
                resource: canvas,
                addressMode: this._wrapMode
            })
        });
        const dist = Math.sqrt(dx * dx + dy * dy);
        const angle = Math.atan2(dy, dx);
        const m = new (0, $deLbn.Matrix)();
        m.scale(dist / defaultSize, 1);
        m.rotate(angle);
        m.translate(x0, y0);
        if (this.textureSpace === "local") m.scale(defaultSize, defaultSize);
        this.transform = m;
    }
    /**
   * Builds the internal texture and transform for the gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */ buildGradient() {
        if (!this.texture) this._tick++;
        if (this.type === "linear") this.buildLinearGradient();
        else this.buildRadialGradient();
    }
    /**
   * Builds the internal texture and transform for the radial gradient.
   * Called automatically when the gradient is first used.
   * @internal
   */ buildRadialGradient() {
        if (this.texture) return;
        const colorStops = this.colorStops.length ? this.colorStops : $81d9f6150bfb4f00$var$emptyColorStops;
        const defaultSize = this._textureSize;
        const { canvas: canvas, context: context } = $81d9f6150bfb4f00$var$getCanvas(defaultSize, defaultSize);
        const { x: x0, y: y0 } = this.center;
        const { x: x1, y: y1 } = this.outerCenter;
        const r0 = this.innerRadius;
        const r1 = this.outerRadius;
        const ox = x1 - r1;
        const oy = y1 - r1;
        const scale = defaultSize / (r1 * 2);
        const cx = (x0 - ox) * scale;
        const cy = (y0 - oy) * scale;
        const gradient = context.createRadialGradient(cx, cy, r0 * scale, (x1 - ox) * scale, (y1 - oy) * scale, r1 * scale);
        $81d9f6150bfb4f00$var$addColorStops(gradient, colorStops);
        context.fillStyle = colorStops[colorStops.length - 1].color;
        context.fillRect(0, 0, defaultSize, defaultSize);
        context.fillStyle = gradient;
        context.translate(cx, cy);
        context.rotate(this.rotation);
        context.scale(1, this.scale);
        context.translate(-cx, -cy);
        context.fillRect(0, 0, defaultSize, defaultSize);
        this.texture = new (0, $cmH9g.Texture)({
            source: new (0, $7xwxM.ImageSource)({
                resource: canvas,
                addressMode: this._wrapMode
            })
        });
        const m = new (0, $deLbn.Matrix)();
        m.scale(1 / scale, 1 / scale);
        m.translate(ox, oy);
        if (this.textureSpace === "local") m.scale(defaultSize, defaultSize);
        this.transform = m;
    }
    /** Destroys the gradient, releasing resources. This will also destroy the internal texture. */ destroy() {
        this.texture?.destroy(true);
        this.texture = null;
        this.transform = null;
        this.colorStops = [];
        this.start = null;
        this.end = null;
        this.center = null;
        this.outerCenter = null;
    }
    /**
   * Returns a unique key for this gradient instance.
   * This key is used for caching and texture management.
   * @returns {string} Unique key for the gradient
   */ get styleKey() {
        return `fill-gradient-${this.uid}-${this._tick}`;
    }
};
/** Default options for creating a gradient fill */ $81d9f6150bfb4f00$var$_FillGradient.defaultLinearOptions = {
    start: {
        x: 0,
        y: 0
    },
    end: {
        x: 0,
        y: 1
    },
    colorStops: [],
    textureSpace: "local",
    type: "linear",
    textureSize: 256,
    wrapMode: "clamp-to-edge"
};
/** Default options for creating a radial gradient fill */ $81d9f6150bfb4f00$var$_FillGradient.defaultRadialOptions = {
    center: {
        x: 0.5,
        y: 0.5
    },
    innerRadius: 0,
    outerRadius: 0.5,
    colorStops: [],
    scale: 1,
    textureSpace: "local",
    type: "radial",
    textureSize: 256,
    wrapMode: "clamp-to-edge"
};
let $81d9f6150bfb4f00$export$722a6ea8c60ca86 = $81d9f6150bfb4f00$var$_FillGradient;
function $81d9f6150bfb4f00$var$addColorStops(gradient, colorStops) {
    for(let i = 0; i < colorStops.length; i++){
        const stop = colorStops[i];
        gradient.addColorStop(stop.offset, stop.color);
    }
}
function $81d9f6150bfb4f00$var$getCanvas(width, height) {
    const canvas = (0, $dHliN.DOMAdapter).get().createCanvas(width, height);
    const context = canvas.getContext("2d");
    return {
        canvas: canvas,
        context: context
    };
}
function $81d9f6150bfb4f00$var$ensureGradientOptions(args) {
    let options = args[0] ?? {};
    if (typeof options === "number" || args[1]) {
        (0, $dXBy0.deprecation)("8.5.2", `use options object instead`);
        options = {
            type: "linear",
            start: {
                x: args[0],
                y: args[1]
            },
            end: {
                x: args[2],
                y: args[3]
            },
            textureSpace: args[4],
            textureSize: args[5] ?? $81d9f6150bfb4f00$export$722a6ea8c60ca86.defaultLinearOptions.textureSize
        };
    }
    return options;
}

});



parcelRegister("jqDfq", function(module, exports) {

$parcel$export(module.exports, "FillPattern", () => $43ee888bab5eea89$export$3d1378c7410cd8e);

var $deLbn = parcelRequire("deLbn");

var $kfwXR = parcelRequire("kfwXR");
"use strict";
const $43ee888bab5eea89$var$repetitionMap = {
    repeat: {
        addressModeU: "repeat",
        addressModeV: "repeat"
    },
    "repeat-x": {
        addressModeU: "repeat",
        addressModeV: "clamp-to-edge"
    },
    "repeat-y": {
        addressModeU: "clamp-to-edge",
        addressModeV: "repeat"
    },
    "no-repeat": {
        addressModeU: "clamp-to-edge",
        addressModeV: "clamp-to-edge"
    }
};
class $43ee888bab5eea89$export$3d1378c7410cd8e {
    constructor(texture, repetition){
        /**
     * unique id for this fill pattern
     * @internal
     */ this.uid = (0, $kfwXR.uid)("fillPattern");
        /**
     * Internal tick counter to track changes in the pattern.
     * This is used to invalidate the pattern when the texture or transform changes.
     * @internal
     */ this._tick = 0;
        /** The transform matrix applied to the pattern */ this.transform = new (0, $deLbn.Matrix)();
        this.texture = texture;
        this.transform.scale(1 / texture.frame.width, 1 / texture.frame.height);
        if (repetition) {
            texture.source.style.addressModeU = $43ee888bab5eea89$var$repetitionMap[repetition].addressModeU;
            texture.source.style.addressModeV = $43ee888bab5eea89$var$repetitionMap[repetition].addressModeV;
        }
    }
    /**
   * Sets the transform for the pattern
   * @param transform - The transform matrix to apply to the pattern.
   * If not provided, the pattern will use the default transform.
   */ setTransform(transform) {
        const texture = this.texture;
        this.transform.copyFrom(transform);
        this.transform.invert();
        this.transform.scale(1 / texture.frame.width, 1 / texture.frame.height);
        this._tick++;
    }
    /** Internal texture used to render the gradient */ get texture() {
        return this._texture;
    }
    set texture(value) {
        if (this._texture === value) return;
        this._texture = value;
        this._tick++;
    }
    /**
   * Returns a unique key for this instance.
   * This key is used for caching.
   * @returns {string} Unique key for the instance
   */ get styleKey() {
        return `fill-pattern-${this.uid}-${this._tick}`;
    }
    /** Destroys the fill pattern, releasing resources. This will also destroy the internal texture. */ destroy() {
        this.texture.destroy(true);
        this.texture = null;
    }
}

});

parcelRegister("bcTIE", function(module, exports) {

$parcel$export(module.exports, "Graphics", () => $4967ab07d279f0e7$export$29d3e417456abdad);

var $dXBy0 = parcelRequire("dXBy0");

var $aHyJR = parcelRequire("aHyJR");

var $lP6io = parcelRequire("lP6io");
parcelRequire("45bKO");
"use strict";
class $4967ab07d279f0e7$export$29d3e417456abdad extends (0, $aHyJR.ViewContainer) {
    /**
   * Creates a new Graphics object.
   * @param options - Options for the Graphics.
   */ constructor(options){
        if (options instanceof (0, $lP6io.GraphicsContext)) options = {
            context: options
        };
        const { context: context, roundPixels: roundPixels, ...rest } = options || {};
        super({
            label: "Graphics",
            ...rest
        });
        /** @internal */ this.renderPipeId = "graphics";
        if (!context) {
            this.context = this._ownedContext = new (0, $lP6io.GraphicsContext)();
            this.context.autoGarbageCollect = this.autoGarbageCollect;
        } else this.context = context;
        this.didViewUpdate = true;
        this.allowChildren = false;
        this.roundPixels = roundPixels ?? false;
    }
    set context(context) {
        if (context === this._context) return;
        if (this._context) {
            this._context.off("update", this.onViewUpdate, this);
            this._context.off("unload", this.unload, this);
        }
        this._context = context;
        this._context.on("update", this.onViewUpdate, this);
        this._context.on("unload", this.unload, this);
        this.onViewUpdate();
    }
    /**
   * The underlying graphics context used for drawing operations.
   * Controls how shapes and paths are rendered.
   * @example
   * ```ts
   * // Create a shared context
   * const sharedContext = new GraphicsContext();
   *
   * // Create graphics objects sharing the same context
   * const graphics1 = new Graphics();
   * const graphics2 = new Graphics();
   *
   * // Assign shared context
   * graphics1.context = sharedContext;
   * graphics2.context = sharedContext;
   *
   * // Both graphics will show the same shapes
   * sharedContext
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   * ```
   * @see {@link GraphicsContext} For drawing operations
   * @see {@link GraphicsOptions} For context configuration
   */ get context() {
        return this._context;
    }
    /**
   * The local bounds of the graphics object.
   * Returns the boundaries after all graphical operations but before any transforms.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Get bounds information
   * const bounds = graphics.bounds;
   * console.log(bounds.width);  // 100
   * console.log(bounds.height); // 100
   * ```
   * @readonly
   * @see {@link Bounds} For bounds operations
   * @see {@link Container#getBounds} For transformed bounds
   */ get bounds() {
        return this._context.bounds;
    }
    /**
   * Graphics objects do not need to update their bounds as the context handles this.
   * @private
   */ updateBounds() {}
    /**
   * Checks if the object contains the given point.
   * Returns true if the point lies within the Graphics object's rendered area.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw a shape
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .fill({ color: 0xff0000 });
   *
   * // Check point intersection
   * if (graphics.containsPoint({ x: 50, y: 50 })) {
   *     console.log('Point is inside rectangle!');
   * }
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is inside the Graphics object
   * @see {@link Graphics#bounds} For bounding box checks
   * @see {@link PointData} For point data structure
   */ containsPoint(point) {
        return this._context.containsPoint(point);
    }
    /**
   * Destroys this graphics renderable and optionally its context.
   * @param options - Options parameter. A boolean will act as if all options
   *
   * If the context was created by this graphics and `destroy(false)` or `destroy()` is called
   * then the context will still be destroyed.
   *
   * If you want to explicitly not destroy this context that this graphics created,
   * then you should pass destroy({ context: false })
   *
   * If the context was passed in as an argument to the constructor then it will not be destroyed
   * @example
   * ```ts
   * // Destroy the graphics and its context
   * graphics.destroy();
   * graphics.destroy(true);
   * graphics.destroy({ context: true, texture: true, textureSource: true });
   * ```
   */ destroy(options) {
        if (this._ownedContext && !options) this._ownedContext.destroy(options);
        else if (options === true || options?.context === true) this._context.destroy(options);
        this._ownedContext = null;
        this._context = null;
        super.destroy(options);
    }
    /**
   * @param now - The current time in milliseconds.
   * @internal
   */ _onTouch(now) {
        this._gcLastUsed = now;
        this._context._gcLastUsed = now;
    }
    _callContextMethod(method, args) {
        this.context[method](...args);
        return this;
    }
    // --------------------------------------- GraphicsContext methods ---------------------------------------
    /**
   * Sets the current fill style of the graphics context.
   * The fill style can be a color, gradient, pattern, or a complex style object.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics
   *     .setFillStyle({ color: 0xff0000 }) // Red fill
   *     .rect(0, 0, 100, 100)
   *     .fill();
   *
   * // Gradient fill
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setFillStyle(gradient)
   *     .circle(100, 100, 50)
   *     .fill();
   *
   * // Pattern fill
   * const pattern = new FillPattern(texture);
   * graphics
   *     .setFillStyle({
   *         fill: pattern,
   *         alpha: 0.5
   *     })
   *     .rect(0, 0, 200, 200)
   *     .fill();
   * ```
   * @param {FillInput} args - The fill style to apply
   * @returns The Graphics instance for chaining
   * @see {@link FillStyle} For fill style options
   * @see {@link FillGradient} For gradient fills
   * @see {@link FillPattern} For pattern fills
   */ setFillStyle(...args) {
        return this._callContextMethod("setFillStyle", args);
    }
    /**
   * Sets the current stroke style of the graphics context.
   * Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color stroke
   * graphics
   *     .setStrokeStyle({
   *         width: 2,
   *         color: 0x000000
   *     })
   *     .rect(0, 0, 100, 100)
   *     .stroke();
   *
   * // Complex stroke style
   * graphics
   *     .setStrokeStyle({
   *         width: 4,
   *         color: 0xff0000,
   *         alpha: 0.5,
   *         join: 'round',
   *         cap: 'round',
   *         alignment: 0.5
   *     })
   *     .circle(100, 100, 50)
   *     .stroke();
   *
   * // Gradient stroke
   * const gradient = new FillGradient({
   *    end: { x: 1, y: 0 },
   *    colorStops: [
   *         { offset: 0, color: 0xff0000 }, // Red at start
   *         { offset: 0.5, color: 0x00ff00 }, // Green at middle
   *         { offset: 1, color: 0x0000ff }, // Blue at end
   *    ],
   * });
   *
   * graphics
   *     .setStrokeStyle({
   *         width: 10,
   *         fill: gradient
   *     })
   *     .poly([0,0, 100,50, 0,100])
   *     .stroke();
   * ```
   * @param {StrokeInput} args - The stroke style to apply
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link FillPattern} For pattern strokes
   */ setStrokeStyle(...args) {
        return this._callContextMethod("setStrokeStyle", args);
    }
    fill(...args) {
        return this._callContextMethod("fill", args);
    }
    /**
   * Strokes the current path with the current stroke style or specified style.
   * Outlines the shape using the stroke settings.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Stroke with direct color
   * graphics
   *     .circle(50, 50, 25)
   *     .stroke({
   *         width: 2,
   *         color: 0xff0000
   *     }); // 2px red stroke
   *
   * // Fill with texture
   * graphics
   *    .rect(0, 0, 100, 100)
   *    .stroke(myTexture); // Fill with texture
   *
   * // Stroke with gradient
   * const gradient = new FillGradient({
   *     end: { x: 1, y: 0 },
   *     colorStops: [
   *         { offset: 0, color: 0xff0000 },
   *         { offset: 0.5, color: 0x00ff00 },
   *         { offset: 1, color: 0x0000ff },
   *     ],
   * });
   *
   * graphics
   *     .rect(0, 0, 100, 100)
   *     .stroke({
   *         width: 4,
   *         fill: gradient,
   *         alignment: 0.5,
   *         join: 'round'
   *     });
   * ```
   * @param {StrokeStyle} args - Optional stroke style to apply. Can be:
   * - A stroke style object with width, color, etc.
   * - A gradient
   * - A pattern
   * If omitted, uses current stroke style.
   * @returns The Graphics instance for chaining
   * @see {@link StrokeStyle} For stroke style options
   * @see {@link FillGradient} For gradient strokes
   * @see {@link setStrokeStyle} For setting default stroke style
   */ stroke(...args) {
        return this._callContextMethod("stroke", args);
    }
    texture(...args) {
        return this._callContextMethod("texture", args);
    }
    /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @example
   * ```ts
   * const graphics = new Graphics();
   * graphics
   *     .circle(150, 150, 50)
   *     .fill({ color: 0x00ff00 })
   *     .beginPath() // Starts a new path
   *     .circle(250, 150, 50)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for chaining
   * @see {@link Graphics#moveTo} For starting a new subpath
   * @see {@link Graphics#closePath} For closing the current path
   */ beginPath() {
        return this._callContextMethod("beginPath", []);
    }
    /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path.
   *
   * If a hole is not completely in a shape, it will fail to cut correctly.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw outer circle
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *     .circle(100, 100, 25) // Inner circle
   *     .cut() // Cuts out the inner circle from the outer circle
   * ```
   */ cut() {
        return this._callContextMethod("cut", []);
    }
    arc(...args) {
        return this._callContextMethod("arc", args);
    }
    arcTo(...args) {
        return this._callContextMethod("arcTo", args);
    }
    arcToSvg(...args) {
        return this._callContextMethod("arcToSvg", args);
    }
    bezierCurveTo(...args) {
        return this._callContextMethod("bezierCurveTo", args);
    }
    /**
   * Closes the current path by drawing a straight line back to the start point.
   *
   * This is useful for completing shapes and ensuring they are properly closed for fills.
   * @example
   * ```ts
   * // Create a triangle with closed path
   * const graphics = new Graphics();
   * graphics
   *     .moveTo(50, 50)
   *     .lineTo(100, 100)
   *     .lineTo(0, 100)
   *     .closePath()
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path
   * @see {@link Graphics#fill} For filling closed paths
   * @see {@link Graphics#stroke} For stroking paths
   */ closePath() {
        return this._callContextMethod("closePath", []);
    }
    ellipse(...args) {
        return this._callContextMethod("ellipse", args);
    }
    circle(...args) {
        return this._callContextMethod("circle", args);
    }
    path(...args) {
        return this._callContextMethod("path", args);
    }
    lineTo(...args) {
        return this._callContextMethod("lineTo", args);
    }
    moveTo(...args) {
        return this._callContextMethod("moveTo", args);
    }
    quadraticCurveTo(...args) {
        return this._callContextMethod("quadraticCurveTo", args);
    }
    rect(...args) {
        return this._callContextMethod("rect", args);
    }
    roundRect(...args) {
        return this._callContextMethod("roundRect", args);
    }
    poly(...args) {
        return this._callContextMethod("poly", args);
    }
    regularPoly(...args) {
        return this._callContextMethod("regularPoly", args);
    }
    roundPoly(...args) {
        return this._callContextMethod("roundPoly", args);
    }
    roundShape(...args) {
        return this._callContextMethod("roundShape", args);
    }
    filletRect(...args) {
        return this._callContextMethod("filletRect", args);
    }
    chamferRect(...args) {
        return this._callContextMethod("chamferRect", args);
    }
    star(...args) {
        return this._callContextMethod("star", args);
    }
    svg(...args) {
        return this._callContextMethod("svg", args);
    }
    restore(...args) {
        return this._callContextMethod("restore", args);
    }
    /**
   * Saves the current graphics state onto a stack. The state includes:
   * - Current transformation matrix
   * - Current fill style
   * - Current stroke style
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Save state before complex operations
   * graphics.save();
   *
   * // Create transformed and styled shape
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4)
   *     .setFillStyle({
   *         color: 0xff0000,
   *         alpha: 0.5
   *     })
   *     .rect(-25, -25, 50, 50)
   *     .fill();
   *
   * // Restore to original state
   * graphics.restore();
   *
   * // Continue drawing with previous state
   * graphics
   *     .circle(50, 50, 25)
   *     .fill();
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#restore} For restoring the saved state
   * @see {@link Graphics#setTransform} For setting transformations
   */ save() {
        return this._callContextMethod("save", []);
    }
    /**
   * Returns the current transformation matrix of the graphics context.
   * This matrix represents all accumulated transformations including translate, scale, and rotate.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply some transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .rotateTransform(Math.PI / 4);
   *
   * // Get the current transform matrix
   * const matrix = graphics.getTransform();
   * console.log(matrix.tx, matrix.ty); // 100, 100
   *
   * // Use the matrix for other operations
   * graphics
   *     .setTransform(matrix)
   *     .circle(0, 0, 50)
   *     .fill({ color: 0xff0000 });
   * ```
   * @returns The current transformation matrix.
   * @see {@link Graphics#setTransform} For setting the transform matrix
   * @see {@link Matrix} For matrix operations
   */ getTransform() {
        return this.context.getTransform();
    }
    /**
   * Resets the current transformation matrix to the identity matrix, effectively removing
   * any transformations (rotation, scaling, translation) previously applied.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Apply transformations
   * graphics
   *     .translateTransform(100, 100)
   *     .scaleTransform(2, 2)
   *     .circle(0, 0, 25)
   *     .fill({ color: 0xff0000 });
   * // Reset transform to default state
   * graphics
   *     .resetTransform()
   *     .circle(50, 50, 25) // Will draw at actual coordinates
   *     .fill({ color: 0x00ff00 });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#getTransform} For getting the current transform
   * @see {@link Graphics#setTransform} For setting a specific transform
   * @see {@link Graphics#save} For saving the current transform state
   * @see {@link Graphics#restore} For restoring a previous transform state
   */ resetTransform() {
        return this._callContextMethod("resetTransform", []);
    }
    rotateTransform(...args) {
        return this._callContextMethod("rotate", args);
    }
    scaleTransform(...args) {
        return this._callContextMethod("scale", args);
    }
    setTransform(...args) {
        return this._callContextMethod("setTransform", args);
    }
    transform(...args) {
        return this._callContextMethod("transform", args);
    }
    translateTransform(...args) {
        return this._callContextMethod("translate", args);
    }
    /**
   * Clears all drawing commands from the graphics context, effectively resetting it.
   * This includes clearing the current path, fill style, stroke style, and transformations.
   *
   * > [!NOTE] Graphics objects are not designed to be continuously cleared and redrawn.
   * > Instead, they are intended to be used for static or semi-static graphics that
   * > can be redrawn as needed. Frequent clearing and redrawing may lead to performance issues.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Draw some shapes
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 })
   *     .rect(200, 100, 100, 50)
   *     .fill({ color: 0x00ff00 });
   *
   * // Clear all graphics
   * graphics.clear();
   *
   * // Start fresh with new shapes
   * graphics
   *     .circle(150, 150, 30)
   *     .fill({ color: 0x0000ff });
   * ```
   * @returns The Graphics instance for method chaining
   * @see {@link Graphics#beginPath} For starting a new path without clearing styles
   * @see {@link Graphics#save} For saving the current state
   * @see {@link Graphics#restore} For restoring a previous state
   */ clear() {
        return this._callContextMethod("clear", []);
    }
    /**
   * Gets or sets the current fill style for the graphics context. The fill style determines
   * how shapes are filled when using the fill() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic color fill
   * graphics.fillStyle = {
   *     color: 0xff0000,  // Red
   *     alpha: 1
   * };
   *
   * // Using gradients
   * const gradient = new FillGradient({
   *     end: { x: 0, y: 1 }, // Vertical gradient
   *     stops: [
   *         { offset: 0, color: 0xff0000, alpha: 1 }, // Start color
   *         { offset: 1, color: 0x0000ff, alpha: 1 }  // End color
   *     ]
   * });
   *
   * graphics.fillStyle = {
   *     fill: gradient,
   *     alpha: 0.8
   * };
   *
   * // Using patterns
   * graphics.fillStyle = {
   *     texture: myTexture,
   *     alpha: 1,
   *     matrix: new Matrix()
   *         .scale(0.5, 0.5)
   *         .rotate(Math.PI / 4)
   * };
   * ```
   * @type {ConvertedFillStyle}
   * @see {@link FillStyle} For all available fill style options
   * @see {@link FillGradient} For creating gradient fills
   * @see {@link Graphics#fill} For applying the fill to paths
   */ get fillStyle() {
        return this._context.fillStyle;
    }
    set fillStyle(value) {
        this._context.fillStyle = value;
    }
    /**
   * Gets or sets the current stroke style for the graphics context. The stroke style determines
   * how paths are outlined when using the stroke() method.
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Basic stroke style
   * graphics.strokeStyle = {
   *     width: 2,
   *     color: 0xff0000,
   *     alpha: 1
   * };
   *
   * // Using with gradients
   * const gradient = new FillGradient({
   *   end: { x: 0, y: 1 },
   *   stops: [
   *       { offset: 0, color: 0xff0000, alpha: 1 },
   *       { offset: 1, color: 0x0000ff, alpha: 1 }
   *   ]
   * });
   *
   * graphics.strokeStyle = {
   *     width: 4,
   *     fill: gradient,
   *     alignment: 0.5,
   *     join: 'round',
   *     cap: 'round'
   * };
   *
   * // Complex stroke settings
   * graphics.strokeStyle = {
   *     width: 6,
   *     color: 0x00ff00,
   *     alpha: 0.5,
   *     join: 'miter',
   *     miterLimit: 10,
   * };
   * ```
   * @see {@link StrokeStyle} For all available stroke style options
   * @see {@link Graphics#stroke} For applying the stroke to paths
   */ get strokeStyle() {
        return this._context.strokeStyle;
    }
    set strokeStyle(value) {
        this._context.strokeStyle = value;
    }
    /**
   * Creates a new Graphics object that copies the current graphics content.
   * The clone can either share the same context (shallow clone) or have its own independent
   * context (deep clone).
   * @example
   * ```ts
   * const graphics = new Graphics();
   *
   * // Create original graphics content
   * graphics
   *     .circle(100, 100, 50)
   *     .fill({ color: 0xff0000 });
   *
   * // Create a shallow clone (shared context)
   * const shallowClone = graphics.clone();
   *
   * // Changes to original affect the clone
   * graphics
   *     .circle(200, 100, 30)
   *     .fill({ color: 0x00ff00 });
   *
   * // Create a deep clone (independent context)
   * const deepClone = graphics.clone(true);
   *
   * // Modify deep clone independently
   * deepClone
   *     .translateTransform(100, 100)
   *     .circle(0, 0, 40)
   *     .fill({ color: 0x0000ff });
   * ```
   * @param deep - Whether to create a deep clone of the graphics object.
   *              If false (default), the context will be shared between objects.
   *              If true, creates an independent copy of the context.
   * @returns A new Graphics instance with either shared or copied context
   * @see {@link Graphics#context} For accessing the underlying graphics context
   * @see {@link GraphicsContext} For understanding the shared context behavior
   */ clone(deep = false) {
        if (deep) return new $4967ab07d279f0e7$export$29d3e417456abdad(this._context.clone());
        this._ownedContext = null;
        const clone = new $4967ab07d279f0e7$export$29d3e417456abdad(this._context);
        return clone;
    }
    // -------- v7 deprecations ---------
    /**
   * @param width
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#setStrokeStyle} instead
   */ lineStyle(width, color, alpha) {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "Graphics#lineStyle is no longer needed. Use Graphics#setStrokeStyle to set the stroke style.");
        const strokeStyle = {};
        width && (strokeStyle.width = width);
        color && (strokeStyle.color = color);
        alpha && (strokeStyle.alpha = alpha);
        this.context.strokeStyle = strokeStyle;
        return this;
    }
    /**
   * @param color
   * @param alpha
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */ beginFill(color, alpha) {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "Graphics#beginFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
        const fillStyle = {};
        if (color !== void 0) fillStyle.color = color;
        if (alpha !== void 0) fillStyle.alpha = alpha;
        this.context.fillStyle = fillStyle;
        return this;
    }
    /**
   * @deprecated since 8.0.0 Use {@link Graphics#fill} instead
   */ endFill() {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "Graphics#endFill is no longer needed. Use Graphics#fill to fill the shape with the desired style.");
        this.context.fill();
        const strokeStyle = this.context.strokeStyle;
        if (strokeStyle.width !== (0, $lP6io.GraphicsContext).defaultStrokeStyle.width || strokeStyle.color !== (0, $lP6io.GraphicsContext).defaultStrokeStyle.color || strokeStyle.alpha !== (0, $lP6io.GraphicsContext).defaultStrokeStyle.alpha) this.context.stroke();
        return this;
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#circle} instead
   */ drawCircle(...args) {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "Graphics#drawCircle has been renamed to Graphics#circle");
        return this._callContextMethod("circle", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#ellipse} instead
   */ drawEllipse(...args) {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "Graphics#drawEllipse has been renamed to Graphics#ellipse");
        return this._callContextMethod("ellipse", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#poly} instead
   */ drawPolygon(...args) {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "Graphics#drawPolygon has been renamed to Graphics#poly");
        return this._callContextMethod("poly", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#rect} instead
   */ drawRect(...args) {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "Graphics#drawRect has been renamed to Graphics#rect");
        return this._callContextMethod("rect", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#roundRect} instead
   */ drawRoundedRect(...args) {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "Graphics#drawRoundedRect has been renamed to Graphics#roundRect");
        return this._callContextMethod("roundRect", args);
    }
    /**
   * @param {...any} args
   * @deprecated since 8.0.0 Use {@link Graphics#star} instead
   */ drawStar(...args) {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "Graphics#drawStar has been renamed to Graphics#star");
        return this._callContextMethod("star", args);
    }
}

});
parcelRegister("lP6io", function(module, exports) {

$parcel$export(module.exports, "GraphicsContext", () => $ba29a52349ba3e0b$export$cde35afe8b5f985);

var $6AQ4q = parcelRequire("6AQ4q");

var $jr7Dg = parcelRequire("jr7Dg");

var $deLbn = parcelRequire("deLbn");

var $lwGvb = parcelRequire("lwGvb");

var $cmH9g = parcelRequire("cmH9g");

var $kfwXR = parcelRequire("kfwXR");

var $dXBy0 = parcelRequire("dXBy0");

var $eWGg9 = parcelRequire("eWGg9");

var $aRSAY = parcelRequire("aRSAY");

var $8mb5H = parcelRequire("8mb5H");

var $3lOoE = parcelRequire("3lOoE");

var $SaxLb = parcelRequire("SaxLb");
"use strict";
const $ba29a52349ba3e0b$var$tmpPoint = new (0, $lwGvb.Point)();
const $ba29a52349ba3e0b$var$tempMatrix = new (0, $deLbn.Matrix)();
const $ba29a52349ba3e0b$var$_GraphicsContext = class _GraphicsContext extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    constructor(){
        super(...arguments);
        /** @internal */ this._gpuData = /* @__PURE__ */ Object.create(null);
        /** If set to true, the resource will be garbage collected automatically when it is not used. */ this.autoGarbageCollect = true;
        /** @internal */ this._gcLastUsed = -1;
        /**
     * unique id for this graphics context
     * @internal
     */ this.uid = (0, $kfwXR.uid)("graphicsContext");
        /**
     * Indicates whether content is updated and have to be re-rendered.
     * @internal
     */ this.dirty = true;
        /** The batch mode for this graphics context. It can be 'auto', 'batch', or 'no-batch'. */ this.batchMode = "auto";
        /** @internal */ this.instructions = [];
        /** Whether the graphics context has been destroyed. */ this.destroyed = false;
        this._activePath = new (0, $aRSAY.GraphicsPath)();
        this._transform = new (0, $deLbn.Matrix)();
        this._fillStyle = {
            ..._GraphicsContext.defaultFillStyle
        };
        this._strokeStyle = {
            ..._GraphicsContext.defaultStrokeStyle
        };
        this._stateStack = [];
        this._tick = 0;
        this._bounds = new (0, $eWGg9.Bounds)();
        this._boundsDirty = true;
    }
    /**
   * Creates a new GraphicsContext object that is a clone of this instance, copying all properties,
   * including the current drawing state, transformations, styles, and instructions.
   * @returns A new GraphicsContext instance with the same properties and state as this one.
   */ clone() {
        const clone = new _GraphicsContext();
        clone.batchMode = this.batchMode;
        clone.instructions = this.instructions.slice();
        clone._activePath = this._activePath.clone();
        clone._transform = this._transform.clone();
        clone._fillStyle = {
            ...this._fillStyle
        };
        clone._strokeStyle = {
            ...this._strokeStyle
        };
        clone._stateStack = this._stateStack.slice();
        clone._bounds = this._bounds.clone();
        clone._boundsDirty = true;
        return clone;
    }
    /**
   * The current fill style of the graphics context. This can be a color, gradient, pattern, or a more complex style defined by a FillStyle object.
   */ get fillStyle() {
        return this._fillStyle;
    }
    set fillStyle(value) {
        this._fillStyle = (0, $3lOoE.toFillStyle)(value, _GraphicsContext.defaultFillStyle);
    }
    /**
   * The current stroke style of the graphics context. Similar to fill styles, stroke styles can encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   */ get strokeStyle() {
        return this._strokeStyle;
    }
    set strokeStyle(value) {
        this._strokeStyle = (0, $3lOoE.toStrokeStyle)(value, _GraphicsContext.defaultStrokeStyle);
    }
    /**
   * Sets the current fill style of the graphics context. The fill style can be a color, gradient,
   * pattern, or a more complex style defined by a FillStyle object.
   * @param style - The fill style to apply. This can be a simple color, a gradient or pattern object,
   *                or a FillStyle or ConvertedFillStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setFillStyle(style) {
        this._fillStyle = (0, $3lOoE.toFillStyle)(style, _GraphicsContext.defaultFillStyle);
        return this;
    }
    /**
   * Sets the current stroke style of the graphics context. Similar to fill styles, stroke styles can
   * encompass colors, gradients, patterns, or more detailed configurations via a StrokeStyle object.
   * @param style - The stroke style to apply. Can be defined as a color, a gradient or pattern,
   *                or a StrokeStyle or ConvertedStrokeStyle object.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ setStrokeStyle(style) {
        this._strokeStyle = (0, $3lOoE.toFillStyle)(style, _GraphicsContext.defaultStrokeStyle);
        return this;
    }
    texture(texture, tint, dx, dy, dw, dh) {
        this.instructions.push({
            action: "texture",
            data: {
                image: texture,
                dx: dx || 0,
                dy: dy || 0,
                dw: dw || texture.frame.width,
                dh: dh || texture.frame.height,
                transform: this._transform.clone(),
                alpha: this._fillStyle.alpha,
                style: tint || tint === 0 ? (0, $jr7Dg.Color).shared.setValue(tint).toNumber() : 16777215
            }
        });
        this.onUpdate();
        return this;
    }
    /**
   * Resets the current path. Any previous path and its commands are discarded and a new path is
   * started. This is typically called before beginning a new shape or series of drawing commands.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ beginPath() {
        this._activePath = new (0, $aRSAY.GraphicsPath)();
        return this;
    }
    fill(style, alpha) {
        let path;
        const lastInstruction = this.instructions[this.instructions.length - 1];
        if (this._tick === 0 && lastInstruction?.action === "stroke") path = lastInstruction.data.path;
        else path = this._activePath.clone();
        if (!path) return this;
        if (style != null) {
            if (alpha !== void 0 && typeof style === "number") {
                (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "GraphicsContext.fill(color, alpha) is deprecated, use GraphicsContext.fill({ color, alpha }) instead");
                style = {
                    color: style,
                    alpha: alpha
                };
            }
            this._fillStyle = (0, $3lOoE.toFillStyle)(style, _GraphicsContext.defaultFillStyle);
        }
        this.instructions.push({
            action: "fill",
            // TODO copy fill style!
            data: {
                style: this.fillStyle,
                path: path
            }
        });
        this.onUpdate();
        this._initNextPathLocation();
        this._tick = 0;
        return this;
    }
    _initNextPathLocation() {
        const { x: x, y: y } = this._activePath.getLastPoint((0, $lwGvb.Point).shared);
        this._activePath.clear();
        this._activePath.moveTo(x, y);
    }
    /**
   * Strokes the current path with the current stroke style. This method can take an optional
   * FillInput parameter to define the stroke's appearance, including its color, width, and other properties.
   * @param style - (Optional) The stroke style to apply. Can be defined as a simple color or a more complex style object. If omitted, uses the current stroke style.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ stroke(style) {
        let path;
        const lastInstruction = this.instructions[this.instructions.length - 1];
        if (this._tick === 0 && lastInstruction?.action === "fill") path = lastInstruction.data.path;
        else path = this._activePath.clone();
        if (!path) return this;
        if (style != null) this._strokeStyle = (0, $3lOoE.toStrokeStyle)(style, _GraphicsContext.defaultStrokeStyle);
        this.instructions.push({
            action: "stroke",
            // TODO copy fill style!
            data: {
                style: this.strokeStyle,
                path: path
            }
        });
        this.onUpdate();
        this._initNextPathLocation();
        this._tick = 0;
        return this;
    }
    /**
   * Applies a cutout to the last drawn shape. This is used to create holes or complex shapes by
   * subtracting a path from the previously drawn path. If a hole is not completely in a shape, it will
   * fail to cut correctly!
   * @returns The instance of the current GraphicsContext for method chaining.
   */ cut() {
        for(let i = 0; i < 2; i++){
            const lastInstruction = this.instructions[this.instructions.length - 1 - i];
            const holePath = this._activePath.clone();
            if (lastInstruction) {
                if (lastInstruction.action === "stroke" || lastInstruction.action === "fill") {
                    if (lastInstruction.data.hole) lastInstruction.data.hole.addPath(holePath);
                    else {
                        lastInstruction.data.hole = holePath;
                        break;
                    }
                }
            }
        }
        this._initNextPathLocation();
        return this;
    }
    /**
   * Adds an arc to the current path, which is centered at (x, y) with the specified radius,
   * starting and ending angles, and direction.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The arc's radius.
   * @param startAngle - The starting angle, in radians.
   * @param endAngle - The ending angle, in radians.
   * @param counterclockwise - (Optional) Specifies whether the arc is drawn counterclockwise (true) or clockwise (false). Defaults to false.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ arc(x, y, radius, startAngle, endAngle, counterclockwise) {
        this._tick++;
        const t = this._transform;
        this._activePath.arc(t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    /**
   * Adds an arc to the current path with the given control points and radius, connected to the previous point
   * by a straight line if necessary.
   * @param x1 - The x-coordinate of the first control point.
   * @param y1 - The y-coordinate of the first control point.
   * @param x2 - The x-coordinate of the second control point.
   * @param y2 - The y-coordinate of the second control point.
   * @param radius - The arc's radius.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ arcTo(x1, y1, x2, y2, radius) {
        this._tick++;
        const t = this._transform;
        this._activePath.arcTo(t.a * x1 + t.c * y1 + t.tx, t.b * x1 + t.d * y1 + t.ty, t.a * x2 + t.c * y2 + t.tx, t.b * x2 + t.d * y2 + t.ty, radius);
        return this;
    }
    /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */ arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
        this._tick++;
        const t = this._transform;
        this._activePath.arcToSvg(rx, ry, xAxisRotation, // should we rotate this with transform??
        largeArcFlag, sweepFlag, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty);
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y, smoothness) {
        this._tick++;
        const t = this._transform;
        this._activePath.bezierCurveTo(t.a * cp1x + t.c * cp1y + t.tx, t.b * cp1x + t.d * cp1y + t.ty, t.a * cp2x + t.c * cp2y + t.tx, t.b * cp2x + t.d * cp2y + t.ty, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, smoothness);
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this._tick++;
        this._activePath?.closePath();
        return this;
    }
    /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @returns The instance of the current object for chaining.
   */ ellipse(x, y, radiusX, radiusY) {
        this._tick++;
        this._activePath.ellipse(x, y, radiusX, radiusY, this._transform.clone());
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius) {
        this._tick++;
        this._activePath.circle(x, y, radius, this._transform.clone());
        return this;
    }
    /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @returns The instance of the current object for chaining.
   */ path(path) {
        this._tick++;
        this._activePath.addPath(path, this._transform.clone());
        return this;
    }
    /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */ lineTo(x, y) {
        this._tick++;
        const t = this._transform;
        this._activePath.lineTo(t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty);
        return this;
    }
    /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */ moveTo(x, y) {
        this._tick++;
        const t = this._transform;
        const instructions = this._activePath.instructions;
        const transformedX = t.a * x + t.c * y + t.tx;
        const transformedY = t.b * x + t.d * y + t.ty;
        if (instructions.length === 1 && instructions[0].action === "moveTo") {
            instructions[0].data[0] = transformedX;
            instructions[0].data[1] = transformedY;
            return this;
        }
        this._activePath.moveTo(transformedX, transformedY);
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cpx - The x-coordinate of the control point.
   * @param cpy - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveTo(cpx, cpy, x, y, smoothness) {
        this._tick++;
        const t = this._transform;
        this._activePath.quadraticCurveTo(t.a * cpx + t.c * cpy + t.tx, t.b * cpx + t.d * cpy + t.ty, t.a * x + t.c * y + t.tx, t.b * x + t.d * y + t.ty, smoothness);
        return this;
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h) {
        this._tick++;
        this._activePath.rect(x, y, w, h, this._transform.clone());
        return this;
    }
    /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @returns The instance of the current object for chaining.
   */ roundRect(x, y, w, h, radius) {
        this._tick++;
        this._activePath.roundRect(x, y, w, h, radius, this._transform.clone());
        return this;
    }
    /**
   * Draws a polygon shape by specifying a sequence of points. This method allows for the creation of complex polygons,
   * which can be both open and closed. An optional transformation can be applied, enabling the polygon to be scaled,
   * rotated, or translated as needed.
   * @param points - An array of numbers, or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates, of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   */ poly(points, close) {
        this._tick++;
        this._activePath.poly(points, close, this._transform.clone());
        return this;
    }
    /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ regularPoly(x, y, radius, sides, rotation = 0, transform) {
        this._tick++;
        this._activePath.regularPoly(x, y, radius, sides, rotation, transform);
        return this;
    }
    /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @returns The instance of the current object for chaining.
   */ roundPoly(x, y, radius, sides, corner, rotation) {
        this._tick++;
        this._activePath.roundPoly(x, y, radius, sides, corner, rotation);
        return this;
    }
    /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */ roundShape(points, radius, useQuadratic, smoothness) {
        this._tick++;
        this._activePath.roundShape(points, radius, useQuadratic, smoothness);
        return this;
    }
    /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */ filletRect(x, y, width, height, fillet) {
        this._tick++;
        this._activePath.filletRect(x, y, width, height, fillet);
        return this;
    }
    /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */ chamferRect(x, y, width, height, chamfer, transform) {
        this._tick++;
        this._activePath.chamferRect(x, y, width, height, chamfer, transform);
        return this;
    }
    /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @returns The instance of the current object for chaining further drawing commands.
   */ star(x, y, points, radius, innerRadius = 0, rotation = 0) {
        this._tick++;
        this._activePath.star(x, y, points, radius, innerRadius, rotation, this._transform.clone());
        return this;
    }
    /**
   * Parses and renders an SVG string into the graphics context. This allows for complex shapes and paths
   * defined in SVG format to be drawn within the graphics context.
   * @param svg - The SVG string to be parsed and rendered.
   */ svg(svg) {
        this._tick++;
        (0, $8mb5H.SVGParser)(svg, this);
        return this;
    }
    /**
   * Restores the most recently saved graphics state by popping the top of the graphics state stack.
   * This includes transformations, fill styles, and stroke styles.
   */ restore() {
        const state = this._stateStack.pop();
        if (state) {
            this._transform = state.transform;
            this._fillStyle = state.fillStyle;
            this._strokeStyle = state.strokeStyle;
        }
        return this;
    }
    /** Saves the current graphics state, including transformations, fill styles, and stroke styles, onto a stack. */ save() {
        this._stateStack.push({
            transform: this._transform.clone(),
            fillStyle: {
                ...this._fillStyle
            },
            strokeStyle: {
                ...this._strokeStyle
            }
        });
        return this;
    }
    /**
   * Returns the current transformation matrix of the graphics context.
   * @returns The current transformation matrix.
   */ getTransform() {
        return this._transform;
    }
    /**
   * Resets the current transformation matrix to the identity matrix, effectively removing any transformations (rotation, scaling, translation) previously applied.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ resetTransform() {
        this._transform.identity();
        return this;
    }
    /**
   * Applies a rotation transformation to the graphics context around the current origin.
   * @param angle - The angle of rotation in radians.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ rotate(angle) {
        this._transform.rotate(angle);
        return this;
    }
    /**
   * Applies a scaling transformation to the graphics context, scaling drawings by x horizontally and by y vertically.
   * @param x - The scale factor in the horizontal direction.
   * @param y - (Optional) The scale factor in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ scale(x, y = x) {
        this._transform.scale(x, y);
        return this;
    }
    setTransform(a, b, c, d, dx, dy) {
        if (a instanceof (0, $deLbn.Matrix)) {
            this._transform.set(a.a, a.b, a.c, a.d, a.tx, a.ty);
            return this;
        }
        this._transform.set(a, b, c, d, dx, dy);
        return this;
    }
    transform(a, b, c, d, dx, dy) {
        if (a instanceof (0, $deLbn.Matrix)) {
            this._transform.append(a);
            return this;
        }
        $ba29a52349ba3e0b$var$tempMatrix.set(a, b, c, d, dx, dy);
        this._transform.append($ba29a52349ba3e0b$var$tempMatrix);
        return this;
    }
    /**
   * Applies a translation transformation to the graphics context, moving the origin by the specified amounts.
   * @param x - The amount to translate in the horizontal direction.
   * @param y - (Optional) The amount to translate in the vertical direction. If not specified, the x value is used for both directions.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ translate(x, y = x) {
        this._transform.translate(x, y);
        return this;
    }
    /**
   * Clears all drawing commands from the graphics context, effectively resetting it. This includes clearing the path,
   * and optionally resetting transformations to the identity matrix.
   * @returns The instance of the current GraphicsContext for method chaining.
   */ clear() {
        this._activePath.clear();
        this.instructions.length = 0;
        this.resetTransform();
        this.onUpdate();
        return this;
    }
    onUpdate() {
        this._boundsDirty = true;
        this.dirty = true;
        this.emit("update", this, 16);
    }
    /** The bounds of the graphic shape. */ get bounds() {
        if (!this._boundsDirty) return this._bounds;
        this._boundsDirty = false;
        const bounds = this._bounds;
        bounds.clear();
        for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            const action = instruction.action;
            if (action === "fill") {
                const data = instruction.data;
                bounds.addBounds(data.path.bounds);
            } else if (action === "texture") {
                const data = instruction.data;
                bounds.addFrame(data.dx, data.dy, data.dx + data.dw, data.dy + data.dh, data.transform);
            }
            if (action === "stroke") {
                const data = instruction.data;
                const alignment = data.style.alignment;
                let outerPadding = data.style.width * (1 - alignment);
                if (data.style.join === "miter") outerPadding *= (0, $SaxLb.getMaxMiterRatio)(data.path, data.style.miterLimit);
                const _bounds = data.path.bounds;
                bounds.addFrame(_bounds.minX - outerPadding, _bounds.minY - outerPadding, _bounds.maxX + outerPadding, _bounds.maxY + outerPadding);
            }
        }
        if (!bounds.isValid) bounds.set(0, 0, 0, 0);
        return bounds;
    }
    /**
   * Check to see if a point is contained within this geometry.
   * @param point - Point to check if it's contained.
   * @returns {boolean} `true` if the point is contained within geometry.
   */ containsPoint(point) {
        if (!this.bounds.containsPoint(point.x, point.y)) return false;
        const instructions = this.instructions;
        let hasHit = false;
        for(let k = 0; k < instructions.length; k++){
            const instruction = instructions[k];
            const data = instruction.data;
            const path = data.path;
            if (!instruction.action || !path) continue;
            const style = data.style;
            const shapes = path.shapePath.shapePrimitives;
            for(let i = 0; i < shapes.length; i++){
                const shape = shapes[i].shape;
                if (!style || !shape) continue;
                const transform = shapes[i].transform;
                const transformedPoint = transform ? transform.applyInverse(point, $ba29a52349ba3e0b$var$tmpPoint) : point;
                if (instruction.action === "fill") hasHit = shape.contains(transformedPoint.x, transformedPoint.y);
                else {
                    const strokeStyle = style;
                    hasHit = shape.strokeContains(transformedPoint.x, transformedPoint.y, strokeStyle.width, strokeStyle.alignment);
                }
                const holes = data.hole;
                if (holes) {
                    const holeShapes = holes.shapePath?.shapePrimitives;
                    if (holeShapes) {
                        for(let j = 0; j < holeShapes.length; j++)if (holeShapes[j].shape.contains(transformedPoint.x, transformedPoint.y)) hasHit = false;
                    }
                }
                if (hasHit) return true;
            }
        }
        return hasHit;
    }
    /** Unloads the GPU data from the graphics context. */ unload() {
        this.emit("unload", this);
        for(const key in this._gpuData)this._gpuData[key]?.destroy();
        this._gpuData = /* @__PURE__ */ Object.create(null);
    }
    /**
   * Destroys the GraphicsData object.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * context.destroy();
   * context.destroy(true);
   * context.destroy({ texture: true, textureSource: true });
   */ destroy(options = false) {
        if (this.destroyed) return;
        this.destroyed = true;
        this._stateStack.length = 0;
        this._transform = null;
        this.unload();
        this.emit("destroy", this);
        this.removeAllListeners();
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            if (this._fillStyle.texture) this._fillStyle.fill && "uid" in this._fillStyle.fill ? this._fillStyle.fill.destroy() : this._fillStyle.texture.destroy(destroyTextureSource);
            if (this._strokeStyle.texture) this._strokeStyle.fill && "uid" in this._strokeStyle.fill ? this._strokeStyle.fill.destroy() : this._strokeStyle.texture.destroy(destroyTextureSource);
        }
        this._fillStyle = null;
        this._strokeStyle = null;
        this.instructions = null;
        this._activePath = null;
        this._bounds = null;
        this._stateStack = null;
        this.customShader = null;
        this._transform = null;
    }
};
/** The default fill style to use when none is provided. */ $ba29a52349ba3e0b$var$_GraphicsContext.defaultFillStyle = {
    /** The color to use for the fill. */ color: 16777215,
    /** The alpha value to use for the fill. */ alpha: 1,
    /** The texture to use for the fill. */ texture: (0, $cmH9g.Texture).WHITE,
    /** The matrix to apply. */ matrix: null,
    /** The fill pattern to use. */ fill: null,
    /** Whether coordinates are 'global' or 'local' */ textureSpace: "local"
};
/** The default stroke style to use when none is provided. */ $ba29a52349ba3e0b$var$_GraphicsContext.defaultStrokeStyle = {
    /** The width of the stroke. */ width: 1,
    /** The color to use for the stroke. */ color: 16777215,
    /** The alpha value to use for the stroke. */ alpha: 1,
    /** The alignment of the stroke. */ alignment: 0.5,
    /** The miter limit to use. */ miterLimit: 10,
    /** The line cap style to use. */ cap: "butt",
    /** The line join style to use. */ join: "miter",
    /** The texture to use for the fill. */ texture: (0, $cmH9g.Texture).WHITE,
    /** The matrix to apply. */ matrix: null,
    /** The fill pattern to use. */ fill: null,
    /** Whether coordinates are 'global' or 'local' */ textureSpace: "local",
    /** If the stroke is a pixel line. */ pixelLine: false
};
let $ba29a52349ba3e0b$export$cde35afe8b5f985 = $ba29a52349ba3e0b$var$_GraphicsContext;

});
parcelRegister("aRSAY", function(module, exports) {

$parcel$export(module.exports, "GraphicsPath", () => $bb26bc9868306c2d$export$7e54506375634c19);

var $lwGvb = parcelRequire("lwGvb");

var $kfwXR = parcelRequire("kfwXR");

var $fGITk = parcelRequire("fGITk");

var $32iSl = parcelRequire("32iSl");

var $kBVeH = parcelRequire("kBVeH");
"use strict";
class $bb26bc9868306c2d$export$7e54506375634c19 {
    /**
   * Creates a `GraphicsPath` instance optionally from an SVG path string or an array of `PathInstruction`.
   * @param instructions - An SVG path string or an array of `PathInstruction` objects.
   * @param signed
   */ constructor(instructions, signed = false){
        this.instructions = [];
        /** unique id for this graphics path */ this.uid = (0, $kfwXR.uid)("graphicsPath");
        this._dirty = true;
        this.checkForHoles = signed;
        if (typeof instructions === "string") (0, $32iSl.parseSVGPath)(instructions, this);
        else this.instructions = instructions?.slice() ?? [];
    }
    /**
   * Provides access to the internal shape path, ensuring it is up-to-date with the current instructions.
   * @returns The `ShapePath` instance associated with this `GraphicsPath`.
   */ get shapePath() {
        if (!this._shapePath) this._shapePath = new (0, $kBVeH.ShapePath)(this);
        if (this._dirty) {
            this._dirty = false;
            this._shapePath.buildPath();
        }
        return this._shapePath;
    }
    /**
   * Adds another `GraphicsPath` to this path, optionally applying a transformation.
   * @param path - The `GraphicsPath` to add.
   * @param transform - An optional transformation to apply to the added path.
   * @returns The instance of the current object for chaining.
   */ addPath(path, transform) {
        path = path.clone();
        this.instructions.push({
            action: "addPath",
            data: [
                path,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    arc(...args) {
        this.instructions.push({
            action: "arc",
            data: args
        });
        this._dirty = true;
        return this;
    }
    arcTo(...args) {
        this.instructions.push({
            action: "arcTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    arcToSvg(...args) {
        this.instructions.push({
            action: "arcToSvg",
            data: args
        });
        this._dirty = true;
        return this;
    }
    bezierCurveTo(...args) {
        this.instructions.push({
            action: "bezierCurveTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires two points: the second control point and the end point. The first control point is assumed to be
   * The starting point is the last point in the current path.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveToShort(cp2x, cp2y, x, y, smoothness) {
        const last = this.instructions[this.instructions.length - 1];
        const lastPoint = this.getLastPoint((0, $lwGvb.Point).shared);
        let cp1x = 0;
        let cp1y = 0;
        if (!last || last.action !== "bezierCurveTo") {
            cp1x = lastPoint.x;
            cp1y = lastPoint.y;
        } else {
            cp1x = last.data[2];
            cp1y = last.data[3];
            const currentX = lastPoint.x;
            const currentY = lastPoint.y;
            cp1x = currentX + (currentX - cp1x);
            cp1y = currentY + (currentY - cp1y);
        }
        this.instructions.push({
            action: "bezierCurveTo",
            data: [
                cp1x,
                cp1y,
                cp2x,
                cp2y,
                x,
                y,
                smoothness
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this.instructions.push({
            action: "closePath",
            data: []
        });
        this._dirty = true;
        return this;
    }
    ellipse(...args) {
        this.instructions.push({
            action: "ellipse",
            data: args
        });
        this._dirty = true;
        return this;
    }
    lineTo(...args) {
        this.instructions.push({
            action: "lineTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    moveTo(...args) {
        this.instructions.push({
            action: "moveTo",
            data: args
        });
        return this;
    }
    quadraticCurveTo(...args) {
        this.instructions.push({
            action: "quadraticCurveTo",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It uses the previous point as the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveToShort(x, y, smoothness) {
        const last = this.instructions[this.instructions.length - 1];
        const lastPoint = this.getLastPoint((0, $lwGvb.Point).shared);
        let cpx1 = 0;
        let cpy1 = 0;
        if (!last || last.action !== "quadraticCurveTo") {
            cpx1 = lastPoint.x;
            cpy1 = lastPoint.y;
        } else {
            cpx1 = last.data[0];
            cpy1 = last.data[1];
            const currentX = lastPoint.x;
            const currentY = lastPoint.y;
            cpx1 = currentX + (currentX - cpx1);
            cpy1 = currentY + (currentY - cpy1);
        }
        this.instructions.push({
            action: "quadraticCurveTo",
            data: [
                cpx1,
                cpy1,
                x,
                y,
                smoothness
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h, transform) {
        this.instructions.push({
            action: "rect",
            data: [
                x,
                y,
                w,
                h,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius, transform) {
        this.instructions.push({
            action: "circle",
            data: [
                x,
                y,
                radius,
                transform
            ]
        });
        this._dirty = true;
        return this;
    }
    roundRect(...args) {
        this.instructions.push({
            action: "roundRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    poly(...args) {
        this.instructions.push({
            action: "poly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    regularPoly(...args) {
        this.instructions.push({
            action: "regularPoly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    roundPoly(...args) {
        this.instructions.push({
            action: "roundPoly",
            data: args
        });
        this._dirty = true;
        return this;
    }
    roundShape(...args) {
        this.instructions.push({
            action: "roundShape",
            data: args
        });
        this._dirty = true;
        return this;
    }
    filletRect(...args) {
        this.instructions.push({
            action: "filletRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    chamferRect(...args) {
        this.instructions.push({
            action: "chamferRect",
            data: args
        });
        this._dirty = true;
        return this;
    }
    /**
   * Draws a star shape centered at a specified location. This method allows for the creation
   *  of stars with a variable number of points, outer radius, optional inner radius, and rotation.
   * The star is drawn as a closed polygon with alternating outer and inner vertices to create the star's points.
   * An optional transformation can be applied to scale, rotate, or translate the star as needed.
   * @param x - The x-coordinate of the center of the star.
   * @param y - The y-coordinate of the center of the star.
   * @param points - The number of points of the star.
   * @param radius - The outer radius of the star (distance from the center to the outer points).
   * @param innerRadius - Optional. The inner radius of the star
   * (distance from the center to the inner points between the outer points).
   * If not provided, defaults to half of the `radius`.
   * @param rotation - Optional. The rotation of the star in radians, where 0 is aligned with the y-axis.
   * Defaults to 0, meaning one point is directly upward.
   * @param transform - An optional `Matrix` object to apply a transformation to the star.
   * This can include rotations, scaling, and translations.
   * @returns The instance of the current object for chaining further drawing commands.
   */ // eslint-disable-next-line max-len
    star(x, y, points, radius, innerRadius, rotation, transform) {
        innerRadius || (innerRadius = radius / 2);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const len = points * 2;
        const delta = Math.PI * 2 / len;
        const polygon = [];
        for(let i = 0; i < len; i++){
            const r = i % 2 ? innerRadius : radius;
            const angle = i * delta + startAngle;
            polygon.push(x + r * Math.cos(angle), y + r * Math.sin(angle));
        }
        this.poly(polygon, true, transform);
        return this;
    }
    /**
   * Creates a copy of the current `GraphicsPath` instance. This method supports both shallow and deep cloning.
   * A shallow clone copies the reference of the instructions array, while a deep clone creates a new array and
   * copies each instruction individually, ensuring that modifications to the instructions of the cloned `GraphicsPath`
   * do not affect the original `GraphicsPath` and vice versa.
   * @param deep - A boolean flag indicating whether the clone should be deep.
   * @returns A new `GraphicsPath` instance that is a clone of the current instance.
   */ clone(deep = false) {
        const newGraphicsPath2D = new $bb26bc9868306c2d$export$7e54506375634c19();
        newGraphicsPath2D.checkForHoles = this.checkForHoles;
        if (!deep) newGraphicsPath2D.instructions = this.instructions.slice();
        else for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            newGraphicsPath2D.instructions.push({
                action: instruction.action,
                data: instruction.data.slice()
            });
        }
        return newGraphicsPath2D;
    }
    clear() {
        this.instructions.length = 0;
        this._dirty = true;
        return this;
    }
    /**
   * Applies a transformation matrix to all drawing instructions within the `GraphicsPath`.
   * This method enables the modification of the path's geometry according to the provided
   * transformation matrix, which can include translations, rotations, scaling, and skewing.
   *
   * Each drawing instruction in the path is updated to reflect the transformation,
   * ensuring the visual representation of the path is consistent with the applied matrix.
   *
   * Note: The transformation is applied directly to the coordinates and control points of the drawing instructions,
   * not to the path as a whole. This means the transformation's effects are baked into the individual instructions,
   * allowing for fine-grained control over the path's appearance.
   * @param matrix - A `Matrix` object representing the transformation to apply.
   * @returns The instance of the current object for chaining further operations.
   */ transform(matrix) {
        if (matrix.isIdentity()) return this;
        const a = matrix.a;
        const b = matrix.b;
        const c = matrix.c;
        const d = matrix.d;
        const tx = matrix.tx;
        const ty = matrix.ty;
        let x = 0;
        let y = 0;
        let cpx1 = 0;
        let cpy1 = 0;
        let cpx2 = 0;
        let cpy2 = 0;
        let rx = 0;
        let ry = 0;
        for(let i = 0; i < this.instructions.length; i++){
            const instruction = this.instructions[i];
            const data = instruction.data;
            switch(instruction.action){
                case "moveTo":
                case "lineTo":
                    x = data[0];
                    y = data[1];
                    data[0] = a * x + c * y + tx;
                    data[1] = b * x + d * y + ty;
                    break;
                case "bezierCurveTo":
                    cpx1 = data[0];
                    cpy1 = data[1];
                    cpx2 = data[2];
                    cpy2 = data[3];
                    x = data[4];
                    y = data[5];
                    data[0] = a * cpx1 + c * cpy1 + tx;
                    data[1] = b * cpx1 + d * cpy1 + ty;
                    data[2] = a * cpx2 + c * cpy2 + tx;
                    data[3] = b * cpx2 + d * cpy2 + ty;
                    data[4] = a * x + c * y + tx;
                    data[5] = b * x + d * y + ty;
                    break;
                case "quadraticCurveTo":
                    cpx1 = data[0];
                    cpy1 = data[1];
                    x = data[2];
                    y = data[3];
                    data[0] = a * cpx1 + c * cpy1 + tx;
                    data[1] = b * cpx1 + d * cpy1 + ty;
                    data[2] = a * x + c * y + tx;
                    data[3] = b * x + d * y + ty;
                    break;
                case "arcToSvg":
                    x = data[5];
                    y = data[6];
                    rx = data[0];
                    ry = data[1];
                    data[0] = a * rx + c * ry;
                    data[1] = b * rx + d * ry;
                    data[5] = a * x + c * y + tx;
                    data[6] = b * x + d * y + ty;
                    break;
                case "circle":
                    data[4] = $bb26bc9868306c2d$var$adjustTransform(data[3], matrix);
                    break;
                case "rect":
                    data[4] = $bb26bc9868306c2d$var$adjustTransform(data[4], matrix);
                    break;
                case "ellipse":
                    data[8] = $bb26bc9868306c2d$var$adjustTransform(data[8], matrix);
                    break;
                case "roundRect":
                    data[5] = $bb26bc9868306c2d$var$adjustTransform(data[5], matrix);
                    break;
                case "addPath":
                    data[0].transform(matrix);
                    break;
                case "poly":
                    data[2] = $bb26bc9868306c2d$var$adjustTransform(data[2], matrix);
                    break;
                case "regularPoly":
                case "chamferRect":
                    data[5] = $bb26bc9868306c2d$var$adjustTransform(data[5], matrix);
                    break;
                case "closePath":
                    break;
                default:
                    (0, $fGITk.warn)("unknown transform action", instruction.action);
                    break;
            }
        }
        this._dirty = true;
        return this;
    }
    get bounds() {
        return this.shapePath.bounds;
    }
    /**
   * Retrieves the last point from the current drawing instructions in the `GraphicsPath`.
   * This method is useful for operations that depend on the path's current endpoint,
   * such as connecting subsequent shapes or paths. It supports various drawing instructions,
   * ensuring the last point's position is accurately determined regardless of the path's complexity.
   *
   * If the last instruction is a `closePath`, the method iterates backward through the instructions
   *  until it finds an actionable instruction that defines a point (e.g., `moveTo`, `lineTo`,
   * `quadraticCurveTo`, etc.). For compound paths added via `addPath`, it recursively retrieves
   * the last point from the nested path.
   * @param out - A `Point` object where the last point's coordinates will be stored.
   * This object is modified directly to contain the result.
   * @returns The `Point` object containing the last point's coordinates.
   */ getLastPoint(out) {
        let index = this.instructions.length - 1;
        let lastInstruction = this.instructions[index];
        if (!lastInstruction) {
            out.x = 0;
            out.y = 0;
            return out;
        }
        while(lastInstruction.action === "closePath"){
            index--;
            if (index < 0) {
                out.x = 0;
                out.y = 0;
                return out;
            }
            lastInstruction = this.instructions[index];
        }
        switch(lastInstruction.action){
            case "moveTo":
            case "lineTo":
                out.x = lastInstruction.data[0];
                out.y = lastInstruction.data[1];
                break;
            case "quadraticCurveTo":
                out.x = lastInstruction.data[2];
                out.y = lastInstruction.data[3];
                break;
            case "bezierCurveTo":
                out.x = lastInstruction.data[4];
                out.y = lastInstruction.data[5];
                break;
            case "arc":
            case "arcToSvg":
                out.x = lastInstruction.data[5];
                out.y = lastInstruction.data[6];
                break;
            case "addPath":
                lastInstruction.data[0].getLastPoint(out);
                break;
        }
        return out;
    }
}
function $bb26bc9868306c2d$var$adjustTransform(currentMatrix, transform) {
    if (currentMatrix) return currentMatrix.prepend(transform);
    return transform.clone();
}

});
parcelRegister("32iSl", function(module, exports) {

$parcel$export(module.exports, "parseSVGPath", () => $b917401e393ddcef$export$33813e954ab16e32);

var $eJJJX = parcelRequire("eJJJX");

var $fGITk = parcelRequire("fGITk");
"use strict";
function $b917401e393ddcef$export$33813e954ab16e32(svgPath, path) {
    const commands = (0, (/*@__PURE__*/$parcel$interopDefault($eJJJX)))(svgPath);
    const subpaths = [];
    let currentSubPath = null;
    let lastX = 0;
    let lastY = 0;
    for(let i = 0; i < commands.length; i++){
        const command = commands[i];
        const type = command[0];
        const data = command;
        switch(type){
            case "M":
                lastX = data[1];
                lastY = data[2];
                path.moveTo(lastX, lastY);
                break;
            case "m":
                lastX += data[1];
                lastY += data[2];
                path.moveTo(lastX, lastY);
                break;
            case "H":
                lastX = data[1];
                path.lineTo(lastX, lastY);
                break;
            case "h":
                lastX += data[1];
                path.lineTo(lastX, lastY);
                break;
            case "V":
                lastY = data[1];
                path.lineTo(lastX, lastY);
                break;
            case "v":
                lastY += data[1];
                path.lineTo(lastX, lastY);
                break;
            case "L":
                lastX = data[1];
                lastY = data[2];
                path.lineTo(lastX, lastY);
                break;
            case "l":
                lastX += data[1];
                lastY += data[2];
                path.lineTo(lastX, lastY);
                break;
            case "C":
                lastX = data[5];
                lastY = data[6];
                path.bezierCurveTo(data[1], data[2], // First control point
                data[3], data[4], // Second control point
                lastX, lastY);
                break;
            case "c":
                path.bezierCurveTo(lastX + data[1], lastY + data[2], // First control point
                lastX + data[3], lastY + data[4], // Second control point
                lastX + data[5], lastY + data[6]);
                lastX += data[5];
                lastY += data[6];
                break;
            case "S":
                lastX = data[3];
                lastY = data[4];
                path.bezierCurveToShort(data[1], data[2], // Control point
                lastX, lastY);
                break;
            case "s":
                path.bezierCurveToShort(lastX + data[1], lastY + data[2], // Control point
                lastX + data[3], lastY + data[4]);
                lastX += data[3];
                lastY += data[4];
                break;
            case "Q":
                lastX = data[3];
                lastY = data[4];
                path.quadraticCurveTo(data[1], data[2], // Control point
                lastX, lastY);
                break;
            case "q":
                path.quadraticCurveTo(lastX + data[1], lastY + data[2], // Control point
                lastX + data[3], lastY + data[4]);
                lastX += data[3];
                lastY += data[4];
                break;
            case "T":
                lastX = data[1];
                lastY = data[2];
                path.quadraticCurveToShort(lastX, lastY);
                break;
            case "t":
                lastX += data[1];
                lastY += data[2];
                path.quadraticCurveToShort(lastX, lastY);
                break;
            case "A":
                lastX = data[6];
                lastY = data[7];
                path.arcToSvg(data[1], // rx
                data[2], // ry
                data[3], // x-axis-rotation
                data[4], // large-arc-flag
                data[5], // sweep-flag
                lastX, lastY);
                break;
            case "a":
                lastX += data[6];
                lastY += data[7];
                path.arcToSvg(data[1], // rx
                data[2], // ry
                data[3], // x-axis-rotation
                data[4], // large-arc-flag
                data[5], // sweep-flag
                lastX, lastY);
                break;
            case "Z":
            // Close Path
            case "z":
                path.closePath();
                if (subpaths.length > 0) {
                    currentSubPath = subpaths.pop();
                    if (currentSubPath) {
                        lastX = currentSubPath.startX;
                        lastY = currentSubPath.startY;
                    } else {
                        lastX = 0;
                        lastY = 0;
                    }
                }
                currentSubPath = null;
                break;
            default:
                (0, $fGITk.warn)(`Unknown SVG path command: ${type}`);
        }
        if (type !== "Z" && type !== "z") {
            if (currentSubPath === null) {
                currentSubPath = {
                    startX: lastX,
                    startY: lastY
                };
                subpaths.push(currentSubPath);
            }
        }
    }
    return path;
}

});
parcelRegister("eJJJX", function(module, exports) {
module.exports = $aba8bfb3df0db863$var$parse;
/**
 * expected argument lengths
 * @type {Object}
 */ var $aba8bfb3df0db863$var$length = {
    a: 7,
    c: 6,
    h: 1,
    l: 2,
    m: 2,
    q: 4,
    s: 4,
    t: 2,
    v: 1,
    z: 0
};
/**
 * segment pattern
 * @type {RegExp}
 */ var $aba8bfb3df0db863$var$segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
/**
 * parse an svg path data string. Generates an Array
 * of commands where each command is an Array of the
 * form `[command, arg1, arg2, ...]`
 *
 * @param {String} path
 * @return {Array}
 */ function $aba8bfb3df0db863$var$parse(path) {
    var data = [];
    path.replace($aba8bfb3df0db863$var$segment, function(_, command, args) {
        var type = command.toLowerCase();
        args = $aba8bfb3df0db863$var$parseValues(args);
        // overloaded moveTo
        if (type == 'm' && args.length > 2) {
            data.push([
                command
            ].concat(args.splice(0, 2)));
            type = 'l';
            command = command == 'm' ? 'l' : 'L';
        }
        while(true){
            if (args.length == $aba8bfb3df0db863$var$length[type]) {
                args.unshift(command);
                return data.push(args);
            }
            if (args.length < $aba8bfb3df0db863$var$length[type]) throw new Error('malformed path data');
            data.push([
                command
            ].concat(args.splice(0, $aba8bfb3df0db863$var$length[type])));
        }
    });
    return data;
}
var $aba8bfb3df0db863$var$number = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
function $aba8bfb3df0db863$var$parseValues(args) {
    var numbers = args.match($aba8bfb3df0db863$var$number);
    return numbers ? numbers.map(Number) : [];
}

});


parcelRegister("kBVeH", function(module, exports) {

$parcel$export(module.exports, "ShapePath", () => $6dec99049edd01de$export$148534a3c727230b);

var $4NUl1 = parcelRequire("4NUl1");

var $i4nao = parcelRequire("i4nao");

var $neDb4 = parcelRequire("neDb4");

var $kNl9L = parcelRequire("kNl9L");

var $de145 = parcelRequire("de145");

var $eWGg9 = parcelRequire("eWGg9");

var $5gw8E = parcelRequire("5gw8E");

var $3dWKd = parcelRequire("3dWKd");

var $4nDbL = parcelRequire("4nDbL");

var $53ruL = parcelRequire("53ruL");

var $g6uOW = parcelRequire("g6uOW");

var $eA1WK = parcelRequire("eA1WK");
"use strict";
const $6dec99049edd01de$var$tempRectangle = new (0, $kNl9L.Rectangle)();
class $6dec99049edd01de$export$148534a3c727230b {
    constructor(graphicsPath2D){
        /** The list of shape primitives that make up the path. */ this.shapePrimitives = [];
        this._currentPoly = null;
        this._bounds = new (0, $eWGg9.Bounds)();
        this._graphicsPath2D = graphicsPath2D;
        this.signed = graphicsPath2D.checkForHoles;
    }
    /**
   * Sets the starting point for a new sub-path. Any subsequent drawing commands are considered part of this path.
   * @param x - The x-coordinate for the starting point.
   * @param y - The y-coordinate for the starting point.
   * @returns The instance of the current object for chaining.
   */ moveTo(x, y) {
        this.startPoly(x, y);
        return this;
    }
    /**
   * Connects the current point to a new point with a straight line. This method updates the current path.
   * @param x - The x-coordinate of the new point to connect to.
   * @param y - The y-coordinate of the new point to connect to.
   * @returns The instance of the current object for chaining.
   */ lineTo(x, y) {
        this._ensurePoly();
        const points = this._currentPoly.points;
        const fromX = points[points.length - 2];
        const fromY = points[points.length - 1];
        if (fromX !== x || fromY !== y) points.push(x, y);
        return this;
    }
    /**
   * Adds an arc to the path. The arc is centered at (x, y)
   *  position with radius `radius` starting at `startAngle` and ending at `endAngle`.
   * @param x - The x-coordinate of the arc's center.
   * @param y - The y-coordinate of the arc's center.
   * @param radius - The radius of the arc.
   * @param startAngle - The starting angle of the arc, in radians.
   * @param endAngle - The ending angle of the arc, in radians.
   * @param counterclockwise - Specifies whether the arc should be drawn in the anticlockwise direction. False by default.
   * @returns The instance of the current object for chaining.
   */ arc(x, y, radius, startAngle, endAngle, counterclockwise) {
        this._ensurePoly(false);
        const points = this._currentPoly.points;
        (0, $4nDbL.buildArc)(points, x, y, radius, startAngle, endAngle, counterclockwise);
        return this;
    }
    /**
   * Adds an arc to the path with the arc tangent to the line joining two specified points.
   * The arc radius is specified by `radius`.
   * @param x1 - The x-coordinate of the first point.
   * @param y1 - The y-coordinate of the first point.
   * @param x2 - The x-coordinate of the second point.
   * @param y2 - The y-coordinate of the second point.
   * @param radius - The radius of the arc.
   * @returns The instance of the current object for chaining.
   */ arcTo(x1, y1, x2, y2, radius) {
        this._ensurePoly();
        const points = this._currentPoly.points;
        (0, $53ruL.buildArcTo)(points, x1, y1, x2, y2, radius);
        return this;
    }
    /**
   * Adds an SVG-style arc to the path, allowing for elliptical arcs based on the SVG spec.
   * @param rx - The x-radius of the ellipse.
   * @param ry - The y-radius of the ellipse.
   * @param xAxisRotation - The rotation of the ellipse's x-axis relative
   * to the x-axis of the coordinate system, in degrees.
   * @param largeArcFlag - Determines if the arc should be greater than or less than 180 degrees.
   * @param sweepFlag - Determines if the arc should be swept in a positive angle direction.
   * @param x - The x-coordinate of the arc's end point.
   * @param y - The y-coordinate of the arc's end point.
   * @returns The instance of the current object for chaining.
   */ arcToSvg(rx, ry, xAxisRotation, largeArcFlag, sweepFlag, x, y) {
        const points = this._currentPoly.points;
        (0, $g6uOW.buildArcToSvg)(points, this._currentPoly.lastX, this._currentPoly.lastY, x, y, rx, ry, xAxisRotation, largeArcFlag, sweepFlag);
        return this;
    }
    /**
   * Adds a cubic Bezier curve to the path.
   * It requires three points: the first two are control points and the third one is the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the first control point.
   * @param cp1y - The y-coordinate of the first control point.
   * @param cp2x - The x-coordinate of the second control point.
   * @param cp2y - The y-coordinate of the second control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothness - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y, smoothness) {
        this._ensurePoly();
        const currentPoly = this._currentPoly;
        (0, $5gw8E.buildAdaptiveBezier)(this._currentPoly.points, currentPoly.lastX, currentPoly.lastY, cp1x, cp1y, cp2x, cp2y, x, y, smoothness);
        return this;
    }
    /**
   * Adds a quadratic curve to the path. It requires two points: the control point and the end point.
   * The starting point is the last point in the current path.
   * @param cp1x - The x-coordinate of the control point.
   * @param cp1y - The y-coordinate of the control point.
   * @param x - The x-coordinate of the end point.
   * @param y - The y-coordinate of the end point.
   * @param smoothing - Optional parameter to adjust the smoothness of the curve.
   * @returns The instance of the current object for chaining.
   */ quadraticCurveTo(cp1x, cp1y, x, y, smoothing) {
        this._ensurePoly();
        const currentPoly = this._currentPoly;
        (0, $3dWKd.buildAdaptiveQuadratic)(this._currentPoly.points, currentPoly.lastX, currentPoly.lastY, cp1x, cp1y, x, y, smoothing);
        return this;
    }
    /**
   * Closes the current path by drawing a straight line back to the start.
   * If the shape is already closed or there are no points in the path, this method does nothing.
   * @returns The instance of the current object for chaining.
   */ closePath() {
        this.endPoly(true);
        return this;
    }
    /**
   * Adds another path to the current path. This method allows for the combination of multiple paths into one.
   * @param path - The `GraphicsPath` object representing the path to add.
   * @param transform - An optional `Matrix` object to apply a transformation to the path before adding it.
   * @returns The instance of the current object for chaining.
   */ addPath(path, transform) {
        this.endPoly();
        if (transform && !transform.isIdentity()) {
            path = path.clone(true);
            path.transform(transform);
        }
        const shapePrimitives = this.shapePrimitives;
        const start = shapePrimitives.length;
        for(let i = 0; i < path.instructions.length; i++){
            const instruction = path.instructions[i];
            this[instruction.action](...instruction.data);
        }
        if (path.checkForHoles && shapePrimitives.length - start > 1) {
            let mainShape = null;
            for(let i = start; i < shapePrimitives.length; i++){
                const shapePrimitive = shapePrimitives[i];
                if (shapePrimitive.shape.type === "polygon") {
                    const polygon = shapePrimitive.shape;
                    const mainPolygon = mainShape?.shape;
                    if (mainPolygon && mainPolygon.containsPolygon(polygon)) {
                        mainShape.holes || (mainShape.holes = []);
                        mainShape.holes.push(shapePrimitive);
                        shapePrimitives.copyWithin(i, i + 1);
                        shapePrimitives.length--;
                        i--;
                    } else mainShape = shapePrimitive;
                }
            }
        }
        return this;
    }
    /**
   * Finalizes the drawing of the current path. Optionally, it can close the path.
   * @param closePath - A boolean indicating whether to close the path after finishing. False by default.
   */ finish(closePath = false) {
        this.endPoly(closePath);
    }
    /**
   * Draws a rectangle shape. This method adds a new rectangle path to the current drawing.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ rect(x, y, w, h, transform) {
        this.drawShape(new (0, $kNl9L.Rectangle)(x, y, w, h), transform);
        return this;
    }
    /**
   * Draws a circle shape. This method adds a new circle path to the current drawing.
   * @param x - The x-coordinate of the center of the circle.
   * @param y - The y-coordinate of the center of the circle.
   * @param radius - The radius of the circle.
   * @param transform - An optional `Matrix` object to apply a transformation to the circle.
   * @returns The instance of the current object for chaining.
   */ circle(x, y, radius, transform) {
        this.drawShape(new (0, $4NUl1.Circle)(x, y, radius), transform);
        return this;
    }
    /**
   * Draws a polygon shape. This method allows for the creation of complex polygons by specifying a sequence of points.
   * @param points - An array of numbers, or or an array of PointData objects eg [{x,y}, {x,y}, {x,y}]
   * representing the x and y coordinates of the polygon's vertices, in sequence.
   * @param close - A boolean indicating whether to close the polygon path. True by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ poly(points, close, transform) {
        const polygon = new (0, $neDb4.Polygon)(points);
        polygon.closePath = close;
        this.drawShape(polygon, transform);
        return this;
    }
    /**
   * Draws a regular polygon with a specified number of sides. All sides and angles are equal.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param transform - An optional `Matrix` object to apply a transformation to the polygon.
   * @returns The instance of the current object for chaining.
   */ regularPoly(x, y, radius, sides, rotation = 0, transform) {
        sides = Math.max(sides | 0, 3);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const delta = Math.PI * 2 / sides;
        const polygon = [];
        for(let i = 0; i < sides; i++){
            const angle = startAngle - i * delta;
            polygon.push(x + radius * Math.cos(angle), y + radius * Math.sin(angle));
        }
        this.poly(polygon, true, transform);
        return this;
    }
    /**
   * Draws a polygon with rounded corners.
   * Similar to `regularPoly` but with the ability to round the corners of the polygon.
   * @param x - The x-coordinate of the center of the polygon.
   * @param y - The y-coordinate of the center of the polygon.
   * @param radius - The radius of the circumscribed circle of the polygon.
   * @param sides - The number of sides of the polygon. Must be 3 or more.
   * @param corner - The radius of the rounding of the corners.
   * @param rotation - The rotation angle of the polygon, in radians. Zero by default.
   * @param smoothness - Optional parameter to adjust the smoothness of the rounding.
   * @returns The instance of the current object for chaining.
   */ roundPoly(x, y, radius, sides, corner, rotation = 0, smoothness) {
        sides = Math.max(sides | 0, 3);
        if (corner <= 0) return this.regularPoly(x, y, radius, sides, rotation);
        const sideLength = radius * Math.sin(Math.PI / sides) - 1e-3;
        corner = Math.min(corner, sideLength);
        const startAngle = -1 * Math.PI / 2 + rotation;
        const delta = Math.PI * 2 / sides;
        const internalAngle = (sides - 2) * Math.PI / sides / 2;
        for(let i = 0; i < sides; i++){
            const angle = i * delta + startAngle;
            const x0 = x + radius * Math.cos(angle);
            const y0 = y + radius * Math.sin(angle);
            const a1 = angle + Math.PI + internalAngle;
            const a2 = angle - Math.PI - internalAngle;
            const x1 = x0 + corner * Math.cos(a1);
            const y1 = y0 + corner * Math.sin(a1);
            const x3 = x0 + corner * Math.cos(a2);
            const y3 = y0 + corner * Math.sin(a2);
            if (i === 0) this.moveTo(x1, y1);
            else this.lineTo(x1, y1);
            this.quadraticCurveTo(x0, y0, x3, y3, smoothness);
        }
        return this.closePath();
    }
    /**
   * Draws a shape with rounded corners. This function supports custom radius for each corner of the shape.
   * Optionally, corners can be rounded using a quadratic curve instead of an arc, providing a different aesthetic.
   * @param points - An array of `RoundedPoint` representing the corners of the shape to draw.
   * A minimum of 3 points is required.
   * @param radius - The default radius for the corners.
   * This radius is applied to all corners unless overridden in `points`.
   * @param useQuadratic - If set to true, rounded corners are drawn using a quadraticCurve
   *  method instead of an arc method. Defaults to false.
   * @param smoothness - Specifies the smoothness of the curve when `useQuadratic` is true.
   * Higher values make the curve smoother.
   * @returns The instance of the current object for chaining.
   */ roundShape(points, radius, useQuadratic = false, smoothness) {
        if (points.length < 3) return this;
        if (useQuadratic) (0, $eA1WK.roundedShapeQuadraticCurve)(this, points, radius, smoothness);
        else (0, $eA1WK.roundedShapeArc)(this, points, radius);
        return this.closePath();
    }
    /**
   * Draw Rectangle with fillet corners. This is much like rounded rectangle
   * however it support negative numbers as well for the corner radius.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param fillet - accept negative or positive values
   */ filletRect(x, y, width, height, fillet) {
        if (fillet === 0) return this.rect(x, y, width, height);
        const maxFillet = Math.min(width, height) / 2;
        const inset = Math.min(maxFillet, Math.max(-maxFillet, fillet));
        const right = x + width;
        const bottom = y + height;
        const dir = inset < 0 ? -inset : 0;
        const size = Math.abs(inset);
        return this.moveTo(x, y + size).arcTo(x + dir, y + dir, x + size, y, size).lineTo(right - size, y).arcTo(right - dir, y + dir, right, y + size, size).lineTo(right, bottom - size).arcTo(right - dir, bottom - dir, x + width - size, bottom, size).lineTo(x + size, bottom).arcTo(x + dir, bottom - dir, x, bottom - size, size).closePath();
    }
    /**
   * Draw Rectangle with chamfer corners. These are angled corners.
   * @param x - Upper left corner of rect
   * @param y - Upper right corner of rect
   * @param width - Width of rect
   * @param height - Height of rect
   * @param chamfer - non-zero real number, size of corner cutout
   * @param transform
   */ chamferRect(x, y, width, height, chamfer, transform) {
        if (chamfer <= 0) return this.rect(x, y, width, height);
        const inset = Math.min(chamfer, Math.min(width, height) / 2);
        const right = x + width;
        const bottom = y + height;
        const points = [
            x + inset,
            y,
            right - inset,
            y,
            right,
            y + inset,
            right,
            bottom - inset,
            right - inset,
            bottom,
            x + inset,
            bottom,
            x,
            bottom - inset,
            x,
            y + inset
        ];
        for(let i = points.length - 1; i >= 2; i -= 2)if (points[i] === points[i - 2] && points[i - 1] === points[i - 3]) points.splice(i - 1, 2);
        return this.poly(points, true, transform);
    }
    /**
   * Draws an ellipse at the specified location and with the given x and y radii.
   * An optional transformation can be applied, allowing for rotation, scaling, and translation.
   * @param x - The x-coordinate of the center of the ellipse.
   * @param y - The y-coordinate of the center of the ellipse.
   * @param radiusX - The horizontal radius of the ellipse.
   * @param radiusY - The vertical radius of the ellipse.
   * @param transform - An optional `Matrix` object to apply a transformation to the ellipse. This can include rotations.
   * @returns The instance of the current object for chaining.
   */ ellipse(x, y, radiusX, radiusY, transform) {
        this.drawShape(new (0, $i4nao.Ellipse)(x, y, radiusX, radiusY), transform);
        return this;
    }
    /**
   * Draws a rectangle with rounded corners.
   * The corner radius can be specified to determine how rounded the corners should be.
   * An optional transformation can be applied, which allows for rotation, scaling, and translation of the rectangle.
   * @param x - The x-coordinate of the top-left corner of the rectangle.
   * @param y - The y-coordinate of the top-left corner of the rectangle.
   * @param w - The width of the rectangle.
   * @param h - The height of the rectangle.
   * @param radius - The radius of the rectangle's corners. If not specified, corners will be sharp.
   * @param transform - An optional `Matrix` object to apply a transformation to the rectangle.
   * @returns The instance of the current object for chaining.
   */ roundRect(x, y, w, h, radius, transform) {
        this.drawShape(new (0, $de145.RoundedRectangle)(x, y, w, h, radius), transform);
        return this;
    }
    /**
   * Draws a given shape on the canvas.
   * This is a generic method that can draw any type of shape specified by the `ShapePrimitive` parameter.
   * An optional transformation matrix can be applied to the shape, allowing for complex transformations.
   * @param shape - The shape to draw, defined as a `ShapePrimitive` object.
   * @param matrix - An optional `Matrix` for transforming the shape. This can include rotations,
   * scaling, and translations.
   * @returns The instance of the current object for chaining.
   */ drawShape(shape, matrix) {
        this.endPoly();
        this.shapePrimitives.push({
            shape: shape,
            transform: matrix
        });
        return this;
    }
    /**
   * Starts a new polygon path from the specified starting point.
   * This method initializes a new polygon or ends the current one if it exists.
   * @param x - The x-coordinate of the starting point of the new polygon.
   * @param y - The y-coordinate of the starting point of the new polygon.
   * @returns The instance of the current object for chaining.
   */ startPoly(x, y) {
        let currentPoly = this._currentPoly;
        if (currentPoly) this.endPoly();
        currentPoly = new (0, $neDb4.Polygon)();
        currentPoly.points.push(x, y);
        this._currentPoly = currentPoly;
        return this;
    }
    /**
   * Ends the current polygon path. If `closePath` is set to true,
   * the path is closed by connecting the last point to the first one.
   * This method finalizes the current polygon and prepares it for drawing or adding to the shape primitives.
   * @param closePath - A boolean indicating whether to close the polygon by connecting the last point
   *  back to the starting point. False by default.
   * @returns The instance of the current object for chaining.
   */ endPoly(closePath = false) {
        const shape = this._currentPoly;
        if (shape && shape.points.length > 2) {
            shape.closePath = closePath;
            this.shapePrimitives.push({
                shape: shape
            });
        }
        this._currentPoly = null;
        return this;
    }
    _ensurePoly(start = true) {
        if (this._currentPoly) return;
        this._currentPoly = new (0, $neDb4.Polygon)();
        if (start) {
            const lastShape = this.shapePrimitives[this.shapePrimitives.length - 1];
            if (lastShape) {
                let lx = lastShape.shape.x;
                let ly = lastShape.shape.y;
                if (lastShape.transform && !lastShape.transform.isIdentity()) {
                    const t = lastShape.transform;
                    const tempX = lx;
                    lx = t.a * lx + t.c * ly + t.tx;
                    ly = t.b * tempX + t.d * ly + t.ty;
                }
                this._currentPoly.points.push(lx, ly);
            } else this._currentPoly.points.push(0, 0);
        }
    }
    /** Builds the path. */ buildPath() {
        const path = this._graphicsPath2D;
        this.shapePrimitives.length = 0;
        this._currentPoly = null;
        for(let i = 0; i < path.instructions.length; i++){
            const instruction = path.instructions[i];
            this[instruction.action](...instruction.data);
        }
        this.finish();
    }
    /** Gets the bounds of the path. */ get bounds() {
        const bounds = this._bounds;
        bounds.clear();
        const shapePrimitives = this.shapePrimitives;
        for(let i = 0; i < shapePrimitives.length; i++){
            const shapePrimitive = shapePrimitives[i];
            const boundsRect = shapePrimitive.shape.getBounds($6dec99049edd01de$var$tempRectangle);
            if (shapePrimitive.transform) bounds.addRect(boundsRect, shapePrimitive.transform);
            else bounds.addRect(boundsRect);
        }
        return bounds;
    }
}

});
parcelRegister("4NUl1", function(module, exports) {

$parcel$export(module.exports, "Circle", () => $bf6ead08c7b5996c$export$c89a927ffc67e6fa);

var $kNl9L = parcelRequire("kNl9L");
"use strict";
class $bf6ead08c7b5996c$export$c89a927ffc67e6fa {
    /**
   * @param x - The X coordinate of the center of this circle
   * @param y - The Y coordinate of the center of this circle
   * @param radius - The radius of the circle
   */ constructor(x = 0, y = 0, radius = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks.
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Circle(0, 0, 50);
     * console.log(shape.type); // 'circle'
     *
     * // Use in type guards
     * if (shape.type === 'circle') {
     *     console.log(shape.radius);
     * }
     * ```
     * @remarks
     * - Used for shape type checking
     * - More efficient than instanceof
     * - Read-only property
     * @readonly
     * @default 'circle'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     * @see {@link ShapePrimitive} For shape interface
     */ this.type = "circle";
        this.x = x;
        this.y = y;
        this.radius = radius;
    }
    /**
   * Creates a clone of this Circle instance.
   * @example
   * ```ts
   * // Basic circle cloning
   * const original = new Circle(100, 100, 50);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 75;
   *
   * // Verify independence
   * console.log(original.radius); // 50
   * console.log(modified.radius); // 75
   * ```
   * @returns A copy of the Circle
   * @see {@link Circle.copyFrom} For copying into existing circle
   * @see {@link Circle.copyTo} For copying to another circle
   */ clone() {
        return new $bf6ead08c7b5996c$export$c89a927ffc67e6fa(this.x, this.y, this.radius);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle.
   *
   * Uses the distance formula to determine if a point is inside the circle's radius.
   *
   * Commonly used for hit testing in PixiJS events and graphics.
   * @example
   * ```ts
   * // Basic containment check
   * const circle = new Circle(100, 100, 50);
   * const isInside = circle.contains(120, 120);
   *
   * // Check mouse position
   * const circle = new Circle(0, 0, 100);
   * container.hitArea = circle;
   * container.on('pointermove', (e) => {
   *     // only called if pointer is within circle
   * });
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Circle
   * @see {@link Circle.strokeContains} For checking stroke intersection
   * @see {@link Circle.getBounds} For getting bounding box
   */ contains(x, y) {
        if (this.radius <= 0) return false;
        const r2 = this.radius * this.radius;
        let dx = this.x - x;
        let dy = this.y - y;
        dx *= dx;
        dy *= dy;
        return dx + dy <= r2;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this circle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const circle = new Circle(100, 100, 50);
   * const isOnStroke = circle.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = circle.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = circle.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = circle.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param width - The width of the line to check
   * @param alignment - The alignment of the stroke, 0.5 by default
   * @returns Whether the x/y coordinates are within this Circle's stroke
   * @see {@link Circle.contains} For checking fill containment
   * @see {@link Circle.getBounds} For getting stroke bounds
   */ strokeContains(x, y, width, alignment = 0.5) {
        if (this.radius === 0) return false;
        const dx = this.x - x;
        const dy = this.y - y;
        const radius = this.radius;
        const outerWidth = (1 - alignment) * width;
        const distance = Math.sqrt(dx * dx + dy * dy);
        return distance <= radius + outerWidth && distance > radius - (width - outerWidth);
    }
    /**
   * Returns the framing rectangle of the circle as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const circle = new Circle(100, 100, 50);
   * const bounds = circle.getBounds();
   * // bounds: x=50, y=50, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * circle.getBounds(rect);
   * ```
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Circle.contains} For point containment
   */ getBounds(out) {
        out || (out = new (0, $kNl9L.Rectangle)());
        out.x = this.x - this.radius;
        out.y = this.y - this.radius;
        out.width = this.radius * 2;
        out.height = this.radius * 2;
        return out;
    }
    /**
   * Copies another circle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * target.copyFrom(source);
   * ```
   * @param circle - The circle to copy from
   * @returns Returns itself
   * @see {@link Circle.copyTo} For copying to another circle
   * @see {@link Circle.clone} For creating new circle copy
   */ copyFrom(circle) {
        this.x = circle.x;
        this.y = circle.y;
        this.radius = circle.radius;
        return this;
    }
    /**
   * Copies this circle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Circle(100, 100, 50);
   * const target = new Circle();
   * source.copyTo(target);
   * ```
   * @param circle - The circle to copy to
   * @returns Returns given parameter
   * @see {@link Circle.copyFrom} For copying from another circle
   * @see {@link Circle.clone} For creating new circle copy
   */ copyTo(circle) {
        circle.copyFrom(this);
        return circle;
    }
    toString() {
        return `[pixi.js/math:Circle x=${this.x} y=${this.y} radius=${this.radius}]`;
    }
}

});

parcelRegister("i4nao", function(module, exports) {

$parcel$export(module.exports, "Ellipse", () => $11b317b184f19d4b$export$80b0269ab108fa11);

var $kNl9L = parcelRequire("kNl9L");
"use strict";
class $11b317b184f19d4b$export$80b0269ab108fa11 {
    /**
   * @param x - The X coordinate of the center of this ellipse
   * @param y - The Y coordinate of the center of this ellipse
   * @param halfWidth - The half width of this ellipse
   * @param halfHeight - The half height of this ellipse
   */ constructor(x = 0, y = 0, halfWidth = 0, halfHeight = 0){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Ellipse(0, 0, 50, 25);
     * console.log(shape.type); // 'ellipse'
     *
     * // Use in type guards
     * if (shape.type === 'ellipse') {
     *     console.log(shape.halfWidth, shape.halfHeight);
     * }
     * ```
     * @readonly
     * @default 'ellipse'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "ellipse";
        this.x = x;
        this.y = y;
        this.halfWidth = halfWidth;
        this.halfHeight = halfHeight;
    }
    /**
   * Creates a clone of this Ellipse instance.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Ellipse(100, 100, 50, 25);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.halfWidth *= 2;
   * modified.halfHeight *= 2;
   *
   * // Verify independence
   * console.log(original.halfWidth);  // 50
   * console.log(modified.halfWidth);  // 100
   * ```
   * @returns A copy of the ellipse
   * @see {@link Ellipse.copyFrom} For copying into existing ellipse
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   */ clone() {
        return new $11b317b184f19d4b$export$80b0269ab108fa11(this.x, this.y, this.halfWidth, this.halfHeight);
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse.
   * Uses normalized coordinates and the ellipse equation to determine containment.
   * @example
   * ```ts
   * // Basic containment check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isInside = ellipse.contains(120, 110);
   * ```
   * @remarks
   * - Uses ellipse equation (x²/a² + y²/b² ≤ 1)
   * - Returns false if dimensions are 0 or negative
   * - Normalized to center (0,0) for calculation
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coords are within this ellipse
   * @see {@link Ellipse.strokeContains} For checking stroke intersection
   * @see {@link Ellipse.getBounds} For getting containing rectangle
   */ contains(x, y) {
        if (this.halfWidth <= 0 || this.halfHeight <= 0) return false;
        let normx = (x - this.x) / this.halfWidth;
        let normy = (y - this.y) / this.halfHeight;
        normx *= normx;
        normy *= normy;
        return normx + normy <= 1;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this ellipse including stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const isOnStroke = ellipse.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = ellipse.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = ellipse.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = ellipse.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @remarks
   * - Uses normalized ellipse equations
   * - Considers stroke alignment
   * - Returns false if dimensions are 0
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coords are within this ellipse's stroke
   * @see {@link Ellipse.contains} For checking fill containment
   * @see {@link Ellipse.getBounds} For getting stroke bounds
   */ strokeContains(x, y, strokeWidth, alignment = 0.5) {
        const { halfWidth: halfWidth, halfHeight: halfHeight } = this;
        if (halfWidth <= 0 || halfHeight <= 0) return false;
        const strokeOuterWidth = strokeWidth * (1 - alignment);
        const strokeInnerWidth = strokeWidth - strokeOuterWidth;
        const innerHorizontal = halfWidth - strokeInnerWidth;
        const innerVertical = halfHeight - strokeInnerWidth;
        const outerHorizontal = halfWidth + strokeOuterWidth;
        const outerVertical = halfHeight + strokeOuterWidth;
        const normalizedX = x - this.x;
        const normalizedY = y - this.y;
        const innerEllipse = normalizedX * normalizedX / (innerHorizontal * innerHorizontal) + normalizedY * normalizedY / (innerVertical * innerVertical);
        const outerEllipse = normalizedX * normalizedX / (outerHorizontal * outerHorizontal) + normalizedY * normalizedY / (outerVertical * outerVertical);
        return innerEllipse > 1 && outerEllipse <= 1;
    }
    /**
   * Returns the framing rectangle of the ellipse as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const ellipse = new Ellipse(100, 100, 50, 25);
   * const bounds = ellipse.getBounds();
   * // bounds: x=50, y=75, width=100, height=50
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * ellipse.getBounds(rect);
   * ```
   * @remarks
   * - Creates Rectangle if none provided
   * - Top-left is (x-halfWidth, y-halfHeight)
   * - Width is halfWidth * 2
   * - Height is halfHeight * 2
   * @param out - Optional Rectangle object to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Ellipse.contains} For checking if a point is inside
   */ getBounds(out) {
        out || (out = new (0, $kNl9L.Rectangle)());
        out.x = this.x - this.halfWidth;
        out.y = this.y - this.halfHeight;
        out.width = this.halfWidth * 2;
        out.height = this.halfHeight * 2;
        return out;
    }
    /**
   * Copies another ellipse to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * target.copyFrom(source);
   * ```
   * @param ellipse - The ellipse to copy from
   * @returns Returns itself
   * @see {@link Ellipse.copyTo} For copying to another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */ copyFrom(ellipse) {
        this.x = ellipse.x;
        this.y = ellipse.y;
        this.halfWidth = ellipse.halfWidth;
        this.halfHeight = ellipse.halfHeight;
        return this;
    }
    /**
   * Copies this ellipse to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Ellipse(100, 100, 50, 25);
   * const target = new Ellipse();
   * source.copyTo(target);
   * ```
   * @param ellipse - The ellipse to copy to
   * @returns Returns given parameter
   * @see {@link Ellipse.copyFrom} For copying from another ellipse
   * @see {@link Ellipse.clone} For creating new ellipse copy
   */ copyTo(ellipse) {
        ellipse.copyFrom(this);
        return ellipse;
    }
    toString() {
        return `[pixi.js/math:Ellipse x=${this.x} y=${this.y} halfWidth=${this.halfWidth} halfHeight=${this.halfHeight}]`;
    }
}

});

parcelRegister("neDb4", function(module, exports) {

$parcel$export(module.exports, "Polygon", () => $af23565336165e32$export$7d31b617c820d435);

var $dXBy0 = parcelRequire("dXBy0");

var $5tu9L = parcelRequire("5tu9L");

var $kNl9L = parcelRequire("kNl9L");
"use strict";
let $af23565336165e32$var$tempRect;
let $af23565336165e32$var$tempRect2;
class $af23565336165e32$export$7d31b617c820d435 {
    /**
   * @param points - This can be an array of Points
   *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
   *  the arguments passed can be all the points of the polygon e.g.
   *  `new Polygon(new Point(), new Point(), ...)`, or the arguments passed can be flat
   *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
   */ constructor(...points){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new Polygon([0, 0, 100, 0, 50, 100]);
     * console.log(shape.type); // 'polygon'
     *
     * // Use in type guards
     * if (shape.type === 'polygon') {
     *     // TypeScript knows this is a Polygon
     *     console.log(shape.points.length);
     * }
     * ```
     * @readonly
     * @default 'polygon'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "polygon";
        let flat = Array.isArray(points[0]) ? points[0] : points;
        if (typeof flat[0] !== "number") {
            const p = [];
            for(let i = 0, il = flat.length; i < il; i++)p.push(flat[i].x, flat[i].y);
            flat = p;
        }
        this.points = flat;
        this.closePath = true;
    }
    /**
   * Determines whether the polygon's points are arranged in a clockwise direction.
   * Uses the shoelace formula (surveyor's formula) to calculate the signed area.
   *
   * A positive area indicates clockwise winding, while negative indicates counter-clockwise.
   *
   * The formula sums up the cross products of adjacent vertices:
   * For each pair of adjacent points (x1,y1) and (x2,y2), we calculate (x1*y2 - x2*y1)
   * The final sum divided by 2 gives the signed area - positive for clockwise.
   * @example
   * ```ts
   * // Check polygon winding
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * console.log(polygon.isClockwise()); // Check direction
   *
   * // Use in path construction
   * const hole = new Polygon([25, 25, 75, 25, 75, 75, 25, 75]);
   * if (hole.isClockwise() === shape.isClockwise()) {
   *     hole.points.reverse(); // Reverse for proper hole winding
   * }
   * ```
   * @returns `true` if the polygon's points are arranged clockwise, `false` if counter-clockwise
   */ isClockwise() {
        let area = 0;
        const points = this.points;
        const length = points.length;
        for(let i = 0; i < length; i += 2){
            const x1 = points[i];
            const y1 = points[i + 1];
            const x2 = points[(i + 2) % length];
            const y2 = points[(i + 3) % length];
            area += (x2 - x1) * (y2 + y1);
        }
        return area < 0;
    }
    /**
   * Checks if this polygon completely contains another polygon.
   * Used for detecting holes in shapes, like when parsing SVG paths.
   * @example
   * ```ts
   * // Basic containment check
   * const outerSquare = new Polygon([0,0, 100,0, 100,100, 0,100]); // A square
   * const innerSquare = new Polygon([25,25, 75,25, 75,75, 25,75]); // A smaller square inside
   *
   * outerSquare.containsPolygon(innerSquare); // Returns true
   * innerSquare.containsPolygon(outerSquare); // Returns false
   * ```
   * @remarks
   * - Uses bounds check for quick rejection
   * - Tests all points for containment
   * @param polygon - The polygon to test for containment
   * @returns True if this polygon completely contains the other polygon
   * @see {@link Polygon.contains} For single point testing
   * @see {@link Polygon.getBounds} For bounds calculation
   */ containsPolygon(polygon) {
        const thisBounds = this.getBounds($af23565336165e32$var$tempRect);
        const otherBounds = polygon.getBounds($af23565336165e32$var$tempRect2);
        if (!thisBounds.containsRect(otherBounds)) return false;
        const points = polygon.points;
        for(let i = 0; i < points.length; i += 2){
            const x = points[i];
            const y = points[i + 1];
            if (!this.contains(x, y)) return false;
        }
        return true;
    }
    /**
   * Creates a clone of this polygon.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new Polygon([0, 0, 100, 0, 50, 100]);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.points[0] = 10; // Modify first x coordinate
   * ```
   * @returns A copy of the polygon
   * @see {@link Polygon.copyFrom} For copying into existing polygon
   * @see {@link Polygon.copyTo} For copying to another polygon
   */ clone() {
        const points = this.points.slice();
        const polygon = new $af23565336165e32$export$7d31b617c820d435(points);
        polygon.closePath = this.closePath;
        return polygon;
    }
    /**
   * Checks whether the x and y coordinates passed to this function are contained within this polygon.
   * Uses raycasting algorithm for point-in-polygon testing.
   * @example
   * ```ts
   * // Basic containment check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isInside = polygon.contains(25, 25); // true
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this polygon
   * @see {@link Polygon.strokeContains} For checking stroke intersection
   * @see {@link Polygon.containsPolygon} For polygon-in-polygon testing
   */ contains(x, y) {
        let inside = false;
        const length = this.points.length / 2;
        for(let i = 0, j = length - 1; i < length; j = i++){
            const xi = this.points[i * 2];
            const yi = this.points[i * 2 + 1];
            const xj = this.points[j * 2];
            const yj = this.points[j * 2 + 1];
            const intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;
            if (intersect) inside = !inside;
        }
        return inside;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this polygon including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const isOnStroke = polygon.strokeContains(25, 25, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = polygon.strokeContains(25, 25, 4, 1);   // Inside
   * const centerStroke = polygon.strokeContains(25, 25, 4, 0.5); // Centered
   * const outerStroke = polygon.strokeContains(25, 25, 4, 0);   // Outside
   * ```
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this polygon's stroke
   * @see {@link Polygon.contains} For checking fill containment
   * @see {@link Polygon.getBounds} For getting stroke bounds
   */ strokeContains(x, y, strokeWidth, alignment = 0.5) {
        const strokeWidthSquared = strokeWidth * strokeWidth;
        const rightWidthSquared = strokeWidthSquared * (1 - alignment);
        const leftWidthSquared = strokeWidthSquared - rightWidthSquared;
        const { points: points } = this;
        const iterationLength = points.length - (this.closePath ? 0 : 2);
        for(let i = 0; i < iterationLength; i += 2){
            const x1 = points[i];
            const y1 = points[i + 1];
            const x2 = points[(i + 2) % points.length];
            const y2 = points[(i + 3) % points.length];
            const distanceSquared = (0, $5tu9L.squaredDistanceToLineSegment)(x, y, x1, y1, x2, y2);
            const sign = Math.sign((x2 - x1) * (y - y1) - (y2 - y1) * (x - x1));
            if (distanceSquared <= (sign < 0 ? leftWidthSquared : rightWidthSquared)) return true;
        }
        return false;
    }
    /**
   * Returns the framing rectangle of the polygon as a Rectangle object.
   * @example
   * ```ts
   * // Basic bounds calculation
   * const polygon = new Polygon([0, 0, 100, 0, 50, 100]);
   * const bounds = polygon.getBounds();
   * // bounds: x=0, y=0, width=100, height=100
   *
   * // Reuse existing rectangle
   * const rect = new Rectangle();
   * polygon.getBounds(rect);
   * ```
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link Polygon.contains} For checking if a point is inside
   */ getBounds(out) {
        out || (out = new (0, $kNl9L.Rectangle)());
        const points = this.points;
        let minX = Infinity;
        let maxX = -Infinity;
        let minY = Infinity;
        let maxY = -Infinity;
        for(let i = 0, n = points.length; i < n; i += 2){
            const x = points[i];
            const y = points[i + 1];
            minX = x < minX ? x : minX;
            maxX = x > maxX ? x : maxX;
            minY = y < minY ? y : minY;
            maxY = y > maxY ? y : maxY;
        }
        out.x = minX;
        out.width = maxX - minX;
        out.y = minY;
        out.height = maxY - minY;
        return out;
    }
    /**
   * Copies another polygon to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * target.copyFrom(source);
   * ```
   * @param polygon - The polygon to copy from
   * @returns Returns itself
   * @see {@link Polygon.copyTo} For copying to another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */ copyFrom(polygon) {
        this.points = polygon.points.slice();
        this.closePath = polygon.closePath;
        return this;
    }
    /**
   * Copies this polygon to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new Polygon([0, 0, 100, 0, 50, 100]);
   * const target = new Polygon();
   * source.copyTo(target);
   * ```
   * @param polygon - The polygon to copy to
   * @returns Returns given parameter
   * @see {@link Polygon.copyFrom} For copying from another polygon
   * @see {@link Polygon.clone} For creating new polygon copy
   */ copyTo(polygon) {
        polygon.copyFrom(this);
        return polygon;
    }
    toString() {
        return `[pixi.js/math:PolygoncloseStroke=${this.closePath}points=${this.points.reduce((pointsDesc, currentPoint)=>`${pointsDesc}, ${currentPoint}`, "")}]`;
    }
    /**
   * Get the last X coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastX); // 300
   * ```
   * @readonly
   * @returns The x-coordinate of the last vertex
   * @see {@link Polygon.lastY} For last Y coordinate
   * @see {@link Polygon.points} For raw points array
   */ get lastX() {
        return this.points[this.points.length - 2];
    }
    /**
   * Get the last Y coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.lastY); // 400
   * ```
   * @readonly
   * @returns The y-coordinate of the last vertex
   * @see {@link Polygon.lastX} For last X coordinate
   * @see {@link Polygon.points} For raw points array
   */ get lastY() {
        return this.points[this.points.length - 1];
    }
    /**
   * Get the last X coordinate of the polygon.
   * @readonly
   * @deprecated since 8.11.0, use {@link Polygon.lastX} instead.
   */ get x() {
        (0, $dXBy0.deprecation)("8.11.0", "Polygon.lastX is deprecated, please use Polygon.lastX instead.");
        return this.points[this.points.length - 2];
    }
    /**
   * Get the last Y coordinate of the polygon.
   * @readonly
   * @deprecated since 8.11.0, use {@link Polygon.lastY} instead.
   */ get y() {
        (0, $dXBy0.deprecation)("8.11.0", "Polygon.y is deprecated, please use Polygon.lastY instead.");
        return this.points[this.points.length - 1];
    }
    /**
   * Get the first X coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.x); // 0
   * ```
   * @readonly
   * @returns The x-coordinate of the first vertex
   * @see {@link Polygon.startY} For first Y coordinate
   * @see {@link Polygon.points} For raw points array
   */ get startX() {
        return this.points[0];
    }
    /**
   * Get the first Y coordinate of the polygon.
   * @example
   * ```ts
   * // Basic coordinate access
   * const polygon = new Polygon([0, 0, 100, 200, 300, 400]);
   * console.log(polygon.y); // 0
   * ```
   * @readonly
   * @returns The y-coordinate of the first vertex
   * @see {@link Polygon.startX} For first X coordinate
   * @see {@link Polygon.points} For raw points array
   */ get startY() {
        return this.points[1];
    }
}

});
parcelRegister("5tu9L", function(module, exports) {

$parcel$export(module.exports, "squaredDistanceToLineSegment", () => $8643ad122d032420$export$db32ff20ff695a);
"use strict";
function $8643ad122d032420$export$db32ff20ff695a(x, y, x1, y1, x2, y2) {
    const a = x - x1;
    const b = y - y1;
    const c = x2 - x1;
    const d = y2 - y1;
    const dot = a * c + b * d;
    const lenSq = c * c + d * d;
    let param = -1;
    if (lenSq !== 0) param = dot / lenSq;
    let xx;
    let yy;
    if (param < 0) {
        xx = x1;
        yy = y1;
    } else if (param > 1) {
        xx = x2;
        yy = y2;
    } else {
        xx = x1 + param * c;
        yy = y1 + param * d;
    }
    const dx = x - xx;
    const dy = y - yy;
    return dx * dx + dy * dy;
}

});


parcelRegister("de145", function(module, exports) {

$parcel$export(module.exports, "RoundedRectangle", () => $6c06478d5625f8b6$export$d55ab2e3dc5a4263);

var $kNl9L = parcelRequire("kNl9L");
"use strict";
const $6c06478d5625f8b6$var$isCornerWithinStroke = (pX, pY, cornerX, cornerY, radius, strokeWidthInner, strokeWidthOuter)=>{
    const dx = pX - cornerX;
    const dy = pY - cornerY;
    const distance = Math.sqrt(dx * dx + dy * dy);
    return distance >= radius - strokeWidthInner && distance <= radius + strokeWidthOuter;
};
class $6c06478d5625f8b6$export$d55ab2e3dc5a4263 {
    /**
   * @param x - The X coordinate of the upper-left corner of the rounded rectangle
   * @param y - The Y coordinate of the upper-left corner of the rounded rectangle
   * @param width - The overall width of this rounded rectangle
   * @param height - The overall height of this rounded rectangle
   * @param radius - Controls the radius of the rounded corners
   */ constructor(x = 0, y = 0, width = 0, height = 0, radius = 20){
        /**
     * The type of the object, mainly used to avoid `instanceof` checks
     * @example
     * ```ts
     * // Check shape type
     * const shape = new RoundedRectangle(0, 0, 100, 100, 20);
     * console.log(shape.type); // 'roundedRectangle'
     *
     * // Use in type guards
     * if (shape.type === 'roundedRectangle') {
     *     console.log(shape.radius);
     * }
     * ```
     * @readonly
     * @default 'roundedRectangle'
     * @see {@link SHAPE_PRIMITIVE} For all shape types
     */ this.type = "roundedRectangle";
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.radius = radius;
    }
    /**
   * Returns the framing rectangle of the rounded rectangle as a Rectangle object
   * @example
   * ```ts
   * // Basic bounds calculation
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const bounds = rect.getBounds();
   * // bounds: x=100, y=100, width=200, height=150
   *
   * // Reuse existing rectangle
   * const out = new Rectangle();
   * rect.getBounds(out);
   * ```
   * @remarks
   * - Rectangle matches outer dimensions
   * - Ignores corner radius
   * @param out - Optional rectangle to store the result
   * @returns The framing rectangle
   * @see {@link Rectangle} For rectangle properties
   * @see {@link RoundedRectangle.contains} For checking if a point is inside
   */ getBounds(out) {
        out || (out = new (0, $kNl9L.Rectangle)());
        out.x = this.x;
        out.y = this.y;
        out.width = this.width;
        out.height = this.height;
        return out;
    }
    /**
   * Creates a clone of this Rounded Rectangle.
   * @example
   * ```ts
   * // Basic cloning
   * const original = new RoundedRectangle(100, 100, 200, 150, 20);
   * const copy = original.clone();
   *
   * // Clone and modify
   * const modified = original.clone();
   * modified.radius = 30;
   * modified.width *= 2;
   *
   * // Verify independence
   * console.log(original.radius);  // 20
   * console.log(modified.radius);  // 30
   * ```
   * @returns A copy of the rounded rectangle
   * @see {@link RoundedRectangle.copyFrom} For copying into existing rectangle
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   */ clone() {
        return new $6c06478d5625f8b6$export$d55ab2e3dc5a4263(this.x, this.y, this.width, this.height, this.radius);
    }
    /**
   * Copies another rectangle to this one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * target.copyFrom(source);
   *
   * // Chain with other operations
   * const rect = new RoundedRectangle()
   *     .copyFrom(source)
   *     .getBounds(rect);
   * ```
   * @param rectangle - The rectangle to copy from
   * @returns Returns itself
   * @see {@link RoundedRectangle.copyTo} For copying to another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */ copyFrom(rectangle) {
        this.x = rectangle.x;
        this.y = rectangle.y;
        this.width = rectangle.width;
        this.height = rectangle.height;
        return this;
    }
    /**
   * Copies this rectangle to another one.
   * @example
   * ```ts
   * // Basic copying
   * const source = new RoundedRectangle(100, 100, 200, 150, 20);
   * const target = new RoundedRectangle();
   * source.copyTo(target);
   *
   * // Chain with other operations
   * const result = source
   *     .copyTo(new RoundedRectangle())
   *     .getBounds();
   * ```
   * @param rectangle - The rectangle to copy to
   * @returns Returns given parameter
   * @see {@link RoundedRectangle.copyFrom} For copying from another rectangle
   * @see {@link RoundedRectangle.clone} For creating new rectangle copy
   */ copyTo(rectangle) {
        rectangle.copyFrom(this);
        return rectangle;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
   * @example
   * ```ts
   * // Basic containment check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isInside = rect.contains(150, 125); // true
   * // Check corner radius
   * const corner = rect.contains(100, 100); // false if within corner curve
   * ```
   * @remarks
   * - Returns false if width/height is 0 or negative
   * - Handles rounded corners with radius check
   * @param x - The X coordinate of the point to test
   * @param y - The Y coordinate of the point to test
   * @returns Whether the x/y coordinates are within this Rounded Rectangle
   * @see {@link RoundedRectangle.strokeContains} For checking stroke intersection
   * @see {@link RoundedRectangle.getBounds} For getting containing rectangle
   */ contains(x, y) {
        if (this.width <= 0 || this.height <= 0) return false;
        if (x >= this.x && x <= this.x + this.width) {
            if (y >= this.y && y <= this.y + this.height) {
                const radius = Math.max(0, Math.min(this.radius, Math.min(this.width, this.height) / 2));
                if (y >= this.y + radius && y <= this.y + this.height - radius || x >= this.x + radius && x <= this.x + this.width - radius) return true;
                let dx = x - (this.x + radius);
                let dy = y - (this.y + radius);
                const radius2 = radius * radius;
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + this.width - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dy = y - (this.y + this.height - radius);
                if (dx * dx + dy * dy <= radius2) return true;
                dx = x - (this.x + radius);
                if (dx * dx + dy * dy <= radius2) return true;
            }
        }
        return false;
    }
    /**
   * Checks whether the x and y coordinates given are contained within this rectangle including the stroke.
   * @example
   * ```ts
   * // Basic stroke check
   * const rect = new RoundedRectangle(100, 100, 200, 150, 20);
   * const isOnStroke = rect.strokeContains(150, 100, 4); // 4px line width
   *
   * // Check with different alignments
   * const innerStroke = rect.strokeContains(150, 100, 4, 1);   // Inside
   * const centerStroke = rect.strokeContains(150, 100, 4, 0.5); // Centered
   * const outerStroke = rect.strokeContains(150, 100, 4, 0);   // Outside
   * ```
   * @param pX - The X coordinate of the point to test
   * @param pY - The Y coordinate of the point to test
   * @param strokeWidth - The width of the line to check
   * @param alignment - The alignment of the stroke (1 = inner, 0.5 = centered, 0 = outer)
   * @returns Whether the x/y coordinates are within this rectangle's stroke
   * @see {@link RoundedRectangle.contains} For checking fill containment
   * @see {@link RoundedRectangle.getBounds} For getting stroke bounds
   */ strokeContains(pX, pY, strokeWidth, alignment = 0.5) {
        const { x: x, y: y, width: width, height: height, radius: radius } = this;
        const strokeWidthOuter = strokeWidth * (1 - alignment);
        const strokeWidthInner = strokeWidth - strokeWidthOuter;
        const innerX = x + radius;
        const innerY = y + radius;
        const innerWidth = width - radius * 2;
        const innerHeight = height - radius * 2;
        const rightBound = x + width;
        const bottomBound = y + height;
        if ((pX >= x - strokeWidthOuter && pX <= x + strokeWidthInner || pX >= rightBound - strokeWidthInner && pX <= rightBound + strokeWidthOuter) && pY >= innerY && pY <= innerY + innerHeight) return true;
        if ((pY >= y - strokeWidthOuter && pY <= y + strokeWidthInner || pY >= bottomBound - strokeWidthInner && pY <= bottomBound + strokeWidthOuter) && pX >= innerX && pX <= innerX + innerWidth) return true;
        return(// Top-left
        pX < innerX && pY < innerY && $6c06478d5625f8b6$var$isCornerWithinStroke(pX, pY, innerX, innerY, radius, strokeWidthInner, strokeWidthOuter) || pX > rightBound - radius && pY < innerY && $6c06478d5625f8b6$var$isCornerWithinStroke(pX, pY, rightBound - radius, innerY, radius, strokeWidthInner, strokeWidthOuter) || pX > rightBound - radius && pY > bottomBound - radius && $6c06478d5625f8b6$var$isCornerWithinStroke(pX, pY, rightBound - radius, bottomBound - radius, radius, strokeWidthInner, strokeWidthOuter) || pX < innerX && pY > bottomBound - radius && $6c06478d5625f8b6$var$isCornerWithinStroke(pX, pY, innerX, bottomBound - radius, radius, strokeWidthInner, strokeWidthOuter));
    }
    toString() {
        return `[pixi.js/math:RoundedRectangle x=${this.x} y=${this.y}width=${this.width} height=${this.height} radius=${this.radius}]`;
    }
}

});

parcelRegister("5gw8E", function(module, exports) {

$parcel$export(module.exports, "buildAdaptiveBezier", () => $ab7812fde5de0309$export$7dab5eac414ecba2);

var $eqSWH = parcelRequire("eqSWH");
"use strict";
const $ab7812fde5de0309$var$RECURSION_LIMIT = 8;
const $ab7812fde5de0309$var$FLT_EPSILON = 11920929e-14;
const $ab7812fde5de0309$var$PATH_DISTANCE_EPSILON = 1;
const $ab7812fde5de0309$var$curveAngleToleranceEpsilon = 0.01;
const $ab7812fde5de0309$var$mAngleTolerance = 0;
const $ab7812fde5de0309$var$mCuspLimit = 0;
function $ab7812fde5de0309$export$7dab5eac414ecba2(points, sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, smoothness) {
    const scale = 1;
    const smoothing = Math.min(0.99, // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? (0, $eqSWH.GraphicsContextSystem).defaultOptions.bezierSmoothness));
    let distanceTolerance = ($ab7812fde5de0309$var$PATH_DISTANCE_EPSILON - smoothing) / scale;
    distanceTolerance *= distanceTolerance;
    $ab7812fde5de0309$var$begin(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance);
    return points;
}
function $ab7812fde5de0309$var$begin(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance) {
    $ab7812fde5de0309$var$recursive(sX, sY, cp1x, cp1y, cp2x, cp2y, eX, eY, points, distanceTolerance, 0);
    points.push(eX, eY);
}
function $ab7812fde5de0309$var$recursive(x1, y1, x2, y2, x3, y3, x4, y4, points, distanceTolerance, level) {
    if (level > $ab7812fde5de0309$var$RECURSION_LIMIT) return;
    const pi = Math.PI;
    const x12 = (x1 + x2) / 2;
    const y12 = (y1 + y2) / 2;
    const x23 = (x2 + x3) / 2;
    const y23 = (y2 + y3) / 2;
    const x34 = (x3 + x4) / 2;
    const y34 = (y3 + y4) / 2;
    const x123 = (x12 + x23) / 2;
    const y123 = (y12 + y23) / 2;
    const x234 = (x23 + x34) / 2;
    const y234 = (y23 + y34) / 2;
    const x1234 = (x123 + x234) / 2;
    const y1234 = (y123 + y234) / 2;
    if (level > 0) {
        let dx = x4 - x1;
        let dy = y4 - y1;
        const d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx);
        const d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx);
        let da1;
        let da2;
        if (d2 > $ab7812fde5de0309$var$FLT_EPSILON && d3 > $ab7812fde5de0309$var$FLT_EPSILON) {
            if ((d2 + d3) * (d2 + d3) <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($ab7812fde5de0309$var$mAngleTolerance < $ab7812fde5de0309$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                const a23 = Math.atan2(y3 - y2, x3 - x2);
                da1 = Math.abs(a23 - Math.atan2(y2 - y1, x2 - x1));
                da2 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - a23);
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da2 >= pi) da2 = 2 * pi - da2;
                if (da1 + da2 < $ab7812fde5de0309$var$mAngleTolerance) {
                    points.push(x1234, y1234);
                    return;
                }
                if ($ab7812fde5de0309$var$mCuspLimit !== 0) {
                    if (da1 > $ab7812fde5de0309$var$mCuspLimit) {
                        points.push(x2, y2);
                        return;
                    }
                    if (da2 > $ab7812fde5de0309$var$mCuspLimit) {
                        points.push(x3, y3);
                        return;
                    }
                }
            }
        } else if (d2 > $ab7812fde5de0309$var$FLT_EPSILON) {
            if (d2 * d2 <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($ab7812fde5de0309$var$mAngleTolerance < $ab7812fde5de0309$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                da1 = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da1 < $ab7812fde5de0309$var$mAngleTolerance) {
                    points.push(x2, y2);
                    points.push(x3, y3);
                    return;
                }
                if ($ab7812fde5de0309$var$mCuspLimit !== 0) {
                    if (da1 > $ab7812fde5de0309$var$mCuspLimit) {
                        points.push(x2, y2);
                        return;
                    }
                }
            }
        } else if (d3 > $ab7812fde5de0309$var$FLT_EPSILON) {
            if (d3 * d3 <= distanceTolerance * (dx * dx + dy * dy)) {
                if ($ab7812fde5de0309$var$mAngleTolerance < $ab7812fde5de0309$var$curveAngleToleranceEpsilon) {
                    points.push(x1234, y1234);
                    return;
                }
                da1 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - Math.atan2(y3 - y2, x3 - x2));
                if (da1 >= pi) da1 = 2 * pi - da1;
                if (da1 < $ab7812fde5de0309$var$mAngleTolerance) {
                    points.push(x2, y2);
                    points.push(x3, y3);
                    return;
                }
                if ($ab7812fde5de0309$var$mCuspLimit !== 0) {
                    if (da1 > $ab7812fde5de0309$var$mCuspLimit) {
                        points.push(x3, y3);
                        return;
                    }
                }
            }
        } else {
            dx = x1234 - (x1 + x4) / 2;
            dy = y1234 - (y1 + y4) / 2;
            if (dx * dx + dy * dy <= distanceTolerance) {
                points.push(x1234, y1234);
                return;
            }
        }
    }
    $ab7812fde5de0309$var$recursive(x1, y1, x12, y12, x123, y123, x1234, y1234, points, distanceTolerance, level + 1);
    $ab7812fde5de0309$var$recursive(x1234, y1234, x234, y234, x34, y34, x4, y4, points, distanceTolerance, level + 1);
}

});
parcelRegister("eqSWH", function(module, exports) {

$parcel$export(module.exports, "GraphicsContextSystem", () => $4036e088988ab682$export$f2f3ca33e4c65172);

var $aBhlC = parcelRequire("aBhlC");

var $fDVAe = parcelRequire("fDVAe");

var $7JTYx = parcelRequire("7JTYx");

var $eGbEm = parcelRequire("eGbEm");

var $96EPk = parcelRequire("96EPk");

var $dXBy0 = parcelRequire("dXBy0");

var $2xwDK = parcelRequire("2xwDK");

var $joLVF = parcelRequire("joLVF");
"use strict";
class $4036e088988ab682$export$e3e348c254036d55 {
    constructor(){
        this.batches = [];
        this.geometryData = {
            vertices: [],
            uvs: [],
            indices: []
        };
    }
    reset() {
        if (this.batches) this.batches.forEach((batch)=>{
            (0, $2xwDK.BigPool).return(batch);
        });
        if (this.graphicsData) (0, $2xwDK.BigPool).return(this.graphicsData);
        this.isBatchable = false;
        this.context = null;
        this.batches.length = 0;
        this.geometryData.indices.length = 0;
        this.geometryData.vertices.length = 0;
        this.geometryData.uvs.length = 0;
        this.graphicsData = null;
    }
    destroy() {
        this.reset();
        this.batches = null;
        this.geometryData = null;
    }
}
class $4036e088988ab682$export$9b6a6c5b37fc8f49 {
    constructor(){
        this.instructions = new (0, $eGbEm.InstructionSet)();
    }
    init(options) {
        const maxTextures = options.maxTextures;
        this.batcher ? this.batcher._updateMaxTextures(maxTextures) : this.batcher = new (0, $7JTYx.DefaultBatcher)({
            maxTextures: maxTextures
        });
        this.instructions.reset();
    }
    /**
   * @deprecated since version 8.0.0
   * Use `batcher.geometry` instead.
   * @see {Batcher#geometry}
   */ get geometry() {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_3_4), "GraphicsContextRenderData#geometry is deprecated, please use batcher.geometry instead.");
        return this.batcher.geometry;
    }
    destroy() {
        this.batcher.destroy();
        this.instructions.destroy();
        this.batcher = null;
        this.instructions = null;
    }
}
const $4036e088988ab682$var$_GraphicsContextSystem = class _GraphicsContextSystem {
    constructor(renderer){
        this._renderer = renderer;
        this._managedContexts = new (0, $96EPk.GCManagedHash)({
            renderer: renderer,
            type: "resource",
            name: "graphicsContext"
        });
    }
    /**
   * Runner init called, update the default options
   * @ignore
   */ init(options) {
        _GraphicsContextSystem.defaultOptions.bezierSmoothness = options?.bezierSmoothness ?? _GraphicsContextSystem.defaultOptions.bezierSmoothness;
    }
    /**
   * Returns the render data for a given GraphicsContext.
   * @param context - The GraphicsContext to get the render data for.
   * @internal
   */ getContextRenderData(context) {
        return context._gpuData[this._renderer.uid].graphicsData || this._initContextRenderData(context);
    }
    /**
   * Updates the GPU context for a given GraphicsContext.
   * If the context is dirty, it will rebuild the batches and geometry data.
   * @param context - The GraphicsContext to update.
   * @returns The updated GpuGraphicsContext.
   * @internal
   */ updateGpuContext(context) {
        const hasContext = !!context._gpuData[this._renderer.uid];
        const gpuContext = context._gpuData[this._renderer.uid] || this._initContext(context);
        if (context.dirty || !hasContext) {
            if (hasContext) gpuContext.reset();
            (0, $joLVF.buildContextBatches)(context, gpuContext);
            const batchMode = context.batchMode;
            if (context.customShader || batchMode === "no-batch") gpuContext.isBatchable = false;
            else if (batchMode === "auto") gpuContext.isBatchable = gpuContext.geometryData.vertices.length < 400;
            else gpuContext.isBatchable = true;
            context.dirty = false;
        }
        return gpuContext;
    }
    /**
   * Returns the GpuGraphicsContext for a given GraphicsContext.
   * If it does not exist, it will initialize a new one.
   * @param context - The GraphicsContext to get the GpuGraphicsContext for.
   * @returns The GpuGraphicsContext for the given GraphicsContext.
   * @internal
   */ getGpuContext(context) {
        return context._gpuData[this._renderer.uid] || this._initContext(context);
    }
    _initContextRenderData(context) {
        const graphicsData = (0, $2xwDK.BigPool).get($4036e088988ab682$export$9b6a6c5b37fc8f49, {
            maxTextures: this._renderer.limits.maxBatchableTextures
        });
        const gpuContext = context._gpuData[this._renderer.uid];
        const { batches: batches, geometryData: geometryData } = gpuContext;
        gpuContext.graphicsData = graphicsData;
        const vertexSize = geometryData.vertices.length;
        const indexSize = geometryData.indices.length;
        for(let i = 0; i < batches.length; i++)batches[i].applyTransform = false;
        const batcher = graphicsData.batcher;
        batcher.ensureAttributeBuffer(vertexSize);
        batcher.ensureIndexBuffer(indexSize);
        batcher.begin();
        for(let i = 0; i < batches.length; i++){
            const batch = batches[i];
            batcher.add(batch);
        }
        batcher.finish(graphicsData.instructions);
        const geometry = batcher.geometry;
        geometry.indexBuffer.setDataWithSize(batcher.indexBuffer, batcher.indexSize, true);
        geometry.buffers[0].setDataWithSize(batcher.attributeBuffer.float32View, batcher.attributeSize, true);
        const drawBatches = batcher.batches;
        for(let i = 0; i < drawBatches.length; i++){
            const batch = drawBatches[i];
            batch.bindGroup = (0, $fDVAe.getTextureBatchBindGroup)(batch.textures.textures, batch.textures.count, this._renderer.limits.maxBatchableTextures);
        }
        return graphicsData;
    }
    _initContext(context) {
        const gpuContext = new $4036e088988ab682$export$e3e348c254036d55();
        gpuContext.context = context;
        context._gpuData[this._renderer.uid] = gpuContext;
        this._managedContexts.add(context);
        return gpuContext;
    }
    destroy() {
        this._managedContexts.destroy();
        this._renderer = null;
    }
};
/** @ignore */ $4036e088988ab682$var$_GraphicsContextSystem.extension = {
    type: [
        (0, $aBhlC.ExtensionType).WebGLSystem,
        (0, $aBhlC.ExtensionType).WebGPUSystem
    ],
    name: "graphicsContext"
};
/** The default options for the GraphicsContextSystem. */ $4036e088988ab682$var$_GraphicsContextSystem.defaultOptions = {
    /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */ bezierSmoothness: 0.5
};
let $4036e088988ab682$export$f2f3ca33e4c65172 = $4036e088988ab682$var$_GraphicsContextSystem;

});


parcelRegister("3dWKd", function(module, exports) {

$parcel$export(module.exports, "buildAdaptiveQuadratic", () => $ab4161dc32619db2$export$d53ce9debfe7a6c2);

var $eqSWH = parcelRequire("eqSWH");
"use strict";
const $ab4161dc32619db2$var$RECURSION_LIMIT = 8;
const $ab4161dc32619db2$var$FLT_EPSILON = 11920929e-14;
const $ab4161dc32619db2$var$PATH_DISTANCE_EPSILON = 1;
const $ab4161dc32619db2$var$curveAngleToleranceEpsilon = 0.01;
const $ab4161dc32619db2$var$mAngleTolerance = 0;
function $ab4161dc32619db2$export$d53ce9debfe7a6c2(points, sX, sY, cp1x, cp1y, eX, eY, smoothness) {
    const scale = 1;
    const smoothing = Math.min(0.99, // a value of 1.0 actually inverts smoothing, so we cap it at 0.99
    Math.max(0, smoothness ?? (0, $eqSWH.GraphicsContextSystem).defaultOptions.bezierSmoothness));
    let distanceTolerance = ($ab4161dc32619db2$var$PATH_DISTANCE_EPSILON - smoothing) / scale;
    distanceTolerance *= distanceTolerance;
    $ab4161dc32619db2$var$begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance);
    return points;
}
function $ab4161dc32619db2$var$begin(sX, sY, cp1x, cp1y, eX, eY, points, distanceTolerance) {
    $ab4161dc32619db2$var$recursive(points, sX, sY, cp1x, cp1y, eX, eY, distanceTolerance, 0);
    points.push(eX, eY);
}
function $ab4161dc32619db2$var$recursive(points, x1, y1, x2, y2, x3, y3, distanceTolerance, level) {
    if (level > $ab4161dc32619db2$var$RECURSION_LIMIT) return;
    const pi = Math.PI;
    const x12 = (x1 + x2) / 2;
    const y12 = (y1 + y2) / 2;
    const x23 = (x2 + x3) / 2;
    const y23 = (y2 + y3) / 2;
    const x123 = (x12 + x23) / 2;
    const y123 = (y12 + y23) / 2;
    let dx = x3 - x1;
    let dy = y3 - y1;
    const d = Math.abs((x2 - x3) * dy - (y2 - y3) * dx);
    if (d > $ab4161dc32619db2$var$FLT_EPSILON) {
        if (d * d <= distanceTolerance * (dx * dx + dy * dy)) {
            if ($ab4161dc32619db2$var$mAngleTolerance < $ab4161dc32619db2$var$curveAngleToleranceEpsilon) {
                points.push(x123, y123);
                return;
            }
            let da = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
            if (da >= pi) da = 2 * pi - da;
            if (da < $ab4161dc32619db2$var$mAngleTolerance) {
                points.push(x123, y123);
                return;
            }
        }
    } else {
        dx = x123 - (x1 + x3) / 2;
        dy = y123 - (y1 + y3) / 2;
        if (dx * dx + dy * dy <= distanceTolerance) {
            points.push(x123, y123);
            return;
        }
    }
    $ab4161dc32619db2$var$recursive(points, x1, y1, x12, y12, x123, y123, distanceTolerance, level + 1);
    $ab4161dc32619db2$var$recursive(points, x123, y123, x23, y23, x3, y3, distanceTolerance, level + 1);
}

});

parcelRegister("4nDbL", function(module, exports) {

$parcel$export(module.exports, "buildArc", () => $761ac56aa74603ab$export$ed8eebdc6998f0f6);
"use strict";
function $761ac56aa74603ab$export$ed8eebdc6998f0f6(points, x, y, radius, start, end, clockwise, steps) {
    let dist = Math.abs(start - end);
    if (!clockwise && start > end) dist = 2 * Math.PI - dist;
    else if (clockwise && end > start) dist = 2 * Math.PI - dist;
    steps || (steps = Math.max(6, Math.floor(6 * Math.pow(radius, 1 / 3) * (dist / Math.PI))));
    steps = Math.max(steps, 3);
    let f = dist / steps;
    let t = start;
    f *= clockwise ? -1 : 1;
    for(let i = 0; i < steps + 1; i++){
        const cs = Math.cos(t);
        const sn = Math.sin(t);
        const nx = x + cs * radius;
        const ny = y + sn * radius;
        points.push(nx, ny);
        t += f;
    }
}

});

parcelRegister("53ruL", function(module, exports) {

$parcel$export(module.exports, "buildArcTo", () => $d5873dc5d5ad10c3$export$d46b7933b415e02f);

var $4nDbL = parcelRequire("4nDbL");
"use strict";
function $d5873dc5d5ad10c3$export$d46b7933b415e02f(points, x1, y1, x2, y2, radius) {
    const fromX = points[points.length - 2];
    const fromY = points[points.length - 1];
    const a1 = fromY - y1;
    const b1 = fromX - x1;
    const a2 = y2 - y1;
    const b2 = x2 - x1;
    const mm = Math.abs(a1 * b2 - b1 * a2);
    if (mm < 1e-8 || radius === 0) {
        if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) points.push(x1, y1);
        return;
    }
    const dd = a1 * a1 + b1 * b1;
    const cc = a2 * a2 + b2 * b2;
    const tt = a1 * a2 + b1 * b2;
    const k1 = radius * Math.sqrt(dd) / mm;
    const k2 = radius * Math.sqrt(cc) / mm;
    const j1 = k1 * tt / dd;
    const j2 = k2 * tt / cc;
    const cx = k1 * b2 + k2 * b1;
    const cy = k1 * a2 + k2 * a1;
    const px = b1 * (k2 + j1);
    const py = a1 * (k2 + j1);
    const qx = b2 * (k1 + j2);
    const qy = a2 * (k1 + j2);
    const startAngle = Math.atan2(py - cy, px - cx);
    const endAngle = Math.atan2(qy - cy, qx - cx);
    (0, $4nDbL.buildArc)(points, cx + x1, cy + y1, radius, startAngle, endAngle, b1 * a2 > b2 * a1);
}

});

parcelRegister("g6uOW", function(module, exports) {

$parcel$export(module.exports, "buildArcToSvg", () => $b5611f568ffc5fed$export$71ccaa6dca53075e);

var $5gw8E = parcelRequire("5gw8E");
"use strict";
const $b5611f568ffc5fed$var$TAU = Math.PI * 2;
const $b5611f568ffc5fed$var$out = {
    centerX: 0,
    centerY: 0,
    ang1: 0,
    ang2: 0
};
const $b5611f568ffc5fed$var$mapToEllipse = ({ x: x, y: y }, rx, ry, cosPhi, sinPhi, centerX, centerY, out2)=>{
    x *= rx;
    y *= ry;
    const xp = cosPhi * x - sinPhi * y;
    const yp = sinPhi * x + cosPhi * y;
    out2.x = xp + centerX;
    out2.y = yp + centerY;
    return out2;
};
function $b5611f568ffc5fed$var$approxUnitArc(ang1, ang2) {
    const a1 = ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);
    const a = ang2 === 1.5707963267948966 ? 0.551915024494 : a1;
    const x1 = Math.cos(ang1);
    const y1 = Math.sin(ang1);
    const x2 = Math.cos(ang1 + ang2);
    const y2 = Math.sin(ang1 + ang2);
    return [
        {
            x: x1 - y1 * a,
            y: y1 + x1 * a
        },
        {
            x: x2 + y2 * a,
            y: y2 - x2 * a
        },
        {
            x: x2,
            y: y2
        }
    ];
}
const $b5611f568ffc5fed$var$vectorAngle = (ux, uy, vx, vy)=>{
    const sign = ux * vy - uy * vx < 0 ? -1 : 1;
    let dot = ux * vx + uy * vy;
    if (dot > 1) dot = 1;
    if (dot < -1) dot = -1;
    return sign * Math.acos(dot);
};
const $b5611f568ffc5fed$var$getArcCenter = (px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, out2)=>{
    const rxSq = Math.pow(rx, 2);
    const rySq = Math.pow(ry, 2);
    const pxpSq = Math.pow(pxp, 2);
    const pypSq = Math.pow(pyp, 2);
    let radicant = rxSq * rySq - rxSq * pypSq - rySq * pxpSq;
    if (radicant < 0) radicant = 0;
    radicant /= rxSq * pypSq + rySq * pxpSq;
    radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
    const centerXp = radicant * rx / ry * pyp;
    const centerYp = radicant * -ry / rx * pxp;
    const centerX = cosPhi * centerXp - sinPhi * centerYp + (px + cx) / 2;
    const centerY = sinPhi * centerXp + cosPhi * centerYp + (py + cy) / 2;
    const vx1 = (pxp - centerXp) / rx;
    const vy1 = (pyp - centerYp) / ry;
    const vx2 = (-pxp - centerXp) / rx;
    const vy2 = (-pyp - centerYp) / ry;
    const ang1 = $b5611f568ffc5fed$var$vectorAngle(1, 0, vx1, vy1);
    let ang2 = $b5611f568ffc5fed$var$vectorAngle(vx1, vy1, vx2, vy2);
    if (sweepFlag === 0 && ang2 > 0) ang2 -= $b5611f568ffc5fed$var$TAU;
    if (sweepFlag === 1 && ang2 < 0) ang2 += $b5611f568ffc5fed$var$TAU;
    out2.centerX = centerX;
    out2.centerY = centerY;
    out2.ang1 = ang1;
    out2.ang2 = ang2;
};
function $b5611f568ffc5fed$export$71ccaa6dca53075e(points, px, py, cx, cy, rx, ry, xAxisRotation = 0, largeArcFlag = 0, sweepFlag = 0) {
    if (rx === 0 || ry === 0) return;
    const sinPhi = Math.sin(xAxisRotation * $b5611f568ffc5fed$var$TAU / 360);
    const cosPhi = Math.cos(xAxisRotation * $b5611f568ffc5fed$var$TAU / 360);
    const pxp = cosPhi * (px - cx) / 2 + sinPhi * (py - cy) / 2;
    const pyp = -sinPhi * (px - cx) / 2 + cosPhi * (py - cy) / 2;
    if (pxp === 0 && pyp === 0) return;
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    const lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
    if (lambda > 1) {
        rx *= Math.sqrt(lambda);
        ry *= Math.sqrt(lambda);
    }
    $b5611f568ffc5fed$var$getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinPhi, cosPhi, pxp, pyp, $b5611f568ffc5fed$var$out);
    let { ang1: ang1, ang2: ang2 } = $b5611f568ffc5fed$var$out;
    const { centerX: centerX, centerY: centerY } = $b5611f568ffc5fed$var$out;
    let ratio = Math.abs(ang2) / ($b5611f568ffc5fed$var$TAU / 4);
    if (Math.abs(1 - ratio) < 1e-7) ratio = 1;
    const segments = Math.max(Math.ceil(ratio), 1);
    ang2 /= segments;
    let lastX = points[points.length - 2];
    let lastY = points[points.length - 1];
    const outCurvePoint = {
        x: 0,
        y: 0
    };
    for(let i = 0; i < segments; i++){
        const curve = $b5611f568ffc5fed$var$approxUnitArc(ang1, ang2);
        const { x: x1, y: y1 } = $b5611f568ffc5fed$var$mapToEllipse(curve[0], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        const { x: x2, y: y2 } = $b5611f568ffc5fed$var$mapToEllipse(curve[1], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        const { x: x, y: y } = $b5611f568ffc5fed$var$mapToEllipse(curve[2], rx, ry, cosPhi, sinPhi, centerX, centerY, outCurvePoint);
        (0, $5gw8E.buildAdaptiveBezier)(points, lastX, lastY, x1, y1, x2, y2, x, y);
        lastX = x;
        lastY = y;
        ang1 += ang2;
    }
}

});

parcelRegister("eA1WK", function(module, exports) {

$parcel$export(module.exports, "roundedShapeArc", () => $dd3caeae888c7a17$export$ae1f43bc280f09be);
$parcel$export(module.exports, "roundedShapeQuadraticCurve", () => $dd3caeae888c7a17$export$cf503f371c53af9e);
"use strict";
function $dd3caeae888c7a17$export$ae1f43bc280f09be(g, points, radius) {
    const vecFrom = (p, pp)=>{
        const x = pp.x - p.x;
        const y = pp.y - p.y;
        const len = Math.sqrt(x * x + y * y);
        const nx = x / len;
        const ny = y / len;
        return {
            len: len,
            nx: nx,
            ny: ny
        };
    };
    const sharpCorner = (i, p)=>{
        if (i === 0) g.moveTo(p.x, p.y);
        else g.lineTo(p.x, p.y);
    };
    let p1 = points[points.length - 1];
    for(let i = 0; i < points.length; i++){
        const p2 = points[i % points.length];
        const pRadius = p2.radius ?? radius;
        if (pRadius <= 0) {
            sharpCorner(i, p2);
            p1 = p2;
            continue;
        }
        const p3 = points[(i + 1) % points.length];
        const v1 = vecFrom(p2, p1);
        const v2 = vecFrom(p2, p3);
        if (v1.len < 1e-4 || v2.len < 1e-4) {
            sharpCorner(i, p2);
            p1 = p2;
            continue;
        }
        let angle = Math.asin(v1.nx * v2.ny - v1.ny * v2.nx);
        let radDirection = 1;
        let drawDirection = false;
        if (v1.nx * v2.nx - v1.ny * -v2.ny < 0) {
            if (angle < 0) angle = Math.PI + angle;
            else {
                angle = Math.PI - angle;
                radDirection = -1;
                drawDirection = true;
            }
        } else if (angle > 0) {
            radDirection = -1;
            drawDirection = true;
        }
        const halfAngle = angle / 2;
        let cRadius;
        let lenOut = Math.abs(Math.cos(halfAngle) * pRadius / Math.sin(halfAngle));
        if (lenOut > Math.min(v1.len / 2, v2.len / 2)) {
            lenOut = Math.min(v1.len / 2, v2.len / 2);
            cRadius = Math.abs(lenOut * Math.sin(halfAngle) / Math.cos(halfAngle));
        } else cRadius = pRadius;
        const cX = p2.x + v2.nx * lenOut + -v2.ny * cRadius * radDirection;
        const cY = p2.y + v2.ny * lenOut + v2.nx * cRadius * radDirection;
        const startAngle = Math.atan2(v1.ny, v1.nx) + Math.PI / 2 * radDirection;
        const endAngle = Math.atan2(v2.ny, v2.nx) - Math.PI / 2 * radDirection;
        if (i === 0) g.moveTo(cX + Math.cos(startAngle) * cRadius, cY + Math.sin(startAngle) * cRadius);
        g.arc(cX, cY, cRadius, startAngle, endAngle, drawDirection);
        p1 = p2;
    }
}
function $dd3caeae888c7a17$export$cf503f371c53af9e(g, points, radius, smoothness) {
    const distance = (p1, p2)=>Math.sqrt((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2);
    const pointLerp = (p1, p2, t)=>({
            x: p1.x + (p2.x - p1.x) * t,
            y: p1.y + (p2.y - p1.y) * t
        });
    const numPoints = points.length;
    for(let i = 0; i < numPoints; i++){
        const thisPoint = points[(i + 1) % numPoints];
        const pRadius = thisPoint.radius ?? radius;
        if (pRadius <= 0) {
            if (i === 0) g.moveTo(thisPoint.x, thisPoint.y);
            else g.lineTo(thisPoint.x, thisPoint.y);
            continue;
        }
        const lastPoint = points[i];
        const nextPoint = points[(i + 2) % numPoints];
        const lastEdgeLength = distance(lastPoint, thisPoint);
        let start;
        if (lastEdgeLength < 1e-4) start = thisPoint;
        else {
            const lastOffsetDistance = Math.min(lastEdgeLength / 2, pRadius);
            start = pointLerp(thisPoint, lastPoint, lastOffsetDistance / lastEdgeLength);
        }
        const nextEdgeLength = distance(nextPoint, thisPoint);
        let end;
        if (nextEdgeLength < 1e-4) end = thisPoint;
        else {
            const nextOffsetDistance = Math.min(nextEdgeLength / 2, pRadius);
            end = pointLerp(thisPoint, nextPoint, nextOffsetDistance / nextEdgeLength);
        }
        if (i === 0) g.moveTo(start.x, start.y);
        else g.lineTo(start.x, start.y);
        g.quadraticCurveTo(thisPoint.x, thisPoint.y, end.x, end.y, smoothness);
    }
}

});



parcelRegister("8mb5H", function(module, exports) {

$parcel$export(module.exports, "SVGParser", () => $aec4860445e6c267$export$2cc2aaca18109aab);

var $fGITk = parcelRequire("fGITk");

var $aRSAY = parcelRequire("aRSAY");

var $9k5Je = parcelRequire("9k5Je");

var $cuSP4 = parcelRequire("cuSP4");

var $5EoyF = parcelRequire("5EoyF");

var $ihJAD = parcelRequire("ihJAD");

var $fKQyd = parcelRequire("fKQyd");
"use strict";
function $aec4860445e6c267$export$2cc2aaca18109aab(svg, graphicsContext) {
    if (typeof svg === "string") {
        const div = document.createElement("div");
        div.innerHTML = svg.trim();
        svg = div.querySelector("svg");
    }
    const session = {
        context: graphicsContext,
        defs: {},
        path: new (0, $aRSAY.GraphicsPath)()
    };
    (0, $9k5Je.parseSVGDefinitions)(svg, session);
    const children = svg.children;
    const { fillStyle: fillStyle, strokeStyle: strokeStyle } = (0, $5EoyF.parseSVGStyle)(svg, session);
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (child.nodeName.toLowerCase() === "defs") continue;
        $aec4860445e6c267$var$renderChildren(child, session, fillStyle, strokeStyle);
    }
    return graphicsContext;
}
function $aec4860445e6c267$var$renderChildren(svg, session, fillStyle, strokeStyle) {
    const children = svg.children;
    const { fillStyle: f1, strokeStyle: s1 } = (0, $5EoyF.parseSVGStyle)(svg, session);
    if (f1 && fillStyle) fillStyle = {
        ...fillStyle,
        ...f1
    };
    else if (f1) fillStyle = f1;
    if (s1 && strokeStyle) strokeStyle = {
        ...strokeStyle,
        ...s1
    };
    else if (s1) strokeStyle = s1;
    const noStyle = !fillStyle && !strokeStyle;
    if (noStyle) fillStyle = {
        color: 0
    };
    let x;
    let y;
    let x1;
    let y1;
    let x2;
    let y2;
    let cx;
    let cy;
    let r;
    let rx;
    let ry;
    let points;
    let pointsString;
    let d;
    let graphicsPath;
    let width;
    let height;
    switch(svg.nodeName.toLowerCase()){
        case "path":
            {
                d = svg.getAttribute("d");
                const fillRule = svg.getAttribute("fill-rule");
                const subpaths = (0, $fKQyd.extractSubpaths)(d);
                const hasExplicitEvenodd = fillRule === "evenodd";
                const hasMultipleSubpaths = subpaths.length > 1;
                const shouldProcessHoles = hasExplicitEvenodd && hasMultipleSubpaths;
                if (shouldProcessHoles) {
                    const subpathsWithArea = subpaths.map((subpath)=>({
                            path: subpath,
                            area: (0, $fKQyd.calculatePathArea)(subpath)
                        }));
                    subpathsWithArea.sort((a, b)=>b.area - a.area);
                    const useMultipleHolesApproach = subpaths.length > 3 || !(0, $ihJAD.checkForNestedPattern)(subpathsWithArea);
                    if (useMultipleHolesApproach) for(let i = 0; i < subpathsWithArea.length; i++){
                        const subpath = subpathsWithArea[i];
                        const isMainShape = i === 0;
                        session.context.beginPath();
                        const newPath = new (0, $aRSAY.GraphicsPath)(void 0, true);
                        (0, $fKQyd.appendSVGPath)(subpath.path, newPath);
                        session.context.path(newPath);
                        if (isMainShape) {
                            if (fillStyle) session.context.fill(fillStyle);
                            if (strokeStyle) session.context.stroke(strokeStyle);
                        } else session.context.cut();
                    }
                    else for(let i = 0; i < subpathsWithArea.length; i++){
                        const subpath = subpathsWithArea[i];
                        const isHole = i % 2 === 1;
                        session.context.beginPath();
                        const newPath = new (0, $aRSAY.GraphicsPath)(void 0, true);
                        (0, $fKQyd.appendSVGPath)(subpath.path, newPath);
                        session.context.path(newPath);
                        if (isHole) session.context.cut();
                        else {
                            if (fillStyle) session.context.fill(fillStyle);
                            if (strokeStyle) session.context.stroke(strokeStyle);
                        }
                    }
                } else {
                    const useEvenoddForGraphicsPath = fillRule ? fillRule === "evenodd" : true;
                    graphicsPath = new (0, $aRSAY.GraphicsPath)(d, useEvenoddForGraphicsPath);
                    session.context.path(graphicsPath);
                    if (fillStyle) session.context.fill(fillStyle);
                    if (strokeStyle) session.context.stroke(strokeStyle);
                }
                break;
            }
        case "circle":
            cx = (0, $cuSP4.parseSVGFloatAttribute)(svg, "cx", 0);
            cy = (0, $cuSP4.parseSVGFloatAttribute)(svg, "cy", 0);
            r = (0, $cuSP4.parseSVGFloatAttribute)(svg, "r", 0);
            session.context.ellipse(cx, cy, r, r);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "rect":
            x = (0, $cuSP4.parseSVGFloatAttribute)(svg, "x", 0);
            y = (0, $cuSP4.parseSVGFloatAttribute)(svg, "y", 0);
            width = (0, $cuSP4.parseSVGFloatAttribute)(svg, "width", 0);
            height = (0, $cuSP4.parseSVGFloatAttribute)(svg, "height", 0);
            rx = (0, $cuSP4.parseSVGFloatAttribute)(svg, "rx", 0);
            ry = (0, $cuSP4.parseSVGFloatAttribute)(svg, "ry", 0);
            if (rx || ry) session.context.roundRect(x, y, width, height, rx || ry);
            else session.context.rect(x, y, width, height);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "ellipse":
            cx = (0, $cuSP4.parseSVGFloatAttribute)(svg, "cx", 0);
            cy = (0, $cuSP4.parseSVGFloatAttribute)(svg, "cy", 0);
            rx = (0, $cuSP4.parseSVGFloatAttribute)(svg, "rx", 0);
            ry = (0, $cuSP4.parseSVGFloatAttribute)(svg, "ry", 0);
            session.context.beginPath();
            session.context.ellipse(cx, cy, rx, ry);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "line":
            x1 = (0, $cuSP4.parseSVGFloatAttribute)(svg, "x1", 0);
            y1 = (0, $cuSP4.parseSVGFloatAttribute)(svg, "y1", 0);
            x2 = (0, $cuSP4.parseSVGFloatAttribute)(svg, "x2", 0);
            y2 = (0, $cuSP4.parseSVGFloatAttribute)(svg, "y2", 0);
            session.context.beginPath();
            session.context.moveTo(x1, y1);
            session.context.lineTo(x2, y2);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "polygon":
            pointsString = svg.getAttribute("points");
            points = pointsString.match(/-?\d+/g).map((n)=>parseInt(n, 10));
            session.context.poly(points, true);
            if (fillStyle) session.context.fill(fillStyle);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        case "polyline":
            pointsString = svg.getAttribute("points");
            points = pointsString.match(/-?\d+/g).map((n)=>parseInt(n, 10));
            session.context.poly(points, false);
            if (strokeStyle) session.context.stroke(strokeStyle);
            break;
        // Group elements - just process children
        case "g":
        case "svg":
            break;
        default:
            (0, $fGITk.warn)(`[SVG parser] <${svg.nodeName}> elements unsupported`);
            break;
    }
    if (noStyle) fillStyle = null;
    for(let i = 0; i < children.length; i++)$aec4860445e6c267$var$renderChildren(children[i], session, fillStyle, strokeStyle);
}

});
parcelRegister("9k5Je", function(module, exports) {

$parcel$export(module.exports, "parseSVGDefinitions", () => $a2655957f98c7f20$export$d578aced17ea3023);

var $jr7Dg = parcelRequire("jr7Dg");

var $fGITk = parcelRequire("fGITk");

var $4dwOg = parcelRequire("4dwOg");

var $cuSP4 = parcelRequire("cuSP4");
"use strict";
function $a2655957f98c7f20$export$d578aced17ea3023(svg, session) {
    const definitions = svg.querySelectorAll("defs");
    for(let i = 0; i < definitions.length; i++){
        const definition = definitions[i];
        for(let j = 0; j < definition.children.length; j++){
            const child = definition.children[j];
            switch(child.nodeName.toLowerCase()){
                case "lineargradient":
                    session.defs[child.id] = $a2655957f98c7f20$var$parseLinearGradient(child);
                    break;
                case "radialgradient":
                    session.defs[child.id] = $a2655957f98c7f20$var$parseRadialGradient(child);
                    break;
                default:
                    break;
            }
        }
    }
}
function $a2655957f98c7f20$var$parseLinearGradient(child) {
    const x0 = (0, $cuSP4.parseSVGFloatAttribute)(child, "x1", 0);
    const y0 = (0, $cuSP4.parseSVGFloatAttribute)(child, "y1", 0);
    const x1 = (0, $cuSP4.parseSVGFloatAttribute)(child, "x2", 1);
    const y1 = (0, $cuSP4.parseSVGFloatAttribute)(child, "y2", 0);
    const gradientUnit = child.getAttribute("gradientUnits") || "objectBoundingBox";
    const gradient = new (0, $4dwOg.FillGradient)(x0, y0, x1, y1, gradientUnit === "objectBoundingBox" ? "local" : "global");
    for(let k = 0; k < child.children.length; k++){
        const stop = child.children[k];
        const offset = (0, $cuSP4.parseSVGFloatAttribute)(stop, "offset", 0);
        const color = (0, $jr7Dg.Color).shared.setValue(stop.getAttribute("stop-color")).toNumber();
        gradient.addColorStop(offset, color);
    }
    return gradient;
}
function $a2655957f98c7f20$var$parseRadialGradient(_child) {
    (0, $fGITk.warn)("[SVG Parser] Radial gradients are not yet supported");
    return new (0, $4dwOg.FillGradient)(0, 0, 1, 0);
}

});
parcelRegister("cuSP4", function(module, exports) {

$parcel$export(module.exports, "parseSVGFloatAttribute", () => $352c17c9e11fb5db$export$dd264bbf059b1af7);
"use strict";
function $352c17c9e11fb5db$export$dd264bbf059b1af7(svg, id, defaultValue) {
    const value = svg.getAttribute(id);
    return value ? Number(value) : defaultValue;
}

});


parcelRegister("5EoyF", function(module, exports) {

$parcel$export(module.exports, "parseSVGStyle", () => $5676df6fba92690f$export$394301fd4b48c7bc);

var $jr7Dg = parcelRequire("jr7Dg");

var $kuDOk = parcelRequire("kuDOk");
"use strict";
const $5676df6fba92690f$export$d1c537faaad576dd = {
    // Fill properties
    fill: {
        type: "paint",
        default: 0
    },
    // Fill color/gradient
    "fill-opacity": {
        type: "number",
        default: 1
    },
    // Fill transparency
    // Stroke properties
    stroke: {
        type: "paint",
        default: 0
    },
    // Stroke color/gradient
    "stroke-width": {
        type: "number",
        default: 1
    },
    // Width of stroke
    "stroke-opacity": {
        type: "number",
        default: 1
    },
    // Stroke transparency
    "stroke-linecap": {
        type: "string",
        default: "butt"
    },
    // End cap style: butt, round, square
    "stroke-linejoin": {
        type: "string",
        default: "miter"
    },
    // Join style: miter, round, bevel
    "stroke-miterlimit": {
        type: "number",
        default: 10
    },
    // Limit on miter join sharpness
    "stroke-dasharray": {
        type: "string",
        default: "none"
    },
    // Dash pattern
    "stroke-dashoffset": {
        type: "number",
        default: 0
    },
    // Offset for dash pattern
    // Global properties
    opacity: {
        type: "number",
        default: 1
    }
};
function $5676df6fba92690f$export$394301fd4b48c7bc(svg, session) {
    const style = svg.getAttribute("style");
    const strokeStyle = {};
    const fillStyle = {};
    const result = {
        strokeStyle: strokeStyle,
        fillStyle: fillStyle,
        useFill: false,
        useStroke: false
    };
    for(const key in $5676df6fba92690f$export$d1c537faaad576dd){
        const attribute = svg.getAttribute(key);
        if (attribute) $5676df6fba92690f$var$parseAttribute(session, result, key, attribute.trim());
    }
    if (style) {
        const styleParts = style.split(";");
        for(let i = 0; i < styleParts.length; i++){
            const stylePart = styleParts[i].trim();
            const [key, value] = stylePart.split(":");
            if ($5676df6fba92690f$export$d1c537faaad576dd[key]) $5676df6fba92690f$var$parseAttribute(session, result, key, value.trim());
        }
    }
    return {
        strokeStyle: result.useStroke ? strokeStyle : null,
        fillStyle: result.useFill ? fillStyle : null,
        useFill: result.useFill,
        useStroke: result.useStroke
    };
}
function $5676df6fba92690f$var$parseAttribute(session, result, id, value) {
    switch(id){
        case "stroke":
            if (value !== "none") {
                if (value.startsWith("url(")) {
                    const id2 = (0, $kuDOk.extractSvgUrlId)(value);
                    result.strokeStyle.fill = session.defs[id2];
                } else result.strokeStyle.color = (0, $jr7Dg.Color).shared.setValue(value).toNumber();
                result.useStroke = true;
            }
            break;
        case "stroke-width":
            result.strokeStyle.width = Number(value);
            break;
        case "fill":
            if (value !== "none") {
                if (value.startsWith("url(")) {
                    const id2 = (0, $kuDOk.extractSvgUrlId)(value);
                    result.fillStyle.fill = session.defs[id2];
                } else result.fillStyle.color = (0, $jr7Dg.Color).shared.setValue(value).toNumber();
                result.useFill = true;
            }
            break;
        case "fill-opacity":
            result.fillStyle.alpha = Number(value);
            break;
        case "stroke-opacity":
            result.strokeStyle.alpha = Number(value);
            break;
        case "opacity":
            result.fillStyle.alpha = Number(value);
            result.strokeStyle.alpha = Number(value);
            break;
    }
}

});
parcelRegister("kuDOk", function(module, exports) {

$parcel$export(module.exports, "extractSvgUrlId", () => $a88c5f65d25e5f32$export$c7c899a4a04107c);
"use strict";
function $a88c5f65d25e5f32$export$c7c899a4a04107c(url) {
    const match = url.match(/url\s*\(\s*['"]?\s*#([^'"\s)]+)\s*['"]?\s*\)/i);
    return match ? match[1] : "";
}

});


parcelRegister("ihJAD", function(module, exports) {

$parcel$export(module.exports, "checkForNestedPattern", () => $8812d951f8428f5c$export$ed0d227537169c54);
"use strict";
function $8812d951f8428f5c$export$ed0d227537169c54(subpathsWithArea) {
    if (subpathsWithArea.length <= 2) return true;
    const areas = subpathsWithArea.map((s)=>s.area).sort((a, b)=>b - a);
    const [largestArea, secondArea] = areas;
    const smallestArea = areas[areas.length - 1];
    const largestToSecondRatio = largestArea / secondArea;
    const secondToSmallestRatio = secondArea / smallestArea;
    if (largestToSecondRatio > 3 && secondToSmallestRatio < 2) return false;
    return true;
}
function $8812d951f8428f5c$export$610d4ffdd1dde411(context, index = 0) {
    const instruction = context.instructions[index];
    if (!instruction || instruction.action !== "fill") throw new Error(`Expected fill instruction at index ${index}, got ${instruction?.action || "undefined"}`);
    return instruction.data;
}

});

parcelRegister("fKQyd", function(module, exports) {

$parcel$export(module.exports, "extractSubpaths", () => $c6d50b324ac0b228$export$af504e8f7eac5195);
$parcel$export(module.exports, "calculatePathArea", () => $c6d50b324ac0b228$export$c5f82a6ddca6e166);
$parcel$export(module.exports, "appendSVGPath", () => $c6d50b324ac0b228$export$29a5b7b41692ef3);

var $aRSAY = parcelRequire("aRSAY");
"use strict";
function $c6d50b324ac0b228$export$af504e8f7eac5195(pathData) {
    const parts = pathData.split(/(?=[Mm])/);
    const subpaths = parts.filter((part)=>part.trim().length > 0);
    return subpaths;
}
function $c6d50b324ac0b228$export$c5f82a6ddca6e166(pathData) {
    const coords = pathData.match(/[-+]?[0-9]*\.?[0-9]+/g);
    if (!coords || coords.length < 4) return 0;
    const numbers = coords.map(Number);
    const xs = [];
    const ys = [];
    for(let i = 0; i < numbers.length; i += 2)if (i + 1 < numbers.length) {
        xs.push(numbers[i]);
        ys.push(numbers[i + 1]);
    }
    if (xs.length === 0 || ys.length === 0) return 0;
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);
    const area = (maxX - minX) * (maxY - minY);
    return area;
}
function $c6d50b324ac0b228$export$29a5b7b41692ef3(pathData, graphicsPath) {
    const tempPath = new (0, $aRSAY.GraphicsPath)(pathData, false);
    for (const instruction of tempPath.instructions)graphicsPath.instructions.push(instruction);
}

});


parcelRegister("3lOoE", function(module, exports) {

$parcel$export(module.exports, "toFillStyle", () => $13d455c31572dfec$export$b254764c5530994a);
$parcel$export(module.exports, "toStrokeStyle", () => $13d455c31572dfec$export$64975ed44b74a62b);

var $jr7Dg = parcelRequire("jr7Dg");

var $cmH9g = parcelRequire("cmH9g");

var $4dwOg = parcelRequire("4dwOg");

var $jqDfq = parcelRequire("jqDfq");
"use strict";
function $13d455c31572dfec$var$isColorLike(value) {
    return (0, $jr7Dg.Color).isColorLike(value);
}
function $13d455c31572dfec$var$isFillPattern(value) {
    return value instanceof (0, $jqDfq.FillPattern);
}
function $13d455c31572dfec$var$isFillGradient(value) {
    return value instanceof (0, $4dwOg.FillGradient);
}
function $13d455c31572dfec$var$isTexture(value) {
    return value instanceof (0, $cmH9g.Texture);
}
function $13d455c31572dfec$var$handleColorLike(fill, value, defaultStyle) {
    const temp = (0, $jr7Dg.Color).shared.setValue(value ?? 0);
    fill.color = temp.toNumber();
    fill.alpha = temp.alpha === 1 ? defaultStyle.alpha : temp.alpha;
    fill.texture = (0, $cmH9g.Texture).WHITE;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $13d455c31572dfec$var$handleTexture(fill, value, defaultStyle) {
    fill.texture = value;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $13d455c31572dfec$var$handleFillPattern(fill, value, defaultStyle) {
    fill.fill = value;
    fill.color = 16777215;
    fill.texture = value.texture;
    fill.matrix = value.transform;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $13d455c31572dfec$var$handleFillGradient(fill, value, defaultStyle) {
    value.buildGradient();
    fill.fill = value;
    fill.color = 16777215;
    fill.texture = value.texture;
    fill.matrix = value.transform;
    fill.textureSpace = value.textureSpace;
    return {
        ...defaultStyle,
        ...fill
    };
}
function $13d455c31572dfec$var$handleFillObject(value, defaultStyle) {
    const style = {
        ...defaultStyle,
        ...value
    };
    const color = (0, $jr7Dg.Color).shared.setValue(style.color);
    style.alpha *= color.alpha;
    style.color = color.toNumber();
    return style;
}
function $13d455c31572dfec$export$b254764c5530994a(value, defaultStyle) {
    if (value === void 0 || value === null) return null;
    const fill = {};
    const objectStyle = value;
    if ($13d455c31572dfec$var$isColorLike(value)) return $13d455c31572dfec$var$handleColorLike(fill, value, defaultStyle);
    else if ($13d455c31572dfec$var$isTexture(value)) return $13d455c31572dfec$var$handleTexture(fill, value, defaultStyle);
    else if ($13d455c31572dfec$var$isFillPattern(value)) return $13d455c31572dfec$var$handleFillPattern(fill, value, defaultStyle);
    else if ($13d455c31572dfec$var$isFillGradient(value)) return $13d455c31572dfec$var$handleFillGradient(fill, value, defaultStyle);
    else if (objectStyle.fill && $13d455c31572dfec$var$isFillPattern(objectStyle.fill)) return $13d455c31572dfec$var$handleFillPattern(objectStyle, objectStyle.fill, defaultStyle);
    else if (objectStyle.fill && $13d455c31572dfec$var$isFillGradient(objectStyle.fill)) return $13d455c31572dfec$var$handleFillGradient(objectStyle, objectStyle.fill, defaultStyle);
    return $13d455c31572dfec$var$handleFillObject(objectStyle, defaultStyle);
}
function $13d455c31572dfec$export$64975ed44b74a62b(value, defaultStyle) {
    const { width: width, alignment: alignment, miterLimit: miterLimit, cap: cap, join: join, pixelLine: pixelLine, ...rest } = defaultStyle;
    const fill = $13d455c31572dfec$export$b254764c5530994a(value, rest);
    if (!fill) return null;
    return {
        width: width,
        alignment: alignment,
        miterLimit: miterLimit,
        cap: cap,
        join: join,
        pixelLine: pixelLine,
        ...fill
    };
}

});

parcelRegister("SaxLb", function(module, exports) {

$parcel$export(module.exports, "getMaxMiterRatio", () => $7990a8a3d1f3af7d$export$95a81f2c49712883);
"use strict";
function $7990a8a3d1f3af7d$export$95a81f2c49712883(path, miterLimit) {
    let maxRatio = 1;
    const shapePrimitives = path.shapePath.shapePrimitives;
    for(let i = 0; i < shapePrimitives.length; i++){
        const shape = shapePrimitives[i].shape;
        if (shape.type !== "polygon") continue;
        const points = shape.points;
        const n = points.length;
        if (n < 6) continue;
        const closed = shape.closePath;
        for(let j = 0; j < n; j += 2){
            if (!closed && (j === 0 || j === n - 2)) continue;
            const prevIdx = (j - 2 + n) % n;
            const nextIdx = (j + 2) % n;
            const x0 = points[prevIdx];
            const y0 = points[prevIdx + 1];
            const x1 = points[j];
            const y1 = points[j + 1];
            const x2 = points[nextIdx];
            const y2 = points[nextIdx + 1];
            const dx0 = x0 - x1;
            const dy0 = y0 - y1;
            const dx1 = x2 - x1;
            const dy1 = y2 - y1;
            const len0Sq = dx0 * dx0 + dy0 * dy0;
            const len1Sq = dx1 * dx1 + dy1 * dy1;
            if (len0Sq < 1e-12 || len1Sq < 1e-12) continue;
            const dot = dx0 * dx1 + dy0 * dy1;
            const cosAngle = dot / Math.sqrt(len0Sq * len1Sq);
            let clampedCos = cosAngle;
            if (clampedCos < -1) clampedCos = -1;
            else if (clampedCos > 1) clampedCos = 1;
            const sinHalfAngle = Math.sqrt((1 - clampedCos) * 0.5);
            if (sinHalfAngle < 1e-6) continue;
            const miterRatio = Math.min(1 / sinHalfAngle, miterLimit);
            if (miterRatio > maxRatio) maxRatio = miterRatio;
        }
    }
    return maxRatio;
}

});


parcelRegister("45bKO", function(module, exports) {

var $aBhlC = parcelRequire("aBhlC");

var $gSowh = parcelRequire("gSowh");

var $eaehU = parcelRequire("eaehU");

var $eqSWH = parcelRequire("eqSWH");

var $e0YVT = parcelRequire("e0YVT");
"use strict";
(0, $aBhlC.extensions).add((0, $eaehU.CanvasGraphicsPipe));
(0, $aBhlC.extensions).add((0, $e0YVT.GraphicsPipe));
(0, $aBhlC.extensions).add((0, $gSowh.CanvasGraphicsContextSystem));
(0, $aBhlC.extensions).add((0, $eqSWH.GraphicsContextSystem));

});
parcelRegister("gSowh", function(module, exports) {

$parcel$export(module.exports, "CanvasGraphicsContextSystem", () => $210aa9bb734e4bde$export$ecb840d1abeff74b);

var $aBhlC = parcelRequire("aBhlC");

var $eGbEm = parcelRequire("eGbEm");

var $96EPk = parcelRequire("96EPk");
"use strict";
class $210aa9bb734e4bde$var$CanvasGraphicsContext {
    constructor(){
        /**
     * Whether this context can be batched.
     * @advanced
     */ this.isBatchable = false;
    }
    /**
   * Reset cached canvas data.
   * @advanced
   */ reset() {
        this.isBatchable = false;
        this.context = null;
        if (this.graphicsData) {
            this.graphicsData.destroy();
            this.graphicsData = null;
        }
    }
    /**
   * Destroy the cached data.
   * @advanced
   */ destroy() {
        this.reset();
    }
}
class $210aa9bb734e4bde$var$CanvasGraphicsContextRenderData {
    constructor(){
        /**
     * Instructions for canvas rendering.
     * @advanced
     */ this.instructions = new (0, $eGbEm.InstructionSet)();
    }
    /**
   * Initialize render data.
   * @advanced
   */ init() {
        this.instructions.reset();
    }
    /**
   * Destroy render data.
   * @advanced
   */ destroy() {
        this.instructions.destroy();
        this.instructions = null;
    }
}
const $210aa9bb734e4bde$var$_CanvasGraphicsContextSystem = class _CanvasGraphicsContextSystem {
    constructor(renderer){
        this._renderer = renderer;
        this._managedContexts = new (0, $96EPk.GCManagedHash)({
            renderer: renderer,
            type: "resource",
            name: "graphicsContext"
        });
    }
    /**
   * Runner init called, update the default options
   * @ignore
   */ init(options) {
        _CanvasGraphicsContextSystem.defaultOptions.bezierSmoothness = options?.bezierSmoothness ?? _CanvasGraphicsContextSystem.defaultOptions.bezierSmoothness;
    }
    /**
   * Returns the render data for a given GraphicsContext.
   * @param context - The GraphicsContext to get the render data for.
   * @internal
   */ getContextRenderData(context) {
        const gpuContext = this.getGpuContext(context);
        return gpuContext.graphicsData || this._initContextRenderData(context);
    }
    /**
   * Updates the GPU context for a given GraphicsContext.
   * @param context - The GraphicsContext to update.
   * @returns The updated CanvasGraphicsContext.
   * @internal
   */ updateGpuContext(context) {
        const gpuData = context._gpuData;
        const hasContext = !!gpuData[this._renderer.uid];
        const gpuContext = gpuData[this._renderer.uid] || this._initContext(context);
        if (context.dirty || !hasContext) {
            if (hasContext) gpuContext.reset();
            gpuContext.isBatchable = false;
            context.dirty = false;
        }
        return gpuContext;
    }
    /**
   * Returns the CanvasGraphicsContext for a given GraphicsContext.
   * If it does not exist, it will initialize a new one.
   * @param context - The GraphicsContext to get the CanvasGraphicsContext for.
   * @returns The CanvasGraphicsContext for the given GraphicsContext.
   * @internal
   */ getGpuContext(context) {
        const gpuData = context._gpuData;
        return gpuData[this._renderer.uid] || this._initContext(context);
    }
    _initContextRenderData(context) {
        const renderData = new $210aa9bb734e4bde$var$CanvasGraphicsContextRenderData();
        const gpuContext = this.getGpuContext(context);
        gpuContext.graphicsData = renderData;
        renderData.init();
        return renderData;
    }
    _initContext(context) {
        const gpuContext = new $210aa9bb734e4bde$var$CanvasGraphicsContext();
        gpuContext.context = context;
        context._gpuData[this._renderer.uid] = gpuContext;
        this._managedContexts.add(context);
        return gpuContext;
    }
    destroy() {
        this._managedContexts.destroy();
        this._renderer = null;
    }
};
/** @ignore */ $210aa9bb734e4bde$var$_CanvasGraphicsContextSystem.extension = {
    type: [
        (0, $aBhlC.ExtensionType).CanvasSystem
    ],
    name: "graphicsContext"
};
/** The default options for the GraphicsContextSystem. */ $210aa9bb734e4bde$var$_CanvasGraphicsContextSystem.defaultOptions = {
    /**
   * A value from 0 to 1 that controls the smoothness of bezier curves (the higher the smoother)
   * @default 0.5
   */ bezierSmoothness: 0.5
};
let $210aa9bb734e4bde$export$ecb840d1abeff74b = $210aa9bb734e4bde$var$_CanvasGraphicsContextSystem;

});

parcelRegister("eaehU", function(module, exports) {

$parcel$export(module.exports, "CanvasGraphicsPipe", () => $60d6155c81d8d3df$export$26ad1716c6143fba);

var $aBhlC = parcelRequire("aBhlC");

var $8xcvq = parcelRequire("8xcvq");

var $96EPk = parcelRequire("96EPk");
"use strict";
class $60d6155c81d8d3df$export$26ad1716c6143fba {
    constructor(renderer, adaptor){
        this.state = (0, $8xcvq.State).for2d();
        this.renderer = renderer;
        this._adaptor = adaptor;
        this.renderer.runners.contextChange.add(this);
        this._managedGraphics = new (0, $96EPk.GCManagedHash)({
            renderer: renderer,
            type: "renderable",
            priority: -1,
            name: "graphics"
        });
    }
    contextChange() {
        this._adaptor.contextChange(this.renderer);
    }
    validateRenderable(_graphics) {
        return false;
    }
    addRenderable(graphics, instructionSet) {
        this._managedGraphics.add(graphics);
        this.renderer.renderPipes.batch.break(instructionSet);
        instructionSet.add(graphics);
    }
    updateRenderable(_graphics) {}
    execute(graphics) {
        if (!graphics.isRenderable) return;
        this._adaptor.execute(this, graphics);
    }
    destroy() {
        this._managedGraphics.destroy();
        this.renderer = null;
        this._adaptor.destroy();
        this._adaptor = null;
    }
}
/** @ignore */ $60d6155c81d8d3df$export$26ad1716c6143fba.extension = {
    type: [
        (0, $aBhlC.ExtensionType).CanvasPipes
    ],
    name: "graphics"
};

});

parcelRegister("e0YVT", function(module, exports) {

$parcel$export(module.exports, "GraphicsPipe", () => $8758b82aa09f3d4f$export$56171ef5563dc803);

var $aBhlC = parcelRequire("aBhlC");

var $8xcvq = parcelRequire("8xcvq");

var $96EPk = parcelRequire("96EPk");

var $2xwDK = parcelRequire("2xwDK");

var $8BD2x = parcelRequire("8BD2x");

var $fTkea = parcelRequire("fTkea");
"use strict";
class $8758b82aa09f3d4f$export$2a885cf99f131046 {
    constructor(){
        this.batches = [];
        this.batched = false;
    }
    destroy() {
        this.batches.forEach((batch)=>{
            (0, $2xwDK.BigPool).return(batch);
        });
        this.batches.length = 0;
    }
}
class $8758b82aa09f3d4f$export$56171ef5563dc803 {
    constructor(renderer, adaptor){
        this.state = (0, $8xcvq.State).for2d();
        this.renderer = renderer;
        this._adaptor = adaptor;
        this.renderer.runners.contextChange.add(this);
        this._managedGraphics = new (0, $96EPk.GCManagedHash)({
            renderer: renderer,
            type: "renderable",
            priority: -1,
            name: "graphics"
        });
    }
    contextChange() {
        this._adaptor.contextChange(this.renderer);
    }
    validateRenderable(graphics) {
        const context = graphics.context;
        const wasBatched = !!graphics._gpuData;
        const contextSystem = this.renderer.graphicsContext;
        const gpuContext = contextSystem.updateGpuContext(context);
        if (gpuContext.isBatchable || wasBatched !== gpuContext.isBatchable) return true;
        return false;
    }
    addRenderable(graphics, instructionSet) {
        const contextSystem = this.renderer.graphicsContext;
        const gpuContext = contextSystem.updateGpuContext(graphics.context);
        if (graphics.didViewUpdate) this._rebuild(graphics);
        if (gpuContext.isBatchable) this._addToBatcher(graphics, instructionSet);
        else {
            this.renderer.renderPipes.batch.break(instructionSet);
            instructionSet.add(graphics);
        }
    }
    updateRenderable(graphics) {
        const gpuData = this._getGpuDataForRenderable(graphics);
        const batches = gpuData.batches;
        for(let i = 0; i < batches.length; i++){
            const batch = batches[i];
            batch._batcher.updateElement(batch);
        }
    }
    execute(graphics) {
        if (!graphics.isRenderable) return;
        const renderer = this.renderer;
        const context = graphics.context;
        const contextSystem = renderer.graphicsContext;
        if (!contextSystem.getGpuContext(context).batches.length) return;
        const shader = context.customShader || this._adaptor.shader;
        this.state.blendMode = graphics.groupBlendMode;
        const localUniforms = shader.resources.localUniforms.uniforms;
        localUniforms.uTransformMatrix = graphics.groupTransform;
        localUniforms.uRound = renderer._roundPixels | graphics._roundPixels;
        (0, $8BD2x.color32BitToUniform)(graphics.groupColorAlpha, localUniforms.uColor, 0);
        this._adaptor.execute(this, graphics);
    }
    _rebuild(graphics) {
        const gpuData = this._getGpuDataForRenderable(graphics);
        const contextSystem = this.renderer.graphicsContext;
        const gpuContext = contextSystem.updateGpuContext(graphics.context);
        gpuData.destroy();
        if (gpuContext.isBatchable) this._updateBatchesForRenderable(graphics, gpuData);
    }
    _addToBatcher(graphics, instructionSet) {
        const batchPipe = this.renderer.renderPipes.batch;
        const batches = this._getGpuDataForRenderable(graphics).batches;
        for(let i = 0; i < batches.length; i++){
            const batch = batches[i];
            batchPipe.addToBatch(batch, instructionSet);
        }
    }
    _getGpuDataForRenderable(graphics) {
        return graphics._gpuData[this.renderer.uid] || this._initGpuDataForRenderable(graphics);
    }
    _initGpuDataForRenderable(graphics) {
        const gpuData = new $8758b82aa09f3d4f$export$2a885cf99f131046();
        graphics._gpuData[this.renderer.uid] = gpuData;
        this._managedGraphics.add(graphics);
        return gpuData;
    }
    _updateBatchesForRenderable(graphics, gpuData) {
        const context = graphics.context;
        const contextSystem = this.renderer.graphicsContext;
        const gpuContext = contextSystem.getGpuContext(context);
        const roundPixels = this.renderer._roundPixels | graphics._roundPixels;
        gpuData.batches = gpuContext.batches.map((batch)=>{
            const batchClone = (0, $2xwDK.BigPool).get((0, $fTkea.BatchableGraphics));
            batch.copyTo(batchClone);
            batchClone.renderable = graphics;
            batchClone.roundPixels = roundPixels;
            return batchClone;
        });
    }
    destroy() {
        this._managedGraphics.destroy();
        this.renderer = null;
        this._adaptor.destroy();
        this._adaptor = null;
        this.state = null;
    }
}
/** @ignore */ $8758b82aa09f3d4f$export$56171ef5563dc803.extension = {
    type: [
        (0, $aBhlC.ExtensionType).WebGLPipes,
        (0, $aBhlC.ExtensionType).WebGPUPipes
    ],
    name: "graphics"
};

});



parcelRegister("7nq8K", function(module, exports) {

$parcel$export(module.exports, "BatchableSprite", () => $5b96e652979c678e$export$fe4bdc7069ee0b9c);
"use strict";
class $5b96e652979c678e$export$fe4bdc7069ee0b9c {
    constructor(){
        this.batcherName = "default";
        this.topology = "triangle-list";
        // batch specific..
        this.attributeSize = 4;
        this.indexSize = 6;
        this.packAsQuad = true;
        this.roundPixels = 0;
        this._attributeStart = 0;
        // location in the buffer
        this._batcher = null;
        this._batch = null;
    }
    get blendMode() {
        return this.renderable.groupBlendMode;
    }
    get color() {
        return this.renderable.groupColorAlpha;
    }
    reset() {
        this.renderable = null;
        this.texture = null;
        this._batcher = null;
        this._batch = null;
        this.bounds = null;
    }
    destroy() {
        this.reset();
    }
}

});

parcelRegister("5UA0V", function(module, exports) {

$parcel$export(module.exports, "getPo2TextureFromSource", () => $090d4e8c393e53df$export$80c61c6b7fb407a3);

var $cOfCf = parcelRequire("cOfCf");

var $eWGg9 = parcelRequire("eWGg9");
"use strict";
const $090d4e8c393e53df$var$tempBounds = new (0, $eWGg9.Bounds)();
function $090d4e8c393e53df$export$80c61c6b7fb407a3(image, width, height, resolution, autoGenerateMipmaps = false) {
    const bounds = $090d4e8c393e53df$var$tempBounds;
    bounds.minX = 0;
    bounds.minY = 0;
    bounds.maxX = image.width / resolution | 0;
    bounds.maxY = image.height / resolution | 0;
    const texture = (0, $cOfCf.TexturePool).getOptimalTexture(bounds.width, bounds.height, resolution, false, autoGenerateMipmaps);
    texture.source.uploadMethodId = "image";
    texture.source.resource = image;
    texture.source.alphaMode = "premultiply-alpha-on-upload";
    texture.frame.width = width / resolution;
    texture.frame.height = height / resolution;
    texture.source.emit("update", texture.source);
    texture.updateUvs();
    return texture;
}

});


var $aBhlC = parcelRequire("aBhlC");
"use strict";

const $b92bf6e5010c4fa3$export$a6aad6334ef58a1c = {
    extension: {
        type: (0, $aBhlC.ExtensionType).Environment,
        name: "browser",
        priority: -1
    },
    test: ()=>true,
    load: async ()=>{
        await (parcelRequire("7D6Dk"));
    }
};



var $aBhlC = parcelRequire("aBhlC");
"use strict";

const $16ff22dbf358da86$export$ee43dd1acddf6cf8 = {
    extension: {
        type: (0, $aBhlC.ExtensionType).Environment,
        name: "webworker",
        priority: 0
    },
    test: ()=>typeof self !== "undefined" && self.WorkerGlobalScope !== void 0,
    load: async ()=>{
        await (parcelRequire("2xXnk"));
    }
};



var $aBhlC = parcelRequire("aBhlC");
parcelRequire("1VA6u");
parcelRequire("lVjv8");













































var $aBhlC = parcelRequire("aBhlC");

var $dHliN = parcelRequire("dHliN");

var $2C2CU = parcelRequire("2C2CU");
"use strict";
let $17ead21b7cc2e556$var$_isWebGLSupported;
function $17ead21b7cc2e556$export$83dc396b76015322(failIfMajorPerformanceCaveat) {
    if ($17ead21b7cc2e556$var$_isWebGLSupported !== void 0) return $17ead21b7cc2e556$var$_isWebGLSupported;
    $17ead21b7cc2e556$var$_isWebGLSupported = (()=>{
        const contextOptions = {
            stencil: true,
            failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat ?? (0, $2C2CU.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat
        };
        try {
            if (!(0, $dHliN.DOMAdapter).get().getWebGLRenderingContext()) return false;
            const canvas = (0, $dHliN.DOMAdapter).get().createCanvas();
            let gl = canvas.getContext("webgl", contextOptions);
            const success = !!gl?.getContextAttributes()?.stencil;
            if (gl) {
                const loseContext = gl.getExtension("WEBGL_lose_context");
                if (loseContext) loseContext.loseContext();
            }
            gl = null;
            return success;
        } catch (_e) {
            return false;
        }
    })();
    return $17ead21b7cc2e556$var$_isWebGLSupported;
}



var $dHliN = parcelRequire("dHliN");
"use strict";
let $3eed8bdc8f985d4b$var$_isWebGPUSupported;
async function $3eed8bdc8f985d4b$export$216169f30082c873(options = {}) {
    if ($3eed8bdc8f985d4b$var$_isWebGPUSupported !== void 0) return $3eed8bdc8f985d4b$var$_isWebGPUSupported;
    $3eed8bdc8f985d4b$var$_isWebGPUSupported = await (async ()=>{
        const gpu = (0, $dHliN.DOMAdapter).get().getNavigator().gpu;
        if (!gpu) return false;
        try {
            const adapter = await gpu.requestAdapter(options);
            await adapter.requestDevice();
            return true;
        } catch (_e) {
            return false;
        }
    })();
    return $3eed8bdc8f985d4b$var$_isWebGPUSupported;
}



var $2C2CU = parcelRequire("2C2CU");
"use strict";
const $94edf3028d07db77$var$renderPriority = [
    "webgl",
    "webgpu",
    "canvas"
];



async function $94edf3028d07db77$export$3583b92ab8150eb6(options) {
    let preferredOrder = [];
    if (options.preference) {
        if (Array.isArray(options.preference)) preferredOrder = options.preference.slice();
        else {
            preferredOrder.push(options.preference);
            $94edf3028d07db77$var$renderPriority.forEach((item)=>{
                if (item !== options.preference) preferredOrder.push(item);
            });
        }
    } else preferredOrder = $94edf3028d07db77$var$renderPriority.slice();
    let RendererClass;
    let finalOptions = {};
    for(let i = 0; i < preferredOrder.length; i++){
        const rendererType = preferredOrder[i];
        if (rendererType === "webgpu" && await (0, $3eed8bdc8f985d4b$export$216169f30082c873)()) {
            const { WebGPURenderer: WebGPURenderer } = await (parcelRequire("la4xz"));
            RendererClass = WebGPURenderer;
            finalOptions = {
                ...options,
                ...options.webgpu
            };
            break;
        } else if (rendererType === "webgl" && (0, $17ead21b7cc2e556$export$83dc396b76015322)(options.failIfMajorPerformanceCaveat ?? (0, $2C2CU.AbstractRenderer).defaultOptions.failIfMajorPerformanceCaveat)) {
            const { WebGLRenderer: WebGLRenderer } = await (parcelRequire("f8sY4"));
            RendererClass = WebGLRenderer;
            finalOptions = {
                ...options,
                ...options.webgl
            };
            break;
        } else if (rendererType === "canvas") {
            const { CanvasRenderer: CanvasRenderer } = await (parcelRequire("hxI5C"));
            RendererClass = CanvasRenderer;
            finalOptions = {
                ...options,
                ...options.canvasOptions
            };
            break;
        }
    }
    delete finalOptions.webgpu;
    delete finalOptions.webgl;
    delete finalOptions.canvasOptions;
    if (!RendererClass) throw new Error("No available renderer for the current environment");
    const renderer = new RendererClass();
    await renderer.init(finalOptions);
    return renderer;
}



var $5Wp7K = parcelRequire("5Wp7K");

var $k73MA = parcelRequire("k73MA");

var $dXBy0 = parcelRequire("dXBy0");

var $aBhlC = parcelRequire("aBhlC");

var $aBhlC = parcelRequire("aBhlC");
"use strict";
class $5a029ee4d6d2b4eb$export$6453cd852defe94a {
    /**
   * Initialize the plugin with scope of application instance
   * @private
   * @param {object} [options] - See application options
   */ static init(options) {
        Object.defineProperty(this, "resizeTo", {
            configurable: true,
            set (dom) {
                globalThis.removeEventListener("resize", this.queueResize);
                this._resizeTo = dom;
                if (dom) {
                    globalThis.addEventListener("resize", this.queueResize);
                    this.resize();
                }
            },
            get () {
                return this._resizeTo;
            }
        });
        this.queueResize = ()=>{
            if (!this._resizeTo) return;
            this._cancelResize();
            this._resizeId = requestAnimationFrame(()=>this.resize());
        };
        this._cancelResize = ()=>{
            if (this._resizeId) {
                cancelAnimationFrame(this._resizeId);
                this._resizeId = null;
            }
        };
        this.resize = ()=>{
            if (!this._resizeTo) return;
            this._cancelResize();
            let width;
            let height;
            if (this._resizeTo === globalThis.window) {
                width = globalThis.innerWidth;
                height = globalThis.innerHeight;
            } else {
                const { clientWidth: clientWidth, clientHeight: clientHeight } = this._resizeTo;
                width = clientWidth;
                height = clientHeight;
            }
            this.renderer.resize(width, height);
            this.render();
        };
        this._resizeId = null;
        this._resizeTo = null;
        this.resizeTo = options.resizeTo || null;
    }
    /**
   * Clean up the ticker, scoped to application
   * @private
   */ static destroy() {
        globalThis.removeEventListener("resize", this.queueResize);
        this._cancelResize();
        this._cancelResize = null;
        this.queueResize = null;
        this.resizeTo = null;
        this.resize = null;
    }
}
/** @ignore */ $5a029ee4d6d2b4eb$export$6453cd852defe94a.extension = (0, $aBhlC.ExtensionType).Application;



var $aBhlC = parcelRequire("aBhlC");

var $7iB5e = parcelRequire("7iB5e");

var $lcv0T = parcelRequire("lcv0T");
"use strict";
class $37a621c7c36d1522$export$50c361ceb4e2f4f0 {
    /**
   * Initialize the plugin with scope of application instance
   * @private
   * @param {object} [options] - See application options
   */ static init(options) {
        options = Object.assign({
            autoStart: true,
            sharedTicker: false
        }, options);
        Object.defineProperty(this, "ticker", {
            configurable: true,
            set (ticker) {
                if (this._ticker) this._ticker.remove(this.render, this);
                this._ticker = ticker;
                if (ticker) ticker.add(this.render, this, (0, $7iB5e.UPDATE_PRIORITY).LOW);
            },
            get () {
                return this._ticker;
            }
        });
        this.stop = ()=>{
            this._ticker.stop();
        };
        this.start = ()=>{
            this._ticker.start();
        };
        this._ticker = null;
        this.ticker = options.sharedTicker ? (0, $lcv0T.Ticker).shared : new (0, $lcv0T.Ticker)();
        if (options.autoStart) this.start();
    }
    /**
   * Clean up the ticker, scoped to application.
   * @private
   */ static destroy() {
        if (this._ticker) {
            const oldTicker = this._ticker;
            this.ticker = null;
            oldTicker.destroy();
        }
    }
}
/** @ignore */ $37a621c7c36d1522$export$50c361ceb4e2f4f0.extension = (0, $aBhlC.ExtensionType).Application;


"use strict";
(0, $aBhlC.extensions).add((0, $5a029ee4d6d2b4eb$export$6453cd852defe94a));
(0, $aBhlC.extensions).add((0, $37a621c7c36d1522$export$50c361ceb4e2f4f0));


"use strict";
const $0828be36c1b794ea$var$_Application = class _Application {
    constructor(...args){
        /**
     * The root display container for your application.
     * All visual elements should be added to this container or its children.
     * @example
     * ```js
     * // Create a sprite and add it to the stage
     * const sprite = Sprite.from('image.png');
     * app.stage.addChild(sprite);
     *
     * // Create a container for grouping objects
     * const container = new Container();
     * app.stage.addChild(container);
     * ```
     */ this.stage = new (0, $5Wp7K.Container)();
        if (args[0] !== void 0) (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "Application constructor options are deprecated, please use Application.init() instead.");
    }
    /**
   * Initializes the PixiJS application with the specified options.
   *
   * This method must be called after creating a new Application instance.
   * @param options - Configuration options for the application and renderer
   * @returns A promise that resolves when initialization is complete
   * @example
   * ```js
   * const app = new Application();
   *
   * // Initialize with custom options
   * await app.init({
   *     width: 800,
   *     height: 600,
   *     backgroundColor: 0x1099bb,
   *     preference: 'webgl', // or 'webgpu'
   * });
   * ```
   */ async init(options) {
        options = {
            ...options
        };
        this.stage || (this.stage = new (0, $5Wp7K.Container)());
        this.renderer = await (0, $94edf3028d07db77$export$3583b92ab8150eb6)(options);
        _Application._plugins.forEach((plugin)=>{
            plugin.init.call(this, options);
        });
    }
    /**
   * Renders the current stage to the screen.
   *
   * When using the default setup with {@link TickerPlugin} (enabled by default), you typically don't need to call
   * this method directly as rendering is handled automatically.
   *
   * Only use this method if you've disabled the {@link TickerPlugin} or need custom
   * render timing control.
   * @example
   * ```js
   * // Example 1: Default setup (TickerPlugin handles rendering)
   * const app = new Application();
   * await app.init();
   * // No need to call render() - TickerPlugin handles it
   *
   * // Example 2: Custom rendering loop (if TickerPlugin is disabled)
   * const app = new Application();
   * await app.init({ autoStart: false }); // Disable automatic rendering
   *
   * function animate() {
   *     app.render();
   *     requestAnimationFrame(animate);
   * }
   * animate();
   * ```
   */ render() {
        this.renderer.render({
            container: this.stage
        });
    }
    /**
   * Reference to the renderer's canvas element. This is the HTML element
   * that displays your application's graphics.
   * @readonly
   * @type {HTMLCanvasElement}
   * @example
   * ```js
   * // Create a new application
   * const app = new Application();
   * // Initialize the application
   * await app.init({...});
   * // Add canvas to the page
   * document.body.appendChild(app.canvas);
   *
   * // Access the canvas directly
   * console.log(app.canvas); // HTMLCanvasElement
   * ```
   */ get canvas() {
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's canvas element.
   * @type {HTMLCanvasElement}
   * @deprecated since 8.0.0
   * @see {@link Application#canvas}
   */ get view() {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "Application.view is deprecated, please use Application.canvas instead.");
        return this.renderer.canvas;
    }
    /**
   * Reference to the renderer's screen rectangle. This represents the visible area of your application.
   *
   * It's commonly used for:
   * - Setting filter areas for full-screen effects
   * - Defining hit areas for screen-wide interaction
   * - Determining the visible bounds of your application
   * @readonly
   * @example
   * ```js
   * // Use as filter area for a full-screen effect
   * const blurFilter = new BlurFilter();
   * sprite.filterArea = app.screen;
   *
   * // Use as hit area for screen-wide interaction
   * const screenSprite = new Sprite();
   * screenSprite.hitArea = app.screen;
   *
   * // Get screen dimensions
   * console.log(app.screen.width, app.screen.height);
   * ```
   * @see {@link Rectangle} For all available properties and methods
   */ get screen() {
        return this.renderer.screen;
    }
    /**
   * Get the html div element that holds all DOM Container elements.
   * @readonly
   * @type {HTMLDivElement}
   */ get domContainerRoot() {
        return this.renderer.renderPipes.dom?._domElement;
    }
    /**
   * Destroys the application and all of its resources.
   *
   * This method should be called when you want to completely
   * clean up the application and free all associated memory.
   * @param rendererDestroyOptions - Options for destroying the renderer:
   *  - `false` or `undefined`: Preserves the canvas element (default)
   *  - `true`: Removes the canvas element
   *  - `{ removeView: boolean }`: Object with removeView property to control canvas removal
   * @param options - Options for destroying the application:
   *  - `false` or `undefined`: Basic cleanup (default)
   *  - `true`: Complete cleanup including children
   *  - Detailed options object:
   *    - `children`: Remove children
   *    - `texture`: Destroy textures
   *    - `textureSource`: Destroy texture sources
   *    - `context`: Destroy WebGL context
   * @example
   * ```js
   * // Basic cleanup
   * app.destroy();
   *
   * // Remove canvas and do complete cleanup
   * app.destroy(true, true);
   *
   * // Remove canvas with explicit options
   * app.destroy({ removeView: true }, true);
   *
   * // Detailed cleanup with specific options
   * app.destroy(
   *     { removeView: true },
   *     {
   *         children: true,
   *         texture: true,
   *         textureSource: true,
   *         context: true
   *     }
   * );
   * ```
   * > [!WARNING] After calling destroy, the application instance should no longer be used.
   * > All properties will be null and further operations will throw errors.
   */ destroy(rendererDestroyOptions = false, options = false) {
        const plugins = _Application._plugins.slice(0);
        plugins.reverse();
        plugins.forEach((plugin)=>{
            plugin.destroy.call(this);
        });
        this.stage.destroy(options);
        this.stage = null;
        this.renderer.destroy(rendererDestroyOptions);
        this.renderer = null;
    }
};
/**
 * Collection of installed plugins.
 * @internal
 */ $0828be36c1b794ea$var$_Application._plugins = [];
let $0828be36c1b794ea$export$16975c34e60e1e61 = $0828be36c1b794ea$var$_Application;
(0, $aBhlC.extensions).handleByList((0, $aBhlC.ExtensionType).Application, $0828be36c1b794ea$export$16975c34e60e1e61._plugins);
(0, $aBhlC.extensions).add((0, $k73MA.ApplicationInitHook));





























































































































var $lwGvb = parcelRequire("lwGvb");





var $kNl9L = parcelRequire("kNl9L");




























































































































































































































var $ejgnR = parcelRequire("ejgnR");

























var $5Wp7K = parcelRequire("5Wp7K");







































var $bcTIE = parcelRequire("bcTIE");




























































































































var $gl1XZ = parcelRequire("gl1XZ");

var $ju4z4 = parcelRequire("ju4z4");

var $2sdBn = parcelRequire("2sdBn");

var $dXBy0 = parcelRequire("dXBy0");

var $aHyJR = parcelRequire("aHyJR");
"use strict";
class $b087d7baf1b2c902$export$daf74670712de91 extends (0, $aHyJR.ViewContainer) {
    constructor(options, styleClass){
        const { text: text, resolution: resolution, style: style, anchor: anchor, width: width, height: height, roundPixels: roundPixels, ...rest } = options;
        super({
            ...rest
        });
        /** @internal */ this.batched = true;
        /** @internal */ this._resolution = null;
        /** @internal */ this._autoResolution = true;
        /** @internal */ this._didTextUpdate = true;
        this._styleClass = styleClass;
        this.text = text ?? "";
        this.style = style;
        this.resolution = resolution ?? null;
        this.allowChildren = false;
        this._anchor = new (0, $2sdBn.ObservablePoint)({
            _onUpdate: ()=>{
                this.onViewUpdate();
            }
        });
        if (anchor) this.anchor = anchor;
        this.roundPixels = roundPixels ?? false;
        if (width !== void 0) this.width = width;
        if (height !== void 0) this.height = height;
    }
    /**
   * The anchor point of the text that controls the origin point for positioning and rotation.
   * Can be a number (same value for x/y) or a PointData object.
   * - (0,0) is top-left
   * - (0.5,0.5) is center
   * - (1,1) is bottom-right
   * ```ts
   * // Set anchor to center
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: 0.5 // Same as { x: 0.5, y: 0.5 }
   * });
   * // Set anchor to top-left
   * const text2 = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: { x: 0, y: 0 } // Top-left corner
   * });
   * // Set anchor to bottom-right
   * const text3 = new Text({
   *     text: 'Hello Pixi!',
   *     anchor: { x: 1, y: 1 } // Bottom-right corner
   * });
   * ```
   * @default { x: 0, y: 0 }
   */ get anchor() {
        return this._anchor;
    }
    set anchor(value) {
        typeof value === "number" ? this._anchor.set(value) : this._anchor.copyFrom(value);
    }
    /**
   * The text content to display. Use '\n' for line breaks.
   * Accepts strings, numbers, or objects with toString() method.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Hello Pixi!',
   * });
   * const multilineText = new Text({
   *     text: 'Line 1\nLine 2\nLine 3',
   * });
   * const numberText = new Text({
   *     text: 12345, // Will be converted to '12345'
   * });
   * const objectText = new Text({
   *     text: { toString: () => 'Object Text' }, // Custom toString
   * });
   *
   * // Update text dynamically
   * text.text = 'Updated Text'; // Re-renders with new text
   * text.text = 67890; // Updates to '67890'
   * text.text = { toString: () => 'Dynamic Text' }; // Uses custom toString method
   * // Clear text
   * text.text = ''; // Clears the text
   * ```
   * @default ''
   */ set text(value) {
        value = value.toString();
        if (this._text === value) return;
        this._text = value;
        this.onViewUpdate();
    }
    get text() {
        return this._text;
    }
    /**
   * The resolution/device pixel ratio for rendering.
   * Higher values result in sharper text at the cost of performance.
   * Set to null for auto-resolution based on device.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     resolution: 2 // High DPI for sharper text
   * });
   * const autoResText = new Text({
   *     text: 'Auto Resolution',
   *     resolution: null // Use device's pixel ratio
   * });
   * ```
   * @default null
   */ set resolution(value) {
        this._autoResolution = value === null;
        this._resolution = value;
        this.onViewUpdate();
    }
    get resolution() {
        return this._resolution;
    }
    get style() {
        return this._style;
    }
    /**
   * The style configuration for the text.
   * Can be a TextStyle instance or a configuration object.
   * Supports canvas text styles, HTML text styles, and bitmap text styles.
   * @example
   * ```ts
   * const text = new Text({
   *     text: 'Styled Text',
   *     style: {
   *         fontSize: 24,
   *         fill: 0xff1010, // Red color
   *         fontFamily: 'Arial',
   *         align: 'center', // Center alignment
   *         stroke: { color: '#4a1850', width: 5 }, // Purple stroke
   *         dropShadow: {
   *             color: '#000000', // Black shadow
   *             blur: 4, // Shadow blur
   *             distance: 6 // Shadow distance
   *         }
   *     }
   * });
   * const htmlText = new HTMLText({
   *     text: 'HTML Styled Text',
   *     style: {
   *         fontSize: '20px',
   *         fill: 'blue',
   *         fontFamily: 'Verdana',
   *     }
   * });
   * const bitmapText = new BitmapText({
   *     text: 'Bitmap Styled Text',
   *     style: {
   *         fontName: 'Arial',
   *         fontSize: 32,
   *     }
   * })
   *
   * // Update style dynamically
   * text.style = {
   *     fontSize: 30, // Change font size
   *     fill: 0x00ff00, // Change color to green
   *     align: 'right', // Change alignment to right
   *     stroke: { color: '#000000', width: 2 }, // Add black stroke
   * }
   */ set style(style) {
        style || (style = {});
        this._style?.off("update", this.onViewUpdate, this);
        if (style instanceof this._styleClass) this._style = style;
        else this._style = new this._styleClass(style);
        this._style.on("update", this.onViewUpdate, this);
        this.onViewUpdate();
    }
    /**
   * The width of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set width directly
   * texture.width = 200;
   * console.log(texture.scale.x); // Scale adjusted to match width
   *
   * // For better performance when setting both width and height
   * texture.setSize(300, 400); // Avoids recalculating bounds twice
   * ```
   */ get width() {
        return Math.abs(this.scale.x) * this.bounds.width;
    }
    set width(value) {
        this._setWidth(value, this.bounds.width);
    }
    /**
   * The height of the sprite, setting this will actually modify the scale to achieve the value set.
   * @example
   * ```ts
   * // Set height directly
   * texture.height = 200;
   * console.log(texture.scale.y); // Scale adjusted to match height
   *
   * // For better performance when setting both width and height
   * texture.setSize(300, 400); // Avoids recalculating bounds twice
   * ```
   */ get height() {
        return Math.abs(this.scale.y) * this.bounds.height;
    }
    set height(value) {
        this._setHeight(value, this.bounds.height);
    }
    /**
   * Retrieves the size of the Text as a [Size]{@link Size} object based on the texture dimensions and scale.
   * This is faster than getting width and height separately as it only calculates the bounds once.
   * @example
   * ```ts
   * // Basic size retrieval
   * const text = new Text({
   *     text: 'Hello Pixi!',
   *     style: { fontSize: 24 }
   * });
   * const size = text.getSize();
   * console.log(`Size: ${size.width}x${size.height}`);
   *
   * // Reuse existing size object
   * const reuseSize = { width: 0, height: 0 };
   * text.getSize(reuseSize);
   * ```
   * @param out - Optional object to store the size in, to avoid allocating a new object
   * @returns The size of the Sprite
   * @see {@link Text#width} For getting just the width
   * @see {@link Text#height} For getting just the height
   * @see {@link Text#setSize} For setting both width and height
   */ getSize(out) {
        out || (out = {});
        out.width = Math.abs(this.scale.x) * this.bounds.width;
        out.height = Math.abs(this.scale.y) * this.bounds.height;
        return out;
    }
    /**
   * Sets the size of the Text to the specified width and height.
   * This is faster than setting width and height separately as it only recalculates bounds once.
   * @example
   * ```ts
   * // Basic size setting
   * const text = new Text({
   *    text: 'Hello Pixi!',
   *    style: { fontSize: 24 }
   * });
   * text.setSize(100, 200); // Width: 100, Height: 200
   *
   * // Set uniform size
   * text.setSize(100); // Sets both width and height to 100
   *
   * // Set size with object
   * text.setSize({
   *     width: 200,
   *     height: 300
   * });
   * ```
   * @param value - This can be either a number or a {@link Size} object
   * @param height - The height to set. Defaults to the value of `width` if not provided
   * @see {@link Text#width} For setting width only
   * @see {@link Text#height} For setting height only
   */ setSize(value, height) {
        if (typeof value === "object") {
            height = value.height ?? value.width;
            value = value.width;
        } else height ?? (height = value);
        value !== void 0 && this._setWidth(value, this.bounds.width);
        height !== void 0 && this._setHeight(height, this.bounds.height);
    }
    /**
   * Checks if the object contains the given point in local coordinates.
   * Uses the text's bounds for hit testing.
   * @example
   * ```ts
   * // Basic point check
   * const localPoint = { x: 50, y: 25 };
   * const contains = text.containsPoint(localPoint);
   * console.log('Point is inside:', contains);
   * ```
   * @param point - The point to check in local coordinates
   * @returns True if the point is within the text's bounds
   * @see {@link Container#toLocal} For converting global coordinates to local
   */ containsPoint(point) {
        const width = this.bounds.width;
        const height = this.bounds.height;
        const x1 = -width * this.anchor.x;
        let y1 = 0;
        if (point.x >= x1 && point.x <= x1 + width) {
            y1 = -height * this.anchor.y;
            if (point.y >= y1 && point.y <= y1 + height) return true;
        }
        return false;
    }
    /** @internal */ onViewUpdate() {
        if (!this.didViewUpdate) this._didTextUpdate = true;
        super.onViewUpdate();
    }
    /**
   * Destroys this text renderable and optionally its style texture.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * // Destroys the text and its style
   * text.destroy({ style: true, texture: true, textureSource: true });
   * text.destroy(true);
   * text.destroy() // Destroys the text, but not its style
   */ destroy(options = false) {
        super.destroy(options);
        this.owner = null;
        this._bounds = null;
        this._anchor = null;
        if (typeof options === "boolean" ? options : options?.style) this._style.destroy(options);
        this._style = null;
        this._text = null;
    }
    /**
   * Returns a unique key for this instance.
   * This key is used for caching.
   * @returns {string} Unique key for the instance
   */ get styleKey() {
        return `${this._text}:${this._style.styleKey}:${this._resolution}`;
    }
}
function $b087d7baf1b2c902$export$8ddfb4f614f8ed86(args, name) {
    let options = args[0] ?? {};
    if (typeof options === "string" || args[1]) {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), `use new ${name}({ text: "hi!", style }) instead`);
        options = {
            text: options,
            style: args[1]
        };
    }
    return options;
}



var $jr7Dg = parcelRequire("jr7Dg");

var $kNl9L = parcelRequire("kNl9L");

var $jcSXK = parcelRequire("jcSXK");

var $dHliN = parcelRequire("dHliN");

var $2CXjJ = parcelRequire("2CXjJ");

var $kNl9L = parcelRequire("kNl9L");
"use strict";
let $c4217ac1a6a14d41$var$_internalCanvas = null;
let $c4217ac1a6a14d41$var$_internalContext = null;
function $c4217ac1a6a14d41$var$ensureInternalCanvas(width, height) {
    if (!$c4217ac1a6a14d41$var$_internalCanvas) {
        $c4217ac1a6a14d41$var$_internalCanvas = (0, $dHliN.DOMAdapter).get().createCanvas(256, 128);
        $c4217ac1a6a14d41$var$_internalContext = $c4217ac1a6a14d41$var$_internalCanvas.getContext("2d", {
            willReadFrequently: true
        });
        $c4217ac1a6a14d41$var$_internalContext.globalCompositeOperation = "copy";
        $c4217ac1a6a14d41$var$_internalContext.globalAlpha = 1;
    }
    if ($c4217ac1a6a14d41$var$_internalCanvas.width < width || $c4217ac1a6a14d41$var$_internalCanvas.height < height) {
        $c4217ac1a6a14d41$var$_internalCanvas.width = (0, $2CXjJ.nextPow2)(width);
        $c4217ac1a6a14d41$var$_internalCanvas.height = (0, $2CXjJ.nextPow2)(height);
    }
}
function $c4217ac1a6a14d41$var$checkRow(data, width, y) {
    for(let x = 0, index = 4 * y * width; x < width; ++x, index += 4){
        if (data[index + 3] !== 0) return false;
    }
    return true;
}
function $c4217ac1a6a14d41$var$checkColumn(data, width, x, top, bottom) {
    const stride = 4 * width;
    for(let y = top, index = top * stride + 4 * x; y <= bottom; ++y, index += stride){
        if (data[index + 3] !== 0) return false;
    }
    return true;
}
function $c4217ac1a6a14d41$export$550eedf6c679837d(...args) {
    let options = args[0];
    if (!options.canvas) options = {
        canvas: args[0],
        resolution: args[1]
    };
    const { canvas: canvas } = options;
    const resolution = Math.min(options.resolution ?? 1, 1);
    const width = options.width ?? canvas.width;
    const height = options.height ?? canvas.height;
    let output = options.output;
    $c4217ac1a6a14d41$var$ensureInternalCanvas(width, height);
    if (!$c4217ac1a6a14d41$var$_internalContext) throw new TypeError("Failed to get canvas 2D context");
    $c4217ac1a6a14d41$var$_internalContext.drawImage(canvas, 0, 0, width, height, 0, 0, width * resolution, height * resolution);
    const imageData = $c4217ac1a6a14d41$var$_internalContext.getImageData(0, 0, width, height);
    const data = imageData.data;
    let left = 0;
    let top = 0;
    let right = width - 1;
    let bottom = height - 1;
    while(top < height && $c4217ac1a6a14d41$var$checkRow(data, width, top))++top;
    if (top === height) return (0, $kNl9L.Rectangle).EMPTY;
    while($c4217ac1a6a14d41$var$checkRow(data, width, bottom))--bottom;
    while($c4217ac1a6a14d41$var$checkColumn(data, width, left, top, bottom))++left;
    while($c4217ac1a6a14d41$var$checkColumn(data, width, right, top, bottom))--right;
    ++right;
    ++bottom;
    $c4217ac1a6a14d41$var$_internalContext.globalCompositeOperation = "source-over";
    $c4217ac1a6a14d41$var$_internalContext.strokeRect(left, top, right - left, bottom - top);
    $c4217ac1a6a14d41$var$_internalContext.globalCompositeOperation = "copy";
    output ?? (output = new (0, $kNl9L.Rectangle)());
    output.set(left / resolution, top / resolution, (right - left) / resolution, (bottom - top) / resolution);
    return output;
}


/**
 * tiny-lru
 *
 * @copyright 2026 Jason Mulligan <jason.mulligan@avoidwork.com>
 * @license BSD-3-Clause
 * @version 11.4.7
 */ var $efe7ca9bd0d801a6$export$ca3ab3d175dec122;
var $efe7ca9bd0d801a6$export$64e09406e6c5de88;
'use strict';
/**
 * A high-performance Least Recently Used (LRU) cache implementation with optional TTL support.
 * Items are automatically evicted when the cache reaches its maximum size,
 * removing the least recently used items first. All core operations (get, set, delete) are O(1).
 *
 * @class LRU
 * @example
 * // Create a cache with max 100 items
 * const cache = new LRU(100);
 * cache.set('key1', 'value1');
 * console.log(cache.get('key1')); // 'value1'
 *
 * @example
 * // Create a cache with TTL
 * const cache = new LRU(100, 5000); // 5 second TTL
 * cache.set('key1', 'value1');
 * // After 5 seconds, key1 will be expired
 */ class $efe7ca9bd0d801a6$var$LRU {
    /**
	 * Creates a new LRU cache instance.
	 * Note: Constructor does not validate parameters. Use lru() factory function for parameter validation.
	 *
	 * @constructor
	 * @param {number} [max=0] - Maximum number of items to store. 0 means unlimited.
	 * @param {number} [ttl=0] - Time to live in milliseconds. 0 means no expiration.
	 * @param {boolean} [resetTtl=false] - Whether to reset TTL when accessing existing items via get().
	 * @example
	 * const cache = new LRU(1000, 60000, true); // 1000 items, 1 minute TTL, reset on access
	 * @see {@link lru} For parameter validation
	 * @since 1.0.0
	 */ constructor(max = 0, ttl = 0, resetTtl = false){
        this.first = null;
        this.items = Object.create(null);
        this.last = null;
        this.max = max;
        this.resetTtl = resetTtl;
        this.size = 0;
        this.ttl = ttl;
    }
    /**
	 * Removes all items from the cache.
	 *
	 * @method clear
	 * @memberof LRU
	 * @returns {LRU} The LRU instance for method chaining.
	 * @example
	 * cache.clear();
	 * console.log(cache.size); // 0
	 * @since 1.0.0
	 */ clear() {
        this.first = null;
        this.items = Object.create(null);
        this.last = null;
        this.size = 0;
        return this;
    }
    /**
	 * Removes an item from the cache by key.
	 *
	 * @method delete
	 * @memberof LRU
	 * @param {string} key - The key of the item to delete.
	 * @returns {LRU} The LRU instance for method chaining.
	 * @example
	 * cache.set('key1', 'value1');
	 * cache.delete('key1');
	 * console.log(cache.has('key1')); // false
	 * @see {@link LRU#has}
	 * @see {@link LRU#clear}
	 * @since 1.0.0
	 */ delete(key) {
        if (this.has(key)) {
            const item = this.items[key];
            delete this.items[key];
            this.size--;
            if (item.prev !== null) item.prev.next = item.next;
            if (item.next !== null) item.next.prev = item.prev;
            if (this.first === item) this.first = item.next;
            if (this.last === item) this.last = item.prev;
        }
        return this;
    }
    /**
	 * Returns an array of [key, value] pairs for the specified keys.
	 * Order follows LRU order (least to most recently used).
	 *
	 * @method entries
	 * @memberof LRU
	 * @param {string[]} [keys=this.keys()] - Array of keys to get entries for. Defaults to all keys.
	 * @returns {Array<Array<*>>} Array of [key, value] pairs in LRU order.
	 * @example
	 * cache.set('a', 1).set('b', 2);
	 * console.log(cache.entries()); // [['a', 1], ['b', 2]]
	 * console.log(cache.entries(['a'])); // [['a', 1]]
	 * @see {@link LRU#keys}
	 * @see {@link LRU#values}
	 * @since 11.1.0
	 */ entries(keys = this.keys()) {
        const result = new Array(keys.length);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            result[i] = [
                key,
                this.get(key)
            ];
        }
        return result;
    }
    /**
	 * Removes the least recently used item from the cache.
	 *
	 * @method evict
	 * @memberof LRU
	 * @param {boolean} [bypass=false] - Whether to force eviction even when cache is empty.
	 * @returns {LRU} The LRU instance for method chaining.
	 * @example
	 * cache.set('old', 'value').set('new', 'value');
	 * cache.evict(); // Removes 'old' item
	 * @see {@link LRU#setWithEvicted}
	 * @since 1.0.0
	 */ evict(bypass = false) {
        if (bypass || this.size > 0) {
            const item = this.first;
            delete this.items[item.key];
            if (--this.size === 0) {
                this.first = null;
                this.last = null;
            } else {
                this.first = item.next;
                this.first.prev = null;
            }
        }
        return this;
    }
    /**
	 * Returns the expiration timestamp for a given key.
	 *
	 * @method expiresAt
	 * @memberof LRU
	 * @param {string} key - The key to check expiration for.
	 * @returns {number|undefined} The expiration timestamp in milliseconds, or undefined if key doesn't exist.
	 * @example
	 * const cache = new LRU(100, 5000); // 5 second TTL
	 * cache.set('key1', 'value1');
	 * console.log(cache.expiresAt('key1')); // timestamp 5 seconds from now
	 * @see {@link LRU#get}
	 * @see {@link LRU#has}
	 * @since 1.0.0
	 */ expiresAt(key) {
        let result;
        if (this.has(key)) result = this.items[key].expiry;
        return result;
    }
    /**
	 * Retrieves a value from the cache by key. Updates the item's position to most recently used.
	 *
	 * @method get
	 * @memberof LRU
	 * @param {string} key - The key to retrieve.
	 * @returns {*} The value associated with the key, or undefined if not found or expired.
	 * @example
	 * cache.set('key1', 'value1');
	 * console.log(cache.get('key1')); // 'value1'
	 * console.log(cache.get('nonexistent')); // undefined
	 * @see {@link LRU#set}
	 * @see {@link LRU#has}
	 * @since 1.0.0
	 */ get(key) {
        const item = this.items[key];
        if (item !== undefined) {
            // Check TTL only if enabled to avoid unnecessary Date.now() calls
            if (this.ttl > 0) {
                if (item.expiry <= Date.now()) {
                    this.delete(key);
                    return undefined;
                }
            }
            // Fast LRU update without full set() overhead
            this.moveToEnd(item);
            return item.value;
        }
        return undefined;
    }
    /**
	 * Checks if a key exists in the cache.
	 *
	 * @method has
	 * @memberof LRU
	 * @param {string} key - The key to check for.
	 * @returns {boolean} True if the key exists, false otherwise.
	 * @example
	 * cache.set('key1', 'value1');
	 * console.log(cache.has('key1')); // true
	 * console.log(cache.has('nonexistent')); // false
	 * @see {@link LRU#get}
	 * @see {@link LRU#delete}
	 * @since 9.0.0
	 */ has(key) {
        return key in this.items;
    }
    /**
	 * Efficiently moves an item to the end of the LRU list (most recently used position).
	 * This is an internal optimization method that avoids the overhead of the full set() operation
	 * when only LRU position needs to be updated.
	 *
	 * @method moveToEnd
	 * @memberof LRU
	 * @param {Object} item - The cache item with prev/next pointers to reposition.
	 * @private
	 * @since 11.3.5
	 */ moveToEnd(item) {
        // If already at the end, nothing to do
        if (this.last === item) return;
        // Remove item from current position in the list
        if (item.prev !== null) item.prev.next = item.next;
        if (item.next !== null) item.next.prev = item.prev;
        // Update first pointer if this was the first item
        if (this.first === item) this.first = item.next;
        // Add item to the end
        item.prev = this.last;
        item.next = null;
        if (this.last !== null) this.last.next = item;
        this.last = item;
        // Handle edge case: if this was the only item, it's also first
        if (this.first === null) this.first = item;
    }
    /**
	 * Returns an array of all keys in the cache, ordered from least to most recently used.
	 *
	 * @method keys
	 * @memberof LRU
	 * @returns {string[]} Array of keys in LRU order.
	 * @example
	 * cache.set('a', 1).set('b', 2);
	 * cache.get('a'); // Move 'a' to most recent
	 * console.log(cache.keys()); // ['b', 'a']
	 * @see {@link LRU#values}
	 * @see {@link LRU#entries}
	 * @since 9.0.0
	 */ keys() {
        const result = new Array(this.size);
        let x = this.first;
        let i = 0;
        while(x !== null){
            result[i++] = x.key;
            x = x.next;
        }
        return result;
    }
    /**
	 * Sets a value in the cache and returns any evicted item.
	 *
	 * @method setWithEvicted
	 * @memberof LRU
	 * @param {string} key - The key to set.
	 * @param {*} value - The value to store.
	 * @param {boolean} [resetTtl=this.resetTtl] - Whether to reset the TTL for this operation.
	 * @returns {Object|null} The evicted item (if any) with shape {key, value, expiry, prev, next}, or null.
	 * @example
	 * const cache = new LRU(2);
	 * cache.set('a', 1).set('b', 2);
	 * const evicted = cache.setWithEvicted('c', 3); // evicted = {key: 'a', value: 1, ...}
	 * @see {@link LRU#set}
	 * @see {@link LRU#evict}
	 * @since 11.3.0
	 */ setWithEvicted(key, value, resetTtl = this.resetTtl) {
        let evicted = null;
        if (this.has(key)) this.set(key, value, true, resetTtl);
        else {
            if (this.max > 0 && this.size === this.max) {
                evicted = {
                    ...this.first
                };
                this.evict(true);
            }
            let item = this.items[key] = {
                expiry: this.ttl > 0 ? Date.now() + this.ttl : this.ttl,
                key: key,
                prev: this.last,
                next: null,
                value: value
            };
            if (++this.size === 1) this.first = item;
            else this.last.next = item;
            this.last = item;
        }
        return evicted;
    }
    /**
	 * Sets a value in the cache. Updates the item's position to most recently used.
	 *
	 * @method set
	 * @memberof LRU
	 * @param {string} key - The key to set.
	 * @param {*} value - The value to store.
	 * @param {boolean} [bypass=false] - Internal parameter for setWithEvicted method.
	 * @param {boolean} [resetTtl=this.resetTtl] - Whether to reset the TTL for this operation.
	 * @returns {LRU} The LRU instance for method chaining.
	 * @example
	 * cache.set('key1', 'value1')
	 *      .set('key2', 'value2')
	 *      .set('key3', 'value3');
	 * @see {@link LRU#get}
	 * @see {@link LRU#setWithEvicted}
	 * @since 1.0.0
	 */ set(key, value, bypass = false, resetTtl = this.resetTtl) {
        let item = this.items[key];
        if (bypass || item !== undefined) {
            // Existing item: update value and position
            item.value = value;
            if (bypass === false && resetTtl) item.expiry = this.ttl > 0 ? Date.now() + this.ttl : this.ttl;
            // Always move to end, but the bypass parameter affects TTL reset behavior
            this.moveToEnd(item);
        } else {
            // New item: check for eviction and create
            if (this.max > 0 && this.size === this.max) this.evict(true);
            item = this.items[key] = {
                expiry: this.ttl > 0 ? Date.now() + this.ttl : this.ttl,
                key: key,
                prev: this.last,
                next: null,
                value: value
            };
            if (++this.size === 1) this.first = item;
            else this.last.next = item;
            this.last = item;
        }
        return this;
    }
    /**
	 * Returns an array of all values in the cache for the specified keys.
	 * Order follows LRU order (least to most recently used).
	 *
	 * @method values
	 * @memberof LRU
	 * @param {string[]} [keys=this.keys()] - Array of keys to get values for. Defaults to all keys.
	 * @returns {Array<*>} Array of values corresponding to the keys in LRU order.
	 * @example
	 * cache.set('a', 1).set('b', 2);
	 * console.log(cache.values()); // [1, 2]
	 * console.log(cache.values(['a'])); // [1]
	 * @see {@link LRU#keys}
	 * @see {@link LRU#entries}
	 * @since 11.1.0
	 */ values(keys = this.keys()) {
        const result = new Array(keys.length);
        for(let i = 0; i < keys.length; i++)result[i] = this.get(keys[i]);
        return result;
    }
}
/**
 * Factory function to create a new LRU cache instance with parameter validation.
 *
 * @function lru
 * @param {number} [max=1000] - Maximum number of items to store. Must be >= 0. Use 0 for unlimited size.
 * @param {number} [ttl=0] - Time to live in milliseconds. Must be >= 0. Use 0 for no expiration.
 * @param {boolean} [resetTtl=false] - Whether to reset TTL when accessing existing items via get().
 * @returns {LRU} A new LRU cache instance.
 * @throws {TypeError} When parameters are invalid (negative numbers or wrong types).
 * @example
 * // Create cache with factory function
 * const cache = lru(100, 5000, true);
 * cache.set('key', 'value');
 *
 * @example
 * // Error handling
 * try {
 *   const cache = lru(-1); // Invalid max
 * } catch (error) {
 *   console.error(error.message); // "Invalid max value"
 * }
 * @see {@link LRU}
 * @since 1.0.0
 */ function $efe7ca9bd0d801a6$var$lru(max = 1000, ttl = 0, resetTtl = false) {
    if (isNaN(max) || max < 0) throw new TypeError("Invalid max value");
    if (isNaN(ttl) || ttl < 0) throw new TypeError("Invalid ttl value");
    if (typeof resetTtl !== "boolean") throw new TypeError("Invalid resetTtl value");
    return new $efe7ca9bd0d801a6$var$LRU(max, ttl, resetTtl);
}
$efe7ca9bd0d801a6$export$ca3ab3d175dec122 = $efe7ca9bd0d801a6$var$LRU;
$efe7ca9bd0d801a6$export$64e09406e6c5de88 = $efe7ca9bd0d801a6$var$lru;



var $dHliN = parcelRequire("dHliN");
"use strict";
function $eb12674011bd078a$export$3c634ede7db41923(style) {
    return !!style.tagStyles && Object.keys(style.tagStyles).length > 0;
}
function $eb12674011bd078a$export$328893c99ad2af02(text) {
    return text.includes("<");
}
function $eb12674011bd078a$var$createMergedStyle(baseStyle, overrides) {
    return baseStyle.clone().assign(overrides);
}
function $eb12674011bd078a$export$9657ef3c3357e745(text, style) {
    const runs = [];
    const tagStyles = style.tagStyles;
    if (!$eb12674011bd078a$export$3c634ede7db41923(style) || !$eb12674011bd078a$export$328893c99ad2af02(text)) {
        runs.push({
            text: text,
            style: style
        });
        return runs;
    }
    const styleStack = [
        style
    ];
    const tagStack = [];
    let currentText = "";
    let i = 0;
    while(i < text.length){
        const char = text[i];
        if (char === "<") {
            const closeIndex = text.indexOf(">", i);
            if (closeIndex === -1) {
                currentText += char;
                i++;
                continue;
            }
            const nextOpenIndex = text.indexOf("<", i + 1);
            if (nextOpenIndex !== -1 && nextOpenIndex < closeIndex) {
                currentText += char;
                i++;
                continue;
            }
            const tagContent = text.slice(i + 1, closeIndex);
            if (tagContent.startsWith("/")) {
                const closingTagName = tagContent.slice(1).trim();
                if (tagStack.length > 0 && tagStack[tagStack.length - 1] === closingTagName) {
                    if (currentText.length > 0) {
                        runs.push({
                            text: currentText,
                            style: styleStack[styleStack.length - 1]
                        });
                        currentText = "";
                    }
                    styleStack.pop();
                    tagStack.pop();
                    i = closeIndex + 1;
                    continue;
                } else {
                    currentText += text.slice(i, closeIndex + 1);
                    i = closeIndex + 1;
                    continue;
                }
            } else {
                const tagName = tagContent.trim();
                if (tagStyles[tagName]) {
                    if (currentText.length > 0) {
                        runs.push({
                            text: currentText,
                            style: styleStack[styleStack.length - 1]
                        });
                        currentText = "";
                    }
                    const currentStyle = styleStack[styleStack.length - 1];
                    const mergedStyle = $eb12674011bd078a$var$createMergedStyle(currentStyle, tagStyles[tagName]);
                    styleStack.push(mergedStyle);
                    tagStack.push(tagName);
                    i = closeIndex + 1;
                    continue;
                } else {
                    currentText += text.slice(i, closeIndex + 1);
                    i = closeIndex + 1;
                    continue;
                }
            }
        } else {
            currentText += char;
            i++;
        }
    }
    if (currentText.length > 0) runs.push({
        text: currentText,
        style: styleStack[styleStack.length - 1]
    });
    return runs;
}
function $eb12674011bd078a$export$1afb3864a65b041b(text, style) {
    if (!$eb12674011bd078a$export$3c634ede7db41923(style) || !$eb12674011bd078a$export$328893c99ad2af02(text)) return text;
    const runs = $eb12674011bd078a$export$9657ef3c3357e745(text, style);
    return runs.map((run)=>run.text).join("");
}


"use strict";
const $b2a9fe7908a879f6$export$c5622f59bd0a84ab = [
    10,
    // line feed
    13
];
const $b2a9fe7908a879f6$export$46828130f2642f37 = new Set($b2a9fe7908a879f6$export$c5622f59bd0a84ab);
const $b2a9fe7908a879f6$export$82c4cde34833f6b6 = [
    9,
    // character tabulation
    32,
    // space
    8192,
    // en quad
    8193,
    // em quad
    8194,
    // en space
    8195,
    // em space
    8196,
    // three-per-em space
    8197,
    // four-per-em space
    8198,
    // six-per-em space
    8200,
    // punctuation space
    8201,
    // thin space
    8202,
    // hair space
    8287,
    // medium mathematical space
    12288
];
const $b2a9fe7908a879f6$export$a7210490df44ebce = new Set($b2a9fe7908a879f6$export$82c4cde34833f6b6);
const $b2a9fe7908a879f6$export$446c7e4d3041897d = [
    9,
    // character tabulation (tab)
    32
];
const $b2a9fe7908a879f6$export$dcd7f83d8608ff99 = new Set($b2a9fe7908a879f6$export$446c7e4d3041897d);
const $b2a9fe7908a879f6$export$980d468e56d3017f = [
    45,
    // hyphen-minus
    8208,
    // unicode hyphen
    8211,
    // en-dash
    8212,
    // em-dash
    173
];
const $b2a9fe7908a879f6$export$534c2cd4e4342d6e = new Set($b2a9fe7908a879f6$export$980d468e56d3017f);
const $b2a9fe7908a879f6$export$b396c635f7504541 = /(\r\n|\r|\n)/;
const $b2a9fe7908a879f6$export$e943b22311785337 = /(?:\r\n|\r|\n)/;
function $b2a9fe7908a879f6$export$c6b40e80adfef3ae(char) {
    if (typeof char !== "string") return false;
    return $b2a9fe7908a879f6$export$46828130f2642f37.has(char.charCodeAt(0));
}
function $b2a9fe7908a879f6$export$40e905615472e8e0(char, _nextChar) {
    if (typeof char !== "string") return false;
    return $b2a9fe7908a879f6$export$a7210490df44ebce.has(char.charCodeAt(0));
}
function $b2a9fe7908a879f6$export$a039ab2e304958a3(char) {
    if (typeof char !== "string") return false;
    return $b2a9fe7908a879f6$export$dcd7f83d8608ff99.has(char.charCodeAt(0));
}
function $b2a9fe7908a879f6$export$6bde8c60f7bc4d99(char) {
    if (typeof char !== "string") return false;
    return $b2a9fe7908a879f6$export$534c2cd4e4342d6e.has(char.charCodeAt(0));
}
function $b2a9fe7908a879f6$export$7070a8061037f71a(whiteSpace) {
    return whiteSpace === "normal" || whiteSpace === "pre-line";
}
function $b2a9fe7908a879f6$export$368cf1740b390323(whiteSpace) {
    return whiteSpace === "normal";
}
function $b2a9fe7908a879f6$export$da8e5da96e287379(text) {
    if (typeof text !== "string") return "";
    let i = text.length - 1;
    while(i >= 0 && $b2a9fe7908a879f6$export$40e905615472e8e0(text[i]))i--;
    return i < text.length - 1 ? text.slice(0, i + 1) : text;
}
function $b2a9fe7908a879f6$export$660b2ee2d4fb4eff(text) {
    const tokens = [];
    const tokenChars = [];
    if (typeof text !== "string") return tokens;
    for(let i = 0; i < text.length; i++){
        const char = text[i];
        const nextChar = text[i + 1];
        if ($b2a9fe7908a879f6$export$40e905615472e8e0(char, nextChar) || $b2a9fe7908a879f6$export$c6b40e80adfef3ae(char)) {
            if (tokenChars.length > 0) {
                tokens.push(tokenChars.join(""));
                tokenChars.length = 0;
            }
            if (char === "\r" && nextChar === "\n") {
                tokens.push("\r\n");
                i++;
            } else tokens.push(char);
            continue;
        }
        tokenChars.push(char);
        if ($b2a9fe7908a879f6$export$6bde8c60f7bc4d99(char) && nextChar && !$b2a9fe7908a879f6$export$40e905615472e8e0(nextChar) && !$b2a9fe7908a879f6$export$c6b40e80adfef3ae(nextChar)) {
            tokens.push(tokenChars.join(""));
            tokenChars.length = 0;
        }
    }
    if (tokenChars.length > 0) tokens.push(tokenChars.join(""));
    return tokens;
}
function $b2a9fe7908a879f6$export$8398461ec76ab549(token, breakWords, splitFn, canBreakCharsFn) {
    const characters = splitFn(token);
    const groups = [];
    for(let j = 0; j < characters.length; j++){
        let char = characters[j];
        let lastChar = char;
        let k = 1;
        while(characters[j + k]){
            const nextChar = characters[j + k];
            if (!canBreakCharsFn(lastChar, nextChar, token, j, breakWords)) {
                char += nextChar;
                lastChar = nextChar;
                k++;
            } else break;
        }
        j += k - 1;
        groups.push(char);
    }
    return groups;
}


"use strict";
const $2cfce11d73060562$var$NEWLINE_TO_SPACE_REGEX = /\r\n|\r|\n/g;
function $2cfce11d73060562$export$2c4cb70a2097cfee(text, style, wordWrap, context, measureTextFn, wrapMeasureTextFn, measureFontFn, canBreakCharsFn, wordWrapSplitFn) {
    const runs = (0, $eb12674011bd078a$export$9657ef3c3357e745)(text, style);
    const shouldCollapseNewlines = (0, $b2a9fe7908a879f6$export$368cf1740b390323)(style.whiteSpace);
    if (shouldCollapseNewlines) for(let i = 0; i < runs.length; i++){
        const run = runs[i];
        runs[i] = {
            text: run.text.replace($2cfce11d73060562$var$NEWLINE_TO_SPACE_REGEX, " "),
            style: run.style
        };
    }
    const runsByLine = [];
    let currentLineRuns = [];
    for (const run of runs){
        const parts = run.text.split((0, $b2a9fe7908a879f6$export$b396c635f7504541));
        for(let i = 0; i < parts.length; i++){
            const part = parts[i];
            if (part === "\r\n" || part === "\r" || part === "\n") {
                runsByLine.push(currentLineRuns);
                currentLineRuns = [];
            } else if (part.length > 0) currentLineRuns.push({
                text: part,
                style: run.style
            });
        }
    }
    if (currentLineRuns.length > 0 || runsByLine.length === 0) runsByLine.push(currentLineRuns);
    const wrappedRunsByLine = wordWrap ? $2cfce11d73060562$export$e01e4e8f2c8b304b(runsByLine, style, context, wrapMeasureTextFn, canBreakCharsFn, wordWrapSplitFn) : runsByLine;
    const lineWidths = [];
    const lineAscents = [];
    const lineDescents = [];
    const lineHeightsArr = [];
    const lines = [];
    let maxLineWidth = 0;
    const baseFont = style._fontString;
    const baseFontProps = measureFontFn(baseFont);
    if (baseFontProps.fontSize === 0) {
        baseFontProps.fontSize = style.fontSize;
        baseFontProps.ascent = style.fontSize;
    }
    let lastFont = "";
    let hasDropShadow = !!style.dropShadow;
    let maxRunStrokeWidth = style._stroke?.width || 0;
    for (const lineRuns of wrappedRunsByLine){
        let lineWidth = 0;
        let lineAscent = baseFontProps.ascent;
        let lineDescent = baseFontProps.descent;
        let lineText = "";
        for (const run of lineRuns){
            const runFont = run.style._fontString;
            const runFontProps = measureFontFn(runFont);
            if (runFont !== lastFont) {
                context.font = runFont;
                lastFont = runFont;
            }
            const runWidth = measureTextFn(run.text, run.style.letterSpacing, context);
            lineWidth += runWidth;
            lineAscent = Math.max(lineAscent, runFontProps.ascent);
            lineDescent = Math.max(lineDescent, runFontProps.descent);
            lineText += run.text;
            const runStrokeWidth = run.style._stroke?.width || 0;
            if (runStrokeWidth > maxRunStrokeWidth) maxRunStrokeWidth = runStrokeWidth;
            if (!hasDropShadow && run.style.dropShadow) hasDropShadow = true;
        }
        if (lineRuns.length === 0) {
            lineAscent = baseFontProps.ascent;
            lineDescent = baseFontProps.descent;
        }
        lineWidths.push(lineWidth);
        lineAscents.push(lineAscent);
        lineDescents.push(lineDescent);
        lines.push(lineText);
        const computedLineHeight = style.lineHeight || lineAscent + lineDescent;
        lineHeightsArr.push(computedLineHeight + style.leading);
        maxLineWidth = Math.max(maxLineWidth, lineWidth);
    }
    const strokeWidth = maxRunStrokeWidth;
    const width = maxLineWidth + strokeWidth + (style.dropShadow ? style.dropShadow.distance : 0);
    let baseHeight = 0;
    for(let i = 0; i < lineHeightsArr.length; i++)baseHeight += lineHeightsArr[i];
    baseHeight = Math.max(baseHeight, lineHeightsArr[0] + strokeWidth);
    const height = baseHeight + (style.dropShadow ? style.dropShadow.distance : 0);
    const baseLineHeight = style.lineHeight || baseFontProps.fontSize;
    return {
        width: width,
        height: height,
        lines: lines,
        lineWidths: lineWidths,
        lineHeight: baseLineHeight + style.leading,
        maxLineWidth: maxLineWidth,
        fontProperties: baseFontProps,
        runsByLine: wrappedRunsByLine,
        lineAscents: lineAscents,
        lineDescents: lineDescents,
        lineHeights: lineHeightsArr,
        hasDropShadow: hasDropShadow
    };
}
function $2cfce11d73060562$export$e01e4e8f2c8b304b(runsByLine, style, context, measureTextFn, canBreakCharsFn, wordWrapSplitFn) {
    const { letterSpacing: letterSpacing, whiteSpace: whiteSpace, wordWrapWidth: wordWrapWidth, breakWords: breakWords } = style;
    const shouldCollapseSpaces = (0, $b2a9fe7908a879f6$export$7070a8061037f71a)(whiteSpace);
    const adjustedWrapWidth = wordWrapWidth + letterSpacing;
    const tokenWidthCache = {};
    let lastFont = "";
    const measureTokenWidth = (token, tokenStyle)=>{
        const cacheKey = `${token}|${tokenStyle.styleKey}`;
        let width = tokenWidthCache[cacheKey];
        if (width === void 0) {
            const font = tokenStyle._fontString;
            if (font !== lastFont) {
                context.font = font;
                lastFont = font;
            }
            width = measureTextFn(token, tokenStyle.letterSpacing, context) + tokenStyle.letterSpacing;
            tokenWidthCache[cacheKey] = width;
        }
        return width;
    };
    const result = [];
    for (const lineRuns of runsByLine){
        const styledTokens = $2cfce11d73060562$export$7d01d70c6417df50(lineRuns);
        const resultStartLength = result.length;
        const getWordGroupWidth = (startIndex)=>{
            let totalWidth = 0;
            let j = startIndex;
            do {
                const { token: groupToken, style: groupStyle } = styledTokens[j];
                totalWidth += measureTokenWidth(groupToken, groupStyle);
                j++;
            }while (j < styledTokens.length && styledTokens[j].continuesFromPrevious);
            return totalWidth;
        };
        const getWordGroupTokens = (startIndex)=>{
            const tokens = [];
            let j = startIndex;
            do {
                tokens.push({
                    token: styledTokens[j].token,
                    style: styledTokens[j].style
                });
                j++;
            }while (j < styledTokens.length && styledTokens[j].continuesFromPrevious);
            return tokens;
        };
        let currentLineRuns = [];
        let currentWidth = 0;
        let canPrependSpaces = !shouldCollapseSpaces;
        let buildingRun = null;
        const flushBuildingRun = ()=>{
            if (buildingRun && buildingRun.text.length > 0) currentLineRuns.push(buildingRun);
            buildingRun = null;
        };
        const startNewLine = ()=>{
            flushBuildingRun();
            if (currentLineRuns.length > 0) {
                const lastRun = currentLineRuns[currentLineRuns.length - 1];
                lastRun.text = (0, $b2a9fe7908a879f6$export$da8e5da96e287379)(lastRun.text);
                if (lastRun.text.length === 0) currentLineRuns.pop();
            }
            result.push(currentLineRuns);
            currentLineRuns = [];
            currentWidth = 0;
            canPrependSpaces = false;
        };
        for(let i = 0; i < styledTokens.length; i++){
            const { token: token, style: tokenStyle, continuesFromPrevious: continuesFromPrevious } = styledTokens[i];
            const tokenWidth = measureTokenWidth(token, tokenStyle);
            if (shouldCollapseSpaces) {
                const currIsSpace = (0, $b2a9fe7908a879f6$export$40e905615472e8e0)(token);
                const lastChar = buildingRun?.text[buildingRun.text.length - 1] ?? currentLineRuns[currentLineRuns.length - 1]?.text.slice(-1) ?? "";
                const lastIsSpace = lastChar ? (0, $b2a9fe7908a879f6$export$40e905615472e8e0)(lastChar) : false;
                if (currIsSpace && lastIsSpace) continue;
            }
            const startsWordGroup = !continuesFromPrevious;
            const wordGroupWidth = startsWordGroup ? getWordGroupWidth(i) : tokenWidth;
            if (wordGroupWidth > adjustedWrapWidth && startsWordGroup) {
                if (currentWidth > 0) startNewLine();
                if (breakWords) {
                    const wordGroupTokens = getWordGroupTokens(i);
                    for(let g = 0; g < wordGroupTokens.length; g++){
                        const groupToken = wordGroupTokens[g].token;
                        const groupStyle = wordGroupTokens[g].style;
                        const charGroups = (0, $b2a9fe7908a879f6$export$8398461ec76ab549)(groupToken, breakWords, wordWrapSplitFn, canBreakCharsFn);
                        for (const char of charGroups){
                            const charWidth = measureTokenWidth(char, groupStyle);
                            if (charWidth + currentWidth > adjustedWrapWidth) startNewLine();
                            if (!buildingRun || buildingRun.style !== groupStyle) {
                                flushBuildingRun();
                                buildingRun = {
                                    text: char,
                                    style: groupStyle
                                };
                            } else buildingRun.text += char;
                            currentWidth += charWidth;
                        }
                    }
                    i += wordGroupTokens.length - 1;
                } else {
                    const wordGroupTokens = getWordGroupTokens(i);
                    flushBuildingRun();
                    result.push(wordGroupTokens.map((t)=>({
                            text: t.token,
                            style: t.style
                        })));
                    canPrependSpaces = false;
                    i += wordGroupTokens.length - 1;
                }
            } else if (wordGroupWidth + currentWidth > adjustedWrapWidth && startsWordGroup) {
                if ((0, $b2a9fe7908a879f6$export$40e905615472e8e0)(token)) {
                    canPrependSpaces = false;
                    continue;
                }
                startNewLine();
                buildingRun = {
                    text: token,
                    style: tokenStyle
                };
                currentWidth = tokenWidth;
            } else if (continuesFromPrevious && !breakWords) {
                if (!buildingRun || buildingRun.style !== tokenStyle) {
                    flushBuildingRun();
                    buildingRun = {
                        text: token,
                        style: tokenStyle
                    };
                } else buildingRun.text += token;
                currentWidth += tokenWidth;
            } else {
                const isSpace = (0, $b2a9fe7908a879f6$export$40e905615472e8e0)(token);
                if (currentWidth === 0 && isSpace && !canPrependSpaces) continue;
                if (!buildingRun || buildingRun.style !== tokenStyle) {
                    flushBuildingRun();
                    buildingRun = {
                        text: token,
                        style: tokenStyle
                    };
                } else buildingRun.text += token;
                currentWidth += tokenWidth;
            }
        }
        flushBuildingRun();
        if (currentLineRuns.length > 0) {
            const lastRun = currentLineRuns[currentLineRuns.length - 1];
            lastRun.text = (0, $b2a9fe7908a879f6$export$da8e5da96e287379)(lastRun.text);
            if (lastRun.text.length === 0) currentLineRuns.pop();
        }
        if (currentLineRuns.length > 0 || result.length === resultStartLength) result.push(currentLineRuns);
    }
    return result;
}
function $2cfce11d73060562$export$7d01d70c6417df50(runs) {
    const styledTokens = [];
    let lastTokenWasWord = false;
    for (const run of runs){
        const tokens = (0, $b2a9fe7908a879f6$export$660b2ee2d4fb4eff)(run.text);
        let isFirstTokenInRun = true;
        for (const token of tokens){
            const isSpace = (0, $b2a9fe7908a879f6$export$40e905615472e8e0)(token) || (0, $b2a9fe7908a879f6$export$c6b40e80adfef3ae)(token);
            const continuesFromPrevious = isFirstTokenInRun && lastTokenWasWord && !isSpace;
            styledTokens.push({
                token: token,
                style: run.style,
                continuesFromPrevious: continuesFromPrevious
            });
            lastTokenWasWord = !isSpace;
            isFirstTokenInRun = false;
        }
    }
    return styledTokens;
}





"use strict";
const $1b1620b77d029474$var$contextSettings = {
    // TextMetrics requires getImageData readback for measuring fonts.
    willReadFrequently: true
};
function $1b1620b77d029474$var$getFromCache(key, letterSpacing, cache, context, measureTextFn) {
    let width = cache[key];
    if (typeof width !== "number") {
        width = measureTextFn(key, letterSpacing, context) + letterSpacing;
        cache[key] = width;
    }
    return width;
}
function $1b1620b77d029474$export$dca3d8ad656c34d2(text, style, canvas, measureTextFn, canBreakWordsFn, canBreakCharsFn, wordWrapSplitFn) {
    const context = canvas.getContext("2d", $1b1620b77d029474$var$contextSettings);
    context.font = style._fontString;
    let width = 0;
    let line = "";
    const linesArray = [];
    const cache = /* @__PURE__ */ Object.create(null);
    const { letterSpacing: letterSpacing, whiteSpace: whiteSpace } = style;
    const shouldCollapseSpaces = (0, $b2a9fe7908a879f6$export$7070a8061037f71a)(whiteSpace);
    const shouldCollapseNewlines = (0, $b2a9fe7908a879f6$export$368cf1740b390323)(whiteSpace);
    let canPrependSpaces = !shouldCollapseSpaces;
    const wordWrapWidth = style.wordWrapWidth + letterSpacing;
    const tokens = (0, $b2a9fe7908a879f6$export$660b2ee2d4fb4eff)(text);
    for(let i = 0; i < tokens.length; i++){
        let token = tokens[i];
        if ((0, $b2a9fe7908a879f6$export$c6b40e80adfef3ae)(token)) {
            if (!shouldCollapseNewlines) {
                linesArray.push((0, $b2a9fe7908a879f6$export$da8e5da96e287379)(line));
                canPrependSpaces = !shouldCollapseSpaces;
                line = "";
                width = 0;
                continue;
            }
            token = " ";
        }
        if (shouldCollapseSpaces) {
            const currIsBreakingSpace = (0, $b2a9fe7908a879f6$export$40e905615472e8e0)(token);
            const lastIsBreakingSpace = (0, $b2a9fe7908a879f6$export$40e905615472e8e0)(line[line.length - 1]);
            if (currIsBreakingSpace && lastIsBreakingSpace) continue;
        }
        const tokenWidth = $1b1620b77d029474$var$getFromCache(token, letterSpacing, cache, context, measureTextFn);
        if (tokenWidth > wordWrapWidth) {
            if (line !== "") {
                linesArray.push((0, $b2a9fe7908a879f6$export$da8e5da96e287379)(line));
                line = "";
                width = 0;
            }
            if (canBreakWordsFn(token, style.breakWords)) {
                const charGroups = (0, $b2a9fe7908a879f6$export$8398461ec76ab549)(token, style.breakWords, wordWrapSplitFn, canBreakCharsFn);
                for (const char of charGroups){
                    const characterWidth = $1b1620b77d029474$var$getFromCache(char, letterSpacing, cache, context, measureTextFn);
                    if (characterWidth + width > wordWrapWidth) {
                        linesArray.push((0, $b2a9fe7908a879f6$export$da8e5da96e287379)(line));
                        canPrependSpaces = false;
                        line = "";
                        width = 0;
                    }
                    line += char;
                    width += characterWidth;
                }
            } else {
                if (line.length > 0) {
                    linesArray.push((0, $b2a9fe7908a879f6$export$da8e5da96e287379)(line));
                    line = "";
                    width = 0;
                }
                linesArray.push((0, $b2a9fe7908a879f6$export$da8e5da96e287379)(token));
                canPrependSpaces = false;
                line = "";
                width = 0;
            }
        } else {
            if (tokenWidth + width > wordWrapWidth) {
                canPrependSpaces = false;
                linesArray.push((0, $b2a9fe7908a879f6$export$da8e5da96e287379)(line));
                line = "";
                width = 0;
            }
            if (line.length > 0 || !(0, $b2a9fe7908a879f6$export$40e905615472e8e0)(token) || canPrependSpaces) {
                line += token;
                width += tokenWidth;
            }
        }
    }
    const trimmedLine = (0, $b2a9fe7908a879f6$export$da8e5da96e287379)(line);
    if (trimmedLine.length > 0) linesArray.push(trimmedLine);
    return linesArray.join("\n");
}


"use strict";
const $8cd48e3f940344a0$var$contextSettings = {
    // TextMetrics requires getImageData readback for measuring fonts.
    willReadFrequently: true
};
const $8cd48e3f940344a0$var$_CanvasTextMetrics = class _CanvasTextMetrics {
    /**
   * Checking that we can use modern canvas 2D API.
   *
   * Note: This is an unstable API, Chrome < 94 use `textLetterSpacing`, later versions use `letterSpacing`.
   * @see CanvasTextMetrics.experimentalLetterSpacing
   * @see https://developer.mozilla.org/en-US/docs/Web/API/ICanvasRenderingContext2D/letterSpacing
   * @see https://developer.chrome.com/origintrials/#/view_trial/3585991203293757441
   */ static get experimentalLetterSpacingSupported() {
        let result = _CanvasTextMetrics._experimentalLetterSpacingSupported;
        if (result === void 0) {
            const proto = (0, $dHliN.DOMAdapter).get().getCanvasRenderingContext2D().prototype;
            result = _CanvasTextMetrics._experimentalLetterSpacingSupported = "letterSpacing" in proto || "textLetterSpacing" in proto;
        }
        return result;
    }
    /**
   * @param text - the text that was measured
   * @param style - the style that was measured
   * @param width - the measured width of the text
   * @param height - the measured height of the text
   * @param lines - an array of the lines of text broken by new lines and wrapping if specified in style
   * @param lineWidths - an array of the line widths for each line matched to `lines`
   * @param lineHeight - the measured line height for this style
   * @param maxLineWidth - the maximum line width for all measured lines
   * @param fontProperties - the font properties object from TextMetrics.measureFont
   * @param taggedData - optional object containing tagged text specific data
   * @param taggedData.runsByLine - per-line style runs for tagged text
   * @param taggedData.lineAscents - per-line ascent values for tagged text
   * @param taggedData.lineDescents - per-line descent values for tagged text
   * @param taggedData.lineHeights - per-line height values for tagged text
   * @param taggedData.hasDropShadow - whether any run has a drop shadow
   */ constructor(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties, taggedData){
        this.text = text;
        this.style = style;
        this.width = width;
        this.height = height;
        this.lines = lines;
        this.lineWidths = lineWidths;
        this.lineHeight = lineHeight;
        this.maxLineWidth = maxLineWidth;
        this.fontProperties = fontProperties;
        if (taggedData) {
            this.runsByLine = taggedData.runsByLine;
            this.lineAscents = taggedData.lineAscents;
            this.lineDescents = taggedData.lineDescents;
            this.lineHeights = taggedData.lineHeights;
            this.hasDropShadow = taggedData.hasDropShadow;
        }
    }
    /**
   * Measures the supplied string of text and returns a Rectangle.
   * @param text - The text to measure.
   * @param style - The text style to use for measuring
   * @param canvas - optional specification of the canvas to use for measuring.
   * @param wordWrap
   * @returns Measured width and height of the text.
   */ static measureText(text = " ", style, canvas = _CanvasTextMetrics._canvas, wordWrap2 = style.wordWrap) {
        const textKey = `${text}-${style.styleKey}-wordWrap-${wordWrap2}`;
        if (_CanvasTextMetrics._measurementCache.has(textKey)) return _CanvasTextMetrics._measurementCache.get(textKey);
        const isTagged = (0, $eb12674011bd078a$export$3c634ede7db41923)(style) && (0, $eb12674011bd078a$export$328893c99ad2af02)(text);
        if (isTagged) {
            const result = (0, $2cfce11d73060562$export$2c4cb70a2097cfee)(text, style, wordWrap2, _CanvasTextMetrics._context, _CanvasTextMetrics._measureText, _CanvasTextMetrics._measureTextAdvance, _CanvasTextMetrics.measureFont, _CanvasTextMetrics.canBreakChars, _CanvasTextMetrics.wordWrapSplit);
            const measurements2 = new _CanvasTextMetrics(text, style, result.width, result.height, result.lines, result.lineWidths, result.lineHeight, result.maxLineWidth, result.fontProperties, {
                runsByLine: result.runsByLine,
                lineAscents: result.lineAscents,
                lineDescents: result.lineDescents,
                lineHeights: result.lineHeights,
                hasDropShadow: result.hasDropShadow
            });
            _CanvasTextMetrics._measurementCache.set(textKey, measurements2);
            return measurements2;
        }
        const font = style._fontString;
        const fontProperties = _CanvasTextMetrics.measureFont(font);
        if (fontProperties.fontSize === 0) {
            fontProperties.fontSize = style.fontSize;
            fontProperties.ascent = style.fontSize;
            fontProperties.descent = 0;
        }
        const context = _CanvasTextMetrics._context;
        context.font = font;
        const outputText = wordWrap2 ? _CanvasTextMetrics._wordWrap(text, style, canvas) : text;
        const lines = outputText.split((0, $b2a9fe7908a879f6$export$e943b22311785337));
        const lineWidths = new Array(lines.length);
        let maxLineWidth = 0;
        for(let i = 0; i < lines.length; i++){
            const lineWidth = _CanvasTextMetrics._measureText(lines[i], style.letterSpacing, context);
            lineWidths[i] = lineWidth;
            maxLineWidth = Math.max(maxLineWidth, lineWidth);
        }
        const strokeWidth = style._stroke?.width ?? 0;
        const lineHeight = style.lineHeight || fontProperties.fontSize;
        const width = _CanvasTextMetrics._adjustWidthForStyle(maxLineWidth, style);
        const baseHeight = Math.max(lineHeight, fontProperties.fontSize + strokeWidth) + (lines.length - 1) * (lineHeight + style.leading);
        const height = _CanvasTextMetrics._adjustHeightForStyle(baseHeight, style);
        const measurements = new _CanvasTextMetrics(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
        _CanvasTextMetrics._measurementCache.set(textKey, measurements);
        return measurements;
    }
    /**
   * Adjusts the measured width to account for stroke and drop shadow.
   * @param baseWidth - The base content width
   * @param style - The text style
   * @returns The adjusted width
   */ static _adjustWidthForStyle(baseWidth, style) {
        const strokeWidth = style._stroke?.width || 0;
        let width = baseWidth + strokeWidth;
        if (style.dropShadow) width += style.dropShadow.distance;
        return width;
    }
    /**
   * Adjusts the measured height to account for drop shadow.
   * @param baseHeight - The base content height
   * @param style - The text style
   * @returns The adjusted height
   */ static _adjustHeightForStyle(baseHeight, style) {
        let height = baseHeight;
        if (style.dropShadow) height += style.dropShadow.distance;
        return height;
    }
    /**
   * Measures the rendered width of a string, accounting for letter spacing and using the provided context.
   * Returns the larger of the advance width and the bounding box width.
   * @param text - The text to measure
   * @param letterSpacing - Letter spacing in pixels
   * @param context - Canvas 2D context
   * @returns The measured width of the text with spacing
   * @internal
   */ static _measureText(text, letterSpacing, context) {
        const { metricWidth: metricWidth, metrics: metrics, letterSpacingVal: letterSpacingVal } = _CanvasTextMetrics._measureTextCore(text, letterSpacing, context);
        const actualBoundingBoxLeft = -(metrics.actualBoundingBoxLeft ?? 0);
        const actualBoundingBoxRight = metrics.actualBoundingBoxRight ?? 0;
        let boundsWidth = actualBoundingBoxRight - actualBoundingBoxLeft;
        if (metrics.width > 0) boundsWidth += letterSpacingVal;
        return Math.max(metricWidth, boundsWidth);
    }
    /**
   * Measures advance width only (no bounding box). Advance widths are additive,
   * making this suitable for word wrap line-fitting where per-token widths must sum correctly.
   * @param text - The text to measure
   * @param letterSpacing - Letter spacing in pixels
   * @param context - Canvas 2D context
   * @returns The advance width of the text
   * @internal
   */ static _measureTextAdvance(text, letterSpacing, context) {
        return _CanvasTextMetrics._measureTextCore(text, letterSpacing, context).metricWidth;
    }
    /**
   * Shared measurement core: sets up letter spacing on the context, calls
   * context.measureText, and adjusts the advance width for letter spacing.
   * @param text
   * @param letterSpacing
   * @param context
   * @internal
   */ static _measureTextCore(text, letterSpacing, context) {
        let useExperimentalLetterSpacing = false;
        if (_CanvasTextMetrics.experimentalLetterSpacingSupported) {
            if (_CanvasTextMetrics.experimentalLetterSpacing) {
                context.letterSpacing = `${letterSpacing}px`;
                context.textLetterSpacing = `${letterSpacing}px`;
                useExperimentalLetterSpacing = true;
            } else {
                context.letterSpacing = "0px";
                context.textLetterSpacing = "0px";
            }
        }
        const metrics = context.measureText(text);
        let metricWidth = metrics.width;
        let letterSpacingVal = 0;
        if (metricWidth > 0) {
            if (useExperimentalLetterSpacing) letterSpacingVal = -letterSpacing;
            else letterSpacingVal = (_CanvasTextMetrics.graphemeSegmenter(text).length - 1) * letterSpacing;
            metricWidth += letterSpacingVal;
        }
        return {
            metricWidth: metricWidth,
            metrics: metrics,
            letterSpacingVal: letterSpacingVal
        };
    }
    /**
   * Applies newlines to a string to have it optimally fit into the horizontal
   * bounds set by the Text object's wordWrapWidth property.
   * @param text - String to apply word wrapping to
   * @param style - the style to use when wrapping
   * @param canvas - optional specification of the canvas to use for measuring.
   * @returns New string with new lines applied where required
   */ static _wordWrap(text, style, canvas = _CanvasTextMetrics._canvas) {
        return (0, $1b1620b77d029474$export$dca3d8ad656c34d2)(text, style, canvas, _CanvasTextMetrics._measureTextAdvance, _CanvasTextMetrics.canBreakWords, _CanvasTextMetrics.canBreakChars, _CanvasTextMetrics.wordWrapSplit);
    }
    /**
   * Determines if char is a breaking whitespace.
   *
   * It allows one to determine whether char should be a breaking whitespace
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param char - The character
   * @param [_nextChar] - The next character
   * @returns True if whitespace, False otherwise.
   */ static isBreakingSpace(char, _nextChar) {
        return (0, $b2a9fe7908a879f6$export$40e905615472e8e0)(char, _nextChar);
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to customise which words should break
   * Examples are if the token is CJK or numbers.
   * It must return a boolean.
   * @param _token - The token
   * @param breakWords - The style attr break words
   * @returns Whether to break word or not
   */ static canBreakWords(_token, breakWords) {
        return breakWords;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It allows one to determine whether a pair of characters
   * should be broken by newlines
   * For example certain characters in CJK langs or numbers.
   * It must return a boolean.
   * @param _char - The character
   * @param _nextChar - The next character
   * @param _token - The token/word the characters are from
   * @param _index - The index in the token of the char
   * @param _breakWords - The style attr break words
   * @returns whether to break word or not
   */ static canBreakChars(_char, _nextChar, _token, _index, _breakWords) {
        return true;
    }
    /**
   * Overridable helper method used internally by TextMetrics, exposed to allow customizing the class's behavior.
   *
   * It is called when a token (usually a word) has to be split into separate pieces
   * in order to determine the point to break a word.
   * It must return an array of characters.
   * @param token - The token to split
   * @returns The characters of the token
   * @see CanvasTextMetrics.graphemeSegmenter
   */ static wordWrapSplit(token) {
        return _CanvasTextMetrics.graphemeSegmenter(token);
    }
    /**
   * Calculates the ascent, descent and fontSize of a given font-style
   * @param font - String representing the style of the font
   * @returns Font properties object
   */ static measureFont(font) {
        if (_CanvasTextMetrics._fonts[font]) return _CanvasTextMetrics._fonts[font];
        const context = _CanvasTextMetrics._context;
        context.font = font;
        const metrics = context.measureText(_CanvasTextMetrics.METRICS_STRING + _CanvasTextMetrics.BASELINE_SYMBOL);
        const ascent = metrics.actualBoundingBoxAscent ?? 0;
        const descent = metrics.actualBoundingBoxDescent ?? 0;
        const properties = {
            ascent: ascent,
            descent: descent,
            fontSize: ascent + descent
        };
        _CanvasTextMetrics._fonts[font] = properties;
        return properties;
    }
    /**
   * Clear font metrics in metrics cache.
   * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
   */ static clearMetrics(font = "") {
        if (font) delete _CanvasTextMetrics._fonts[font];
        else _CanvasTextMetrics._fonts = {};
    }
    /**
   * Cached canvas element for measuring text
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _canvas() {
        if (!_CanvasTextMetrics.__canvas) {
            let canvas;
            try {
                const c = new OffscreenCanvas(0, 0);
                const context = c.getContext("2d", $8cd48e3f940344a0$var$contextSettings);
                if (context?.measureText) {
                    _CanvasTextMetrics.__canvas = c;
                    return c;
                }
                canvas = (0, $dHliN.DOMAdapter).get().createCanvas();
            } catch (_cx) {
                canvas = (0, $dHliN.DOMAdapter).get().createCanvas();
            }
            canvas.width = canvas.height = 10;
            _CanvasTextMetrics.__canvas = canvas;
        }
        return _CanvasTextMetrics.__canvas;
    }
    /**
   * TODO: this should be private, but isn't because of backward compat, will fix later.
   * @ignore
   */ static get _context() {
        if (!_CanvasTextMetrics.__context) _CanvasTextMetrics.__context = _CanvasTextMetrics._canvas.getContext("2d", $8cd48e3f940344a0$var$contextSettings);
        return _CanvasTextMetrics.__context;
    }
};
/**
 * String used for calculate font metrics.
 * These characters are all tall to help calculate the height required for text.
 */ $8cd48e3f940344a0$var$_CanvasTextMetrics.METRICS_STRING = "|\xC9q\xC5";
/** Baseline symbol for calculate font metrics. */ $8cd48e3f940344a0$var$_CanvasTextMetrics.BASELINE_SYMBOL = "M";
/** Baseline multiplier for calculate font metrics. */ $8cd48e3f940344a0$var$_CanvasTextMetrics.BASELINE_MULTIPLIER = 1.4;
/** Height multiplier for setting height of canvas to calculate font metrics. */ $8cd48e3f940344a0$var$_CanvasTextMetrics.HEIGHT_MULTIPLIER = 2;
/**
 * A Unicode "character", or "grapheme cluster", can be composed of multiple Unicode code points,
 * such as letters with diacritical marks (e.g. `'\u0065\u0301'`, letter e with acute)
 * or emojis with modifiers (e.g. `'\uD83E\uDDD1\u200D\uD83D\uDCBB'`, technologist).
 * The new `Intl.Segmenter` API in ES2022 can split the string into grapheme clusters correctly. If it is not available,
 * PixiJS will fallback to use the iterator of String, which can only spilt the string into code points.
 * If you want to get full functionality in environments that don't support `Intl.Segmenter` (such as Firefox),
 * you can use other libraries such as [grapheme-splitter]{@link https://www.npmjs.com/package/grapheme-splitter}
 * or [graphemer]{@link https://www.npmjs.com/package/graphemer} to create a polyfill. Since these libraries can be
 * relatively large in size to handle various Unicode grapheme clusters properly, PixiJS won't use them directly.
 */ $8cd48e3f940344a0$var$_CanvasTextMetrics.graphemeSegmenter = (()=>{
    if (typeof Intl?.Segmenter === "function") {
        const segmenter = new Intl.Segmenter();
        return (s)=>{
            const segments = segmenter.segment(s);
            const result = [];
            let i = 0;
            for (const segment of segments)result[i++] = segment.segment;
            return result;
        };
    }
    return (s)=>[
            ...s
        ];
})();
/**
 * New rendering behavior for letter-spacing which uses Chrome's new native API. This will
 * lead to more accurate letter-spacing results because it does not try to manually draw
 * each character. However, this Chrome API is experimental and may not serve all cases yet.
 * @see CanvasTextMetrics.experimentalLetterSpacingSupported
 */ $8cd48e3f940344a0$var$_CanvasTextMetrics.experimentalLetterSpacing = false;
/** Cache of {@link TextMetrics.FontMetrics} objects. */ $8cd48e3f940344a0$var$_CanvasTextMetrics._fonts = {};
/** Cache for measured text metrics */ $8cd48e3f940344a0$var$_CanvasTextMetrics._measurementCache = (0, $efe7ca9bd0d801a6$export$64e09406e6c5de88)(1e3);
let $8cd48e3f940344a0$export$b12f6bdc825d944f = $8cd48e3f940344a0$var$_CanvasTextMetrics;


"use strict";
const $412c431785e258a2$var$genericFontFamilies = [
    "serif",
    "sans-serif",
    "monospace",
    "cursive",
    "fantasy",
    "system-ui"
];
function $412c431785e258a2$export$b7b5edb82ac3fc66(style) {
    const fontSizeString = typeof style.fontSize === "number" ? `${style.fontSize}px` : style.fontSize;
    let fontFamilies = style.fontFamily;
    if (!Array.isArray(style.fontFamily)) fontFamilies = style.fontFamily.split(",");
    for(let i = fontFamilies.length - 1; i >= 0; i--){
        let fontFamily = fontFamilies[i].trim();
        if (!/([\"\'])[^\'\"]+\1/.test(fontFamily) && !$412c431785e258a2$var$genericFontFamilies.includes(fontFamily)) fontFamily = `"${fontFamily}"`;
        fontFamilies[i] = fontFamily;
    }
    return `${style.fontStyle} ${style.fontVariant} ${style.fontWeight} ${fontSizeString} ${fontFamilies.join(",")}`;
}



var $jr7Dg = parcelRequire("jr7Dg");

var $deLbn = parcelRequire("deLbn");

var $cmH9g = parcelRequire("cmH9g");

var $fGITk = parcelRequire("fGITk");

var $4dwOg = parcelRequire("4dwOg");

var $jqDfq = parcelRequire("jqDfq");
"use strict";
const $8c1f194471528310$var$PRECISION = 1e5;
function $8c1f194471528310$export$c31af9427fa8602b(fillStyle, context, textMetrics, padding = 0, offsetX = 0, offsetY = 0) {
    if (fillStyle.texture === (0, $cmH9g.Texture).WHITE && !fillStyle.fill) return (0, $jr7Dg.Color).shared.setValue(fillStyle.color).setAlpha(fillStyle.alpha ?? 1).toHexa();
    else if (!fillStyle.fill) {
        const pattern = context.createPattern(fillStyle.texture.source.resource, "repeat");
        const tempMatrix = fillStyle.matrix.copyTo((0, $deLbn.Matrix).shared);
        tempMatrix.scale(fillStyle.texture.source.pixelWidth, fillStyle.texture.source.pixelHeight);
        pattern.setTransform(tempMatrix);
        return pattern;
    } else if (fillStyle.fill instanceof (0, $jqDfq.FillPattern)) {
        const fillPattern = fillStyle.fill;
        const pattern = context.createPattern(fillPattern.texture.source.resource, "repeat");
        const tempMatrix = fillPattern.transform.copyTo((0, $deLbn.Matrix).shared);
        tempMatrix.scale(fillPattern.texture.source.pixelWidth, fillPattern.texture.source.pixelHeight);
        pattern.setTransform(tempMatrix);
        return pattern;
    } else if (fillStyle.fill instanceof (0, $4dwOg.FillGradient)) {
        const fillGradient = fillStyle.fill;
        const isLinear = fillGradient.type === "linear";
        const isLocal = fillGradient.textureSpace === "local";
        let width = 1;
        let height = 1;
        if (isLocal && textMetrics) {
            width = textMetrics.width + padding;
            height = textMetrics.height + padding;
        }
        let gradient;
        let isNearlyVertical = false;
        if (isLinear) {
            const { start: start, end: end } = fillGradient;
            gradient = context.createLinearGradient(start.x * width + offsetX, start.y * height + offsetY, end.x * width + offsetX, end.y * height + offsetY);
            isNearlyVertical = Math.abs(end.x - start.x) < Math.abs((end.y - start.y) * 0.1);
        } else {
            const { center: center, innerRadius: innerRadius, outerCenter: outerCenter, outerRadius: outerRadius } = fillGradient;
            gradient = context.createRadialGradient(center.x * width + offsetX, center.y * height + offsetY, innerRadius * width, outerCenter.x * width + offsetX, outerCenter.y * height + offsetY, outerRadius * width);
        }
        if (isNearlyVertical && isLocal && textMetrics) {
            const ratio = textMetrics.lineHeight / height;
            for(let i = 0; i < textMetrics.lines.length; i++){
                const start = (i * textMetrics.lineHeight + padding / 2) / height;
                fillGradient.colorStops.forEach((stop)=>{
                    let globalStop = start + stop.offset * ratio;
                    globalStop = Math.max(0, Math.min(1, globalStop));
                    gradient.addColorStop(// fix to 5 decimal places to avoid floating point precision issues
                    Math.floor(globalStop * $8c1f194471528310$var$PRECISION) / $8c1f194471528310$var$PRECISION, (0, $jr7Dg.Color).shared.setValue(stop.color).toHex());
                });
            }
        } else fillGradient.colorStops.forEach((stop)=>{
            gradient.addColorStop(stop.offset, (0, $jr7Dg.Color).shared.setValue(stop.color).toHex());
        });
        return gradient;
    }
    (0, $fGITk.warn)("FillStyle not recognised", fillStyle);
    return "red";
}


"use strict";
const $66bcd1818e5ec118$var$tempRect = new (0, $kNl9L.Rectangle)();
function $66bcd1818e5ec118$var$countSpaces(text) {
    let count = 0;
    for(let i = 0; i < text.length; i++)if (text.charCodeAt(i) === 32) count++;
    return count;
}
class $66bcd1818e5ec118$var$CanvasTextGeneratorClass {
    /**
   * Creates a canvas with the specified text rendered to it.
   *
   * Generates a canvas of appropriate size, renders the text with the provided style,
   * and returns both the canvas/context and a Rectangle representing the text bounds.
   *
   * When trim is enabled in the style, the frame will represent the bounds of the
   * non-transparent pixels, which can be smaller than the full canvas.
   * @param options - The options for generating the text canvas
   * @param options.text - The text to render
   * @param options.style - The style to apply to the text
   * @param options.resolution - The resolution of the canvas (defaults to 1)
   * @param options.padding
   * @returns An object containing the canvas/context and the frame (bounds) of the text
   */ getCanvasAndContext(options) {
        const { text: text, style: style, resolution: resolution = 1 } = options;
        const padding = style._getFinalPadding();
        const measured = (0, $8cd48e3f940344a0$export$b12f6bdc825d944f).measureText(text || " ", style);
        const width = Math.ceil(Math.ceil(Math.max(1, measured.width) + padding * 2) * resolution);
        const height = Math.ceil(Math.ceil(Math.max(1, measured.height) + padding * 2) * resolution);
        const canvasAndContext = (0, $jcSXK.CanvasPool).getOptimalCanvasAndContext(width, height);
        this._renderTextToCanvas(style, padding, resolution, canvasAndContext, measured);
        const frame = style.trim ? (0, $c4217ac1a6a14d41$export$550eedf6c679837d)({
            canvas: canvasAndContext.canvas,
            width: width,
            height: height,
            resolution: 1,
            output: $66bcd1818e5ec118$var$tempRect
        }) : $66bcd1818e5ec118$var$tempRect.set(0, 0, width, height);
        return {
            canvasAndContext: canvasAndContext,
            frame: frame
        };
    }
    /**
   * Returns a canvas and context to the pool.
   *
   * This should be called when you're done with the canvas to allow reuse
   * and prevent memory leaks.
   * @param canvasAndContext - The canvas and context to return to the pool
   */ returnCanvasAndContext(canvasAndContext) {
        (0, $jcSXK.CanvasPool).returnCanvasAndContext(canvasAndContext);
    }
    /**
   * Renders text to its canvas, and updates its texture.
   * @param style - The style of the text
   * @param padding - The padding of the text
   * @param resolution - The resolution of the text
   * @param canvasAndContext - The canvas and context to render the text to
   * @param measured - Pre-measured text metrics to avoid duplicate measurement
   */ _renderTextToCanvas(style, padding, resolution, canvasAndContext, measured) {
        if (measured.runsByLine && measured.runsByLine.length > 0) {
            this._renderTaggedTextToCanvas(measured, style, padding, resolution, canvasAndContext);
            return;
        }
        const { canvas: canvas, context: context } = canvasAndContext;
        const font = (0, $412c431785e258a2$export$b7b5edb82ac3fc66)(style);
        const lines = measured.lines;
        const lineHeight = measured.lineHeight;
        const lineWidths = measured.lineWidths;
        const maxLineWidth = measured.maxLineWidth;
        const fontProperties = measured.fontProperties;
        const height = canvas.height;
        context.resetTransform();
        context.scale(resolution, resolution);
        context.textBaseline = style.textBaseline;
        if (style._stroke?.width) {
            const strokeStyle = style._stroke;
            context.lineWidth = strokeStyle.width;
            context.miterLimit = strokeStyle.miterLimit;
            context.lineJoin = strokeStyle.join;
            context.lineCap = strokeStyle.cap;
        }
        context.font = font;
        let linePositionX;
        let linePositionY;
        const passesCount = style.dropShadow ? 2 : 1;
        const strokeWidth = style._stroke?.width ?? 0;
        const halfStroke = strokeWidth / 2;
        let linePositionYShift = (lineHeight - fontProperties.fontSize) / 2;
        if (lineHeight - fontProperties.fontSize < 0) linePositionYShift = 0;
        for(let i = 0; i < passesCount; ++i){
            const isShadowPass = style.dropShadow && i === 0;
            const dsOffsetText = isShadowPass ? Math.ceil(Math.max(1, height) + padding * 2) : 0;
            const dsOffsetShadow = dsOffsetText * resolution;
            if (isShadowPass) this._setupDropShadow(context, style, resolution, dsOffsetShadow);
            else {
                const gradientBounds = style._gradientBounds;
                const gradientOffset = style._gradientOffset;
                if (gradientBounds) {
                    const gradientMetrics = {
                        width: gradientBounds.width,
                        height: gradientBounds.height,
                        lineHeight: gradientBounds.height,
                        lines: measured.lines
                    };
                    this._setFillAndStrokeStyles(context, style, gradientMetrics, padding, halfStroke, gradientOffset?.x ?? 0, gradientOffset?.y ?? 0);
                } else if (gradientOffset) this._setFillAndStrokeStyles(context, style, measured, padding, halfStroke, gradientOffset.x, gradientOffset.y);
                else this._setFillAndStrokeStyles(context, style, measured, padding, halfStroke);
                context.shadowColor = "rgba(0,0,0,0)";
            }
            for(let j = 0; j < lines.length; j++){
                linePositionX = halfStroke;
                linePositionY = halfStroke + j * lineHeight + fontProperties.ascent + linePositionYShift;
                linePositionX += this._getAlignmentOffset(lineWidths[j], maxLineWidth, style.align);
                let wordSpacing = 0;
                if (style.align === "justify" && style.wordWrap && j < lines.length - 1) {
                    const spaces = $66bcd1818e5ec118$var$countSpaces(lines[j]);
                    if (spaces > 0) wordSpacing = (maxLineWidth - lineWidths[j]) / spaces;
                }
                if (style._stroke?.width) this._drawLetterSpacing(lines[j], style, canvasAndContext, linePositionX + padding, linePositionY + padding - dsOffsetText, true, wordSpacing);
                if (style._fill !== void 0) this._drawLetterSpacing(lines[j], style, canvasAndContext, linePositionX + padding, linePositionY + padding - dsOffsetText, false, wordSpacing);
            }
        }
    }
    /**
   * Renders tagged text (with per-run styles) to canvas.
   * @param measured - The measured text metrics containing runsByLine
   * @param style - The base text style
   * @param padding - The padding of the text
   * @param resolution - The resolution of the text
   * @param canvasAndContext - The canvas and context to render to
   */ _renderTaggedTextToCanvas(measured, style, padding, resolution, canvasAndContext) {
        const { canvas: canvas, context: context } = canvasAndContext;
        const { runsByLine: runsByLine, lineWidths: lineWidths, maxLineWidth: maxLineWidth, lineAscents: lineAscents, lineHeights: lineHeights, hasDropShadow: hasDropShadow } = measured;
        const height = canvas.height;
        context.resetTransform();
        context.scale(resolution, resolution);
        context.textBaseline = style.textBaseline;
        const passesCount = hasDropShadow ? 2 : 1;
        let maxStrokeWidth = style._stroke?.width ?? 0;
        for (const lineRuns of runsByLine)for (const run of lineRuns){
            const w = run.style._stroke?.width ?? 0;
            if (w > maxStrokeWidth) maxStrokeWidth = w;
        }
        const halfStroke = maxStrokeWidth / 2;
        const runDataByLine = [];
        for(let lineIndex = 0; lineIndex < runsByLine.length; lineIndex++){
            const lineRuns = runsByLine[lineIndex];
            const runData = [];
            for (const run of lineRuns){
                const font = (0, $412c431785e258a2$export$b7b5edb82ac3fc66)(run.style);
                context.font = font;
                runData.push({
                    width: (0, $8cd48e3f940344a0$export$b12f6bdc825d944f)._measureText(run.text, run.style.letterSpacing, context),
                    font: font
                });
            }
            runDataByLine.push(runData);
        }
        for(let pass = 0; pass < passesCount; ++pass){
            const isShadowPass = hasDropShadow && pass === 0;
            const dsOffsetText = isShadowPass ? Math.ceil(Math.max(1, height) + padding * 2) : 0;
            const dsOffsetShadow = dsOffsetText * resolution;
            if (!isShadowPass) context.shadowColor = "rgba(0,0,0,0)";
            let currentY = halfStroke;
            for(let lineIndex = 0; lineIndex < runsByLine.length; lineIndex++){
                const lineRuns = runsByLine[lineIndex];
                const lineWidth = lineWidths[lineIndex];
                const lineAscent = lineAscents[lineIndex];
                const currentLineHeight = lineHeights[lineIndex];
                const lineRunData = runDataByLine[lineIndex];
                let linePositionX = halfStroke;
                linePositionX += this._getAlignmentOffset(lineWidth, maxLineWidth, style.align);
                let wordSpacing = 0;
                if (style.align === "justify" && style.wordWrap && lineIndex < runsByLine.length - 1) {
                    let totalSpaces = 0;
                    for (const run of lineRuns)totalSpaces += $66bcd1818e5ec118$var$countSpaces(run.text);
                    if (totalSpaces > 0) wordSpacing = (maxLineWidth - lineWidth) / totalSpaces;
                }
                const linePositionY = currentY + lineAscent;
                let runX = linePositionX + padding;
                for(let runIndex = 0; runIndex < lineRuns.length; runIndex++){
                    const run = lineRuns[runIndex];
                    const { width: runWidth, font: runFont } = lineRunData[runIndex];
                    context.font = runFont;
                    context.textBaseline = run.style.textBaseline;
                    if (run.style._stroke?.width) {
                        const runStroke = run.style._stroke;
                        context.lineWidth = runStroke.width;
                        context.miterLimit = runStroke.miterLimit;
                        context.lineJoin = runStroke.join;
                        context.lineCap = runStroke.cap;
                        if (isShadowPass) {
                            if (run.style.dropShadow) this._setupDropShadow(context, run.style, resolution, dsOffsetShadow);
                            else {
                                const spacesSkipped = $66bcd1818e5ec118$var$countSpaces(run.text);
                                runX += runWidth + spacesSkipped * wordSpacing;
                                continue;
                            }
                        } else {
                            const runFontProps = (0, $8cd48e3f940344a0$export$b12f6bdc825d944f).measureFont(runFont);
                            const runHeight = run.style.lineHeight || runFontProps.fontSize;
                            const runMetrics = {
                                width: runWidth,
                                height: runHeight,
                                lineHeight: runHeight,
                                lines: [
                                    run.text
                                ]
                            };
                            context.strokeStyle = (0, $8c1f194471528310$export$c31af9427fa8602b)(runStroke, context, runMetrics, padding * 2, runX - padding, currentY);
                        }
                        this._drawLetterSpacing(run.text, run.style, canvasAndContext, runX, linePositionY + padding - dsOffsetText, true, wordSpacing);
                    }
                    const spacesInRun = $66bcd1818e5ec118$var$countSpaces(run.text);
                    runX += runWidth + spacesInRun * wordSpacing;
                }
                runX = linePositionX + padding;
                for(let runIndex = 0; runIndex < lineRuns.length; runIndex++){
                    const run = lineRuns[runIndex];
                    const { width: runWidth, font: runFont } = lineRunData[runIndex];
                    context.font = runFont;
                    context.textBaseline = run.style.textBaseline;
                    if (run.style._fill !== void 0) {
                        if (isShadowPass) {
                            if (run.style.dropShadow) this._setupDropShadow(context, run.style, resolution, dsOffsetShadow);
                            else {
                                const spacesSkipped = $66bcd1818e5ec118$var$countSpaces(run.text);
                                runX += runWidth + spacesSkipped * wordSpacing;
                                continue;
                            }
                        } else {
                            const runFontProps = (0, $8cd48e3f940344a0$export$b12f6bdc825d944f).measureFont(runFont);
                            const runHeight = run.style.lineHeight || runFontProps.fontSize;
                            const runMetrics = {
                                width: runWidth,
                                height: runHeight,
                                lineHeight: runHeight,
                                lines: [
                                    run.text
                                ]
                            };
                            context.fillStyle = (0, $8c1f194471528310$export$c31af9427fa8602b)(run.style._fill, context, runMetrics, padding * 2, runX - padding, currentY);
                        }
                        this._drawLetterSpacing(run.text, run.style, canvasAndContext, runX, linePositionY + padding - dsOffsetText, false, wordSpacing);
                    }
                    const spacesInFillRun = $66bcd1818e5ec118$var$countSpaces(run.text);
                    runX += runWidth + spacesInFillRun * wordSpacing;
                }
                currentY += currentLineHeight;
            }
        }
    }
    /**
   * Sets fill and stroke styles on the canvas context for text rendering.
   * @param context - The canvas context
   * @param style - The text style
   * @param metrics - The text metrics for gradient calculation
   * @param padding - The padding value
   * @param halfStroke - Half the stroke width
   * @param offsetX - X offset for gradient positioning
   * @param offsetY - Y offset for gradient positioning
   */ _setFillAndStrokeStyles(context, style, metrics, padding, halfStroke, offsetX = 0, offsetY = 0) {
        context.fillStyle = style._fill ? (0, $8c1f194471528310$export$c31af9427fa8602b)(style._fill, context, metrics, padding * 2, offsetX, offsetY) : null;
        if (style._stroke?.width) {
            const strokePadding = halfStroke + padding * 2;
            context.strokeStyle = (0, $8c1f194471528310$export$c31af9427fa8602b)(style._stroke, context, metrics, strokePadding, offsetX, offsetY);
        }
    }
    /**
   * Sets up the canvas context for drop shadow rendering.
   * @param context - The canvas context
   * @param style - The text style containing drop shadow options
   * @param resolution - The resolution multiplier
   * @param dsOffsetShadow - The shadow Y offset
   */ _setupDropShadow(context, style, resolution, dsOffsetShadow) {
        context.fillStyle = "black";
        context.strokeStyle = "black";
        const shadowOptions = style.dropShadow;
        const dropShadowColor = shadowOptions.color;
        const dropShadowAlpha = shadowOptions.alpha;
        context.shadowColor = (0, $jr7Dg.Color).shared.setValue(dropShadowColor).setAlpha(dropShadowAlpha).toRgbaString();
        const dropShadowBlur = shadowOptions.blur * resolution;
        const dropShadowDistance = shadowOptions.distance * resolution;
        context.shadowBlur = dropShadowBlur;
        context.shadowOffsetX = Math.cos(shadowOptions.angle) * dropShadowDistance;
        context.shadowOffsetY = Math.sin(shadowOptions.angle) * dropShadowDistance + dsOffsetShadow;
    }
    /**
   * Calculates the X offset for text alignment.
   * @param lineWidth - The width of the current line
   * @param alignWidth - The width to align against
   * @param align - The text alignment
   * @returns The X offset for this line
   */ _getAlignmentOffset(lineWidth, alignWidth, align) {
        if (align === "right") return alignWidth - lineWidth;
        else if (align === "center") return (alignWidth - lineWidth) / 2;
        return 0;
    }
    /**
   * Render the text with letter-spacing.
   *
   * This method handles rendering text with the correct letter spacing, using either:
   * 1. Native letter spacing if supported by the browser
   * 2. Manual letter spacing calculation if not natively supported
   *
   * For manual letter spacing, it calculates the position of each character
   * based on its width and the desired spacing.
   * @param text - The text to draw
   * @param style - The text style to apply
   * @param canvasAndContext - The canvas and context to draw to
   * @param x - Horizontal position to draw the text
   * @param y - Vertical position to draw the text
   * @param isStroke - Whether to render the stroke (true) or fill (false)
   * @param wordSpacing - Extra spacing to add between words (for justify alignment)
   * @private
   */ _drawLetterSpacing(text, style, canvasAndContext, x, y, isStroke = false, wordSpacing = 0) {
        const { context: context } = canvasAndContext;
        const letterSpacing = style.letterSpacing;
        let useExperimentalLetterSpacing = false;
        if ((0, $8cd48e3f940344a0$export$b12f6bdc825d944f).experimentalLetterSpacingSupported) {
            if ((0, $8cd48e3f940344a0$export$b12f6bdc825d944f).experimentalLetterSpacing) {
                context.letterSpacing = `${letterSpacing}px`;
                context.textLetterSpacing = `${letterSpacing}px`;
                useExperimentalLetterSpacing = true;
            } else {
                context.letterSpacing = "0px";
                context.textLetterSpacing = "0px";
            }
        }
        if ((letterSpacing === 0 || useExperimentalLetterSpacing) && wordSpacing === 0) {
            if (isStroke) context.strokeText(text, x, y);
            else context.fillText(text, x, y);
            return;
        }
        if (wordSpacing !== 0 && (letterSpacing === 0 || useExperimentalLetterSpacing)) {
            const words = text.split(" ");
            let currentPosition2 = x;
            const spaceWidth = context.measureText(" ").width;
            for(let i = 0; i < words.length; i++){
                if (isStroke) context.strokeText(words[i], currentPosition2, y);
                else context.fillText(words[i], currentPosition2, y);
                currentPosition2 += context.measureText(words[i]).width + spaceWidth + wordSpacing;
            }
            return;
        }
        let currentPosition = x;
        const stringArray = (0, $8cd48e3f940344a0$export$b12f6bdc825d944f).graphemeSegmenter(text);
        let previousWidth = context.measureText(text).width;
        let currentWidth = 0;
        for(let i = 0; i < stringArray.length; ++i){
            const currentChar = stringArray[i];
            if (isStroke) context.strokeText(currentChar, currentPosition, y);
            else context.fillText(currentChar, currentPosition, y);
            let textStr = "";
            for(let j = i + 1; j < stringArray.length; ++j)textStr += stringArray[j];
            currentWidth = context.measureText(textStr).width;
            currentPosition += previousWidth - currentWidth + letterSpacing;
            if (currentChar === " ") currentPosition += wordSpacing;
            previousWidth = currentWidth;
        }
    }
}
const $66bcd1818e5ec118$export$bb54b62b519176d5 = new $66bcd1818e5ec118$var$CanvasTextGeneratorClass();




var $6AQ4q = parcelRequire("6AQ4q");

var $jr7Dg = parcelRequire("jr7Dg");

var $kfwXR = parcelRequire("kfwXR");

var $dXBy0 = parcelRequire("dXBy0");

var $fGITk = parcelRequire("fGITk");

var $4dwOg = parcelRequire("4dwOg");

var $jqDfq = parcelRequire("jqDfq");

var $lP6io = parcelRequire("lP6io");

var $3lOoE = parcelRequire("3lOoE");

"use strict";
const $6572d68b0820a289$var$_TextStyle = class _TextStyle extends (0, (/*@__PURE__*/$parcel$interopDefault($6AQ4q))) {
    constructor(style = {}){
        super();
        /**
     * Unique identifier for the TextStyle class.
     * This is used to track instances and ensure uniqueness.
     * @internal
     */ this.uid = (0, $kfwXR.uid)("textStyle");
        /**
     * Internal tick counter used to track updates and changes.
     * This is incremented whenever the style is modified, allowing for efficient change detection.
     * @internal
     */ this._tick = 0;
        this._cachedFontString = null;
        $6572d68b0820a289$var$convertV7Tov8Style(style);
        const isTextStyle = style instanceof _TextStyle;
        const existingStyle = style;
        if (isTextStyle) style = existingStyle._toObject();
        const fullStyle = {
            ..._TextStyle.defaultTextStyle,
            ...style
        };
        for(const key in fullStyle){
            const thisKey = key;
            this[thisKey] = fullStyle[key];
        }
        this._tagStyles = style.tagStyles ?? void 0;
        this.update();
        this._tick = 0;
    }
    /**
   * Alignment for multiline text, does not affect single line text.
   * @type {'left'|'center'|'right'|'justify'}
   */ get align() {
        return this._align;
    }
    set align(value) {
        if (this._align === value) return;
        this._align = value;
        this.update();
    }
    /** Indicates if lines can be wrapped within words, it needs wordWrap to be set to true. */ get breakWords() {
        return this._breakWords;
    }
    set breakWords(value) {
        if (this._breakWords === value) return;
        this._breakWords = value;
        this.update();
    }
    /** Set a drop shadow for the text. */ get dropShadow() {
        return this._dropShadow;
    }
    set dropShadow(value) {
        if (this._dropShadow === value) return;
        if (value !== null && typeof value === "object") this._dropShadow = this._createProxy({
            ..._TextStyle.defaultDropShadow,
            ...value
        });
        else this._dropShadow = value ? this._createProxy({
            ..._TextStyle.defaultDropShadow
        }) : null;
        this.update();
    }
    /** The font family, can be a single font name, or a list of names where the first is the preferred font. */ get fontFamily() {
        return this._fontFamily;
    }
    set fontFamily(value) {
        if (this._fontFamily === value) return;
        this._fontFamily = value;
        this.update();
    }
    /** The font size (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em') */ get fontSize() {
        return this._fontSize;
    }
    set fontSize(value) {
        if (this._fontSize === value) return;
        if (typeof value === "string") this._fontSize = parseInt(value, 10);
        else this._fontSize = value;
        this.update();
    }
    /**
   * The font style.
   * @type {'normal'|'italic'|'oblique'}
   */ get fontStyle() {
        return this._fontStyle;
    }
    set fontStyle(value) {
        if (this._fontStyle === value) return;
        this._fontStyle = value.toLowerCase();
        this.update();
    }
    /**
   * The font variant.
   * @type {'normal'|'small-caps'}
   */ get fontVariant() {
        return this._fontVariant;
    }
    set fontVariant(value) {
        if (this._fontVariant === value) return;
        this._fontVariant = value;
        this.update();
    }
    /**
   * The font weight.
   * @type {'normal'|'bold'|'bolder'|'lighter'|'100'|'200'|'300'|'400'|'500'|'600'|'700'|'800'|'900'}
   */ get fontWeight() {
        return this._fontWeight;
    }
    set fontWeight(value) {
        if (this._fontWeight === value) return;
        this._fontWeight = value;
        this.update();
    }
    /** The space between lines. */ get leading() {
        return this._leading;
    }
    set leading(value) {
        if (this._leading === value) return;
        this._leading = value;
        this.update();
    }
    /** The amount of spacing between letters, default is 0. */ get letterSpacing() {
        return this._letterSpacing;
    }
    set letterSpacing(value) {
        if (this._letterSpacing === value) return;
        this._letterSpacing = value;
        this.update();
    }
    /** The line height, a number that represents the vertical space that a letter uses. */ get lineHeight() {
        return this._lineHeight;
    }
    set lineHeight(value) {
        if (this._lineHeight === value) return;
        this._lineHeight = value;
        this.update();
    }
    /**
   * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
   * by adding padding to all sides of the text.
   * > [!NOTE] This will NOT affect the positioning or bounds of the text.
   */ get padding() {
        return this._padding;
    }
    set padding(value) {
        if (this._padding === value) return;
        this._padding = value;
        this.update();
    }
    /**
   * An optional filter or array of filters to apply to the text, allowing for advanced visual effects.
   * These filters will be applied to the text as it is created, resulting in faster rendering for static text
   * compared to applying the filter directly to the text object (which would be applied at run time).
   * @default null
   */ get filters() {
        return this._filters;
    }
    set filters(value) {
        if (this._filters === value) return;
        this._filters = Object.freeze(value);
        this.update();
    }
    /**
   * Trim transparent borders from the text texture.
   * > [!IMPORTANT] PERFORMANCE WARNING:
   * > This is a costly operation as it requires scanning pixel alpha values.
   * > Avoid using `trim: true` for dynamic text, as it could significantly impact performance.
   */ get trim() {
        return this._trim;
    }
    set trim(value) {
        if (this._trim === value) return;
        this._trim = value;
        this.update();
    }
    /**
   * The baseline of the text that is rendered.
   * @type {'alphabetic'|'top'|'hanging'|'middle'|'ideographic'|'bottom'}
   */ get textBaseline() {
        return this._textBaseline;
    }
    set textBaseline(value) {
        if (this._textBaseline === value) return;
        this._textBaseline = value;
        this.update();
    }
    /**
   * How newlines and spaces should be handled.
   * Default is 'pre' (preserve, preserve).
   *
   *  value       | New lines     |   Spaces
   *  ---         | ---           |   ---
   * 'normal'     | Collapse      |   Collapse
   * 'pre'        | Preserve      |   Preserve
   * 'pre-line'   | Preserve      |   Collapse
   * @type {'normal'|'pre'|'pre-line'}
   */ get whiteSpace() {
        return this._whiteSpace;
    }
    set whiteSpace(value) {
        if (this._whiteSpace === value) return;
        this._whiteSpace = value;
        this.update();
    }
    /** Indicates if word wrap should be used. */ get wordWrap() {
        return this._wordWrap;
    }
    set wordWrap(value) {
        if (this._wordWrap === value) return;
        this._wordWrap = value;
        this.update();
    }
    /** The width at which text will wrap, it needs wordWrap to be set to true. */ get wordWrapWidth() {
        return this._wordWrapWidth;
    }
    set wordWrapWidth(value) {
        if (this._wordWrapWidth === value) return;
        this._wordWrapWidth = value;
        this.update();
    }
    /**
   * The fill style that will be used to color the text.
   * This can be:
   * - A color string like 'red', '#00FF00', or 'rgba(255,0,0,0.5)'
   * - A hex number like 0xff0000 for red
   * - A FillStyle object with properties like { color: 0xff0000, alpha: 0.5 }
   * - A FillGradient for gradient fills
   * - A FillPattern for pattern/texture fills
   *
   * When using a FillGradient, vertical gradients (angle of 90 degrees) are applied per line of text,
   * while gradients at any other angle are spread across the entire text body as a whole.
   * @example
   * // Vertical gradient applied per line
   * const verticalGradient = new FillGradient(0, 0, 0, 1)
   *     .addColorStop(0, 0xff0000)
   *     .addColorStop(1, 0x0000ff);
   *
   * const text = new Text({
   *     text: 'Line 1\nLine 2',
   *     style: { fill: verticalGradient }
   * });
   *
   * To manage the gradient in a global scope, set the textureSpace property of the FillGradient to 'global'.
   * @type {string|number|FillStyle|FillGradient|FillPattern}
   */ get fill() {
        return this._originalFill;
    }
    set fill(value) {
        if (value === this._originalFill) return;
        this._originalFill = value;
        if (this._isFillStyle(value)) this._originalFill = this._createProxy({
            ...(0, $lP6io.GraphicsContext).defaultFillStyle,
            ...value
        }, ()=>{
            this._fill = (0, $3lOoE.toFillStyle)({
                ...this._originalFill
            }, (0, $lP6io.GraphicsContext).defaultFillStyle);
        });
        this._fill = (0, $3lOoE.toFillStyle)(value === 0 ? "black" : value, (0, $lP6io.GraphicsContext).defaultFillStyle);
        this.update();
    }
    /** A fillstyle that will be used on the text stroke, e.g., 'blue', '#FCFF00'. */ get stroke() {
        return this._originalStroke;
    }
    set stroke(value) {
        if (value === this._originalStroke) return;
        this._originalStroke = value;
        if (this._isFillStyle(value)) this._originalStroke = this._createProxy({
            ...(0, $lP6io.GraphicsContext).defaultStrokeStyle,
            ...value
        }, ()=>{
            this._stroke = (0, $3lOoE.toStrokeStyle)({
                ...this._originalStroke
            }, (0, $lP6io.GraphicsContext).defaultStrokeStyle);
        });
        this._stroke = (0, $3lOoE.toStrokeStyle)(value, (0, $lP6io.GraphicsContext).defaultStrokeStyle);
        this.update();
    }
    /**
   * Custom styles to apply to specific tags within the text.
   * Allows for rich text formatting using simple tag markup like `<red>text</red>`.
   *
   * Tags are only parsed when this property has entries. If `tagStyles` is undefined,
   * `<` characters in text are treated as literal.
   * @example
   * ```ts
   * const text = new Text({
   *     text: '<red>Red</red>, <blue>Blue</blue>',
   *     style: {
   *         fill: 'white',
   *         tagStyles: {
   *             red: { fill: 'red' },
   *             blue: { fill: 'blue' }
   *         }
   *     }
   * });
   * ```
   */ get tagStyles() {
        return this._tagStyles;
    }
    set tagStyles(value) {
        if (this._tagStyles === value) return;
        this._tagStyles = value ?? void 0;
        this.update();
    }
    update() {
        this._tick++;
        this._cachedFontString = null;
        this.emit("update", this);
    }
    /** Resets all properties to the default values */ reset() {
        const defaultStyle = _TextStyle.defaultTextStyle;
        for(const key in defaultStyle)this[key] = defaultStyle[key];
    }
    /**
   * Assigns partial style options to this TextStyle instance.
   * Uses public setters to ensure proper value transformation.
   * @param values - Partial style options to assign
   * @returns This TextStyle instance for chaining
   */ assign(values) {
        for(const key in values){
            const thisKey = key;
            this[thisKey] = values[key];
        }
        return this;
    }
    /**
   * Returns a unique key for this instance.
   * This key is used for caching.
   * @returns {string} Unique key for the instance
   */ get styleKey() {
        return `${this.uid}-${this._tick}`;
    }
    /**
   * Returns the CSS font string for this style, cached for performance.
   * @internal
   * @returns CSS font string
   */ get _fontString() {
        if (this._cachedFontString === null) this._cachedFontString = (0, $412c431785e258a2$export$b7b5edb82ac3fc66)(this);
        return this._cachedFontString;
    }
    /**
   * Returns an object with the same values as this TextStyle instance.
   * @returns Object with the same values as this TextStyle instance
   * @example
   * ```ts
   * const style = new TextStyle({
   *     fontSize: 24,
   *     fill: 0xff0000,
   *     stroke: { color: 0x0000ff, width: 2 }
   * });
   * const object = style.toObject();
   * console.log(object);
   * // { fontSize: 24, fill: 0xff0000, stroke: { color: 0x0000ff, width: 2 } }
   * ```
   */ _toObject() {
        return {
            align: this.align,
            breakWords: this.breakWords,
            dropShadow: this._dropShadow ? {
                ...this._dropShadow
            } : null,
            fill: this._fill ? {
                ...this._fill
            } : void 0,
            fontFamily: this.fontFamily,
            fontSize: this.fontSize,
            fontStyle: this.fontStyle,
            fontVariant: this.fontVariant,
            fontWeight: this.fontWeight,
            leading: this.leading,
            letterSpacing: this.letterSpacing,
            lineHeight: this.lineHeight,
            padding: this.padding,
            stroke: this._stroke ? {
                ...this._stroke
            } : void 0,
            textBaseline: this.textBaseline,
            trim: this.trim,
            whiteSpace: this.whiteSpace,
            wordWrap: this.wordWrap,
            wordWrapWidth: this.wordWrapWidth,
            filters: this._filters ? [
                ...this._filters
            ] : void 0,
            tagStyles: this._tagStyles ? {
                ...this._tagStyles
            } : void 0
        };
    }
    /**
   * Creates a new TextStyle object with the same values as this one.
   * @returns New cloned TextStyle object
   */ clone() {
        return new _TextStyle(this._toObject());
    }
    /**
   * Returns the final padding for the text style, taking into account any filters applied.
   * Used internally for correct measurements
   * @internal
   * @returns {number} The final padding for the text style.
   */ _getFinalPadding() {
        let filterPadding = 0;
        if (this._filters) for(let i = 0; i < this._filters.length; i++)filterPadding += this._filters[i].padding;
        return Math.max(this._padding, filterPadding);
    }
    /**
   * Destroys this text style.
   * @param options - Options parameter. A boolean will act as if all options
   *  have been set to that value
   * @example
   * // Destroy the text style and its textures
   * textStyle.destroy({ texture: true, textureSource: true });
   * textStyle.destroy(true);
   */ destroy(options = false) {
        this.removeAllListeners();
        const destroyTexture = typeof options === "boolean" ? options : options?.texture;
        if (destroyTexture) {
            const destroyTextureSource = typeof options === "boolean" ? options : options?.textureSource;
            if (this._fill?.texture) this._fill.texture.destroy(destroyTextureSource);
            if (this._originalFill?.texture) this._originalFill.texture.destroy(destroyTextureSource);
            if (this._stroke?.texture) this._stroke.texture.destroy(destroyTextureSource);
            if (this._originalStroke?.texture) this._originalStroke.texture.destroy(destroyTextureSource);
        }
        this._fill = null;
        this._stroke = null;
        this.dropShadow = null;
        this._originalStroke = null;
        this._originalFill = null;
    }
    _createProxy(value, cb) {
        return new Proxy(value, {
            set: (target, property, newValue)=>{
                if (target[property] === newValue) return true;
                target[property] = newValue;
                cb?.(property, newValue);
                this.update();
                return true;
            }
        });
    }
    _isFillStyle(value) {
        return (value ?? null) !== null && !((0, $jr7Dg.Color).isColorLike(value) || value instanceof (0, $4dwOg.FillGradient) || value instanceof (0, $jqDfq.FillPattern));
    }
};
/**
 * Default drop shadow settings used when enabling drop shadows on text.
 * These values are used as the base configuration when drop shadows are enabled without specific settings.
 * @example
 * ```ts
 * // Customize default settings globally
 * TextStyle.defaultDropShadow.alpha = 0.5;    // 50% opacity for all shadows
 * TextStyle.defaultDropShadow.blur = 2;       // 2px blur for all shadows
 * TextStyle.defaultDropShadow.color = 'blue'; // Blue shadows by default
 * ```
 */ $6572d68b0820a289$var$_TextStyle.defaultDropShadow = {
    alpha: 1,
    angle: Math.PI / 6,
    blur: 0,
    color: "black",
    distance: 5
};
/**
 * Default text style settings used when creating new text objects.
 * These values serve as the base configuration and can be customized globally.
 * @example
 * ```ts
 * // Customize default text style globally
 * TextStyle.defaultTextStyle.fontSize = 16;
 * TextStyle.defaultTextStyle.fill = 0x333333;
 * TextStyle.defaultTextStyle.fontFamily = ['Arial', 'Helvetica', 'sans-serif'];
 * ```
 */ $6572d68b0820a289$var$_TextStyle.defaultTextStyle = {
    align: "left",
    breakWords: false,
    dropShadow: null,
    fill: "black",
    fontFamily: "Arial",
    fontSize: 26,
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: "normal",
    leading: 0,
    letterSpacing: 0,
    lineHeight: 0,
    padding: 0,
    stroke: null,
    textBaseline: "alphabetic",
    trim: false,
    whiteSpace: "pre",
    wordWrap: false,
    wordWrapWidth: 100
};
let $6572d68b0820a289$export$1df879243bf2e42d = $6572d68b0820a289$var$_TextStyle;
function $6572d68b0820a289$var$convertV7Tov8Style(style) {
    const oldStyle = style;
    if (typeof oldStyle.dropShadow === "boolean" && oldStyle.dropShadow) {
        const defaults = $6572d68b0820a289$export$1df879243bf2e42d.defaultDropShadow;
        style.dropShadow = {
            alpha: oldStyle.dropShadowAlpha ?? defaults.alpha,
            angle: oldStyle.dropShadowAngle ?? defaults.angle,
            blur: oldStyle.dropShadowBlur ?? defaults.blur,
            color: oldStyle.dropShadowColor ?? defaults.color,
            distance: oldStyle.dropShadowDistance ?? defaults.distance
        };
    }
    if (oldStyle.strokeThickness !== void 0) {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "strokeThickness is now a part of stroke");
        const color = oldStyle.stroke;
        let obj = {};
        if ((0, $jr7Dg.Color).isColorLike(color)) obj.color = color;
        else if (color instanceof (0, $4dwOg.FillGradient) || color instanceof (0, $jqDfq.FillPattern)) obj.fill = color;
        else if (Object.hasOwnProperty.call(color, "color") || Object.hasOwnProperty.call(color, "fill")) obj = color;
        else throw new Error("Invalid stroke value.");
        style.stroke = {
            ...obj,
            width: oldStyle.strokeThickness
        };
    }
    if (Array.isArray(oldStyle.fillGradientStops)) {
        (0, $dXBy0.deprecation)((0, $dXBy0.v8_0_0), "gradient fill is now a fill pattern: `new FillGradient(...)`");
        if (!Array.isArray(oldStyle.fill) || oldStyle.fill.length === 0) throw new Error("Invalid fill value. Expected an array of colors for gradient fill.");
        if (oldStyle.fill.length !== oldStyle.fillGradientStops.length) (0, $fGITk.warn)("The number of fill colors must match the number of fill gradient stops.");
        const gradientFill = new (0, $4dwOg.FillGradient)({
            start: {
                x: 0,
                y: 0
            },
            end: {
                x: 0,
                y: 1
            },
            textureSpace: "local"
        });
        const fillGradientStops = oldStyle.fillGradientStops.slice();
        const fills = oldStyle.fill.map((color)=>(0, $jr7Dg.Color).shared.setValue(color).toNumber());
        fillGradientStops.forEach((stop, index)=>{
            gradientFill.addColorStop(stop, fills[index]);
        });
        style.fill = {
            fill: gradientFill
        };
    }
}



var $aBhlC = parcelRequire("aBhlC");

var $aBhlC = parcelRequire("aBhlC");

var $96EPk = parcelRequire("96EPk");

var $cfUjt = parcelRequire("cfUjt");
"use strict";
function $edb6a5361da324cf$export$cd6ce24a38c376aa(batchableSprite, text) {
    const { texture: texture, bounds: bounds } = batchableSprite;
    const padding = text._style._getFinalPadding();
    (0, $cfUjt.updateQuadBounds)(bounds, text._anchor, texture);
    const paddingOffset = text._anchor._x * padding * 2;
    const paddingOffsetY = text._anchor._y * padding * 2;
    bounds.minX -= padding - paddingOffset;
    bounds.minY -= padding - paddingOffsetY;
    bounds.maxX -= padding - paddingOffset;
    bounds.maxY -= padding - paddingOffsetY;
}



var $7nq8K = parcelRequire("7nq8K");
"use strict";
class $3d47475b6bc04f48$export$f986f9176e9ba9b4 extends (0, $7nq8K.BatchableSprite) {
}


"use strict";
class $e0f8f11146d10a8f$export$ed0d779e44b53050 {
    constructor(renderer){
        this._renderer = renderer;
        renderer.runners.resolutionChange.add(this);
        this._managedTexts = new (0, $96EPk.GCManagedHash)({
            renderer: renderer,
            type: "renderable",
            onUnload: this.onTextUnload.bind(this),
            name: "canvasText"
        });
    }
    resolutionChange() {
        for(const key in this._managedTexts.items){
            const text = this._managedTexts.items[key];
            if (text?._autoResolution) text.onViewUpdate();
        }
    }
    validateRenderable(text) {
        const gpuText = this._getGpuText(text);
        const newKey = text.styleKey;
        if (gpuText.currentKey !== newKey) return true;
        return text._didTextUpdate;
    }
    addRenderable(text, instructionSet) {
        const batchableText = this._getGpuText(text);
        if (text._didTextUpdate) {
            const resolution = text._autoResolution ? this._renderer.resolution : text.resolution;
            if (batchableText.currentKey !== text.styleKey || text._resolution !== resolution) this._updateGpuText(text);
            text._didTextUpdate = false;
            (0, $edb6a5361da324cf$export$cd6ce24a38c376aa)(batchableText, text);
        }
        this._renderer.renderPipes.batch.addToBatch(batchableText, instructionSet);
    }
    updateRenderable(text) {
        const batchableText = this._getGpuText(text);
        batchableText._batcher.updateElement(batchableText);
    }
    _updateGpuText(text) {
        const batchableText = this._getGpuText(text);
        if (batchableText.texture) this._renderer.canvasText.decreaseReferenceCount(batchableText.currentKey);
        text._resolution = text._autoResolution ? this._renderer.resolution : text.resolution;
        batchableText.texture = this._renderer.canvasText.getManagedTexture(text);
        batchableText.currentKey = text.styleKey;
    }
    _getGpuText(text) {
        return text._gpuData[this._renderer.uid] || this.initGpuText(text);
    }
    initGpuText(text) {
        const batchableText = new (0, $3d47475b6bc04f48$export$f986f9176e9ba9b4)();
        batchableText.currentKey = "--";
        batchableText.renderable = text;
        batchableText.transform = text.groupTransform;
        batchableText.bounds = {
            minX: 0,
            maxX: 1,
            minY: 0,
            maxY: 0
        };
        batchableText.roundPixels = this._renderer._roundPixels | text._roundPixels;
        text._gpuData[this._renderer.uid] = batchableText;
        this._managedTexts.add(text);
        return batchableText;
    }
    onTextUnload(text) {
        const gpuData = text._gpuData[this._renderer.uid];
        if (!gpuData) return;
        const { canvasText: canvasText } = this._renderer;
        const refCount = canvasText.getReferenceCount(gpuData.currentKey);
        if (refCount > 0) canvasText.decreaseReferenceCount(gpuData.currentKey);
        else if (gpuData.texture) canvasText.returnTexture(gpuData.texture);
    }
    destroy() {
        this._managedTexts.destroy();
        this._renderer = null;
    }
}
/** @ignore */ $e0f8f11146d10a8f$export$ed0d779e44b53050.extension = {
    type: [
        (0, $aBhlC.ExtensionType).WebGLPipes,
        (0, $aBhlC.ExtensionType).WebGPUPipes,
        (0, $aBhlC.ExtensionType).CanvasPipes
    ],
    name: "text"
};



var $aBhlC = parcelRequire("aBhlC");

var $cOfCf = parcelRequire("cOfCf");

var $ju4z4 = parcelRequire("ju4z4");

var $dXBy0 = parcelRequire("dXBy0");



var $5UA0V = parcelRequire("5UA0V");
"use strict";
class $4223b39091df9b40$export$1f58c6bd1c266764 {
    constructor(renderer, retainCanvasContext){
        this._activeTextures = {};
        this._renderer = renderer;
        this._retainCanvasContext = retainCanvasContext;
    }
    getTexture(options, _resolution, _style, _textKey) {
        if (typeof options === "string") {
            (0, $dXBy0.deprecation)("8.0.0", "CanvasTextSystem.getTexture: Use object TextOptions instead of separate arguments");
            options = {
                text: options,
                style: _style,
                resolution: _resolution
            };
        }
        if (!(options.style instanceof (0, $6572d68b0820a289$export$1df879243bf2e42d))) options.style = new (0, $6572d68b0820a289$export$1df879243bf2e42d)(options.style);
        if (!(options.textureStyle instanceof (0, $ju4z4.TextureStyle))) options.textureStyle = new (0, $ju4z4.TextureStyle)(options.textureStyle);
        if (typeof options.text !== "string") options.text = options.text.toString();
        const { text: text, style: style, textureStyle: textureStyle, autoGenerateMipmaps: autoGenerateMipmaps } = options;
        const resolution = options.resolution ?? this._renderer.resolution;
        const { frame: frame, canvasAndContext: canvasAndContext } = (0, $66bcd1818e5ec118$export$bb54b62b519176d5).getCanvasAndContext({
            text: text,
            style: style,
            resolution: resolution
        });
        const texture = (0, $5UA0V.getPo2TextureFromSource)(canvasAndContext.canvas, frame.width, frame.height, resolution, autoGenerateMipmaps);
        if (textureStyle) texture.source.style = textureStyle;
        if (style.trim) {
            frame.pad(style.padding);
            texture.frame.copyFrom(frame);
            texture.frame.scale(1 / resolution);
            texture.updateUvs();
        }
        if (style.filters) {
            const filteredTexture = this._applyFilters(texture, style.filters);
            this.returnTexture(texture);
            (0, $66bcd1818e5ec118$export$bb54b62b519176d5).returnCanvasAndContext(canvasAndContext);
            return filteredTexture;
        }
        this._renderer.texture.initSource(texture._source);
        if (!this._retainCanvasContext) (0, $66bcd1818e5ec118$export$bb54b62b519176d5).returnCanvasAndContext(canvasAndContext);
        return texture;
    }
    /**
   * Returns a texture that was created wit the above `getTexture` function.
   * Handy if you are done with a texture and want to return it to the pool.
   * @param texture - The texture to be returned.
   */ returnTexture(texture) {
        const source = texture.source;
        const resource = source.resource;
        if (this._retainCanvasContext && resource?.getContext) {
            const context = resource.getContext("2d");
            if (context) (0, $66bcd1818e5ec118$export$bb54b62b519176d5).returnCanvasAndContext({
                canvas: resource,
                context: context
            });
        }
        source.resource = null;
        source.uploadMethodId = "unknown";
        source.alphaMode = "no-premultiply-alpha";
        (0, $cOfCf.TexturePool).returnTexture(texture, true);
    }
    /**
   * Renders text to its canvas, and updates its texture.
   * @deprecated since 8.10.0
   */ renderTextToCanvas() {
        (0, $dXBy0.deprecation)("8.10.0", "CanvasTextSystem.renderTextToCanvas: no longer supported, use CanvasTextSystem.getTexture instead");
    }
    /**
   * Gets or creates a managed texture for a Text object. This method handles texture reuse and reference counting.
   * @param text - The Text object that needs a texture
   * @returns A Texture instance that represents the rendered text
   * @remarks
   * This method performs the following:
   * 1. Sets the appropriate resolution based on auto-resolution settings
   * 2. Checks if a texture already exists for the text's style
   * 3. Creates a new texture if needed or returns an existing one
   * 4. Manages reference counting for texture reuse
   */ getManagedTexture(text) {
        text._resolution = text._autoResolution ? this._renderer.resolution : text.resolution;
        const textKey = text.styleKey;
        if (this._activeTextures[textKey]) {
            this._increaseReferenceCount(textKey);
            return this._activeTextures[textKey].texture;
        }
        const texture = this.getTexture({
            text: text.text,
            style: text.style,
            resolution: text._resolution,
            textureStyle: text.textureStyle,
            autoGenerateMipmaps: text.autoGenerateMipmaps
        });
        this._activeTextures[textKey] = {
            texture: texture,
            usageCount: 1
        };
        return texture;
    }
    /**
   * Decreases the reference count for a texture associated with a text key.
   * When the reference count reaches zero, the texture is returned to the pool.
   * @param textKey - The unique key identifying the text style configuration
   * @remarks
   * This method is crucial for memory management, ensuring textures are properly
   * cleaned up when they are no longer needed by any Text instances.
   */ decreaseReferenceCount(textKey) {
        const activeTexture = this._activeTextures[textKey];
        if (!activeTexture) return;
        activeTexture.usageCount--;
        if (activeTexture.usageCount === 0) {
            this.returnTexture(activeTexture.texture);
            this._activeTextures[textKey] = null;
        }
    }
    /**
   * Gets the current reference count for a texture associated with a text key.
   * @param textKey - The unique key identifying the text style configuration
   * @returns The number of Text instances currently using this texture
   */ getReferenceCount(textKey) {
        return this._activeTextures[textKey]?.usageCount ?? 0;
    }
    _increaseReferenceCount(textKey) {
        this._activeTextures[textKey].usageCount++;
    }
    /**
   * Applies the specified filters to the given texture.
   *
   * This method takes a texture and a list of filters, applies the filters to the texture,
   * and returns the resulting texture. It also ensures that the alpha mode of the resulting
   * texture is set to 'premultiplied-alpha'.
   * @param {Texture} texture - The texture to which the filters will be applied.
   * @param {Filter[]} filters - The filters to apply to the texture.
   * @returns {Texture} The resulting texture after all filters have been applied.
   */ _applyFilters(texture, filters) {
        const currentRenderTarget = this._renderer.renderTarget.renderTarget;
        const resultTexture = this._renderer.filter.generateFilteredTexture({
            texture: texture,
            filters: filters
        });
        this._renderer.renderTarget.bind(currentRenderTarget, false);
        return resultTexture;
    }
    destroy() {
        this._renderer = null;
        for(const key in this._activeTextures)if (this._activeTextures[key]) this.returnTexture(this._activeTextures[key].texture);
        this._activeTextures = null;
    }
}


"use strict";
class $20512998d06d48d5$export$b13c6e11d8ae9690 extends (0, $4223b39091df9b40$export$1f58c6bd1c266764) {
    constructor(renderer){
        super(renderer, true);
    }
}
/** @ignore */ $20512998d06d48d5$export$b13c6e11d8ae9690.extension = {
    type: [
        (0, $aBhlC.ExtensionType).CanvasSystem
    ],
    name: "canvasText"
};



var $aBhlC = parcelRequire("aBhlC");

"use strict";
class $72ab42381958a2f5$export$56e4907c2e518abc extends (0, $4223b39091df9b40$export$1f58c6bd1c266764) {
    constructor(renderer){
        super(renderer, false);
    }
}
/** @ignore */ $72ab42381958a2f5$export$56e4907c2e518abc.extension = {
    type: [
        (0, $aBhlC.ExtensionType).WebGLSystem,
        (0, $aBhlC.ExtensionType).WebGPUSystem
    ],
    name: "canvasText"
};


"use strict";
(0, $aBhlC.extensions).add((0, $20512998d06d48d5$export$b13c6e11d8ae9690));
(0, $aBhlC.extensions).add((0, $72ab42381958a2f5$export$56e4907c2e518abc));
(0, $aBhlC.extensions).add((0, $e0f8f11146d10a8f$export$ed0d779e44b53050));


"use strict";
class $fb07824581091256$export$5f1af8db9871e1d6 extends (0, $b087d7baf1b2c902$export$daf74670712de91) {
    constructor(...args){
        const options = (0, $b087d7baf1b2c902$export$8ddfb4f614f8ed86)(args, "Text");
        super(options, (0, $6572d68b0820a289$export$1df879243bf2e42d));
        /** @internal */ this.renderPipeId = "text";
        if (options.textureStyle) this.textureStyle = options.textureStyle instanceof (0, $ju4z4.TextureStyle) ? options.textureStyle : new (0, $ju4z4.TextureStyle)(options.textureStyle);
        this.autoGenerateMipmaps = options.autoGenerateMipmaps ?? (0, $gl1XZ.TextureSource).defaultOptions.autoGenerateMipmaps;
    }
    /** @private */ updateBounds() {
        const bounds = this._bounds;
        const anchor = this._anchor;
        let width = 0;
        let height = 0;
        if (this._style.trim) {
            const { frame: frame, canvasAndContext: canvasAndContext } = (0, $66bcd1818e5ec118$export$bb54b62b519176d5).getCanvasAndContext({
                text: this.text,
                style: this._style,
                resolution: 1
            });
            (0, $66bcd1818e5ec118$export$bb54b62b519176d5).returnCanvasAndContext(canvasAndContext);
            width = frame.width;
            height = frame.height;
        } else {
            const canvasMeasurement = (0, $8cd48e3f940344a0$export$b12f6bdc825d944f).measureText(this._text, this._style);
            width = canvasMeasurement.width;
            height = canvasMeasurement.height;
        }
        bounds.minX = -anchor._x * width;
        bounds.maxX = bounds.minX + width;
        bounds.minY = -anchor._y * height;
        bounds.maxY = bounds.minY + height;
    }
}












var $lcv0T = parcelRequire("lcv0T");










var $6AQ4q = parcelRequire("6AQ4q");




















"use strict";
(0, $aBhlC.extensions).add((0, $b92bf6e5010c4fa3$export$a6aad6334ef58a1c), (0, $16ff22dbf358da86$export$ee43dd1acddf6cf8));


var $bcTIE = parcelRequire("bcTIE");

var $5Wp7K = parcelRequire("5Wp7K");
var $lwGvb = parcelRequire("lwGvb");
var $kNl9L = parcelRequire("kNl9L");
var $lcv0T = parcelRequire("lcv0T");
var $762e77127186c3c6$var$S = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $762e77127186c3c6$var$M(l) {
    return l && l.__esModule && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;
}
var $762e77127186c3c6$var$W = {
    exports: {}
};
(function(l, t) {
    (function() {
        var e, n;
        n = function(i) {
            return l.exports = i;
        }, e = {
            linear: function(i, s, h, o) {
                return h * i / o + s;
            },
            easeInQuad: function(i, s, h, o) {
                return h * (i /= o) * i + s;
            },
            easeOutQuad: function(i, s, h, o) {
                return -h * (i /= o) * (i - 2) + s;
            },
            easeInOutQuad: function(i, s, h, o) {
                return (i /= o / 2) < 1 ? h / 2 * i * i + s : -h / 2 * (--i * (i - 2) - 1) + s;
            },
            easeInCubic: function(i, s, h, o) {
                return h * (i /= o) * i * i + s;
            },
            easeOutCubic: function(i, s, h, o) {
                return h * ((i = i / o - 1) * i * i + 1) + s;
            },
            easeInOutCubic: function(i, s, h, o) {
                return (i /= o / 2) < 1 ? h / 2 * i * i * i + s : h / 2 * ((i -= 2) * i * i + 2) + s;
            },
            easeInQuart: function(i, s, h, o) {
                return h * (i /= o) * i * i * i + s;
            },
            easeOutQuart: function(i, s, h, o) {
                return -h * ((i = i / o - 1) * i * i * i - 1) + s;
            },
            easeInOutQuart: function(i, s, h, o) {
                return (i /= o / 2) < 1 ? h / 2 * i * i * i * i + s : -h / 2 * ((i -= 2) * i * i * i - 2) + s;
            },
            easeInQuint: function(i, s, h, o) {
                return h * (i /= o) * i * i * i * i + s;
            },
            easeOutQuint: function(i, s, h, o) {
                return h * ((i = i / o - 1) * i * i * i * i + 1) + s;
            },
            easeInOutQuint: function(i, s, h, o) {
                return (i /= o / 2) < 1 ? h / 2 * i * i * i * i * i + s : h / 2 * ((i -= 2) * i * i * i * i + 2) + s;
            },
            easeInSine: function(i, s, h, o) {
                return -h * Math.cos(i / o * (Math.PI / 2)) + h + s;
            },
            easeOutSine: function(i, s, h, o) {
                return h * Math.sin(i / o * (Math.PI / 2)) + s;
            },
            easeInOutSine: function(i, s, h, o) {
                return -h / 2 * (Math.cos(Math.PI * i / o) - 1) + s;
            },
            easeInExpo: function(i, s, h, o) {
                return i === 0 ? s : h * Math.pow(2, 10 * (i / o - 1)) + s;
            },
            easeOutExpo: function(i, s, h, o) {
                return i === o ? s + h : h * (-Math.pow(2, -10 * i / o) + 1) + s;
            },
            easeInOutExpo: function(i, s, h, o) {
                return (i /= o / 2) < 1 ? h / 2 * Math.pow(2, 10 * (i - 1)) + s : h / 2 * (-Math.pow(2, -10 * --i) + 2) + s;
            },
            easeInCirc: function(i, s, h, o) {
                return -h * (Math.sqrt(1 - (i /= o) * i) - 1) + s;
            },
            easeOutCirc: function(i, s, h, o) {
                return h * Math.sqrt(1 - (i = i / o - 1) * i) + s;
            },
            easeInOutCirc: function(i, s, h, o) {
                return (i /= o / 2) < 1 ? -h / 2 * (Math.sqrt(1 - i * i) - 1) + s : h / 2 * (Math.sqrt(1 - (i -= 2) * i) + 1) + s;
            },
            easeInElastic: function(i, s, h, o) {
                var r, a, p;
                return p = 1.70158, a = 0, r = h, i === 0 || (i /= o), a || (a = o * 0.3), r < Math.abs(h) ? (r = h, p = a / 4) : p = a / (2 * Math.PI) * Math.asin(h / r), -(r * Math.pow(2, 10 * (i -= 1)) * Math.sin((i * o - p) * (2 * Math.PI) / a)) + s;
            },
            easeOutElastic: function(i, s, h, o) {
                var r, a, p;
                return p = 1.70158, a = 0, r = h, i === 0 || (i /= o), a || (a = o * 0.3), r < Math.abs(h) ? (r = h, p = a / 4) : p = a / (2 * Math.PI) * Math.asin(h / r), r * Math.pow(2, -10 * i) * Math.sin((i * o - p) * (2 * Math.PI) / a) + h + s;
            },
            easeInOutElastic: function(i, s, h, o) {
                var r, a, p;
                return p = 1.70158, a = 0, r = h, i === 0 || (i /= o / 2), a || (a = o * (0.3 * 1.5)), r < Math.abs(h) ? (r = h, p = a / 4) : p = a / (2 * Math.PI) * Math.asin(h / r), i < 1 ? -0.5 * (r * Math.pow(2, 10 * (i -= 1)) * Math.sin((i * o - p) * (2 * Math.PI) / a)) + s : r * Math.pow(2, -10 * (i -= 1)) * Math.sin((i * o - p) * (2 * Math.PI) / a) * 0.5 + h + s;
            },
            easeInBack: function(i, s, h, o, r) {
                return r === void 0 && (r = 1.70158), h * (i /= o) * i * ((r + 1) * i - r) + s;
            },
            easeOutBack: function(i, s, h, o, r) {
                return r === void 0 && (r = 1.70158), h * ((i = i / o - 1) * i * ((r + 1) * i + r) + 1) + s;
            },
            easeInOutBack: function(i, s, h, o, r) {
                return r === void 0 && (r = 1.70158), (i /= o / 2) < 1 ? h / 2 * (i * i * (((r *= 1.525) + 1) * i - r)) + s : h / 2 * ((i -= 2) * i * (((r *= 1.525) + 1) * i + r) + 2) + s;
            },
            easeInBounce: function(i, s, h, o) {
                var r;
                return r = e.easeOutBounce(o - i, 0, h, o), h - r + s;
            },
            easeOutBounce: function(i, s, h, o) {
                return (i /= o) < 1 / 2.75 ? h * (7.5625 * i * i) + s : i < 2 / 2.75 ? h * (7.5625 * (i -= 1.5 / 2.75) * i + 0.75) + s : i < 2.5 / 2.75 ? h * (7.5625 * (i -= 2.25 / 2.75) * i + 0.9375) + s : h * (7.5625 * (i -= 2.625 / 2.75) * i + 0.984375) + s;
            },
            easeInOutBounce: function(i, s, h, o) {
                var r;
                return i < o / 2 ? (r = e.easeInBounce(i * 2, 0, h, o), r * 0.5 + s) : (r = e.easeOutBounce(i * 2 - o, 0, h, o), r * 0.5 + h * 0.5 + s);
            }
        }, n(e);
    }).call($762e77127186c3c6$var$S);
})($762e77127186c3c6$var$W);
var $762e77127186c3c6$var$O = $762e77127186c3c6$var$W.exports;
const $762e77127186c3c6$var$v = /* @__PURE__ */ $762e77127186c3c6$var$M($762e77127186c3c6$var$O);
function $762e77127186c3c6$var$x(l, t) {
    if (l) {
        if (typeof l == "function") return l;
        if (typeof l == "string") return $762e77127186c3c6$var$v[l];
    } else return $762e77127186c3c6$var$v[t];
}
class $762e77127186c3c6$export$2da2653229140a6c {
    constructor(t){
        this.viewport = t, this.touches = [], this.addListeners();
    }
    /** Add input listeners */ addListeners() {
        this.viewport.eventMode = "static", this.viewport.forceHitArea || (this.viewport.hitArea = new (0, $kNl9L.Rectangle)(0, 0, this.viewport.worldWidth, this.viewport.worldHeight)), this.viewport.on("pointerdown", this.down, this), this.viewport.options.allowPreserveDragOutside ? this.viewport.on("globalpointermove", this.move, this) : this.viewport.on("pointermove", this.move, this), this.viewport.on("pointerup", this.up, this), this.viewport.on("pointerupoutside", this.up, this), this.viewport.on("pointercancel", this.up, this), this.viewport.options.allowPreserveDragOutside || this.viewport.on("pointerleave", this.up, this), this.wheelFunction = (t)=>this.handleWheel(t), this.viewport.options.events.domElement.addEventListener("wheel", this.wheelFunction, {
            passive: this.viewport.options.passiveWheel
        }), this.isMouseDown = !1;
    }
    /**
   * Removes all event listeners from viewport
   * (useful for cleanup of wheel when removing viewport)
   */ destroy() {
        var t;
        (t = this.viewport.options.events.domElement) == null || t.removeEventListener("wheel", this.wheelFunction);
    }
    /**
   * handle down events for viewport
   *
   * @param {PIXI.FederatedPointerEvent} event
   */ down(t) {
        if (this.viewport.pause || !this.viewport.visible) return;
        if (t.pointerType === "mouse" ? this.isMouseDown = !0 : this.get(t.pointerId) || this.touches.push({
            id: t.pointerId,
            last: null
        }), this.count() === 1) {
            this.last = t.global.clone();
            const n = this.viewport.plugins.get("decelerate", !0), i = this.viewport.plugins.get("bounce", !0);
            (!n || !n.isActive()) && (!i || !i.isActive()) ? this.clickedAvailable = !0 : this.clickedAvailable = !1;
        } else this.clickedAvailable = !1;
        this.viewport.plugins.down(t) && this.viewport.options.stopPropagation && t.stopPropagation();
    }
    /** Clears all pointer events */ clear() {
        this.isMouseDown = !1, this.touches = [], this.last = null;
    }
    /**
   * @param {number} change
   * @returns whether change exceeds threshold
   */ checkThreshold(t) {
        return Math.abs(t) >= this.viewport.threshold;
    }
    /** Handle move events for viewport */ move(t) {
        if (this.viewport.pause || !this.viewport.visible) return;
        const e = this.viewport.plugins.move(t);
        if (this.clickedAvailable && this.last) {
            const n = t.global.x - this.last.x, i = t.global.y - this.last.y;
            (this.checkThreshold(n) || this.checkThreshold(i)) && (this.clickedAvailable = !1);
        }
        e && this.viewport.options.stopPropagation && t.stopPropagation();
    }
    /** Handle up events for viewport */ up(t) {
        if (this.viewport.pause || !this.viewport.visible) return;
        t.pointerType === "mouse" && (this.isMouseDown = !1), t.pointerType !== "mouse" && this.remove(t.pointerId);
        const e = this.viewport.plugins.up(t);
        this.clickedAvailable && this.count() === 0 && this.last && (this.viewport.emit("clicked", {
            event: t,
            screen: this.last,
            world: this.viewport.toWorld(this.last),
            viewport: this.viewport
        }), this.clickedAvailable = !1), e && this.viewport.options.stopPropagation && t.stopPropagation();
    }
    /** Gets pointer position if this.interaction is set */ getPointerPosition(t) {
        const e = new (0, $lwGvb.Point)();
        return this.viewport.options.events.mapPositionToPoint(e, t.clientX, t.clientY), e;
    }
    /** Handle wheel events */ handleWheel(t) {
        if (this.viewport.pause || !this.viewport.visible) return;
        const e = this.viewport.toLocal(this.getPointerPosition(t));
        this.viewport.left <= e.x && e.x <= this.viewport.right && this.viewport.top <= e.y && e.y <= this.viewport.bottom && this.viewport.plugins.wheel(t) && !this.viewport.options.passiveWheel && t.preventDefault();
    }
    pause() {
        this.touches = [], this.isMouseDown = !1;
    }
    /** Get touch by id */ get(t) {
        for (const e of this.touches)if (e.id === t) return e;
        return null;
    }
    /** Remove touch by number */ remove(t) {
        for(let e = 0; e < this.touches.length; e++)if (this.touches[e].id === t) {
            this.touches.splice(e, 1);
            return;
        }
    }
    /**
   * @returns {number} count of mouse/touch pointers that are down on the viewport
   */ count() {
        return (this.isMouseDown ? 1 : 0) + this.touches.length;
    }
}
const $762e77127186c3c6$var$m = [
    "drag",
    "pinch",
    "wheel",
    "follow",
    "mouse-edges",
    "decelerate",
    "animate",
    "bounce",
    "snap-zoom",
    "clamp-zoom",
    "snap",
    "clamp"
];
class $762e77127186c3c6$export$f2c0a16002429d72 {
    /** This is called by {@link Viewport} to initialize the {@link Viewport.plugins plugins}. */ constructor(t){
        this.viewport = t, this.list = [], this.plugins = {};
    }
    /**
   * Inserts a named plugin or a user plugin into the viewport
   * default plugin order: 'drag', 'pinch', 'wheel', 'follow', 'mouse-edges', 'decelerate', 'bounce',
   * 'snap-zoom', 'clamp-zoom', 'snap', 'clamp'
   *
   * @param {string} name of plugin
   * @param {Plugin} plugin - instantiated Plugin class
   * @param {number} index to insert userPlugin (otherwise inserts it at the end)
   */ add(t, e, n = $762e77127186c3c6$var$m.length) {
        const i = this.plugins[t];
        i && i.destroy(), this.plugins[t] = e;
        const s = $762e77127186c3c6$var$m.indexOf(t);
        s !== -1 && $762e77127186c3c6$var$m.splice(s, 1), $762e77127186c3c6$var$m.splice(n, 0, t), this.sort();
    }
    /**
   * Get plugin
   *
   * @param {string} name of plugin
   * @param {boolean} [ignorePaused] return null if plugin is paused
   */ get(t, e) {
        var n;
        return e && (n = this.plugins[t]) != null && n.paused ? null : this.plugins[t];
    }
    /**
   * Update all active plugins
   *
   * @internal
   * @ignore
   * @param {number} elapsed type in milliseconds since last update
   */ update(t) {
        for (const e of this.list)e.update(t);
    }
    /**
   * Resize all active plugins
   *
   * @internal
   * @ignore
   */ resize() {
        for (const t of this.list)t.resize();
    }
    /** Clamps and resets bounce and decelerate (as needed) after manually moving viewport */ reset() {
        for (const t of this.list)t.reset();
    }
    /** removes all installed plugins */ removeAll() {
        this.list.forEach((t)=>{
            t.destroy();
        }), this.plugins = {}, this.sort();
    }
    /**
   * Removes installed plugin
   *
   * @param {string} name of plugin (e.g., 'drag', 'pinch')
   */ remove(t) {
        var e;
        this.plugins[t] && ((e = this.plugins[t]) == null || e.destroy(), delete this.plugins[t], this.viewport.emit("plugin-remove", t), this.sort());
    }
    /**
   * Pause plugin
   *
   * @param {string} name of plugin (e.g., 'drag', 'pinch')
   */ pause(t) {
        var e;
        (e = this.plugins[t]) == null || e.pause();
    }
    /**
   * Resume plugin
   *
   * @param {string} name of plugin (e.g., 'drag', 'pinch')
   */ resume(t) {
        var e;
        (e = this.plugins[t]) == null || e.resume();
    }
    /**
   * Sort plugins according to PLUGIN_ORDER
   *
   * @internal
   * @ignore
   */ sort() {
        this.list = [];
        for (const t of $762e77127186c3c6$var$m)this.plugins[t] && this.list.push(this.plugins[t]);
    }
    /**
   * Handle down for all plugins
   *
   * @internal
   * @ignore
   */ down(t) {
        let e = !1;
        for (const n of this.list)n.down(t) && (e = !0);
        return e;
    }
    /**
   * Handle move for all plugins
   *
   * @internal
   * @ignore
   */ move(t) {
        let e = !1;
        for (const n of this.viewport.plugins.list)n.move(t) && (e = !0);
        return e;
    }
    /**
   * Handle up for all plugins
   *
   * @internal
   * @ignore
   */ up(t) {
        let e = !1;
        for (const n of this.list)n.up(t) && (e = !0);
        return e;
    }
    /**
   * Handle wheel event for all plugins
   *
   * @internal
   * @ignore
   */ wheel(t) {
        let e = !1;
        for (const n of this.list)n.wheel(t) && (e = !0);
        return e;
    }
}
class $762e77127186c3c6$export$901cf72dabf2112a {
    /** @param {Viewport} parent */ constructor(t){
        this.parent = t, this.paused = !1;
    }
    /** Called when plugin is removed */ destroy() {}
    /** Handler for pointerdown PIXI event */ down(t) {
        return !1;
    }
    /** Handler for pointermove PIXI event */ move(t) {
        return !1;
    }
    /** Handler for pointerup PIXI event */ up(t) {
        return !1;
    }
    /** Handler for wheel event on div */ wheel(t) {
        return !1;
    }
    /**
   * Called on each tick
   * @param {number} elapsed time in millisecond since last update
   */ update(t) {}
    /** Called when the viewport is resized */ resize() {}
    /** Called when the viewport is manually moved */ reset() {}
    /** Pause the plugin */ pause() {
        this.paused = !0;
    }
    /** Un-pause the plugin */ resume() {
        this.paused = !1;
    }
}
const $762e77127186c3c6$var$I = {
    removeOnInterrupt: !1,
    ease: "linear",
    time: 1e3
};
class $762e77127186c3c6$export$83a1293bbde53b95 extends $762e77127186c3c6$export$901cf72dabf2112a {
    /**
   * This is called by {@link Viewport.animate}.
   *
   * @param parent
   * @param options
   */ constructor(t, e = {}){
        super(t), this.startWidth = null, this.startHeight = null, this.deltaWidth = null, this.deltaHeight = null, this.width = null, this.height = null, this.time = 0, this.options = Object.assign({}, $762e77127186c3c6$var$I, e), this.options.ease = $762e77127186c3c6$var$x(this.options.ease), this.setupPosition(), this.setupZoom(), this.time = 0;
    }
    /**
   * Setup `startX`, `startY`, `deltaX`, `deltaY`, `keepCenter`.
   *
   * This is called during construction.
   */ setupPosition() {
        typeof this.options.position < "u" ? (this.startX = this.parent.center.x, this.startY = this.parent.center.y, this.deltaX = this.options.position.x - this.parent.center.x, this.deltaY = this.options.position.y - this.parent.center.y, this.keepCenter = !1) : this.keepCenter = !0;
    }
    /**
   * Setup `startWidth, `startHeight`, `deltaWidth, `deltaHeight, `width`, `height`.
   *
   * This is called during construction.
   */ setupZoom() {
        this.width = null, this.height = null, typeof this.options.scale < "u" ? this.width = this.parent.screenWidth / this.options.scale : typeof this.options.scaleX < "u" || typeof this.options.scaleY < "u" ? (typeof this.options.scaleX < "u" && (this.width = this.parent.screenWidth / this.options.scaleX), typeof this.options.scaleY < "u" && (this.height = this.parent.screenHeight / this.options.scaleY)) : (typeof this.options.width < "u" && (this.width = this.options.width), typeof this.options.height < "u" && (this.height = this.options.height)), this.width !== null && (this.startWidth = this.parent.screenWidthInWorldPixels, this.deltaWidth = this.width - this.startWidth), this.height !== null && (this.startHeight = this.parent.screenHeightInWorldPixels, this.deltaHeight = this.height - this.startHeight);
    }
    down() {
        return this.options.removeOnInterrupt && this.parent.plugins.remove("animate"), !1;
    }
    complete() {
        this.parent.plugins.remove("animate"), this.width !== null && this.parent.fitWidth(this.width, this.keepCenter, this.height === null), this.height !== null && this.parent.fitHeight(this.height, this.keepCenter, this.width === null), !this.keepCenter && this.options.position && this.parent.moveCenter(this.options.position), this.parent.emit("animate-end", this.parent), this.options.callbackOnComplete && this.options.callbackOnComplete(this.parent);
    }
    update(t) {
        if (this.paused) return;
        this.time += t;
        const e = new (0, $lwGvb.Point)(this.parent.scale.x, this.parent.scale.y);
        if (this.time >= this.options.time) {
            const n = this.parent.width, i = this.parent.height;
            this.complete(), (n !== this.parent.width || i !== this.parent.height) && this.parent.emit("zoomed", {
                viewport: this.parent,
                original: e,
                type: "animate"
            });
        } else {
            const n = this.options.ease(this.time, 0, 1, this.options.time);
            if (this.width !== null) {
                const i = this.startWidth, s = this.deltaWidth;
                this.parent.fitWidth(i + s * n, this.keepCenter, this.height === null);
            }
            if (this.height !== null) {
                const i = this.startHeight, s = this.deltaHeight;
                this.parent.fitHeight(i + s * n, this.keepCenter, this.width === null);
            }
            if (this.width === null ? this.parent.scale.x = this.parent.scale.y : this.height === null && (this.parent.scale.y = this.parent.scale.x), !this.keepCenter) {
                const i = this.startX, s = this.startY, h = this.deltaX, o = this.deltaY, r = new (0, $lwGvb.Point)(this.parent.x, this.parent.y);
                this.parent.moveCenter(i + h * n, s + o * n), this.parent.emit("moved", {
                    viewport: this.parent,
                    original: r,
                    type: "animate"
                });
            }
            (this.width || this.height) && this.parent.emit("zoomed", {
                viewport: this.parent,
                original: e,
                type: "animate"
            });
        }
    }
}
const $762e77127186c3c6$var$Y = {
    sides: "all",
    friction: 0.5,
    time: 150,
    ease: "easeInOutSine",
    underflow: "center",
    bounceBox: null
};
class $762e77127186c3c6$export$d20e79fdc3899e95 extends $762e77127186c3c6$export$901cf72dabf2112a {
    /**
   * This is called by {@link Viewport.bounce}.
   */ constructor(t, e = {}){
        super(t), this.options = Object.assign({}, $762e77127186c3c6$var$Y, e), this.ease = $762e77127186c3c6$var$x(this.options.ease, "easeInOutSine"), this.options.sides ? this.options.sides === "all" ? this.top = this.bottom = this.left = this.right = !0 : this.options.sides === "horizontal" ? (this.right = this.left = !0, this.top = this.bottom = !1) : this.options.sides === "vertical" ? (this.left = this.right = !1, this.top = this.bottom = !0) : (this.top = this.options.sides.indexOf("top") !== -1, this.bottom = this.options.sides.indexOf("bottom") !== -1, this.left = this.options.sides.indexOf("left") !== -1, this.right = this.options.sides.indexOf("right") !== -1) : this.left = this.top = this.right = this.bottom = !1;
        const n = this.options.underflow.toLowerCase();
        n === "center" ? (this.underflowX = 0, this.underflowY = 0) : (this.underflowX = n.indexOf("left") !== -1 ? -1 : n.indexOf("right") !== -1 ? 1 : 0, this.underflowY = n.indexOf("top") !== -1 ? -1 : n.indexOf("bottom") !== -1 ? 1 : 0), this.reset();
    }
    isActive() {
        return this.toX !== null || this.toY !== null;
    }
    down() {
        return this.toX = this.toY = null, !1;
    }
    up() {
        return this.bounce(), !1;
    }
    update(t) {
        if (!this.paused) {
            if (this.bounce(), this.toX) {
                const e = this.toX;
                e.time += t, this.parent.emit("moved", {
                    viewport: this.parent,
                    type: "bounce-x"
                }), e.time >= this.options.time ? (this.parent.x = e.end, this.toX = null, this.parent.emit("bounce-x-end", this.parent)) : this.parent.x = this.ease(e.time, e.start, e.delta, this.options.time);
            }
            if (this.toY) {
                const e = this.toY;
                e.time += t, this.parent.emit("moved", {
                    viewport: this.parent,
                    type: "bounce-y"
                }), e.time >= this.options.time ? (this.parent.y = e.end, this.toY = null, this.parent.emit("bounce-y-end", this.parent)) : this.parent.y = this.ease(e.time, e.start, e.delta, this.options.time);
            }
        }
    }
    /** @internal */ calcUnderflowX() {
        let t;
        switch(this.underflowX){
            case -1:
                t = 0;
                break;
            case 1:
                t = this.parent.screenWidth - this.parent.screenWorldWidth;
                break;
            default:
                t = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
        }
        return t;
    }
    /** @internal */ calcUnderflowY() {
        let t;
        switch(this.underflowY){
            case -1:
                t = 0;
                break;
            case 1:
                t = this.parent.screenHeight - this.parent.screenWorldHeight;
                break;
            default:
                t = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
        }
        return t;
    }
    oob() {
        const t = this.options.bounceBox;
        if (t) {
            const e = typeof t.x > "u" ? 0 : t.x, n = typeof t.y > "u" ? 0 : t.y, i = typeof t.width > "u" ? this.parent.worldWidth : t.width, s = typeof t.height > "u" ? this.parent.worldHeight : t.height;
            return {
                left: this.parent.left < e,
                right: this.parent.right > i,
                top: this.parent.top < n,
                bottom: this.parent.bottom > s,
                topLeft: new (0, $lwGvb.Point)(e * this.parent.scale.x, n * this.parent.scale.y),
                bottomRight: new (0, $lwGvb.Point)(i * this.parent.scale.x - this.parent.screenWidth, s * this.parent.scale.y - this.parent.screenHeight)
            };
        }
        return {
            left: this.parent.left < 0,
            right: this.parent.right > this.parent.worldWidth,
            top: this.parent.top < 0,
            bottom: this.parent.bottom > this.parent.worldHeight,
            topLeft: new (0, $lwGvb.Point)(0, 0),
            bottomRight: new (0, $lwGvb.Point)(this.parent.worldWidth * this.parent.scale.x - this.parent.screenWidth, this.parent.worldHeight * this.parent.scale.y - this.parent.screenHeight)
        };
    }
    bounce() {
        var s, h;
        if (this.paused) return;
        let t, e = this.parent.plugins.get("decelerate", !0);
        e && (e.x || e.y) && (e.x && e.percentChangeX === ((s = e.options) == null ? void 0 : s.friction) || e.y && e.percentChangeY === ((h = e.options) == null ? void 0 : h.friction)) && (t = this.oob(), (t.left && this.left || t.right && this.right) && (e.percentChangeX = this.options.friction), (t.top && this.top || t.bottom && this.bottom) && (e.percentChangeY = this.options.friction));
        const n = this.parent.plugins.get("drag", !0) || {}, i = this.parent.plugins.get("pinch", !0) || {};
        if (e = e || {}, !(n != null && n.active) && !(i != null && i.active) && (!this.toX || !this.toY) && (!e.x || !e.y)) {
            t = t || this.oob();
            const o = t.topLeft, r = t.bottomRight;
            if (!this.toX && !e.x) {
                let a = null;
                t.left && this.left ? a = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : -o.x : t.right && this.right && (a = this.parent.screenWorldWidth < this.parent.screenWidth ? this.calcUnderflowX() : -r.x), a !== null && this.parent.x !== a && (this.toX = {
                    time: 0,
                    start: this.parent.x,
                    delta: a - this.parent.x,
                    end: a
                }, this.parent.emit("bounce-x-start", this.parent));
            }
            if (!this.toY && !e.y) {
                let a = null;
                t.top && this.top ? a = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : -o.y : t.bottom && this.bottom && (a = this.parent.screenWorldHeight < this.parent.screenHeight ? this.calcUnderflowY() : -r.y), a !== null && this.parent.y !== a && (this.toY = {
                    time: 0,
                    start: this.parent.y,
                    delta: a - this.parent.y,
                    end: a
                }, this.parent.emit("bounce-y-start", this.parent));
            }
        }
    }
    reset() {
        this.toX = this.toY = null, this.bounce();
    }
}
const $762e77127186c3c6$var$z = {
    left: !1,
    right: !1,
    top: !1,
    bottom: !1,
    direction: null,
    underflow: "center"
};
class $762e77127186c3c6$export$90534cad35a14134 extends $762e77127186c3c6$export$901cf72dabf2112a {
    /**
  * This is called by {@link Viewport.clamp}.
  */ constructor(t, e = {}){
        super(t), this.options = Object.assign({}, $762e77127186c3c6$var$z, e), this.options.direction && (this.options.left = this.options.direction === "x" || this.options.direction === "all" ? !0 : null, this.options.right = this.options.direction === "x" || this.options.direction === "all" ? !0 : null, this.options.top = this.options.direction === "y" || this.options.direction === "all" ? !0 : null, this.options.bottom = this.options.direction === "y" || this.options.direction === "all" ? !0 : null), this.parseUnderflow(), this.last = {
            x: null,
            y: null,
            scaleX: null,
            scaleY: null
        }, this.update();
    }
    parseUnderflow() {
        const t = this.options.underflow.toLowerCase();
        t === "none" ? this.noUnderflow = !0 : t === "center" ? (this.underflowX = this.underflowY = 0, this.noUnderflow = !1) : (this.underflowX = t.indexOf("left") !== -1 ? -1 : t.indexOf("right") !== -1 ? 1 : 0, this.underflowY = t.indexOf("top") !== -1 ? -1 : t.indexOf("bottom") !== -1 ? 1 : 0, this.noUnderflow = !1);
    }
    move() {
        return this.update(), !1;
    }
    update() {
        if (this.paused || this.parent.x === this.last.x && this.parent.y === this.last.y && this.parent.scale.x === this.last.scaleX && this.parent.scale.y === this.last.scaleY) return;
        const t = new (0, $lwGvb.Point)(this.parent.x, this.parent.y), e = this.parent.plugins.decelerate || {};
        if (this.options.left !== null || this.options.right !== null) {
            let n = !1;
            if (!this.noUnderflow && this.parent.screenWorldWidth < this.parent.screenWidth) switch(this.underflowX){
                case -1:
                    this.parent.x !== 0 && (this.parent.x = 0, n = !0);
                    break;
                case 1:
                    this.parent.x !== this.parent.screenWidth - this.parent.screenWorldWidth && (this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth, n = !0);
                    break;
                default:
                    this.parent.x !== (this.parent.screenWidth - this.parent.screenWorldWidth) / 2 && (this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2, n = !0);
            }
            else this.options.left !== null && this.parent.left < (this.options.left === !0 ? 0 : this.options.left) && (this.parent.x = -(this.options.left === !0 ? 0 : this.options.left) * this.parent.scale.x, e.x = 0, n = !0), this.options.right !== null && this.parent.right > (this.options.right === !0 ? this.parent.worldWidth : this.options.right) && (this.parent.x = -(this.options.right === !0 ? this.parent.worldWidth : this.options.right) * this.parent.scale.x + this.parent.screenWidth, e.x = 0, n = !0);
            n && this.parent.emit("moved", {
                viewport: this.parent,
                original: t,
                type: "clamp-x"
            });
        }
        if (this.options.top !== null || this.options.bottom !== null) {
            let n = !1;
            if (!this.noUnderflow && this.parent.screenWorldHeight < this.parent.screenHeight) switch(this.underflowY){
                case -1:
                    this.parent.y !== 0 && (this.parent.y = 0, n = !0);
                    break;
                case 1:
                    this.parent.y !== this.parent.screenHeight - this.parent.screenWorldHeight && (this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight, n = !0);
                    break;
                default:
                    this.parent.y !== (this.parent.screenHeight - this.parent.screenWorldHeight) / 2 && (this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2, n = !0);
            }
            else this.options.top !== null && this.parent.top < (this.options.top === !0 ? 0 : this.options.top) && (this.parent.y = -(this.options.top === !0 ? 0 : this.options.top) * this.parent.scale.y, e.y = 0, n = !0), this.options.bottom !== null && this.parent.bottom > (this.options.bottom === !0 ? this.parent.worldHeight : this.options.bottom) && (this.parent.y = -(this.options.bottom === !0 ? this.parent.worldHeight : this.options.bottom) * this.parent.scale.y + this.parent.screenHeight, e.y = 0, n = !0);
            n && this.parent.emit("moved", {
                viewport: this.parent,
                original: t,
                type: "clamp-y"
            });
        }
        this.last.x = this.parent.x, this.last.y = this.parent.y, this.last.scaleX = this.parent.scale.x, this.last.scaleY = this.parent.scale.y;
    }
    reset() {
        this.update();
    }
}
const $762e77127186c3c6$var$T = {
    minWidth: null,
    minHeight: null,
    maxWidth: null,
    maxHeight: null,
    minScale: null,
    maxScale: null
};
class $762e77127186c3c6$export$220d7a3461bca2df extends $762e77127186c3c6$export$901cf72dabf2112a {
    /**
   * This is called by {@link Viewport.clampZoom}.
   */ constructor(t, e = {}){
        super(t), this.options = Object.assign({}, $762e77127186c3c6$var$T, e), this.clamp();
    }
    resize() {
        this.clamp();
    }
    /** Clamp the viewport scale zoom) */ clamp() {
        if (!this.paused) {
            if (this.options.minWidth || this.options.minHeight || this.options.maxWidth || this.options.maxHeight) {
                let t = this.parent.worldScreenWidth, e = this.parent.worldScreenHeight;
                if (this.options.minWidth !== null && t < this.options.minWidth) {
                    const n = this.parent.scale.x;
                    this.parent.fitWidth(this.options.minWidth, !1, !1, !0), this.parent.scale.y *= this.parent.scale.x / n, t = this.parent.worldScreenWidth, e = this.parent.worldScreenHeight, this.parent.emit("zoomed", {
                        viewport: this.parent,
                        type: "clamp-zoom"
                    });
                }
                if (this.options.maxWidth !== null && t > this.options.maxWidth) {
                    const n = this.parent.scale.x;
                    this.parent.fitWidth(this.options.maxWidth, !1, !1, !0), this.parent.scale.y *= this.parent.scale.x / n, t = this.parent.worldScreenWidth, e = this.parent.worldScreenHeight, this.parent.emit("zoomed", {
                        viewport: this.parent,
                        type: "clamp-zoom"
                    });
                }
                if (this.options.minHeight !== null && e < this.options.minHeight) {
                    const n = this.parent.scale.y;
                    this.parent.fitHeight(this.options.minHeight, !1, !1, !0), this.parent.scale.x *= this.parent.scale.y / n, t = this.parent.worldScreenWidth, e = this.parent.worldScreenHeight, this.parent.emit("zoomed", {
                        viewport: this.parent,
                        type: "clamp-zoom"
                    });
                }
                if (this.options.maxHeight !== null && e > this.options.maxHeight) {
                    const n = this.parent.scale.y;
                    this.parent.fitHeight(this.options.maxHeight, !1, !1, !0), this.parent.scale.x *= this.parent.scale.y / n, this.parent.emit("zoomed", {
                        viewport: this.parent,
                        type: "clamp-zoom"
                    });
                }
            } else if (this.options.minScale || this.options.maxScale) {
                const t = {
                    x: null,
                    y: null
                }, e = {
                    x: null,
                    y: null
                };
                if (typeof this.options.minScale == "number") t.x = this.options.minScale, t.y = this.options.minScale;
                else if (this.options.minScale !== null) {
                    const s = this.options.minScale;
                    t.x = typeof s.x > "u" ? null : s.x, t.y = typeof s.y > "u" ? null : s.y;
                }
                if (typeof this.options.maxScale == "number") e.x = this.options.maxScale, e.y = this.options.maxScale;
                else if (this.options.maxScale !== null) {
                    const s = this.options.maxScale;
                    e.x = typeof s.x > "u" ? null : s.x, e.y = typeof s.y > "u" ? null : s.y;
                }
                let n = this.parent.scale.x, i = this.parent.scale.y;
                t.x !== null && n < t.x && (n = t.x), e.x !== null && n > e.x && (n = e.x), t.y !== null && i < t.y && (i = t.y), e.y !== null && i > e.y && (i = e.y), (n !== this.parent.scale.x || i !== this.parent.scale.y) && (this.parent.scale.set(n, i), this.parent.emit("zoomed", {
                    viewport: this.parent,
                    type: "clamp-zoom"
                }));
            }
        }
    }
    reset() {
        this.clamp();
    }
}
const $762e77127186c3c6$var$L = {
    friction: 0.98,
    bounce: 0.8,
    minSpeed: 0.01
}, $762e77127186c3c6$var$d = 16;
class $762e77127186c3c6$export$4bbb5144deae3118 extends $762e77127186c3c6$export$901cf72dabf2112a {
    /**
   * This is called by {@link Viewport.decelerate}.
   */ constructor(t, e = {}){
        super(t), this.options = Object.assign({}, $762e77127186c3c6$var$L, e), this.saved = [], this.timeSinceRelease = 0, this.reset(), this.parent.on("moved", (n)=>this.handleMoved(n));
    }
    down() {
        return this.saved = [], this.x = this.y = null, !1;
    }
    isActive() {
        return !!(this.x || this.y);
    }
    move() {
        if (this.paused) return !1;
        const t = this.parent.input.count();
        return (t === 1 || t > 1 && !this.parent.plugins.get("pinch", !0)) && (this.saved.push({
            x: this.parent.x,
            y: this.parent.y,
            time: performance.now()
        }), this.saved.length > 60 && this.saved.splice(0, 30)), !1;
    }
    /** Listener to viewport's "moved" event. */ handleMoved(t) {
        if (this.saved.length) {
            const e = this.saved[this.saved.length - 1];
            t.type === "clamp-x" && t.original ? e.x === t.original.x && (e.x = this.parent.x) : t.type === "clamp-y" && t.original && e.y === t.original.y && (e.y = this.parent.y);
        }
    }
    up() {
        if (this.parent.input.count() === 0 && this.saved.length) {
            const t = performance.now();
            for (const e of this.saved)if (e.time >= t - 100) {
                const n = t - e.time;
                this.x = (this.parent.x - e.x) / n, this.y = (this.parent.y - e.y) / n, this.percentChangeX = this.percentChangeY = this.options.friction, this.timeSinceRelease = 0;
                break;
            }
        }
        return !1;
    }
    /**
   * Manually activate deceleration, starting from the (x, y) velocity components passed in the options.
   *
   * @param {object} options
   * @param {number} [options.x] - Specify x-component of initial velocity.
   * @param {number} [options.y] - Specify y-component of initial velocity.
   */ activate(t) {
        t = t || {}, typeof t.x < "u" && (this.x = t.x, this.percentChangeX = this.options.friction), typeof t.y < "u" && (this.y = t.y, this.percentChangeY = this.options.friction);
    }
    update(t) {
        if (this.paused) return;
        const e = this.x || this.y, n = this.timeSinceRelease, i = this.timeSinceRelease + t;
        if (this.x) {
            const s = this.percentChangeX, h = Math.log(s);
            this.parent.x += this.x * $762e77127186c3c6$var$d / h * (Math.pow(s, i / $762e77127186c3c6$var$d) - Math.pow(s, n / $762e77127186c3c6$var$d)), this.x *= Math.pow(this.percentChangeX, t / $762e77127186c3c6$var$d);
        }
        if (this.y) {
            const s = this.percentChangeY, h = Math.log(s);
            this.parent.y += this.y * $762e77127186c3c6$var$d / h * (Math.pow(s, i / $762e77127186c3c6$var$d) - Math.pow(s, n / $762e77127186c3c6$var$d)), this.y *= Math.pow(this.percentChangeY, t / $762e77127186c3c6$var$d);
        }
        this.timeSinceRelease += t, this.x && this.y ? Math.abs(this.x) < this.options.minSpeed && Math.abs(this.y) < this.options.minSpeed && (this.x = 0, this.y = 0) : (Math.abs(this.x || 0) < this.options.minSpeed && (this.x = 0), Math.abs(this.y || 0) < this.options.minSpeed && (this.y = 0)), e && this.parent.emit("moved", {
            viewport: this.parent,
            type: "decelerate"
        });
    }
    reset() {
        this.x = this.y = null;
    }
}
const $762e77127186c3c6$var$D = {
    direction: "all",
    pressDrag: !0,
    wheel: !0,
    wheelScroll: 1,
    reverse: !1,
    clampWheel: !1,
    underflow: "center",
    factor: 1,
    mouseButtons: "all",
    keyToPress: null,
    ignoreKeyToPressOnTouch: !1,
    lineHeight: 20,
    wheelSwapAxes: !1
};
class $762e77127186c3c6$export$b48985bba8f530f5 extends $762e77127186c3c6$export$901cf72dabf2112a {
    /**
  * This is called by {@link Viewport.drag}.
  */ constructor(t, e = {}){
        super(t), this.windowEventHandlers = [], this.options = Object.assign({}, $762e77127186c3c6$var$D, e), this.moved = !1, this.reverse = this.options.reverse ? 1 : -1, this.xDirection = !this.options.direction || this.options.direction === "all" || this.options.direction === "x", this.yDirection = !this.options.direction || this.options.direction === "all" || this.options.direction === "y", this.keyIsPressed = !1, this.parseUnderflow(), this.mouseButtons(this.options.mouseButtons), this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
    }
    /**
  * Handles keypress events and set the keyIsPressed boolean accordingly
  *
  * @param {array} codes - key codes that can be used to trigger drag event
  */ handleKeyPresses(t) {
        const e = (i)=>{
            t.includes(i.code) && (this.keyIsPressed = !0);
        }, n = (i)=>{
            t.includes(i.code) && (this.keyIsPressed = !1);
        };
        this.addWindowEventHandler("keyup", n), this.addWindowEventHandler("keydown", e);
    }
    addWindowEventHandler(t, e) {
        typeof window > "u" || (window.addEventListener(t, e), this.windowEventHandlers.push({
            event: t,
            handler: e
        }));
    }
    destroy() {
        typeof window > "u" || this.windowEventHandlers.forEach(({ event: t, handler: e })=>{
            window.removeEventListener(t, e);
        });
    }
    /**
  * initialize mousebuttons array
  * @param {string} buttons
  */ mouseButtons(t) {
        !t || t === "all" ? this.mouse = [
            !0,
            !0,
            !0
        ] : this.mouse = [
            t.indexOf("left") !== -1,
            t.indexOf("middle") !== -1,
            t.indexOf("right") !== -1
        ];
    }
    parseUnderflow() {
        const t = this.options.underflow.toLowerCase();
        t === "center" ? (this.underflowX = 0, this.underflowY = 0) : (t.includes("left") ? this.underflowX = -1 : t.includes("right") ? this.underflowX = 1 : this.underflowX = 0, t.includes("top") ? this.underflowY = -1 : t.includes("bottom") ? this.underflowY = 1 : this.underflowY = 0);
    }
    /**
  * @param {PIXI.FederatedPointerEvent} event
  * @returns {boolean}
  */ checkButtons(t) {
        const e = t.pointerType === "mouse", n = this.parent.input.count();
        return !!((n === 1 || n > 1 && !this.parent.plugins.get("pinch", !0)) && (!e || this.mouse[t.button]));
    }
    /**
  * @param {PIXI.FederatedPointerEvent} event
  * @returns {boolean}
  */ checkKeyPress(t) {
        return !this.options.keyToPress || this.keyIsPressed || this.options.ignoreKeyToPressOnTouch && t.data.pointerType === "touch";
    }
    down(t) {
        return this.paused || !this.options.pressDrag ? !1 : this.checkButtons(t) && this.checkKeyPress(t) ? (this.last = {
            x: t.global.x,
            y: t.global.y
        }, (this.parent.parent || this.parent).toLocal(this.last, void 0, this.last), this.current = t.pointerId, !0) : (this.last = null, !1);
    }
    get active() {
        return this.moved;
    }
    move(t) {
        if (this.paused || !this.options.pressDrag) return !1;
        if (this.last && this.current === t.data.pointerId) {
            const e = t.global.x, n = t.global.y, i = this.parent.input.count();
            if (i === 1 || i > 1 && !this.parent.plugins.get("pinch", !0)) {
                const s = {
                    x: e,
                    y: n
                };
                (this.parent.parent || this.parent).toLocal(s, void 0, s);
                const h = s.x - this.last.x, o = s.y - this.last.y;
                if (this.moved || this.xDirection && this.parent.input.checkThreshold(h) || this.yDirection && this.parent.input.checkThreshold(o)) return this.xDirection && (this.parent.x += (s.x - this.last.x) * this.options.factor), this.yDirection && (this.parent.y += (s.y - this.last.y) * this.options.factor), this.last = s, this.moved || this.parent.emit("drag-start", {
                    event: t,
                    screen: new (0, $lwGvb.Point)(this.last.x, this.last.y),
                    world: this.parent.toWorld(new (0, $lwGvb.Point)(this.last.x, this.last.y)),
                    viewport: this.parent
                }), this.moved = !0, this.parent.emit("moved", {
                    viewport: this.parent,
                    type: "drag"
                }), !0;
            } else this.moved = !1;
        }
        return !1;
    }
    up(t) {
        if (this.paused) return !1;
        const e = this.parent.input.touches;
        if (e.length === 1) {
            const n = e[0];
            return n.last && (this.last = {
                x: n.last.x,
                y: n.last.y
            }, this.current = n.id), this.moved = !1, !0;
        } else if (this.last && this.moved) {
            const n = new (0, $lwGvb.Point)(this.last.x, this.last.y);
            return (this.parent.parent || this.parent).toGlobal(n, n, !0), this.parent.emit("drag-end", {
                event: t,
                screen: n,
                world: this.parent.toWorld(n),
                viewport: this.parent
            }), this.last = null, this.moved = !1, !0;
        }
        return !1;
    }
    wheel(t) {
        if (this.paused) return !1;
        if (this.options.wheel) {
            const e = this.parent.plugins.get("wheel", !0);
            if (!e || !e.options.wheelZoom && !t.ctrlKey) {
                const n = t.deltaMode ? this.options.lineHeight : 1, i = [
                    t.deltaX,
                    t.deltaY
                ], [s, h] = this.options.wheelSwapAxes ? i.reverse() : i;
                return this.xDirection && (this.parent.x += s * n * this.options.wheelScroll * this.reverse), this.yDirection && (this.parent.y += h * n * this.options.wheelScroll * this.reverse), this.options.clampWheel && this.clamp(), this.parent.emit("wheel-scroll", this.parent), this.parent.emit("moved", {
                    viewport: this.parent,
                    type: "wheel"
                }), this.parent.options.passiveWheel || t.preventDefault(), this.parent.options.stopPropagation && t.stopPropagation(), !0;
            }
        }
        return !1;
    }
    resume() {
        this.last = null, this.paused = !1;
    }
    clamp() {
        const t = this.parent.plugins.get("decelerate", !0) || {};
        if (this.options.clampWheel !== "y") {
            if (this.parent.screenWorldWidth < this.parent.screenWidth) switch(this.underflowX){
                case -1:
                    this.parent.x = 0;
                    break;
                case 1:
                    this.parent.x = this.parent.screenWidth - this.parent.screenWorldWidth;
                    break;
                default:
                    this.parent.x = (this.parent.screenWidth - this.parent.screenWorldWidth) / 2;
            }
            else this.parent.left < 0 ? (this.parent.x = 0, t.x = 0) : this.parent.right > this.parent.worldWidth && (this.parent.x = -this.parent.worldWidth * this.parent.scale.x + this.parent.screenWidth, t.x = 0);
        }
        if (this.options.clampWheel !== "x") {
            if (this.parent.screenWorldHeight < this.parent.screenHeight) switch(this.underflowY){
                case -1:
                    this.parent.y = 0;
                    break;
                case 1:
                    this.parent.y = this.parent.screenHeight - this.parent.screenWorldHeight;
                    break;
                default:
                    this.parent.y = (this.parent.screenHeight - this.parent.screenWorldHeight) / 2;
            }
            else this.parent.top < 0 && (this.parent.y = 0, t.y = 0), this.parent.bottom > this.parent.worldHeight && (this.parent.y = -this.parent.worldHeight * this.parent.scale.y + this.parent.screenHeight, t.y = 0);
        }
    }
}
const $762e77127186c3c6$var$F = {
    speed: 0,
    acceleration: null,
    radius: null
};
class $762e77127186c3c6$export$455f05776f1ba8ba extends $762e77127186c3c6$export$901cf72dabf2112a {
    /**
   * This is called by {@link Viewport.follow}.
   *
   * @param parent
   * @param target - target to follow
   * @param options
   */ constructor(t, e, n = {}){
        super(t), this.target = e, this.options = Object.assign({}, $762e77127186c3c6$var$F, n), this.velocity = {
            x: 0,
            y: 0
        };
    }
    update(t) {
        if (this.paused) return;
        const e = this.parent.center;
        let n = this.target.x, i = this.target.y;
        if (this.options.radius) {
            if (Math.sqrt(Math.pow(this.target.y - e.y, 2) + Math.pow(this.target.x - e.x, 2)) > this.options.radius) {
                const r = Math.atan2(this.target.y - e.y, this.target.x - e.x);
                n = this.target.x - Math.cos(r) * this.options.radius, i = this.target.y - Math.sin(r) * this.options.radius;
            } else return;
        }
        const s = n - e.x, h = i - e.y;
        if (s || h) {
            if (this.options.speed) {
                if (this.options.acceleration) {
                    const o = Math.atan2(i - e.y, n - e.x), r = Math.sqrt(Math.pow(s, 2) + Math.pow(h, 2));
                    if (r) {
                        const a = (Math.pow(this.velocity.x, 2) + Math.pow(this.velocity.y, 2)) / (2 * this.options.acceleration);
                        r > a ? this.velocity = {
                            x: Math.min(this.velocity.x + (this.options.acceleration * t, this.options.speed)),
                            y: Math.min(this.velocity.y + (this.options.acceleration * t, this.options.speed))
                        } : this.velocity = {
                            x: Math.max(this.velocity.x - this.options.acceleration * this.options.speed, 0),
                            y: Math.max(this.velocity.y - this.options.acceleration * this.options.speed, 0)
                        };
                        const p = Math.cos(o) * this.velocity.x, f = Math.sin(o) * this.velocity.y, g = Math.abs(p) > Math.abs(s) ? n : e.x + p, w = Math.abs(f) > Math.abs(h) ? i : e.y + f;
                        this.parent.moveCenter(g, w), this.parent.emit("moved", {
                            viewport: this.parent,
                            type: "follow"
                        });
                    }
                } else {
                    const o = Math.atan2(i - e.y, n - e.x), r = Math.cos(o) * this.options.speed, a = Math.sin(o) * this.options.speed, p = Math.abs(r) > Math.abs(s) ? n : e.x + r, f = Math.abs(a) > Math.abs(h) ? i : e.y + a;
                    this.parent.moveCenter(p, f), this.parent.emit("moved", {
                        viewport: this.parent,
                        type: "follow"
                    });
                }
            } else this.parent.moveCenter(n, i), this.parent.emit("moved", {
                viewport: this.parent,
                type: "follow"
            });
        }
    }
}
const $762e77127186c3c6$var$N = {
    radius: null,
    distance: null,
    top: null,
    bottom: null,
    left: null,
    right: null,
    speed: 8,
    reverse: !1,
    noDecelerate: !1,
    linear: !1,
    allowButtons: !1
};
class $762e77127186c3c6$export$dd505d2e20e3eaaf extends $762e77127186c3c6$export$901cf72dabf2112a {
    /**
   * This is called by {@link Viewport.mouseEdges}.
   */ constructor(t, e = {}){
        super(t), this.options = Object.assign({}, $762e77127186c3c6$var$N, e), this.reverse = this.options.reverse ? 1 : -1, this.radiusSquared = typeof this.options.radius == "number" ? Math.pow(this.options.radius, 2) : null, this.resize();
    }
    resize() {
        const t = this.options.distance;
        t !== null ? (this.left = t, this.top = t, this.right = this.parent.screenWidth - t, this.bottom = this.parent.screenHeight - t) : this.options.radius || (this.left = this.options.left, this.top = this.options.top, this.right = this.options.right === null ? null : this.parent.screenWidth - this.options.right, this.bottom = this.options.bottom === null ? null : this.parent.screenHeight - this.options.bottom);
    }
    down() {
        return this.paused || this.options.allowButtons || (this.horizontal = this.vertical = null), !1;
    }
    move(t) {
        if (this.paused || t.pointerType !== "mouse" && t.pointerId !== 1 || !this.options.allowButtons && t.buttons !== 0) return !1;
        const e = t.global.x, n = t.global.y;
        if (this.radiusSquared) {
            const i = this.parent.toScreen(this.parent.center);
            if (Math.pow(i.x - e, 2) + Math.pow(i.y - n, 2) >= this.radiusSquared) {
                const h = Math.atan2(i.y - n, i.x - e);
                this.options.linear ? (this.horizontal = Math.round(Math.cos(h)) * this.options.speed * this.reverse * 0.06, this.vertical = Math.round(Math.sin(h)) * this.options.speed * this.reverse * 0.06) : (this.horizontal = Math.cos(h) * this.options.speed * this.reverse * 0.06, this.vertical = Math.sin(h) * this.options.speed * this.reverse * 0.06);
            } else this.horizontal && this.decelerateHorizontal(), this.vertical && this.decelerateVertical(), this.horizontal = this.vertical = 0;
        } else this.left !== null && e < this.left ? this.horizontal = Number(this.reverse) * this.options.speed * 0.06 : this.right !== null && e > this.right ? this.horizontal = -1 * this.reverse * this.options.speed * 0.06 : (this.decelerateHorizontal(), this.horizontal = 0), this.top !== null && n < this.top ? this.vertical = Number(this.reverse) * this.options.speed * 0.06 : this.bottom !== null && n > this.bottom ? this.vertical = -1 * this.reverse * this.options.speed * 0.06 : (this.decelerateVertical(), this.vertical = 0);
        return !1;
    }
    decelerateHorizontal() {
        const t = this.parent.plugins.get("decelerate", !0);
        this.horizontal && t && !this.options.noDecelerate && t.activate({
            x: this.horizontal * this.options.speed * this.reverse / (1e3 / 60)
        });
    }
    decelerateVertical() {
        const t = this.parent.plugins.get("decelerate", !0);
        this.vertical && t && !this.options.noDecelerate && t.activate({
            y: this.vertical * this.options.speed * this.reverse / (1e3 / 60)
        });
    }
    up() {
        return this.paused || (this.horizontal && this.decelerateHorizontal(), this.vertical && this.decelerateVertical(), this.horizontal = this.vertical = null), !1;
    }
    update() {
        if (!this.paused && (this.horizontal || this.vertical)) {
            const t = this.parent.center;
            this.horizontal && (t.x += this.horizontal * this.options.speed), this.vertical && (t.y += this.vertical * this.options.speed), this.parent.moveCenter(t), this.parent.emit("moved", {
                viewport: this.parent,
                type: "mouse-edges"
            });
        }
    }
}
const $762e77127186c3c6$var$Z = {
    noDrag: !1,
    percent: 1,
    center: null,
    factor: 1,
    axis: "all"
}, $762e77127186c3c6$var$R = new (0, $lwGvb.Point)();
class $762e77127186c3c6$export$826ae541ddf1527b extends $762e77127186c3c6$export$901cf72dabf2112a {
    /**
  * This is called by {@link Viewport.pinch}.
  */ constructor(t, e = {}){
        super(t), this.active = !1, this.pinching = !1, this.moved = !1, this.options = Object.assign({}, $762e77127186c3c6$var$Z, e);
    }
    down() {
        return this.parent.input.count() >= 2 ? (this.active = !0, !0) : !1;
    }
    isAxisX() {
        return [
            "all",
            "x"
        ].includes(this.options.axis);
    }
    isAxisY() {
        return [
            "all",
            "y"
        ].includes(this.options.axis);
    }
    move(t) {
        if (this.paused || !this.active) return !1;
        const { x: e, y: n } = (this.parent.parent || this.parent).toLocal(t.global, void 0, $762e77127186c3c6$var$R), i = this.parent.input.touches;
        if (i.length >= 2) {
            const s = i[0], h = i[1], o = s.last && h.last ? Math.sqrt(Math.pow(h.last.x - s.last.x, 2) + Math.pow(h.last.y - s.last.y, 2)) : null;
            if (s.id === t.pointerId ? s.last = {
                x: e,
                y: n,
                data: t
            } : h.id === t.pointerId && (h.last = {
                x: e,
                y: n,
                data: t
            }), o) {
                let r;
                const a = new (0, $lwGvb.Point)(s.last.x + (h.last.x - s.last.x) / 2, s.last.y + (h.last.y - s.last.y) / 2);
                this.options.center || (r = this.parent.toLocal(a, this.parent.parent || this.parent));
                let p = Math.sqrt(Math.pow(h.last.x - s.last.x, 2) + Math.pow(h.last.y - s.last.y, 2));
                p = p === 0 ? p = 1e-10 : p;
                const f = (1 - o / p) * this.options.percent * (this.isAxisX() ? this.parent.scale.x : this.parent.scale.y);
                this.isAxisX() && (this.parent.scale.x += f), this.isAxisY() && (this.parent.scale.y += f), this.parent.emit("zoomed", {
                    viewport: this.parent,
                    type: "pinch",
                    center: a
                });
                const g = this.parent.plugins.get("clamp-zoom", !0);
                if (g && g.clamp(), this.options.center) this.parent.moveCenter(this.options.center);
                else {
                    const w = (this.parent.parent || this.parent).toLocal(r, this.parent);
                    this.parent.x += (a.x - w.x) * this.options.factor, this.parent.y += (a.y - w.y) * this.options.factor, this.parent.emit("moved", {
                        viewport: this.parent,
                        type: "pinch"
                    });
                }
                !this.options.noDrag && this.lastCenter && (this.parent.x += (a.x - this.lastCenter.x) * this.options.factor, this.parent.y += (a.y - this.lastCenter.y) * this.options.factor, this.parent.emit("moved", {
                    viewport: this.parent,
                    type: "pinch"
                })), this.lastCenter = a, this.moved = !0;
            } else this.pinching || (this.parent.emit("pinch-start", this.parent), this.pinching = !0);
            return !0;
        }
        return !1;
    }
    up() {
        return this.pinching && this.parent.input.touches.length <= 1 ? (this.active = !1, this.lastCenter = null, this.pinching = !1, this.moved = !1, this.parent.emit("pinch-end", this.parent), !0) : !1;
    }
}
const $762e77127186c3c6$var$K = {
    topLeft: !1,
    friction: 0.8,
    time: 1e3,
    ease: "easeInOutSine",
    interrupt: !0,
    removeOnComplete: !1,
    removeOnInterrupt: !1,
    forceStart: !1
};
class $762e77127186c3c6$export$4dbf1f67c012298b extends $762e77127186c3c6$export$901cf72dabf2112a {
    /**
   * This is called by {@link Viewport.snap}.
   */ constructor(t, e, n, i = {}){
        super(t), this.options = Object.assign({}, $762e77127186c3c6$var$K, i), this.ease = $762e77127186c3c6$var$x(i.ease, "easeInOutSine"), this.x = e, this.y = n, this.options.forceStart && this.snapStart();
    }
    snapStart() {
        this.percent = 0, this.snapping = {
            time: 0
        };
        const t = this.options.topLeft ? this.parent.corner : this.parent.center;
        this.deltaX = this.x - t.x, this.deltaY = this.y - t.y, this.startX = t.x, this.startY = t.y, this.parent.emit("snap-start", this.parent);
    }
    wheel() {
        return this.options.removeOnInterrupt && this.parent.plugins.remove("snap"), !1;
    }
    down() {
        return this.options.removeOnInterrupt ? this.parent.plugins.remove("snap") : this.options.interrupt && (this.snapping = null), !1;
    }
    up() {
        if (this.parent.input.count() === 0) {
            const t = this.parent.plugins.get("decelerate", !0);
            t && (t.x || t.y) && (t.percentChangeX = t.percentChangeY = this.options.friction);
        }
        return !1;
    }
    update(t) {
        if (!this.paused && !(this.options.interrupt && this.parent.input.count() !== 0)) {
            if (this.snapping) {
                const e = this.snapping;
                e.time += t;
                let n, i, s;
                const h = this.startX, o = this.startY, r = this.deltaX, a = this.deltaY;
                if (e.time > this.options.time) n = !0, i = h + r, s = o + a;
                else {
                    const p = this.ease(e.time, 0, 1, this.options.time);
                    i = h + r * p, s = o + a * p;
                }
                this.options.topLeft ? this.parent.moveCorner(i, s) : this.parent.moveCenter(i, s), this.parent.emit("moved", {
                    viewport: this.parent,
                    type: "snap"
                }), n && (this.options.removeOnComplete && this.parent.plugins.remove("snap"), this.parent.emit("snap-end", this.parent), this.snapping = null);
            } else {
                const e = this.options.topLeft ? this.parent.corner : this.parent.center;
                (e.x !== this.x || e.y !== this.y) && this.snapStart();
            }
        }
    }
}
const $762e77127186c3c6$var$Q = {
    width: 0,
    height: 0,
    time: 1e3,
    ease: "easeInOutSine",
    center: null,
    interrupt: !0,
    removeOnComplete: !1,
    removeOnInterrupt: !1,
    forceStart: !1,
    noMove: !1
};
class $762e77127186c3c6$export$8d3b89b6e4db7cd0 extends $762e77127186c3c6$export$901cf72dabf2112a {
    /**
   * This is called by {@link Viewport.snapZoom}.
   */ constructor(t, e = {}){
        super(t), this.options = Object.assign({}, $762e77127186c3c6$var$Q, e), this.ease = $762e77127186c3c6$var$x(this.options.ease), this.xIndependent = !1, this.yIndependent = !1, this.xScale = 0, this.yScale = 0, this.options.width > 0 && (this.xScale = t.screenWidth / this.options.width, this.xIndependent = !0), this.options.height > 0 && (this.yScale = t.screenHeight / this.options.height, this.yIndependent = !0), this.xScale = this.xIndependent ? this.xScale : this.yScale, this.yScale = this.yIndependent ? this.yScale : this.xScale, this.options.time === 0 ? (t.container.scale.x = this.xScale, t.container.scale.y = this.yScale, this.options.removeOnComplete && this.parent.plugins.remove("snap-zoom")) : e.forceStart && this.createSnapping();
    }
    createSnapping() {
        const t = this.parent.worldScreenWidth, e = this.parent.worldScreenHeight, n = this.parent.screenWidth / this.xScale, i = this.parent.screenHeight / this.yScale;
        this.snapping = {
            time: 0,
            startX: t,
            startY: e,
            deltaX: n - t,
            deltaY: i - e
        }, this.parent.emit("snap-zoom-start", this.parent);
    }
    resize() {
        this.snapping = null, this.options.width > 0 && (this.xScale = this.parent.screenWidth / this.options.width), this.options.height > 0 && (this.yScale = this.parent.screenHeight / this.options.height), this.xScale = this.xIndependent ? this.xScale : this.yScale, this.yScale = this.yIndependent ? this.yScale : this.xScale;
    }
    wheel() {
        return this.options.removeOnInterrupt && this.parent.plugins.remove("snap-zoom"), !1;
    }
    down() {
        return this.options.removeOnInterrupt ? this.parent.plugins.remove("snap-zoom") : this.options.interrupt && (this.snapping = null), !1;
    }
    update(t) {
        if (this.paused || this.options.interrupt && this.parent.input.count() !== 0) return;
        let e;
        if (!this.options.center && !this.options.noMove && (e = this.parent.center), !this.snapping) (this.parent.scale.x !== this.xScale || this.parent.scale.y !== this.yScale) && this.createSnapping();
        else if (this.snapping) {
            const n = this.snapping;
            if (n.time += t, n.time >= this.options.time) this.parent.scale.set(this.xScale, this.yScale), this.options.removeOnComplete && this.parent.plugins.remove("snap-zoom"), this.parent.emit("snap-zoom-end", this.parent), this.snapping = null;
            else {
                const s = this.snapping, h = this.ease(s.time, s.startX, s.deltaX, this.options.time), o = this.ease(s.time, s.startY, s.deltaY, this.options.time);
                this.parent.scale.x = this.parent.screenWidth / h, this.parent.scale.y = this.parent.screenHeight / o;
            }
            const i = this.parent.plugins.get("clamp-zoom", !0);
            i && i.clamp(), this.options.noMove || (this.options.center ? this.parent.moveCenter(this.options.center) : this.parent.moveCenter(e));
        }
    }
    resume() {
        this.snapping = null, super.resume();
    }
}
const $762e77127186c3c6$var$J = {
    percent: 0.1,
    smooth: !1,
    interrupt: !0,
    reverse: !1,
    center: null,
    lineHeight: 20,
    axis: "all",
    keyToPress: null,
    trackpadPinch: !1,
    wheelZoom: !0
};
class $762e77127186c3c6$export$ae16e1bcb40d6793 extends $762e77127186c3c6$export$901cf72dabf2112a {
    /**
  * This is called by {@link Viewport.wheel}.
  */ constructor(t, e = {}){
        super(t), this.options = Object.assign({}, $762e77127186c3c6$var$J, e), this.keyIsPressed = !1, this.options.keyToPress && this.handleKeyPresses(this.options.keyToPress);
    }
    /**
  * Handles keypress events and set the keyIsPressed boolean accordingly
  *
  * @param {array} codes - key codes that can be used to trigger zoom event
  */ handleKeyPresses(t) {
        typeof window > "u" || (window.addEventListener("keydown", (e)=>{
            t.includes(e.code) && (this.keyIsPressed = !0);
        }), window.addEventListener("keyup", (e)=>{
            t.includes(e.code) && (this.keyIsPressed = !1);
        }));
    }
    checkKeyPress() {
        return !this.options.keyToPress || this.keyIsPressed;
    }
    down() {
        return this.options.interrupt && (this.smoothing = null), !1;
    }
    isAxisX() {
        return [
            "all",
            "x"
        ].includes(this.options.axis);
    }
    isAxisY() {
        return [
            "all",
            "y"
        ].includes(this.options.axis);
    }
    update() {
        if (this.smoothing) {
            const t = this.smoothingCenter, e = this.smoothing;
            let n;
            this.options.center || (n = this.parent.toLocal(t)), this.isAxisX() && (this.parent.scale.x += e.x), this.isAxisY() && (this.parent.scale.y += e.y), this.parent.emit("zoomed", {
                viewport: this.parent,
                type: "wheel"
            });
            const i = this.parent.plugins.get("clamp-zoom", !0);
            if (i && i.clamp(), this.options.center) this.parent.moveCenter(this.options.center);
            else {
                const s = this.parent.parent || this.parent;
                s.toLocal(n, this.parent, n);
                const h = s.toLocal(t);
                this.parent.x += h.x - n.x, this.parent.y += h.y - n.y;
            }
            this.parent.emit("moved", {
                viewport: this.parent,
                type: "wheel"
            }), this.smoothingCount++, typeof this.options.smooth == "number" && this.smoothingCount >= this.options.smooth && (this.smoothing = null);
        }
    }
    pinch(t) {
        if (this.paused) return;
        const e = this.parent.input.getPointerPosition(t), n = -t.deltaY * (t.deltaMode ? this.options.lineHeight : 1) / 200, i = Math.pow(2, (1 + this.options.percent) * n);
        let s;
        this.options.center || (s = this.parent.toLocal(e)), this.isAxisX() && (this.parent.scale.x *= i), this.isAxisY() && (this.parent.scale.y *= i), this.parent.emit("zoomed", {
            viewport: this.parent,
            type: "wheel"
        });
        const h = this.parent.plugins.get("clamp-zoom", !0);
        if (h && h.clamp(), this.options.center) this.parent.moveCenter(this.options.center);
        else {
            const o = this.parent.parent || this.parent;
            o.toLocal(s, this.parent, s);
            const r = o.toLocal(e);
            this.parent.x += r.x - s.x, this.parent.y += r.y - s.y;
        }
        this.parent.emit("moved", {
            viewport: this.parent,
            type: "wheel"
        }), this.parent.emit("wheel-start", {
            event: t,
            viewport: this.parent
        });
    }
    wheel(t) {
        if (this.paused || !this.checkKeyPress()) return !1;
        if (t.ctrlKey && this.options.trackpadPinch) this.pinch(t);
        else if (this.options.wheelZoom) {
            const e = this.parent.input.getPointerPosition(t), i = (this.options.reverse ? -1 : 1) * -t.deltaY * (t.deltaMode ? this.options.lineHeight : 1) / 500, s = Math.pow(2, (1 + this.options.percent) * i);
            if (this.options.smooth) {
                const h = {
                    x: this.smoothing ? this.smoothing.x * (this.options.smooth - this.smoothingCount) : 0,
                    y: this.smoothing ? this.smoothing.y * (this.options.smooth - this.smoothingCount) : 0
                };
                this.smoothing = {
                    x: ((this.parent.scale.x + h.x) * s - this.parent.scale.x) / this.options.smooth,
                    y: ((this.parent.scale.y + h.y) * s - this.parent.scale.y) / this.options.smooth
                }, this.smoothingCount = 0, this.smoothingCenter = e;
            } else {
                let h;
                this.options.center || (h = this.parent.toLocal(e)), this.isAxisX() && (this.parent.scale.x *= s), this.isAxisY() && (this.parent.scale.y *= s), this.parent.emit("zoomed", {
                    viewport: this.parent,
                    type: "wheel"
                });
                const o = this.parent.plugins.get("clamp-zoom", !0);
                if (o && o.clamp(), this.options.center) this.parent.moveCenter(this.options.center);
                else {
                    const r = this.parent.parent || this.parent;
                    r.toLocal(h, this.parent, h);
                    const a = r.toLocal(e);
                    this.parent.x += a.x - h.x, this.parent.y += a.y - h.y;
                }
            }
            this.parent.emit("moved", {
                viewport: this.parent,
                type: "wheel"
            }), this.parent.emit("wheel-start", {
                event: t,
                viewport: this.parent
            });
        }
        return !this.parent.options.passiveWheel;
    }
}
const $762e77127186c3c6$var$tt = {
    screenWidth: typeof window > "u" ? 0 : window.innerWidth,
    screenHeight: typeof window > "u" ? 0 : window.innerHeight,
    worldWidth: null,
    worldHeight: null,
    threshold: 5,
    passiveWheel: !0,
    stopPropagation: !1,
    forceHitArea: null,
    noTicker: !1,
    disableOnContextMenu: !1,
    ticker: (0, $lcv0T.Ticker).shared,
    allowPreserveDragOutside: !1
};
class $762e77127186c3c6$export$d5c6c08dc2d3ca7 extends (0, $5Wp7K.Container) {
    /**
   * @param {IViewportOptions} ViewportOptions
   * @param {number} [options.screenWidth=window.innerWidth]
   * @param {number} [options.screenHeight=window.innerHeight]
   * @param {number} [options.worldWidth=this.width]
   * @param {number} [options.worldHeight=this.height]
   * @param {number} [options.threshold=5] number of pixels to move to trigger an input event (e.g., drag, pinch)
   * or disable a clicked event
   * @param {boolean} [options.passiveWheel=true] whether the 'wheel' event is set to passive (note: if false,
   * e.preventDefault() will be called when wheel is used over the viewport)
   * @param {boolean} [options.stopPropagation=false] whether to stopPropagation of events that impact the viewport
   * (except wheel events, see options.passiveWheel)
   * @param {HitArea} [options.forceHitArea] change the default hitArea from world size to a new value
   * @param {boolean} [options.noTicker] set this if you want to manually call update() function on each frame
   * @param {PIXI.Ticker} [options.ticker=PIXI.Ticker.shared] use this PIXI.ticker for updates
   * @param {PIXI.EventSystem} [options.events] EventSystem available from app.events or added manually and passed here
   * location on screen
   * @param {boolean} [options.disableOnContextMenu] remove oncontextmenu=() => {} from the pixi's events.domElement
   */ constructor(t){
        super(), this._disableOnContextMenu = (e)=>e.preventDefault(), this.options = {
            ...$762e77127186c3c6$var$tt,
            ...t
        }, this.screenWidth = this.options.screenWidth, this.screenHeight = this.options.screenHeight, this._worldWidth = this.options.worldWidth, this._worldHeight = this.options.worldHeight, this.forceHitArea = this.options.forceHitArea, this.threshold = this.options.threshold, this.options.disableOnContextMenu && this.options.events.domElement.addEventListener("contextmenu", this._disableOnContextMenu), this.options.noTicker || (this.tickerFunction = ()=>this.update(this.options.ticker.elapsedMS), this.options.ticker.add(this.tickerFunction)), this.input = new $762e77127186c3c6$export$2da2653229140a6c(this), this.plugins = new $762e77127186c3c6$export$f2c0a16002429d72(this);
    }
    /** Overrides PIXI.Container's destroy to also remove the 'wheel' and PIXI.Ticker listeners */ destroy(t) {
        var e;
        !this.options.noTicker && this.tickerFunction && this.options.ticker.remove(this.tickerFunction), this.options.disableOnContextMenu && ((e = this.options.events.domElement) == null || e.removeEventListener("contextmenu", this._disableOnContextMenu)), this.input.destroy(), super.destroy(t);
    }
    /**
   * Update viewport on each frame.
   *
   * By default, you do not need to call this unless you set `options.noTicker=true`.
   *
   * @param {number} elapsed time in milliseconds since last update
   */ update(t) {
        this.pause || (this.plugins.update(t), this.lastViewport && (this.lastViewport.x !== this.x || this.lastViewport.y !== this.y ? this.moving = !0 : this.moving && (this.emit("moved-end", this), this.moving = !1), this.lastViewport.scaleX !== this.scale.x || this.lastViewport.scaleY !== this.scale.y ? this.zooming = !0 : this.zooming && (this.emit("zoomed-end", this), this.zooming = !1)), this.forceHitArea || (this._hitAreaDefault = new (0, $kNl9L.Rectangle)(this.left, this.top, this.worldScreenWidth, this.worldScreenHeight), this.hitArea = this._hitAreaDefault), this._dirty = this._dirty || !this.lastViewport || this.lastViewport.x !== this.x || this.lastViewport.y !== this.y || this.lastViewport.scaleX !== this.scale.x || this.lastViewport.scaleY !== this.scale.y, this.lastViewport = {
            x: this.x,
            y: this.y,
            scaleX: this.scale.x,
            scaleY: this.scale.y
        }, this.emit("frame-end", this));
    }
    /**
   * Use this to set screen and world sizes, needed for pinch/wheel/clamp/bounce.
   * @param {number} screenWidth=window.innerWidth
   * @param {number} screenHeight=window.innerHeight
   * @param {number} [worldWidth]
   * @param {number} [worldHeight]
   */ resize(t = typeof window > "u" ? 0 : window.innerWidth, e = typeof window > "u" ? 0 : window.innerHeight, n, i) {
        this.screenWidth = t, this.screenHeight = e, typeof n < "u" && (this._worldWidth = n), typeof i < "u" && (this._worldHeight = i), this.plugins.resize(), this.dirty = !0;
    }
    /** World width, in pixels */ get worldWidth() {
        return this._worldWidth ? this._worldWidth : this.width / this.scale.x;
    }
    set worldWidth(t) {
        this._worldWidth = t, this.plugins.resize();
    }
    /** World height, in pixels */ get worldHeight() {
        return this._worldHeight ? this._worldHeight : this.height / this.scale.y;
    }
    set worldHeight(t) {
        this._worldHeight = t, this.plugins.resize();
    }
    /** Get visible world bounds of viewport */ getVisibleBounds() {
        return new (0, $kNl9L.Rectangle)(this.left, this.top, this.worldScreenWidth, this.worldScreenHeight);
    }
    /**
   * Changes coordinate from screen to world
   * @param {number|PIXI.Point} x
   * @param {number} y
   * @returns {PIXI.Point}
   */ toWorld(t, e) {
        return arguments.length === 2 ? this.toLocal(new (0, $lwGvb.Point)(t, e)) : this.toLocal(t);
    }
    /**
   * Changes coordinate from world to screen
   * @param {number|PIXI.Point} x
   * @param {number} y
   * @returns {PIXI.Point}
   */ toScreen(t, e) {
        return arguments.length === 2 ? this.toGlobal(new (0, $lwGvb.Point)(t, e)) : this.toGlobal(t);
    }
    /** Screen width in world coordinates */ get worldScreenWidth() {
        return this.screenWidth / this.scale.x;
    }
    /** Screen height in world coordinates */ get worldScreenHeight() {
        return this.screenHeight / this.scale.y;
    }
    /** World width in screen coordinates */ get screenWorldWidth() {
        return this.worldWidth * this.scale.x;
    }
    /** World height in screen coordinates */ get screenWorldHeight() {
        return this.worldHeight * this.scale.y;
    }
    /** Center of screen in world coordinates */ get center() {
        return new (0, $lwGvb.Point)(this.worldScreenWidth / 2 - this.x / this.scale.x, this.worldScreenHeight / 2 - this.y / this.scale.y);
    }
    set center(t) {
        this.moveCenter(t);
    }
    /**
   * Move center of viewport to (x, y)
   * @param {number|PIXI.Point} x
   * @param {number} [y]
   * @return {Viewport}
   */ moveCenter(...t) {
        let e, n;
        typeof t[0] == "number" ? (e = t[0], n = t[1]) : (e = t[0].x, n = t[0].y);
        const i = (this.worldScreenWidth / 2 - e) * this.scale.x, s = (this.worldScreenHeight / 2 - n) * this.scale.y;
        return (this.x !== i || this.y !== s) && (this.position.set(i, s), this.plugins.reset(), this.dirty = !0), this;
    }
    /** Top-left corner of Viewport */ get corner() {
        return new (0, $lwGvb.Point)(-this.x / this.scale.x, -this.y / this.scale.y);
    }
    set corner(t) {
        this.moveCorner(t);
    }
    /**
   * MoveCorner
   * @param {number|PIXI.Point} x
   * @param {number} [y]
   * @returns {Viewport}
   */ moveCorner(...t) {
        let e, n;
        return t.length === 1 ? (e = -t[0].x * this.scale.x, n = -t[0].y * this.scale.y) : (e = -t[0] * this.scale.x, n = -t[1] * this.scale.y), (e !== this.x || n !== this.y) && (this.position.set(e, n), this.plugins.reset(), this.dirty = !0), this;
    }
    /** Get how many world pixels fit in screen's width */ get screenWidthInWorldPixels() {
        return this.screenWidth / this.scale.x;
    }
    /** Get how many world pixels fit on screen's height */ get screenHeightInWorldPixels() {
        return this.screenHeight / this.scale.y;
    }
    /**
   * Find the scale value that fits a world width on the screen
   * does not change the viewport (use fit... to change)
   *
   * @param width - Width in world pixels
   * @return - scale
   */ findFitWidth(t) {
        return this.screenWidth / t;
    }
    /**
   * Finds the scale value that fits a world height on the screens
   * does not change the viewport (use fit... to change)
   *
   * @param height - Height in world pixels
   * @return - scale
   */ findFitHeight(t) {
        return this.screenHeight / t;
    }
    /**
   * Finds the scale value that fits the smaller of a world width and world height on the screen
   * does not change the viewport (use fit... to change)
   *
   * @param {number} width in world pixels
   * @param {number} height in world pixels
   * @returns {number} scale
   */ findFit(t, e) {
        const n = this.screenWidth / t, i = this.screenHeight / e;
        return Math.min(n, i);
    }
    /**
   * Finds the scale value that fits the larger of a world width and world height on the screen
   * does not change the viewport (use fit... to change)
   *
   * @param {number} width in world pixels
   * @param {number} height in world pixels
   * @returns {number} scale
   */ findCover(t, e) {
        const n = this.screenWidth / t, i = this.screenHeight / e;
        return Math.max(n, i);
    }
    /**
   * Change zoom so the width fits in the viewport
   *
   * @param width - width in world coordinates
   * @param center - maintain the same center
   * @param scaleY - whether to set scaleY=scaleX
   * @param noClamp - whether to disable clamp-zoom
   * @returns {Viewport} this
   */ fitWidth(t = this.worldWidth, e, n = !0, i) {
        let s;
        e && (s = this.center), this.scale.x = this.screenWidth / t, n && (this.scale.y = this.scale.x);
        const h = this.plugins.get("clamp-zoom", !0);
        return !i && h && h.clamp(), e && s && this.moveCenter(s), this;
    }
    /**
   * Change zoom so the height fits in the viewport
   *
   * @param {number} [height=this.worldHeight] in world coordinates
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @param {boolean} [scaleX=true] whether to set scaleX = scaleY
   * @param {boolean} [noClamp] whether to disable clamp-zoom
   * @returns {Viewport} this
   */ fitHeight(t = this.worldHeight, e, n = !0, i) {
        let s;
        e && (s = this.center), this.scale.y = this.screenHeight / t, n && (this.scale.x = this.scale.y);
        const h = this.plugins.get("clamp-zoom", !0);
        return !i && h && h.clamp(), e && s && this.moveCenter(s), this;
    }
    /**
   * Change zoom so it fits the entire world in the viewport
   *
   * @param {boolean} center maintain the same center of the screen after zoom
   * @returns {Viewport} this
   */ fitWorld(t) {
        let e;
        t && (e = this.center), this.scale.x = this.screenWidth / this.worldWidth, this.scale.y = this.screenHeight / this.worldHeight, this.scale.x < this.scale.y ? this.scale.y = this.scale.x : this.scale.x = this.scale.y;
        const n = this.plugins.get("clamp-zoom", !0);
        return n && n.clamp(), t && e && this.moveCenter(e), this;
    }
    /**
   * Change zoom so it fits the size or the entire world in the viewport
   *
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @param {number} [width=this.worldWidth] desired width
   * @param {number} [height=this.worldHeight] desired height
   * @returns {Viewport} this
   */ fit(t, e = this.worldWidth, n = this.worldHeight) {
        let i;
        t && (i = this.center), this.scale.x = this.screenWidth / e, this.scale.y = this.screenHeight / n, this.scale.x < this.scale.y ? this.scale.y = this.scale.x : this.scale.x = this.scale.y;
        const s = this.plugins.get("clamp-zoom", !0);
        return s && s.clamp(), t && i && this.moveCenter(i), this;
    }
    /**
   * Zoom viewport to specific value.
   *
   * @param {number} scale value (e.g., 1 would be 100%, 0.25 would be 25%)
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @return {Viewport} this
   */ setZoom(t, e) {
        let n;
        e && (n = this.center), this.scale.set(t);
        const i = this.plugins.get("clamp-zoom", !0);
        return i && i.clamp(), e && n && this.moveCenter(n), this;
    }
    /**
   * Zoom viewport by a certain percent (in both x and y direction).
   *
   * @param {number} percent change (e.g., 0.25 would increase a starting scale of 1.0 to 1.25)
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @return {Viewport} this
   */ zoomPercent(t, e) {
        return this.setZoom(this.scale.x + this.scale.x * t, e);
    }
    /**
   * Zoom viewport by increasing/decreasing width by a certain number of pixels.
   *
   * @param {number} change in pixels
   * @param {boolean} [center] maintain the same center of the screen after zoom
   * @return {Viewport} this
   */ zoom(t, e) {
        return this.fitWidth(t + this.worldScreenWidth, e), this;
    }
    /** Changes scale of viewport and maintains center of viewport */ get scaled() {
        return this.scale.x;
    }
    set scaled(t) {
        this.setZoom(t, !0);
    }
    /**
   * Returns zoom to the desired scale
   *
   * @param {ISnapZoomOptions} options
   * @param {number} [options.width=0] - the desired width to snap (to maintain aspect ratio, choose width or height)
   * @param {number} [options.height=0] - the desired height to snap (to maintain aspect ratio, choose width or height)
   * @param {number} [options.time=1000] - time for snapping in ms
   * @param {(string|function)} [options.ease=easeInOutSine] ease function or name (see http://easings.net/
   *   for supported names)
   * @param {PIXI.Point} [options.center] - place this point at center during zoom instead of center of the viewport
   * @param {boolean} [options.interrupt=true] - pause snapping with any user input on the viewport
   * @param {boolean} [options.removeOnComplete] - removes this plugin after snapping is complete
   * @param {boolean} [options.removeOnInterrupt] - removes this plugin if interrupted by any user input
   * @param {boolean} [options.forceStart] - starts the snap immediately regardless of whether the viewport is at the
   *   desired zoom
   * @param {boolean} [options.noMove] - zoom but do not move
   */ snapZoom(t) {
        return this.plugins.add("snap-zoom", new $762e77127186c3c6$export$8d3b89b6e4db7cd0(this, t)), this;
    }
    /** Is container out of world bounds */ OOB() {
        return {
            left: this.left < 0,
            right: this.right > this.worldWidth,
            top: this.top < 0,
            bottom: this.bottom > this.worldHeight,
            cornerPoint: new (0, $lwGvb.Point)(this.worldWidth * this.scale.x - this.screenWidth, this.worldHeight * this.scale.y - this.screenHeight)
        };
    }
    /** World coordinates of the right edge of the screen */ get right() {
        return -this.x / this.scale.x + this.worldScreenWidth;
    }
    set right(t) {
        this.x = -t * this.scale.x + this.screenWidth, this.plugins.reset();
    }
    /** World coordinates of the left edge of the screen */ get left() {
        return -this.x / this.scale.x;
    }
    set left(t) {
        this.x = -t * this.scale.x, this.plugins.reset();
    }
    /** World coordinates of the top edge of the screen */ get top() {
        return -this.y / this.scale.y;
    }
    set top(t) {
        this.y = -t * this.scale.y, this.plugins.reset();
    }
    /** World coordinates of the bottom edge of the screen */ get bottom() {
        return -this.y / this.scale.y + this.worldScreenHeight;
    }
    set bottom(t) {
        this.y = -t * this.scale.y + this.screenHeight, this.plugins.reset();
    }
    /**
   * Determines whether the viewport is dirty (i.e., needs to be rendered to the screen because of a change)
   */ get dirty() {
        return !!this._dirty;
    }
    set dirty(t) {
        this._dirty = t;
    }
    /**
   * Permanently changes the Viewport's hitArea
   *
   * NOTE: if not set then hitArea = PIXI.Rectangle(Viewport.left, Viewport.top, Viewport.worldScreenWidth,
   * Viewport.worldScreenHeight)
   */ get forceHitArea() {
        return this._forceHitArea;
    }
    set forceHitArea(t) {
        t ? (this._forceHitArea = t, this.hitArea = t) : (this._forceHitArea = null, this.hitArea = new (0, $kNl9L.Rectangle)(0, 0, this.worldWidth, this.worldHeight));
    }
    /**
   * Enable one-finger touch to drag
   *
   * NOTE: if you expect users to use right-click dragging, you should enable `viewport.options.disableOnContextMenu`
   * to avoid the context menu popping up on each right-click drag.
   *
   * @param {IDragOptions} [options]
   * @param {string} [options.direction=all] direction to drag
   * @param {boolean} [options.pressDrag=true] whether click to drag is active
   * @param {boolean} [options.wheel=true] use wheel to scroll in direction (unless wheel plugin is active)
   * @param {number} [options.wheelScroll=1] number of pixels to scroll with each wheel spin
   * @param {boolean} [options.reverse] reverse the direction of the wheel scroll
   * @param {(boolean|string)} [options.clampWheel=false] clamp wheel(to avoid weird bounce with mouse wheel)
   * @param {string} [options.underflow=center] where to place world if too small for screen
   * @param {number} [options.factor=1] factor to multiply drag to increase the speed of movement
   * @param {string} [options.mouseButtons=all] changes which mouse buttons trigger drag, use: 'all', 'left',
   *  'right' 'middle', or some combination, like, 'middle-right'; you may want to set
   *   viewport.options.disableOnContextMenu if you want to use right-click dragging
   * @param {string[]} [options.keyToPress=null] - array containing
   *  {@link key|https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/code} codes of keys that can be
   *  pressed for the drag to be triggered, e.g.: ['ShiftLeft', 'ShiftRight'}.
   * @param {boolean} [options.ignoreKeyToPressOnTouch=false] - ignore keyToPress for touch events
   * @param {number} [options.lineHeight=20] - scaling factor for non-DOM_DELTA_PIXEL scrolling events
   * @returns {Viewport} this
   */ drag(t) {
        return this.plugins.add("drag", new $762e77127186c3c6$export$b48985bba8f530f5(this, t)), this;
    }
    /**
   * Clamp to world boundaries or other provided boundaries
   * There are three ways to clamp:
   * 1. direction: 'all' = the world is clamped to its world boundaries, ie, you cannot drag any part of offscreen
   *    direction: 'x' | 'y' = only the x or y direction is clamped to its world boundary
   * 2. left, right, top, bottom = true | number = the world is clamped to the world's pixel location for each side;
   *    if any of these are set to true, then the location is set to the boundary
   *    [0, viewport.worldWidth/viewport.worldHeight], eg: to allow the world to be completely dragged offscreen,
   *    set [-viewport.worldWidth, -viewport.worldHeight, viewport.worldWidth * 2, viewport.worldHeight * 2]
   *
   * Underflow determines what happens when the world is smaller than the viewport
   * 1. none = the world is clamped but there is no special behavior
   * 2. center = the world is centered on the viewport
   * 3. combination of top/bottom/center and left/right/center (case insensitive) = the world is stuck to the
   *     appropriate boundaries
   *
   * NOTES:
   *   clamp is disabled if called with no options; use { direction: 'all' } for all edge clamping
   *   screenWidth, screenHeight, worldWidth, and worldHeight needs to be set for this to work properly
   *
   * @param {object} [options]
   * @param {(number|boolean)} [options.left=false] - clamp left; true = 0
   * @param {(number|boolean)} [options.right=false] - clamp right; true = viewport.worldWidth
   * @param {(number|boolean)} [options.top=false] - clamp top; true = 0
   * @param {(number|boolean)} [options.bottom=false] - clamp bottom; true = viewport.worldHeight
   * @param {string} [direction] - (all, x, or y) using clamps of [0, viewport.worldWidth/viewport.worldHeight];
   *  replaces left/right/top/bottom if set
   * @param {string} [underflow=center] - where to place world if too small for screen (e.g., top-right, center,
   *  none, bottomLeft)     * @returns {Viewport} this
   */ clamp(t) {
        return this.plugins.add("clamp", new $762e77127186c3c6$export$90534cad35a14134(this, t)), this;
    }
    /**
   * Decelerate after a move
   *
   * NOTE: this fires 'moved' event during deceleration
   *
   * @param {IDecelerateOptions} [options]
   * @param {number} [options.friction=0.95] - percent to decelerate after movement
   * @param {number} [options.bounce=0.8] - percent to decelerate when past boundaries (only applicable when
   *   viewport.bounce() is active)
   * @param {number} [options.minSpeed=0.01] - minimum velocity before stopping/reversing acceleration
   * @return {Viewport} this
   */ decelerate(t) {
        return this.plugins.add("decelerate", new $762e77127186c3c6$export$4bbb5144deae3118(this, t)), this;
    }
    /**
   * Bounce on borders
   * NOTES:
   *    screenWidth, screenHeight, worldWidth, and worldHeight needs to be set for this to work properly
   *    fires 'moved', 'bounce-x-start', 'bounce-y-start', 'bounce-x-end', and 'bounce-y-end' events
   * @param {object} [options]
   * @param {string} [options.sides=all] - all, horizontal, vertical, or combination of top, bottom, right, left
   *  (e.g., 'top-bottom-right')
   * @param {number} [options.friction=0.5] - friction to apply to decelerate if active
   * @param {number} [options.time=150] - time in ms to finish bounce
   * @param {object} [options.bounceBox] - use this bounceBox instead of (0, 0, viewport.worldWidth, viewport.worldHeight)
   * @param {number} [options.bounceBox.x=0]
   * @param {number} [options.bounceBox.y=0]
   * @param {number} [options.bounceBox.width=viewport.worldWidth]
   * @param {number} [options.bounceBox.height=viewport.worldHeight]
   * @param {string|function} [options.ease=easeInOutSine] - ease function or name
   *  (see http://easings.net/ for supported names)
   * @param {string} [options.underflow=center] - (top/bottom/center and left/right/center, or center)
   *  where to place world if too small for screen
   * @return {Viewport} this
   */ bounce(t) {
        return this.plugins.add("bounce", new $762e77127186c3c6$export$d20e79fdc3899e95(this, t)), this;
    }
    /**
   * Enable pinch to zoom and two-finger touch to drag
   *
   * @param {PinchOptions} [options]
   * @param {boolean} [options.noDrag] - disable two-finger dragging
   * @param {number} [options.percent=1] - percent to modify pinch speed
   * @param {number} [options.factor=1] - factor to multiply two-finger drag to increase the speed of movement
   * @param {PIXI.Point} [options.center] - place this point at center during zoom instead of center of two fingers
   * @param {('all'|'x'|'y')} [options.axis=all] - axis to zoom
   * @return {Viewport} this
   */ pinch(t) {
        return this.plugins.add("pinch", new $762e77127186c3c6$export$826ae541ddf1527b(this, t)), this;
    }
    /**
   * Snap to a point
   *
   * @param {number} x
   * @param {number} y
   * @param {ISnapOptions} [options]
   * @param {boolean} [options.topLeft] - snap to the top-left of viewport instead of center
   * @param {number} [options.friction=0.8] - friction/frame to apply if decelerate is active
   * @param {number} [options.time=1000] - time in ms to snap
   * @param {string|function} [options.ease=easeInOutSine] - ease function or name (see http://easings.net/
   *   for supported names)
   * @param {boolean} [options.interrupt=true] - pause snapping with any user input on the viewport
   * @param {boolean} [options.removeOnComplete] - removes this plugin after snapping is complete
   * @param {boolean} [options.removeOnInterrupt] - removes this plugin if interrupted by any user input
   * @param {boolean} [options.forceStart] - starts the snap immediately regardless of whether the viewport is at
   *   the desired location
   * @return {Viewport} this
   */ snap(t, e, n) {
        return this.plugins.add("snap", new $762e77127186c3c6$export$4dbf1f67c012298b(this, t, e, n)), this;
    }
    /**
   * Follow a target
   *
   * NOTES:
   *    uses the (x, y) as the center to follow; for PIXI.Sprite to work properly, use sprite.anchor.set(0.5)
   *    options.acceleration is not perfect as it doesn't know the velocity of the target. It adds acceleration
   *    to the start of movement and deceleration to the end of movement when the target is stopped.
   *    To cancel the follow, use: `viewport.plugins.remove('follow')`
   *
   * @fires 'moved' event
   *
   * @param {PIXI.DisplayObject} target to follow
   * @param {IFollowOptions} [options]
   * @param {number} [options.speed=0] - to follow in pixels/frame (0=teleport to location)
   * @param {number} [options.acceleration] - set acceleration to accelerate and decelerate at this rate; speed
   *   cannot be 0 to use acceleration
   * @param {number} [options.radius] - radius (in world coordinates) of center circle where movement is allowed
   *   without moving the viewport     * @returns {Viewport} this
   * @returns {Viewport} this
   */ follow(t, e) {
        return this.plugins.add("follow", new $762e77127186c3c6$export$455f05776f1ba8ba(this, t, e)), this;
    }
    /**
   * Zoom using mouse wheel
   *
   * NOTE: the default event listener for 'wheel' event is the options.events.domElement.
   *
   * @param {IWheelOptions} [options]
   * @param {number} [options.percent=0.1] - percent to scroll with each spin
   * @param {number} [options.smooth] - smooth the zooming by providing the number of frames to zoom between wheel spins
   * @param {boolean} [options.interrupt=true] - stop smoothing with any user input on the viewport
   * @param {boolean} [options.reverse] - reverse the direction of the scroll
   * @param {PIXI.Point} [options.center] - place this point at center during zoom instead of current mouse position
   * @param {number} [options.lineHeight=20] - scaling factor for non-DOM_DELTA_PIXEL scrolling events
   * @param {('all'|'x'|'y')} [options.axis=all] - axis to zoom
   * @return {Viewport} this
   */ wheel(t) {
        return this.plugins.add("wheel", new $762e77127186c3c6$export$ae16e1bcb40d6793(this, t)), this;
    }
    /**
   * Animate the position and/or scale of the viewport
   * To set the zoom level, use: (1) scale, (2) scaleX and scaleY, or (3) width and/or height
   * @param {object} options
   * @param {number} [options.time=1000] - time to animate
   * @param {PIXI.Point} [options.position=viewport.center] - position to move viewport
   * @param {number} [options.width] - desired viewport width in world pixels (use instead of scale;
   *  aspect ratio is maintained if height is not provided)
   * @param {number} [options.height] - desired viewport height in world pixels (use instead of scale;
   *  aspect ratio is maintained if width is not provided)
   * @param {number} [options.scale] - scale to change zoom (scale.x = scale.y)
   * @param {number} [options.scaleX] - independently change zoom in x-direction
   * @param {number} [options.scaleY] - independently change zoom in y-direction
   * @param {(function|string)} [options.ease=linear] - easing function to use
   * @param {function} [options.callbackOnComplete]
   * @param {boolean} [options.removeOnInterrupt] removes this plugin if interrupted by any user input
   * @returns {Viewport} this
   */ animate(t) {
        return this.plugins.add("animate", new $762e77127186c3c6$export$83a1293bbde53b95(this, t)), this;
    }
    /**
   * Enable clamping of zoom to constraints
   *
   * The minWidth/Height settings are how small the world can get (as it would appear on the screen)
   * before clamping. The maxWidth/maxHeight is how larger the world can scale (as it would appear on
   * the screen) before clamping.
   *
   * For example, if you have a world size of 1000 x 1000 and a screen size of 100 x 100, if you set
   * minWidth/Height = 100 then the world will not be able to zoom smaller than the screen size (ie,
   * zooming out so it appears smaller than the screen). Similarly, if you set maxWidth/Height = 100
   * the world will not be able to zoom larger than the screen size (ie, zooming in so it appears
   * larger than the screen).
   *
   * @param {object} [options]
   * @param {number} [options.minWidth] - minimum width
   * @param {number} [options.minHeight] - minimum height
   * @param {number} [options.maxWidth] - maximum width
   * @param {number} [options.maxHeight] - maximum height
   * @param {number} [options.minScale] - minimum scale
   * @param {number} [options.maxScale] - minimum scale
   * @return {Viewport} this
   */ clampZoom(t) {
        return this.plugins.add("clamp-zoom", new $762e77127186c3c6$export$220d7a3461bca2df(this, t)), this;
    }
    /**
   * Scroll viewport when mouse hovers near one of the edges or radius-distance from center of screen.
   *
   * NOTES: fires 'moved' event; there's a known bug where the mouseEdges does not work properly with "windowed" viewports
   *
   * @param {IMouseEdgesOptions} [options]
   * @param {number} [options.radius] - distance from center of screen in screen pixels
   * @param {number} [options.distance] - distance from all sides in screen pixels
   * @param {number} [options.top] - alternatively, set top distance (leave unset for no top scroll)
   * @param {number} [options.bottom] - alternatively, set bottom distance (leave unset for no top scroll)
   * @param {number} [options.left] - alternatively, set left distance (leave unset for no top scroll)
   * @param {number} [options.right] - alternatively, set right distance (leave unset for no top scroll)
   * @param {number} [options.speed=8] - speed in pixels/frame to scroll viewport
   * @param {boolean} [options.reverse] - reverse direction of scroll
   * @param {boolean} [options.noDecelerate] - don't use decelerate plugin even if it's installed
   * @param {boolean} [options.linear] - if using radius, use linear movement (+/- 1, +/- 1) instead of angled
   *   movement (Math.cos(angle from center), Math.sin(angle from center))
   * @param {boolean} [options.allowButtons] allows plugin to continue working even when there's a mousedown event
   */ mouseEdges(t) {
        return this.plugins.add("mouse-edges", new $762e77127186c3c6$export$dd505d2e20e3eaaf(this, t)), this;
    }
    /** Pause viewport (including animation updates such as decelerate) */ get pause() {
        return !!this._pause;
    }
    set pause(t) {
        this._pause = t, this.lastViewport = null, this.moving = !1, this.zooming = !1, t && this.input.pause();
    }
    /**
   * Move the viewport so the bounding box is visible
   *
   * @param x - left
   * @param y - top
   * @param width
   * @param height
   * @param resizeToFit - Resize the viewport so the box fits within the viewport
   */ ensureVisible(t, e, n, i, s) {
        s && (n > this.worldScreenWidth || i > this.worldScreenHeight) && (this.fit(!0, n, i), this.emit("zoomed", {
            viewport: this,
            type: "ensureVisible"
        }));
        let h = !1;
        t < this.left ? (this.left = t, h = !0) : t + n > this.right && (this.right = t + n, h = !0), e < this.top ? (this.top = e, h = !0) : e + i > this.bottom && (this.bottom = e + i, h = !0), h && this.emit("moved", {
            viewport: this,
            type: "ensureVisible"
        });
    }
}


const $88850f982d8abd1a$export$9e15ff8aa6bc996f = ("" ?? 'http://localhost:3001').replace(/\/+$/, '');
async function $88850f982d8abd1a$export$b3bfa2e9714d3bf2() {
    const res = await fetch(`${$88850f982d8abd1a$export$9e15ff8aa6bc996f}/api/pages`);
    if (!res.ok) throw new Error(`fetchPages: ${res.status}`);
    return res.json();
}
async function $88850f982d8abd1a$export$eea1b38e4aaafc7d(title) {
    const res = await fetch(`${$88850f982d8abd1a$export$9e15ff8aa6bc996f}/api/pages`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            title: title
        })
    });
    if (!res.ok) throw new Error(`createPage: ${res.status}`);
    return res.json();
}
async function $88850f982d8abd1a$export$4b5ca02e0d193347(id, title) {
    const res = await fetch(`${$88850f982d8abd1a$export$9e15ff8aa6bc996f}/api/pages/${encodeURIComponent(id)}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            title: title
        })
    });
    if (!res.ok) throw new Error(`renamePage: ${res.status}`);
}
async function $88850f982d8abd1a$export$2e9858c25869c949(id) {
    const res = await fetch(`${$88850f982d8abd1a$export$9e15ff8aa6bc996f}/api/pages/${encodeURIComponent(id)}`, {
        method: 'DELETE'
    });
    if (!res.ok) throw new Error(`deletePage: ${res.status}`);
}
async function $88850f982d8abd1a$export$db921b253abfda9b(pageId) {
    const res = await fetch(`${$88850f982d8abd1a$export$9e15ff8aa6bc996f}/api/pages/${encodeURIComponent(pageId)}/nodes`);
    if (!res.ok) throw new Error(`fetchNodes: ${res.status}`);
    return res.json();
}
async function $88850f982d8abd1a$export$270e7ba5936d3c48(pageId, label, parentId) {
    const res = await fetch(`${$88850f982d8abd1a$export$9e15ff8aa6bc996f}/api/pages/${encodeURIComponent(pageId)}/nodes`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            label: label,
            parent_id: parentId
        })
    });
    if (!res.ok) throw new Error(`createNode: ${res.status}`);
    return res.json();
}
// ─── Writes (fire-and-forget; UI is the source of truth at runtime) ──────────
const $88850f982d8abd1a$var$reportFailure = (op)=>(err)=>{
        console.warn(`[api] ${op} failed`, err);
    };
function $88850f982d8abd1a$export$bfcba650c63431da(id, x, y) {
    fetch(`${$88850f982d8abd1a$export$9e15ff8aa6bc996f}/api/nodes/${encodeURIComponent(id)}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            x: x,
            y: y
        })
    }).catch($88850f982d8abd1a$var$reportFailure('patchPosition'));
}
function $88850f982d8abd1a$export$e0a999c03d83fa5(id, status) {
    fetch(`${$88850f982d8abd1a$export$9e15ff8aa6bc996f}/api/nodes/${encodeURIComponent(id)}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            status: status
        })
    }).catch($88850f982d8abd1a$var$reportFailure('patchStatus'));
}
function $88850f982d8abd1a$export$2ff8ceeb000e6aee(id, description) {
    fetch(`${$88850f982d8abd1a$export$9e15ff8aa6bc996f}/api/nodes/${encodeURIComponent(id)}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            description: description
        })
    }).catch($88850f982d8abd1a$var$reportFailure('patchDescription'));
}
function $88850f982d8abd1a$export$502f3028ce474436(items) {
    if (items.length === 0) return;
    fetch(`${$88850f982d8abd1a$export$9e15ff8aa6bc996f}/api/nodes/positions`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(items)
    }).catch($88850f982d8abd1a$var$reportFailure('bulkPositions'));
}
function $88850f982d8abd1a$export$b05da9e94a08038f(id) {
    fetch(`${$88850f982d8abd1a$export$9e15ff8aa6bc996f}/api/nodes/${encodeURIComponent(id)}`, {
        method: 'DELETE'
    }).catch($88850f982d8abd1a$var$reportFailure('deleteNode'));
}
async function $88850f982d8abd1a$export$2f6ec72f51ef1792(nodeId) {
    const res = await fetch(`${$88850f982d8abd1a$export$9e15ff8aa6bc996f}/api/nodes/${encodeURIComponent(nodeId)}/events`);
    if (!res.ok) throw new Error(`fetchEvents: ${res.status}`);
    return res.json();
}
async function $88850f982d8abd1a$export$74b470722ef75a01(pageId, since) {
    const qs = since !== undefined ? `?since=${encodeURIComponent(since)}` : '';
    const res = await fetch(`${$88850f982d8abd1a$export$9e15ff8aa6bc996f}/api/pages/${encodeURIComponent(pageId)}/events${qs}`);
    if (!res.ok) throw new Error(`fetchPageEvents: ${res.status}`);
    return res.json();
}
async function $88850f982d8abd1a$export$1624fa12e286a50f(pageId) {
    const { events: events } = await $88850f982d8abd1a$export$74b470722ef75a01(pageId, '');
    return events.reverse();
}
async function $88850f982d8abd1a$export$c30017717ce2168e(nodeId, payload) {
    const res = await fetch(`${$88850f982d8abd1a$export$9e15ff8aa6bc996f}/api/nodes/${encodeURIComponent(nodeId)}/events`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
    if (!res.ok) throw new Error(`createEvent: ${res.status}`);
    return res.json();
}
function $88850f982d8abd1a$export$1c2dd91db560a75e(rows) {
    const childrenByParent = new Map();
    for (const r of rows)if (r.parent_id) {
        const list = childrenByParent.get(r.parent_id) ?? [];
        list.push({
            id: r.id,
            order: r.child_order
        });
        childrenByParent.set(r.parent_id, list);
    }
    return rows.map((r)=>({
            id: r.id,
            label: r.label,
            description: r.description,
            status: r.status,
            children: (childrenByParent.get(r.id) ?? []).sort((a, b)=>a.order - b.order).map((c)=>c.id)
        }));
}


// ─── Configuration visuelle par niveau ───────────────────────────────────────
// Couleurs indexées par niveau — overridées par le thème au moment du rendu.
// Ces valeurs sont des fallbacks neutres, jamais utilisées en pratique.
const $d030d2651a318c02$var$COLORS = [
    0x4caf50,
    0x2196f3,
    0xff9800,
    0xe91e63
];
// Rayons indexés par niveau — plus grands pour que le texte respire
const $d030d2651a318c02$var$RADII = [
    70,
    52,
    38,
    30
];
// Distance centre-à-centre parent → enfants, indexée par niveau du parent
const $d030d2651a318c02$var$DISTANCES = [
    220,
    165,
    135,
    110
];
// Écart angulaire (rad) entre enfants d'un même nœud (niveaux ≥ 1)
const $d030d2651a318c02$var$SPREAD = 0.6;
// Écart entre racines quand plusieurs projets sont affichés côte-à-côte
const $d030d2651a318c02$var$ROOT_SPACING_X = 1400;
const $d030d2651a318c02$var$ROOT_SPACING_Y = 1200;
function $d030d2651a318c02$export$a95f910e046ea54a(nodes, canvasWidth, canvasHeight) {
    const dataMap = new Map(nodes.map((n)=>[
            n.id,
            n
        ]));
    const layoutMap = new Map();
    // Racines = nœuds qui ne sont l'enfant d'aucun autre (dans l'ordre d'apparition)
    const allChildIds = new Set(nodes.flatMap((n)=>n.children));
    const roots = nodes.filter((n)=>!allChildIds.has(n.id));
    if (roots.length === 0) return layoutMap;
    // Grille centrée autour du centre du canvas.
    // Pour un seul projet, cela revient exactement à le placer au centre.
    const cols = Math.ceil(Math.sqrt(roots.length));
    const rows = Math.ceil(roots.length / cols);
    const gridCx = (cols - 1) / 2;
    const gridCy = (rows - 1) / 2;
    const centerX = canvasWidth / 2;
    const centerY = canvasHeight / 2;
    roots.forEach((rootData, i)=>{
        const col = i % cols;
        const row = Math.floor(i / cols);
        const rx = centerX + (col - gridCx) * $d030d2651a318c02$var$ROOT_SPACING_X;
        const ry = centerY + (row - gridCy) * $d030d2651a318c02$var$ROOT_SPACING_Y;
        layoutMap.set(rootData.id, {
            id: rootData.id,
            label: rootData.label,
            description: rootData.description ?? '',
            level: 0,
            color: $d030d2651a318c02$var$COLORS[0],
            radius: $d030d2651a318c02$var$RADII[0],
            x: rx,
            y: ry,
            parentId: null,
            childIds: rootData.children,
            angle: 0,
            status: rootData.status ?? 'todo'
        });
        $d030d2651a318c02$var$placeChildren(rootData.id, 0, 0, dataMap, layoutMap);
    });
    return layoutMap;
}
/**
 * Positionne récursivement les enfants d'un nœud déjà placé dans layoutMap.
 *
 * @param parentId    identifiant du nœud parent (déjà dans layoutMap)
 * @param parentAngle angle (rad) du grand-parent vers ce parent (pour l'éventail)
 * @param level       niveau du parent (ses enfants seront level+1)
 */ function $d030d2651a318c02$var$placeChildren(parentId, parentAngle, level, dataMap, layoutMap) {
    const parentLayout = layoutMap.get(parentId);
    const parentData = dataMap.get(parentId);
    if (!parentLayout || !parentData || parentData.children.length === 0) return;
    const childLevel = level + 1;
    const color = $d030d2651a318c02$var$COLORS[Math.min(childLevel, $d030d2651a318c02$var$COLORS.length - 1)];
    const radius = $d030d2651a318c02$var$RADII[Math.min(childLevel, $d030d2651a318c02$var$RADII.length - 1)];
    const dist = $d030d2651a318c02$var$DISTANCES[Math.min(level, $d030d2651a318c02$var$DISTANCES.length - 1)];
    const n = parentData.children.length;
    parentData.children.forEach((childId, i)=>{
        const childData = dataMap.get(childId);
        if (!childData) return;
        let angle;
        if (level === 0) // Enfants directs de la racine : répartis uniformément sur 360°
        angle = i / n * Math.PI * 2;
        else {
            // Éventail centré sur la direction parent→grandParent
            const offset = (i - (n - 1) / 2) * $d030d2651a318c02$var$SPREAD;
            angle = parentAngle + offset;
        }
        const x = parentLayout.x + Math.cos(angle) * dist;
        const y = parentLayout.y + Math.sin(angle) * dist;
        layoutMap.set(childId, {
            id: childId,
            label: childData.label,
            description: childData.description ?? '',
            level: childLevel,
            color: color,
            radius: radius,
            x: x,
            y: y,
            parentId: parentId,
            childIds: childData.children,
            angle: angle,
            status: childData.status ?? 'todo'
        });
        // Descendre récursivement
        $d030d2651a318c02$var$placeChildren(childId, angle, childLevel, dataMap, layoutMap);
    });
}
function $d030d2651a318c02$export$911a8f94f7e3e0a7(id, layoutMap) {
    const node = layoutMap.get(id);
    if (!node || node.childIds.length === 0) return;
    // Recompute the "outward" angle from the actual parent → node direction.
    // For a root (no parent), leave angle at 0 — children fan out 360°.
    if (node.parentId) {
        const parent = layoutMap.get(node.parentId);
        if (parent) node.angle = Math.atan2(node.y - parent.y, node.x - parent.x);
    }
    $d030d2651a318c02$var$relayoutRecursive(node, layoutMap);
}
function $d030d2651a318c02$export$78f30f0059ab853a(opts) {
    const lvl = opts.level;
    return {
        id: opts.id,
        label: opts.label,
        description: opts.description ?? '',
        level: lvl,
        color: $d030d2651a318c02$var$COLORS[Math.min(lvl, $d030d2651a318c02$var$COLORS.length - 1)],
        radius: $d030d2651a318c02$var$RADII[Math.min(lvl, $d030d2651a318c02$var$RADII.length - 1)],
        x: opts.x,
        y: opts.y,
        parentId: opts.parentId,
        childIds: opts.childIds,
        angle: 0,
        status: opts.status
    };
}
function $d030d2651a318c02$var$relayoutRecursive(parent, layoutMap) {
    if (parent.childIds.length === 0) return;
    const level = parent.level;
    const dist = $d030d2651a318c02$var$DISTANCES[Math.min(level, $d030d2651a318c02$var$DISTANCES.length - 1)];
    const n = parent.childIds.length;
    parent.childIds.forEach((childId, i)=>{
        const child = layoutMap.get(childId);
        if (!child) return;
        const angle = level === 0 ? i / n * Math.PI * 2 : parent.angle + (i - (n - 1) / 2) * $d030d2651a318c02$var$SPREAD;
        child.x = parent.x + Math.cos(angle) * dist;
        child.y = parent.y + Math.sin(angle) * dist;
        child.angle = angle;
        $d030d2651a318c02$var$relayoutRecursive(child, layoutMap);
    });
}



var $5Wp7K = parcelRequire("5Wp7K");
var $bcTIE = parcelRequire("bcTIE");
var $9c241b623d4069e9$exports = {};
$9c241b623d4069e9$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-check\" viewBox=\"0 0 24 24\"><path d=\"M20 6 9 17l-5-5\"/></svg>";


var $9bd6f9bd96577804$exports = {};
$9bd6f9bd96577804$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-more-horizontal\" viewBox=\"0 0 24 24\"><circle cx=\"12\" cy=\"12\" r=\"1\"/><circle cx=\"19\" cy=\"12\" r=\"1\"/><circle cx=\"5\" cy=\"12\" r=\"1\"/></svg>";


var $46e5d9a8f53673a1$exports = {};
$46e5d9a8f53673a1$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-circle-x\" viewBox=\"0 0 24 24\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"m15 9-6 6M9 9l6 6\"/></svg>";


var $bbc8f3fff1fa105a$exports = {};
$bbc8f3fff1fa105a$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-circle\" viewBox=\"0 0 24 24\"><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>";


var $25e167f22440ab43$exports = {};
$25e167f22440ab43$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-trash-2\" viewBox=\"0 0 24 24\"><path d=\"M10 11v6M14 11v6M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2\"/></svg>";


var $6caf1d93a139d037$exports = {};
$6caf1d93a139d037$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-rotate-ccw\" viewBox=\"0 0 24 24\"><path d=\"M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8\"/><path d=\"M3 3v5h5\"/></svg>";


var $f0d9c9f339de3dfa$exports = {};
$f0d9c9f339de3dfa$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-plus\" viewBox=\"0 0 24 24\"><path d=\"M5 12h14M12 5v14\"/></svg>";


var $e7ad7d87330d12c0$exports = {};
$e7ad7d87330d12c0$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-x\" viewBox=\"0 0 24 24\"><path d=\"M18 6 6 18M6 6l12 12\"/></svg>";


var $c777ce476b102b38$exports = {};
$c777ce476b102b38$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-panel-right\" viewBox=\"0 0 24 24\"><rect width=\"18\" height=\"18\" x=\"3\" y=\"3\" rx=\"2\"/><path d=\"M15 3v18\"/></svg>";


var $89b8ab6af6b17805$exports = {};
$89b8ab6af6b17805$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-pencil\" viewBox=\"0 0 24 24\"><path d=\"M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497ZM15 5l4 4\"/></svg>";


var $91ee7e70c83327a2$exports = {};
$91ee7e70c83327a2$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-file-text\" viewBox=\"0 0 24 24\"><path d=\"M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2Z\"/><path d=\"M14 2v5a1 1 0 0 0 1 1h5M10 9H8M16 13H8M16 17H8\"/></svg>";


var $4810292e4ecaa898$exports = {};
$4810292e4ecaa898$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-sun\" viewBox=\"0 0 24 24\"><circle cx=\"12\" cy=\"12\" r=\"4\"/><path d=\"M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41\"/></svg>";


var $52a952143ca37dde$exports = {};
$52a952143ca37dde$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-moon\" viewBox=\"0 0 24 24\"><path d=\"M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401\"/></svg>";


var $5446f60d71748fe0$exports = {};
$5446f60d71748fe0$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-star\" viewBox=\"0 0 24 24\"><path d=\"M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.12 2.12 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.12 2.12 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.12 2.12 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16Z\"/></svg>";


var $def19fc923a078e6$exports = {};
$def19fc923a078e6$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-heart\" viewBox=\"0 0 24 24\"><path d=\"M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5\"/></svg>";


var $4e22652f20ae3fcb$exports = {};
$4e22652f20ae3fcb$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-zap\" viewBox=\"0 0 24 24\"><path d=\"M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14Z\"/></svg>";


var $2c3e335c4506cc72$exports = {};
$2c3e335c4506cc72$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-flame\" viewBox=\"0 0 24 24\"><path d=\"M12 3q1 4 4 6.5t3 5.5a1 1 0 0 1-14 0 5 5 0 0 1 1-3 1 1 0 0 0 5 0c0-2-1.5-3-1.5-5q0-2 2.5-4\"/></svg>";


var $79caf82584c65b03$exports = {};
$79caf82584c65b03$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-smile\" viewBox=\"0 0 24 24\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01\"/></svg>";


var $6f8936cd5fe13767$exports = {};
$6f8936cd5fe13767$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-trophy\" viewBox=\"0 0 24 24\"><path d=\"M10 14.66v1.626a2 2 0 0 1-.976 1.696A5 5 0 0 0 7 21.978M14 14.66v1.626a2 2 0 0 0 .976 1.696A5 5 0 0 1 17 21.978M18 9h1.5a1 1 0 0 0 0-5H18M4 22h16\"/><path d=\"M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1Z\"/><path d=\"M6 9H4.5a1 1 0 0 1 0-5H6\"/></svg>";


var $4cca10b7bce9fabb$exports = {};
$4cca10b7bce9fabb$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-sparkles\" viewBox=\"0 0 24 24\"><path d=\"M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594ZM20 2v4M22 4h-4\"/><circle cx=\"4\" cy=\"20\" r=\"2\"/></svg>";


var $2d22ecfe3f1845ae$exports = {};
$2d22ecfe3f1845ae$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"lucide lucide-party-popper\" viewBox=\"0 0 24 24\"><path d=\"M5.8 11.3 2 22l10.7-3.79M4 3h.01M22 8h.01M15 2h.01M22 20h.01M22 2l-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10M22 13l-.82-.33c-.86-.34-1.82.2-1.98 1.11-.11.7-.72 1.22-1.43 1.22H17M11 2l.33.82c.34.86-.2 1.82-1.11 1.98-.7.1-1.22.72-1.22 1.43V7\"/><path d=\"M11 13c1.93 1.93 2.83 4.17 2 5s-3.07-.07-5-2-2.83-4.17-2-5 3.07.07 5 2\"/></svg>";


const $bece2cf6ee11737c$export$fde44257752a9f60 = {
    check: (0, (/*@__PURE__*/$parcel$interopDefault($9c241b623d4069e9$exports))),
    ellipsis: (0, (/*@__PURE__*/$parcel$interopDefault($9bd6f9bd96577804$exports))),
    circleX: (0, (/*@__PURE__*/$parcel$interopDefault($46e5d9a8f53673a1$exports))),
    circle: (0, (/*@__PURE__*/$parcel$interopDefault($bbc8f3fff1fa105a$exports))),
    trash: (0, (/*@__PURE__*/$parcel$interopDefault($25e167f22440ab43$exports))),
    rotate: (0, (/*@__PURE__*/$parcel$interopDefault($6caf1d93a139d037$exports))),
    plus: (0, (/*@__PURE__*/$parcel$interopDefault($f0d9c9f339de3dfa$exports))),
    x: (0, (/*@__PURE__*/$parcel$interopDefault($e7ad7d87330d12c0$exports))),
    panelRight: (0, (/*@__PURE__*/$parcel$interopDefault($c777ce476b102b38$exports))),
    edit: (0, (/*@__PURE__*/$parcel$interopDefault($89b8ab6af6b17805$exports))),
    fileText: (0, (/*@__PURE__*/$parcel$interopDefault($91ee7e70c83327a2$exports))),
    sun: (0, (/*@__PURE__*/$parcel$interopDefault($4810292e4ecaa898$exports))),
    moon: (0, (/*@__PURE__*/$parcel$interopDefault($52a952143ca37dde$exports))),
    star: (0, (/*@__PURE__*/$parcel$interopDefault($5446f60d71748fe0$exports))),
    heart: (0, (/*@__PURE__*/$parcel$interopDefault($def19fc923a078e6$exports))),
    zap: (0, (/*@__PURE__*/$parcel$interopDefault($4e22652f20ae3fcb$exports))),
    flame: (0, (/*@__PURE__*/$parcel$interopDefault($2c3e335c4506cc72$exports))),
    smile: (0, (/*@__PURE__*/$parcel$interopDefault($79caf82584c65b03$exports))),
    trophy: (0, (/*@__PURE__*/$parcel$interopDefault($6f8936cd5fe13767$exports))),
    sparkles: (0, (/*@__PURE__*/$parcel$interopDefault($4cca10b7bce9fabb$exports))),
    partyPopper: (0, (/*@__PURE__*/$parcel$interopDefault($2d22ecfe3f1845ae$exports)))
};
const $bece2cf6ee11737c$export$17256b591efd52a2 = [
    'star',
    'heart',
    'zap',
    'flame',
    'smile',
    'trophy',
    'sparkles',
    'partyPopper'
];
const $bece2cf6ee11737c$var$hex = (n)=>`#${n.toString(16).padStart(6, '0')}`;
// Cache: every theme toggle drives ~525 calls to colorize() (75 sprites × 7 buttons).
// Distinct (svg, color, strokeWidth) tuples are < 50 in practice, so a plain Map
// keyed on the combined string is plenty.
const $bece2cf6ee11737c$var$colorizedCache = new Map();
function $bece2cf6ee11737c$var$colorize(svg, color, strokeWidth) {
    const key = `${color}|${strokeWidth}|${svg}`;
    let out = $bece2cf6ee11737c$var$colorizedCache.get(key);
    if (out === undefined) {
        out = svg.replace(/currentColor/g, $bece2cf6ee11737c$var$hex(color)).replace(/stroke-width="2"/, `stroke-width="${strokeWidth}"`);
        $bece2cf6ee11737c$var$colorizedCache.set(key, out);
    }
    return out;
}
function $bece2cf6ee11737c$export$317873f447e05c70(gfx, svg, color, size, strokeWidth = 2) {
    gfx.clear();
    const colored = $bece2cf6ee11737c$var$colorize(svg, color, strokeWidth);
    const scale = size / 24;
    gfx.scale.set(scale);
    gfx.position.set(-12 * scale, -12 * scale);
    gfx.svg(colored);
}
function $bece2cf6ee11737c$export$a93c45a3f0b1e89e(name, sizePx = 16) {
    return $bece2cf6ee11737c$export$fde44257752a9f60[name].replace(/width="24"\s+height="24"/, `width="${sizePx}" height="${sizePx}"`);
}


const $b2b0b848f61053a7$export$58a5f3166fc74e5c = 14;
// ─── Constants ───────────────────────────────────────────────────────────────
const $b2b0b848f61053a7$var$STATUS_RADIUS = 11;
const $b2b0b848f61053a7$var$STATUS_ICON_SIZE = 14;
// Description badge — smaller than the status badge, on the circle's right edge.
const $b2b0b848f61053a7$var$DESC_RADIUS = 8;
const $b2b0b848f61053a7$var$DESC_ICON_SIZE = 10;
const $b2b0b848f61053a7$var$ACTION_RADIUS = 14;
const $b2b0b848f61053a7$var$ACTION_ICON_SIZE = 16;
const $b2b0b848f61053a7$var$ACTION_GAP = 10;
const $b2b0b848f61053a7$var$ACTION_OFFSET_Y = 22;
const $b2b0b848f61053a7$var$STATUS_ICON = {
    'in-progress': 'ellipsis',
    'done': 'check',
    'blocked': 'circleX'
};
const $b2b0b848f61053a7$export$3350f4ba2fa1a3b = {
    'todo': 'circle',
    'in-progress': 'ellipsis',
    'done': 'check',
    'blocked': 'circleX'
};
const $b2b0b848f61053a7$export$a52272efb2c5663f = [
    'todo',
    'in-progress',
    'done',
    'blocked'
];
function $b2b0b848f61053a7$export$33afc5c2570a827c(current) {
    const i = $b2b0b848f61053a7$export$a52272efb2c5663f.indexOf(current);
    return $b2b0b848f61053a7$export$a52272efb2c5663f[(i + 1) % $b2b0b848f61053a7$export$a52272efb2c5663f.length];
}
// ─── Helpers ─────────────────────────────────────────────────────────────────
function $b2b0b848f61053a7$var$nodeColor(theme, level) {
    return theme.nodeColors[Math.min(level, theme.nodeColors.length - 1)];
}
function $b2b0b848f61053a7$var$makeTextStyle(layout, theme) {
    const fontSize = Math.max(10, Math.min(16, Math.round(layout.radius * 0.28)));
    const wrapWidth = (layout.radius - 11) * 2;
    return new (0, $6572d68b0820a289$export$1df879243bf2e42d)({
        fontFamily: '"Rajdhani", "Inter", Arial, sans-serif',
        fontSize: fontSize,
        fontWeight: layout.level === 0 ? '700' : '600',
        fill: theme.textColor,
        wordWrap: true,
        wordWrapWidth: wrapWidth,
        align: 'center'
    });
}
function $b2b0b848f61053a7$export$a484e31e13c53240(graphics, layouts, theme, highlightEdges) {
    graphics.clear();
    for (const node of layouts.values())for (const childId of node.childIds){
        const child = layouts.get(childId);
        if (!child) continue;
        const isHighlighted = highlightEdges?.has(`${node.id}|${childId}`) ?? false;
        const color = isHighlighted ? theme.pulseColor : theme.lineColor;
        graphics.moveTo(node.x, node.y).lineTo(child.x, child.y).stroke({
            width: theme.lineWidth,
            color: color,
            alpha: theme.lineAlpha
        });
    }
}
function $b2b0b848f61053a7$export$dad3a499a0323eb4(gfx, layout, theme) {
    gfx.clear();
    gfx.circle(0, 0, layout.radius);
    gfx.fill({
        color: $b2b0b848f61053a7$var$nodeColor(theme, layout.level)
    });
}
// ─── Status badge (top-right of circle, on border) ───────────────────────────
function $b2b0b848f61053a7$var$renderStatusBadge(badge, layout, theme) {
    if (layout.status === 'todo') {
        badge.container.visible = false;
        return;
    }
    badge.container.visible = true;
    badge.graphics.clear();
    badge.graphics.circle(0, 0, $b2b0b848f61053a7$var$STATUS_RADIUS);
    badge.graphics.fill({
        color: theme.statusColors[layout.status]
    });
    badge.graphics.circle(0, 0, $b2b0b848f61053a7$var$STATUS_RADIUS);
    badge.graphics.stroke({
        width: 2,
        color: theme.statusBorderColor
    });
    (0, $bece2cf6ee11737c$export$317873f447e05c70)(badge.iconGfx, (0, $bece2cf6ee11737c$export$fde44257752a9f60)[$b2b0b848f61053a7$var$STATUS_ICON[layout.status]], theme.actionIconColor, $b2b0b848f61053a7$var$STATUS_ICON_SIZE, 3);
}
function $b2b0b848f61053a7$var$createStatusBadge(layout, theme) {
    const container = new (0, $5Wp7K.Container)();
    const a = -Math.PI / 4; // NE on the circle border
    container.x = Math.cos(a) * layout.radius;
    container.y = Math.sin(a) * layout.radius;
    const graphics = new (0, $bcTIE.Graphics)();
    container.addChild(graphics);
    const iconGfx = new (0, $bcTIE.Graphics)();
    container.addChild(iconGfx);
    const badge = {
        container: container,
        graphics: graphics,
        iconGfx: iconGfx
    };
    $b2b0b848f61053a7$var$renderStatusBadge(badge, layout, theme);
    return badge;
}
// ─── Description badge (right of circle, on border, smaller than status) ──────
function $b2b0b848f61053a7$var$renderDescBadge(badge, layout, theme) {
    badge.graphics.clear();
    badge.graphics.circle(0, 0, $b2b0b848f61053a7$var$DESC_RADIUS);
    badge.graphics.fill({
        color: theme.rotateColor
    });
    badge.graphics.circle(0, 0, $b2b0b848f61053a7$var$DESC_RADIUS);
    badge.graphics.stroke({
        width: 2,
        color: theme.statusBorderColor
    });
    (0, $bece2cf6ee11737c$export$317873f447e05c70)(badge.iconGfx, (0, $bece2cf6ee11737c$export$fde44257752a9f60)['fileText'], theme.actionIconColor, $b2b0b848f61053a7$var$DESC_ICON_SIZE, 2.4);
    // Full opacity when a description exists, dimmed when empty (still clickable).
    badge.container.alpha = layout.description.trim().length > 0 ? 1 : 0.4;
}
function $b2b0b848f61053a7$var$createDescBadge(layout, theme) {
    const container = new (0, $5Wp7K.Container)();
    container.x = layout.radius; // east, on the circle border
    container.y = 0;
    container.eventMode = 'static';
    container.cursor = 'pointer';
    const graphics = new (0, $bcTIE.Graphics)();
    container.addChild(graphics);
    const iconGfx = new (0, $bcTIE.Graphics)();
    container.addChild(iconGfx);
    const badge = {
        container: container,
        graphics: graphics,
        iconGfx: iconGfx
    };
    $b2b0b848f61053a7$var$renderDescBadge(badge, layout, theme);
    return badge;
}
// ─── Action bar (two buttons below circle, hidden by default) ────────────────
function $b2b0b848f61053a7$var$renderActionButton(btn, bgColor, iconName, theme) {
    btn.graphics.clear();
    btn.graphics.circle(0, 0, $b2b0b848f61053a7$var$ACTION_RADIUS);
    btn.graphics.fill({
        color: bgColor
    });
    (0, $bece2cf6ee11737c$export$317873f447e05c70)(btn.iconGfx, (0, $bece2cf6ee11737c$export$fde44257752a9f60)[iconName], theme.actionIconColor, $b2b0b848f61053a7$var$ACTION_ICON_SIZE, 2.2);
}
function $b2b0b848f61053a7$var$createActionButton(x, bgColor, iconName, theme) {
    const container = new (0, $5Wp7K.Container)();
    container.x = x;
    container.y = 0;
    container.eventMode = 'static';
    container.cursor = 'pointer';
    const graphics = new (0, $bcTIE.Graphics)();
    container.addChild(graphics);
    const iconGfx = new (0, $bcTIE.Graphics)();
    container.addChild(iconGfx);
    const btn = {
        container: container,
        graphics: graphics,
        iconGfx: iconGfx
    };
    $b2b0b848f61053a7$var$renderActionButton(btn, bgColor, iconName, theme);
    return btn;
}
const $b2b0b848f61053a7$export$6d4894f9964c5fee = 0.35;
const $b2b0b848f61053a7$export$f6c5f38e96711b6e = 1.0;
function $b2b0b848f61053a7$var$applyStatusActiveAlpha(bar, current) {
    for(let i = 0; i < $b2b0b848f61053a7$export$a52272efb2c5663f.length; i++){
        const btn = bar.buttons[i];
        if (!btn) continue;
        btn.container.alpha = $b2b0b848f61053a7$export$a52272efb2c5663f[i] === current ? $b2b0b848f61053a7$export$f6c5f38e96711b6e : $b2b0b848f61053a7$export$6d4894f9964c5fee;
    }
}
function $b2b0b848f61053a7$var$createStatusBar(layout, theme) {
    const container = new (0, $5Wp7K.Container)();
    container.x = 0;
    container.y = -(layout.radius + $b2b0b848f61053a7$var$ACTION_OFFSET_Y);
    container.visible = false;
    const spacing = $b2b0b848f61053a7$var$ACTION_RADIUS * 2 + $b2b0b848f61053a7$var$ACTION_GAP;
    const buttons = $b2b0b848f61053a7$export$a52272efb2c5663f.map((status, i)=>{
        const x = (i - ($b2b0b848f61053a7$export$a52272efb2c5663f.length - 1) / 2) * spacing;
        const btn = $b2b0b848f61053a7$var$createActionButton(x, theme.statusColors[status], $b2b0b848f61053a7$export$3350f4ba2fa1a3b[status], theme);
        container.addChild(btn.container);
        return btn;
    });
    const bar = {
        container: container,
        buttons: buttons
    };
    $b2b0b848f61053a7$var$applyStatusActiveAlpha(bar, layout.status);
    return bar;
}
function $b2b0b848f61053a7$export$a07758ef936a4649(sprite, theme) {
    $b2b0b848f61053a7$var$renderStatusBadge(sprite.statusBadge, sprite.layout, theme);
    $b2b0b848f61053a7$var$applyStatusActiveAlpha(sprite.statusBar, sprite.layout.status);
}
function $b2b0b848f61053a7$export$cd4f9a6eb89818ab(sprite, theme) {
    $b2b0b848f61053a7$var$renderDescBadge(sprite.descBadge, sprite.layout, theme);
}
function $b2b0b848f61053a7$var$createActionBar(layout, theme) {
    const container = new (0, $5Wp7K.Container)();
    container.x = 0;
    container.y = layout.radius + $b2b0b848f61053a7$var$ACTION_OFFSET_Y;
    container.visible = false;
    // 3 buttons centered at x = -spacing, 0, +spacing.
    const spacing = $b2b0b848f61053a7$var$ACTION_RADIUS * 2 + $b2b0b848f61053a7$var$ACTION_GAP;
    const addButton = $b2b0b848f61053a7$var$createActionButton(-spacing, theme.addColor, 'plus', theme);
    const rotateButton = $b2b0b848f61053a7$var$createActionButton(0, theme.rotateColor, 'rotate', theme);
    const deleteButton = $b2b0b848f61053a7$var$createActionButton(spacing, theme.deleteColor, 'trash', theme);
    container.addChild(addButton.container);
    container.addChild(rotateButton.container);
    container.addChild(deleteButton.container);
    return {
        container: container,
        addButton: addButton,
        rotateButton: rotateButton,
        deleteButton: deleteButton
    };
}
function $b2b0b848f61053a7$export$96a186a9b8e41771(layout, theme) {
    const container = new (0, $5Wp7K.Container)();
    container.x = layout.x;
    container.y = layout.y;
    const gfx = new (0, $bcTIE.Graphics)();
    $b2b0b848f61053a7$export$dad3a499a0323eb4(gfx, layout, theme);
    container.addChild(gfx);
    const text = new (0, $fb07824581091256$export$5f1af8db9871e1d6)({
        text: layout.label,
        style: $b2b0b848f61053a7$var$makeTextStyle(layout, theme)
    });
    text.anchor.set(0.5, 0.5);
    container.addChild(text);
    const statusBadge = $b2b0b848f61053a7$var$createStatusBadge(layout, theme);
    container.addChild(statusBadge.container);
    const descBadge = $b2b0b848f61053a7$var$createDescBadge(layout, theme);
    container.addChild(descBadge.container);
    const statusBar = $b2b0b848f61053a7$var$createStatusBar(layout, theme);
    container.addChild(statusBar.container);
    const actionBar = $b2b0b848f61053a7$var$createActionBar(layout, theme);
    container.addChild(actionBar.container);
    return {
        container: container,
        graphics: gfx,
        text: text,
        layout: layout,
        statusBadge: statusBadge,
        descBadge: descBadge,
        statusBar: statusBar,
        actionBar: actionBar
    };
}
function $b2b0b848f61053a7$export$fefc5ff285547933(sprites, theme) {
    // Per-call TextStyle cache — most sprites share identical (fontSize, weight)
    // by virtue of the level → radius mapping (only ~4 distinct styles). PIXI
    // dedupes text textures by structural style, so reusing the same instance
    // also means a single rasterization pass.
    const textStyleCache = new Map();
    const styleFor = (layout)=>{
        const fontSize = Math.max(10, Math.min(16, Math.round(layout.radius * 0.28)));
        const weight = layout.level === 0 ? '700' : '600';
        const wrapWidth = (layout.radius - 11) * 2;
        const key = `${fontSize}|${weight}|${wrapWidth}|${theme.textColor}`;
        let s = textStyleCache.get(key);
        if (!s) {
            s = $b2b0b848f61053a7$var$makeTextStyle(layout, theme);
            textStyleCache.set(key, s);
        }
        return s;
    };
    for (const sprite of sprites.values()){
        $b2b0b848f61053a7$export$dad3a499a0323eb4(sprite.graphics, sprite.layout, theme);
        sprite.text.style = styleFor(sprite.layout);
        $b2b0b848f61053a7$var$renderStatusBadge(sprite.statusBadge, sprite.layout, theme);
        $b2b0b848f61053a7$var$renderDescBadge(sprite.descBadge, sprite.layout, theme);
        for(let i = 0; i < $b2b0b848f61053a7$export$a52272efb2c5663f.length; i++){
            const status = $b2b0b848f61053a7$export$a52272efb2c5663f[i];
            const btn = sprite.statusBar.buttons[i];
            if (!status || !btn) continue;
            $b2b0b848f61053a7$var$renderActionButton(btn, theme.statusColors[status], $b2b0b848f61053a7$export$3350f4ba2fa1a3b[status], theme);
        }
        $b2b0b848f61053a7$var$applyStatusActiveAlpha(sprite.statusBar, sprite.layout.status);
        $b2b0b848f61053a7$var$renderActionButton(sprite.actionBar.addButton, theme.addColor, 'plus', theme);
        $b2b0b848f61053a7$var$renderActionButton(sprite.actionBar.rotateButton, theme.rotateColor, 'rotate', theme);
        $b2b0b848f61053a7$var$renderActionButton(sprite.actionBar.deleteButton, theme.deleteColor, 'trash', theme);
    }
}



var $5Wp7K = parcelRequire("5Wp7K");
var $bcTIE = parcelRequire("bcTIE");



// Tiny modal helper for collecting a single text input.
// Backed by a native <dialog> in index.html.
const $81e833ca5dd4fe80$var$DIALOG_ID = 'add-modal';
const $81e833ca5dd4fe80$var$TITLE_ID = 'add-modal-title';
const $81e833ca5dd4fe80$var$INPUT_ID = 'add-modal-input';
// Wire the Cancel button once. It's type="button" so it doesn't act as the
// implicit form submitter when the user presses Enter — Enter now activates
// the only remaining submit button ("Create"), which is the desired behavior.
let $81e833ca5dd4fe80$var$cancelWired = false;
function $81e833ca5dd4fe80$var$ensureCancelWired(dialog) {
    if ($81e833ca5dd4fe80$var$cancelWired) return;
    const cancelBtn = dialog.querySelector('[data-cancel]');
    cancelBtn?.addEventListener('click', ()=>dialog.close('cancel'));
    $81e833ca5dd4fe80$var$cancelWired = true;
}
function $81e833ca5dd4fe80$export$e2d76aac9cd37a6b(title, placeholder = 'Label') {
    const dialog = document.getElementById($81e833ca5dd4fe80$var$DIALOG_ID);
    const input = document.getElementById($81e833ca5dd4fe80$var$INPUT_ID);
    const titleEl = document.getElementById($81e833ca5dd4fe80$var$TITLE_ID);
    $81e833ca5dd4fe80$var$ensureCancelWired(dialog);
    titleEl.textContent = title;
    input.placeholder = placeholder;
    input.value = '';
    return new Promise((resolve)=>{
        const onClose = ()=>{
            dialog.removeEventListener('close', onClose);
            const value = input.value.trim();
            resolve(dialog.returnValue === 'confirm' && value.length > 0 ? value : null);
        };
        dialog.addEventListener('close', onClose);
        dialog.showModal();
        input.focus();
        input.select();
    });
}
// ─── Description modal (bigger — textarea) ───────────────────────────────────
const $81e833ca5dd4fe80$var$DESC_DIALOG_ID = 'desc-modal';
const $81e833ca5dd4fe80$var$DESC_TITLE_ID = 'desc-modal-title';
const $81e833ca5dd4fe80$var$DESC_INPUT_ID = 'desc-modal-input';
let $81e833ca5dd4fe80$var$descCancelWired = false;
function $81e833ca5dd4fe80$var$ensureDescCancelWired(dialog) {
    if ($81e833ca5dd4fe80$var$descCancelWired) return;
    const cancelBtn = dialog.querySelector('[data-cancel]');
    cancelBtn?.addEventListener('click', ()=>dialog.close('cancel'));
    $81e833ca5dd4fe80$var$descCancelWired = true;
}
function $81e833ca5dd4fe80$export$2c6b9969095d608d(title, current) {
    const dialog = document.getElementById($81e833ca5dd4fe80$var$DESC_DIALOG_ID);
    const input = document.getElementById($81e833ca5dd4fe80$var$DESC_INPUT_ID);
    const titleEl = document.getElementById($81e833ca5dd4fe80$var$DESC_TITLE_ID);
    $81e833ca5dd4fe80$var$ensureDescCancelWired(dialog);
    titleEl.textContent = title;
    input.value = current;
    return new Promise((resolve)=>{
        const onClose = ()=>{
            dialog.removeEventListener('close', onClose);
            resolve(dialog.returnValue === 'confirm' ? input.value.trim() : null);
        };
        dialog.addEventListener('close', onClose);
        dialog.showModal();
        input.focus();
    });
}



const $e5725b4a775f592f$var$STATUS_HOVER_ALPHA = 0.75;
const $e5725b4a775f592f$var$STATUS_HOVER_SCALE = 1.15;
const $e5725b4a775f592f$var$STATUS_TWEEN_DURATION_MS = 150;
const $e5725b4a775f592f$var$PULSE_DURATION_MS = 900;
const $e5725b4a775f592f$var$PULSE_REPEATS = 2;
const $e5725b4a775f592f$var$FOCUS_ZOOM = 1.6;
// High-contrast ring color for event-driven pulses — deliberately different
// from the usual theme pulse (yellow in night). Hot magenta reads clearly on
// both the dark and light backgrounds and isn't a status/action color.
const $e5725b4a775f592f$var$EVENT_PULSE_COLOR = 0xff2d95;
// ─── Easing ───────────────────────────────────────────────────────────────────
const $e5725b4a775f592f$var$easeInOutCubic = (t)=>t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
// ─── Animation de pan sur le ticker ──────────────────────────────────────────
const $e5725b4a775f592f$var$PAN_DURATION_MS = 900;
function $e5725b4a775f592f$var$createPanController(viewport, requestRender) {
    let rafId = null;
    const stop = ()=>{
        if (rafId !== null) {
            cancelAnimationFrame(rafId);
            rafId = null;
        }
    };
    // onDone fires once the pan lands (t reaches 1). It is NOT called if the pan is
    // interrupted by another focusTo/stop, so a superseded animation never triggers it.
    const focusTo = (targetX, targetY, targetScale, onDone)=>{
        stop();
        const startX = viewport.center.x;
        const startY = viewport.center.y;
        const startScale = viewport.scale.x;
        const endScale = targetScale ?? startScale;
        const startTime = performance.now();
        const tick = (now)=>{
            const t = Math.min(1, (now - startTime) / $e5725b4a775f592f$var$PAN_DURATION_MS);
            const et = $e5725b4a775f592f$var$easeInOutCubic(t);
            const s = startScale + (endScale - startScale) * et;
            viewport.scale.set(s);
            viewport.moveCenter(startX + (targetX - startX) * et, startY + (targetY - startY) * et);
            requestRender();
            if (t < 1) rafId = requestAnimationFrame(tick);
            else {
                rafId = null;
                onDone?.();
            }
        };
        rafId = requestAnimationFrame(tick);
    };
    const panTo = (targetX, targetY)=>focusTo(targetX, targetY);
    return {
        panTo: panTo,
        focusTo: focusTo,
        stop: stop
    };
}
function $e5725b4a775f592f$export$f2e6b952b66b609b(viewport, sprites, layouts, linesGraphics, getTheme, requestRender, pageId, onLayoutsChanged, onSelectionChange) {
    let drag = null;
    let selected = null;
    // Edges (parentId|childId) belonging to the path root → … → selected.
    // drawLines uses this to color those edges with theme.pulseColor.
    let selectedPathEdges = new Set();
    const updateSelectedPathEdges = (sprite)=>{
        selectedPathEdges = new Set();
        if (!sprite) return;
        let cursor = sprite.layout;
        while(cursor?.parentId){
            selectedPathEdges.add(`${cursor.parentId}|${cursor.id}`);
            cursor = layouts.get(cursor.parentId);
        }
    };
    const redrawLines = ()=>{
        (0, $b2b0b848f61053a7$export$a484e31e13c53240)(linesGraphics, layouts, getTheme(), selectedPathEdges);
    };
    // Drag-time coalescer: multiple pointermoves in one frame collapse to one
    // line rebuild. Every other call site (theme toggle, rotate, addSubtask,
    // delete, drag-end) keeps using `redrawLines` directly — those are rare
    // enough that synchronous redraws are clearer.
    let linesDirty = false;
    const scheduleLinesRedraw = ()=>{
        if (linesDirty) return;
        linesDirty = true;
        requestAnimationFrame(()=>{
            linesDirty = false;
            redrawLines();
            requestRender();
        });
    };
    // Manual double-click tracking. Two consecutive clicks on the same sprite
    // within DOUBLE_CLICK_MS open the add-subtask modal.
    const DOUBLE_CLICK_MS = 350;
    let lastClickAt = 0;
    let lastClicked = null;
    const pan = $e5725b4a775f592f$var$createPanController(viewport, requestRender);
    const setBarsVisible = (sprite, visible)=>{
        sprite.actionBar.container.visible = visible;
        sprite.statusBar.container.visible = visible;
    };
    const clearSelection = ()=>{
        if (!selected) return;
        setBarsVisible(selected, false);
        selected = null;
        updateSelectedPathEdges(null);
        redrawLines();
        cancelPathPulse();
        requestRender();
        onSelectionChange?.(null);
    };
    const select = (sprite)=>{
        if (selected === sprite) return;
        if (selected) setBarsVisible(selected, false);
        selected = sprite;
        setBarsVisible(sprite, true);
        updateSelectedPathEdges(sprite);
        redrawLines();
        requestRender();
        linePulsePaths(buildSelectionPaths(sprite));
        onSelectionChange?.(sprite.layout);
    };
    const deleteNode = (id)=>{
        const toDelete = new Set();
        const stack = [
            id
        ];
        while(stack.length > 0){
            const curr = stack.pop();
            if (toDelete.has(curr)) continue;
            toDelete.add(curr);
            const lay = layouts.get(curr);
            if (lay) stack.push(...lay.childIds);
        }
        const rootLayout = layouts.get(id);
        if (rootLayout?.parentId) {
            const parent = layouts.get(rootLayout.parentId);
            if (parent) parent.childIds = parent.childIds.filter((c)=>c !== id);
        }
        for (const delId of toDelete){
            const sprite = sprites.get(delId);
            if (sprite) {
                // Animate then destroy. Drop from sprites map immediately so the rest
                // of the system stops considering it a live node.
                crumple(sprite.container);
                sprites.delete(delId);
            }
            layouts.delete(delId);
        }
        selected = null;
        cancelPathPulse();
        redrawLines();
        requestRender();
        $88850f982d8abd1a$export$b05da9e94a08038f(id);
        onLayoutsChanged?.();
    };
    const addSubtask = async (parent)=>{
        const label = await (0, $81e833ca5dd4fe80$export$e2d76aac9cd37a6b)(`New subtask of "${parent.layout.label}"`);
        if (!label) return;
        let apiNode;
        try {
            apiNode = await $88850f982d8abd1a$export$270e7ba5936d3c48(pageId, label, parent.layout.id);
        } catch (err) {
            console.warn('[api] createNode failed', err);
            return;
        }
        const child = (0, $d030d2651a318c02$export$78f30f0059ab853a)({
            id: apiNode.id,
            label: apiNode.label,
            level: parent.layout.level + 1,
            status: apiNode.status,
            parentId: parent.layout.id,
            childIds: [],
            x: parent.layout.x,
            y: parent.layout.y
        });
        layouts.set(child.id, child);
        parent.layout.childIds.push(child.id);
        // Fan-out the parent's subtree so siblings + new child get clean positions.
        (0, $d030d2651a318c02$export$911a8f94f7e3e0a7)(parent.layout.id, layouts);
        registerNode(child);
        const updates = [];
        for (const [id, s] of sprites){
            const lay = layouts.get(id);
            if (!lay) continue;
            s.container.x = lay.x;
            s.container.y = lay.y;
            updates.push({
                id: id,
                x: lay.x,
                y: lay.y
            });
        }
        redrawLines();
        requestRender();
        $88850f982d8abd1a$export$502f3028ce474436(updates);
        onLayoutsChanged?.();
        linePulse(parent.layout, child);
    };
    function wireSprite(sprite) {
        const { container: container, actionBar: actionBar, statusBar: statusBar } = sprite;
        container.eventMode = 'static';
        container.cursor = 'pointer';
        container.on('pointerdown', (e)=>{
            const world = viewport.toWorld(e.global.x, e.global.y);
            drag = {
                sprite: sprite,
                offsetX: container.x - world.x,
                offsetY: container.y - world.y,
                startX: e.global.x,
                startY: e.global.y
            };
            container.zIndex = 999;
            e.stopPropagation();
        });
        statusBar.buttons.forEach((btn, i)=>{
            btn.container.on('pointerover', ()=>{
                const isActive = sprite.layout.status === (0, $b2b0b848f61053a7$export$a52272efb2c5663f)[i];
                const toAlpha = isActive ? (0, $b2b0b848f61053a7$export$f6c5f38e96711b6e) : $e5725b4a775f592f$var$STATUS_HOVER_ALPHA;
                tweenButton(btn.container, $e5725b4a775f592f$var$STATUS_HOVER_SCALE, toAlpha);
            });
            btn.container.on('pointerout', ()=>{
                const isActive = sprite.layout.status === (0, $b2b0b848f61053a7$export$a52272efb2c5663f)[i];
                const toAlpha = isActive ? (0, $b2b0b848f61053a7$export$f6c5f38e96711b6e) : (0, $b2b0b848f61053a7$export$6d4894f9964c5fee);
                tweenButton(btn.container, 1, toAlpha);
            });
            btn.container.on('pointerdown', (e)=>{
                e.stopPropagation();
                const target = (0, $b2b0b848f61053a7$export$a52272efb2c5663f)[i];
                if (!target || sprite.layout.status === target) {
                    // Re-clicking the active status still gives feedback.
                    pulseRing(btn.container, (0, $b2b0b848f61053a7$export$58a5f3166fc74e5c), 1);
                    return;
                }
                // Cancel any in-flight hover tweens so the snap from refreshNodeStatus sticks.
                statusBar.buttons.forEach((b)=>cancelTween(b.container));
                sprite.layout.status = target;
                (0, $b2b0b848f61053a7$export$a07758ef936a4649)(sprite, getTheme());
                bounce(sprite.statusBadge.container);
                if (target === 'blocked') shake(sprite);
                if (target === 'done') triggerFirework(sprite);
                pulseRing(btn.container, (0, $b2b0b848f61053a7$export$58a5f3166fc74e5c), 1);
                $88850f982d8abd1a$export$e0a999c03d83fa5(sprite.layout.id, target);
                requestRender();
                onLayoutsChanged?.();
            });
        });
        actionBar.addButton.container.on('pointerdown', (e)=>{
            e.stopPropagation();
            addSubtask(sprite);
        });
        actionBar.rotateButton.container.on('pointerdown', (e)=>{
            e.stopPropagation();
            (0, $d030d2651a318c02$export$911a8f94f7e3e0a7)(sprite.layout.id, layouts);
            const updates = [];
            for (const [id, s] of sprites){
                const lay = layouts.get(id);
                if (!lay) continue;
                s.container.x = lay.x;
                s.container.y = lay.y;
                updates.push({
                    id: id,
                    x: lay.x,
                    y: lay.y
                });
            }
            redrawLines();
            requestRender();
            $88850f982d8abd1a$export$502f3028ce474436(updates);
        });
        actionBar.deleteButton.container.on('pointerdown', (e)=>{
            e.stopPropagation();
            deleteNode(sprite.layout.id);
        });
        sprite.descBadge.container.on('pointerdown', (e)=>{
            e.stopPropagation();
            editDescription(sprite);
        });
    }
    const editDescription = async (sprite)=>{
        const next = await (0, $81e833ca5dd4fe80$export$2c6b9969095d608d)(`Description \u{2014} "${sprite.layout.label}"`, sprite.layout.description);
        if (next === null || next === sprite.layout.description) return;
        sprite.layout.description = next;
        (0, $b2b0b848f61053a7$export$cd4f9a6eb89818ab)(sprite, getTheme());
        requestRender();
        $88850f982d8abd1a$export$2ff8ceeb000e6aee(sprite.layout.id, next);
        onLayoutsChanged?.();
    };
    function registerNode(layout) {
        const sprite = (0, $b2b0b848f61053a7$export$96a186a9b8e41771)(layout, getTheme());
        sprite.container.zIndex = Math.max(1, 4 - layout.level);
        sprites.set(layout.id, sprite);
        viewport.addChild(sprite.container);
        wireSprite(sprite);
        dropIn(sprite.container);
        return sprite;
    }
    viewport.on('drag-start', ()=>{
        pan.stop();
    });
    viewport.on('wheel', pan.stop);
    viewport.on('pinch-start', pan.stop);
    // Tap on empty canvas → clear selection. Sprite pointerdowns stopPropagation,
    // so this only fires for empty space. Distinguish tap from pan-drag via distance.
    let emptyTapStart = null;
    viewport.on('pointerdown', (e)=>{
        emptyTapStart = {
            x: e.global.x,
            y: e.global.y
        };
    });
    viewport.on('pointerup', (e)=>{
        if (!emptyTapStart) return;
        const dx = e.global.x - emptyTapStart.x;
        const dy = e.global.y - emptyTapStart.y;
        emptyTapStart = null;
        if (Math.hypot(dx, dy) < 5) {
            pan.stop();
            clearSelection();
        }
    });
    for (const sprite of sprites.values())wireSprite(sprite);
    viewport.on('pointermove', (e)=>{
        if (!drag) return;
        const world = viewport.toWorld(e.global.x, e.global.y);
        drag.sprite.container.x = world.x + drag.offsetX;
        drag.sprite.container.y = world.y + drag.offsetY;
        drag.sprite.layout.x = drag.sprite.container.x;
        drag.sprite.layout.y = drag.sprite.container.y;
        // High-refresh-rate pointers can fire >120 Hz; coalesce line rebuilds
        // to one per frame regardless of how many move events arrive.
        scheduleLinesRedraw();
        // Drop a fading ghost every ~50 ms so motion leaves a trail.
        const now = performance.now();
        if (now - lastTrailAt > 50) {
            lastTrailAt = now;
            spawnTrailGhost(drag.sprite);
        }
        requestRender();
    });
    const endDrag = (e)=>{
        if (!drag) return;
        const { sprite: sprite, startX: startX, startY: startY } = drag;
        const dx = e.global.x - startX;
        const dy = e.global.y - startY;
        const moved = Math.hypot(dx, dy) >= 5;
        if (!moved) {
            const now = performance.now();
            const isDouble = lastClicked === sprite && now - lastClickAt < DOUBLE_CLICK_MS;
            if (isDouble) {
                lastClickAt = 0;
                lastClicked = null;
                pan.stop();
                addSubtask(sprite);
            } else {
                lastClickAt = now;
                lastClicked = sprite;
                select(sprite);
                // Zoom in to at least FOCUS_ZOOM (don't de-zoom if user is already deeper).
                const targetZoom = Math.max(viewport.scale.x, $e5725b4a775f592f$var$FOCUS_ZOOM);
                pan.focusTo(sprite.layout.x, sprite.layout.y, targetZoom);
                pulseNode(sprite.layout.id);
            }
        } else $88850f982d8abd1a$export$bfcba650c63431da(sprite.layout.id, sprite.layout.x, sprite.layout.y);
        sprite.container.zIndex = Math.max(1, 4 - sprite.layout.level);
        drag = null;
        requestRender();
    };
    viewport.on('pointerup', endDrag);
    window.addEventListener('pointerup', ()=>{
        if (!drag) return;
        drag.sprite.container.zIndex = Math.max(1, 4 - drag.sprite.layout.level);
        drag = null;
        requestRender();
    });
    // ─── Smooth scale + alpha tween on a Container ─────────────────────────
    const buttonTweens = new WeakMap();
    const cancelTween = (target)=>{
        const id = buttonTweens.get(target);
        if (id !== undefined) {
            cancelAnimationFrame(id);
            buttonTweens.delete(target);
        }
    };
    const tweenButton = (target, toScale, toAlpha)=>{
        cancelTween(target);
        const startScale = target.scale.x;
        const startAlpha = target.alpha;
        const startTime = performance.now();
        const tick = (now)=>{
            const t = Math.min(1, (now - startTime) / $e5725b4a775f592f$var$STATUS_TWEEN_DURATION_MS);
            const et = t * (2 - t); // easeOutQuad
            target.scale.set(startScale + (toScale - startScale) * et);
            target.alpha = startAlpha + (toAlpha - startAlpha) * et;
            requestRender();
            if (t < 1) buttonTweens.set(target, requestAnimationFrame(tick));
            else buttonTweens.delete(target);
        };
        buttonTweens.set(target, requestAnimationFrame(tick));
    };
    // ─── Bounce (status badge punch) ───────────────────────────────────────
    const bounceTweens = new WeakMap();
    const cancelBounce = (target)=>{
        const id = bounceTweens.get(target);
        if (id !== undefined) {
            cancelAnimationFrame(id);
            bounceTweens.delete(target);
        }
    };
    const bounce = (target, peak = 1.4, duration = 250)=>{
        cancelBounce(target);
        const start = performance.now();
        const tick = (now)=>{
            if (target.destroyed) {
                bounceTweens.delete(target);
                return;
            }
            const elapsed = now - start;
            if (elapsed >= duration) {
                target.scale.set(1);
                bounceTweens.delete(target);
                requestRender();
                return;
            }
            // Bell curve: 1 → peak → 1 via sine.
            const t = elapsed / duration;
            target.scale.set(1 + (peak - 1) * Math.sin(t * Math.PI));
            requestRender();
            bounceTweens.set(target, requestAnimationFrame(tick));
        };
        bounceTweens.set(target, requestAnimationFrame(tick));
    };
    // ─── Shake (negative feedback when a node is blocked) ──────────────────
    const shakeTweens = new WeakMap();
    const cancelShake = (target)=>{
        const id = shakeTweens.get(target);
        if (id !== undefined) {
            cancelAnimationFrame(id);
            shakeTweens.delete(target);
        }
    };
    const shake = (sprite, peak = 6, duration = 400)=>{
        const c = sprite.container;
        cancelShake(c);
        const start = performance.now();
        const tick = (now)=>{
            // Bail out if the user is currently dragging this sprite or it was destroyed.
            if (c.destroyed || drag?.sprite === sprite) {
                shakeTweens.delete(c);
                return;
            }
            const elapsed = now - start;
            if (elapsed >= duration) {
                c.x = sprite.layout.x;
                shakeTweens.delete(c);
                requestRender();
                return;
            }
            const t = elapsed / duration;
            const dx = peak * Math.sin(t * Math.PI * 5) * (1 - t); // 5 oscillations, damped
            c.x = sprite.layout.x + dx;
            requestRender();
            shakeTweens.set(c, requestAnimationFrame(tick));
        };
        shakeTweens.set(c, requestAnimationFrame(tick));
    };
    // ─── Drop-in (new sprite scales from 0 → 1 with easeOutBack) ───────────
    const dropIn = (target, duration = 360)=>{
        target.scale.set(0);
        const c1 = 1.70158;
        const c3 = c1 + 1;
        const start = performance.now();
        const tick = (now)=>{
            if (target.destroyed) return;
            const elapsed = now - start;
            if (elapsed >= duration) {
                target.scale.set(1);
                requestRender();
                return;
            }
            const t = elapsed / duration;
            const u = t - 1;
            const e = 1 + c3 * u * u * u + c1 * u * u;
            target.scale.set(Math.max(0, e));
            requestRender();
            requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
    };
    // ─── Crumple (sprite collapses + fades, then destroys itself) ──────────
    const crumple = (target, duration = 280)=>{
        const start = performance.now();
        const startScale = target.scale.x;
        const startAlpha = target.alpha;
        const tick = (now)=>{
            if (target.destroyed) return;
            const elapsed = now - start;
            if (elapsed >= duration) {
                target.destroy({
                    children: true
                });
                requestRender();
                return;
            }
            const t = elapsed / duration;
            const e = t * t; // easeInQuad
            target.scale.set(Math.max(0, startScale * (1 - e)));
            target.alpha = Math.max(0, startAlpha * (1 - e));
            requestRender();
            requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
    };
    // ─── Drag trail (fading ghost disc dropped at the dragged node's path) ─
    let lastTrailAt = 0;
    const spawnTrailGhost = (sprite)=>{
        const ghost = new (0, $bcTIE.Graphics)();
        ghost.eventMode = 'none';
        const theme = getTheme();
        const color = theme.nodeColors[Math.min(sprite.layout.level, theme.nodeColors.length - 1)];
        ghost.circle(0, 0, sprite.layout.radius);
        ghost.fill({
            color: color,
            alpha: 0.35
        });
        ghost.x = sprite.layout.x;
        ghost.y = sprite.layout.y;
        // Insert behind sprites: linesGraphics sits at viewport child index 0,
        // adding here puts the ghost just above lines and below the live nodes.
        viewport.addChildAt(ghost, 1);
        const start = performance.now();
        const duration = 420;
        const tick = (now)=>{
            if (ghost.destroyed) return;
            const elapsed = now - start;
            if (elapsed >= duration) {
                ghost.destroy();
                requestRender();
                return;
            }
            ghost.alpha = 0.35 * (1 - elapsed / duration);
            requestRender();
            requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
    };
    // ─── Path pulse: sparkle dot(s) flowing root → selected → every leaf ───
    let pathPulseRafId = null;
    let pathPulseDots = [];
    const cancelPathPulse = ()=>{
        if (pathPulseRafId !== null) {
            cancelAnimationFrame(pathPulseRafId);
            pathPulseRafId = null;
        }
        for (const dot of pathPulseDots)if (!dot.destroyed) dot.destroy();
        pathPulseDots = [];
    };
    const pathToRoot = (sprite)=>{
        const path = [];
        let cursor = sprite.layout;
        while(cursor){
            path.unshift(cursor);
            cursor = cursor.parentId ? layouts.get(cursor.parentId) : undefined;
        }
        return path;
    };
    /** All paths from `start` to every leaf (DFS). For a leaf, returns [[start]]. */ const leafPathsFrom = (start)=>{
        const out = [];
        const dfs = (node, acc)=>{
            const next = [
                ...acc,
                node
            ];
            if (node.childIds.length === 0) {
                out.push(next);
                return;
            }
            for (const childId of node.childIds){
                const child = layouts.get(childId);
                if (child) dfs(child, next);
            }
        };
        dfs(start, []);
        return out;
    };
    /** Full root → leaf paths through the selected node. */ const buildSelectionPaths = (sprite)=>{
        const trunk = pathToRoot(sprite); // [root, …, selected]
        const tails = leafPathsFrom(sprite.layout); // [[selected, …, leaf], …]
        return tails.map((tail)=>[
                ...trunk.slice(0, -1),
                ...tail
            ]);
    };
    /** Smooth oval ("comet") — angle-free. Rotation is set per-frame to align with motion. */ const makeOvalDot = (color, halfW = 9, halfH = 4.5)=>{
        const g = new (0, $bcTIE.Graphics)();
        g.eventMode = 'none';
        g.ellipse(0, 0, halfW, halfH).fill({
            color: color
        });
        return g;
    };
    const PATH_PULSE_PAUSE_MS = 400;
    const PATH_PULSE_EDGE_MS = 650; // slower: 650 ms per edge
    const MAX_PATH_PULSE_LEAVES = 24; // cap to keep deep-root selections cheap
    const linePulsePaths = (paths, durationPerEdge = PATH_PULSE_EDGE_MS)=>{
        cancelPathPulse();
        let valid = paths.filter((p)=>p.length >= 2);
        if (valid.length === 0) return;
        if (valid.length > MAX_PATH_PULSE_LEAVES) {
            // Fisher-Yates partial shuffle, then keep the first N.
            // Random sampling keeps the visual evenly distributed across branches.
            const arr = valid.slice();
            for(let i = 0; i < MAX_PATH_PULSE_LEAVES; i++){
                const j = i + Math.floor(Math.random() * (arr.length - i));
                const tmp = arr[i];
                arr[i] = arr[j];
                arr[j] = tmp;
            }
            valid = arr.slice(0, MAX_PATH_PULSE_LEAVES);
        }
        const totals = [];
        const dots = [];
        const color = getTheme().pulseColor;
        for (const path of valid){
            const dot = makeOvalDot(color);
            const first = path[0];
            dot.x = first.x;
            dot.y = first.y;
            dot.alpha = 0;
            viewport.addChild(dot);
            dots.push(dot);
            totals.push(durationPerEdge * (path.length - 1));
        }
        pathPulseDots = dots;
        const maxTotal = Math.max(...totals);
        const cycle = maxTotal + PATH_PULSE_PAUSE_MS;
        let cycleStart = performance.now();
        const tick = (now)=>{
            const elapsed = now - cycleStart;
            if (elapsed >= cycle) {
                cycleStart = now;
                pathPulseRafId = requestAnimationFrame(tick);
                return;
            }
            for(let i = 0; i < valid.length; i++){
                const path = valid[i];
                const dot = dots[i];
                const total = totals[i];
                if (!path || !dot || total === undefined || dot.destroyed) continue;
                if (elapsed >= total) {
                    if (dot.alpha !== 0) dot.alpha = 0;
                    continue;
                }
                const globalT = elapsed / total;
                const edgeProgress = globalT * (path.length - 1);
                const edgeIdx = Math.max(0, Math.min(Math.floor(edgeProgress), path.length - 2));
                const localT = edgeProgress - edgeIdx;
                const from = path[edgeIdx];
                const to = path[edgeIdx + 1];
                // Defensive: the path is captured by closure, so a node deleted between
                // selection and this tick still has its NodeLayout in JS memory — but
                // log + skip if for some reason an endpoint is missing.
                if (!from || !to) continue;
                const e = localT < 0.5 ? 4 * localT * localT * localT : 1 - Math.pow(-2 * localT + 2, 3) / 2;
                dot.x = from.x + (to.x - from.x) * e;
                dot.y = from.y + (to.y - from.y) * e;
                dot.rotation = Math.atan2(to.y - from.y, to.x - from.x);
                dot.alpha = globalT < 0.1 ? globalT / 0.1 : globalT > 0.9 ? (1 - globalT) / 0.1 : 1;
            }
            requestRender();
            pathPulseRafId = requestAnimationFrame(tick);
        };
        pathPulseRafId = requestAnimationFrame(tick);
    };
    // ─── Line pulse (dot travelling along a freshly-created edge) ──────────
    const linePulse = (parent, child, duration = 600)=>{
        const dot = new (0, $bcTIE.Graphics)();
        dot.eventMode = 'none';
        dot.circle(0, 0, 5);
        dot.fill({
            color: getTheme().pulseColor
        });
        dot.x = parent.x;
        dot.y = parent.y;
        viewport.addChild(dot);
        const start = performance.now();
        const tick = (now)=>{
            const elapsed = now - start;
            if (elapsed >= duration) {
                dot.destroy();
                requestRender();
                return;
            }
            const t = elapsed / duration;
            // easeInOutCubic
            const e = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
            dot.x = parent.x + (child.x - parent.x) * e;
            dot.y = parent.y + (child.y - parent.y) * e;
            // Trapezoid alpha: fade in over first 15 %, hold, fade out over last 15 %.
            const alpha = t < 0.15 ? t / 0.15 : t > 0.85 ? (1 - t) / 0.15 : 1;
            dot.alpha = alpha;
            requestRender();
            requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
    };
    const pulseRing = (target, baseRadius, repeats, color)=>{
        const ring = new (0, $bcTIE.Graphics)();
        target.addChild(ring);
        const start = performance.now();
        const total = $e5725b4a775f592f$var$PULSE_DURATION_MS * repeats;
        const tick = (now)=>{
            const elapsed = now - start;
            if (elapsed >= total) {
                ring.destroy();
                requestRender();
                return;
            }
            const local = elapsed % $e5725b4a775f592f$var$PULSE_DURATION_MS / $e5725b4a775f592f$var$PULSE_DURATION_MS;
            const r = baseRadius + baseRadius * 1.6 * local;
            const alpha = 0.85 * (1 - local);
            ring.clear();
            ring.circle(0, 0, r);
            ring.stroke({
                width: 3,
                color: color ?? getTheme().pulseColor,
                alpha: alpha
            });
            requestRender();
            requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
    };
    const pulseNode = (id)=>{
        const sprite = sprites.get(id);
        if (!sprite) return;
        pulseRing(sprite.container, sprite.layout.radius, $e5725b4a775f592f$var$PULSE_REPEATS);
    };
    // ─── Firework / success animation ──────────────────────────────────────
    const FIREWORK_PARTICLE_COUNT = 16;
    const FIREWORK_DURATION_MS = 1100;
    const FIREWORK_MIN_DISTANCE = 90;
    const FIREWORK_MAX_DISTANCE = 220;
    const FIREWORK_PARTICLE_R = 13;
    const FIREWORK_ICON_SIZE = 14;
    // Bright, mutually-distinct fills.
    const FIREWORK_COLORS = [
        0xff6b9d,
        0xfeca57,
        0x48dbfb,
        0x1dd1a1,
        0xff9ff3,
        0xff7f50,
        0xa29bfe,
        0xffd93d
    ];
    const triggerFirework = (sprite)=>{
        const particles = [];
        for(let i = 0; i < FIREWORK_PARTICLE_COUNT; i++){
            // Even radial distribution + small jitter so it doesn't look mechanical.
            const angle = i / FIREWORK_PARTICLE_COUNT * Math.PI * 2 + (Math.random() - 0.5) * 0.5;
            const distance = FIREWORK_MIN_DISTANCE + Math.random() * (FIREWORK_MAX_DISTANCE - FIREWORK_MIN_DISTANCE);
            const color = FIREWORK_COLORS[Math.floor(Math.random() * FIREWORK_COLORS.length)];
            const iconName = (0, $bece2cf6ee11737c$export$17256b591efd52a2)[Math.floor(Math.random() * (0, $bece2cf6ee11737c$export$17256b591efd52a2).length)];
            const spin = (Math.random() - 0.5) * Math.PI * 1.2;
            const p = new (0, $5Wp7K.Container)();
            p.eventMode = 'none';
            const bg = new (0, $bcTIE.Graphics)();
            bg.circle(0, 0, FIREWORK_PARTICLE_R);
            bg.fill({
                color: color
            });
            p.addChild(bg);
            const iconGfx = new (0, $bcTIE.Graphics)();
            (0, $bece2cf6ee11737c$export$317873f447e05c70)(iconGfx, (0, $bece2cf6ee11737c$export$fde44257752a9f60)[iconName], 0xffffff, FIREWORK_ICON_SIZE, 2.4);
            p.addChild(iconGfx);
            sprite.container.addChild(p);
            particles.push({
                container: p,
                angle: angle,
                distance: distance,
                spin: spin
            });
        }
        // Boost zIndex during the burst so particles fly above neighbouring nodes.
        const prevZ = sprite.container.zIndex;
        sprite.container.zIndex = 1000;
        const start = performance.now();
        const tick = (now)=>{
            const elapsed = now - start;
            if (elapsed >= FIREWORK_DURATION_MS) {
                for (const p of particles)p.container.destroy({
                    children: true
                });
                sprite.container.zIndex = prevZ;
                requestRender();
                return;
            }
            const t = elapsed / FIREWORK_DURATION_MS;
            const ease = 1 - Math.pow(1 - t, 3); // easeOutCubic for distance
            const fade = t < 0.65 ? 1 : 1 - (t - 0.65) / 0.35; // hold then fade
            for (const p of particles){
                const r = p.distance * ease;
                p.container.x = Math.cos(p.angle) * r;
                // Slight gravity pull so particles drop a bit at the end.
                p.container.y = Math.sin(p.angle) * r + 40 * t * t;
                p.container.alpha = Math.max(0, fade);
                p.container.rotation = p.spin * t;
                p.container.scale.set(0.5 + 0.5 * (1 - t));
            }
            requestRender();
            requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
    };
    // Space → mark selected node as done + firework.
    window.addEventListener('keydown', (e)=>{
        if (e.code !== 'Space' || e.repeat || !selected) return;
        const target = e.target;
        const tag = target?.tagName;
        if (tag === 'INPUT' || tag === 'TEXTAREA' || target?.isContentEditable) return;
        e.preventDefault();
        if (selected.layout.status !== 'done') {
            selected.statusBar.buttons.forEach((b)=>cancelTween(b.container));
            selected.layout.status = 'done';
            (0, $b2b0b848f61053a7$export$a07758ef936a4649)(selected, getTheme());
            bounce(selected.statusBadge.container);
            $88850f982d8abd1a$export$e0a999c03d83fa5(selected.layout.id, 'done');
            onLayoutsChanged?.();
        }
        triggerFirework(selected);
    });
    const selectNode = (id)=>{
        const sprite = sprites.get(id);
        if (sprite) select(sprite);
    };
    // Mirrors a user tapping a node: zoom in to at least FOCUS_ZOOM (without
    // de-zooming if already deeper), pulse, and select. Same path as the node-list
    // panel click and the canvas focus.
    // Event pulse — zoom/pan to the node, THEN (once the zoom lands) play the
    // high-contrast ring and run onArrive. No selection, no panel navigation, so
    // the view scope is preserved. Returns false if the node isn't on this page.
    const pulseEvent = (id, onArrive)=>{
        const sprite = sprites.get(id);
        if (!sprite) return false;
        pan.focusTo(sprite.layout.x, sprite.layout.y, Math.max(viewport.scale.x, $e5725b4a775f592f$var$FOCUS_ZOOM), ()=>{
            const s = sprites.get(id); // node may have been removed during the pan
            if (!s) return;
            pulseRing(s.container, s.layout.radius, $e5725b4a775f592f$var$PULSE_REPEATS, $e5725b4a775f592f$var$EVENT_PULSE_COLOR);
            requestRender();
            onArrive?.();
        });
        return true;
    };
    // Card click: zoom to the node, then play its event animation (pulse + status
    // flourish) on arrival. Does not change the node's state or the panel scope.
    const playEventAnimation = (id, status)=>pulseEvent(id, ()=>{
            const s = sprites.get(id);
            if (!s) return;
            if (status === 'done') triggerFirework(s);
            else if (status === 'blocked') {
                shake(s);
                bounce(s.statusBadge.container);
            } else if (status) bounce(s.statusBadge.container);
            requestRender();
        });
    const getSelectedId = ()=>selected?.layout.id ?? null;
    // Reflect a status the API already persisted (via an event) onto the sprite.
    // Mirrors the status-bar click path, minus the api.patchStatus write.
    const applyStatusVisual = (id, status)=>{
        const sprite = sprites.get(id);
        if (!sprite || sprite.layout.status === status) return;
        sprite.statusBar.buttons.forEach((b)=>cancelTween(b.container));
        sprite.layout.status = status;
        (0, $b2b0b848f61053a7$export$a07758ef936a4649)(sprite, getTheme());
        bounce(sprite.statusBadge.container);
        if (status === 'blocked') shake(sprite);
        if (status === 'done') triggerFirework(sprite);
        requestRender();
        onLayoutsChanged?.();
    };
    // Reflect a label the API already persisted (via an event) onto the sprite.
    const applyLabelVisual = (id, label)=>{
        const sprite = sprites.get(id);
        if (!sprite || sprite.layout.label === label) return;
        sprite.layout.label = label;
        sprite.text.text = label;
        requestRender();
        onLayoutsChanged?.();
    };
    return {
        registerNode: registerNode,
        focusOn: pan.focusTo,
        pulseNode: pulseNode,
        selectNode: selectNode,
        pulseEvent: pulseEvent,
        playEventAnimation: playEventAnimation,
        getSelectedId: getSelectedId,
        applyStatusVisual: applyStatusVisual,
        applyLabelVisual: applyLabelVisual,
        redrawLines: redrawLines
    };
}




const $0f6a2e8989a0c18e$var$FOCUS_ZOOM = 1.6;
function $0f6a2e8989a0c18e$export$58a97a354cca1bd9(layouts, focusOn, pulseNode, selectNode) {
    const search = document.getElementById('node-search');
    const list = document.getElementById('node-list');
    let query = '';
    const render = ()=>{
        const q = query.toLowerCase();
        // DFS pre-order from each root so the list mirrors the project hierarchy.
        // Roots iterate in `layouts` insertion order (which matches creation order).
        const ordered = [];
        const seen = new Set();
        const visit = (layout)=>{
            if (seen.has(layout.id)) return; // safety against accidental cycles
            seen.add(layout.id);
            ordered.push(layout);
            for (const childId of layout.childIds){
                const child = layouts.get(childId);
                if (child) visit(child);
            }
        };
        for (const layout of layouts.values())if (layout.parentId === null) visit(layout);
        list.innerHTML = '';
        for (const layout of ordered){
            if (q !== '' && !layout.label.toLowerCase().includes(q)) continue;
            const li = document.createElement('li');
            li.dataset.id = layout.id;
            li.style.paddingLeft = `${14 + layout.level * 12}px`;
            const statusIcon = (0, $bece2cf6ee11737c$export$a93c45a3f0b1e89e)((0, $b2b0b848f61053a7$export$3350f4ba2fa1a3b)[layout.status], 14);
            li.innerHTML = `<span class="status" style="color:var(--status-${layout.status})">${statusIcon}</span>` + `<span class="level">L${layout.level}</span>` + `<span class="label">${$0f6a2e8989a0c18e$var$escapeHtml(layout.label)}</span>`;
            list.appendChild(li);
        }
    };
    // Coalesce render() calls to one per frame — keystrokes and external
    // refreshes can arrive in bursts; we don't need a DOM rebuild for each.
    let renderQueued = false;
    const scheduleRender = ()=>{
        if (renderQueued) return;
        renderQueued = true;
        requestAnimationFrame(()=>{
            renderQueued = false;
            render();
        });
    };
    // Click delegation — survives re-renders.
    list.addEventListener('click', (e)=>{
        const li = e.target.closest('li');
        if (!li || !li.dataset.id) return;
        const layout = layouts.get(li.dataset.id);
        if (!layout) return;
        focusOn(layout.x, layout.y, $0f6a2e8989a0c18e$var$FOCUS_ZOOM);
        pulseNode(layout.id);
        selectNode(layout.id);
    });
    // Search-match pulse: 250 ms after the user stops typing, pulse every node
    // whose label still matches the query — capped to avoid mass-pulse sweeps.
    const SEARCH_PULSE_DEBOUNCE_MS = 250;
    const SEARCH_PULSE_MAX_MATCHES = 30;
    let searchPulseTimer = null;
    search.addEventListener('input', ()=>{
        query = search.value;
        scheduleRender();
        if (searchPulseTimer !== null) clearTimeout(searchPulseTimer);
        const trimmed = query.trim();
        if (trimmed === '') return;
        searchPulseTimer = window.setTimeout(()=>{
            searchPulseTimer = null;
            const q = trimmed.toLowerCase();
            const matches = [];
            for (const layout of layouts.values())if (layout.label.toLowerCase().includes(q)) {
                matches.push(layout.id);
                if (matches.length > SEARCH_PULSE_MAX_MATCHES) return; // skip when too broad
            }
            for (const id of matches)pulseNode(id);
        }, SEARCH_PULSE_DEBOUNCE_MS);
    });
    render();
    return {
        refresh: scheduleRender
    };
}
function $0f6a2e8989a0c18e$var$escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}





const $27dfa76bb68b188f$var$STATUS_LABEL = {
    'todo': 'Todo',
    'in-progress': 'In progress',
    'done': 'Done',
    'blocked': 'Blocked'
};
function $27dfa76bb68b188f$export$1adbbcd8ae53030c(pageId, layouts, onEventClick = ()=>{}) {
    const body = document.getElementById('event-body');
    let nodeId = null;
    let playingId = null; // event currently being played by the queue
    // Guards against a stale fetchEvents resolving after the user switched nodes.
    let gen = 0;
    const statusDot = (status, label)=>`<span class="ep-status-dot" style="color:var(--status-${status})">` + `${(0, $bece2cf6ee11737c$export$a93c45a3f0b1e89e)((0, $b2b0b848f61053a7$export$3350f4ba2fa1a3b)[status], 14)}</span>${$27dfa76bb68b188f$var$escapeHtml(label)}`;
    // Read-only node header + timeline (events are sent via the API, not this panel).
    const nodeViewHtml = (layout)=>`<div class="ep-node">` + `<span class="ep-status-dot" style="color:var(--status-${layout.status})">` + `${(0, $bece2cf6ee11737c$export$a93c45a3f0b1e89e)((0, $b2b0b848f61053a7$export$3350f4ba2fa1a3b)[layout.status], 16)}</span>` + `<span class="ep-node-label">${$27dfa76bb68b188f$var$escapeHtml(layout.label)}</span>` + `</div>` + `<ul id="event-list"></ul>`;
    // `showNode` prefixes each row with its node's label — used by the page feed,
    // where events come from many different nodes.
    const eventHtml = (e, showNode = false)=>{
        const head = e.status ? `<span class="ep-event-status">${statusDot(e.status, $27dfa76bb68b188f$var$STATUS_LABEL[e.status])}</span>` : `<span class="ep-event-status ep-info">Info</span>`;
        const node = showNode ? `<div class="ep-event-node">${$27dfa76bb68b188f$var$escapeHtml(layouts.get(e.node_id)?.label ?? '(node)')}</div>` : '';
        // Rename line keeps the previous name alongside the new one.
        const rename = e.label ? `<p class="ep-event-rename">` + `<span class="ep-old-name">${$27dfa76bb68b188f$var$escapeHtml(e.prev_label ?? '')}</span>` + ` \u{2192} <span class="ep-new-name">${$27dfa76bb68b188f$var$escapeHtml(e.label)}</span></p>` : '';
        const note = e.note ? `<p class="ep-event-note">${$27dfa76bb68b188f$var$escapeHtml(e.note)}</p>` : '';
        const author = e.author ? `<span class="ep-event-author">\u{2014} ${$27dfa76bb68b188f$var$escapeHtml(e.author)}</span>` : '';
        return `<li class="ep-event${e.id === playingId ? ' ep-event-playing' : ''}" ` + `data-event-id="${e.id}" data-node-id="${e.node_id}" data-status="${e.status ?? ''}">` + node + `<div class="ep-event-head">${head}<time>${$27dfa76bb68b188f$var$escapeHtml($27dfa76bb68b188f$var$formatTime(e.created_at))}</time></div>` + rename + note + author + `</li>`;
    };
    const renderTimeline = (events, showNode = false)=>{
        const list = document.getElementById('event-list');
        if (!list) return;
        list.innerHTML = events.length === 0 ? `<li class="ep-event-empty">No events yet.</li>` : events.map((e)=>eventHtml(e, showNode)).join('');
    };
    // No node connected → show every event on the page, newest first, read-only.
    const renderFeed = ()=>{
        body.innerHTML = `<div class="ep-node ep-feed-head"><span class="ep-node-label">All page events</span></div>` + `<ul id="event-list"></ul>`;
        const myGen = ++gen;
        renderTimeline([]); // placeholder cleared by the fetch below
        $88850f982d8abd1a$export$1624fa12e286a50f(pageId).then((events)=>{
            if (myGen === gen) renderTimeline(events, true);
        }).catch((err)=>{
            console.warn('[eventPanel] fetchAllPageEvents failed', err);
            if (myGen === gen) renderTimeline([], true);
        });
    };
    const render = ()=>{
        const layout = nodeId !== null ? layouts.get(nodeId) : undefined;
        if (!layout) {
            renderFeed();
            return;
        }
        body.innerHTML = nodeViewHtml(layout);
        const myGen = ++gen;
        renderTimeline([]); // placeholder cleared by the fetch below
        $88850f982d8abd1a$export$2f6ec72f51ef1792(layout.id).then((events)=>{
            if (myGen === gen) renderTimeline(events);
        }).catch((err)=>{
            console.warn('[eventPanel] fetchEvents failed', err);
            if (myGen === gen) renderTimeline([]);
        });
    };
    const isOpen = ()=>document.body.classList.contains('events-open');
    // Clicking an event card replays its animation on the concerned node.
    // Delegated on `body` (stable) so it survives timeline re-renders.
    body.addEventListener('click', (ev)=>{
        const li = ev.target.closest('.ep-event');
        if (!li || !li.dataset.nodeId) return;
        onEventClick(li.dataset.nodeId, li.dataset.status || null);
    });
    // Feed mode = no node connected (null id, or the node isn't on this page).
    const inFeedMode = ()=>nodeId === null || !layouts.get(nodeId);
    const addEvent = (e)=>{
        if (!isOpen()) return; // closed → the list re-fetches fresh when reopened
        const feed = inFeedMode();
        if (!feed && e.node_id !== nodeId) return; // node mode: only this node's events
        const list = document.getElementById('event-list');
        if (!list || list.querySelector(`[data-event-id="${e.id}"]`)) return; // dedupe
        const empty = list.querySelector('.ep-event-empty');
        if (empty) empty.remove();
        list.insertAdjacentHTML('afterbegin', eventHtml(e, feed));
    };
    const markPlaying = (id)=>{
        playingId = id;
        const list = document.getElementById('event-list');
        if (!list) return;
        list.querySelectorAll('.ep-event-playing').forEach((el)=>el.classList.remove('ep-event-playing'));
        if (id) list.querySelector(`[data-event-id="${id}"]`)?.classList.add('ep-event-playing');
    };
    if (isOpen()) render(); // otherwise the toggle renders on open
    return {
        // Track the selection always, but only render/fetch while the panel is
        // visible — the toggle calls setNode() again on open, so it loads then.
        setNode: (id)=>{
            nodeId = id;
            if (isOpen()) render();
        },
        refresh: ()=>{
            if (isOpen()) render();
        },
        addEvent: addEvent,
        markPlaying: markPlaying
    };
}
function $27dfa76bb68b188f$var$formatTime(iso) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleString(undefined, {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
}
function $27dfa76bb68b188f$var$escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}


// ─── Theme definitions ────────────────────────────────────────────────────────

const $05f13ed94b53e0ba$export$88613d5626004446 = {
    mode: 'night',
    background: 0x0a0620,
    lineColor: 0x452e5a,
    lineAlpha: 1,
    lineWidth: 1,
    // Palette: coral, gold, muted purple, deep purple
    nodeColors: [
        0xff653f,
        0xffc85c,
        0x452e5a,
        0x1e104e
    ],
    textColor: 0xffffff,
    statusColors: {
        'todo': 0x9ca3af,
        'in-progress': 0x3b82f6,
        'done': 0x22c55e,
        'blocked': 0xef4444
    },
    statusBorderColor: 0x0a0620,
    deleteColor: 0xef4444,
    rotateColor: 0x3b82f6,
    addColor: 0x10b981,
    actionIconColor: 0xffffff,
    pulseColor: 0xffc85c,
    css: {
        bg: '#0a0620',
        text: '#ffc85c',
        btnBg: 'rgba(10,6,32,0.9)',
        btnText: '#ffc85c',
        btnBorder: '#452e5a',
        modalBg: '#1e104e',
        modalBorder: '#452e5a',
        modalShadow: '0 20px 60px rgba(0,0,0,0.7)',
        inputBg: '#100828'
    }
};
const $05f13ed94b53e0ba$export$99d2992244f00fc4 = {
    mode: 'day',
    background: 0xfafafa,
    lineColor: 0xd1d5db,
    lineAlpha: 1,
    lineWidth: 1.5,
    // Pastel palette: sky-blue, thistle, baby-pink, icy-blue
    nodeColors: [
        0xa2d2ff,
        0xcdb4db,
        0xffafcc,
        0xbde0fe
    ],
    textColor: 0x1f2433,
    statusColors: {
        'todo': 0x9ca3af,
        'in-progress': 0x2563eb,
        'done': 0x16a34a,
        'blocked': 0xdc2626
    },
    statusBorderColor: 0xfafafa,
    deleteColor: 0xdc2626,
    rotateColor: 0x2563eb,
    addColor: 0x059669,
    actionIconColor: 0xffffff,
    pulseColor: 0x4f46e5,
    css: {
        bg: '#fafafa',
        text: '#4f46e5',
        btnBg: 'rgba(250,250,250,0.92)',
        btnText: '#4f46e5',
        btnBorder: '#e5e7eb',
        modalBg: '#ffffff',
        modalBorder: '#e5e7eb',
        modalShadow: '0 20px 60px rgba(0,0,0,0.18)',
        inputBg: '#f5f5f5'
    }
};
// ─── State ────────────────────────────────────────────────────────────────────
// Navigation between routes uses full page loads, so the active theme is kept in
// localStorage — otherwise every navigation would reset to night.
const $05f13ed94b53e0ba$var$STORAGE_KEY = 'dictator-theme';
function $05f13ed94b53e0ba$var$loadInitialTheme() {
    try {
        return window.localStorage.getItem($05f13ed94b53e0ba$var$STORAGE_KEY) === 'day' ? $05f13ed94b53e0ba$export$99d2992244f00fc4 : $05f13ed94b53e0ba$export$88613d5626004446;
    } catch  {
        return $05f13ed94b53e0ba$export$88613d5626004446;
    }
}
let $05f13ed94b53e0ba$var$_current = $05f13ed94b53e0ba$var$loadInitialTheme();
function $05f13ed94b53e0ba$export$f89dfc8082866bac() {
    return $05f13ed94b53e0ba$var$_current;
}
function $05f13ed94b53e0ba$export$f543642fc33c1018() {
    $05f13ed94b53e0ba$var$_current = $05f13ed94b53e0ba$var$_current.mode === 'night' ? $05f13ed94b53e0ba$export$99d2992244f00fc4 : $05f13ed94b53e0ba$export$88613d5626004446;
    try {
        window.localStorage.setItem($05f13ed94b53e0ba$var$STORAGE_KEY, $05f13ed94b53e0ba$var$_current.mode);
    } catch  {
    /* storage unavailable (e.g. private mode) — theme just won't persist */ }
    return $05f13ed94b53e0ba$var$_current;
}
// ─── CSS overlay theming ───────────────────────────────────────────────────────
const $05f13ed94b53e0ba$var$hex = (n)=>`#${n.toString(16).padStart(6, '0')}`;
function $05f13ed94b53e0ba$export$6a694ad44101b6d7() {
    const t = $05f13ed94b53e0ba$var$_current;
    const root = document.documentElement.style;
    root.setProperty('--bg', t.css.bg);
    root.setProperty('--text', t.css.text);
    root.setProperty('--btn-bg', t.css.btnBg);
    root.setProperty('--btn-text', t.css.btnText);
    root.setProperty('--btn-border', t.css.btnBorder);
    root.setProperty('--modal-bg', t.css.modalBg);
    root.setProperty('--modal-border', t.css.modalBorder);
    root.setProperty('--modal-shadow', t.css.modalShadow);
    root.setProperty('--input-bg', t.css.inputBg);
    root.setProperty('--status-todo', $05f13ed94b53e0ba$var$hex(t.statusColors['todo']));
    root.setProperty('--status-in-progress', $05f13ed94b53e0ba$var$hex(t.statusColors['in-progress']));
    root.setProperty('--status-done', $05f13ed94b53e0ba$var$hex(t.statusColors['done']));
    root.setProperty('--status-blocked', $05f13ed94b53e0ba$var$hex(t.statusColors['blocked']));
}
function $05f13ed94b53e0ba$export$e26f216ddaf8a4ac(btn) {
    const paint = ()=>{
        const mode = $05f13ed94b53e0ba$var$_current.mode;
        // Night mode offers a switch to day (sun); day mode a switch to night (moon).
        btn.innerHTML = (0, $bece2cf6ee11737c$export$a93c45a3f0b1e89e)(mode === 'night' ? 'sun' : 'moon', 16);
        btn.setAttribute('aria-label', mode === 'night' ? 'Switch to day theme' : 'Switch to night theme');
    };
    paint();
    btn.addEventListener('click', ()=>{
        $05f13ed94b53e0ba$export$f543642fc33c1018();
        $05f13ed94b53e0ba$export$6a694ad44101b6d7();
        paint();
    });
}








// ─── Pages list view (DOM) ───────────────────────────────────────────────────
// Rendered into #pages-view when the route is "/". Plain HTML — no PixiJS.
const $2c49474a09b9174f$var$navigate = (path)=>{
    window.location.assign(path);
};
function $2c49474a09b9174f$var$formatDate(iso) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
}
function $2c49474a09b9174f$var$cardHtml(page) {
    const count = page.node_count === 1 ? '1 node' : `${page.node_count} nodes`;
    return `
    <article class="page-card" data-id="${page.id}" role="button" tabindex="0">
      <div class="page-card-actions">
        <button class="page-card-btn" data-action="rename" data-id="${page.id}"
                type="button" aria-label="Rename page">${(0, $bece2cf6ee11737c$export$a93c45a3f0b1e89e)('edit', 15)}</button>
        <button class="page-card-btn" data-action="delete" data-id="${page.id}"
                type="button" aria-label="Delete page">${(0, $bece2cf6ee11737c$export$a93c45a3f0b1e89e)('trash', 15)}</button>
      </div>
      <h2 class="page-card-title">${$2c49474a09b9174f$var$escapeHtml(page.title)}</h2>
      <p class="page-card-meta">${count} \xb7 ${$2c49474a09b9174f$var$formatDate(page.created_at)}</p>
    </article>`;
}
function $2c49474a09b9174f$var$escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
async function $2c49474a09b9174f$export$de5c4544df5b5e5a() {
    (0, $05f13ed94b53e0ba$export$6a694ad44101b6d7)();
    const root = document.getElementById('pages-view');
    const draw = (pages)=>{
        const cards = pages.map($2c49474a09b9174f$var$cardHtml).join('');
        root.innerHTML = `
      <div class="pages-shell">
        <header class="pages-header">
          <h1 class="app-logo" role="button" tabindex="0">Dictator</h1>
          <div class="pages-header-actions">
            <a class="pages-api-link" href="/api">API</a>
            <button id="theme-toggle-dom" class="theme-toggle-btn" type="button"></button>
            <button id="new-page-btn" type="button">${(0, $bece2cf6ee11737c$export$a93c45a3f0b1e89e)('plus', 16)}<span>New page</span></button>
          </div>
        </header>
        <div class="pages-grid">
          ${cards}
          ${pages.length === 0 ? '<p class="pages-empty">No pages yet. Create your first one.</p>' : ''}
        </div>
      </div>`;
        wire(pages);
    };
    const wire = (_pages)=>{
        document.getElementById('new-page-btn').addEventListener('click', onCreate);
        (0, $05f13ed94b53e0ba$export$e26f216ddaf8a4ac)(document.getElementById('theme-toggle-dom'));
        const logo = root.querySelector('.app-logo');
        logo.addEventListener('click', ()=>$2c49474a09b9174f$var$navigate('/'));
        logo.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $2c49474a09b9174f$var$navigate('/');
            }
        });
        root.querySelectorAll('.page-card').forEach((card)=>{
            const id = card.dataset.id;
            card.addEventListener('click', (e)=>{
                // Ignore clicks that originated on an action button.
                if (e.target.closest('.page-card-btn')) return;
                $2c49474a09b9174f$var$navigate(`/page/${id}`);
            });
            card.addEventListener('keydown', (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    $2c49474a09b9174f$var$navigate(`/page/${id}`);
                }
            });
        });
        root.querySelectorAll('.page-card-btn').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                e.stopPropagation();
                const id = btn.dataset.id;
                const action = btn.dataset.action;
                if (action === 'rename') onRename(id);
                else if (action === 'delete') onDelete(id);
            });
        });
    };
    const onCreate = async ()=>{
        const title = await (0, $81e833ca5dd4fe80$export$e2d76aac9cd37a6b)('New page');
        if (!title) return;
        try {
            const page = await $88850f982d8abd1a$export$eea1b38e4aaafc7d(title);
            $2c49474a09b9174f$var$navigate(`/page/${page.id}`);
        } catch (err) {
            console.warn('[pages] createPage failed', err);
        }
    };
    const onRename = async (id)=>{
        const title = await (0, $81e833ca5dd4fe80$export$e2d76aac9cd37a6b)('Rename page');
        if (!title) return;
        try {
            await $88850f982d8abd1a$export$4b5ca02e0d193347(id, title);
            draw(await $88850f982d8abd1a$export$b3bfa2e9714d3bf2());
        } catch (err) {
            console.warn('[pages] renamePage failed', err);
        }
    };
    const onDelete = async (id)=>{
        if (!window.confirm('Delete this page and all its nodes?')) return;
        try {
            await $88850f982d8abd1a$export$2e9858c25869c949(id);
            draw(await $88850f982d8abd1a$export$b3bfa2e9714d3bf2());
        } catch (err) {
            console.warn('[pages] deletePage failed', err);
        }
    };
    try {
        draw(await $88850f982d8abd1a$export$b3bfa2e9714d3bf2());
    } catch (err) {
        console.warn('[pages] fetchPages failed', err);
        root.innerHTML = '<p class="pages-empty">Could not load pages. Is the backend running?</p>';
    }
}




// ─── API documentation view (DOM) ───────────────────────────────────────────
// Rendered into #api-view when the route is "/api". Static reference for the
// backend REST API. The endpoint list mirrors backend/src/server.ts.
// In production BASE is "" (same-origin); show the live origin in examples so
// the curl commands are copy-pasteable.
const $4fe41c8061c76ff4$var$HOST = (0, $88850f982d8abd1a$export$9e15ff8aa6bc996f) || window.location.origin;
const $4fe41c8061c76ff4$var$GROUPS = [
    {
        title: 'Pages',
        endpoints: [
            {
                method: 'GET',
                path: '/api/pages',
                summary: 'List all pages, newest first. node_count is the number of nodes the page owns.',
                request: `curl ${$4fe41c8061c76ff4$var$HOST}/api/pages`,
                status: '200 OK',
                response: `[
  {
    "id": "019f0463-8a77-746d-bc2d-5e5190ec7eb8",
    "title": "My First Map",
    "created_at": "2026-06-26T14:44:20.215Z",
    "node_count": 12
  }
]`
            },
            {
                method: 'POST',
                path: '/api/pages',
                summary: 'Create a page. The returned id is a UUID v7 (time-ordered).',
                detail: 'Body: { "title": string }. Returns 400 if title is missing or blank.',
                request: `curl -X POST ${$4fe41c8061c76ff4$var$HOST}/api/pages \\
  -H 'Content-Type: application/json' \\
  -d '{"title":"Roadmap"}'`,
                status: "201 Created \xb7 400 if title blank",
                response: `{
  "id": "019f0470-6784-7f72-834c-b4a72e33ebd2",
  "title": "Roadmap",
  "created_at": "2026-06-26T15:01:09.882Z",
  "node_count": 0
}`
            },
            {
                method: 'PATCH',
                path: '/api/pages/:id',
                summary: 'Rename a page.',
                detail: 'Body: { "title": string }. Returns 400 if title is blank.',
                request: `curl -X PATCH ${$4fe41c8061c76ff4$var$HOST}/api/pages/019f0470-6784-7f72-834c-b4a72e33ebd2 \\
  -H 'Content-Type: application/json' \\
  -d '{"title":"Q3 Roadmap"}'`,
                status: "204 No Content \xb7 400 if title blank",
                response: ''
            },
            {
                method: 'DELETE',
                path: '/api/pages/:id',
                summary: 'Delete a page and all of its nodes (cascade).',
                request: `curl -X DELETE ${$4fe41c8061c76ff4$var$HOST}/api/pages/019f0470-6784-7f72-834c-b4a72e33ebd2`,
                status: '204 No Content',
                response: ''
            }
        ]
    },
    {
        title: 'Nodes',
        endpoints: [
            {
                method: 'GET',
                path: '/api/pages/:id/nodes',
                summary: 'List every node in a page.',
                detail: 'Nodes form a tree via parent_id (root nodes have parent_id: null), ordered by child_order. x / y are world coordinates (null until first positioned).',
                request: `curl ${$4fe41c8061c76ff4$var$HOST}/api/pages/019f0463-8a77-746d-bc2d-5e5190ec7eb8/nodes`,
                status: '200 OK',
                response: `[
  {
    "id": "n_mqv231ck_8jannx",
    "label": "Backend API",
    "description": "Auth, DB, endpoints.",
    "status": "in-progress",
    "parent_id": null,
    "child_order": 0,
    "x": 640,
    "y": 360
  }
]`
            },
            {
                method: 'POST',
                path: '/api/pages/:id/nodes',
                summary: 'Create a node in a page.',
                detail: 'Body: { "label": string, "parent_id": string | null }. Use parent_id: null for a root node, or a node id to attach it as a child. New nodes start with description "" and status "todo".',
                request: `curl -X POST ${$4fe41c8061c76ff4$var$HOST}/api/pages/019f0463-8a77-746d-bc2d-5e5190ec7eb8/nodes \\
  -H 'Content-Type: application/json' \\
  -d '{"label":"Task A","parent_id":null}'`,
                status: "201 Created \xb7 400 if label blank",
                response: `{
  "id": "n_mqv231ck_8jannx",
  "label": "Task A",
  "description": "",
  "status": "todo",
  "parent_id": null,
  "child_order": 0,
  "x": null,
  "y": null
}`
            },
            {
                method: 'PATCH',
                path: '/api/nodes/:id',
                summary: 'Update a node. Send any subset of the fields.',
                detail: 'Body: { x?, y?, status?, label?, description? }. x and y must be sent together (a position update). status is one of todo | in-progress | done | blocked.',
                request: `curl -X PATCH ${$4fe41c8061c76ff4$var$HOST}/api/nodes/n_mqv231ck_8jannx \\
  -H 'Content-Type: application/json' \\
  -d '{"status":"done","description":"Shipped \u{1F389}"}'`,
                status: '204 No Content',
                response: ''
            },
            {
                method: 'POST',
                path: '/api/nodes/positions',
                summary: 'Bulk-update node positions in one request (used after a drag or auto-layout).',
                detail: 'Body: an array of { id, x, y }. Returns 400 if the body is not an array.',
                request: `curl -X POST ${$4fe41c8061c76ff4$var$HOST}/api/nodes/positions \\
  -H 'Content-Type: application/json' \\
  -d '[{"id":"n_mqv231ck_8jannx","x":640,"y":360}]'`,
                status: "204 No Content \xb7 400 if body is not an array",
                response: ''
            },
            {
                method: 'DELETE',
                path: '/api/nodes/:id',
                summary: 'Delete a node and its entire subtree (cascade).',
                detail: 'Also deletes every event attached to the deleted nodes.',
                request: `curl -X DELETE ${$4fe41c8061c76ff4$var$HOST}/api/nodes/n_mqv231ck_8jannx`,
                status: '204 No Content',
                response: ''
            }
        ]
    },
    {
        title: 'Events',
        endpoints: [
            {
                method: 'GET',
                path: '/api/pages/:id/events',
                summary: "Poll a page-wide event stream \u2014 every event across all of the page's nodes.",
                detail: 'Query: ?since=<cursor>. Omit since on the first call to seed the cursor (returns { "events": [], "cursor" }); pass the returned cursor on each subsequent call to receive only events created since, oldest first. Used for live polling. Pass an empty since (?since=) to get the full history \u2014 the cursor is "before everything".',
                request: `curl ${$4fe41c8061c76ff4$var$HOST}/api/pages/019f0463-8a77-746d-bc2d-5e5190ec7eb8/events?since=2026-06-30T15:01:09.882Z`,
                status: '200 OK',
                response: `{
  "events": [
    {
      "id": "e_mqv24abc_x7k2p9",
      "node_id": "n_mqv231ck_8jannx",
      "status": "done",
      "note": "shipped",
      "author": "pierre",
      "label": null,
      "prev_label": null,
      "created_at": "2026-06-30T16:20:00.000Z"
    }
  ],
  "cursor": "2026-06-30T16:20:00.000Z"
}`
            },
            {
                method: 'GET',
                path: '/api/nodes/:id/events',
                summary: 'List a node\'s events, newest first.',
                detail: "An event records an optional status change and/or a rename, plus extra information (note, author) that lives only on the event \u2014 never on the node. status is null for events that don't change status; label/prev_label are null unless the event renamed the node.",
                request: `curl ${$4fe41c8061c76ff4$var$HOST}/api/nodes/n_mqv231ck_8jannx/events`,
                status: '200 OK',
                response: `[
  {
    "id": "e_mqv24abc_x7k2p9",
    "node_id": "n_mqv231ck_8jannx",
    "status": "blocked",
    "note": "waiting on vendor",
    "author": "pierre",
    "label": null,
    "prev_label": null,
    "created_at": "2026-06-30T15:01:09.882Z"
  }
]`
            },
            {
                method: 'POST',
                path: '/api/nodes/:id/events',
                summary: 'Send an event about a node.',
                detail: "Body: { status?, note?, author?, label? }. All fields optional. A non-empty status (todo | in-progress | done | blocked) is recorded on the event AND updates the node's current status. A non-empty label that differs from the current name renames the node \u2014 the event keeps the previous name in prev_label. Omit both for an info-only event. note and author are stored only on the event.",
                request: `curl -X POST ${$4fe41c8061c76ff4$var$HOST}/api/nodes/n_mqv231ck_8jannx/events \\
  -H 'Content-Type: application/json' \\
  -d '{"label":"Backend API v2","note":"renamed for clarity","author":"pierre"}'`,
                status: '201 Created',
                response: `{
  "id": "e_mqv24abc_x7k2p9",
  "node_id": "n_mqv231ck_8jannx",
  "status": null,
  "note": "renamed for clarity",
  "author": "pierre",
  "label": "Backend API v2",
  "prev_label": "Backend API",
  "created_at": "2026-06-30T15:01:09.882Z"
}`
            }
        ]
    }
];
function $4fe41c8061c76ff4$var$escapeHtml(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $4fe41c8061c76ff4$var$block(label, body) {
    if (!body) return '';
    return `
    <div class="api-block">
      <span class="api-block-label">${label}</span>
      <pre><code>${$4fe41c8061c76ff4$var$escapeHtml(body)}</code></pre>
    </div>`;
}
function $4fe41c8061c76ff4$var$endpointHtml(e) {
    return `
    <article class="api-endpoint">
      <div class="api-sig">
        <span class="api-method api-method-${e.method.toLowerCase()}">${e.method}</span>
        <code class="api-path">${$4fe41c8061c76ff4$var$escapeHtml(e.path)}</code>
      </div>
      <p class="api-summary">${$4fe41c8061c76ff4$var$escapeHtml(e.summary)}</p>
      ${e.detail ? `<p class="api-detail">${$4fe41c8061c76ff4$var$escapeHtml(e.detail)}</p>` : ''}
      <p class="api-status"><span class="api-block-label">Status</span> ${$4fe41c8061c76ff4$var$escapeHtml(e.status)}</p>
      ${$4fe41c8061c76ff4$var$block('Request', e.request ?? '')}
      ${$4fe41c8061c76ff4$var$block('Response', e.response)}
    </article>`;
}
function $4fe41c8061c76ff4$export$d594da2bffd08c34() {
    (0, $05f13ed94b53e0ba$export$6a694ad44101b6d7)();
    const root = document.getElementById('api-view');
    const groups = $4fe41c8061c76ff4$var$GROUPS.map((g)=>`
    <section class="api-group">
      <h2>${$4fe41c8061c76ff4$var$escapeHtml(g.title)}</h2>
      ${g.endpoints.map($4fe41c8061c76ff4$var$endpointHtml).join('')}
    </section>`).join('');
    root.innerHTML = `
    <div class="api-shell">
      <header class="api-header">
        <h1><span class="app-logo" role="button" tabindex="0">Dictator</span> API</h1>
        <div class="api-header-actions">
          <button id="api-theme-toggle" class="theme-toggle-btn" type="button"></button>
          <button id="api-back-btn" type="button">\u{2190} Pages</button>
        </div>
      </header>

      <section class="api-intro">
        <p>REST API backing the mind map. All responses are JSON; CORS is open
           (<code>Access-Control-Allow-Origin: *</code>) and <code>OPTIONS</code>
           preflight returns <code>204</code>.</p>
        <p><strong>Base URL</strong> <code>${$4fe41c8061c76ff4$var$escapeHtml($4fe41c8061c76ff4$var$HOST)}</code></p>
        <p><strong>Data model.</strong> A <em>page</em> owns a tree of <em>nodes</em>.
           Page ids are UUID v7; node ids are server-generated strings
           (<code>n_\u{2026}</code>). A node's <code>parent_id</code> links it to its parent \u{2014}
           root nodes have <code>parent_id: null</code>. Status is one of
           <code>todo</code>, <code>in-progress</code>, <code>done</code>,
           <code>blocked</code>.</p>
      </section>

      ${groups}
    </div>`;
    document.getElementById('api-back-btn').addEventListener('click', ()=>window.location.assign('/'));
    (0, $05f13ed94b53e0ba$export$e26f216ddaf8a4ac)(document.getElementById('api-theme-toggle'));
    const logo = root.querySelector('.app-logo');
    logo.addEventListener('click', ()=>window.location.assign('/'));
    logo.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            window.location.assign('/');
        }
    });
}


// ─── Map view (route: /page/:id) ────────────────────────────────────────────
async function $aec5cb2f67926290$var$initMap(pageId) {
    // ── 1. Apply initial theme CSS ──────────────────────────────────────────
    (0, $05f13ed94b53e0ba$export$6a694ad44101b6d7)();
    // ── 2. Application PixiJS ───────────────────────────────────────────────
    const app = new (0, $0828be36c1b794ea$export$16975c34e60e1e61)();
    await app.init({
        backgroundColor: (0, $05f13ed94b53e0ba$export$f89dfc8082866bac)().background,
        resizeTo: window,
        antialias: false,
        resolution: window.devicePixelRatio || 1,
        autoDensity: true,
        autoStart: false
    });
    // We render on demand — keep the ticker permanently stopped.
    app.ticker.stop();
    document.body.appendChild(app.canvas);
    // ── Render-on-demand helper (coalesces multiple requests into one frame) ─
    let renderScheduled = false;
    const requestRender = ()=>{
        if (renderScheduled) return;
        renderScheduled = true;
        requestAnimationFrame(()=>{
            renderScheduled = false;
            app.renderer.render(app.stage);
        });
    };
    // ── 3. Viewport ─────────────────────────────────────────────────────────
    const viewport = new (0, $762e77127186c3c6$export$d5c6c08dc2d3ca7)({
        screenWidth: window.innerWidth,
        screenHeight: window.innerHeight,
        worldWidth: window.innerWidth,
        worldHeight: window.innerHeight,
        events: app.renderer.events
    });
    app.stage.addChild(viewport);
    app.stage.sortableChildren = true;
    viewport.sortableChildren = true;
    viewport.drag().pinch().wheel();
    // Any viewport motion (drag / wheel zoom / pinch) needs a redraw.
    viewport.on('moved', requestRender);
    viewport.on('zoomed', requestRender);
    // ── Persist pan/zoom per page, restore on refresh ────────────────────────
    // 'moved-end' / 'zoomed-end' fire only after a user drag / wheel / pinch
    // settles — not on programmatic pans (event zooms), so we save the user's
    // last position, not wherever an event last panned to.
    const VIEWPORT_KEY = `dictator-viewport-${pageId}`;
    const saveViewport = ()=>{
        try {
            window.localStorage.setItem(VIEWPORT_KEY, JSON.stringify({
                x: viewport.center.x,
                y: viewport.center.y,
                scale: viewport.scale.x
            }));
        } catch  {}
    };
    const restoreViewport = ()=>{
        try {
            const raw = window.localStorage.getItem(VIEWPORT_KEY);
            if (!raw) return;
            const v = JSON.parse(raw);
            if (typeof v.x === 'number' && typeof v.y === 'number' && typeof v.scale === 'number') {
                viewport.scale.set(v.scale);
                viewport.moveCenter(v.x, v.y);
            }
        } catch  {}
    };
    viewport.on('moved-end', saveViewport);
    viewport.on('zoomed-end', saveViewport);
    // ── 4. Fetch nodes from backend, build layout ───────────────────────────
    const rows = await (0, $88850f982d8abd1a$export$db921b253abfda9b)(pageId);
    const nodes = (0, $88850f982d8abd1a$export$1c2dd91db560a75e)(rows);
    const layouts = (0, $d030d2651a318c02$export$a95f910e046ea54a)(nodes, window.innerWidth, window.innerHeight);
    // Apply stored positions where present; collect missing positions to persist.
    const missing = [];
    for (const row of rows){
        const layout = layouts.get(row.id);
        if (!layout) continue;
        if (row.x !== null && row.y !== null) {
            layout.x = row.x;
            layout.y = row.y;
        } else missing.push({
            id: layout.id,
            x: layout.x,
            y: layout.y
        });
    }
    if (missing.length > 0) $88850f982d8abd1a$export$502f3028ce474436(missing);
    // ── 5. Lines layer ──────────────────────────────────────────────────────
    const linesGraphics = new (0, $bcTIE.Graphics)();
    linesGraphics.zIndex = 0;
    viewport.addChild(linesGraphics);
    // ── 7. Sprites des nœuds ────────────────────────────────────────────────
    const sprites = new Map();
    for (const [id, layout] of layouts){
        const sprite = (0, $b2b0b848f61053a7$export$96a186a9b8e41771)(layout, (0, $05f13ed94b53e0ba$export$f89dfc8082866bac)());
        sprite.container.zIndex = Math.max(1, 4 - layout.level);
        sprites.set(id, sprite);
        viewport.addChild(sprite.container);
    }
    // ── 8. Dessin initial + interactions + panel ────────────────────────────
    (0, $b2b0b848f61053a7$export$a484e31e13c53240)(linesGraphics, layouts, (0, $05f13ed94b53e0ba$export$f89dfc8082866bac)());
    // Forward declaration: the panel is created below but interactions may need
    // to refresh it on add/delete. Use a mutable holder.
    const panelRef = {
        handle: null
    };
    const refreshPanel = ()=>panelRef.handle?.refresh();
    // The event panel reacts to canvas selection; created below, so route the
    // selection callback through a mutable holder (same pattern as panelRef).
    const eventPanelRef = {
        handle: null
    };
    const interactions = (0, $e5725b4a775f592f$export$f2e6b952b66b609b)(viewport, sprites, layouts, linesGraphics, (0, $05f13ed94b53e0ba$export$f89dfc8082866bac), requestRender, pageId, refreshPanel, (layout)=>eventPanelRef.handle?.setNode(layout?.id ?? null));
    panelRef.handle = (0, $0f6a2e8989a0c18e$export$58a97a354cca1bd9)(layouts, interactions.focusOn, interactions.pulseNode, interactions.selectNode);
    eventPanelRef.handle = (0, $27dfa76bb68b188f$export$1adbbcd8ae53030c)(pageId, layouts, (nodeId, status)=>interactions.playEventAnimation(nodeId, status));
    // ── Live event polling (this page only) ──────────────────────────────────
    // Poll the page-wide event stream and react on the canvas: zoom to the target
    // node, pulse it, run the status/label effects, and prepend it to the event
    // panel. The first poll only seeds the cursor (no history replay).
    const POLL_INTERVAL_MS = 4000;
    const seenEvents = new Set();
    let pollCursor;
    const reactToEvent = (e)=>{
        // Prepend the new event to the list (no full reload) and flag it as the
        // currently-playing card — keeps the panel's scope.
        eventPanelRef.handle?.addEvent(e);
        eventPanelRef.handle?.markPlaying(e.id);
        // Apply the persisted status/label — which fire the done/blocked/bounce
        // effects — deferred until the zoom lands.
        const applyEffects = ()=>{
            if (e.status) interactions.applyStatusVisual(e.node_id, e.status);
            if (e.label) interactions.applyLabelVisual(e.node_id, e.label);
        };
        // Zoom to the node first (pulse on arrival), then run the effects. If the
        // node isn't on this page there's no zoom — run them immediately.
        if (!interactions.pulseEvent(e.node_id, applyEffects)) applyEffects();
    };
    // ── Playback queue ────────────────────────────────────────────────────────
    // Events are queued and played one at a time, every 3s, so two events never
    // animate simultaneously (a poll can return a whole burst at once).
    const EVENT_PLAY_INTERVAL_MS = 3000;
    const MAX_QUEUE = 40; // bound memory during long/fast bursts
    const eventQueue = [];
    let playing = false;
    const playNextQueued = ()=>{
        const e = eventQueue.shift();
        if (!e) {
            playing = false;
            eventPanelRef.handle?.markPlaying(null);
            return;
        }
        reactToEvent(e);
        window.setTimeout(playNextQueued, EVENT_PLAY_INTERVAL_MS);
    };
    const enqueueEvent = (e)=>{
        eventQueue.push(e);
        if (eventQueue.length > MAX_QUEUE) {
            const dropped = eventQueue.splice(0, eventQueue.length - MAX_QUEUE);
            console.warn(`[poll] event queue over ${MAX_QUEUE}; dropped ${dropped.length} oldest`);
        }
        if (!playing) {
            playing = true;
            playNextQueued();
        } // play the first immediately
    };
    const pollOnce = async ()=>{
        try {
            const { events: events, cursor: cursor } = await $88850f982d8abd1a$export$74b470722ef75a01(pageId, pollCursor);
            pollCursor = cursor;
            for (const e of events){
                if (seenEvents.has(e.id)) continue;
                seenEvents.add(e.id);
                enqueueEvent(e);
            }
        } catch (err) {
            console.warn('[poll] fetchPageEvents failed', err);
        }
    };
    const scheduleNextPoll = ()=>{
        window.setTimeout(async ()=>{
            if (!document.hidden) await pollOnce(); // don't hammer the API in a hidden tab
            scheduleNextPoll();
        }, POLL_INTERVAL_MS);
    };
    pollOnce().finally(scheduleNextPoll); // seed cursor, then loop
    // ── 9. Résolution du texte adaptée au zoom ───────────────────────────────
    // Re-rasterizing 75 PIXI.Text textures on every wheel tick is the bottleneck.
    // Solution: snap to integer tiers (1/2/3) and debounce until zoom settles.
    let currentTextRes = 0;
    let zoomDebounce = null;
    const applyTextResolution = ()=>{
        const raw = viewport.scale.x * (window.devicePixelRatio || 1);
        const tier = Math.max(1, Math.min(3, Math.ceil(raw)));
        if (tier === currentTextRes) return;
        currentTextRes = tier;
        for (const sprite of sprites.values())sprite.text.resolution = tier;
        requestRender();
    };
    viewport.on('zoomed', ()=>{
        if (zoomDebounce !== null) clearTimeout(zoomDebounce);
        zoomDebounce = window.setTimeout(()=>{
            zoomDebounce = null;
            applyTextResolution();
        }, 120);
    });
    applyTextResolution();
    // ── Back to pages list ──────────────────────────────────────────────────
    const backBtn = document.getElementById('back-btn');
    backBtn.innerHTML = `${(0, $bece2cf6ee11737c$export$a93c45a3f0b1e89e)('panelRight', 16)}<span>Pages</span>`;
    backBtn.addEventListener('click', ()=>window.location.assign('/'));
    // ── Dictator logo → pages list ──────────────────────────────────────────
    const title = document.getElementById('title');
    title.addEventListener('click', ()=>window.location.assign('/'));
    // ── Panel toggle (top bar) + close button (inside panel header) ─────────
    const panelToggle = document.getElementById('panel-toggle');
    const panelClose = document.getElementById('panel-close');
    panelToggle.innerHTML = `${(0, $bece2cf6ee11737c$export$a93c45a3f0b1e89e)('panelRight', 16)}<span>Nodes</span>`;
    panelClose.innerHTML = (0, $bece2cf6ee11737c$export$a93c45a3f0b1e89e)('x', 18);
    panelToggle.addEventListener('click', ()=>{
        document.body.classList.remove('events-open'); // only one right panel at a time
        document.body.classList.toggle('panel-open');
    });
    panelClose.addEventListener('click', ()=>{
        document.body.classList.remove('panel-open');
    });
    // ── Event panel toggle (lightning) + its close button ───────────────────
    const eventsToggle = document.getElementById('events-toggle');
    const eventPanelClose = document.getElementById('event-panel-close');
    const eventPanelTitle = document.getElementById('event-panel-title');
    eventsToggle.innerHTML = `${(0, $bece2cf6ee11737c$export$a93c45a3f0b1e89e)('zap', 16)}<span>Events</span>`;
    eventPanelTitle.innerHTML = `${(0, $bece2cf6ee11737c$export$a93c45a3f0b1e89e)('zap', 16)}<span>Events</span>`;
    eventPanelClose.innerHTML = (0, $bece2cf6ee11737c$export$a93c45a3f0b1e89e)('x', 18);
    eventsToggle.addEventListener('click', ()=>{
        document.body.classList.remove('panel-open'); // only one right panel at a time
        document.body.classList.toggle('events-open');
        eventPanelRef.handle?.setNode(interactions.getSelectedId());
    });
    eventPanelClose.addEventListener('click', ()=>{
        document.body.classList.remove('events-open');
    });
    // ── 10. Theme toggle button ─────────────────────────────────────────────
    const themeBtn = document.getElementById('theme-toggle');
    const setThemeBtnContent = (mode)=>{
        // In night mode, button offers a switch to day (sun). In day mode, to night (moon).
        themeBtn.innerHTML = mode === 'night' ? (0, $bece2cf6ee11737c$export$a93c45a3f0b1e89e)('sun', 16) : (0, $bece2cf6ee11737c$export$a93c45a3f0b1e89e)('moon', 16);
        themeBtn.setAttribute('aria-label', mode === 'night' ? 'Switch to day theme' : 'Switch to night theme');
    };
    setThemeBtnContent((0, $05f13ed94b53e0ba$export$f89dfc8082866bac)().mode);
    themeBtn.addEventListener('click', ()=>{
        const theme = (0, $05f13ed94b53e0ba$export$f543642fc33c1018)();
        (0, $05f13ed94b53e0ba$export$6a694ad44101b6d7)();
        app.renderer.background.color = theme.background;
        interactions.redrawLines();
        (0, $b2b0b848f61053a7$export$fefc5ff285547933)(sprites, theme);
        setThemeBtnContent(theme.mode);
        requestRender();
    });
    // ── 10b. Add (new project) button ───────────────────────────────────────
    const addBtn = document.getElementById('add-btn');
    addBtn.innerHTML = `${(0, $bece2cf6ee11737c$export$a93c45a3f0b1e89e)('plus', 16)}<span>Add</span>`;
    addBtn.addEventListener('click', async ()=>{
        const label = await (0, $81e833ca5dd4fe80$export$e2d76aac9cd37a6b)('New project');
        if (!label) return;
        let apiNode;
        try {
            apiNode = await $88850f982d8abd1a$export$270e7ba5936d3c48(pageId, label, null);
        } catch (err) {
            console.warn('[api] createNode failed', err);
            return;
        }
        // Place the new root at the current viewport center so it's visible.
        const layout = (0, $d030d2651a318c02$export$78f30f0059ab853a)({
            id: apiNode.id,
            label: apiNode.label,
            level: 0,
            status: apiNode.status,
            parentId: null,
            childIds: [],
            x: viewport.center.x,
            y: viewport.center.y
        });
        layouts.set(layout.id, layout);
        interactions.registerNode(layout);
        (0, $b2b0b848f61053a7$export$a484e31e13c53240)(linesGraphics, layouts, (0, $05f13ed94b53e0ba$export$f89dfc8082866bac)());
        $88850f982d8abd1a$export$bfcba650c63431da(layout.id, layout.x, layout.y);
        requestRender();
        refreshPanel();
    });
    // ── 11. Redimensionnement ────────────────────────────────────────────────
    window.addEventListener('resize', ()=>{
        viewport.resize(window.innerWidth, window.innerHeight);
        requestRender();
    });
    // ── 12. Restore the saved pan/zoom (if any), then initial render ─────────
    restoreViewport();
    requestRender();
}
// ─── Router ──────────────────────────────────────────────────────────────────
// "/page/:id" → map view; anything else → pages list. Navigation between the
// two uses full page loads (location.assign), so there is no PixiJS teardown.
function $aec5cb2f67926290$var$boot() {
    const path = window.location.pathname;
    const match = path.match(/^\/page\/([^/]+)$/);
    if (match) {
        document.body.classList.add('route-map');
        $aec5cb2f67926290$var$initMap(decodeURIComponent(match[1])).catch(console.error);
    } else if (path === '/api') {
        document.body.classList.add('route-api');
        (0, $4fe41c8061c76ff4$export$d594da2bffd08c34)();
    } else {
        document.body.classList.add('route-list');
        (0, $2c49474a09b9174f$export$de5c4544df5b5e5a)().catch(console.error);
    }
}
$aec5cb2f67926290$var$boot();


//# sourceMappingURL=frontend.7600c73a.js.map
